var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x4) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x4, {
  get: (a2, b3) => (typeof require !== "undefined" ? require : a2)[b3]
}) : x4)(function(x4) {
  if (typeof require !== "undefined") return require.apply(this, arguments);
  throw Error('Dynamic require of "' + x4 + '" is not supported');
});
var __esm = (fn, res, err2) => function __init() {
  if (err2) throw err2[0];
  try {
    return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
  } catch (e5) {
    throw err2 = [e5], e5;
  }
};
var __commonJS = (cb, mod) => function __require2() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e5) {
    throw mod = 0, e5;
  }
};
var __export = (target3, all) => {
  for (var name in all)
    __defProp(target3, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target3) => (target3 = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target3, "default", { value: mod, enumerable: true }) : target3,
  mod
));

// ../../node_modules/@moq/signals/index.js
var signals_exports = {};
__export(signals_exports, {
  Computed: () => Computed,
  Derived: () => Derived,
  Effect: () => Effect,
  Once: () => Once,
  Signal: () => Signal,
  getter: () => getter,
  race: () => race,
  readonlys: () => readonlys
});
function branded(value, brand) {
  return typeof value === "object" && value !== null && brand in value;
}
function isThenable(value) {
  return (typeof value === "object" || typeof value === "function") && value !== null && typeof value.then === "function";
}
function listen(value, fn) {
  if (!isThenable(value)) {
    fn({ ok: true, value });
    return noop;
  }
  if (getterShaped(value)) {
    const readable = value;
    const current = readable.peek();
    if (current !== void 0) {
      fn({ ok: true, value: current });
      return noop;
    }
    const dispose = readable.subscribe((next) => {
      if (next === void 0)
        return;
      dispose();
      fn({ ok: true, value: next });
    });
    return dispose;
  }
  let entry = watched.get(value);
  if (!entry) {
    const created = { listeners: /* @__PURE__ */ new Set() };
    Promise.resolve(value).then((value2) => settle(created, { ok: true, value: value2 }), (error2) => settle(created, { ok: false, error: error2 }));
    watched.set(value, created);
    entry = created;
  }
  if (entry.settled) {
    fn(entry.settled);
    return noop;
  }
  const listeners = entry.listeners;
  listeners.add(fn);
  return () => listeners.delete(fn);
}
function settle(entry, settled) {
  entry.settled = settled;
  const listeners = [...entry.listeners];
  entry.listeners.clear();
  for (const fn of listeners)
    fn(settled);
}
function raceUntil(values, abort) {
  return new Promise((resolve2, reject) => {
    const disposes = [];
    let done = false;
    const finish = (settled) => {
      if (done)
        return;
      done = true;
      for (const dispose of disposes)
        dispose();
      if (settled.ok)
        resolve2(settled.value);
      else
        reject(settled.error);
    };
    if (abort?.aborted) {
      finish({ ok: true, value: void 0 });
    } else if (abort) {
      const stop = () => finish({ ok: true, value: void 0 });
      abort.addEventListener("abort", stop);
      disposes.push(() => abort.removeEventListener("abort", stop));
    }
    for (const value of values) {
      if (done) {
        listen(value, noop)();
        continue;
      }
      const dispose = listen(value, finish);
      if (done)
        dispose();
      else
        disposes.push(dispose);
    }
  });
}
function race(values) {
  return raceUntil(values);
}
function readonlys(signals) {
  return signals;
}
function getter(value) {
  if (branded(value, GETTER_BRAND) || branded(value, SIGNAL_BRAND) || getterShaped(value)) {
    return value;
  }
  return new Signal(value);
}
function getterShaped(value) {
  if (typeof value !== "object" || value === null)
    return false;
  const maybe = value;
  return typeof maybe.peek === "function" && typeof maybe.subscribe === "function" && typeof maybe.changed === "function";
}
function isEqual(a2, b3) {
  if (a2 === b3)
    return true;
  if (a2 === null || b3 === null || typeof a2 !== "object" || typeof b3 !== "object")
    return false;
  const protoA = Object.getPrototypeOf(a2);
  const protoB = Object.getPrototypeOf(b3);
  if (protoA !== protoB)
    return false;
  if (protoA !== Object.prototype && protoA !== Array.prototype)
    return false;
  const keysA = Object.keys(a2);
  const keysB = Object.keys(b3);
  if (keysA.length !== keysB.length)
    return false;
  for (const key of keysA) {
    if (!isEqual(a2[key], b3[key]))
      return false;
  }
  return true;
}
var noop, DEV, SIGNAL_BRAND, GETTER_BRAND, Signal, Once, watched, Effect, Computed, Derived;
var init_signals = __esm({
  "../../node_modules/@moq/signals/index.js"() {
    noop = () => {
    };
    DEV = typeof import.meta.env !== "undefined" && import.meta.env?.MODE !== "production";
    SIGNAL_BRAND = /* @__PURE__ */ Symbol.for("@moq/signals");
    GETTER_BRAND = /* @__PURE__ */ Symbol.for("@moq/signals.getter");
    Signal = class _Signal {
      #value;
      #subscribers = /* @__PURE__ */ new Set();
      #changed = /* @__PURE__ */ new Set();
      // Microtask coalescing state
      #pending = false;
      #oldValue;
      #hasCapturedOldValue = false;
      #forceNotify = false;
      // Brands to identify this as a Signal (and a readable) across package instances.
      [SIGNAL_BRAND] = true;
      [GETTER_BRAND] = true;
      constructor(value) {
        this.#value = value;
      }
      /** Returns the value if it's already a Signal, otherwise wraps it in a new Signal. */
      static from(value) {
        if (branded(value, SIGNAL_BRAND)) {
          return value;
        }
        return new _Signal(value);
      }
      /** Returns the current value without subscribing. */
      peek() {
        return this.#value;
      }
      /**
       * Sets the current value, notifying subscribers if it changed.
       * Pass `notify` true to always notify or false to never notify.
       * A function is stored as the value; use {@link update} to transform instead.
       */
      set(value, notify) {
        if (!this.#hasCapturedOldValue) {
          this.#oldValue = this.#value;
          this.#hasCapturedOldValue = true;
        }
        this.#value = value;
        if (notify === false)
          return;
        if (notify === true)
          this.#forceNotify = true;
        if (this.#subscribers.size === 0 && this.#changed.size === 0) {
          this.#hasCapturedOldValue = false;
          this.#oldValue = void 0;
          this.#forceNotify = false;
          return;
        }
        if (this.#pending)
          return;
        this.#pending = true;
        queueMicrotask(() => this.#flush());
      }
      #flush() {
        this.#pending = false;
        this.#hasCapturedOldValue = false;
        const old = this.#oldValue;
        this.#oldValue = void 0;
        const force = this.#forceNotify;
        this.#forceNotify = false;
        if (!force && isEqual(old, this.#value))
          return;
        const value = this.#value;
        const changed = this.#changed;
        this.#changed = /* @__PURE__ */ new Set();
        for (const fn of this.#subscribers) {
          try {
            fn(value);
          } catch (error2) {
            console.error("signal subscriber error", error2);
          }
        }
        for (const fn of changed) {
          try {
            fn(value);
          } catch (error2) {
            console.error("signal changed error", error2);
          }
        }
      }
      /** Sets the value to the result of `fn(prev)`, notifying subscribers unless `notify` is false. */
      update(fn, notify = true) {
        const value = fn(this.#value);
        this.set(value, notify);
      }
      /**
       * Mutates the current value in place via `fn`, returning `fn`'s result and
       * notifying subscribers unless `notify` is false.
       */
      mutate(fn, notify = true) {
        const r2 = fn(this.#value);
        this.set(this.#value, notify);
        return r2;
      }
      /** Calls `fn` every time the value changes. Returns a function to unsubscribe. */
      subscribe(fn) {
        this.#subscribers.add(fn);
        if (DEV && this.#subscribers.size >= 100 && Number.isInteger(Math.log10(this.#subscribers.size))) {
          throw new Error("signal has too many subscribers; may be leaking");
        }
        return () => this.#subscribers.delete(fn);
      }
      changed(fn) {
        if (fn) {
          this.#changed.add(fn);
          return () => this.#changed.delete(fn);
        }
        return new Promise((resolve2) => {
          this.#changed.add(resolve2);
        });
      }
      /** Calls `fn` with the current value now, and again every time it changes. */
      watch(fn) {
        const dispose = this.subscribe(fn);
        queueMicrotask(() => fn(this.#value));
        return dispose;
      }
      /** Resolves with the next value from whichever of the given readables changes first. */
      static async race(...sigs) {
        const dispose = [];
        const result = await new Promise((resolve2) => {
          for (const sig of sigs) {
            dispose.push(sig.changed(resolve2));
          }
        });
        for (const fn of dispose)
          fn();
        return result;
      }
    };
    Once = class {
      #signal = new Signal(void 0);
      // Brand to identify this as a readable across package instances.
      [GETTER_BRAND] = true;
      /** Settle the value. Throws if it has already settled. */
      set(value) {
        if (this.#signal.peek() !== void 0) {
          throw new Error("Once has already settled");
        }
        this.#signal.set(value);
      }
      /** The settled value, or `undefined` while still pending. */
      peek() {
        return this.#signal.peek();
      }
      changed(fn) {
        return fn ? this.#signal.changed(fn) : this.#signal.changed();
      }
      /** Calls `fn` when it settles (fires at most once). Returns a function to unsubscribe. */
      subscribe(fn) {
        return this.#signal.subscribe(fn);
      }
      /** Resolves with the settled value, immediately if it already settled. Never rejects on its own. */
      // biome-ignore lint/suspicious/noThenProperty: Once is intentionally awaitable (thenable).
      then(onFulfilled, onRejected) {
        const current = this.#signal.peek();
        const settled = current !== void 0 ? Promise.resolve(current) : this.#signal.changed().then((value) => value);
        return settled.then(onFulfilled, onRejected);
      }
    };
    watched = /* @__PURE__ */ new WeakMap();
    Effect = class _Effect {
      // Sanity check to make sure roots are being disposed on dev.
      static #finalizer = new FinalizationRegistry((debugInfo) => {
        console.warn(`Signals was garbage collected without being closed:
${debugInfo}`);
      });
      #fn;
      #dispose = [];
      // The teardown list a drain is walking, and how far it has got. Shared by the rerun and close
      // paths so a `close` landing inside a rerun's drain continues that pass instead of starting a
      // second one over callbacks that already ran. Set only while a drain is running.
      #draining;
      #drained = 0;
      #unwatch = [];
      #async = /* @__PURE__ */ new Set();
      #stack;
      #scheduled = false;
      #stopped;
      #closed;
      #abort = new AbortController();
      #abortUsed = false;
      // True between a run's teardown and the start of the next one. A spawn task that resumes in
      // this window belongs to the run that just died, so its cleanup has to fire now.
      #stale = false;
      /** If a function is provided, it runs immediately and reruns whenever a tracked signal changes. */
      constructor(fn) {
        if (DEV) {
          const debug = new Error("created here:").stack ?? "No stack";
          _Effect.#finalizer.register(this, debug, this);
        }
        this.#fn = fn;
        if (DEV) {
          this.#stack = new Error().stack;
        }
        this.#stopped = Promise.withResolvers();
        this.#closed = Promise.withResolvers();
        if (fn) {
          this.#schedule();
        }
      }
      #schedule() {
        if (this.#scheduled)
          return;
        this.#scheduled = true;
        queueMicrotask(() => this.#run().catch((error2) => {
          console.error("effect error", error2, this.#stack);
        }));
      }
      async #run() {
        if (this.#dispose === void 0)
          return;
        this.#stale = true;
        this.#stopped.resolve();
        this.#abort.abort();
        for (const unwatch of this.#unwatch)
          unwatch();
        this.#unwatch.length = 0;
        const dispose = this.#dispose;
        this.#drain(dispose);
        if (this.#dispose === void 0)
          return;
        dispose.length = 0;
        if (this.#async.size > 0) {
          const warn = DEV ? setTimeout(() => {
            if (this.#dispose === void 0)
              return;
            console.warn("spawn is still running after 5s; the effect cannot rerun until it settles", this.#stack);
          }, 5e3) : void 0;
          try {
            while (this.#dispose !== void 0 && this.#async.size > 0) {
              const pending = this.#async;
              this.#async = /* @__PURE__ */ new Set();
              await race([Promise.all(pending), this.#closed.promise]);
            }
          } catch (error2) {
            console.error("async effect error", error2);
            if (this.#stack)
              console.error("stack", this.#stack);
          } finally {
            if (warn !== void 0)
              clearTimeout(warn);
          }
        }
        if (this.#dispose === void 0)
          return;
        this.#scheduled = false;
        this.#stale = false;
        this.#stopped = Promise.withResolvers();
        this.#abort = new AbortController();
        this.#abortUsed = false;
        if (this.#fn) {
          this.#fn(this);
          if (DEV && this.#dispose !== void 0 && this.#unwatch.length === 0 && this.#dispose.length === 0 && this.#async.size === 0 && !this.#abortUsed) {
            console.warn("Effect did not subscribe to any signals; it will never rerun.", this.#stack);
          }
        }
      }
      /** Reads a signal and tracks it, rerunning the effect whenever it changes. */
      get(signal) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.get called when closed, returning current value");
          }
          return signal.peek();
        }
        const value = signal.peek();
        const dispose = signal.changed(() => this.#schedule());
        this.#unwatch.push(dispose);
        return value;
      }
      /**
       * Sets a signal for the duration of this run, restoring `cleanup` on rerun or close.
       * The cleanup value is optional only when the signal type includes `undefined`.
       */
      set(signal, value, ...args) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.set called when closed, ignoring");
          }
          return;
        }
        signal.set(value);
        const cleanup = args[0];
        const cleanupValue = cleanup === void 0 ? void 0 : cleanup;
        this.cleanup(() => signal.set(cleanupValue));
      }
      /**
       * Runs an async task. The effect will not rerun until the task's promise settles.
       */
      // TODO: Add effect for another layer of nesting
      spawn(fn) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.spawn called when closed");
          }
          return;
        }
        const promise = fn().catch((error2) => {
          console.error("spawn error", error2);
        });
        if (this.#dispose === void 0)
          return;
        const tasks = this.#async;
        tasks.add(promise);
        void promise.then(() => tasks.delete(promise));
      }
      /** Runs `fn` after `ms` milliseconds, unless the effect reruns or closes first. */
      timer(fn, ms2) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.timer called when closed, ignoring");
          }
          return;
        }
        let timeout;
        timeout = setTimeout(() => {
          timeout = void 0;
          fn();
        }, ms2);
        this.cleanup(() => timeout !== void 0 && clearTimeout(timeout));
      }
      /**
       * Runs `fn` as a nested effect, then closes that effect after `ms` milliseconds.
       *
       * Shares {@link run}'s handling of a task that outlived its run: the child is closed at the
       * next teardown, not immediately.
       */
      timeout(fn, ms2) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.timeout called when closed, ignoring");
          }
          return;
        }
        const effect = new _Effect(fn);
        let timeout = setTimeout(() => {
          effect.close();
          timeout = void 0;
        }, ms2);
        this.#dispose.push(() => {
          if (timeout !== void 0) {
            clearTimeout(timeout);
            effect.close();
          }
        });
      }
      /** Runs `fn` on the next animation frame, unless the effect reruns or closes first. */
      animate(fn) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.animate called when closed, ignoring");
          }
          return;
        }
        let animate = requestAnimationFrame((now) => {
          fn(now);
          animate = void 0;
        });
        this.cleanup(() => {
          if (animate !== void 0)
            cancelAnimationFrame(animate);
        });
      }
      /** Runs `fn` every `ms` milliseconds until the effect reruns or closes. */
      interval(fn, ms2) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.interval called when closed, ignoring");
          }
          return;
        }
        const interval2 = setInterval(() => {
          fn();
        }, ms2);
        this.cleanup(() => clearInterval(interval2));
      }
      /**
       * Creates a nested effect that reruns independently and is closed with its parent.
       *
       * Returns a disposer that closes the child early and releases it from the parent, so a long-lived
       * effect spawning a child per event (e.g. one per accepted subscription) doesn't accumulate dead
       * scopes until it finally reruns or closes.
       *
       * Called from a task that outlived its run, the child is closed at the *next* teardown rather
       * than immediately, unlike {@link cleanup}. Closing it now would cancel its first run before
       * `fn` executes, so whatever teardown `fn` registers would never fire at all.
       */
      run(fn) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.run called when closed, ignoring");
          }
          return () => {
          };
        }
        const effect = new _Effect(fn);
        const dispose = () => effect.close();
        this.#dispose.push(dispose);
        return () => {
          effect.close();
          const disposers = this.#dispose;
          const index2 = disposers?.indexOf(dispose) ?? -1;
          if (disposers === void 0 || index2 === -1)
            return;
          if (this.#draining === disposers)
            disposers[index2] = noop;
          else
            disposers.splice(index2, 1);
        };
      }
      /** Creates a derived signal scoped to this effect, closed when the effect reruns or closes. */
      computed(fn) {
        const computed = new Computed(fn);
        this.cleanup(() => computed.close());
        return computed;
      }
      /** Reads and tracks several signals, returning their values or `undefined` if any is falsy. */
      getAll(signals) {
        const values = [];
        for (const signal of signals) {
          const value = this.get(signal);
          if (!value)
            return void 0;
          values.push(value);
        }
        return values;
      }
      /** Runs `fn` with the signal's value now and again whenever it changes, scoped to this effect. */
      subscribe(signal, fn) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.subscribe called when closed, running once");
          }
          fn(signal.peek());
          return;
        }
        this.run((effect) => {
          const value = effect.get(signal);
          fn(value);
        });
      }
      event(target3, type, listener, options) {
        if (this.#dispose === void 0) {
          if (DEV) {
            console.warn("Effect.eventListener called when closed, ignoring");
          }
          return;
        }
        const effectSignal = this.abort;
        const signal = typeof options !== "boolean" && options?.signal ? AbortSignal.any([effectSignal, options.signal]) : effectSignal;
        const merged = typeof options === "boolean" ? { capture: options, signal } : { ...options, signal };
        target3.addEventListener(type, listener, merged);
      }
      /**
       * Registers a function to run when the effect reruns or closes.
       *
       * Runs `fn` immediately if the run that registered it is already over, which is what an
       * {@link spawn} task resuming after a rerun or close sees. Registering teardown is
       * therefore enough to own a resource, with no staleness check needed first.
       */
      /**
       * Run every callback in `list` exactly once, including ones registered while draining.
       *
       * Iterative, so a cascade of any depth stays flat rather than nesting a stack frame per link.
       * Re-entrant: a `close` from inside a rerun's teardown resumes this pass at the cursor instead
       * of replaying it. A callback that throws is reported and the rest still run, since teardown
       * that stops half way leaks whatever the remaining callbacks owned.
       */
      #drain(list) {
        const owner = this.#draining !== list;
        if (owner) {
          this.#draining = list;
          this.#drained = 0;
        }
        try {
          while (this.#drained < list.length) {
            const fn = list[this.#drained++];
            try {
              fn();
            } catch (error2) {
              console.error("cleanup error", error2, this.#stack);
            }
          }
        } finally {
          if (owner)
            this.#draining = void 0;
        }
      }
      cleanup(fn) {
        if (this.#dispose === void 0 || this.#stale) {
          if (this.#draining !== void 0) {
            this.#draining.push(fn);
            return;
          }
          fn();
          return;
        }
        this.#dispose.push(fn);
      }
      /** Stops the effect permanently, running all cleanup and unsubscribing from every signal. */
      close() {
        const dispose = this.#dispose;
        if (dispose === void 0) {
          return;
        }
        this.#dispose = void 0;
        this.#closed.resolve();
        this.#stopped.resolve();
        this.#abort.abort();
        this.#drain(dispose);
        for (const signal of this.#unwatch)
          signal();
        this.#unwatch.length = 0;
        this.#async.clear();
        if (DEV) {
          _Effect.#finalizer.unregister(this);
        }
      }
      /** Resolves when the effect is closed. */
      get closed() {
        return this.#closed.promise;
      }
      /**
       * Resolves when the current run is about to be torn down, by a rerun or close.
       *
       * @internal Racing it adds a reaction per call that lives until the run ends; use {@link race}.
       */
      get cancel() {
        return this.#stopped.promise;
      }
      /**
       * Settles with the first of `values`, like the free {@link race}, or resolves `undefined` once the
       * current run is torn down. Either way it drops every listener it registered.
       */
      race(...values) {
        return raceUntil(values, this.#abort.signal);
      }
      /** An AbortSignal that fires when the current run is torn down. */
      get abort() {
        this.#abortUsed = true;
        return this.#abort.signal;
      }
      /** Copies `src` into `dst` and keeps `dst` in sync as `src` changes. */
      proxy(dst, src) {
        this.subscribe(src, (value) => dst.update(() => value));
      }
    };
    Computed = class {
      #signal = new Signal(void 0);
      #effect;
      // Brand to identify this as a readable across package instances.
      [GETTER_BRAND] = true;
      /** Creates a computed that derives its value from `fn`, rerunning when dependencies change. */
      constructor(fn) {
        this.#effect = new Effect((effect) => {
          this.#signal.set(fn(effect));
        });
      }
      /** Returns the current derived value without subscribing (`undefined` until the first run). */
      peek() {
        return this.#signal.peek();
      }
      changed(fn) {
        return fn ? this.#signal.changed(fn) : this.#signal.changed();
      }
      /** Calls `fn` every time the derived value changes. */
      subscribe(fn) {
        return this.#signal.subscribe(fn);
      }
      /**
       * Stops recomputing and tracking dependencies. Required for standalone computeds;
       * an `effect.computed()` is closed automatically with its parent effect.
       */
      close() {
        this.#effect.close();
      }
    };
    Derived = class {
      #sources;
      #fn;
      // Brand to identify this as a readable across package instances.
      [GETTER_BRAND] = true;
      /** Creates a view deriving its value from `sources` via `fn`, recomputed on every read. */
      constructor(sources, fn) {
        this.#sources = sources;
        this.#fn = fn;
      }
      /** Returns the current derived value without subscribing. */
      peek() {
        return this.#fn(...this.#sources.map((source) => source.peek()));
      }
      /** Calls `fn` with the derived value every time any source notifies. */
      subscribe(fn) {
        return this.#watch(fn);
      }
      changed(fn) {
        if (fn)
          return this.#once(fn);
        return new Promise((resolve2) => {
          this.#once(resolve2);
        });
      }
      // Calls `fn` with the derived value the first time it changes, then unsubscribes.
      #once(fn) {
        const dispose = this.subscribe((value) => {
          dispose();
          fn(value);
        });
        return dispose;
      }
      // Subscribes to every source, recomputing on any notification.
      #watch(fn) {
        const disposes = this.#sources.map((source) => source.subscribe(() => fn(this.peek())));
        return () => {
          for (const dispose of disposes)
            dispose();
        };
      }
    };
  }
});

// ../../node_modules/@moq/net/announced.js
function isActive(kind) {
  return kind !== "retracted";
}
function closeState(state, abort) {
  if (state.closed.peek() !== void 0)
    return;
  state.closed.set(abort ?? null);
  state.queue.mutate((queue) => {
    queue.length = 0;
  });
}
var AnnounceState, Producer, makeConsumer, Consumer;
var init_announced = __esm({
  "../../node_modules/@moq/net/announced.js"() {
    init_signals();
    AnnounceState = class {
      queue = new Signal([]);
      closed = new Once();
    };
    Producer = class {
      #state = new AnnounceState();
      /**
       * Settles once the stream closes: `null` on a clean close, or the abort {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       */
      get closed() {
        return this.#state.closed;
      }
      /** A read handle for this announcement stream. */
      consume() {
        return makeConsumer(this.#state);
      }
      /** Writes an announcement to the queue. */
      append(update) {
        if (this.#state.closed.peek() !== void 0)
          throw new Error("announcements are closed");
        this.#state.queue.mutate((queue) => {
          queue.push(update);
        });
      }
      /** Closes the writer. Idempotent. */
      close(abort) {
        closeState(this.#state, abort);
      }
    };
    Consumer = class _Consumer {
      #state;
      constructor(state) {
        this.#state = state;
      }
      /** Settles once the stream closes; see {@link Producer.closed}. */
      get closed() {
        return this.#state.closed;
      }
      static {
        makeConsumer = (state) => new _Consumer(state);
      }
      /** The announcements as they arrive, until the stream closes. */
      async *[Symbol.asyncIterator]() {
        for (; ; ) {
          const update = await this.next();
          if (!update)
            return;
          yield update;
        }
      }
      /** Returns the next announcement. */
      async next() {
        for (; ; ) {
          const announce = this.#state.queue.peek().shift();
          if (announce)
            return announce;
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0)
            return void 0;
          await Signal.race(this.#state.queue, this.#state.closed);
        }
      }
      /** Closes the reader. Idempotent. */
      close(abort) {
        closeState(this.#state, abort);
      }
    };
  }
});

// ../../node_modules/@moq/net/announce.js
var announce_exports = {};
__export(announce_exports, {
  Consumer: () => Consumer,
  isActive: () => isActive
});
var init_announce = __esm({
  "../../node_modules/@moq/net/announce.js"() {
    init_announced();
  }
});

// ../../node_modules/@moq/net/bandwidth.js
function allocate(estimate, wants, id) {
  let budget = estimate;
  let tier;
  for (const want of wants) {
    if (tier === void 0 || want.priority > tier)
      tier = want.priority;
  }
  while (tier !== void 0) {
    const members2 = wants.filter((want) => want.priority === tier).sort((a2, b3) => a2.max - b3.max);
    let remaining = members2.length;
    for (const want of members2) {
      const even = Math.floor(budget / remaining);
      const grant = Math.min(want.max, even);
      if (want.id === id)
        return grant;
      budget -= grant;
      remaining -= 1;
    }
    let next;
    for (const want of wants) {
      if (want.priority < tier && (next === void 0 || want.priority > next)) {
        next = want.priority;
      }
    }
    tier = next;
  }
  return void 0;
}
function wantsOf(entries) {
  const wants = [];
  for (const entry of entries) {
    if (entry.demand.closed.peek() !== void 0)
      continue;
    if (!entry.demand.used.peek())
      continue;
    wants.push({ id: entry.id, priority: entry.priority, max: entry.max });
  }
  return wants;
}
function ceiling(max) {
  if (!Number.isFinite(max) || max < 0) {
    throw new Error(`reservation ceiling must be a finite non-negative number, got ${max}`);
  }
  return max;
}
var Allocator, makeReservation, Reservation;
var init_bandwidth = __esm({
  "../../node_modules/@moq/net/bandwidth.js"() {
    init_signals();
    Allocator = class _Allocator {
      #estimate;
      #entries = new Signal([]);
      #alive = new Signal(true);
      #nextId = 0;
      #signals = new Effect();
      #registry;
      /**
       * Divide `estimate`, normally a connection's sampled send rate.
       *
       * Omit it (or call {@link unlimited}) for nothing to divide: every reservation
       * reports `undefined`, which already means "no opinion, hold your rate".
       */
      constructor(estimate) {
        this.#estimate = estimate;
        this.#registry = {
          peek: (id) => this.#peek(id),
          update: (id, max) => this.#update(id, max),
          release: (id) => this.#release(id)
        };
        this.#signals.run((effect) => {
          if (!effect.get(this.#alive))
            return;
          if (this.#estimate)
            effect.get(this.#estimate);
          const entries = effect.get(this.#entries);
          for (const entry of entries) {
            effect.get(entry.demand.used);
            effect.get(entry.demand.closed);
          }
          this.#publish();
        });
      }
      /**
       * An allocator with nothing to divide, so every reservation reports `undefined`.
       *
       * `undefined` already means "no opinion, hold your rate" to a sender, so this is
       * what a transport with no congestion estimate, a local file, or a test harness
       * wants.
       */
      static unlimited() {
        return new _Allocator();
      }
      /**
       * Reserve up to `max` for `track`, returning the reservation.
       *
       * `max` is a ceiling, not a measurement: reserve the most the track can ever
       * send, not what it happens to be sending. A VBR encoder sitting on a black
       * screen at 1 Mbps can jump to 6 Mbps between one frame and the next, and a
       * reservation that had followed it down would have already handed that room
       * to somebody else.
       *
       * Priority comes from the track (higher served first). A tier is filled to
       * its reservations before the next one sees a bit; within a tier the split is
       * max-min fair.
       *
       * The reservation lasts until {@link Reservation.close}: hold it for as long
       * as the sender is publishing, change the ceiling with
       * {@link Reservation.update}, and close it to hand the room back.
       *
       * {@link Reservation.peek} / {@link Reservation.grant} report `undefined`
       * while nothing is subscribed to the track or the connection has no estimate.
       * That tells a sender to hold its current rate rather than encode at zero.
       */
      reserve(track, max) {
        max = ceiling(max);
        this.#prune();
        const id = this.#nextId++;
        const grant = new Signal(void 0);
        this.#entries.mutate((entries) => {
          entries.push({
            id,
            demand: track,
            priority: track.priority,
            max,
            grant
          });
        });
        const reservation = makeReservation(this.#registry, id, grant);
        this.#publish();
        return reservation;
      }
      /**
       * Stop dividing. Existing reservations report `undefined` and further
       * {@link reserve} calls still return a handle that never claims.
       */
      close() {
        if (!this.#alive.peek())
          return;
        this.#alive.set(false);
        for (const entry of this.#entries.peek()) {
          entry.grant.set(void 0);
        }
        this.#entries.set([]);
        this.#signals.close();
      }
      #prune() {
        const entries = this.#entries.peek();
        const live = entries.filter((entry) => entry.demand.closed.peek() === void 0);
        if (live.length !== entries.length)
          this.#entries.set(live);
      }
      #publish() {
        if (!this.#alive.peek())
          return;
        const estimate = this.#estimate?.peek();
        const entries = this.#entries.peek();
        const wants = wantsOf(entries);
        for (const entry of entries) {
          entry.grant.set(estimate == null ? void 0 : allocate(estimate, wants, entry.id));
        }
      }
      #peek(id) {
        if (!this.#alive.peek())
          return void 0;
        const estimate = this.#estimate?.peek();
        if (estimate == null)
          return void 0;
        const entries = this.#entries.peek();
        if (!entries.some((entry) => entry.id === id))
          return void 0;
        return allocate(estimate, wantsOf(entries), id);
      }
      #update(id, max) {
        if (!this.#alive.peek())
          return;
        max = ceiling(max);
        this.#entries.mutate((entries) => {
          const entry = entries.find((candidate) => candidate.id === id);
          if (entry)
            entry.max = max;
        });
        this.#publish();
      }
      #release(id) {
        if (!this.#alive.peek())
          return;
        this.#entries.mutate((entries) => {
          const index2 = entries.findIndex((entry) => entry.id === id);
          if (index2 >= 0)
            entries.splice(index2, 1);
        });
        this.#publish();
      }
    };
    Reservation = class _Reservation {
      #registry;
      #id;
      #grant;
      #closed = false;
      constructor(registry2, id, grant) {
        this.#registry = registry2;
        this.#id = id;
        this.#grant = grant;
      }
      static {
        makeReservation = (registry2, id, grant) => new _Reservation(registry2, id, grant);
      }
      /**
       * This reservation's slice right now.
       *
       * Stateless, unlike {@link grant}, which is a signal of what was last
       * published and so can lag a synchronous {@link update} by a microtask if
       * something else writes the registry first. Call this after {@link update}.
       */
      peek() {
        if (this.#closed)
          return void 0;
        return this.#registry.peek(this.#id);
      }
      /**
       * This reservation's current slice of the estimate.
       *
       * `undefined` while nothing is subscribed, the connection has no estimate, or
       * this reservation has been closed: hold the current rate rather than encode
       * at zero.
       */
      get grant() {
        return this.#grant;
      }
      /**
       * Change the ceiling, keeping the same claim.
       *
       * For a sender whose ceiling genuinely moved: an encoder reopening at a
       * resolution it negotiated with the device, not an encoder observing its own
       * output.
       */
      update(max) {
        if (this.#closed)
          return;
        this.#registry.update(this.#id, max);
      }
      /** Release the claim so siblings take the room. Idempotent. */
      close() {
        if (this.#closed)
          return;
        this.#closed = true;
        this.#grant.set(void 0);
        this.#registry.release(this.#id);
      }
      /** Calls {@link close}, so `using` releases the claim. */
      [Symbol.dispose]() {
        this.close();
      }
    };
  }
});

// ../../node_modules/@moq/net/bandwidth_api.js
var bandwidth_api_exports = {};
__export(bandwidth_api_exports, {
  Allocator: () => Allocator,
  Reservation: () => Reservation
});
var init_bandwidth_api = __esm({
  "../../node_modules/@moq/net/bandwidth_api.js"() {
    init_bandwidth();
  }
});

// ../../node_modules/@moq/net/ietf/version.js
function versionName(v3) {
  return VERSION_NAMES[v3] ?? `unknown(0x${v3.toString(16)})`;
}
var Version, ALPN, VERSION_NAMES;
var init_version = __esm({
  "../../node_modules/@moq/net/ietf/version.js"() {
    Version = {
      /**
       * draft-ietf-moq-transport-07
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-07.txt
       */
      DRAFT_07: 4278190087,
      /**
       * draft-ietf-moq-transport-14
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-14.txt
       */
      DRAFT_14: 4278190094,
      /**
       * draft-ietf-moq-transport-15
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-15.txt
       */
      DRAFT_15: 4278190095,
      /**
       * draft-ietf-moq-transport-16
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-16.txt
       */
      DRAFT_16: 4278190096,
      /**
       * draft-ietf-moq-transport-17
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-17.txt
       */
      DRAFT_17: 4278190097,
      /**
       * draft-ietf-moq-transport-18
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-18.txt
       */
      DRAFT_18: 4278190098,
      /**
       * draft-ietf-moq-transport-19
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-19.txt
       */
      DRAFT_19: 4278190099,
      /**
       * draft-ietf-moq-transport-20
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-20.txt
       */
      DRAFT_20: 4278190100,
      /**
       * draft-ietf-moq-transport-21
       * https://www.ietf.org/archive/id/draft-ietf-moq-transport-21.txt
       */
      DRAFT_21: 4278190101,
      /**
       * draft-ietf-moq-transport-22 (unpublished, wire-identical to draft-21)
       */
      DRAFT_22: 4278190102
    };
    ALPN = {
      DRAFT_14: "moq-00",
      DRAFT_15: "moqt-15",
      DRAFT_16: "moqt-16",
      DRAFT_17: "moqt-17",
      DRAFT_18: "moqt-18",
      DRAFT_19: "moqt-19",
      DRAFT_20: "moqt-20",
      DRAFT_21: "moqt-21",
      DRAFT_22: "moqt-22"
    };
    VERSION_NAMES = {
      [Version.DRAFT_07]: "moq-transport-07",
      [Version.DRAFT_14]: "moq-transport-14",
      [Version.DRAFT_15]: "moq-transport-15",
      [Version.DRAFT_16]: "moq-transport-16",
      [Version.DRAFT_17]: "moq-transport-17",
      [Version.DRAFT_18]: "moq-transport-18",
      [Version.DRAFT_19]: "moq-transport-19",
      [Version.DRAFT_20]: "moq-transport-20",
      [Version.DRAFT_21]: "moq-transport-21",
      [Version.DRAFT_22]: "moq-transport-22"
    };
  }
});

// ../../node_modules/@moq/net/ietf/error.js
function sharedStreamCode(code, version2) {
  switch (code) {
    case 0:
    case 1:
    case 2:
    case 3:
      return true;
    // Draft-16 and 17 give 0x4 to UNKNOWN_OBJECT_STATUS, which draft-18 moved to 0x6 when
    // it took 0x4 for GOING_AWAY. Draft-14 and 15 assign it nothing.
    case 4:
      return version2 >= Version.DRAFT_18;
    // TOO_FAR_BEHIND arrived in draft-17.
    case 5:
      return version2 >= Version.DRAFT_17;
    // MALFORMED_TRACK arrived in draft-16.
    case 18:
      return version2 >= Version.DRAFT_16;
    default:
      return false;
  }
}
function invalidRange(kind, version2) {
  if (kind !== "fetch")
    return void 0;
  return version2 === Version.DRAFT_14 ? INVALID_RANGE_14 : INVALID_RANGE;
}
function invalidJoiningRequestId(kind, version2) {
  if (kind !== "fetch")
    return void 0;
  if (version2 === Version.DRAFT_14)
    return INVALID_JOINING_REQUEST_ID_14;
  return version2 <= Version.DRAFT_19 ? INVALID_JOINING_REQUEST_ID : void 0;
}
function doesNotExist(kind, version2) {
  if (version2 !== Version.DRAFT_14)
    return DOES_NOT_EXIST;
  return kind === "subscribe" || kind === "fetch" || kind === "track_status" ? DOES_NOT_EXIST_14 : void 0;
}
function uninterested(kind, version2) {
  if (version2 !== Version.DRAFT_14)
    return UNINTERESTED;
  return kind === "publish" || kind === "publish_namespace" ? UNINTERESTED_14 : void 0;
}
function malformedTrack(kind, version2) {
  if (version2 !== Version.DRAFT_14)
    return MALFORMED_TRACK;
  return kind === "fetch" ? MALFORMED_TRACK_14 : void 0;
}
function goingAway(version2) {
  return version2 >= Version.DRAFT_17 ? GOING_AWAY : void 0;
}
function toRequestCode(condition, kind, version2) {
  switch (condition) {
    case "internal":
      return INTERNAL_ERROR;
    case "unauthorized":
      return UNAUTHORIZED;
    case "timeout":
      return TIMEOUT;
    case "not_supported":
      return NOT_SUPPORTED;
    case "invalid_range":
      return invalidRange(kind, version2) ?? INTERNAL_ERROR;
    case "invalid_joining_request_id":
      return invalidJoiningRequestId(kind, version2) ?? INTERNAL_ERROR;
    case "does_not_exist":
      return doesNotExist(kind, version2) ?? INTERNAL_ERROR;
    // A subscriber that asked for content cannot act on "we do not want it": what it needs
    // to know is that we do not have it, which is the same refusal from its side. Only the
    // requests that offer content say UNINTERESTED.
    case "uninterested":
      return kind === "subscribe" || kind === "fetch" || kind === "track_status" ? doesNotExist(kind, version2) ?? INTERNAL_ERROR : uninterested(kind, version2) ?? INTERNAL_ERROR;
    case "malformed_track":
      return malformedTrack(kind, version2) ?? INTERNAL_ERROR;
    case "going_away":
      return goingAway(version2) ?? INTERNAL_ERROR;
  }
}
function fromRequestCode(code, kind, version2) {
  switch (code) {
    case UNAUTHORIZED:
      return "unauthorized";
    case TIMEOUT:
      return "timeout";
    case NOT_SUPPORTED:
      return "not_supported";
  }
  if (code === doesNotExist(kind, version2))
    return "does_not_exist";
  if (code === invalidRange(kind, version2))
    return "invalid_range";
  if (code === invalidJoiningRequestId(kind, version2))
    return "invalid_joining_request_id";
  if (code === uninterested(kind, version2))
    return "uninterested";
  if (code === malformedTrack(kind, version2))
    return "malformed_track";
  if (code === goingAway(version2))
    return "going_away";
  return void 0;
}
function requestReason(code, reasonPhrase, kind, version2) {
  const condition = fromRequestCode(code, kind, version2) ?? "unregistered";
  return `${condition} (code=${code}) ${reasonPhrase}`;
}
var INTERNAL_ERROR, UNAUTHORIZED, TIMEOUT, NOT_SUPPORTED, GOING_AWAY, INVALID_RANGE_14, INVALID_RANGE, INVALID_JOINING_REQUEST_ID_14, INVALID_JOINING_REQUEST_ID, DOES_NOT_EXIST_14, DOES_NOT_EXIST, UNINTERESTED_14, UNINTERESTED, MALFORMED_TRACK_14, MALFORMED_TRACK;
var init_error = __esm({
  "../../node_modules/@moq/net/ietf/error.js"() {
    init_version();
    INTERNAL_ERROR = 0;
    UNAUTHORIZED = 1;
    TIMEOUT = 2;
    NOT_SUPPORTED = 3;
    GOING_AWAY = 6;
    INVALID_RANGE_14 = 5;
    INVALID_RANGE = 17;
    INVALID_JOINING_REQUEST_ID_14 = 7;
    INVALID_JOINING_REQUEST_ID = 50;
    DOES_NOT_EXIST_14 = 4;
    DOES_NOT_EXIST = 16;
    UNINTERESTED_14 = 4;
    UNINTERESTED = 32;
    MALFORMED_TRACK_14 = 9;
    MALFORMED_TRACK = 18;
  }
});

// ../../node_modules/@moq/net/util/timeout.js
function withTimeout(promise, ms2, message) {
  let timer;
  const timeout = new Promise((_3, reject) => {
    timer = setTimeout(() => reject(new TimeoutError(message)), ms2);
  });
  return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
}
var TimeoutError;
var init_timeout = __esm({
  "../../node_modules/@moq/net/util/timeout.js"() {
    TimeoutError = class extends Error {
      constructor(message) {
        super(message);
        this.name = "TimeoutError";
      }
    };
  }
});

// ../../node_modules/@moq/net/error.js
function applicationCode(code) {
  if (!Number.isInteger(code) || code < 64 || code > 4294967295) {
    throw new RangeError(`invalid application error code: ${code}`);
  }
  return code;
}
function streamCode(err2) {
  if (typeof err2 !== "object" || err2 === null)
    return void 0;
  const { source, streamErrorCode } = err2;
  if (source !== "stream" || typeof streamErrorCode !== "number")
    return void 0;
  return streamErrorCode;
}
function toStreamCode(err2, options) {
  const code = localStreamCode(err2);
  if (options?.version === void 0)
    return code;
  return sharedStreamCode(code, options.version) ? code : StreamCode.Internal;
}
function localStreamCode(err2) {
  if (err2 instanceof Stream)
    return err2.code;
  if (err2 instanceof TimeoutError)
    return StreamCode.DeliveryTimeout;
  if (err2 instanceof ProtocolViolation)
    return StreamCode.SessionClosed;
  return StreamCode.Internal;
}
function controlTimeout(cause) {
  const message = cause instanceof Error && cause.message ? cause.message : "control request timed out";
  return new Stream(StreamCode.ControlTimeout, { cause, message });
}
function fromTransport(err2, options) {
  const code = streamCode(err2);
  if (code === void 0)
    return error(err2);
  if (options?.version !== void 0 && !sharedStreamCode(code, options.version) && claimedLocally(code)) {
    return new Stream(StreamCode.Internal, { cause: err2, message: `remote error: ${code}` });
  }
  if (code === StreamCode.TooFarBehind)
    return new TooFarBehind({ cause: err2 });
  if (code === StreamCode.FrameTooLarge)
    return new FrameTooLarge({ cause: err2 });
  if (code === StreamCode.GroupTooLarge)
    return new GroupTooLarge({ cause: err2 });
  return new Stream(code, { cause: err2 });
}
function claimedLocally(code) {
  return code >= 64 || NAMED_CODES.has(code);
}
function toTransport(code, message) {
  const Native = globalThis.WebTransportError;
  if (Native) {
    const Legacy = Native;
    if (legacyWebTransportErrors.has(Native))
      return new Legacy({ message, streamErrorCode: code });
    try {
      return new Native(message, { source: "stream", streamErrorCode: code });
    } catch (err2) {
      if (!(err2 instanceof TypeError))
        throw err2;
      legacyWebTransportErrors.add(Native);
      return new Legacy({ message, streamErrorCode: code });
    }
  }
  return Object.assign(new Error(message), { source: "stream", streamErrorCode: code });
}
function fromClose(info) {
  const code = info.closeCode ?? SessionCode.Cancel;
  if (code === SessionCode.Cancel)
    return null;
  return new Session(code, { reason: info.reason });
}
function closeError(quic) {
  return quic.closed.then((info) => fromClose(info) ?? new Session(SessionCode.Cancel, { reason: info.reason }), (err2) => error(err2));
}
async function sessionCause(quic, err2) {
  const source = typeof err2 === "object" && err2 !== null ? err2.source : void 0;
  if (quic && source === "session")
    return closeError(quic);
  return error(err2);
}
function error(err2) {
  return err2 instanceof Error ? err2 : new Error(String(err2));
}
function reason(err2) {
  const e5 = error(err2);
  if (typeof WebTransportError !== "undefined" && e5 instanceof WebTransportError) {
    const parts3 = [`source=${e5.source}`];
    if (e5.streamErrorCode !== null)
      parts3.push(`code=${e5.streamErrorCode}`);
    const detail = parts3.join(" ");
    return e5.message ? `${e5.message} (${detail})` : `WebTransportError: ${detail}`;
  }
  return e5.message || e5.name || "unknown error";
}
var SessionCode, StreamCode, Session, Stream, TooFarBehind, FrameTooLarge, GroupTooLarge, NotFound, RefusedRedirect, ProtocolViolation, NAMED_CODES, legacyWebTransportErrors;
var init_error2 = __esm({
  "../../node_modules/@moq/net/error.js"() {
    init_error();
    init_timeout();
    SessionCode = Object.freeze(Object.assign((code) => applicationCode(code), {
      /** Ending the session normally, with no error. */
      Cancel: 0,
      /** Something went wrong that isn't worth a dedicated code. */
      Internal: 1,
      /** The credentials don't grant the requested path or operation. Retrying will fail again. */
      Unauthorized: 2,
      /** A protocol rule was broken; the session is unusable. */
      ProtocolViolation: 3,
      /** A key-value pair was malformed or repeated more than allowed. */
      KeyValueFormatting: 6,
      /** The peer did not close within the GOAWAY drain deadline. */
      GoawayTimeout: 16,
      /** A control message took too long. */
      Timeout: 17,
      /** No version could be negotiated. */
      Version: 21
    }));
    StreamCode = Object.freeze(Object.assign((code) => applicationCode(code), {
      /** Something went wrong that isn't worth a dedicated code. */
      Internal: 0,
      /** The sender is done with this stream, not failing. A routine unsubscribe. */
      Cancel: 1,
      /** The content missed its delivery deadline. */
      DeliveryTimeout: 2,
      /** The session ended, taking this stream with it. */
      SessionClosed: 3,
      /** The session is going away (a GOAWAY was received). */
      GoingAway: 4,
      /** The reader fell too far behind and content was dropped to catch up. */
      TooFarBehind: 5,
      /** The track's content could not be parsed. */
      MalformedTrack: 18,
      /** The peer took too long to answer a control request. */
      ControlTimeout: 49,
      /** The requested broadcast or track does not exist at the peer. */
      NotFound: 51,
      /** The group was superseded by a newer one and dropped. */
      Old: 52,
      /** The group was dropped under memory pressure, so it can be re-fetched. */
      Evicted: 53,
      /** A frame declared a payload larger than the receiver accepts. */
      FrameTooLarge: 56,
      /** The publisher could serve this request but has no capacity for it now. */
      NoCapacity: 48,
      /** A group grew past its cache budget and was aborted. */
      GroupTooLarge: 50
    }));
    Session = class extends Error {
      /** The session code the peer sent, verbatim. */
      code;
      constructor(code, options) {
        super(options?.reason ? `remote error: ${code} (${options.reason})` : `remote error: ${code}`, options);
        this.name = "Session";
        this.code = code;
      }
    };
    Stream = class extends Error {
      /** The stream code; moq-lite resets forward it verbatim. */
      code;
      constructor(code, options) {
        super(options?.message ?? (options?.reason ? `remote error: ${code} (${options.reason})` : `remote error: ${code}`), options);
        this.name = "Stream";
        this.code = code;
      }
    };
    TooFarBehind = class extends Stream {
      constructor(options) {
        super(StreamCode.TooFarBehind, {
          ...options,
          message: "lagged: frames were evicted before being read"
        });
        this.name = "TooFarBehind";
      }
    };
    FrameTooLarge = class extends Stream {
      constructor(options) {
        super(StreamCode.FrameTooLarge, {
          ...options,
          message: "frame too large: larger than a group can cache"
        });
        this.name = "FrameTooLarge";
      }
    };
    GroupTooLarge = class extends Stream {
      constructor(options) {
        super(StreamCode.GroupTooLarge, {
          ...options,
          message: "group too large: exceeded the cache budget"
        });
        this.name = "GroupTooLarge";
      }
    };
    NotFound = class extends Stream {
      constructor(what, options) {
        super(StreamCode.NotFound, { ...options, message: `not found: ${what}` });
        this.name = "NotFound";
      }
    };
    RefusedRedirect = class extends Error {
      constructor(reason2) {
        super(`GOAWAY redirect refused: ${reason2}`);
        this.name = "RefusedRedirect";
      }
    };
    ProtocolViolation = class extends Error {
      constructor(message, options) {
        super(message, options);
        this.name = "ProtocolViolation";
      }
    };
    NAMED_CODES = new Set(Object.values(StreamCode));
    legacyWebTransportErrors = /* @__PURE__ */ new WeakSet();
  }
});

// ../../node_modules/zod/v4/core/util.js
var util_exports = {};
__export(util_exports, {
  BIGINT_FORMAT_RANGES: () => BIGINT_FORMAT_RANGES,
  CONSTANT_CATCH: () => CONSTANT_CATCH,
  Class: () => Class,
  NUMBER_FORMAT_RANGES: () => NUMBER_FORMAT_RANGES,
  aborted: () => aborted,
  allowsEval: () => allowsEval,
  assert: () => assert,
  assertEqual: () => assertEqual,
  assertIs: () => assertIs,
  assertNever: () => assertNever,
  assertNotEqual: () => assertNotEqual,
  assignProp: () => assignProp,
  attachSchema: () => attachSchema,
  base64ToUint8Array: () => base64ToUint8Array,
  base64urlToUint8Array: () => base64urlToUint8Array,
  cached: () => cached,
  captureStackTrace: () => captureStackTrace,
  cleanEnum: () => cleanEnum,
  cleanRegex: () => cleanRegex,
  clone: () => clone,
  cloneDef: () => cloneDef,
  codePointLength: () => codePointLength,
  constantCatch: () => constantCatch,
  createTransparentProxy: () => createTransparentProxy,
  defineLazy: () => defineLazy,
  defineLazyInternal: () => defineLazyInternal,
  derived: () => derived,
  esc: () => esc,
  escapeRegex: () => escapeRegex,
  explicitlyAborted: () => explicitlyAborted,
  extend: () => extend,
  finalizeIssue: () => finalizeIssue,
  floatSafeRemainder: () => floatSafeRemainder,
  getElementAtPath: () => getElementAtPath,
  getEnumValues: () => getEnumValues,
  getLengthableOrigin: () => getLengthableOrigin,
  getParsedType: () => getParsedType,
  getSizableOrigin: () => getSizableOrigin,
  hexToUint8Array: () => hexToUint8Array,
  hide: () => hide,
  installLazyProp: () => installLazyProp,
  isObject: () => isObject,
  isPlainObject: () => isPlainObject,
  issue: () => issue,
  joinValues: () => joinValues,
  jsonStringifyReplacer: () => jsonStringifyReplacer,
  members: () => members,
  merge: () => merge,
  mergeDefs: () => mergeDefs,
  normalizeParams: () => normalizeParams,
  nullish: () => nullish,
  numKeys: () => numKeys,
  objectClone: () => objectClone,
  omit: () => omit,
  optionalKeys: () => optionalKeys,
  own: () => own,
  parsedType: () => parsedType,
  partial: () => partial,
  pick: () => pick,
  prefixIssues: () => prefixIssues,
  primitiveTypes: () => primitiveTypes,
  promiseAllObject: () => promiseAllObject,
  propertyKeyTypes: () => propertyKeyTypes,
  randomString: () => randomString,
  rawShape: () => rawShape,
  required: () => required,
  safeExtend: () => safeExtend,
  shallowClone: () => shallowClone,
  slugify: () => slugify,
  stringifyPrimitive: () => stringifyPrimitive,
  toZod: () => toZod,
  uint8ArrayToBase64: () => uint8ArrayToBase64,
  uint8ArrayToBase64url: () => uint8ArrayToBase64url,
  uint8ArrayToHex: () => uint8ArrayToHex,
  unwrapMessage: () => unwrapMessage
});
function assertEqual(val) {
  return val;
}
function assertNotEqual(val) {
  return val;
}
function toZod() {
  return (schema) => schema;
}
function assertIs(_arg) {
}
function assertNever(_x) {
  throw new Error("Unexpected value in exhaustive check");
}
function assert(_3) {
}
function getEnumValues(entries) {
  const numericValues = Object.values(entries).filter((v3) => typeof v3 === "number");
  const values = Object.entries(entries).filter(([k2, _3]) => numericValues.indexOf(+k2) === -1).map(([_3, v3]) => v3);
  return values;
}
function joinValues(array2, separator = "|") {
  return array2.map((val) => stringifyPrimitive(val)).join(separator);
}
function jsonStringifyReplacer(_3, value) {
  if (typeof value === "bigint")
    return value.toString();
  return value;
}
function cached(getter2) {
  return new Cached(getter2);
}
function nullish(input) {
  return input === null || input === void 0;
}
function cleanRegex(source) {
  const start = source.startsWith("^") ? 1 : 0;
  const end = source.endsWith("$") ? source.length - 1 : source.length;
  return source.slice(start, end);
}
function floatSafeRemainder(val, step) {
  const ratio = val / step;
  const roundedRatio = Math.round(ratio);
  const tolerance = 4 * Number.EPSILON * Math.max(Math.abs(ratio), 1);
  if (Math.abs(ratio - roundedRatio) < tolerance)
    return 0;
  return ratio - roundedRatio;
}
function defineLazy(object3, key, getter2) {
  let value = void 0;
  Object.defineProperty(object3, key, {
    get() {
      if (value === EVALUATING) {
        return void 0;
      }
      if (value === void 0) {
        value = EVALUATING;
        value = getter2();
      }
      return value;
    },
    set(v3) {
      Object.defineProperty(object3, key, {
        value: v3
        // configurable: true,
      });
    },
    configurable: true
  });
}
function objectClone(obj) {
  return Object.create(Object.getPrototypeOf(obj), Object.getOwnPropertyDescriptors(obj));
}
function assignProp(target3, prop, value) {
  Object.defineProperty(target3, prop, {
    value,
    writable: true,
    enumerable: true,
    configurable: true
  });
}
function rawShape(def) {
  const desc = Object.getOwnPropertyDescriptor(def, "shape");
  return desc?.get ? desc.get.raw : desc?.value;
}
function sourceShape(schema) {
  return rawShape(schema._zod.def) ?? schema._zod.def.shape;
}
function deferProp(target3, key, getter2) {
  Object.defineProperty(target3, key, {
    get() {
      const value = getter2();
      assignProp(this, key, value);
      return value;
    },
    enumerable: true,
    configurable: true
  });
}
function putProp(target3, key, value) {
  if (key in target3)
    assignProp(target3, key, value);
  else
    target3[key] = value;
}
function mirrorShape(target3, source, keys, wrap) {
  const raw = sourceShape(source);
  for (const key of keys) {
    const desc = Object.getOwnPropertyDescriptor(raw, key);
    if (!desc.enumerable)
      continue;
    if (desc.get) {
      deferProp(target3, key, () => {
        const value = source._zod.def.shape[key];
        return wrap ? wrap(value, key) : value;
      });
    } else
      putProp(target3, key, wrap ? wrap(desc.value, key) : desc.value);
  }
}
function mirrorProps(target3, source) {
  for (const key of Reflect.ownKeys(source)) {
    const desc = Object.getOwnPropertyDescriptor(source, key);
    if (!desc.enumerable)
      continue;
    if (desc.get)
      deferProp(target3, key, () => source[key]);
    else
      putProp(target3, key, desc.value);
  }
}
function mergeDefs(...defs) {
  const mergedDescriptors = {};
  for (const def of defs) {
    const descriptors = Object.getOwnPropertyDescriptors(def);
    Object.assign(mergedDescriptors, descriptors);
  }
  return Object.defineProperties({}, mergedDescriptors);
}
function cloneDef(schema) {
  return mergeDefs(schema._zod.def);
}
function getElementAtPath(obj, path) {
  if (!path)
    return obj;
  return path.reduce((acc, key) => acc?.[key], obj);
}
function promiseAllObject(promisesObj) {
  const keys = Object.keys(promisesObj);
  const promises = keys.map((key) => promisesObj[key]);
  return Promise.all(promises).then((results) => {
    const resolvedObj = {};
    for (let i2 = 0; i2 < keys.length; i2++) {
      resolvedObj[keys[i2]] = results[i2];
    }
    return resolvedObj;
  });
}
function randomString(length = 10) {
  const chars = "abcdefghijklmnopqrstuvwxyz";
  let str = "";
  for (let i2 = 0; i2 < length; i2++) {
    str += chars[Math.floor(Math.random() * chars.length)];
  }
  return str;
}
function esc(str) {
  return JSON.stringify(str);
}
function slugify(input) {
  return input.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
function isObject(data) {
  return typeof data === "object" && data !== null && !Array.isArray(data);
}
function isPlainObject(o) {
  if (isObject(o) === false)
    return false;
  const ctor = o.constructor;
  if (ctor === void 0)
    return true;
  if (typeof ctor !== "function")
    return true;
  const prot = ctor.prototype;
  if (isObject(prot) === false)
    return false;
  if (Object.prototype.hasOwnProperty.call(prot, "isPrototypeOf") === false) {
    return false;
  }
  return true;
}
function shallowClone(o) {
  if (isPlainObject(o))
    return { ...o };
  if (Array.isArray(o))
    return [...o];
  if (o instanceof Map)
    return new Map(o);
  if (o instanceof Set)
    return new Set(o);
  return o;
}
function numKeys(data) {
  let keyCount = 0;
  for (const key in data) {
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      keyCount++;
    }
  }
  return keyCount;
}
function escapeRegex(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function clone(inst, def, params) {
  const cl2 = new inst._zod.constr(def ?? inst._zod.def);
  if (!def || params?.parent)
    cl2._zod.parent = inst;
  return cl2;
}
function normalizeParams(_params) {
  const params = _params;
  if (!params)
    return {};
  if (typeof params === "string")
    return { error: () => params };
  if (params?.message !== void 0) {
    if (params?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    params.error = params.message;
  }
  delete params.message;
  if (typeof params.error === "string")
    return { ...params, error: () => params.error };
  return params;
}
function createTransparentProxy(getter2) {
  let target3;
  return new Proxy({}, {
    get(_3, prop, receiver) {
      target3 ?? (target3 = getter2());
      return Reflect.get(target3, prop, receiver);
    },
    set(_3, prop, value, receiver) {
      target3 ?? (target3 = getter2());
      return Reflect.set(target3, prop, value, receiver);
    },
    has(_3, prop) {
      target3 ?? (target3 = getter2());
      return Reflect.has(target3, prop);
    },
    deleteProperty(_3, prop) {
      target3 ?? (target3 = getter2());
      return Reflect.deleteProperty(target3, prop);
    },
    ownKeys(_3) {
      target3 ?? (target3 = getter2());
      return Reflect.ownKeys(target3);
    },
    getOwnPropertyDescriptor(_3, prop) {
      target3 ?? (target3 = getter2());
      return Reflect.getOwnPropertyDescriptor(target3, prop);
    },
    defineProperty(_3, prop, descriptor) {
      target3 ?? (target3 = getter2());
      return Reflect.defineProperty(target3, prop, descriptor);
    }
  });
}
function stringifyPrimitive(value) {
  if (typeof value === "bigint")
    return value.toString() + "n";
  if (typeof value === "string")
    return `"${value}"`;
  return `${value}`;
}
function optionalKeys(shape) {
  return Object.keys(shape).filter((k2) => {
    return shape[k2]._zod.optin !== void 0 && shape[k2]._zod.optout === "optional";
  });
}
function pick(schema, mask) {
  const currDef = schema._zod.def;
  const checks = currDef.checks;
  const hasChecks = checks && checks.length > 0;
  if (hasChecks) {
    throw new Error(".pick() cannot be used on object schemas containing refinements");
  }
  const newShape = {};
  mirrorShape(newShape, schema, maskedKeys(schema, mask));
  return clone(schema, mergeDefs(currDef, { shape: newShape, checks: [] }));
}
function maskedKeys(schema, mask) {
  const raw = sourceShape(schema);
  const keys = [];
  for (const key of Reflect.ownKeys(mask)) {
    if (!Object.getOwnPropertyDescriptor(raw, key)?.enumerable) {
      throw new Error(`Unrecognized key: "${String(key)}"`);
    }
    if (mask[key])
      keys.push(key);
  }
  return keys;
}
function omit(schema, mask) {
  const currDef = schema._zod.def;
  const checks = currDef.checks;
  const hasChecks = checks && checks.length > 0;
  if (hasChecks) {
    throw new Error(".omit() cannot be used on object schemas containing refinements");
  }
  const omitted = new Set(maskedKeys(schema, mask));
  const newShape = {};
  mirrorShape(newShape, schema, Reflect.ownKeys(sourceShape(schema)).filter((key) => !omitted.has(key)));
  return clone(schema, mergeDefs(currDef, { shape: newShape, checks: [] }));
}
function extend(schema, shape) {
  if (!isPlainObject(shape)) {
    throw new Error("Invalid input to extend: expected a plain object");
  }
  const checks = schema._zod.def.checks;
  const hasChecks = checks && checks.length > 0;
  if (hasChecks) {
    const existingShape = sourceShape(schema);
    for (const key of Reflect.ownKeys(shape)) {
      if (Object.getOwnPropertyDescriptor(existingShape, key) !== void 0) {
        throw new Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
      }
    }
  }
  return clone(schema, mergeDefs(schema._zod.def, { shape: extended(schema, shape) }));
}
function extended(schema, shape) {
  const newShape = {};
  mirrorShape(newShape, schema, Reflect.ownKeys(sourceShape(schema)));
  mirrorProps(newShape, shape);
  return newShape;
}
function safeExtend(schema, shape) {
  if (!isPlainObject(shape)) {
    throw new Error("Invalid input to safeExtend: expected a plain object");
  }
  return clone(schema, mergeDefs(schema._zod.def, { shape: extended(schema, shape) }));
}
function merge(a2, b3) {
  if (!b3?._zod?.def) {
    throw new Error("Invalid input to merge: expected an object schema. To merge a plain shape, use `.extend()`.");
  }
  if (a2._zod.def.checks?.length) {
    throw new Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
  }
  const newShape = {};
  mirrorShape(newShape, a2, Reflect.ownKeys(sourceShape(a2)));
  mirrorShape(newShape, b3, Reflect.ownKeys(sourceShape(b3)));
  const def = mergeDefs(a2._zod.def, {
    shape: newShape,
    get catchall() {
      return b3._zod.def.catchall;
    },
    checks: b3._zod.def.checks ?? []
  });
  return clone(a2, def);
}
function partial(Class2, schema, mask, name = "partial") {
  const currDef = schema._zod.def;
  const checks = currDef.checks;
  const hasChecks = checks && checks.length > 0;
  if (hasChecks) {
    throw new Error(`.${name}() cannot be used on object schemas containing refinements`);
  }
  const selected = mask ? new Set(maskedKeys(schema, mask)) : void 0;
  const newShape = {};
  mirrorShape(newShape, schema, Reflect.ownKeys(sourceShape(schema)), Class2 && ((value, key) => selected && !selected.has(key) ? value : new Class2({ type: "optional", innerType: value })));
  return clone(schema, mergeDefs(schema._zod.def, { shape: newShape, checks: [] }));
}
function required(Class2, schema, mask) {
  const selected = mask ? new Set(maskedKeys(schema, mask)) : void 0;
  const newShape = {};
  mirrorShape(newShape, schema, Reflect.ownKeys(sourceShape(schema)), (value, key) => (
    // overwrite with non-optional
    selected && !selected.has(key) ? value : new Class2({ type: "nonoptional", innerType: value })
  ));
  return clone(schema, mergeDefs(schema._zod.def, { shape: newShape }));
}
function aborted(x4, startIndex = 0) {
  if (x4.aborted === true)
    return true;
  for (let i2 = startIndex; i2 < x4.issues.length; i2++) {
    if (x4.issues[i2]?.continue !== true) {
      return true;
    }
  }
  return false;
}
function explicitlyAborted(x4, startIndex = 0) {
  if (x4.aborted === true)
    return true;
  for (let i2 = startIndex; i2 < x4.issues.length; i2++) {
    if (x4.issues[i2]?.continue === false) {
      return true;
    }
  }
  return false;
}
function prefixIssues(path, issues) {
  return issues.map((iss) => {
    var _a3;
    (_a3 = iss).path ?? (_a3.path = []);
    iss.path.unshift(path);
    return iss;
  });
}
function unwrapMessage(message) {
  return typeof message === "string" ? message : message?.message;
}
function attachSchema(issues, start, inst) {
  var _a3;
  for (let i2 = start; i2 < issues.length; i2++) {
    (_a3 = issues[i2]).schema ?? (_a3.schema = inst);
  }
}
function finalizeIssue(iss, ctx, config2) {
  var _a3;
  const traits = iss.inst?._zod?.traits;
  if (traits?.has("$ZodType")) {
    if (traits.has("$ZodCheck"))
      (_a3 = iss).schema ?? (_a3.schema = iss.inst);
    else
      iss.schema = iss.inst;
  }
  const schemaError = iss.schema !== iss.inst ? iss.schema?._zod.def?.error : void 0;
  const message = iss.message ? iss.message : unwrapMessage(iss.inst?._zod.def?.error?.(iss)) ?? unwrapMessage(schemaError?.(iss)) ?? unwrapMessage(ctx?.error?.(iss)) ?? unwrapMessage(config2.customError?.(iss)) ?? unwrapMessage(config2.localeError?.(iss)) ?? "Invalid input";
  const full = {};
  for (const k2 of Object.keys(iss)) {
    if (k2 === "inst" || k2 === "schema" || k2 === "continue" || k2 === "input" || k2 === "__proto__")
      continue;
    full[k2] = iss[k2];
  }
  full.path ?? (full.path = []);
  full.message = message;
  if (ctx?.reportInput) {
    full.input = iss.input;
  }
  return full;
}
function getSizableOrigin(input) {
  if (input instanceof Set)
    return "set";
  if (input instanceof Map)
    return "map";
  if (input instanceof File)
    return "file";
  return "unknown";
}
function codePointLength(str) {
  const units = str.length;
  if (!highSurrogate.test(str))
    return units;
  let count2 = units;
  for (let i2 = 0; i2 < units - 1; i2++) {
    if ((str.charCodeAt(i2) & 64512) === 55296 && (str.charCodeAt(i2 + 1) & 64512) === 56320) {
      count2--;
      i2++;
    }
  }
  return count2;
}
function getLengthableOrigin(input) {
  if (Array.isArray(input))
    return "array";
  if (typeof input === "string")
    return "string";
  return "unknown";
}
function parsedType(data) {
  const t = typeof data;
  switch (t) {
    case "number": {
      return Number.isNaN(data) ? "nan" : "number";
    }
    case "object": {
      if (data === null) {
        return "null";
      }
      if (Array.isArray(data)) {
        return "array";
      }
      const obj = data;
      if (obj && Object.getPrototypeOf(obj) !== Object.prototype && "constructor" in obj && obj.constructor) {
        return obj.constructor.name;
      }
    }
  }
  return t;
}
function issue(...args) {
  const [iss, input, inst] = args;
  if (typeof iss === "string") {
    return {
      message: iss,
      code: "custom",
      input,
      inst
    };
  }
  return { ...iss };
}
function cleanEnum(obj) {
  return Object.entries(obj).filter(([k2, _3]) => {
    return Number.isNaN(Number.parseInt(k2, 10));
  }).map((el) => el[1]);
}
function base64ToUint8Array(base642) {
  const binaryString = atob(base642);
  const bytes = new Uint8Array(binaryString.length);
  for (let i2 = 0; i2 < binaryString.length; i2++) {
    bytes[i2] = binaryString.charCodeAt(i2);
  }
  return bytes;
}
function uint8ArrayToBase64(bytes) {
  let binaryString = "";
  for (let i2 = 0; i2 < bytes.length; i2++) {
    binaryString += String.fromCharCode(bytes[i2]);
  }
  return btoa(binaryString);
}
function base64urlToUint8Array(base64url2) {
  const base642 = base64url2.replace(/-/g, "+").replace(/_/g, "/");
  const padding = "=".repeat((4 - base642.length % 4) % 4);
  return base64ToUint8Array(base642 + padding);
}
function uint8ArrayToBase64url(bytes) {
  return uint8ArrayToBase64(bytes).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function hexToUint8Array(hex) {
  const cleanHex = hex.replace(/^0x/, "");
  if (cleanHex.length % 2 !== 0) {
    throw new Error("Invalid hex string length");
  }
  const bytes = new Uint8Array(cleanHex.length / 2);
  for (let i2 = 0; i2 < cleanHex.length; i2 += 2) {
    bytes[i2 / 2] = Number.parseInt(cleanHex.slice(i2, i2 + 2), 16);
  }
  return bytes;
}
function uint8ArrayToHex(bytes) {
  return Array.from(bytes).map((b3) => b3.toString(16).padStart(2, "0")).join("");
}
function members(proto, table) {
  for (const key in table) {
    const desc = Object.getOwnPropertyDescriptor(table, key);
    if (desc.get)
      Object.defineProperty(proto, key, { ...desc, enumerable: false });
    else
      defineBound(proto, key, desc.value);
  }
}
function own(inst, key, value, enumerable = true) {
  Object.defineProperty(inst, key, { configurable: true, writable: true, enumerable, value });
  return value;
}
function hide(inst, key, value) {
  return own(inst, key, value, false);
}
// @__NO_SIDE_EFFECTS__
function derived(computes, table) {
  for (const key in computes) {
    const compute = computes[key];
    Object.defineProperty(table, key, {
      configurable: true,
      enumerable: true,
      get() {
        return own(this, key, compute(this));
      },
      set(value) {
        own(this, key, value);
      }
    });
  }
  return table;
}
function defineBound(proto, key, fn) {
  Object.defineProperty(proto, key, {
    configurable: true,
    get() {
      return this == null ? fn : own(this, key, fn.bind(this));
    },
    set(value) {
      own(this, key, value);
    }
  });
}
function claim(inst, sentinel) {
  const proto = Object.getPrototypeOf(inst);
  return sentinel in proto ? void 0 : proto;
}
function defineLazyInternal(inst, key, compute) {
  const proto = Object.getPrototypeOf(inst._zod);
  if (key in proto && installing !== inst._zod) {
    installing = void 0;
    return;
  }
  installing = inst._zod;
  Object.defineProperty(proto, key, {
    configurable: true,
    get() {
      Object.defineProperty(this, key, breaker);
      const outer = broke;
      broke = false;
      try {
        const value = compute(this);
        if (broke)
          delete this[key];
        else
          Object.defineProperty(this, key, { configurable: true, writable: true, value });
        broke = broke || outer;
        return value;
      } catch (err2) {
        delete this[key];
        broke = broke || outer;
        throw err2;
      }
    },
    set(value) {
      Object.defineProperty(this, key, { configurable: true, writable: true, value });
    }
  });
}
function installLazyProp(inst, key, make, enumerable) {
  const proto = claim(inst, key);
  if (!proto)
    return;
  Object.defineProperty(proto, key, {
    configurable: true,
    get() {
      const desc = { configurable: true, writable: true, enumerable, value: void 0 };
      Object.defineProperty(this, key, desc);
      desc.value = make(this);
      Object.defineProperty(this, key, desc);
      return desc.value;
    },
    set(value) {
      Object.defineProperty(this, key, { configurable: true, writable: true, enumerable, value });
    }
  });
}
function constantCatch(value) {
  const fn = () => value;
  fn[CONSTANT_CATCH] = true;
  return fn;
}
var Cached, EVALUATING, captureStackTrace, allowsEval, getParsedType, propertyKeyTypes, primitiveTypes, NUMBER_FORMAT_RANGES, BIGINT_FORMAT_RANGES, highSurrogate, Class, installing, broke, breaker, CONSTANT_CATCH;
var init_util = __esm({
  "../../node_modules/zod/v4/core/util.js"() {
    init_core();
    Cached = class {
      constructor(getter2) {
        this._getter = getter2;
        this._value = void 0;
      }
      get value() {
        const getter2 = this._getter;
        if (getter2 !== void 0) {
          this._value = getter2();
          this._getter = void 0;
        }
        return this._value;
      }
    };
    EVALUATING = /* @__PURE__ */ Symbol("evaluating");
    captureStackTrace = "captureStackTrace" in Error ? Error.captureStackTrace : (..._args) => {
    };
    allowsEval = /* @__PURE__ */ cached(() => {
      if (globalConfig.jitless) {
        return false;
      }
      if (typeof navigator !== "undefined" && navigator?.userAgent?.includes("Cloudflare")) {
        return false;
      }
      try {
        const F3 = Function;
        new F3("");
        return true;
      } catch (_3) {
        return false;
      }
    });
    getParsedType = (data) => {
      const t = typeof data;
      switch (t) {
        case "undefined":
          return "undefined";
        case "string":
          return "string";
        case "number":
          return Number.isNaN(data) ? "nan" : "number";
        case "boolean":
          return "boolean";
        case "function":
          return "function";
        case "bigint":
          return "bigint";
        case "symbol":
          return "symbol";
        case "object":
          if (Array.isArray(data)) {
            return "array";
          }
          if (data === null) {
            return "null";
          }
          if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
            return "promise";
          }
          if (typeof Map !== "undefined" && data instanceof Map) {
            return "map";
          }
          if (typeof Set !== "undefined" && data instanceof Set) {
            return "set";
          }
          if (typeof Date !== "undefined" && data instanceof Date) {
            return "date";
          }
          if (typeof File !== "undefined" && data instanceof File) {
            return "file";
          }
          return "object";
        default:
          throw new Error(`Unknown data type: ${t}`);
      }
    };
    propertyKeyTypes = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
    primitiveTypes = /* @__PURE__ */ new Set([
      "string",
      "number",
      "bigint",
      "boolean",
      "symbol",
      "undefined"
    ]);
    NUMBER_FORMAT_RANGES = /* @__PURE__ */ (() => ({
      safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
      int32: [-2147483648, 2147483647],
      uint32: [0, 4294967295],
      float32: [-34028234663852886e22, 34028234663852886e22],
      float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
    }))();
    BIGINT_FORMAT_RANGES = {
      int64: [/* @__PURE__ */ BigInt("-9223372036854775808"), /* @__PURE__ */ BigInt("9223372036854775807")],
      uint64: [/* @__PURE__ */ BigInt(0), /* @__PURE__ */ BigInt("18446744073709551615")]
    };
    highSurrogate = /[\uD800-\uDBFF]/;
    Class = class {
      constructor(..._args) {
      }
    };
    broke = false;
    breaker = {
      configurable: true,
      get() {
        broke = true;
        return void 0;
      }
    };
    CONSTANT_CATCH = "~constantCatch";
  }
});

// ../../node_modules/zod/v4/core/core.js
function newError(Definition) {
  const E2 = _E;
  if (E2) {
    const saved = E2.stackTraceLimit;
    if (typeof saved === "number") {
      try {
        E2.stackTraceLimit = 0;
      } catch {
        _E = null;
        return new Definition();
      }
      try {
        return new Definition();
      } finally {
        E2.stackTraceLimit = saved;
      }
    }
  }
  return new Definition();
}
// @__NO_SIDE_EFFECTS__
function $constructor(name, initializer2, proto, params) {
  const zodProto = {};
  function Internals(def) {
    this.def = def;
    this.constr = _3;
    this.traits = /* @__PURE__ */ new Set();
  }
  Internals.prototype = zodProto;
  const protoMembers = proto;
  const initialized = protoMembers && /* @__PURE__ */ new WeakSet();
  function init(inst, def) {
    if (!inst._zod) {
      _zodDesc.value = new Internals(def);
      try {
        Object.defineProperty(inst, "_zod", _zodDesc);
      } finally {
        _zodDesc.value = void 0;
      }
    } else if (inst._zod.traits.has(name)) {
      return;
    }
    inst._zod.traits.add(name);
    initializer2(inst, def);
    if (initialized) {
      const own2 = Object.getPrototypeOf(inst);
      const ctorProto = inst._zod.constr.prototype;
      let up = own2;
      while (up && up !== ctorProto)
        up = Object.getPrototypeOf(up);
      const target3 = up ?? own2;
      if (!initialized.has(target3)) {
        initialized.add(target3);
        members(target3, protoMembers);
      }
    }
    const proto2 = _3.prototype;
    for (const k2 in proto2) {
      if (!Object.prototype.hasOwnProperty.call(proto2, k2))
        continue;
      if (!(k2 in inst)) {
        inst[k2] = proto2[k2].bind(inst);
      }
    }
  }
  const Parent = params?.Parent ?? Object;
  class Definition extends Parent {
  }
  Object.defineProperty(Definition, "name", { value: name });
  function _3(def) {
    const inst = params?.Parent ? newError(Definition) : this;
    init(inst, def);
    const deferred = inst._zod.deferred;
    if (deferred) {
      for (const fn of deferred) {
        fn();
      }
      inst._zod.deferred = void 0;
    }
    const pp = globalThis.__zod_globalConfig?.postProcessor;
    if (pp)
      pp(inst);
    return inst;
  }
  Object.defineProperty(_3, "init", { value: init });
  Object.defineProperty(_3, Symbol.hasInstance, {
    value: (inst) => {
      if (params?.Parent && inst instanceof params.Parent)
        return true;
      return inst?._zod?.traits?.has(name);
    }
  });
  Object.defineProperty(_3, "name", { value: name });
  return _3;
}
function config(newConfig) {
  if (newConfig)
    Object.assign(globalConfig, newConfig);
  return globalConfig;
}
var _a, _zodDesc, _E, $ZodAsyncError, $ZodEncodeError, globalConfig;
var init_core = __esm({
  "../../node_modules/zod/v4/core/core.js"() {
    init_util();
    _zodDesc = { value: void 0, enumerable: false };
    _E = "captureStackTrace" in Error ? Error : null;
    $ZodAsyncError = class extends Error {
      constructor() {
        super(`Encountered Promise during synchronous parse. Use .parseAsync() instead.`);
      }
    };
    $ZodEncodeError = class extends Error {
      constructor(name) {
        super(`Encountered unidirectional transform during encode: ${name}`);
        this.name = "ZodEncodeError";
      }
    };
    (_a = globalThis).__zod_globalConfig ?? (_a.__zod_globalConfig = {});
    globalConfig = globalThis.__zod_globalConfig;
  }
});

// ../../node_modules/zod/v4/core/errors.js
function _getMessage() {
  const internals = this._zod;
  internals.message ?? (internals.message = JSON.stringify(internals.def, jsonStringifyReplacer, 2));
  return internals.message;
}
function _setMessage(value) {
  this._zod.message = value;
}
var _messageDesc, _issuesDesc, _installedToString, initializer, $ZodError, $ZodRealError;
var init_errors = __esm({
  "../../node_modules/zod/v4/core/errors.js"() {
    init_core();
    init_util();
    _messageDesc = {
      get: _getMessage,
      set: _setMessage,
      enumerable: true,
      configurable: true
    };
    _issuesDesc = { value: void 0, enumerable: false };
    _installedToString = /* @__PURE__ */ new WeakSet([Object.prototype, Error.prototype]);
    initializer = (inst, def) => {
      inst.name = "$ZodError";
      _issuesDesc.value = def;
      Object.defineProperty(inst, "issues", _issuesDesc);
      _issuesDesc.value = void 0;
      Object.defineProperty(inst, "message", _messageDesc);
      const proto = Object.getPrototypeOf(inst);
      if (!_installedToString.has(proto)) {
        _installedToString.add(proto);
        Object.defineProperty(proto, "toString", {
          configurable: true,
          enumerable: false,
          get() {
            const value = () => this.message;
            Object.defineProperty(this, "toString", { value, configurable: true, writable: true });
            return value;
          },
          set(value) {
            Object.defineProperty(this, "toString", { value, configurable: true, writable: true });
          }
        });
      }
    };
    $ZodError = $constructor("$ZodError", initializer);
    $ZodRealError = $constructor("$ZodError", initializer, void 0, {
      Parent: Error
    });
  }
});

// ../../node_modules/zod/v4/core/parse.js
function failure(Err, issues, ctx) {
  let error2;
  return {
    success: false,
    get error() {
      if (!error2) {
        error2 = new Err(issues.map((iss) => finalizeIssue(iss, ctx, config())));
        issues = void 0;
        ctx = void 0;
      }
      return error2;
    },
    set error(e5) {
      error2 = e5;
      issues = void 0;
      ctx = void 0;
    }
  };
}
var _parse, parse, _parseAsync, parseAsync, _safeParse, safeParse, _safeParseAsync, safeParseAsync;
var init_parse = __esm({
  "../../node_modules/zod/v4/core/parse.js"() {
    init_core();
    init_errors();
    init_util();
    _parse = (_Err) => {
      const fn = (schema, value, _ctx, _params) => {
        const ctx = _ctx ? { ..._ctx, async: false } : { async: false };
        const result = schema._zod.run({ value, issues: [] }, ctx);
        if (result instanceof Promise) {
          throw new $ZodAsyncError();
        }
        if (result.issues.length) {
          const e5 = new (_params?.Err ?? _Err)(result.issues.map((iss) => finalizeIssue(iss, ctx, config())));
          captureStackTrace(e5, _params?.callee ?? fn);
          throw e5;
        }
        return result.value;
      };
      return fn;
    };
    parse = /* @__PURE__ */ _parse($ZodRealError);
    _parseAsync = (_Err) => {
      const fn = async (schema, value, _ctx, params) => {
        const ctx = _ctx ? { ..._ctx, async: true } : { async: true };
        let result = schema._zod.run({ value, issues: [] }, ctx);
        if (result instanceof Promise)
          result = await result;
        if (result.issues.length) {
          const e5 = new (params?.Err ?? _Err)(result.issues.map((iss) => finalizeIssue(iss, ctx, config())));
          captureStackTrace(e5, params?.callee ?? fn);
          throw e5;
        }
        return result.value;
      };
      return fn;
    };
    parseAsync = /* @__PURE__ */ _parseAsync($ZodRealError);
    _safeParse = (_Err) => (schema, value, _ctx) => {
      const ctx = _ctx ? { ..._ctx, async: false } : { async: false };
      const result = schema._zod.run({ value, issues: [] }, ctx);
      if (result instanceof Promise) {
        throw new $ZodAsyncError();
      }
      return result.issues.length ? failure(_Err, result.issues, ctx) : { success: true, data: result.value };
    };
    safeParse = /* @__PURE__ */ _safeParse($ZodRealError);
    _safeParseAsync = (_Err) => async (schema, value, _ctx) => {
      const ctx = _ctx ? { ..._ctx, async: true } : { async: true };
      let result = schema._zod.run({ value, issues: [] }, ctx);
      if (result instanceof Promise)
        result = await result;
      return result.issues.length ? failure(_Err, result.issues, ctx) : { success: true, data: result.value };
    };
    safeParseAsync = /* @__PURE__ */ _safeParseAsync($ZodRealError);
  }
});

// ../../node_modules/zod/v4/core/regexes.js
var httpProtocol, anyString, bigint, number, boolean;
var init_regexes = __esm({
  "../../node_modules/zod/v4/core/regexes.js"() {
    httpProtocol = /^https?$/;
    anyString = /^[\s\S]{0,}$/;
    bigint = /^-?\d+n?$/;
    number = /^-?\d+(?:\.\d+)?$/;
    boolean = /^(?:true|false)$/i;
  }
});

// ../../node_modules/zod/v4/core/checks.js
var $ZodCheck, numericOriginMap, $ZodCheckLessThan, $ZodCheckGreaterThan, $ZodCheckNumberFormat, $ZodCheckStringFormat, $ZodCheckRegex;
var init_checks = __esm({
  "../../node_modules/zod/v4/core/checks.js"() {
    init_core();
    init_util();
    $ZodCheck = /* @__PURE__ */ $constructor("$ZodCheck", (inst, def) => {
      var _a3;
      inst._zod ?? (inst._zod = {});
      inst._zod.def = def;
      (_a3 = inst._zod).onattach ?? (_a3.onattach = []);
    });
    numericOriginMap = {
      number: "number",
      bigint: "bigint",
      object: "date"
    };
    $ZodCheckLessThan = /* @__PURE__ */ $constructor("$ZodCheckLessThan", (inst, def) => {
      $ZodCheck.init(inst, def);
      const origin = numericOriginMap[typeof def.value];
      inst._zod.check = (payload) => {
        if (def.inclusive ? payload.value <= def.value : payload.value < def.value) {
          return;
        }
        payload.issues.push({
          origin: numericOriginMap[typeof payload.value] ?? origin,
          code: "too_big",
          maximum: typeof def.value === "object" ? def.value.getTime() : def.value,
          input: payload.value,
          inclusive: def.inclusive,
          inst,
          continue: !def.abort
        });
      };
    });
    $ZodCheckGreaterThan = /* @__PURE__ */ $constructor("$ZodCheckGreaterThan", (inst, def) => {
      $ZodCheck.init(inst, def);
      const origin = numericOriginMap[typeof def.value];
      inst._zod.check = (payload) => {
        if (def.inclusive ? payload.value >= def.value : payload.value > def.value) {
          return;
        }
        payload.issues.push({
          origin: numericOriginMap[typeof payload.value] ?? origin,
          code: "too_small",
          minimum: typeof def.value === "object" ? def.value.getTime() : def.value,
          input: payload.value,
          inclusive: def.inclusive,
          inst,
          continue: !def.abort
        });
      };
    });
    $ZodCheckNumberFormat = /* @__PURE__ */ $constructor("$ZodCheckNumberFormat", (inst, def) => {
      $ZodCheck.init(inst, def);
      def.format = def.format || "float64";
      const isInt = def.format?.includes("int");
      const origin = isInt ? "int" : "number";
      const [minimum, maximum] = NUMBER_FORMAT_RANGES[def.format];
      inst._zod.check = (payload) => {
        const input = payload.value;
        if (isInt) {
          if (!Number.isInteger(input)) {
            payload.issues.push({
              expected: origin,
              format: def.format,
              code: "invalid_type",
              continue: false,
              input,
              inst
            });
            return;
          }
          if (!Number.isSafeInteger(input)) {
            if (input > 0) {
              payload.issues.push({
                input,
                code: "too_big",
                maximum: Number.MAX_SAFE_INTEGER,
                note: "Integers must be within the safe integer range.",
                inst,
                origin,
                inclusive: true,
                continue: !def.abort
              });
            } else {
              payload.issues.push({
                input,
                code: "too_small",
                minimum: Number.MIN_SAFE_INTEGER,
                note: "Integers must be within the safe integer range.",
                inst,
                origin,
                inclusive: true,
                continue: !def.abort
              });
            }
            return;
          }
        }
        if (input < minimum) {
          payload.issues.push({
            origin: "number",
            input,
            code: "too_small",
            minimum,
            inclusive: true,
            inst,
            continue: !def.abort
          });
        }
        if (input > maximum) {
          payload.issues.push({
            origin: "number",
            input,
            code: "too_big",
            maximum,
            inclusive: true,
            inst,
            continue: !def.abort
          });
        }
      };
    });
    $ZodCheckStringFormat = /* @__PURE__ */ $constructor("$ZodCheckStringFormat", (inst, def) => {
      var _a3, _b;
      $ZodCheck.init(inst, def);
      if (def.pattern)
        (_a3 = inst._zod).check ?? (_a3.check = (payload) => {
          def.pattern.lastIndex = 0;
          if (def.pattern.test(payload.value))
            return;
          payload.issues.push({
            origin: "string",
            code: "invalid_format",
            format: def.format,
            input: payload.value,
            ...def.pattern ? { pattern: def.pattern.toString() } : {},
            inst,
            continue: !def.abort
          });
        });
      else
        (_b = inst._zod).check ?? (_b.check = () => {
        });
    });
    $ZodCheckRegex = /* @__PURE__ */ $constructor("$ZodCheckRegex", (inst, def) => {
      $ZodCheckStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        def.pattern.lastIndex = 0;
        if (def.pattern.test(payload.value))
          return;
        payload.issues.push({
          origin: "string",
          code: "invalid_format",
          format: "regex",
          input: payload.value,
          pattern: def.pattern.toString(),
          inst,
          continue: !def.abort
        });
      };
    });
  }
});

// ../../node_modules/zod/v4/core/doc.js
var init_doc = __esm({
  "../../node_modules/zod/v4/core/doc.js"() {
  }
});

// ../../node_modules/zod/v4/core/versions.js
var version;
var init_versions = __esm({
  "../../node_modules/zod/v4/core/versions.js"() {
    version = {
      major: 4,
      minor: 6,
      patch: 5
    };
  }
});

// ../../node_modules/zod/v4/core/schemas.js
async function validateAsync(inst, value) {
  const ctx = { async: true };
  return toStandardResult(await inst._zod.run({ value, issues: [] }, ctx), ctx);
}
function standardProps(inst) {
  return {
    validate: (value) => {
      const ctx = { async: false };
      try {
        const r2 = inst._zod.run({ value, issues: [] }, ctx);
        if (!(r2 instanceof Promise))
          return toStandardResult(r2, ctx);
      } catch (_3) {
      }
      return validateAsync(inst, value);
    },
    vendor: "zod",
    version: 1
  };
}
function canParseURL(input) {
  try {
    if (typeof URL !== "undefined" && typeof URL.canParse === "function")
      return URL.canParse(input);
    new URL(input);
    return true;
  } catch {
    return false;
  }
}
function validateURL(trimmed, def) {
  if (!("normalize" in def) && !("hostname" in def) && !("protocol" in def)) {
    return canParseURL(trimmed) || URL_UNPARSEABLE;
  }
  return parseURLObject(trimmed, def);
}
function parseURLObject(trimmed, def) {
  if (!def.normalize && def.protocol?.source === httpProtocol.source && !/^https?:\/\//i.test(trimmed)) {
    return URL_BAD_FORMAT;
  }
  try {
    if (typeof URL !== "undefined") {
      const URLStatic = URL;
      if (typeof URLStatic.parse === "function")
        return URLStatic.parse(trimmed) ?? URL_UNPARSEABLE;
    }
    return new URL(trimmed);
  } catch {
    return URL_UNPARSEABLE;
  }
}
function stripTabAndNewline(value) {
  return value.replace(asciiTabOrNewline, "");
}
function urlHostnameOk(url2, hostname) {
  hostname.lastIndex = 0;
  return hostname.test(url2.hostname);
}
function urlProtocolOk(url2, protocol) {
  protocol.lastIndex = 0;
  return protocol.test(url2.protocol.endsWith(":") ? url2.protocol.slice(0, -1) : url2.protocol);
}
function isValidBase64(data) {
  if (data === "")
    return true;
  if (/\s/.test(data))
    return false;
  if (data.length % 4 !== 0)
    return false;
  try {
    atob(data);
    return true;
  } catch {
    return false;
  }
}
function handleArrayResult(result, final, index2) {
  if (result.issues.length) {
    final.issues.push(...prefixIssues(index2, result.issues));
  }
  final.value[index2] = result.value;
}
function handlePropertyResult(result, final, key, input, optin, optout) {
  const isPresent = key in input;
  const isOptionalOut = optout === "optional";
  if (!isPresent && isOptionalOut && optin === "optional") {
    return;
  }
  if (result.issues.length) {
    if (optin !== void 0 && isOptionalOut && !isPresent) {
      return;
    }
    final.issues.push(...prefixIssues(key, result.issues));
  }
  if (!isPresent && optin === void 0) {
    if (!result.issues.length) {
      final.issues.push({
        code: "invalid_type",
        expected: "nonoptional",
        input: void 0,
        path: [key]
      });
    }
    return;
  }
  if (result.value === void 0) {
    if (isPresent || optin === "defaulted" && !isOptionalOut) {
      final.value[key] = void 0;
    }
  } else {
    final.value[key] = result.value;
  }
}
function normalizeDef(def) {
  const keys = Object.keys(def.shape);
  const ownSymbols = Object.getOwnPropertySymbols(def.shape);
  const symbolKeys = ownSymbols.length ? ownSymbols : NO_SYMBOL_KEYS;
  const allKeys = symbolKeys.length ? [...keys, ...symbolKeys] : keys;
  for (const k2 of allKeys) {
    if (!def.shape?.[k2]?._zod?.traits?.has("$ZodType")) {
      throw new Error(`Invalid element at key "${String(k2)}": expected a Zod schema`);
    }
  }
  const okeys = optionalKeys(def.shape);
  return {
    ...def,
    allKeys,
    symbolKeys,
    // string-only: handleCatchall matches it against `for...in`, which never yields a symbol
    keySet: new Set(keys),
    numKeys: keys.length,
    optionalKeys: new Set(okeys)
  };
}
function handleCatchall(proms, input, payload, ctx, def, inst, abortEarly) {
  const unrecognized = [];
  const keySet = def.keySet;
  const _catchall = def.catchall._zod;
  const t = _catchall.def.type;
  const optin = _catchall.optin;
  const optout = _catchall.optout;
  let seen = 0;
  for (const key in input) {
    if (abortEarly && payload.issues.length !== seen) {
      if (aborted(payload, seen))
        break;
      seen = payload.issues.length;
    }
    if (keySet.has(key))
      continue;
    if (key === "__proto__") {
      if (t === "never")
        unrecognized.push(key);
      continue;
    }
    if (t === "never") {
      unrecognized.push(key);
      continue;
    }
    const r2 = _catchall.run({ value: input[key], issues: [] }, ctx);
    if (r2 instanceof Promise) {
      proms.push(r2.then((r3) => handlePropertyResult(r3, payload, key, input, optin, optout)));
    } else {
      handlePropertyResult(r2, payload, key, input, optin, optout);
    }
  }
  if (unrecognized.length) {
    payload.issues.push({
      code: "unrecognized_keys",
      keys: unrecognized,
      input,
      inst,
      // Describes the shape of the input, not the validity of the parsed value, so it never aborts. The parse still fails; the schema's own checks just get to run first, and an enclosing intersection can reconcile the key against a sibling operand.
      continue: true
    });
  }
  if (!proms.length)
    return payload;
  return Promise.all(proms).then(() => {
    return payload;
  });
}
function handleUnionResults(results, final, inst, ctx) {
  for (const result of results) {
    if (result.issues.length === 0) {
      final.value = result.value;
      return final;
    }
  }
  const nonaborted = results.filter((r2) => !aborted(r2));
  if (nonaborted.length === 1) {
    final.value = nonaborted[0].value;
    return nonaborted[0];
  }
  final.issues.push({
    code: "invalid_union",
    input: final.value,
    inst,
    errors: results.map((result) => result.issues.map((iss) => finalizeIssue(iss, ctx, config())))
  });
  return final;
}
function discriminatorMap(def) {
  const map = /* @__PURE__ */ new Map();
  for (const option of def.options) {
    const values = option._zod.propValues?.[def.discriminator];
    if (!values || values.size === 0)
      throw new Error(`Invalid discriminated union option at index "${def.options.indexOf(option)}"`);
    for (const value of values) {
      if (map.has(value)) {
        if (value !== void 0)
          throw new Error(`Duplicate discriminator value "${String(value)}"`);
        map.set(value, null);
      } else {
        map.set(value, option);
      }
    }
  }
  return map;
}
function handleOptionalResult(payload, result) {
  payload.value = result.issues.length ? void 0 : result.value;
  return payload;
}
function handleDefaultResult(payload, def) {
  if (payload.value === void 0) {
    payload.value = def.defaultValue;
  }
  return payload;
}
function handleCatchResult(payload, result, def, ctx) {
  if (!result.issues.length) {
    payload.value = result.value;
    if (result.memo)
      payload.memo = true;
    return payload;
  }
  payload.value = def.catchValue({
    ...result,
    value: payload.value,
    error: {
      issues: result.issues.map((iss) => finalizeIssue(iss, ctx, config()))
    },
    input: payload.value
  });
  return payload;
}
function handlePipeResult(left, next, ctx) {
  if (left.issues.some((iss) => iss.code !== "unrecognized_keys")) {
    left.aborted = true;
    return left;
  }
  return next._zod.run({ value: left.value, issues: left.issues }, ctx);
}
function handleRefineResult(result, payload, input, inst) {
  if (!result) {
    const _iss = {
      code: "custom",
      input,
      inst,
      // incorporates params.error into issue reporting
      path: [...inst._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !inst._zod.def.abort
      // params: inst._zod.def.params,
    };
    if (inst._zod.def.params)
      _iss.params = inst._zod.def.params;
    payload.issues.push(issue(_iss));
  }
}
var $ZodType, toStandardResult, $ZodString, $ZodStringFormat, URL_BAD_FORMAT, URL_UNPARSEABLE, asciiTabOrNewline, $ZodURL, base64Charset, $ZodBase64, $ZodNumber, $ZodNumberFormat, $ZodBoolean, $ZodBigInt, $ZodUnknown, $ZodArray, NO_SYMBOL_KEYS, $ZodObject, $ZodUnion, $ZodDiscriminatedUnion, $ZodRecord, $ZodEnum, $ZodLiteral, $ZodTransform, $ZodOptional, $ZodDefault, $ZodCatch, $ZodPipe, $ZodCustom;
var init_schemas = __esm({
  "../../node_modules/zod/v4/core/schemas.js"() {
    init_checks();
    init_core();
    init_regexes();
    init_util();
    init_versions();
    init_util();
    $ZodType = /* @__PURE__ */ $constructor("$ZodType", (inst, def) => {
      var _a3;
      inst ?? (inst = {});
      inst._zod.def = def;
      inst._zod.bag = inst._zod.bag || {};
      inst._zod.version = version;
      const defChecks = inst._zod.def.checks;
      const checks = inst._zod.traits.has("$ZodCheck") ? [inst, ...defChecks ?? []] : defChecks?.length ? [...defChecks] : [];
      for (const ch of checks) {
        for (const fn of ch._zod.onattach) {
          fn(inst);
        }
      }
      if (checks.length === 0) {
        (_a3 = inst._zod).deferred ?? (_a3.deferred = []);
        inst._zod.deferred?.push(() => {
          inst._zod.run = inst._zod.parse;
        });
      } else {
        const runChecks = (payload, checks2, ctx) => {
          if (payload.memo)
            return payload;
          let isAborted = aborted(payload);
          let asyncResult;
          for (const ch of checks2) {
            if (ch._zod.def.when) {
              if (explicitlyAborted(payload))
                continue;
              const shouldRun = ch._zod.def.when(payload);
              if (!shouldRun)
                continue;
            } else if (isAborted) {
              continue;
            }
            const currLen = payload.issues.length;
            const _3 = ch._zod.check(payload);
            if (_3 instanceof Promise && ctx?.async === false) {
              throw new $ZodAsyncError();
            }
            if (asyncResult || _3 instanceof Promise) {
              asyncResult = (asyncResult ?? Promise.resolve()).then(async () => {
                await _3;
                const nextLen = payload.issues.length;
                if (nextLen === currLen)
                  return;
                attachSchema(payload.issues, currLen, inst);
                if (!isAborted)
                  isAborted = aborted(payload, currLen);
              });
            } else {
              const nextLen = payload.issues.length;
              if (nextLen === currLen)
                continue;
              attachSchema(payload.issues, currLen, inst);
              if (!isAborted)
                isAborted = aborted(payload, currLen);
            }
          }
          if (asyncResult) {
            return asyncResult.then(() => {
              return payload;
            });
          }
          return payload;
        };
        const handleCanaryResult = (canary, payload, ctx) => {
          if (aborted(canary)) {
            canary.aborted = true;
            return canary;
          }
          const checkResult = runChecks(payload, checks, ctx);
          if (checkResult instanceof Promise) {
            if (ctx.async === false)
              throw new $ZodAsyncError();
            return checkResult.then((checkResult2) => inst._zod.parse(checkResult2, ctx));
          }
          return inst._zod.parse(checkResult, ctx);
        };
        inst._zod.run = (payload, ctx) => {
          if (ctx.skipChecks) {
            return inst._zod.parse(payload, ctx);
          }
          if (ctx.direction === "backward") {
            const canary = inst._zod.parse({ value: payload.value, issues: [] }, { ...ctx, skipChecks: true });
            if (canary instanceof Promise) {
              return canary.then((canary2) => {
                return handleCanaryResult(canary2, payload, ctx);
              });
            }
            return handleCanaryResult(canary, payload, ctx);
          }
          const result = inst._zod.parse(payload, ctx);
          if (result instanceof Promise) {
            if (ctx.async === false)
              throw new $ZodAsyncError();
            return result.then((result2) => runChecks(result2, checks, ctx));
          }
          return runChecks(result, checks, ctx);
        };
      }
    }, {
      // Wrappers extend this by installing a richer factory over it; reading it eagerly would defeat the laziness.
      get "~standard"() {
        return hide(this, "~standard", standardProps(this));
      },
      set "~standard"(value) {
        own(this, "~standard", value);
      }
    });
    toStandardResult = (r2, ctx) => r2.issues.length ? { issues: r2.issues.map((iss) => finalizeIssue(iss, ctx, config())) } : { value: r2.value };
    $ZodString = /* @__PURE__ */ $constructor("$ZodString", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.pattern = def.pattern ?? anyString;
      inst._zod.parse = (payload, _3) => {
        if (def.coerce)
          try {
            payload.value = String(payload.value);
          } catch (_4) {
          }
        if (typeof payload.value === "string")
          return payload;
        payload.issues.push({
          expected: "string",
          code: "invalid_type",
          input: payload.value,
          inst
        });
        return payload;
      };
    });
    $ZodStringFormat = /* @__PURE__ */ $constructor("$ZodStringFormat", (inst, def) => {
      $ZodCheckStringFormat.init(inst, def);
      $ZodString.init(inst, def);
    });
    URL_BAD_FORMAT = 1;
    URL_UNPARSEABLE = 2;
    asciiTabOrNewline = /[\t\n\r]/g;
    $ZodURL = /* @__PURE__ */ $constructor("$ZodURL", (inst, def) => {
      $ZodStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        try {
          const trimmed = payload.value.trim();
          const url2 = validateURL(trimmed, def);
          if (url2 === URL_BAD_FORMAT) {
            payload.issues.push({
              code: "invalid_format",
              format: "url",
              note: "Invalid URL format",
              input: payload.value,
              inst,
              continue: !def.abort
            });
            return;
          }
          if (url2 === URL_UNPARSEABLE) {
            payload.issues.push({
              code: "invalid_format",
              format: "url",
              input: payload.value,
              inst,
              continue: !def.abort
            });
            return;
          }
          if (url2 === true) {
            payload.value = stripTabAndNewline(trimmed);
            return;
          }
          if (def.hostname && !urlHostnameOk(url2, def.hostname)) {
            payload.issues.push({
              code: "invalid_format",
              format: "url",
              note: "Invalid hostname",
              pattern: def.hostname.source,
              input: payload.value,
              inst,
              continue: !def.abort
            });
          }
          if (def.protocol && !urlProtocolOk(url2, def.protocol)) {
            payload.issues.push({
              code: "invalid_format",
              format: "url",
              note: "Invalid protocol",
              pattern: def.protocol.source,
              input: payload.value,
              inst,
              continue: !def.abort
            });
          }
          payload.value = def.normalize ? url2.href : stripTabAndNewline(trimmed);
          return;
        } catch (_3) {
          payload.issues.push({
            code: "invalid_format",
            format: "url",
            input: payload.value,
            inst,
            continue: !def.abort
          });
        }
      };
    });
    base64Charset = /^[0-9a-zA-Z+/]*={0,2}$/;
    $ZodBase64 = /* @__PURE__ */ $constructor("$ZodBase64", (inst, def) => {
      def.pattern ?? (def.pattern = base64Charset);
      $ZodStringFormat.init(inst, def);
      inst._zod.check = (payload) => {
        if (isValidBase64(payload.value))
          return;
        payload.issues.push({
          code: "invalid_format",
          format: "base64",
          input: payload.value,
          inst,
          continue: !def.abort
        });
      };
    });
    $ZodNumber = /* @__PURE__ */ $constructor("$ZodNumber", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.pattern = number;
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce)
          try {
            payload.value = Number(payload.value);
          } catch (_3) {
          }
        const input = payload.value;
        if (typeof input === "number" && !Number.isNaN(input) && Number.isFinite(input)) {
          return payload;
        }
        const received3 = typeof input === "number" ? Number.isNaN(input) ? "NaN" : !Number.isFinite(input) ? String(input) : void 0 : void 0;
        payload.issues.push({
          expected: "number",
          code: "invalid_type",
          input,
          inst,
          ...received3 ? { received: received3 } : {}
        });
        return payload;
      };
    });
    $ZodNumberFormat = /* @__PURE__ */ $constructor("$ZodNumberFormat", (inst, def) => {
      $ZodCheckNumberFormat.init(inst, def);
      $ZodNumber.init(inst, def);
    });
    $ZodBoolean = /* @__PURE__ */ $constructor("$ZodBoolean", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.pattern = boolean;
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce)
          try {
            payload.value = Boolean(payload.value);
          } catch (_3) {
          }
        const input = payload.value;
        if (typeof input === "boolean")
          return payload;
        payload.issues.push({
          expected: "boolean",
          code: "invalid_type",
          input,
          inst
        });
        return payload;
      };
    });
    $ZodBigInt = /* @__PURE__ */ $constructor("$ZodBigInt", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.pattern = bigint;
      inst._zod.parse = (payload, _ctx) => {
        if (def.coerce)
          try {
            payload.value = BigInt(payload.value);
          } catch (_3) {
          }
        if (typeof payload.value === "bigint")
          return payload;
        payload.issues.push({
          expected: "bigint",
          code: "invalid_type",
          input: payload.value,
          inst
        });
        return payload;
      };
    });
    $ZodUnknown = /* @__PURE__ */ $constructor("$ZodUnknown", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.parse = (payload) => payload;
    });
    $ZodArray = /* @__PURE__ */ $constructor("$ZodArray", (inst, def) => {
      $ZodType.init(inst, def);
      const memo = globalConfig.memoizer;
      memo?.attach(inst);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!Array.isArray(input)) {
          payload.issues.push({
            expected: "array",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, Array(input.length), ctx) : Array(input.length);
        const proms = [];
        const abortEarly = ctx?.abortEarly;
        for (let i2 = 0; i2 < input.length; i2++) {
          const item = input[i2];
          const result = def.element._zod.run({
            value: item,
            issues: []
          }, ctx);
          if (result instanceof Promise) {
            proms.push(result.then((result2) => handleArrayResult(result2, payload, i2)));
          } else {
            handleArrayResult(result, payload, i2);
            if (abortEarly && result.issues.length !== 0 && aborted(result))
              break;
          }
        }
        if (proms.length) {
          return Promise.all(proms).then(() => payload);
        }
        return payload;
      };
    });
    NO_SYMBOL_KEYS = [];
    $ZodObject = /* @__PURE__ */ $constructor("$ZodObject", (inst, def) => {
      $ZodType.init(inst, def);
      const desc = Object.getOwnPropertyDescriptor(def, "shape");
      const sh = desc?.get ? desc.get.raw : def.shape ?? {};
      if (sh) {
        const get2 = () => {
          const newSh = { ...sh };
          Object.defineProperty(def, "shape", { value: newSh });
          get2.raw = newSh;
          return newSh;
        };
        get2.raw = sh;
        Object.defineProperty(def, "shape", { get: get2 });
      }
      const _normalized = cached(() => normalizeDef(def));
      defineLazyInternal(inst, "propValues", (zod) => {
        const shape = zod.def.shape;
        const propValues = {};
        for (const key in shape) {
          const field = shape[key]._zod;
          if (field.values) {
            if (!Object.prototype.hasOwnProperty.call(propValues, key)) {
              assignProp(propValues, key, /* @__PURE__ */ new Set());
            }
            for (const v3 of field.values)
              propValues[key].add(v3);
            if (field.optin !== void 0)
              propValues[key].add(void 0);
          }
        }
        return propValues;
      });
      const isObject3 = isObject;
      const catchall = def.catchall;
      let value;
      const memo = globalConfig.memoizer;
      memo?.attach(inst);
      inst._zod.parse = (payload, ctx) => {
        value ?? (value = _normalized.value);
        const input = payload.value;
        if (!isObject3(input)) {
          payload.issues.push({
            expected: "object",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
        const proms = [];
        const shape = value.shape;
        const abortEarly = ctx?.abortEarly;
        let seen = payload.issues.length;
        for (const key of value.allKeys) {
          if (abortEarly && payload.issues.length !== seen) {
            if (aborted(payload, seen))
              break;
            seen = payload.issues.length;
          }
          if (key === "__proto__")
            continue;
          const el = shape[key];
          const optin = el._zod.optin;
          const optout = el._zod.optout;
          const r2 = el._zod.run({ value: input[key], issues: [] }, ctx);
          if (r2 instanceof Promise) {
            proms.push(r2.then((r3) => handlePropertyResult(r3, payload, key, input, optin, optout)));
          } else {
            handlePropertyResult(r2, payload, key, input, optin, optout);
          }
        }
        if (!catchall) {
          return proms.length ? Promise.all(proms).then(() => payload) : payload;
        }
        return handleCatchall(proms, input, payload, ctx, _normalized.value, inst, abortEarly === true);
      };
    });
    $ZodUnion = /* @__PURE__ */ $constructor("$ZodUnion", (inst, def) => {
      $ZodType.init(inst, def);
      defineLazyInternal(inst, "optin", (zod) => zod.def.options.some((o) => o._zod.optin === "defaulted") ? "defaulted" : zod.def.options.some((o) => o._zod.optin !== void 0) ? "optional" : void 0);
      defineLazyInternal(inst, "optout", (zod) => zod.def.options.some((o) => o._zod.optout === "optional") ? "optional" : void 0);
      defineLazyInternal(inst, "values", (zod) => {
        if (zod.def.options.every((o) => o._zod.values)) {
          return new Set(zod.def.options.flatMap((option) => Array.from(option._zod.values)));
        }
        return void 0;
      });
      defineLazyInternal(inst, "pattern", (zod) => {
        if (zod.def.options.every((o) => o._zod.pattern)) {
          const patterns = zod.def.options.map((o) => o._zod.pattern);
          return new RegExp(`^(${patterns.map((p3) => cleanRegex(p3.source)).join("|")})$`);
        }
        return void 0;
      });
      const first = def.options.length === 1 ? def.options[0]._zod.run : null;
      inst._zod.parse = (payload, ctx) => {
        if (first) {
          return first(payload, ctx);
        }
        let async = false;
        const results = [];
        for (const option of def.options) {
          const result = option._zod.run({
            value: payload.value,
            issues: []
          }, ctx);
          if (result instanceof Promise) {
            results.push(result);
            async = true;
          } else {
            if (result.issues.length === 0)
              return result;
            results.push(result);
          }
        }
        if (!async)
          return handleUnionResults(results, payload, inst, ctx);
        return Promise.all(results).then((results2) => {
          return handleUnionResults(results2, payload, inst, ctx);
        });
      };
    });
    $ZodDiscriminatedUnion = /* @__PURE__ */ $constructor("$ZodDiscriminatedUnion", (inst, def) => {
      def.inclusive = false;
      $ZodUnion.init(inst, def);
      const _super = inst._zod.parse;
      defineLazyInternal(inst, "propValues", (zod) => {
        const propValues = {};
        let undefinedCount = 0;
        for (const option of zod.def.options) {
          const pv = option._zod.propValues;
          if (!pv || Object.keys(pv).length === 0)
            throw new Error(`Invalid discriminated union option at index "${zod.def.options.indexOf(option)}"`);
          if (pv[zod.def.discriminator]?.has(void 0))
            undefinedCount++;
          for (const [k2, v3] of Object.entries(pv)) {
            if (!Object.prototype.hasOwnProperty.call(propValues, k2)) {
              assignProp(propValues, k2, /* @__PURE__ */ new Set());
            }
            for (const val of v3) {
              propValues[k2].add(val);
            }
          }
        }
        if (!zod.def.unionFallback && undefinedCount > 1)
          propValues[zod.def.discriminator]?.delete(void 0);
        return propValues;
      });
      def.options.forEach((option, i2) => {
        const propShape = rawShape(option._zod.def);
        if (propShape && !Object.prototype.hasOwnProperty.call(propShape, def.discriminator)) {
          throw new Error(`Invalid discriminated union option at index "${i2}"`);
        }
      });
      const disc = cached(() => discriminatorMap(def));
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!isObject(input)) {
          payload.issues.push({
            code: "invalid_type",
            expected: "object",
            input,
            inst
          });
          return payload;
        }
        const value = input?.[def.discriminator];
        const opt = disc.value.get(value);
        if (opt && (value !== void 0 || ctx.direction !== "backward")) {
          return opt._zod.run(payload, ctx);
        }
        if (def.unionFallback || ctx.direction === "backward") {
          return _super(payload, ctx);
        }
        payload.issues.push({
          code: "invalid_union",
          errors: [],
          note: "No matching discriminator",
          discriminator: def.discriminator,
          options: Array.from(disc.value.keys()).filter((value2) => disc.value.get(value2) !== null),
          input,
          path: [def.discriminator],
          inst
        });
        return payload;
      };
    });
    $ZodRecord = /* @__PURE__ */ $constructor("$ZodRecord", (inst, def) => {
      $ZodType.init(inst, def);
      const memo = globalConfig.memoizer;
      memo?.attach(inst);
      inst._zod.parse = (payload, ctx) => {
        const input = payload.value;
        if (!isPlainObject(input)) {
          payload.issues.push({
            expected: "record",
            code: "invalid_type",
            input,
            inst
          });
          return payload;
        }
        const proms = [];
        const values = def.keyType._zod.values;
        if (values && !def.partial) {
          payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
          const recordKeys = /* @__PURE__ */ new Set();
          for (const key of values) {
            if (typeof key === "string" || typeof key === "number" || typeof key === "symbol") {
              recordKeys.add(typeof key === "number" ? key.toString() : key);
              if (key === "__proto__")
                continue;
              const keyResult = def.keyType._zod.run({ value: key, issues: [] }, ctx);
              if (keyResult instanceof Promise) {
                throw new Error("Async schemas not supported in object keys currently");
              }
              if (keyResult.issues.length) {
                payload.issues.push({
                  code: "invalid_key",
                  origin: "record",
                  issues: keyResult.issues.map((iss) => finalizeIssue(iss, ctx, config())),
                  input: key,
                  path: [key],
                  inst
                });
                continue;
              }
              const outKey = keyResult.value;
              if (outKey === "__proto__")
                continue;
              const result = def.valueType._zod.run({ value: input[key], issues: [] }, ctx);
              if (result instanceof Promise) {
                proms.push(result.then((result2) => {
                  if (result2.issues.length) {
                    payload.issues.push(...prefixIssues(key, result2.issues));
                  }
                  payload.value[outKey] = result2.value;
                }));
              } else {
                if (result.issues.length) {
                  payload.issues.push(...prefixIssues(key, result.issues));
                }
                payload.value[outKey] = result.value;
              }
            }
          }
          let unrecognized;
          for (const key in input) {
            if (!recordKeys.has(key)) {
              if (def.mode === "loose") {
                if (key === "__proto__")
                  continue;
                payload.value[key] = input[key];
              } else {
                unrecognized = unrecognized ?? [];
                unrecognized.push(key);
              }
            }
          }
          if (unrecognized && unrecognized.length > 0) {
            payload.issues.push({
              code: "unrecognized_keys",
              input,
              inst,
              keys: unrecognized,
              continue: true
            });
          }
        } else {
          payload.value = memo ? memo.alloc(inst, payload, {}, ctx) : {};
          let unrecognized;
          for (const key of Reflect.ownKeys(input)) {
            if (key === "__proto__")
              continue;
            if (!Object.prototype.propertyIsEnumerable.call(input, key))
              continue;
            let keyResult = def.keyType._zod.run({ value: key, issues: [] }, ctx);
            if (keyResult instanceof Promise) {
              throw new Error("Async schemas not supported in object keys currently");
            }
            const checkNumericKey = typeof key === "string" && number.test(key) && keyResult.issues.length;
            if (checkNumericKey) {
              const retryResult = def.keyType._zod.run({ value: Number(key), issues: [] }, ctx);
              if (retryResult instanceof Promise) {
                throw new Error("Async schemas not supported in object keys currently");
              }
              if (retryResult.issues.length === 0) {
                keyResult = retryResult;
              }
            }
            if (keyResult.issues.length) {
              if (def.mode === "loose") {
                payload.value[key] = input[key];
              } else if (values) {
                unrecognized = unrecognized ?? [];
                unrecognized.push(key);
              } else {
                payload.issues.push({
                  code: "invalid_key",
                  origin: "record",
                  issues: keyResult.issues.map((iss) => finalizeIssue(iss, ctx, config())),
                  input: key,
                  path: [key],
                  inst
                });
              }
              continue;
            }
            const outKey = keyResult.value;
            if (outKey === "__proto__")
              continue;
            const result = def.valueType._zod.run({ value: input[key], issues: [] }, ctx);
            if (result instanceof Promise) {
              proms.push(result.then((result2) => {
                if (result2.issues.length) {
                  payload.issues.push(...prefixIssues(key, result2.issues));
                }
                payload.value[outKey] = result2.value;
              }));
            } else {
              if (result.issues.length) {
                payload.issues.push(...prefixIssues(key, result.issues));
              }
              payload.value[outKey] = result.value;
            }
          }
          if (unrecognized && unrecognized.length > 0) {
            payload.issues.push({
              code: "unrecognized_keys",
              input,
              inst,
              keys: unrecognized,
              continue: true
            });
          }
        }
        if (proms.length) {
          return Promise.all(proms).then(() => payload);
        }
        return payload;
      };
    });
    $ZodEnum = /* @__PURE__ */ $constructor("$ZodEnum", (inst, def) => {
      $ZodType.init(inst, def);
      const values = getEnumValues(def.entries);
      const valuesSet = new Set(values);
      inst._zod.values = valuesSet;
      defineLazyInternal(inst, "pattern", (zod) => {
        const patternValues = getEnumValues(zod.def.entries).filter((k2) => propertyKeyTypes.has(typeof k2));
        return new RegExp(patternValues.length ? `^(${patternValues.map((o) => escapeRegex(o.toString())).join("|")})$` : "^[^\\s\\S]$");
      });
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (valuesSet.has(input)) {
          return payload;
        }
        payload.issues.push({
          code: "invalid_value",
          values,
          input,
          inst
        });
        return payload;
      };
    });
    $ZodLiteral = /* @__PURE__ */ $constructor("$ZodLiteral", (inst, def) => {
      $ZodType.init(inst, def);
      const values = new Set(def.values);
      inst._zod.values = values;
      defineLazyInternal(inst, "pattern", (zod) => {
        const vals = zod.def.values;
        return new RegExp(vals.length ? `^(${vals.map((o) => typeof o === "string" ? escapeRegex(o) : o ? escapeRegex(o.toString()) : String(o)).join("|")})$` : "^[^\\s\\S]$");
      });
      inst._zod.parse = (payload, _ctx) => {
        const input = payload.value;
        if (values.has(input)) {
          return payload;
        }
        payload.issues.push({
          code: "invalid_value",
          values: def.values,
          input,
          inst
        });
        return payload;
      };
    });
    $ZodTransform = /* @__PURE__ */ $constructor("$ZodTransform", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.optin = "optional";
      globalConfig.memoizer?.guard(inst);
      inst._zod.parse = (payload, ctx) => {
        if (ctx.direction === "backward") {
          throw new $ZodEncodeError(inst.constructor.name);
        }
        const _out = def.transform(payload.value, payload);
        if (ctx.async) {
          const output = _out instanceof Promise ? _out : Promise.resolve(_out);
          return output.then((output2) => {
            payload.value = output2;
            return payload;
          });
        }
        if (_out instanceof Promise) {
          throw new $ZodAsyncError();
        }
        payload.value = _out;
        return payload;
      };
    });
    $ZodOptional = /* @__PURE__ */ $constructor("$ZodOptional", (inst, def) => {
      $ZodType.init(inst, def);
      defineLazyInternal(inst, "optin", (zod) => zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
      inst._zod.optout = "optional";
      defineLazyInternal(inst, "values", (zod) => {
        const values = zod.def.innerType._zod.values;
        return values ? /* @__PURE__ */ new Set([...values, void 0]) : void 0;
      });
      defineLazyInternal(inst, "pattern", (zod) => {
        const pattern = zod.def.innerType._zod.pattern;
        return pattern ? new RegExp(`^(${cleanRegex(pattern.source)})?$`) : void 0;
      });
      inst._zod.parse = (payload, ctx) => {
        if (payload.value === void 0) {
          if (def.innerType._zod.optin !== "defaulted")
            return payload;
          const result = def.innerType._zod.run({ value: payload.value, issues: [] }, ctx);
          if (result instanceof Promise)
            return result.then((result2) => handleOptionalResult(payload, result2));
          return handleOptionalResult(payload, result);
        }
        return def.innerType._zod.run(payload, ctx);
      };
    });
    $ZodDefault = /* @__PURE__ */ $constructor("$ZodDefault", (inst, def) => {
      $ZodType.init(inst, def);
      inst._zod.optin = "defaulted";
      defineLazyInternal(inst, "values", (zod) => zod.def.innerType._zod.values);
      inst._zod.parse = (payload, ctx) => {
        if (ctx.direction === "backward") {
          return def.innerType._zod.run(payload, ctx);
        }
        if (payload.value === void 0) {
          payload.value = def.defaultValue;
          return payload;
        }
        const result = def.innerType._zod.run(payload, ctx);
        if (result instanceof Promise) {
          return result.then((result2) => handleDefaultResult(result2, def));
        }
        return handleDefaultResult(result, def);
      };
    });
    $ZodCatch = /* @__PURE__ */ $constructor("$ZodCatch", (inst, def) => {
      $ZodType.init(inst, def);
      defineLazyInternal(inst, "optin", (zod) => zod.def.innerType._zod.optin === "defaulted" ? "defaulted" : "optional");
      defineLazyInternal(inst, "optout", (zod) => zod.def.innerType._zod.optout);
      defineLazyInternal(inst, "values", (zod) => zod.def.innerType._zod.values);
      inst._zod.parse = (payload, ctx) => {
        if (ctx.direction === "backward") {
          return def.innerType._zod.run(payload, ctx);
        }
        const result = def.innerType._zod.run({ value: payload.value, issues: [] }, ctx);
        if (result instanceof Promise) {
          return result.then((result2) => handleCatchResult(payload, result2, def, ctx));
        }
        return handleCatchResult(payload, result, def, ctx);
      };
    });
    $ZodPipe = /* @__PURE__ */ $constructor("$ZodPipe", (inst, def) => {
      $ZodType.init(inst, def);
      defineLazyInternal(inst, "values", (zod) => zod.def.in._zod.values);
      defineLazyInternal(inst, "optin", (zod) => zod.def.in._zod.optin);
      defineLazyInternal(inst, "optout", (zod) => zod.def.out._zod.optout);
      defineLazyInternal(inst, "propValues", (zod) => zod.def.in._zod.propValues);
      inst._zod.parse = (payload, ctx) => {
        if (ctx.direction === "backward") {
          const right = def.out._zod.run(payload, ctx);
          if (right instanceof Promise) {
            return right.then((right2) => handlePipeResult(right2, def.in, ctx));
          }
          return handlePipeResult(right, def.in, ctx);
        }
        const left = def.in._zod.run(payload, ctx);
        if (left instanceof Promise) {
          return left.then((left2) => handlePipeResult(left2, def.out, ctx));
        }
        return handlePipeResult(left, def.out, ctx);
      };
    });
    $ZodCustom = /* @__PURE__ */ $constructor("$ZodCustom", (inst, def) => {
      $ZodCheck.init(inst, def);
      $ZodType.init(inst, def);
      inst._zod.parse = (payload, _3) => {
        return payload;
      };
      inst._zod.check = (payload) => {
        const input = payload.value;
        const r2 = def.fn(input);
        if (r2 instanceof Promise) {
          return r2.then((r3) => handleRefineResult(r3, payload, input, inst));
        }
        handleRefineResult(r2, payload, input, inst);
        return;
      };
    });
  }
});

// ../../node_modules/zod/v4/core/memoizer.js
var init_memoizer = __esm({
  "../../node_modules/zod/v4/core/memoizer.js"() {
  }
});

// ../../node_modules/zod/v4/locales/index.js
var init_locales = __esm({
  "../../node_modules/zod/v4/locales/index.js"() {
  }
});

// ../../node_modules/zod/v4/core/registries.js
function registry() {
  return new $ZodRegistry();
}
var _a2, $ZodRegistry, globalRegistry;
var init_registries = __esm({
  "../../node_modules/zod/v4/core/registries.js"() {
    $ZodRegistry = class {
      constructor() {
        this._map = /* @__PURE__ */ new WeakMap();
        this._idmap = /* @__PURE__ */ new Map();
      }
      add(schema, ..._meta) {
        const meta2 = _meta[0];
        this._map.set(schema, meta2);
        if (meta2 && typeof meta2 === "object" && "id" in meta2) {
          this._idmap.set(meta2.id, schema);
        }
        return this;
      }
      clear() {
        this._map = /* @__PURE__ */ new WeakMap();
        this._idmap = /* @__PURE__ */ new Map();
        return this;
      }
      remove(schema) {
        const meta2 = this._map.get(schema);
        if (meta2 && typeof meta2 === "object" && "id" in meta2) {
          this._idmap.delete(meta2.id);
        }
        this._map.delete(schema);
        return this;
      }
      get(schema) {
        const p3 = schema._zod.parent;
        if (p3) {
          const pm = { ...this.get(p3) ?? {} };
          delete pm.id;
          const f3 = { ...pm, ...this._map.get(schema) };
          return Object.keys(f3).length ? f3 : void 0;
        }
        return this._map.get(schema);
      }
      has(schema) {
        return this._map.has(schema);
      }
    };
    (_a2 = globalThis).__zod_globalRegistry ?? (_a2.__zod_globalRegistry = registry());
    globalRegistry = globalThis.__zod_globalRegistry;
  }
});

// ../../node_modules/zod/v4/core/compile.js
var init_compile = __esm({
  "../../node_modules/zod/v4/core/compile.js"() {
  }
});

// ../../node_modules/zod/v4/core/api.js
function snapshotChecks(def) {
  if (def.checks)
    def.checks = [...def.checks];
  return def;
}
// @__NO_SIDE_EFFECTS__
function _string(Class2, params) {
  return new Class2(snapshotChecks({ type: "string", ...normalizeParams(params) }));
}
// @__NO_SIDE_EFFECTS__
function _url(Class2, params) {
  return new Class2({
    type: "string",
    format: "url",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function _base64(Class2, params) {
  return new Class2({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: false,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function _number(Class2, params) {
  return new Class2(snapshotChecks({ type: "number", checks: [], ...normalizeParams(params) }));
}
// @__NO_SIDE_EFFECTS__
function _int(Class2, params) {
  return new Class2({
    type: "number",
    check: "number_format",
    abort: false,
    format: "safeint",
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function _boolean(Class2, params) {
  return new Class2({
    type: "boolean",
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function _bigint(Class2, params) {
  return new Class2({
    type: "bigint",
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function _unknown(Class2) {
  return new Class2({
    type: "unknown"
  });
}
// @__NO_SIDE_EFFECTS__
function _lte(value, params) {
  return new $ZodCheckLessThan({
    check: "less_than",
    ...normalizeParams(params),
    value,
    inclusive: true
  });
}
// @__NO_SIDE_EFFECTS__
function _gt(value, params) {
  return new $ZodCheckGreaterThan({
    check: "greater_than",
    ...normalizeParams(params),
    value,
    inclusive: false
  });
}
// @__NO_SIDE_EFFECTS__
function _gte(value, params) {
  return new $ZodCheckGreaterThan({
    check: "greater_than",
    ...normalizeParams(params),
    value,
    inclusive: true
  });
}
// @__NO_SIDE_EFFECTS__
function _positive(params) {
  return /* @__PURE__ */ _gt(0, params);
}
// @__NO_SIDE_EFFECTS__
function _nonnegative(params) {
  return /* @__PURE__ */ _gte(0, params);
}
// @__NO_SIDE_EFFECTS__
function _regex(pattern, params) {
  return new $ZodCheckRegex({
    check: "string_format",
    format: "regex",
    ...normalizeParams(params),
    pattern
  });
}
// @__NO_SIDE_EFFECTS__
function _custom(Class2, fn, _params) {
  const norm = normalizeParams(_params);
  norm.abort ?? (norm.abort = true);
  const schema = new Class2({
    type: "custom",
    check: "custom",
    fn,
    ...norm
  });
  return schema;
}
// @__NO_SIDE_EFFECTS__
function _refine(Class2, fn, _params) {
  const schema = new Class2({
    type: "custom",
    check: "custom",
    fn,
    ...normalizeParams(_params)
  });
  return schema;
}
var init_api = __esm({
  "../../node_modules/zod/v4/core/api.js"() {
    init_checks();
    init_util();
  }
});

// ../../node_modules/zod/v4/core/to-json-schema.js
var init_to_json_schema = __esm({
  "../../node_modules/zod/v4/core/to-json-schema.js"() {
  }
});

// ../../node_modules/zod/v4/core/json-schema.js
var init_json_schema = __esm({
  "../../node_modules/zod/v4/core/json-schema.js"() {
  }
});

// ../../node_modules/zod/v4/core/index.js
var init_core2 = __esm({
  "../../node_modules/zod/v4/core/index.js"() {
    init_core();
    init_parse();
    init_errors();
    init_schemas();
    init_memoizer();
    init_checks();
    init_versions();
    init_util();
    init_regexes();
    init_locales();
    init_registries();
    init_doc();
    init_compile();
    init_api();
    init_to_json_schema();
    init_json_schema();
  }
});

// ../../node_modules/zod/v4/mini/parse.js
var init_parse2 = __esm({
  "../../node_modules/zod/v4/mini/parse.js"() {
    init_core2();
  }
});

// ../../node_modules/zod/v4/mini/schemas.js
// @__NO_SIDE_EFFECTS__
function string2(params) {
  return _string(ZodMiniString, params);
}
// @__NO_SIDE_EFFECTS__
function url(params) {
  return _url(ZodMiniURL, params);
}
// @__NO_SIDE_EFFECTS__
function base64(params) {
  return _base64(ZodMiniBase64, params);
}
// @__NO_SIDE_EFFECTS__
function number2(params) {
  return _number(ZodMiniNumber, params);
}
function int(params) {
  return _int(ZodMiniNumberFormat, params);
}
// @__NO_SIDE_EFFECTS__
function boolean2(params) {
  return _boolean(ZodMiniBoolean, params);
}
// @__NO_SIDE_EFFECTS__
function bigint2(params) {
  return _bigint(ZodMiniBigInt, params);
}
// @__NO_SIDE_EFFECTS__
function unknown() {
  return _unknown(ZodMiniUnknown);
}
// @__NO_SIDE_EFFECTS__
function array(element, params) {
  return new ZodMiniArray({
    type: "array",
    element,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function object(shape, params) {
  const def = {
    type: "object",
    shape: shape ?? {},
    ...normalizeParams(params)
  };
  return new ZodMiniObject(def);
}
// @__NO_SIDE_EFFECTS__
function looseObject(shape, params) {
  return new ZodMiniObject({
    type: "object",
    shape,
    catchall: /* @__PURE__ */ unknown(),
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function union(options, params) {
  return new ZodMiniUnion({
    type: "union",
    options,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function discriminatedUnion(discriminator, options, params) {
  return new ZodMiniDiscriminatedUnion({
    type: "union",
    options,
    discriminator,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function record(keyType, valueType, params) {
  if (!valueType || !valueType._zod) {
    return new ZodMiniRecord({
      type: "record",
      keyType: /* @__PURE__ */ string2(),
      valueType: keyType,
      ...normalizeParams(valueType)
    });
  }
  return new ZodMiniRecord({
    type: "record",
    keyType,
    valueType,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function _enum(values, params) {
  const entries = Array.isArray(values) ? Object.fromEntries(values.map((v3) => [v3, v3])) : values;
  return new ZodMiniEnum({
    type: "enum",
    entries,
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function literal(value, params) {
  return new ZodMiniLiteral({
    type: "literal",
    values: Array.isArray(value) ? value : [value],
    ...normalizeParams(params)
  });
}
// @__NO_SIDE_EFFECTS__
function transform(fn) {
  return new ZodMiniTransform({
    type: "transform",
    transform: fn
  });
}
// @__NO_SIDE_EFFECTS__
function optional(innerType) {
  return new ZodMiniOptional({
    type: "optional",
    innerType
  });
}
// @__NO_SIDE_EFFECTS__
function _default(innerType, defaultValue) {
  return new ZodMiniDefault({
    type: "default",
    innerType,
    get defaultValue() {
      return typeof defaultValue === "function" ? defaultValue() : shallowClone(defaultValue);
    }
  });
}
// @__NO_SIDE_EFFECTS__
function _catch(innerType, catchValue) {
  return new ZodMiniCatch({
    type: "catch",
    innerType,
    catchValue: typeof catchValue === "function" ? catchValue : util_exports.constantCatch(catchValue)
  });
}
// @__NO_SIDE_EFFECTS__
function pipe(in_, out) {
  return new ZodMiniPipe({
    type: "pipe",
    in: in_,
    out
  });
}
// @__NO_SIDE_EFFECTS__
function custom(fn, _params) {
  return _custom(ZodMiniCustom, fn ?? (() => true), _params);
}
// @__NO_SIDE_EFFECTS__
function refine(fn, _params = {}) {
  return _refine(ZodMiniCustom, fn, _params);
}
var ZodMiniType, ZodMiniString, ZodMiniStringFormat, ZodMiniURL, ZodMiniBase64, ZodMiniNumber, ZodMiniNumberFormat, ZodMiniBoolean, ZodMiniBigInt, ZodMiniUnknown, ZodMiniArray, ZodMiniObject, ZodMiniUnion, ZodMiniDiscriminatedUnion, ZodMiniRecord, ZodMiniEnum, ZodMiniLiteral, ZodMiniTransform, ZodMiniOptional, ZodMiniDefault, ZodMiniCatch, ZodMiniPipe, ZodMiniCustom;
var init_schemas2 = __esm({
  "../../node_modules/zod/v4/mini/schemas.js"() {
    init_core2();
    init_util();
    init_parse2();
    ZodMiniType = /* @__PURE__ */ $constructor("ZodMiniType", (inst, def) => {
      if (!inst._zod)
        throw new Error("Uninitialized schema in ZodMiniType.");
      $ZodType.init(inst, def);
      inst.def = def;
      inst.type = def.type;
    }, {
      // `with` is an alias for `check`: the same function object, not a wrapper.
      get with() {
        return this.check;
      },
      set with(value) {
        own(this, "with", value);
      },
      parse(data, params) {
        return parse(this, data, params, { callee: this.parse });
      },
      parseAsync(data, params) {
        return parseAsync(this, data, params, { callee: this.parseAsync });
      },
      safeParse(data, params) {
        return safeParse(this, data, params);
      },
      safeParseAsync(data, params) {
        return safeParseAsync(this, data, params);
      },
      check(...checks) {
        const def = this.def;
        return this.clone({
          ...def,
          checks: [
            ...def.checks ?? [],
            ...checks.map((ch) => typeof ch === "function" ? { _zod: { check: ch, def: { check: "custom" }, onattach: [] } } : ch)
          ]
        }, { parent: true });
      },
      clone(_def, params) {
        return clone(this, _def, params);
      },
      brand() {
        return this;
      },
      register(reg, meta2) {
        reg.add(this, meta2);
        return this;
      },
      apply(fn, ...args) {
        return args.length === 0 ? fn(this) : fn(this, ...args);
      }
    });
    ZodMiniString = /* @__PURE__ */ $constructor("ZodMiniString", (inst, def) => {
      $ZodString.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniStringFormat = /* @__PURE__ */ $constructor("ZodMiniStringFormat", (inst, def) => {
      $ZodStringFormat.init(inst, def);
      ZodMiniString.init(inst, def);
    });
    ZodMiniURL = /* @__PURE__ */ $constructor("ZodMiniURL", (inst, def) => {
      $ZodURL.init(inst, def);
      ZodMiniStringFormat.init(inst, def);
    });
    ZodMiniBase64 = /* @__PURE__ */ $constructor("ZodMiniBase64", (inst, def) => {
      $ZodBase64.init(inst, def);
      ZodMiniStringFormat.init(inst, def);
    });
    ZodMiniNumber = /* @__PURE__ */ $constructor("ZodMiniNumber", (inst, def) => {
      $ZodNumber.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniNumberFormat = /* @__PURE__ */ $constructor("ZodMiniNumberFormat", (inst, def) => {
      $ZodNumberFormat.init(inst, def);
      ZodMiniNumber.init(inst, def);
    });
    ZodMiniBoolean = /* @__PURE__ */ $constructor("ZodMiniBoolean", (inst, def) => {
      $ZodBoolean.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniBigInt = /* @__PURE__ */ $constructor("ZodMiniBigInt", (inst, def) => {
      $ZodBigInt.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniUnknown = /* @__PURE__ */ $constructor("ZodMiniUnknown", (inst, def) => {
      $ZodUnknown.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniArray = /* @__PURE__ */ $constructor("ZodMiniArray", (inst, def) => {
      $ZodArray.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniObject = /* @__PURE__ */ $constructor("ZodMiniObject", (inst, def) => {
      $ZodObject.init(inst, def);
      ZodMiniType.init(inst, def);
      installLazyProp(inst, "shape", (self2) => self2._zod.def.shape, false);
    });
    ZodMiniUnion = /* @__PURE__ */ $constructor("ZodMiniUnion", (inst, def) => {
      $ZodUnion.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniDiscriminatedUnion = /* @__PURE__ */ $constructor("ZodMiniDiscriminatedUnion", (inst, def) => {
      $ZodDiscriminatedUnion.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniRecord = /* @__PURE__ */ $constructor("ZodMiniRecord", (inst, def) => {
      $ZodRecord.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniEnum = /* @__PURE__ */ $constructor("ZodMiniEnum", (inst, def) => {
      $ZodEnum.init(inst, def);
      ZodMiniType.init(inst, def);
      inst.options = [...inst._zod.values];
    });
    ZodMiniLiteral = /* @__PURE__ */ $constructor("ZodMiniLiteral", (inst, def) => {
      $ZodLiteral.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniTransform = /* @__PURE__ */ $constructor("ZodMiniTransform", (inst, def) => {
      $ZodTransform.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniOptional = /* @__PURE__ */ $constructor("ZodMiniOptional", (inst, def) => {
      $ZodOptional.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniDefault = /* @__PURE__ */ $constructor("ZodMiniDefault", (inst, def) => {
      $ZodDefault.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniCatch = /* @__PURE__ */ $constructor("ZodMiniCatch", (inst, def) => {
      $ZodCatch.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniPipe = /* @__PURE__ */ $constructor("ZodMiniPipe", (inst, def) => {
      $ZodPipe.init(inst, def);
      ZodMiniType.init(inst, def);
    });
    ZodMiniCustom = /* @__PURE__ */ $constructor("ZodMiniCustom", (inst, def) => {
      $ZodCustom.init(inst, def);
      ZodMiniType.init(inst, def);
    });
  }
});

// ../../node_modules/zod/v4/mini/checks.js
var init_checks2 = __esm({
  "../../node_modules/zod/v4/mini/checks.js"() {
    init_core2();
  }
});

// ../../node_modules/zod/v4/mini/iso.js
var init_iso = __esm({
  "../../node_modules/zod/v4/mini/iso.js"() {
  }
});

// ../../node_modules/zod/v4/mini/coerce.js
var init_coerce = __esm({
  "../../node_modules/zod/v4/mini/coerce.js"() {
  }
});

// ../../node_modules/zod/v4/mini/external.js
var init_external = __esm({
  "../../node_modules/zod/v4/mini/external.js"() {
    init_core2();
    init_parse2();
    init_schemas2();
    init_checks2();
    init_locales();
    init_iso();
    init_coerce();
  }
});

// ../../node_modules/zod/mini/index.js
var init_mini = __esm({
  "../../node_modules/zod/mini/index.js"() {
    init_external();
  }
});

// ../../node_modules/@moq/net/hop.js
function randomHop() {
  const buf = new BigUint64Array(1);
  crypto.getRandomValues(buf);
  const raw = buf[0] & 0x1fffffffffffffn;
  return HopSchema.parse(raw === 0n ? 1n : raw);
}
function stampHops(hops, stamp) {
  if (hops.length === 0)
    return [stamp, UNKNOWN_HOP];
  if (hops[0] !== UNKNOWN_HOP)
    return [...hops];
  if (hops.length >= MAX_HOPS || hops.includes(stamp))
    return void 0;
  return [stamp, ...hops];
}
function isAnonymous(route) {
  return route.hops.includes(UNKNOWN_HOP);
}
function routesEqual(a2, b3) {
  if (a2 === b3)
    return true;
  if (!a2 || !b3)
    return false;
  return a2.cost.warm === b3.cost.warm && a2.cost.cold === b3.cost.cold && a2.hops.length === b3.hops.length && a2.hops.every((hop, i2) => hop === b3.hops[i2]);
}
var HopSchema, UNKNOWN_HOP, MAX_HOPS, Cost, Route;
var init_hop = __esm({
  "../../node_modules/@moq/net/hop.js"() {
    init_mini();
    HopSchema = bigint2().check(refine((value) => value >= 0n && value < 1n << 62n, "Hop must be a non-negative 62-bit integer")).brand("Hop");
    UNKNOWN_HOP = HopSchema.parse(0n);
    MAX_HOPS = 32;
    Cost = {
      /** A free path in both magnitudes: what a live publisher seeds. */
      zero: { warm: 0n, cold: 0n }
    };
    Route = {
      /** An empty hop chain at zero cost: what a publisher seeds for a live broadcast. */
      default: { hops: [], cost: Cost.zero },
      /** Normalize a partial route, treating a bare bigint cost as both magnitudes alike. */
      normalize(route = {}) {
        const hops = route.hops ? [...route.hops] : [];
        const cost = route.cost;
        if (cost === void 0)
          return { hops, cost: Cost.zero };
        if (typeof cost === "bigint")
          return { hops, cost: { warm: cost, cold: cost } };
        return { hops, cost: { warm: cost.warm, cold: cost.cold } };
      }
    };
  }
});

// ../../node_modules/@moq/pattern/index.js
function compareSpecificity(a2, b3) {
  if (a2.literals !== b3.literals)
    return a2.literals - b3.literals;
  if (a2.exact !== b3.exact)
    return a2.exact ? 1 : -1;
  if (a2.partials !== b3.partials)
    return a2.partials - b3.partials;
  if (a2.wildcards !== b3.wildcards)
    return a2.wildcards - b3.wildcards;
  if (a2.pinned !== b3.pinned)
    return a2.pinned - b3.pinned;
  return a2.head - b3.head;
}
function splitPath(path) {
  return path.split("/").filter((part) => part !== "");
}
function invalidSegment(text) {
  return new InvalidPattern("invalid-segment", `invalid pattern segment: ${JSON.stringify(text)}`);
}
function parseSegment(text) {
  if (text === "")
    throw new InvalidPattern("empty-segment", "empty path segment");
  if (text === "*")
    return WILDCARD;
  if (text === "**")
    return GLOBSTAR;
  if (text.includes("/"))
    throw invalidSegment(text);
  const star = text.indexOf("*");
  if (star < 0)
    return { kind: "literal", value: text };
  const prefix = text.slice(0, star);
  const suffix = text.slice(star + 1);
  if (suffix.includes("*"))
    throw invalidSegment(text);
  return { kind: "partial", prefix, suffix };
}
function segmentText(segment) {
  switch (segment.kind) {
    case "literal":
      return segment.value;
    case "wildcard":
      return "*";
    case "partial":
      return `${segment.prefix}*${segment.suffix}`;
    case "globstar":
      return "**";
  }
}
function freezeSegment(segment) {
  switch (segment?.kind) {
    case "literal":
      return Object.freeze({ kind: "literal", value: segment.value });
    case "partial":
      return Object.freeze({ kind: "partial", prefix: segment.prefix, suffix: segment.suffix });
    case "wildcard":
      return Object.freeze({ kind: "wildcard" });
    case "globstar":
      return Object.freeze({ kind: "globstar" });
    default:
      throw new InvalidPattern("invalid-segment", "unknown pattern segment kind");
  }
}
function covers(a2, b3) {
  switch (a2.kind) {
    case "wildcard":
      return b3.kind !== "globstar";
    case "literal":
      return b3.kind === "literal" && a2.value === b3.value;
    case "partial":
      if (b3.kind === "literal")
        return matchesPart(a2, b3.value);
      return b3.kind === "partial" && b3.prefix.startsWith(a2.prefix) && b3.suffix.endsWith(a2.suffix);
    case "globstar":
      return false;
  }
}
function compatible(a2, b3) {
  if (a2.kind === "partial" && b3.kind === "partial") {
    return (a2.prefix.startsWith(b3.prefix) || b3.prefix.startsWith(a2.prefix)) && (a2.suffix.endsWith(b3.suffix) || b3.suffix.endsWith(a2.suffix));
  }
  return covers(a2, b3) || covers(b3, a2);
}
function matchesPart(segment, part) {
  switch (segment.kind) {
    case "literal":
      return segment.value === part;
    case "wildcard":
      return true;
    case "partial":
      return part.length >= segment.prefix.length + segment.suffix.length && part.startsWith(segment.prefix) && part.endsWith(segment.suffix);
    case "globstar":
      return false;
  }
}
function matchesRun(segments, parts3) {
  return segments.every((segment, i2) => matchesPart(segment, parts3[i2]));
}
function matchesTail(segments, parts3) {
  return segments.every((segment, i2) => matchesPart(segment, parts3[parts3.length - segments.length + i2]));
}
function coversRun(ours, theirs) {
  return ours.every((a2, i2) => i2 < theirs.length ? covers(a2, theirs[i2]) : a2.kind === "wildcard");
}
function compatibleRun(a2, b3) {
  const n2 = Math.min(a2.length, b3.length);
  for (let i2 = 0; i2 < n2; i2++)
    if (!compatible(a2[i2], b3[i2]))
      return false;
  return true;
}
function reversed(list) {
  return [...list].reverse();
}
function intersectSegment(a2, b3) {
  if (a2.kind === "globstar" || b3.kind === "globstar")
    return [];
  if (a2.kind === "wildcard")
    return [b3];
  if (b3.kind === "wildcard")
    return [a2];
  if (a2.kind === "literal") {
    if (b3.kind === "literal")
      return a2.value === b3.value ? [a2] : [];
    return matchesPart(b3, a2.value) ? [a2] : [];
  }
  if (b3.kind === "literal")
    return matchesPart(a2, b3.value) ? [b3] : [];
  if (!compatible(a2, b3))
    return [];
  const prefix = a2.prefix.length >= b3.prefix.length ? a2.prefix : b3.prefix;
  const suffix = a2.suffix.length >= b3.suffix.length ? a2.suffix : b3.suffix;
  const out = [{ kind: "partial", prefix, suffix }];
  for (let overlap = 1; overlap <= Math.min(prefix.length, suffix.length); overlap++) {
    if (prefix.slice(prefix.length - overlap) !== suffix.slice(0, overlap))
      continue;
    const part = prefix + suffix.slice(overlap);
    if (matchesPart(a2, part) && matchesPart(b3, part))
      out.push({ kind: "literal", value: part });
  }
  return out;
}
function intersectRun(a2, b3, limit) {
  let out = [[]];
  for (let i2 = 0; i2 < a2.length; i2++) {
    const choices = intersectSegment(a2[i2], b3[i2]);
    if (choices.length === 0)
      return [];
    if (out.length * choices.length > limit)
      throw new IntersectionError();
    out = out.flatMap((prefix) => choices.map((choice) => [...prefix, choice]));
  }
  return out;
}
function expand(head, tail, len) {
  return [...head, ...Array(len - head.length - tail.length).fill(WILDCARD), ...tail];
}
var InvalidPattern, IntersectionError, WILDCARD, GLOBSTAR, UTF8, MAX_PATTERN_SEGMENTS, MAX_INTERSECTION_PATTERNS, Pattern, Patterns;
var init_pattern = __esm({
  "../../node_modules/@moq/pattern/index.js"() {
    InvalidPattern = class extends Error {
      /** Which rule was broken. */
      code;
      /** Create an error with the violated grammar rule in `code` and a human-readable `message`. */
      constructor(code, message) {
        super(message);
        this.name = "InvalidPattern";
        this.code = code;
      }
    };
    IntersectionError = class extends Error {
      /** Create an intersection complexity error. */
      constructor() {
        super("pattern intersection exceeds the complexity limit");
        this.name = "IntersectionError";
      }
    };
    WILDCARD = { kind: "wildcard" };
    GLOBSTAR = { kind: "globstar" };
    UTF8 = new TextEncoder();
    MAX_PATTERN_SEGMENTS = 32;
    MAX_INTERSECTION_PATTERNS = 1024;
    Pattern = class _Pattern {
      /** The most segments a pattern may have, matching the path limit on the wire. */
      static get MAX_SEGMENTS() {
        return MAX_PATTERN_SEGMENTS;
      }
      /** The most patterns one exact intersection may produce. */
      static get MAX_INTERSECTIONS() {
        return MAX_INTERSECTION_PATTERNS;
      }
      /** The canonical text: segments joined by `/`, wildcards as `*` and `**`. */
      text;
      /** The segments, in order. */
      segments;
      // Index of the `**` segment, if any.
      #globstar;
      // Length of the literal head within `text`.
      #head;
      constructor(segments) {
        if (segments.length > MAX_PATTERN_SEGMENTS) {
          throw new InvalidPattern("too-many-segments", `more than ${MAX_PATTERN_SEGMENTS} segments`);
        }
        const owned = segments.map(freezeSegment);
        segments = owned;
        let globstar;
        for (const [i2, segment] of segments.entries()) {
          if (segment.kind === "literal") {
            if (typeof segment.value !== "string") {
              throw new InvalidPattern("invalid-segment", "literal value must be a string");
            }
            if (segment.value === "")
              throw new InvalidPattern("empty-segment", "empty path segment");
            if (segment.value.includes("*") || segment.value.includes("/"))
              throw invalidSegment(segment.value);
          } else if (segment.kind === "partial") {
            const { prefix, suffix } = segment;
            if (typeof prefix !== "string" || typeof suffix !== "string") {
              throw new InvalidPattern("invalid-segment", "partial prefix and suffix must be strings");
            }
            if (prefix === "" && suffix === "" || /[*/]/.test(prefix) || /[*/]/.test(suffix)) {
              throw invalidSegment(`${prefix}*${suffix}`);
            }
          } else if (segment.kind === "globstar") {
            if (globstar !== void 0)
              throw new InvalidPattern("multiple-globstars", "more than one ** segment");
            globstar = i2;
          }
        }
        if (globstar !== void 0) {
          while (globstar > 0 && owned[globstar - 1].kind === "wildcard") {
            [owned[globstar - 1], owned[globstar]] = [owned[globstar], owned[globstar - 1]];
            globstar--;
          }
        }
        let head = 0;
        let inHead = true;
        let text = "";
        for (const [i2, segment] of segments.entries()) {
          if (i2 > 0)
            text += "/";
          if (segment.kind !== "literal")
            inHead = false;
          text += segmentText(segment);
          if (inHead)
            head = text.length;
        }
        this.segments = Object.freeze([...segments]);
        this.text = text;
        this.#globstar = globstar;
        this.#head = head;
        Object.freeze(this);
      }
      /**
       * Parse a pattern's text. Throws {@link InvalidPattern} on invalid syntax.
       *
       * Unlike a path, slashes are not normalized: a leading, trailing, or doubled `/` is
       * an error, so a typo cannot silently widen a grant.
       */
      static parse(text) {
        if (text === "")
          return new _Pattern([]);
        return new _Pattern(text.split("/").map(parseSegment));
      }
      /** A pattern from its segments, validating the grammar. Throws {@link InvalidPattern}. */
      static from(segments) {
        return new _Pattern([...segments]);
      }
      /**
       * The pattern matching exactly `path`.
       *
       * The path is normalized like a broadcast path (slashes trimmed and collapsed).
       * Throws when a segment is `*` or `**` or contains `*`: those are wildcards, and a
       * path using them cannot be named by a pattern.
       */
      static literal(path) {
        return new _Pattern(splitPath(path).map((value) => ({ kind: "literal", value })));
      }
      /**
       * The pattern matching `path` and everything beneath it: `path/**`.
       *
       * The empty path yields `**`, and a path of {@link Pattern.MAX_SEGMENTS} yields the
       * literal, since nothing can sit beneath it.
       */
      static subtree(path) {
        const segments = splitPath(path).map((value) => ({ kind: "literal", value }));
        if (segments.length < MAX_PATTERN_SEGMENTS)
          segments.push(GLOBSTAR);
        return new _Pattern(segments);
      }
      /** The pattern matching every path: `**`. */
      static all() {
        return new _Pattern([GLOBSTAR]);
      }
      /** The empty pattern, which matches only the empty path. */
      static empty() {
        return new _Pattern([]);
      }
      /** Order two patterns by text, so a sorted list is deterministic. */
      static compare(a2, b3) {
        const left = Array.from(a2.text, (char) => char.codePointAt(0) ?? 0);
        const right = Array.from(b3.text, (char) => char.codePointAt(0) ?? 0);
        for (let i2 = 0; i2 < Math.min(left.length, right.length); i2++) {
          if (left[i2] !== right[i2])
            return left[i2] - right[i2];
        }
        return left.length - right.length;
      }
      /** The canonical text. */
      toString() {
        return this.text;
      }
      /** Serializes as the canonical text, matching the Rust crate's serde form. */
      toJSON() {
        return this.text;
      }
      /** Whether the two patterns are the same pattern. */
      equals(other) {
        return this.text === other.text;
      }
      /**
       * The literal segments before the first wildcard, as a path.
       *
       * Every matching path starts with it, so it is where a tree walk starts. Empty when
       * the pattern starts with a wildcard; the whole pattern when it has none.
       */
      get head() {
        return this.text.slice(0, this.#head);
      }
      /** Whether the pattern has no wildcards, so it matches exactly one path. */
      get isLiteral() {
        return this.#head === this.text.length;
      }
      /** The covered prefix for literals followed by `**`, or undefined for other patterns. */
      asPrefix() {
        const last = this.segments[this.segments.length - 1];
        if (last?.kind !== "globstar")
          return void 0;
        if (this.segments.slice(0, -1).some((segment) => segment.kind !== "literal"))
          return void 0;
        return this.head;
      }
      /** Whether the pattern has a `**`, so it matches paths of more than one length. */
      get hasGlobstar() {
        return this.#globstar !== void 0;
      }
      /** Whether `path` is in the set this pattern describes. The path is normalized like a broadcast path. */
      matches(path) {
        const parts3 = splitPath(path);
        if (this.#globstar === void 0) {
          return parts3.length === this.segments.length && matchesRun(this.segments, parts3);
        }
        const [head, tail] = this.#split();
        return parts3.length >= head.length + tail.length && matchesRun(head, parts3) && matchesTail(tail, parts3);
      }
      /**
       * Whether every path `other` matches, this pattern matches too.
       *
       * This is the authorization check: a grant contains a request when the request
       * cannot name a path outside it. A pattern contains itself.
       */
      contains(other) {
        if (this.#globstar === void 0) {
          if (other.#globstar !== void 0)
            return false;
          return this.segments.length === other.segments.length && this.segments.every((a2, i2) => covers(a2, other.segments[i2]));
        }
        const [head, tail] = this.#split();
        if (other.#globstar === void 0) {
          return other.segments.length >= head.length + tail.length && head.every((a2, i2) => covers(a2, other.segments[i2])) && tail.every((a2, i2) => covers(a2, other.segments[other.segments.length - tail.length + i2]));
        }
        const [otherHead, otherTail] = other.#split();
        return head.length + tail.length <= otherHead.length + otherTail.length && coversRun(head, otherHead) && coversRun(reversed(tail), reversed(otherTail));
      }
      /** Whether some path matches both patterns. */
      overlaps(other) {
        if (this.#globstar === void 0) {
          if (other.#globstar !== void 0)
            return other.overlaps(this);
          return this.segments.length === other.segments.length && compatibleRun(this.segments, other.segments);
        }
        const [head, tail] = this.#split();
        if (other.#globstar === void 0) {
          return other.segments.length >= head.length + tail.length && compatibleRun(head, other.segments) && compatibleRun(reversed(tail), reversed(other.segments));
        }
        const [otherHead, otherTail] = other.#split();
        return compatibleRun(head, otherHead) && compatibleRun(reversed(tail), reversed(otherTail));
      }
      /** How much of a path this pattern pins down. See {@link Specificity}. */
      specificity() {
        let head = 0;
        while (head < this.segments.length && this.segments[head].kind === "literal")
          head++;
        let pinned = 0;
        for (const s of this.segments) {
          if (s.kind === "partial")
            pinned += UTF8.encode(s.prefix).length + UTF8.encode(s.suffix).length;
        }
        return {
          literals: this.segments.filter((s) => s.kind === "literal").length,
          exact: this.#globstar === void 0,
          partials: this.segments.filter((s) => s.kind === "partial").length,
          wildcards: this.segments.filter((s) => s.kind === "wildcard").length,
          pinned,
          head
        };
      }
      /**
       * The patterns that, relative to `root`, match exactly the paths this pattern matches
       * beneath `root`.
       *
       * This is how a grant or an advertisement is presented inside a rooted view. It is a
       * set because `**` may consume the root or stop short of it: `** /a` rebased at `a` is
       * both the empty pattern (the root itself) and `** /a` (deeper paths ending in `a`).
       * Empty when nothing under `root` matches. The root is normalized like a broadcast path.
       */
      rebase(root) {
        const parts3 = splitPath(root);
        const out = new Patterns();
        if (this.#globstar === void 0) {
          if (parts3.length <= this.segments.length && matchesRun(this.segments.slice(0, parts3.length), parts3)) {
            out.insert(new _Pattern(this.segments.slice(parts3.length)));
          }
          return out;
        }
        const [head, tail] = this.#split();
        if (parts3.length <= head.length) {
          if (matchesRun(head.slice(0, parts3.length), parts3)) {
            out.insert(new _Pattern(this.segments.slice(parts3.length)));
          }
          return out;
        }
        if (!matchesRun(head, parts3))
          return out;
        const rest = parts3.slice(head.length);
        out.insert(new _Pattern(this.segments.slice(this.#globstar)));
        for (let consumed = 1; consumed <= Math.min(tail.length, rest.length); consumed++) {
          if (matchesRun(tail.slice(0, consumed), rest.slice(rest.length - consumed))) {
            out.insert(new _Pattern(tail.slice(consumed)));
          }
        }
        return out;
      }
      /**
       * The patterns matching exactly the paths both patterns match.
       *
       * This is how a claim is clamped to a scope: the covered paths inside the grant, as
       * patterns of their own. It is a set because two partial segments or two `**` runs can
       * meet in more than one way: `ab*` and `*b` meet at `ab*b` and at `ab`, and `a/**` and
       * `** /a` meet at `a/** /a` and at `a`. Empty when the two do not {@link overlaps | overlap}.
       */
      intersect(other) {
        if (this.contains(other))
          return new Patterns([other]);
        if (other.contains(this))
          return new Patterns([this]);
        const out = new Patterns();
        let remaining = MAX_INTERSECTION_PATTERNS;
        const emit = (segments) => {
          if (remaining-- === 0)
            throw new IntersectionError();
          try {
            out.insert(new _Pattern(segments));
          } catch {
          }
        };
        if (this.#globstar === void 0) {
          if (other.#globstar !== void 0)
            return other.intersect(this);
          if (this.segments.length === other.segments.length) {
            for (const run of intersectRun(this.segments, other.segments, remaining))
              emit(run);
          }
          return out;
        }
        const [head, tail] = this.#split();
        if (other.#globstar === void 0) {
          if (other.segments.length >= head.length + tail.length) {
            const stretched = expand(head, tail, other.segments.length);
            for (const run of intersectRun(stretched, other.segments, remaining))
              emit(run);
          }
          return out;
        }
        const [otherHead, otherTail] = other.#split();
        const heads = Math.max(head.length, otherHead.length);
        const tails = Math.max(tail.length, otherTail.length);
        const shortest = Math.max(head.length + tail.length, otherHead.length + otherTail.length);
        const long = heads + tails;
        const open = long < MAX_PATTERN_SEGMENTS;
        const cap = open ? long : MAX_PATTERN_SEGMENTS + 1;
        for (let len = shortest; len < cap; len++) {
          for (const run of intersectRun(expand(head, tail, len), expand(otherHead, otherTail, len), remaining))
            emit(run);
        }
        if (open) {
          const pad = (run, len, front) => {
            const fill = Array(len - run.length).fill(WILDCARD);
            return front ? [...run, ...fill] : [...fill, ...run];
          };
          const fronts = intersectRun(pad(head, heads, true), pad(otherHead, heads, true), remaining);
          const backs = intersectRun(pad(tail, tails, false), pad(otherTail, tails, false), remaining);
          if (fronts.length * backs.length > remaining)
            throw new IntersectionError();
          for (const front of fronts)
            for (const back of backs)
              emit([...front, GLOBSTAR, ...back]);
        }
        return out;
      }
      /**
       * What each wildcard of this pattern stands for in `matched`, a pattern this one
       * {@link contains}; undefined when it does not.
       *
       * One capture per non-literal segment (`*`, `prefix*suffix`, `**`), in order, the way a
       * regex match exposes its groups: `foo/* /chat` against `foo/alice/chat` captures `alice`,
       * and `foo/**` against `foo/alice/chat` captures `alice/chat`. A capture is a pattern
       * because `matched` may be one: `foo/**` against `foo/alice/**` captures `alice/**`. When
       * `matched` has a `**` that this pattern's own segments straddle (`** /*` against `a/**`,
       * where the last segment is `a` or anything after it), the segments it straddles cannot
       * be pinned and capture themselves: `**` then `*`.
       */
      captures(matched) {
        if (!this.contains(matched))
          return void 0;
        const out = [];
        if (this.#globstar === void 0) {
          for (const [i2, segment] of this.segments.entries()) {
            if (segment.kind !== "literal")
              out.push(new _Pattern([matched.segments[i2]]));
          }
          return out;
        }
        const [head, tail] = this.#split();
        const middle = matched.segments.length - tail.length;
        const free2 = matched.#globstar;
        const pinned = (at2, fromFront) => free2 === void 0 ? true : fromFront ? at2 < free2 : at2 > free2;
        for (const [i2, segment] of head.entries()) {
          if (segment.kind === "literal")
            continue;
          out.push(new _Pattern([pinned(i2, true) ? matched.segments[i2] : segment]));
        }
        if (free2 === void 0 || free2 >= head.length && free2 < middle) {
          out.push(new _Pattern(matched.segments.slice(head.length, middle)));
        } else {
          out.push(_Pattern.all());
        }
        for (const [j2, segment] of tail.entries()) {
          if (segment.kind === "literal")
            continue;
          const at2 = middle + j2;
          out.push(new _Pattern([pinned(at2, false) ? matched.segments[at2] : segment]));
        }
        return out;
      }
      /**
       * This pattern placed beneath a literal `root`: the same paths, named from the root's
       * parent. The inverse of {@link rebase} for a single pattern.
       *
       * The root is normalized and validated like {@link Pattern.literal}, and the result
       * must fit {@link Pattern.MAX_SEGMENTS}.
       */
      rooted(root) {
        return new _Pattern([
          ...splitPath(root).map((value) => ({ kind: "literal", value })),
          ...this.segments
        ]);
      }
      /** The segments before and after the `**`. Only meaningful when there is one. */
      #split() {
        if (this.#globstar === void 0)
          return [this.segments, []];
        return [this.segments.slice(0, this.#globstar), this.segments.slice(this.#globstar + 1)];
      }
    };
    Patterns = class _Patterns {
      #members = [];
      /** A union of the given patterns, reduced. Empty when none are given. */
      constructor(patterns) {
        if (patterns)
          for (const pattern of patterns)
            this.insert(pattern);
      }
      /**
       * Add a pattern, dropping members it contains.
       *
       * Returns false when a member already contains it, leaving the union unchanged.
       */
      insert(pattern) {
        if (this.contains(pattern))
          return false;
        this.#members = this.#members.filter((member) => !pattern.contains(member));
        let at2 = 0;
        while (at2 < this.#members.length && Pattern.compare(this.#members[at2], pattern) < 0)
          at2++;
        this.#members.splice(at2, 0, pattern);
        return true;
      }
      /** Whether any member matches `path`. */
      matches(path) {
        return this.#members.some((member) => member.matches(path));
      }
      /** Whether some member contains `pattern`. See the class docs for why this is per member. */
      contains(pattern) {
        return this.#members.some((member) => member.contains(pattern));
      }
      /** Whether every member of `other` is contained here: `other` grants nothing this union does not. */
      covers(other) {
        return other.#members.every((pattern) => this.contains(pattern));
      }
      /** Whether any member overlaps `pattern`. */
      overlaps(pattern) {
        return this.#members.some((member) => member.overlaps(pattern));
      }
      /**
       * The paths in both unions, as one union: every member of this one intersected with
       * every member of `other`. See {@link Pattern.intersect}.
       */
      intersect(other) {
        const out = new _Patterns();
        for (const member of this.#members) {
          for (const candidate of other.#members)
            for (const pattern of member.intersect(candidate)) {
              out.insert(pattern);
              if (out.size > MAX_INTERSECTION_PATTERNS)
                throw new IntersectionError();
            }
        }
        return out;
      }
      /** Every member rebased at `root`, as one union. See {@link Pattern.rebase}. */
      rebase(root) {
        const out = new _Patterns();
        for (const member of this.#members)
          for (const pattern of member.rebase(root))
            out.insert(pattern);
        return out;
      }
      /** Every member placed beneath `root`. See {@link Pattern.rooted}. */
      rooted(root) {
        return new _Patterns(this.#members.map((member) => member.rooted(root)));
      }
      /** The number of members. */
      get size() {
        return this.#members.length;
      }
      /** The members, in canonical order. */
      [Symbol.iterator]() {
        return this.#members[Symbol.iterator]();
      }
      /** The members as a fresh array, in canonical order. */
      toArray() {
        return [...this.#members];
      }
      /** Serializes as a list of texts, matching the Rust crate's serde form. */
      toJSON() {
        return this.#members.map((member) => member.text);
      }
      /** Whether the two unions have the same reduced pattern members. */
      equals(other) {
        return this.size === other.size && this.#members.every((member, i2) => member.equals(other.#members[i2]));
      }
    };
  }
});

// ../../node_modules/@moq/net/path.js
var path_exports = {};
__export(path_exports, {
  InvalidPattern: () => InvalidPattern,
  MAX_PARTS: () => MAX_PARTS,
  Pattern: () => Pattern,
  Patterns: () => Patterns,
  compareSpecificity: () => compareSpecificity,
  decode: () => decode2,
  empty: () => empty,
  encode: () => encode2,
  from: () => from,
  hasPrefix: () => hasPrefix,
  join: () => join,
  normalizeRelative: () => normalizeRelative,
  parts: () => parts,
  relative: () => relative,
  resolve: () => resolve,
  stripPrefix: () => stripPrefix,
  tryResolve: () => tryResolve
});
function from(...paths) {
  const joined = paths.join("/");
  return joined.replace(/\/+/g, "/").replace(/^\/+/, "").replace(/\/+$/, "");
}
function parts(path) {
  return path === "" ? [] : path.split("/");
}
function decode2(raw) {
  const path = from(raw);
  return encode2(path);
}
function encode2(path) {
  if (parts(path).length > MAX_PARTS) {
    throw new Error(`path exceeds ${MAX_PARTS} parts`);
  }
  return path;
}
function hasPrefix(prefix, path) {
  if (prefix === "") {
    return true;
  }
  if (!path.startsWith(prefix)) {
    return false;
  }
  if (path.length === prefix.length) {
    return true;
  }
  return path[prefix.length] === "/";
}
function stripPrefix(prefix, path) {
  if (!hasPrefix(prefix, path)) {
    return null;
  }
  if (prefix === "") {
    return path;
  }
  if (path.length === prefix.length) {
    return "";
  }
  return path.slice(prefix.length + 1);
}
function join(path, other) {
  if (path === "") {
    return other;
  } else if (other === "") {
    return path;
  } else {
    return `${path}/${other}`;
  }
}
function empty() {
  return "";
}
function normalizeRelative(rel) {
  const raw = rel.split("/");
  const normalized = raw.filter((s) => s !== "" && s !== ".").join("/");
  return normalized === "" && raw.includes(".") ? "." : normalized;
}
function resolve(base2, rel) {
  if (rel === "")
    return base2;
  const segments = base2 === "" ? [] : base2.split("/");
  segments.pop();
  for (const seg of rel.split("/")) {
    if (seg === "" || seg === ".") {
      continue;
    }
    if (seg === "..") {
      segments.pop();
    } else {
      segments.push(seg);
    }
  }
  return segments.join("/");
}
function tryResolve(base2, rel) {
  if (rel === "")
    return base2;
  const segments = base2 === "" ? [] : base2.split("/");
  segments.pop();
  for (const seg of rel.split("/")) {
    if (seg === "" || seg === ".") {
      continue;
    }
    if (seg === "..") {
      if (segments.pop() === void 0)
        return void 0;
    } else {
      segments.push(seg);
    }
  }
  return segments.join("/");
}
function relative(target3, base2) {
  if (target3 === base2)
    return "";
  const dir = base2 === "" ? [] : base2.split("/");
  dir.pop();
  const parts3 = target3 === "" ? [] : target3.split("/");
  let common = 0;
  while (common < dir.length && common < parts3.length && dir[common] === parts3[common]) {
    common += 1;
  }
  const down = parts3.slice(common);
  if (down.some((part) => part === "." || part === ".."))
    return void 0;
  const rel = Array(dir.length - common).fill("..").concat(down);
  return rel.length === 0 ? "." : rel.join("/");
}
var MAX_PARTS;
var init_path = __esm({
  "../../node_modules/@moq/net/path.js"() {
    init_pattern();
    MAX_PARTS = 32;
  }
});

// ../../node_modules/@moq/net/internal.js
function groupBounds(groups2 = {}) {
  const bound = (value, start) => {
    if (value === void 0)
      return void 0;
    if (value.included === void 0 === (value.excluded === void 0)) {
      throw new Error("a group bound must be either included or excluded");
    }
    const sequence = value.included ?? value.excluded;
    if (sequence === void 0 || !Number.isSafeInteger(sequence) || sequence < 0) {
      throw new Error("a group bound must be a non-negative safe integer");
    }
    return sequence + (start ? Number(value.excluded !== void 0) : Number(value.included !== void 0));
  };
  return { start: bound(groups2.start, true) ?? 0, end: bound(groups2.end, false) };
}
function scopeHead(scope) {
  return from(scope.head);
}
function hiddenBelow(prefix, path) {
  const below = stripPrefix(prefix, path);
  return below !== null && parts(below).some((part) => part.startsWith("."));
}
function presented(prefix, table, carries) {
  const out = /* @__PURE__ */ new Map();
  let rootLen = -1;
  const requested = Pattern.subtree(prefix);
  for (const [covered, candidates] of table) {
    if (!carries(covered))
      continue;
    if (hasPrefix(covered, prefix)) {
      if (covered.length < rootLen)
        continue;
      const snap = candidates.find((candidate) => !candidate.claim || candidate.claim.overlaps(requested));
      if (!snap)
        continue;
      rootLen = covered.length;
      out.set(empty(), snap);
      continue;
    }
    const suffix = stripPrefix(prefix, covered);
    if (suffix !== null && candidates.length > 0)
      out.set(suffix, candidates[0]);
  }
  return out;
}
function scopeOverlaps(scope, prefix) {
  return scope.overlaps(Pattern.subtree(prefix));
}
function scopeCaptures(scope, prefix) {
  return scope.captures(Pattern.literal(prefix));
}
var hooks;
var init_internal = __esm({
  "../../node_modules/@moq/net/internal.js"() {
    init_path();
    hooks = {
      makeRequest: () => {
        throw new Error("track.ts not loaded");
      },
      pendingTrackProducer: () => {
        throw new Error("track.ts not loaded");
      },
      tryRecvGroup: () => {
        throw new Error("track.ts not loaded");
      },
      groupChanged: () => {
        throw new Error("track.ts not loaded");
      },
      exemptFetch: () => {
        throw new Error("track.ts not loaded");
      },
      replaceGroups: () => {
        throw new Error("track.ts not loaded");
      },
      groupTimestamp: () => {
        throw new Error("group.ts not loaded");
      },
      groupLatest: () => {
        throw new Error("group.ts not loaded");
      },
      expireGroup: () => {
        throw new Error("group.ts not loaded");
      },
      guardGroup: () => {
        throw new Error("group.ts not loaded");
      },
      readGroupFrame: () => {
        throw new Error("group.ts not loaded");
      },
      evictGroup: () => {
        throw new Error("group.ts not loaded");
      },
      attachAnnouncer: () => {
        throw new Error("broadcast.ts not loaded");
      },
      stampPath: () => {
        throw new Error("broadcast.ts not loaded");
      }
    };
  }
});

// ../../node_modules/@moq/net/time.js
var time_exports = {};
__export(time_exports, {
  Micro: () => Micro,
  Milli: () => Milli,
  Nano: () => Nano,
  Second: () => Second,
  Timescale: () => Timescale,
  Timestamp: () => Timestamp
});
function assertTimestampValue(value) {
  if (!Number.isFinite(value) || value < 0 || value > Number.MAX_SAFE_INTEGER) {
    throw new RangeError(`invalid timestamp: ${value}`);
  }
}
var Nano, Micro, Milli, Timescale, Timestamp, Second;
var init_time = __esm({
  "../../node_modules/@moq/net/time.js"() {
    Nano = Object.assign((value) => value, {
      zero: 0,
      fromMicro: (us2) => us2 * 1e3,
      fromMilli: (ms2) => ms2 * 1e6,
      fromSecond: (s) => s * 1e9,
      toMicro: (ns) => ns / 1e3,
      toMilli: (ns) => ns / 1e6,
      toSecond: (ns) => ns / 1e9,
      now: () => performance.now() * 1e6,
      add: (a2, b3) => a2 + b3,
      sub: (a2, b3) => a2 - b3,
      mul: (a2, b3) => a2 * b3,
      div: (a2, b3) => a2 / b3,
      max: (a2, b3) => Math.max(a2, b3),
      min: (a2, b3) => Math.min(a2, b3)
    });
    Micro = Object.assign((value) => value, {
      zero: 0,
      fromNano: (ns) => ns / 1e3,
      fromMilli: (ms2) => ms2 * 1e3,
      fromSecond: (s) => s * 1e6,
      toNano: (us2) => us2 * 1e3,
      toMilli: (us2) => us2 / 1e3,
      toSecond: (us2) => us2 / 1e6,
      now: () => performance.now() * 1e3,
      add: (a2, b3) => a2 + b3,
      sub: (a2, b3) => a2 - b3,
      mul: (a2, b3) => a2 * b3,
      div: (a2, b3) => a2 / b3,
      max: (a2, b3) => Math.max(a2, b3),
      min: (a2, b3) => Math.min(a2, b3)
    });
    Milli = Object.assign((value) => value, {
      zero: 0,
      fromNano: (ns) => ns / 1e6,
      fromMicro: (us2) => us2 / 1e3,
      fromSecond: (s) => s * 1e3,
      toNano: (ms2) => ms2 * 1e6,
      toMicro: (ms2) => ms2 * 1e3,
      toSecond: (ms2) => ms2 / 1e3,
      now: () => performance.now(),
      add: (a2, b3) => a2 + b3,
      sub: (a2, b3) => a2 - b3,
      mul: (a2, b3) => a2 * b3,
      div: (a2, b3) => a2 / b3,
      max: (a2, b3) => Math.max(a2, b3),
      min: (a2, b3) => Math.min(a2, b3)
    });
    Timescale = Object.assign((unitsPerSecond) => {
      if (!Number.isSafeInteger(unitsPerSecond) || unitsPerSecond <= 0) {
        throw new RangeError(`invalid timescale: ${unitsPerSecond}`);
      }
      return unitsPerSecond;
    }, {
      /** One unit per second. */
      SECOND: 1,
      /** 1,000 units per second. */
      MILLI: 1e3,
      /** 1,000,000 units per second. */
      MICRO: 1e6,
      /** 1,000,000,000 units per second. */
      NANO: 1e9
    });
    Timestamp = class _Timestamp {
      /** The raw value, in `scale` units. */
      value;
      /** Units per second the {@link value} is measured in. */
      scale;
      /** Build a timestamp of `value` units at `scale`. */
      constructor(value, scale) {
        assertTimestampValue(value);
        this.value = value;
        this.scale = Timescale(scale);
      }
      /** Monotonic now (`performance.now()`, milliseconds since page load), not wall-clock time. */
      static now() {
        return new _Timestamp(performance.now(), Timescale.MILLI);
      }
      /** A timestamp of `ms` milliseconds. */
      static fromMillis(ms2) {
        return new _Timestamp(ms2, Timescale.MILLI);
      }
      /** A timestamp of `us` microseconds. */
      static fromMicros(us2) {
        return new _Timestamp(us2, Timescale.MICRO);
      }
      /** This timestamp's value re-expressed at `scale`; throws if the result is not in the safe range. */
      as(scale) {
        const dest = Timescale(scale);
        const converted = dest === this.scale ? this.value : this.value * dest / this.scale;
        assertTimestampValue(converted);
        return converted;
      }
      /** The value in milliseconds. */
      asMillis() {
        return this.as(Timescale.MILLI);
      }
      /** The value in microseconds. */
      asMicros() {
        return this.as(Timescale.MICRO);
      }
    };
    Second = Object.assign((value) => value, {
      zero: 0,
      fromNano: (ns) => ns / 1e9,
      fromMicro: (us2) => us2 / 1e6,
      fromMilli: (ms2) => ms2 / 1e3,
      toNano: (s) => s * 1e9,
      toMicro: (s) => s * 1e6,
      toMilli: (s) => s * 1e3,
      now: () => performance.now() / 1e3,
      add: (a2, b3) => a2 + b3,
      sub: (a2, b3) => a2 - b3,
      mul: (a2, b3) => a2 * b3,
      div: (a2, b3) => a2 / b3,
      max: (a2, b3) => Math.max(a2, b3),
      min: (a2, b3) => Math.min(a2, b3)
    });
  }
});

// ../../node_modules/@moq/net/group.js
var group_exports = {};
__export(group_exports, {
  Consumer: () => Consumer2,
  MAX_GROUP_CACHE_BYTES: () => MAX_GROUP_CACHE_BYTES,
  MAX_GROUP_FRAMES: () => MAX_GROUP_FRAMES,
  Producer: () => Producer2
});
function appendFrame(state, frame) {
  if (state.closed.peek() !== void 0)
    throw new Error("group is closed");
  state.timestamp ??= frame.timestamp;
  state.latest = frame.timestamp;
  state.cacheBytes += frame.payload.byteLength;
  state.frames.mutate((frames) => {
    frames.push(frame);
  });
  state.total.update((total) => total + 1);
}
var MAX_GROUP_CACHE_BYTES, MAX_GROUP_FRAMES, GroupState, Producer2, makeConsumer2, CombinedClosed, Consumer2;
var init_group = __esm({
  "../../node_modules/@moq/net/group.js"() {
    init_signals();
    init_error2();
    init_internal();
    init_time();
    MAX_GROUP_CACHE_BYTES = 32 * 1024 * 1024;
    MAX_GROUP_FRAMES = 8192;
    GroupState = class {
      sequence;
      frames = new Signal([]);
      closed = new Once();
      total = new Signal(0);
      // The total number of frames in the group thus far
      // Absolute sequence of the frame at the front of `frames`, advanced by a read: the
      // sequence the next read returns.
      start = 0;
      cacheBytes = 0;
      // The first frame's timestamp, retained after reads.
      timestamp;
      // The newest frame's timestamp: where a reader that has taken every frame sits.
      latest;
      constructor(sequence) {
        this.sequence = sequence;
      }
    };
    Producer2 = class {
      /** Sequence number of this group within its track. */
      sequence;
      #state;
      #mirrors;
      // Whether any mirror reader is attached (see {@link used}). Fetch coalescing watches it to
      // cancel an abandoned download; a group can stay open indefinitely (a catalog or JSON stream),
      // so this is what stops a reader-less fetch instead of the stream ending on its own.
      #used = new Signal(false);
      // When the group was created or last written. Retention ages a group from this,
      // not from its creation, so a group still being filled is never reclaimed.
      #activity = performance.now();
      constructor(sequence) {
        this.#state = new GroupState(sequence);
        this.sequence = sequence;
      }
      /**
       * When the group was created or last written, in `performance.now()` milliseconds.
       *
       * @internal Track retention only.
       */
      get activity() {
        return this.#activity;
      }
      /**
       * Settles once the group closes: `null` on a clean close, or the abort {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       */
      get closed() {
        return this.#state.closed;
      }
      /** A read handle for this group. */
      consume() {
        return makeConsumer2(this.#state);
      }
      /**
       * Create an independent read handle that receives every frame written here.
       *
       * Frames written so far are replayed synchronously; later writes and close are teed
       * in as they happen.
       *
       * @internal Track fan-out and fetch coalescing only. Use {@link consume} instead.
       */
      mirror() {
        const dst = new GroupState(this.sequence);
        dst.timestamp = this.#state.timestamp;
        dst.latest = this.#state.latest;
        for (const frame of this.#state.frames.peek())
          appendFrame(dst, frame);
        dst.start = this.#state.start;
        dst.total.set(this.#state.total.peek());
        const closed = this.#state.closed.peek();
        if (closed !== void 0) {
          dst.closed.set(closed);
          return makeConsumer2(dst);
        }
        this.#mirrors ??= /* @__PURE__ */ new Set();
        this.#mirrors.add(dst);
        this.#used.set(true);
        const dispose = dst.closed.subscribe((c2) => {
          if (c2 === void 0)
            return;
          this.#mirrors?.delete(dst);
          this.#used.set((this.#mirrors?.size ?? 0) > 0);
          dispose();
        });
        return makeConsumer2(dst);
      }
      /**
       * Whether any mirror reader is currently attached.
       *
       * Pairs with {@link unused}. Fetch coalescing watches it to cancel a download once every reader
       * has gone: a group can stay open indefinitely (a catalog track, a JSON stream), so it can't
       * rely on the stream ending on its own.
       *
       * @internal Track fan-out and fetch coalescing only.
       */
      get used() {
        return this.#used;
      }
      /**
       * Resolves once no mirror reader remains (or the group closes).
       *
       * @internal Track fan-out and fetch coalescing only.
       */
      async unused() {
        while (this.#used.peek() && this.#state.closed.peek() === void 0) {
          await Signal.race(this.#used, this.#state.closed);
        }
      }
      /** Writes a frame to the group. */
      writeFrame(frame) {
        if (this.#state.closed.peek() !== void 0)
          throw new Error("group is closed");
        if (frame.payload.byteLength > MAX_GROUP_CACHE_BYTES)
          throw new FrameTooLarge();
        if (this.#state.total.peek() >= MAX_GROUP_FRAMES || this.#state.cacheBytes + frame.payload.byteLength > MAX_GROUP_CACHE_BYTES) {
          const err2 = new GroupTooLarge();
          this.#state.frames.set([]);
          this.#state.cacheBytes = 0;
          if (this.#mirrors) {
            for (const mirror of this.#mirrors) {
              mirror.frames.set([]);
              mirror.cacheBytes = 0;
            }
          }
          this.close(err2);
          throw err2;
        }
        this.#activity = performance.now();
        appendFrame(this.#state, frame);
        if (this.#mirrors) {
          for (const mirror of this.#mirrors) {
            if (mirror.closed.peek() !== void 0)
              this.#mirrors.delete(mirror);
            else
              appendFrame(mirror, frame);
          }
        }
      }
      /** Write a string as a single UTF-8 encoded frame, stamped with {@link Timestamp.now}. */
      writeString(str) {
        this.writeFrame({ payload: new TextEncoder().encode(str), timestamp: Timestamp.now() });
      }
      /** Write a value as a single JSON-encoded frame, stamped with {@link Timestamp.now}. */
      writeJson(json) {
        this.writeString(JSON.stringify(json));
      }
      /** Write a boolean as a single one-byte frame, stamped with {@link Timestamp.now}. */
      writeBool(bool) {
        this.writeFrame({ payload: new Uint8Array([bool ? 1 : 0]), timestamp: Timestamp.now() });
      }
      /** True once the group has been closed. */
      get isClosed() {
        return this.#state.closed.peek() !== void 0;
      }
      /** Closes the group, optionally with an error to abort readers. */
      close(abort) {
        if (this.#state.closed.peek() !== void 0)
          return;
        this.#state.closed.set(abort ?? null);
        if (this.#mirrors) {
          for (const mirror of this.#mirrors) {
            if (mirror.closed.peek() === void 0)
              mirror.closed.set(abort ?? null);
          }
          this.#mirrors.clear();
        }
      }
    };
    CombinedClosed = class {
      #preferred;
      #source;
      #sourceCleanReady;
      #value = new Once();
      #dispose;
      constructor(preferred, source, sourceCleanReady) {
        this.#preferred = preferred;
        this.#source = source;
        this.#sourceCleanReady = sourceCleanReady;
        if (this.#sync())
          return;
        const dispose = [preferred.changed(() => this.#sync()), source.changed(() => this.#sync())];
        this.#dispose = () => {
          for (const close of dispose)
            close();
        };
      }
      #sync() {
        if (this.#value.peek() !== void 0)
          return true;
        const preferred = this.#preferred.peek();
        const source = this.#source.peek();
        const value = preferred !== void 0 ? preferred : source instanceof Error || this.#sourceCleanReady() ? source : void 0;
        if (value === void 0)
          return false;
        this.#value.set(value);
        this.#dispose?.();
        this.#dispose = void 0;
        return true;
      }
      refresh() {
        this.#sync();
      }
      peek() {
        this.#sync();
        return this.#value.peek();
      }
      changed(fn) {
        this.#sync();
        return fn ? this.#value.changed(fn) : this.#value.changed();
      }
      subscribe(fn) {
        this.#sync();
        return this.#value.subscribe(fn);
      }
      // biome-ignore lint/suspicious/noThenProperty: CombinedClosed is intentionally awaitable.
      then(onFulfilled, onRejected) {
        this.#sync();
        return this.#value.then(onFulfilled, onRejected);
      }
    };
    Consumer2 = class _Consumer {
      /** Sequence number of this group within its track. */
      sequence;
      #state;
      #expiry;
      // Sticky verdicts, set once. `#ended` is a drained group the budget gave up on,
      // which is indistinguishable from one that ended: nothing was lost, so it reads as
      // the end of the group. `#terminal` is a failure, including a budget that gave up
      // while content was still unread.
      #ended = false;
      #terminal;
      #verdict = new Once();
      #closed;
      #pendingFrames = 0;
      constructor(state) {
        this.#state = state;
        this.sequence = state.sequence;
      }
      /**
       * Settles when this consumer reaches a terminal state: `null` after a clean close has no
       * unread or in-flight frames, or the terminal {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       */
      get closed() {
        this.#closed ??= new CombinedClosed(this.#verdict, this.#state.closed, () => this.#state.frames.peek().length === 0 && this.#pendingFrames === 0);
        return this.#closed;
      }
      static {
        makeConsumer2 = (state) => new _Consumer(state);
        hooks.groupTimestamp = (group) => group.#state.timestamp;
        hooks.groupLatest = (group) => group.#state.latest;
        hooks.expireGroup = (group, expiry) => {
          group.#expiry = expiry;
        };
        hooks.guardGroup = (group, operation) => group.#guard(operation);
        hooks.readGroupFrame = (group, from2) => group.#readFramePosition(true, from2);
        hooks.evictGroup = (group) => {
          group.#evict();
        };
      }
      // Evaluate the drift budget for a read that has nothing buffered and is about to
      // wait. A group with frames in hand is always drained: the budget bounds a group
      // that has stalled while the live edge moved on, not a reader slower than the wire.
      // Returns true if a verdict was just reached, so the caller re-checks.
      //
      // `unread` is for a caller that still holds content the reader has not seen (a
      // publisher part-way through writing a frame): giving up there is a truncation, so
      // it fails rather than ending.
      #expire(unread = false) {
        if (this.#terminal || this.#ended)
          return false;
        if (this.#state.closed.peek() instanceof Error)
          return false;
        if (!this.#expiry?.expired())
          return false;
        if (unread) {
          this.#terminal = new Error("group exceeded the subscription max age budget");
        } else {
          this.#ended = true;
        }
        if (this.#verdict.peek() === void 0)
          this.#verdict.set(this.#terminal ?? null);
        return true;
      }
      // Takes a thunk rather than a started promise, so a group already past its budget
      // never begins the write: an abandoned write would reject later with no handler.
      #guard(operation) {
        this.#expire(true);
        if (this.#terminal)
          return Promise.reject(this.#terminal);
        const expiry = this.#expiry;
        if (!expiry)
          return operation();
        return new Promise((resolve2, reject) => {
          let settled = false;
          const disposes = [];
          const finish = (fn) => {
            if (settled)
              return;
            settled = true;
            for (const dispose of disposes)
              dispose();
            fn();
          };
          const check = () => {
            this.#expire(true);
            if (this.#terminal) {
              const error2 = this.#terminal;
              finish(() => reject(error2));
            }
          };
          for (const changed of expiry.changed)
            disposes.push(changed.subscribe(check));
          operation().then((value) => finish(() => resolve2(value)), (error2) => finish(() => reject(error2)));
          check();
        });
      }
      #evict() {
        const frames = this.#state.frames.peek();
        if (frames.length > 0) {
          this.#expire(true);
          if (!this.#terminal && !this.#ended) {
            this.#terminal = new TooFarBehind();
            if (this.#verdict.peek() === void 0)
              this.#verdict.set(this.#terminal);
          }
        }
        if (frames.length > 0) {
          this.#state.start += frames.length;
        }
        this.#state.cacheBytes = 0;
        this.#state.frames.set([]);
      }
      async #changed() {
        if (!this.#expiry) {
          await Signal.race(this.#state.frames, this.#state.closed);
          return;
        }
        await Signal.race(this.#state.frames, this.#state.closed, ...this.#expiry.changed);
      }
      #readBufferedFrame(pending = false) {
        const frames = this.#state.frames.peek();
        const buffered = frames.shift();
        if (!buffered)
          return void 0;
        const sequence = this.#state.start++;
        if (pending)
          this.#pendingFrames++;
        let completed = false;
        return {
          sequence,
          frame: buffered,
          complete: () => {
            if (completed)
              return;
            completed = true;
            if (pending)
              this.#pendingFrames--;
            this.#closed?.refresh();
          }
        };
      }
      /** True once no further frames can be read: the group has closed and every buffered frame is read. */
      get done() {
        return this.#terminal !== void 0 || this.#ended || this.#state.frames.peek().length === 0 && this.#state.closed.peek() !== void 0;
      }
      /** True once the group has been closed, regardless of whether buffered frames remain unread. Synchronous complement to the {@link closed} promise. */
      get isClosed() {
        return this.#terminal !== void 0 || this.#ended || this.#state.closed.peek() !== void 0;
      }
      /**
       * How many frames the group has held, including any already read.
       *
       * It is also the next frame's sequence number, so `frameCount - 1` names the newest
       * frame written so far. A publisher snapshots it to resolve the track's live edge.
       */
      get frameCount() {
        return this.#state.total.peek();
      }
      /**
       * Reads the next already-buffered frame without blocking.
       * Treat the returned frame bytes as read-only; they are shared with other consumers.
       *
       * Returns `undefined` when nothing is buffered right now. That is not by itself
       * end-of-group: check {@link done} to tell "no frame buffered yet" from "finished".
       */
      tryReadFrame() {
        if (this.#terminal || this.#ended)
          return void 0;
        const read2 = this.#readBufferedFrame();
        read2?.complete();
        return read2?.frame;
      }
      /** Like {@link tryReadFrame} but also reports the frame's sequence number within the group. */
      tryReadFrameSequence() {
        if (this.#terminal || this.#ended)
          return void 0;
        const read2 = this.#readBufferedFrame();
        if (!read2)
          return void 0;
        read2.complete();
        return { sequence: read2.sequence, payload: read2.frame.payload, timestamp: read2.frame.timestamp };
      }
      /** Resolves once {@link readFrame} would not block. */
      async readable() {
        for (; ; ) {
          if (this.#terminal || this.#ended)
            return;
          if (this.#state.frames.peek().length > 0)
            return;
          if (this.#state.closed.peek() !== void 0) {
            this.#closed?.refresh();
            return;
          }
          if (this.#expire())
            return;
          await this.#changed();
        }
      }
      /**
       * Reads the next frame from the group.
       * Treat the returned frame bytes as read-only; they are shared with other consumers.
       */
      async readFrame() {
        return (await this.#readFramePosition())?.frame;
      }
      async #readFramePosition(pending = false, from2 = 0) {
        for (; ; ) {
          if (this.#terminal)
            throw this.#terminal;
          if (this.#ended)
            return;
          const read2 = this.#readBufferedFrame(pending);
          if (read2) {
            if (read2.sequence < from2) {
              read2.complete();
              continue;
            }
            if (!pending)
              read2.complete();
            return read2;
          }
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0) {
            this.#closed?.refresh();
            return;
          }
          if (this.#expire())
            continue;
          await this.#changed();
        }
      }
      /**
       * Reads the next frame along with its sequence number within the group.
       * Treat the returned frame bytes as read-only; they are shared with other consumers.
       */
      async readFrameSequence(options) {
        const read2 = await this.#readFramePosition(false, options?.from ?? 0);
        if (!read2)
          return void 0;
        return { sequence: read2.sequence, payload: read2.frame.payload, timestamp: read2.frame.timestamp };
      }
      /** Reads the next frame and decodes its payload as a UTF-8 string. */
      async readString() {
        const frame = await this.readFrame();
        return frame ? new TextDecoder().decode(frame.payload) : void 0;
      }
      /** Reads the next frame and parses its payload as JSON. */
      async readJson() {
        const frame = await this.readString();
        return frame ? JSON.parse(frame) : void 0;
      }
      /** Reads the next frame and decodes its payload as a one-byte boolean. */
      async readBool() {
        const frame = await this.readFrame();
        return frame ? frame.payload[0] === 1 : void 0;
      }
      /** Closes the group, optionally with an error to abort readers. Idempotent. */
      close(abort) {
        if (this.#state.closed.peek() !== void 0)
          return;
        this.#state.closed.set(abort ?? null);
      }
    };
  }
});

// ../../node_modules/@moq/net/wire.js
function registerWire(handle, view) {
  views.set(handle, view);
}
function overrideBroadcastWire(handle, overrides) {
  const view = views.get(handle);
  if (!view)
    throw new Error("broadcast has no wire view");
  views.set(handle, { ...view, ...overrides });
}
function wireOf(handle) {
  const view = views.get(handle);
  if (!view)
    throw new Error("handle has no wire view");
  return view;
}
function registerTrackConsumer(factory) {
  makeTrack = factory;
}
function trackOf(name, source) {
  if (!makeTrack)
    throw new Error("track module is not loaded");
  return makeTrack(name, wireOf(source));
}
var views, makeTrack;
var init_wire = __esm({
  "../../node_modules/@moq/net/wire.js"() {
    views = /* @__PURE__ */ new WeakMap();
  }
});

// ../../node_modules/@moq/net/track.js
var track_exports = {};
__export(track_exports, {
  Consumer: () => Consumer3,
  DEFAULT_MAX_AGE_MS: () => DEFAULT_MAX_AGE_MS,
  Ordered: () => Ordered,
  Producer: () => Producer3,
  Request: () => Request,
  Subscriber: () => Subscriber,
  infoDefaults: () => infoDefaults
});
function maxAgeMillis(value) {
  if (!Number.isFinite(value) || value < 0) {
    throw new RangeError(`maxAge must be a non-negative number of milliseconds: ${value}`);
  }
  const millis = Math.ceil(value);
  if (!Number.isSafeInteger(millis)) {
    throw new RangeError(`maxAge exceeds the safe integer millisecond range: ${value}`);
  }
  return Milli(millis);
}
function priorityByte(value) {
  if (!Number.isInteger(value) || value < 0 || value > 255) {
    throw new RangeError(`priority must be an integer in 0..=255: ${value}`);
  }
  return value;
}
function infoDefaults(info = {}) {
  return {
    timescale: Timescale(info.timescale ?? Timescale.MILLI),
    maxAge: maxAgeMillis(info.maxAge ?? DEFAULT_MAX_AGE_MS),
    priority: priorityByte(info.priority ?? DEFAULT_PRIORITY)
  };
}
function subscriptionDefaults(subscription = {}) {
  const bounds = groupBounds(subscription.groups ?? {});
  return {
    priority: priorityByte(subscription.priority ?? 0),
    maxAge: maxAgeMillis(subscription.maxAge ?? Milli.zero),
    groups: {
      start: subscription.groups?.start === void 0 ? void 0 : { included: bounds.start },
      end: bounds.end === void 0 ? void 0 : { excluded: bounds.end }
    }
  };
}
function combineSubscriptions(states) {
  let combined;
  for (const state of states) {
    const subscription = state.update.peek();
    if (!subscription)
      continue;
    if (!combined) {
      combined = { ...subscription };
      continue;
    }
    combined.priority = Math.max(combined.priority ?? 0, subscription.priority ?? 0);
    combined.maxAge = Milli(Math.max(combined.maxAge ?? Milli.zero, subscription.maxAge ?? Milli.zero));
    const a2 = groupBounds(combined.groups ?? {});
    const b3 = groupBounds(subscription.groups ?? {});
    combined.groups = {
      start: combined.groups?.start === void 0 || subscription.groups?.start === void 0 ? void 0 : { included: Math.min(a2.start, b3.start) },
      end: a2.end === void 0 || b3.end === void 0 ? void 0 : { excluded: Math.max(a2.end, b3.end) }
    };
  }
  return combined;
}
function timelineIndex(timeline, sequence) {
  let lo = 0;
  let hi = timeline.length;
  while (lo < hi) {
    const mid = lo + hi >>> 1;
    if (timeline[mid].sequence < sequence)
      lo = mid + 1;
    else
      hi = mid;
  }
  return lo;
}
function timelineInsert(timeline, group) {
  const last = timeline.at(-1);
  if (!last || last.sequence < group.sequence) {
    timeline.push(group);
    return;
  }
  const index2 = timelineIndex(timeline, group.sequence);
  if (timeline[index2]?.sequence === group.sequence)
    timeline[index2] = group;
  else
    timeline.splice(index2, 0, group);
}
function closeTrackState(state, abort) {
  if (state.closed.peek() !== void 0)
    return false;
  state.closed.set(abort ?? null);
  return true;
}
async function resolveInfo(state) {
  for (; ; ) {
    const info = state.info.peek();
    if (info)
      return info;
    const closed = state.closed.peek();
    if (closed instanceof Error)
      throw closed;
    if (closed !== void 0)
      throw new Error("track closed before info was known");
    await Signal.race(state.info, state.closed);
  }
}
function bindProducer(name, producer, sequences) {
  let shared2 = sequences.get(name);
  if (!shared2) {
    shared2 = { next: 0 };
    sequences.set(name, shared2);
  }
  bindProducerSequence(producer, shared2);
}
var MAX_TIMEOUT_MS, PRUNE_SLICES, DEFAULT_MAX_AGE_MS, DEFAULT_PRIORITY, MAX_DATAGRAMS, MAX_DATAGRAM_BYTES, Request, Consumer3, TrackState, bindProducerSequence, makeOrdered, ordered_, makeSubscriber, Producer3, Subscriber, Ordered;
var init_track = __esm({
  "../../node_modules/@moq/net/track.js"() {
    init_signals();
    init_error2();
    init_group();
    init_internal();
    init_time();
    init_wire();
    MAX_TIMEOUT_MS = 2 ** 31 - 1;
    PRUNE_SLICES = 8;
    DEFAULT_MAX_AGE_MS = Milli(5e3);
    DEFAULT_PRIORITY = 127;
    MAX_DATAGRAMS = 64;
    MAX_DATAGRAM_BYTES = 65535;
    Request = class _Request {
      /** The requested track name. */
      name;
      #producer;
      #sequences;
      #pending;
      constructor(options) {
        this.name = options.name;
        this.#producer = options.producer;
        this.#sequences = options.sequences;
        this.#pending = options.pending;
        this.#pending.add(this);
      }
      static {
        hooks.makeRequest = (options) => new _Request(options);
        hooks.pendingTrackProducer = (request) => request.#producer;
      }
      /** The aggregate subscription requested for this track. */
      get subscription() {
        return this.#producer.subscription.peek() ?? subscriptionDefaults();
      }
      /** The subscriber's priority for this track. */
      get priority() {
        return this.subscription.priority ?? 0;
      }
      /** Accept the request, committing the track's immutable {@link Info}. */
      accept(info = {}) {
        this.#pending.delete(this);
        bindProducer(this.name, this.#producer, this.#sequences);
        return this.#producer.accept(info);
      }
      /** Reject the request, closing the track optionally with an error. */
      reject(err2) {
        this.#pending.delete(this);
        this.#producer.close(err2);
      }
    };
    Consumer3 = class _Consumer {
      /** The track name. */
      name;
      #broadcast;
      constructor(name, broadcast2) {
        this.name = name;
        this.#broadcast = broadcast2;
      }
      static {
        registerTrackConsumer((name, broadcast2) => new _Consumer(name, broadcast2));
      }
      /**
       * Open a live subscription to the track.
       *
       * The cursor starts at the group the subscription named (its floor), or 0.
       * {@link Subscription.maxAge} is what asks for data: delivery skips everything above
       * the floor that the budget convicts, so the default budget of zero delivers only the
       * latest group and a larger one reaches back over what it can still use.
       */
      subscribe(options) {
        return this.#broadcast.subscribe(this.name, options);
      }
      /** Fetch the track's immutable publisher properties without subscribing. */
      info() {
        return this.#broadcast.resolveTrackInfo(this.name);
      }
      /** Fetch a single group by sequence without holding a live subscription. */
      fetchGroup(sequence, options) {
        return this.#broadcast.fetchGroup(this.name, sequence, options);
      }
    };
    TrackState = class {
      /** The producer fanning into this sink, so a subscriber can mint a sibling of itself. */
      producer;
      groups = new Signal([]);
      // Every group still in the producer's replay cache, including groups this
      // subscriber already consumed, sorted by sequence. Drift anchors have the same
      // lifetime as content. Sorted so the latency guard, evaluated per group and per
      // arrival, searches it instead of scanning the whole retained window.
      timeline = [];
      // First timestamps mutate group state rather than track state, so held groups
      // watch this revision as well as arrivals when enforcing latency after handoff.
      timelineChanged = new Signal(0);
      /** Best-effort datagram channel, parallel to {@link groups}; a bounded send buffer per subscriber. */
      datagrams = new Signal([]);
      latest;
      /**
       * The exclusive final boundary, declared by {@link Producer.finishAt} or stamped by a
       * clean close as one past the highest sequence produced. Groups and datagrams share the
       * namespace, so this can exceed `latest + 1` (which only tracks groups). Mirrors the
       * Rust `final_sequence`.
       */
      final = new Signal(void 0);
      closed = new Once();
      update;
      /** Resolved once the producer commits the immutable properties. */
      info = new Signal(void 0);
      constructor(subscription) {
        this.update = new Signal(subscription === void 0 ? void 0 : subscriptionDefaults(subscription));
      }
    };
    Producer3 = class {
      /** The track name. */
      name;
      // The producer's own state is the source of truth (info/closed); subscribers
      // read mirrored sinks, never this state directly.
      #state = new TrackState();
      #sequence = { next: 0 };
      // One past the highest group or datagram this producer received, like the Rust
      // `max_sequence`. The shared counter above can run ahead of it: sibling producers of
      // the same track advance it too.
      #received = 0;
      // Recently written source groups, retained for replay to late subscribers and
      // pruned once idle for longer than the cache window. Each entry tracks the mirror
      // it handed to every sink so eviction can drop them too: otherwise a slow consumer
      // that never reads would pin old groups (and their frame bytes) forever.
      #cache = [];
      // The same entries by sequence, so a write finds a duplicate without a scan.
      #cached = /* @__PURE__ */ new Map();
      // When the cache was last scanned. See #prune.
      #pruned = Number.NEGATIVE_INFINITY;
      // Wakeup for the next entry due to age out. Writes settle retention inline, but a
      // publisher that stalls stops writing, so without this an abandoned group (and any
      // reader parked in it) would wait for a write that never comes.
      #pruneTimer;
      #pruneTimerAt = 0;
      // One independent downstream state per live subscriber.
      #sinks = /* @__PURE__ */ new Set();
      // Whether any subscriber is currently attached. Exposed as {@link used}; the consumer wire
      // watches it to tear down an idle upstream, and a publisher can watch it for on-demand capture.
      #used = new Signal(false);
      constructor(name) {
        this.name = name;
      }
      static {
        bindProducerSequence = (producer, sequence) => {
          producer.#sequence = sequence;
        };
      }
      /**
       * Resolve this track's immutable publisher properties, committed at accept time.
       * Rejects if the track is closed before the properties are known.
       */
      info() {
        return resolveInfo(this.#state);
      }
      /**
       * Publisher priority from the committed {@link Info}, or the default before {@link accept}.
       *
       * Higher is served first. Hang publishers set this from `Catalog.PRIORITY` so
       * audio outranks video on the wire and in the bandwidth allocator.
       */
      get priority() {
        return this.#state.info.peek()?.priority ?? DEFAULT_PRIORITY;
      }
      /**
       * Settles once the track closes: `null` on a clean close, or the abort {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       */
      get closed() {
        return this.#state.closed;
      }
      /**
       * The aggregate subscription across live subscribers, or `undefined` when there are none.
       * The wire layer watches this to emit SUBSCRIBE_UPDATE.
       */
      get subscription() {
        return this.#state.update;
      }
      /** Commit the immutable publisher properties, resolving {@link info}. Returns `this`. */
      accept(info = {}) {
        if (this.#state.closed.peek() !== void 0)
          return this;
        const resolved = infoDefaults(info);
        this.#state.info.set(resolved);
        for (const sink of this.#sinks)
          sink.info.set(resolved);
        this.#updateSubscription();
        return this;
      }
      /**
       * An independent {@link Subscriber} reading this track's groups.
       *
       * Its cursor starts at the group the subscription named (its floor), or 0.
       * {@link Subscription.maxAge} is what asks for data: delivery skips everything above
       * the floor that the budget convicts, so the default budget of zero delivers only the
       * latest group and a larger one reaches back over what it can still use.
       */
      subscribe(options = {}) {
        const sink = new TrackState(options);
        this.#addSink(sink);
        return makeSubscriber(this.name, sink);
      }
      /**
       * Whether the track currently has any subscribers.
       *
       * Watch it (`effect.get` / `.peek()`) to drive on-demand work: a publisher can start and stop
       * capture with demand, and the consumer wire watches it to tear an idle upstream subscription
       * down instead of downloading to nobody. Pairs with {@link unused}. Mirrors the Rust `Demand`.
       */
      get used() {
        return this.#used;
      }
      /** Resolves once the track has no subscribers (or has closed). Await it to react to demand ending. */
      async unused() {
        while (this.#used.peek() && this.#state.closed.peek() === void 0) {
          await Signal.race(this.#used, this.#state.closed);
        }
      }
      // Register a downstream sink: seed its info, replay the retained window, and (while
      // the track is open) mirror future groups into it. A late subscriber to a closed
      // track still drains the buffered groups before seeing the end.
      #addSink(sink) {
        sink.producer = this;
        const info = this.#state.info.peek();
        if (info)
          sink.info.set(info);
        const closed = this.#state.closed.peek();
        if (closed === void 0) {
          this.#sinks.add(sink);
          this.#used.set(true);
          const forward = sink.update.subscribe(() => this.#updateSubscription());
          this.#updateSubscription();
          const dispose = sink.closed.subscribe((c2) => {
            if (c2 === void 0)
              return;
            const abort = c2 instanceof Error ? c2 : void 0;
            forward();
            this.#sinks.delete(sink);
            this.#updateSubscription();
            this.#used.set(this.#sinks.size > 0);
            if (this.#state.closed.peek() !== void 0) {
              dispose();
              return;
            }
            for (const entry of this.#cache) {
              const mirror = entry.mirrors.get(sink);
              if (mirror) {
                mirror.close(abort);
                entry.mirrors.delete(sink);
              }
            }
            for (const group of sink.groups.peek())
              group.close(abort);
            dispose();
          });
        }
        this.#prune();
        for (const entry of this.#cache)
          this.#mirror(entry, sink);
        sink.final.set(this.#state.final.peek());
        if (closed !== void 0)
          closeTrackState(sink, closed instanceof Error ? closed : void 0);
      }
      // Recompute from every live sink because an update or close can narrow as well as widen
      // the aggregate. The wire layer observes this signal and emits SUBSCRIBE_UPDATE.
      #updateSubscription() {
        const combined = combineSubscriptions(this.#sinks);
        const retained = this.#state.info.peek()?.maxAge;
        if (combined && retained !== void 0)
          combined.maxAge = Milli.min(combined.maxAge ?? Milli.zero, retained);
        this.#state.update.set(combined);
      }
      // Mirror a cached source group into a sink. The mirror fills synchronously as the
      // source is written and keeps its own read cursor; frame bytes are shared by
      // reference. Tracked on the entry so eviction can drop it from the sink.
      #mirror(entry, sink) {
        const dst = entry.group.mirror();
        entry.mirrors.set(sink, dst);
        timelineInsert(sink.timeline, dst);
        void dst.readable().then(() => sink.timelineChanged.update((revision) => revision + 1));
        sink.latest = Math.max(sink.latest ?? 0, dst.sequence);
        sink.groups.mutate((groups2) => {
          groups2.push(dst);
          groups2.sort((a2, b3) => a2.sequence - b3.sequence);
        });
      }
      // Drop a cached group's mirror from every sink so no consumer can pin it.
      #evict(entry) {
        if (!entry.group.isClosed)
          entry.group.close(new TooFarBehind());
        const mirrors = [...entry.mirrors.values()];
        for (const mirror of mirrors)
          hooks.evictGroup(mirror);
        this.#unlink(entry);
        for (const mirror of mirrors)
          mirror.close();
      }
      // Take a cached group's mirrors out of every sink, so a subscriber can no longer
      // receive them. A reader already holding one keeps it as is.
      #unlink(entry) {
        for (const [sink, mirror] of entry.mirrors) {
          sink.groups.mutate((groups2) => {
            const i2 = groups2.indexOf(mirror);
            if (i2 >= 0)
              groups2.splice(i2, 1);
          });
          const index2 = timelineIndex(sink.timeline, mirror.sequence);
          if (sink.timeline[index2] === mirror)
            sink.timeline.splice(index2, 1);
        }
        entry.mirrors.clear();
      }
      // Take a cached group out of the cache lookups.
      #uncache(entry) {
        this.#cache.splice(this.#cache.indexOf(entry), 1);
        this.#cached.delete(entry.group.sequence);
      }
      // Tablebox: moq-dev/moq#4659 (tablebox.io patches.mjs). When the track closed, which
      // restarts the former newest group's idle window. See #prune.
      #closedAt = Number.NEGATIVE_INFINITY;
      // The newest group remains replayable while the track is live, even after the group
      // closes: a catalog can publish one snapshot for the broadcast's whole lifetime. An
      // aborted one holds nothing worth replaying, so it ages out like any other.
      #edge() {
        const latest = this.#state.latest;
        if (latest === void 0)
          return void 0;
        const group = this.#cached.get(latest)?.group;
        return group?.closed.peek() instanceof Error ? void 0 : group;
      }
      // Evict cached groups idle for longer than the cache window. Idle means nothing
      // written, so an abandoned open group ages out instead of pinning its buffer (and
      // any reader parked in it) forever.
      //
      // Scans at most once per slice of the window, so a track publishing faster than that
      // evicts a run of groups per scan instead of scanning everything to evict one per
      // write. A group can outlive the window by up to one slice.
      #prune() {
        const maxAgeMs = this.#state.info.peek()?.maxAge ?? DEFAULT_MAX_AGE_MS;
        const now = performance.now();
        const slice = maxAgeMs / PRUNE_SLICES;
        if (now < this.#pruned + slice) {
          this.#wake(this.#pruned + slice);
          return;
        }
        this.#pruned = now;
        const cutoff = now - maxAgeMs;
        const edge = this.#edge();
        const live = this.#state.closed.peek() === void 0;
        let oldest;
        const retained = [];
        for (const entry of this.#cache) {
          const activity = entry.group === edge ? Math.max(entry.group.activity, this.#closedAt) : entry.group.activity;
          if (entry.group === edge && live) {
            retained.push(entry);
          } else if (activity >= cutoff) {
            retained.push(entry);
            if (oldest === void 0 || activity < oldest)
              oldest = activity;
          } else {
            this.#cached.delete(entry.group.sequence);
            this.#evict(entry);
          }
        }
        this.#cache = retained;
        clearTimeout(this.#pruneTimer);
        this.#pruneTimer = void 0;
        if (oldest !== void 0)
          this.#wake(Math.max(oldest + maxAgeMs, now + slice));
      }
      // Arm the prune wakeup for `at`, unless one is already armed sooner. Kept after a close,
      // until the cache empties, so what the track left behind still ages out.
      #wake(at2) {
        if (this.#pruneTimer !== void 0 && this.#pruneTimerAt <= at2)
          return;
        clearTimeout(this.#pruneTimer);
        const delay = Math.min(MAX_TIMEOUT_MS, Math.max(0, at2 - performance.now()));
        const timer = setTimeout(() => {
          this.#pruneTimer = void 0;
          this.#prune();
        }, delay);
        timer.unref?.();
        this.#pruneTimer = timer;
        this.#pruneTimerAt = at2;
      }
      // Retain a source group and fan it out to every live sink.
      #publish(group) {
        const entry = { group, mirrors: /* @__PURE__ */ new Map() };
        this.#cache.push(entry);
        this.#cached.set(group.sequence, entry);
        this.#received = Math.max(this.#received, group.sequence + 1);
        this.#state.latest = Math.max(this.#state.latest ?? 0, group.sequence);
        for (const sink of this.#sinks)
          this.#mirror(entry, sink);
        this.#prune();
      }
      // Refuse a write once the track is closed, or at or past its declared end.
      #writable(sequence) {
        if (this.#state.closed.peek() !== void 0)
          throw new Error("track is closed");
        const final = this.#state.final.peek();
        if (final !== void 0 && sequence >= final) {
          throw new Error(`sequence ${sequence} is at or past the track's end ${final}`);
        }
      }
      /** Append a new group with the next sequence number. */
      appendGroup() {
        const sequence = this.#sequence;
        this.#writable(sequence.next);
        const group = new Producer2(sequence.next);
        sequence.next = group.sequence + 1;
        this.#publish(group);
        return group;
      }
      /**
       * Insert an existing group into the track.
       *
       * Throws on a sequence that is still cached: a live duplicate would fan out to every
       * subscriber twice. An aborted incarnation is evicted so a fresh group can serve the
       * sequence again. Best effort (mirrors Rust): nothing remembers a sequence whose cache
       * entry is already gone, so a long-evicted sequence is accepted as new.
       */
      writeGroup(group) {
        this.#writable(group.sequence);
        const existing = this.#cached.get(group.sequence);
        if (existing) {
          if (!(existing.group.closed.peek() instanceof Error)) {
            throw new Error(`duplicate group: sequence=${group.sequence}`);
          }
          this.#evict(existing);
          this.#uncache(existing);
        }
        const sequence = this.#sequence;
        if (group.sequence >= sequence.next) {
          sequence.next = group.sequence + 1;
        }
        this.#publish(group);
      }
      // Fan a datagram out to every live subscriber, dropping the oldest once the ring is full.
      // Late subscribers do NOT replay old datagrams (best-effort, unlike the group cache).
      #publishDatagram(datagram) {
        this.#received = Math.max(this.#received, datagram.sequence + 1);
        for (const sink of this.#sinks) {
          sink.datagrams.mutate((list) => {
            if (list.length === MAX_DATAGRAMS)
              list.shift();
            list.push(datagram);
          });
        }
      }
      /**
       * Append a datagram with the next sequence number, returning the assigned sequence.
       *
       * A datagram is delivered best-effort over a single QUIC datagram, parallel to the track's
       * groups but drawing from the same sequence namespace (interleaving with {@link appendGroup}
       * never reuses a number). The payload must fit the negotiated transport datagram size minus
       * a small header; an oversize payload is dropped at each hop (there is no group fallback), so
       * keep datagram payloads small (e.g. a single audio frame). Datagrams are never delivered
       * over IETF moq-transport or stream-only transports (the WebSocket fallback). A payload over
       * 65535 bytes (the QUIC datagram frame ceiling) throws. An origin publisher uses this; a
       * relay preserving upstream numbering uses {@link insertDatagram}.
       */
      appendDatagram(timestamp, payload) {
        const counter = this.#sequence;
        const sequence = counter.next;
        this.#writable(sequence);
        if (payload.byteLength > MAX_DATAGRAM_BYTES)
          throw new Error("datagram payload too large");
        counter.next = sequence + 1;
        this.#publishDatagram({ sequence, timestamp, payload });
        return sequence;
      }
      /**
       * Insert a datagram with an explicit sequence number.
       *
       * Preserves the supplied sequence (advancing the shared counter if needed) so a relay can
       * forward a datagram without renumbering it. The size limits of {@link appendDatagram}
       * apply. Most origin publishers want {@link appendDatagram} instead.
       */
      insertDatagram(sequence, timestamp, payload) {
        this.#writable(sequence);
        if (payload.byteLength > MAX_DATAGRAM_BYTES)
          throw new Error("datagram payload too large");
        const counter = this.#sequence;
        if (sequence >= counter.next) {
          counter.next = sequence + 1;
        }
        this.#publishDatagram({ sequence, timestamp, payload });
      }
      /**
       * Declare the track's exclusive end, possibly ahead of the live edge, mirroring the Rust
       * `finish_at`.
       *
       * `final` is the first sequence that will never be produced, so a track whose last group
       * is 89 finishes at 90. Groups and datagrams below it are still accepted; anything at or
       * above it is refused. Unlike {@link close} it is not terminal: call `close()` once the
       * remaining groups are written. Throws if the track is closed, already has an end, or
       * `final` is at or below a sequence already produced.
       */
      finishAt(final) {
        if (this.#state.closed.peek() !== void 0)
          throw new Error("track is closed");
        if (!Number.isSafeInteger(final) || final < 0)
          throw new RangeError(`invalid track end: ${final}`);
        const declared = this.#state.final.peek();
        if (declared !== void 0)
          throw new Error(`track already ends at ${declared}`);
        if (final < this.#received) {
          throw new Error(`track end ${final} is below the next sequence ${this.#received}`);
        }
        this.#declareFinal(final);
      }
      #declareFinal(final) {
        this.#state.final.set(final);
        for (const sink of this.#sinks)
          sink.final.set(final);
      }
      /**
       * Close the track and every subscriber, mirroring the abort to their groups. Idempotent.
       *
       * A clean close keeps the end {@link finishAt} declared, or declares one past the highest
       * sequence produced; an abort ends without one. Subscribers still draining get the
       * finished groups first, then the end or the abort. An abort after the declared end
       * settled (reached, with every group below it finished) is a clean close. The groups
       * left behind still age out after the track's `maxAge`, so a stale subscriber can't pin
       * them.
       */
      close(abort) {
        if (this.#state.closed.peek() !== void 0)
          return;
        if (abort && this.#settled())
          abort = void 0;
        if (abort === void 0 && this.#state.final.peek() === void 0) {
          this.#declareFinal(this.#received);
        }
        const open = abort ? this.#cache.filter((entry) => entry.group.closed.peek() === void 0) : [];
        closeTrackState(this.#state, abort);
        for (const { group } of this.#cache)
          group.close(abort);
        for (const entry of open) {
          this.#unlink(entry);
          this.#uncache(entry);
        }
        for (const sink of this.#sinks) {
          for (const group of sink.groups.peek())
            group.close(abort);
          closeTrackState(sink, abort);
        }
        this.#sinks.clear();
        this.#closedAt = performance.now();
        this.#prune();
      }
      // Whether the declared end was reached and every cached group below it finished, so
      // the track already holds everything it promised. Mirrors the Rust `is_settled`.
      #settled() {
        const final = this.#state.final.peek();
        if (final === void 0 || this.#received < final)
          return false;
        return this.#cache.every(({ group }) => group.sequence >= final || group.closed.peek() === null);
      }
      /** Append a frame as its own single-frame group. */
      writeFrame(frame) {
        const group = this.appendGroup();
        group.writeFrame(frame);
        group.close();
      }
      /** Appends a string to the track as its own single-frame group. */
      writeString(str) {
        const group = this.appendGroup();
        group.writeString(str);
        group.close();
      }
      /** Appends a JSON value to the track as its own single-frame group. */
      writeJson(json) {
        const group = this.appendGroup();
        group.writeJson(json);
        group.close();
      }
      /** Appends a boolean to the track as its own single-frame group. */
      writeBool(bool) {
        const group = this.appendGroup();
        group.writeBool(bool);
        group.close();
      }
    };
    Subscriber = class _Subscriber {
      /** The track name. */
      name;
      #state;
      #nextSequence = 0;
      #cursor = new Signal({ start: 0 });
      #enforceLatency = true;
      // Which cursor owns this subscription. Both cursors draw from one buffer, so the
      // first group read commits the track to arrival order and {@link ordered} commits
      // it to sequence order; whichever wins is the only one allowed from here on.
      // Datagrams are a separate cursor and never commit.
      #mode;
      // The group the frame-level helpers are currently draining, acquired through the
      // sequence cursor so frame reads and {@link Ordered.nextGroup} share one floor.
      #frameGroup;
      #drift() {
        const { end } = this.#cursor.peek();
        const timeline = this.#state.timeline;
        let presentation;
        for (let i2 = (end === void 0 ? timeline.length : timelineIndex(timeline, end)) - 1; i2 >= 0; i2--) {
          const group = timeline[i2];
          if (group.closed.peek() instanceof Error)
            continue;
          const timestamp = hooks.groupTimestamp(group);
          if (timestamp === void 0)
            continue;
          presentation = { sequence: group.sequence, timestamp: hooks.groupLatest(group) ?? timestamp };
          break;
        }
        const requested = this.#state.update.peek()?.maxAge ?? 0;
        const retained = this.#state.info.peek()?.maxAge;
        return {
          budget: this.#enforceLatency ? retained === void 0 ? requested : Math.min(requested, retained) : Number.POSITIVE_INFINITY,
          presentation,
          end
        };
      }
      // The furthest presentation time the group at `sequence` could still reach: where its
      // immediate servable successor begins, or undefined when nothing proves where it
      // stops. An upper bound, deliberately: a frame's duration is not on the wire, so a
      // group's own last timestamp says where it starts presenting, not where it ends.
      // Only the *immediate* successor counts: timestamps need not rise with sequence (a
      // rewind reorders them), so a later stamped group proves nothing about where an
      // unstamped successor will begin, and shrinking the bound is the unsafe direction.
      // An unstamped successor leaves the reach unbounded until it presents a frame.
      #reach(sequence, end) {
        const timeline = this.#state.timeline;
        for (let i2 = timelineIndex(timeline, sequence + 1); i2 < timeline.length; i2++) {
          const successor = timeline[i2];
          if (end !== void 0 && successor.sequence >= end)
            break;
          if (successor.closed.peek() instanceof Error)
            continue;
          return hooks.groupTimestamp(successor)?.asMillis();
        }
        return void 0;
      }
      // Whether the drift budget says to give up on `group`.
      //
      // Presentation time measures a group by how far it could still reach, not by how far
      // behind it started. Being behind is survivable: priority transmits newer groups first,
      // so a backlog bursts at whatever rate is left over and closes the gap faster than the
      // live edge advances. A group is abandoned only once everything it could still present
      // falls outside the budget.
      //
      // A group's reach is bounded by its nearest successor: it cannot present past where the
      // next group begins. Its own frames say nothing, since a frame's duration is not on the
      // wire, and the candidate needs no timestamp of its own: an empty group is bounded by
      // its stamped successor the same way. The bound is exclusive, so the comparison is `>=`:
      // the freshest frame a group could still hold sits just below its reach, so an age equal
      // to the budget already puts every frame in it strictly past the budget. A zero budget
      // falls out for free. Only timestamps drive expiry; wall-clock reclamation of idle
      // content is the cache's own policy, not the budget's.
      #isStale(group, drift) {
        if (this.#state.timeline[timelineIndex(this.#state.timeline, group.sequence)] !== group)
          return false;
        const reach = this.#reach(group.sequence, drift.end);
        return drift.presentation !== void 0 && drift.presentation.sequence > group.sequence && reach !== void 0 && drift.presentation.timestamp.asMillis() - reach >= drift.budget;
      }
      #guard(group) {
        if (!this.#enforceLatency)
          return group;
        hooks.expireGroup(group, {
          expired: () => this.#isStale(group, this.#drift()),
          changed: [
            this.#state.groups,
            this.#state.timelineChanged,
            this.#state.update,
            this.#state.info,
            this.#cursor,
            this.#state.closed
          ]
        });
        return group;
      }
      constructor(name, state) {
        this.name = name;
        this.#state = state;
        this.#cursor.set({ start: groupBounds(state.update.peek()?.groups ?? {}).start });
      }
      static {
        makeSubscriber = (name, state) => new _Subscriber(name, state);
        hooks.tryRecvGroup = (subscriber) => subscriber.#tryRecvGroup();
        hooks.groupChanged = (subscriber, fn) => subscriber.#groupChanged(fn);
        hooks.exemptFetch = (subscriber) => {
          subscriber.#enforceLatency = false;
        };
        hooks.replaceGroups = (subscriber, groups2) => subscriber.#replaceGroups(groups2);
        ordered_ = {
          nextGroup: (subscriber) => subscriber.#nextGroup(),
          readFrame: (subscriber) => subscriber.#readFrame(),
          readString: (subscriber) => subscriber.#readString(),
          readJson: (subscriber) => subscriber.#readJson(),
          readBool: (subscriber) => subscriber.#readBool(),
          // Unordered either way, so both handles reach the same cursor.
          recvDatagram: (subscriber) => subscriber.#recvDatagram()
        };
      }
      // Refuse a read on this handle once `ordered()` has taken the subscription.
      #live() {
        if (this.#mode === "ordered")
          throw new Error("track is read in sequence order; use the Ordered handle");
      }
      /**
       * Resolve this track's immutable publisher properties.
       *
       * Resolves once the wire layer commits the TRACK_INFO it received (lite-05+) or
       * defaults (older drafts), so awaiting it never yields a placeholder. Rejects if
       * the track is closed before the properties are known (e.g. a rejected subscription).
       */
      info() {
        return resolveInfo(this.#state);
      }
      /** Settles once the track closes; see {@link Producer.closed}. */
      get closed() {
        return this.#state.closed;
      }
      /** This subscriber's current options, including defaults and the last {@link update}. */
      get subscription() {
        return this.#state.update;
      }
      /** Return the latest group sequence observed on this track, if any. */
      latest() {
        return this.#state.latest;
      }
      /**
       * The track's exclusive final boundary: the end {@link Producer.finishAt} declared, which
       * can be ahead of the live edge, or one past the highest sequence produced once the
       * producer closes cleanly (0 for a track that produced none). Groups and datagrams share
       * the sequence namespace, so this can exceed `latest() + 1`. Undefined until declared,
       * and after an abort that declared none.
       */
      final() {
        return this.#state.final.peek();
      }
      /**
       * Resolve with the track's exclusive final boundary once it is known, mirroring the Rust
       * `finished`.
       *
       * Resolves as soon as the end is declared, which may be ahead of the live edge, so it
       * says nothing about every group having arrived: read until the cursor returns
       * `undefined` for that. Rejects with the abort, or if the track closes without an end.
       */
      async finished() {
        for (; ; ) {
          const final = this.#state.final.peek();
          if (final !== void 0)
            return final;
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0)
            throw new Error("track closed before its end was known");
          await Signal.race(this.#state.final, this.#state.closed);
        }
      }
      /**
       * The newest frame this track has produced, or `undefined` while it has none.
       *
       * Read from the groups buffered for this subscriber, so nothing is consumed. A newest
       * group that has no frames yet falls back to the newest older group that does. It
       * reads as `undefined` once the newest group has been evicted or received: what is
       * left can no longer say where the edge is.
       */
      largest() {
        const latest = this.#state.latest;
        if (latest === void 0)
          return void 0;
        const groups2 = this.#state.groups.peek();
        const newest = groups2[groups2.length - 1];
        if (!newest || newest.sequence !== latest)
          return void 0;
        for (let i2 = groups2.length - 1; i2 >= 0; i2--) {
          const count2 = groups2[i2].frameCount;
          if (count2 > 0)
            return { group: groups2[i2].sequence, frame: count2 - 1 };
        }
        return void 0;
      }
      /**
       * An independent subscriber to the same track, with its own cursor and its own replay of
       * the retained window.
       *
       * Reads here do not consume anything this one would deliver, which is what lets a
       * publisher read the cache alongside the cursor it is serving from. Resolving the track
       * again through the broadcast would not do: a dynamic serve is one request per peer
       * subscription, so that mints a second producer the application has to answer separately.
       *
       * @internal Wire layers only.
       */
      fork(options) {
        const producer = this.#state.producer;
        if (!producer)
          throw new Error("track has no producer to fork from");
        return producer.subscribe(options);
      }
      /** Limit subsequent reads to these groups and return this reader for chaining. */
      withGroups(groups2) {
        this.setGroups(groups2);
        return this;
      }
      /**
       * Limit subsequent reads without rewinding read progress or changing the wire request.
       * An omitted start preserves the current floor; an omitted end removes the cap.
       * Raising the end makes unread buffered groups available again.
       */
      setGroups(groups2) {
        const { start, end } = groupBounds(groups2);
        this.#cursor.update((cursor) => ({ start: Math.max(cursor.start, start), end }));
      }
      // Serving counterpart of setGroups: a named start replaces the floor, matching
      // Rust `start_at`. Local readers stay monotonic; only the wire publisher lowers.
      #replaceGroups(groups2) {
        const { start, end } = groupBounds(groups2);
        this.#cursor.update((cursor) => ({
          start: groups2.start === void 0 ? cursor.start : start,
          end
        }));
      }
      /** Close the track (optionally with an error), closing any pending groups. Idempotent. */
      close(abort) {
        closeTrackState(this.#state, abort);
        this.#state.groups.mutate((groups2) => {
          for (const group of groups2)
            group.close(abort);
          groups2.length = 0;
        });
        this.#frameGroup?.close(abort);
        this.#frameGroup = void 0;
        this.#state.timeline.length = 0;
      }
      /**
       * Receive every group on this track exactly once, as it becomes available.
       *
       * Groups may arrive out of order or with gaps due to network conditions; unlike
       * {@link Ordered.nextGroup}, one that arrives after a newer group was already returned
       * is still delivered. When several groups are buffered, the lowest sequence is
       * returned first.
       *
       * Honors the range set by {@link setGroups}: a group
       * beyond the cap stays buffered (not dropped) and is offered once the cap rises, even
       * after a clean close, without blocking in-range groups that arrive behind it.
       * A group whose presentation time is further behind the live edge than this
       * subscriber's `maxAge` is skipped. The default of zero takes the live edge.
       * The budget remains attached after return, so a pending frame read rejects if a stalled
       * group becomes stale while newer data advances.
       *
       * The first call commits this track to arrival order: {@link ordered} throws afterwards.
       */
      async recvGroup() {
        this.#live();
        this.#mode = "arrival";
        for (; ; ) {
          const recv = this.#tryRecvGroup();
          switch (recv.kind) {
            case "group":
              return recv.group;
            case "done":
              return void 0;
            case "error":
              throw recv.error;
          }
          await Signal.race(this.#state.groups, this.#cursor, this.#state.closed);
        }
      }
      // Package-internal synchronous half of recvGroup. The lite publisher uses this so applying
      // control state, popping the group, and positioning its frames are one JavaScript turn.
      #tryRecvGroup() {
        const groups2 = this.#state.groups.peek();
        const { start, end } = this.#cursor.peek();
        while (groups2.length > 0 && groups2[0].sequence < start)
          groups2.shift()?.close();
        const drift = this.#drift();
        for (; ; ) {
          const group2 = groups2[0];
          if (!group2 || end !== void 0 && group2.sequence >= end)
            break;
          groups2.shift();
          if (this.#isStale(group2, drift)) {
            group2.close();
            continue;
          }
          return { kind: "group", group: this.#guard(group2) };
        }
        const group = groups2[0];
        const closed = this.#state.closed.peek();
        if (closed instanceof Error)
          return { kind: "error", error: closed };
        if (closed === void 0)
          return { kind: "idle" };
        return group ? { kind: "boundary" } : { kind: "done" };
      }
      // Package-internal readiness half of recvGroup. Each registration fires at most once, and
      // the caller disposes the losers after whichever source wakes it. A declared end wakes it
      // too, so a publisher can forward the end before the live edge reaches it.
      #groupChanged(fn) {
        const dispose = [
          this.#state.groups.changed(fn),
          this.#cursor.changed(fn),
          this.#state.closed.changed(fn),
          this.#state.final.changed(fn)
        ];
        return () => {
          for (const close of dispose)
            close();
        };
      }
      /**
       * Take the next buffered group without blocking, honoring the same cursor bounds as
       * {@link recvGroup}.
       *
       * Returns `undefined` when nothing is deliverable right now, which is not by itself the
       * end of the track: a group may still arrive, or one may be parked beyond the
       * {@link setGroups} cap. Use it to drain what the retained window already holds, where
       * waiting for a sequence nothing will republish would park forever.
       */
      tryRecvGroup() {
        this.#live();
        this.#mode = "arrival";
        const recv = this.#tryRecvGroup();
        if (recv.kind === "group")
          return recv.group;
        if (recv.kind === "error")
          throw recv.error;
        return void 0;
      }
      /**
       * Receive the next datagram in arrival order.
       *
       * Datagrams are a separate best-effort channel from groups (see
       * {@link Producer.appendDatagram}); they share only the sequence namespace. A consumer
       * that falls too far behind silently loses the oldest datagrams. Read this alongside
       * {@link recvGroup} (e.g. in a separate loop) to receive both channels concurrently.
       * The two cursors are independent: a datagram never moves the group cursor.
       */
      async recvDatagram() {
        this.#live();
        return this.#recvDatagram();
      }
      // The datagram cursor, reachable from either handle: unordered by construction, so the
      // choice of group order says nothing about it.
      async #recvDatagram() {
        for (; ; ) {
          const datagrams2 = this.#state.datagrams.peek();
          if (datagrams2.length > 0) {
            return datagrams2.shift();
          }
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0)
            return void 0;
          await Signal.race(this.#state.datagrams, this.#state.closed);
        }
      }
      // The sequence cursor behind {@link Ordered}, which owns the only public door to it.
      async #nextGroup() {
        for (; ; ) {
          const groups2 = this.#state.groups.peek();
          const cursor = this.#cursor.peek();
          const start = Math.max(cursor.start, this.#nextSequence);
          while (groups2.length > 0 && groups2[0].sequence < start)
            groups2.shift()?.close();
          const drift = this.#drift();
          for (; ; ) {
            const group = groups2[0];
            if (!group || cursor.end !== void 0 && group.sequence >= cursor.end)
              break;
            groups2.shift();
            this.#nextSequence = group.sequence + 1;
            if (this.#isStale(group, drift)) {
              group.close();
              continue;
            }
            if (this.#frameGroup && this.#frameGroup.sequence < group.sequence) {
              this.#frameGroup.close();
              this.#frameGroup = void 0;
            }
            return this.#guard(group);
          }
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0 && !groups2[0])
            return void 0;
          await Signal.race(this.#state.groups, this.#cursor, this.#state.closed);
        }
      }
      /**
       * Reads the next frame across groups, in sequence order, with its group and frame numbers.
       * Treat the returned frame bytes as read-only; they are shared with other consumers.
       *
       * Groups are acquired through the same sequence cursor as {@link Ordered.nextGroup},
       * so frames never run backwards: a late lower-sequence group is skipped, and so is
       * one every frame of which `maxAge` proves is too old. A group the budget abandons
       * mid-stall ends cleanly and the cursor resyncs from the next group; a gap inside a
       * group still surfaces as {@link TooFarBehind} or {@link GroupTooLarge}.
       */
      async #readFrame() {
        for (; ; ) {
          if (!this.#frameGroup) {
            this.#frameGroup = await this.#nextGroup();
            if (!this.#frameGroup)
              return void 0;
          }
          const group = this.#frameGroup;
          let next;
          try {
            next = await group.readFrameSequence();
          } catch (err2) {
            this.#frameGroup = void 0;
            group.close();
            if (err2 instanceof TooFarBehind || err2 instanceof GroupTooLarge)
              throw err2;
            const closed = this.#state.closed.peek();
            if (closed instanceof Error)
              throw closed;
            continue;
          }
          if (next) {
            return {
              group: group.sequence,
              frame: next.sequence,
              payload: next.payload,
              timestamp: next.timestamp
            };
          }
          this.#frameGroup = void 0;
          group.close();
        }
      }
      /** Reads the next frame and decodes it as a UTF-8 string. */
      async #readString() {
        const next = await this.#readFrame();
        if (!next)
          return void 0;
        return new TextDecoder().decode(next.payload);
      }
      /** Reads the next frame and parses it as JSON. */
      async #readJson() {
        const next = await this.#readString();
        if (!next)
          return void 0;
        return JSON.parse(next);
      }
      /** Reads the next frame and decodes it as a one-byte boolean, throwing on a malformed frame. */
      async #readBool() {
        const next = await this.#readFrame();
        if (!next)
          return void 0;
        const payload = next.payload;
        if (payload.byteLength !== 1 || !(payload[0] === 0 || payload[0] === 1))
          throw new Error("invalid bool frame");
        return payload[0] === 1;
      }
      /**
       * Read this track's groups in sequence order instead of arrival order.
       *
       * Both cursors draw from the same buffer, so a track is read one way or the other: this
       * hands the subscription to the returned {@link Ordered} and leaves this handle inert.
       * {@link recvGroup} and {@link recvDatagram} throw afterwards. Throws once a
       * {@link recvGroup} call has already committed the track to arrival order.
       *
       * Datagrams come along: they are a separate cursor either way, so the choice of group
       * order says nothing about them, and reading them commits nothing.
       */
      ordered() {
        if (this.#mode === "ordered")
          throw new Error("track is already read in sequence order");
        if (this.#mode === "arrival")
          throw new Error("track is already read in arrival order");
        this.#mode = "ordered";
        return makeOrdered(this);
      }
      /**
       * Update this subscription's options (e.g. priority), triggering a SUBSCRIBE_UPDATE to the
       * publisher. Mirrors the Rust `Subscriber::update`.
       */
      update(options) {
        this.#state.update.set(subscriptionDefaults(options));
      }
    };
    Ordered = class _Ordered {
      /** The track name. */
      name;
      #subscriber;
      constructor(subscriber) {
        this.name = subscriber.name;
        this.#subscriber = subscriber;
      }
      static {
        makeOrdered = (subscriber) => new _Ordered(subscriber);
      }
      /** Resolve this track's immutable publisher properties; see {@link Subscriber.info}. */
      info() {
        return this.#subscriber.info();
      }
      /** Settles once the track closes; see {@link Producer.closed}. */
      get closed() {
        return this.#subscriber.closed;
      }
      /** This subscriber's current options, including defaults and the last {@link update}. */
      get subscription() {
        return this.#subscriber.subscription;
      }
      /** The latest group sequence observed on this track, if any. */
      latest() {
        return this.#subscriber.latest();
      }
      /** The track's exclusive final boundary; see {@link Subscriber.final}. */
      final() {
        return this.#subscriber.final();
      }
      /** Resolve with the track's exclusive final boundary once known; see {@link Subscriber.finished}. */
      finished() {
        return this.#subscriber.finished();
      }
      /** Limit subsequent reads to these groups and return this reader for chaining. */
      withGroups(groups2) {
        this.setGroups(groups2);
        return this;
      }
      /** Limit subsequent reads to these groups; see {@link Subscriber.setGroups}. */
      setGroups(groups2) {
        this.#subscriber.setGroups(groups2);
      }
      /** Update this subscription's options; see {@link Subscriber.update}. */
      update(options) {
        this.#subscriber.update(options);
      }
      /** Close the track (optionally with an error), closing any pending groups. Idempotent. */
      close(abort) {
        this.#subscriber.close(abort);
      }
      /**
       * Return the next group with a strictly-greater sequence number than the last returned.
       *
       * Late arrivals (sequence at or below the last returned) are silently skipped, as is a
       * group whose every frame is further behind the live edge than `maxAge` (the default of
       * zero keeps only what nothing newer has superseded). Honors the bounds set by
       * {@link setGroups}.
       */
      nextGroup() {
        return ordered_.nextGroup(this.#subscriber);
      }
      /**
       * Read the next frame across groups, in sequence order, with its group and frame numbers.
       *
       * Rides the same cursor as {@link nextGroup} and shares this handle's contract: a
       * buffered backlog is drained in full up to the point `maxAge` proves it useless.
       * Treat the returned frame bytes as read-only; they are shared with other consumers.
       */
      readFrame() {
        return ordered_.readFrame(this.#subscriber);
      }
      /** Read the next frame and decode it as a UTF-8 string. */
      readString() {
        return ordered_.readString(this.#subscriber);
      }
      /** Read the next frame and parse it as JSON. */
      readJson() {
        return ordered_.readJson(this.#subscriber);
      }
      /** Read the next frame and decode it as a one-byte boolean, throwing on a malformed frame. */
      readBool() {
        return ordered_.readBool(this.#subscriber);
      }
      /**
       * Receive the next datagram in arrival order.
       *
       * Datagrams are a separate best-effort channel from groups (see
       * {@link Producer.appendDatagram}); they share only the sequence namespace, and
       * neither cursor moves the other. Unordered by construction, so this behaves
       * identically on either handle; it is here so a track carrying both channels needs
       * one subscription rather than two.
       */
      recvDatagram() {
        return ordered_.recvDatagram(this.#subscriber);
      }
    };
  }
});

// ../../node_modules/@moq/net/util/abort.js
async function untilAborted(promise, signal) {
  if (!signal)
    return promise;
  signal.throwIfAborted();
  const { promise: aborted3, reject } = Promise.withResolvers();
  const onAbort = () => reject(signal.reason);
  signal.addEventListener("abort", onAbort, { once: true });
  try {
    return await race([promise, aborted3]);
  } finally {
    signal.removeEventListener("abort", onAbort);
  }
}
var init_abort = __esm({
  "../../node_modules/@moq/net/util/abort.js"() {
    init_signals();
  }
});

// ../../node_modules/@moq/net/broadcast.js
var broadcast_exports = {};
__export(broadcast_exports, {
  Consumer: () => Consumer4,
  Producer: () => Producer4
});
function dequeueRequest(state) {
  const requested = state.requested.peek();
  requested.sort((a2, b3) => a2.priority - b3.priority);
  return requested.pop();
}
function closeState2(state, abort) {
  if (state.closed.peek() !== void 0)
    return;
  state.closed.set(abort ?? null);
  for (const request of state.pending)
    request.reject(abort);
  state.requested.mutate((requests) => {
    requests.length = 0;
  });
}
function subscribe(state, name, options = {}, register = false) {
  if (state.closed.peek() !== void 0) {
    throw new Error(`broadcast is closed: ${state.closed.peek()}`);
  }
  const existing = state.tracks.get(name);
  if (existing) {
    if (existing.closed.peek() === void 0)
      return existing.subscribe(options);
    state.tracks.delete(name);
  }
  const producer = new Producer3(name);
  const subscriber = producer.subscribe(options);
  if (register) {
    state.tracks.set(name, producer);
    void producer.closed.then(() => {
      if (state.tracks.get(name) === producer)
        state.tracks.delete(name);
    });
  }
  state.requested.mutate((requested) => {
    requested.push(hooks.makeRequest({ name, producer, sequences: state.sequences, pending: state.pending }));
  });
  return subscriber;
}
async function resolveTrackInfo(state, name) {
  const existing = state.tracks.get(name);
  if (existing && existing.closed.peek() === void 0) {
    return existing.info();
  }
  if (state.closed.peek() !== void 0) {
    return Promise.reject(new Error(`broadcast is closed: ${state.closed.peek()}`));
  }
  const producer = new Producer3(name);
  state.requested.mutate((requested) => {
    requested.push(hooks.makeRequest({ name, producer, sequences: state.sequences, pending: state.pending }));
  });
  try {
    return await producer.info();
  } finally {
    producer.close();
  }
}
async function fetchGroup(state, name, sequence, options = {}) {
  options.signal?.throwIfAborted();
  const subscriber = subscribe(state, name, { priority: options.priority });
  hooks.exemptFetch(subscriber);
  try {
    for (; ; ) {
      const group = await untilAborted(subscriber.recvGroup(), options.signal);
      if (!group)
        throw new NotFound(`group ${sequence}`);
      if (group.sequence === sequence) {
        void group.closed.then(() => subscriber.close());
        return group;
      }
      group.close();
      if (group.sequence > sequence)
        throw new NotFound(`group ${sequence}`);
    }
  } catch (err2) {
    subscriber.close();
    throw err2;
  }
}
var attachAnnouncer, stampProducer, BroadcastState, Producer4, makeConsumer3, Consumer4;
var init_broadcast = __esm({
  "../../node_modules/@moq/net/broadcast.js"() {
    init_signals();
    init_error2();
    init_hop();
    init_internal();
    init_path();
    init_track();
    init_abort();
    init_wire();
    BroadcastState = class {
      requested = new Signal([]);
      pending = /* @__PURE__ */ new Set();
      closed = new Once();
      tracks = /* @__PURE__ */ new Map();
      sequences = /* @__PURE__ */ new Map();
      // Live consumer handles sharing this state (see {@link Consumer.clone}). The broadcast
      // closes once the last one closes, so a shared consumer can be handed to several callers.
      consumers = 0;
    };
    Producer4 = class {
      #state = new BroadcastState();
      #announcer;
      #path = empty();
      constructor() {
        registerWire(this, this.#wire(false));
      }
      static {
        attachAnnouncer = (producer, announcer) => {
          producer.#announcer = announcer;
        };
        hooks.attachAnnouncer = attachAnnouncer;
        stampProducer = (producer, path) => {
          producer.#path = path;
        };
      }
      /**
       * Settles once the broadcast closes: `null` on a clean close, or the abort {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       */
      get closed() {
        return this.#state.closed;
      }
      /** A read handle for this broadcast, named by the path the origin created it at. */
      consume() {
        return makeConsumer3({ state: this.#state, path: this.#path });
      }
      async #requested() {
        for (; ; ) {
          const request = dequeueRequest(this.#state);
          if (request)
            return request;
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0)
            return void 0;
          await Signal.race(this.#state.requested, this.#state.closed);
        }
      }
      /** Insert a track that is served directly, without an on-demand request round-trip. */
      insertTrack(track) {
        if (this.#state.closed.peek() !== void 0) {
          throw new Error(`broadcast is closed: ${this.#state.closed.peek()}`);
        }
        const existing = this.#state.tracks.get(track.name);
        if (existing && existing.closed.peek() === void 0) {
          throw new Error(`duplicate track: ${track.name}`);
        }
        this.#state.tracks.set(track.name, track);
        void track.closed.then(() => {
          if (this.#state.tracks.get(track.name) === track) {
            this.#state.tracks.delete(track.name);
          }
        });
      }
      /** Create a track, insert it into the broadcast, and return its producer. */
      createTrack(name, info = {}) {
        const producer = new Producer3(name).accept(info);
        this.insertTrack(producer);
        return producer;
      }
      /** Remove a statically inserted track by name. */
      removeTrack(name) {
        this.#state.tracks.delete(name);
      }
      /** A lazy read handle for a track on this broadcast. */
      track(name) {
        return trackOf(name, this);
      }
      #wire(register) {
        return {
          subscribe: (name, options) => subscribe(this.#state, name, options, register),
          resolveTrackInfo: (name) => resolveTrackInfo(this.#state, name),
          fetchGroup: (name, sequence, options) => fetchGroup(this.#state, name, sequence, options),
          requested: () => this.#requested()
        };
      }
      /**
       * Advertise this broadcast's exact path, or re-price a standing advertisement in place.
       *
       * Call it once the tracks a subscriber needs first (a catalog) exist. Until then the
       * broadcast exists for nobody, on its own origin or at a peer. Retracts on
       * {@link unannounce} or {@link close}. Throws if this producer was not created through an
       * origin, or if the broadcast is already closed.
       */
      announce(route = Route.default) {
        if (this.#state.closed.peek() !== void 0) {
          throw new Error(`broadcast is closed: ${this.#state.closed.peek()}`);
        }
        if (!this.#announcer)
          throw new Error("broadcast is not attached to an origin");
        this.#announcer.announce(Route.normalize(route));
      }
      /**
       * Retract the advertisement of this broadcast's path, if any, from local consumers and
       * peers alike. {@link announce} brings it back.
       */
      unannounce() {
        this.#announcer?.unannounce();
      }
      close(abort) {
        this.#announcer?.unannounce();
        this.#announcer = void 0;
        closeState2(this.#state, abort);
      }
    };
    Consumer4 = class _Consumer {
      #state;
      #path;
      // Guards against a double close() on this handle over-decrementing the consumer count.
      #closed = false;
      constructor(shared2) {
        this.#state = shared2?.state ?? new BroadcastState();
        this.#path = shared2?.path ?? empty();
        this.#state.consumers++;
        registerWire(this, {
          subscribe: (name, options) => subscribe(this.#state, name, options, true),
          resolveTrackInfo: (name) => resolveTrackInfo(this.#state, name),
          fetchGroup: (name, sequence, options) => fetchGroup(this.#state, name, sequence, options),
          requested: () => this.#requested()
        });
      }
      static {
        makeConsumer3 = (shared2) => new _Consumer(shared2);
        hooks.stampPath = (target3, path) => {
          if (target3 instanceof _Consumer)
            target3.#path = path;
          else
            stampProducer(target3, path);
        };
      }
      /**
       * The path this handle names the broadcast by, which relative references in its catalog
       * (hang's `broadcast` field) resolve against.
       *
       * An origin stamps each handle it hands out with the path it was requested at, relative to
       * that origin handle's scope root, and a broadcast it created with the path it was created at.
       * Empty for a standalone broadcast, which is then its own root: any `..` reference escapes.
       */
      get path() {
        return this.#path;
      }
      /**
       * Settles once the broadcast closes: `null` on a clean close, or the abort {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       *
       * Shared by every {@link clone}: it settles once the last handle closes. The subscribing
       * wire layer peeks it to evict a closed entry from its per-path consume cache.
       */
      get closed() {
        return this.#state.closed;
      }
      /**
       * Return another handle to the same broadcast, reference-counted with this one.
       *
       * Both handles read the same tracks, carry the same {@link path}, and share one {@link closed}
       * state; the broadcast closes only once *every* handle has {@link close}d. Used by the connection's per-path
       * consume cache to share one subscription across callers. Subclasses that resolve info over
       * the wire override this to preserve their type (see the wire layer's consumed broadcast).
       */
      clone() {
        return new _Consumer(this.shareState());
      }
      // Hand this consumer's backing state and path to a clone. Opaque (`never`) so the state type
      // stays unexported; a subclass passes it straight back into its own `super(...)`.
      shareState() {
        return { state: this.#state, path: this.#path };
      }
      /** Get a lazy handle for a track on this broadcast. Repeat subscriptions dedupe onto one upstream subscription. */
      track(name) {
        return trackOf(name, this);
      }
      async #requested() {
        for (; ; ) {
          const request = dequeueRequest(this.#state);
          if (request)
            return request;
          const closed = this.#state.closed.peek();
          if (closed instanceof Error)
            throw closed;
          if (closed !== void 0)
            return void 0;
          await Signal.race(this.#state.requested, this.#state.closed);
        }
      }
      close(abort) {
        if (this.#closed)
          return;
        this.#closed = true;
        if (--this.#state.consumers > 0)
          return;
        closeState2(this.#state, abort);
      }
    };
  }
});

// ../../node_modules/async-mutex/index.mjs
function insertSorted(a2, v3) {
  const i2 = findIndexFromEnd(a2, (other) => v3.priority <= other.priority);
  a2.splice(i2 + 1, 0, v3);
}
function findIndexFromEnd(a2, predicate) {
  for (let i2 = a2.length - 1; i2 >= 0; i2--) {
    if (predicate(a2[i2])) {
      return i2;
    }
  }
  return -1;
}
var E_TIMEOUT, E_ALREADY_LOCKED, E_CANCELED, __awaiter$2, Semaphore, __awaiter$1, Mutex;
var init_async_mutex = __esm({
  "../../node_modules/async-mutex/index.mjs"() {
    E_TIMEOUT = new Error("timeout while waiting for mutex to become available");
    E_ALREADY_LOCKED = new Error("mutex already locked");
    E_CANCELED = new Error("request for lock canceled");
    __awaiter$2 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    Semaphore = class {
      constructor(_value, _cancelError = E_CANCELED) {
        this._value = _value;
        this._cancelError = _cancelError;
        this._queue = [];
        this._weightedWaiters = [];
      }
      acquire(weight = 1, priority = 0) {
        if (weight <= 0)
          throw new Error(`invalid weight ${weight}: must be positive`);
        return new Promise((resolve2, reject) => {
          const task = { resolve: resolve2, reject, weight, priority };
          const i2 = findIndexFromEnd(this._queue, (other) => priority <= other.priority);
          if (i2 === -1 && weight <= this._value) {
            this._dispatchItem(task);
          } else {
            this._queue.splice(i2 + 1, 0, task);
          }
        });
      }
      runExclusive(callback_1) {
        return __awaiter$2(this, arguments, void 0, function* (callback, weight = 1, priority = 0) {
          const [value, release] = yield this.acquire(weight, priority);
          try {
            return yield callback(value);
          } finally {
            release();
          }
        });
      }
      waitForUnlock(weight = 1, priority = 0) {
        if (weight <= 0)
          throw new Error(`invalid weight ${weight}: must be positive`);
        if (this._couldLockImmediately(weight, priority)) {
          return Promise.resolve();
        } else {
          return new Promise((resolve2) => {
            if (!this._weightedWaiters[weight - 1])
              this._weightedWaiters[weight - 1] = [];
            insertSorted(this._weightedWaiters[weight - 1], { resolve: resolve2, priority });
          });
        }
      }
      isLocked() {
        return this._value <= 0;
      }
      getValue() {
        return this._value;
      }
      setValue(value) {
        this._value = value;
        this._dispatchQueue();
      }
      release(weight = 1) {
        if (weight <= 0)
          throw new Error(`invalid weight ${weight}: must be positive`);
        this._value += weight;
        this._dispatchQueue();
      }
      cancel() {
        this._queue.forEach((entry) => entry.reject(this._cancelError));
        this._queue = [];
      }
      _dispatchQueue() {
        this._drainUnlockWaiters();
        while (this._queue.length > 0 && this._queue[0].weight <= this._value) {
          this._dispatchItem(this._queue.shift());
          this._drainUnlockWaiters();
        }
      }
      _dispatchItem(item) {
        const previousValue = this._value;
        this._value -= item.weight;
        item.resolve([previousValue, this._newReleaser(item.weight)]);
      }
      _newReleaser(weight) {
        let called = false;
        return () => {
          if (called)
            return;
          called = true;
          this.release(weight);
        };
      }
      _drainUnlockWaiters() {
        if (this._queue.length === 0) {
          for (let weight = this._value; weight > 0; weight--) {
            const waiters = this._weightedWaiters[weight - 1];
            if (!waiters)
              continue;
            waiters.forEach((waiter) => waiter.resolve());
            this._weightedWaiters[weight - 1] = [];
          }
        } else {
          const queuedPriority = this._queue[0].priority;
          for (let weight = this._value; weight > 0; weight--) {
            const waiters = this._weightedWaiters[weight - 1];
            if (!waiters)
              continue;
            const i2 = waiters.findIndex((waiter) => waiter.priority <= queuedPriority);
            (i2 === -1 ? waiters : waiters.splice(0, i2)).forEach(((waiter) => waiter.resolve()));
          }
        }
      }
      _couldLockImmediately(weight, priority) {
        return (this._queue.length === 0 || this._queue[0].priority < priority) && weight <= this._value;
      }
    };
    __awaiter$1 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    Mutex = class {
      constructor(cancelError) {
        this._semaphore = new Semaphore(1, cancelError);
      }
      acquire() {
        return __awaiter$1(this, arguments, void 0, function* (priority = 0) {
          const [, releaser] = yield this._semaphore.acquire(1, priority);
          return releaser;
        });
      }
      runExclusive(callback, priority = 0) {
        return this._semaphore.runExclusive(() => callback(), 1, priority);
      }
      isLocked() {
        return this._semaphore.isLocked();
      }
      waitForUnlock(priority = 0) {
        return this._semaphore.waitForUnlock(1, priority);
      }
      release() {
        if (this._semaphore.isLocked())
          this._semaphore.release();
      }
      cancel() {
        return this._semaphore.cancel();
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/version.js
function hasProbeRtt(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
      return false;
    default:
      return true;
  }
}
function hasSetupStream(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      return false;
    default:
      return true;
  }
}
function hasDatagrams(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      return false;
    default:
      return true;
  }
}
function hasAnnounceOk(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      return false;
    default:
      return true;
  }
}
function restartSupported(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      return false;
    default:
      return true;
  }
}
function hasAnnounceId(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
      return false;
    default:
      return true;
  }
}
function hasExcludeHop(version2) {
  switch (version2) {
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
      return true;
    default:
      return false;
  }
}
function hasRouteCost(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
      return false;
    default:
      return true;
  }
}
function hasFrameBounds(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
      return false;
    default:
      return true;
  }
}
function hasGroupOrder(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
      return true;
    default:
      return false;
  }
}
function resolvesStart(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
      return false;
    default:
      return true;
  }
}
function hasHidden(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
    case Version2.DRAFT_06:
      return false;
    default:
      return true;
  }
}
function hasStreamCount(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
    case Version2.DRAFT_06:
      return false;
    default:
      return true;
  }
}
function hasAnnounceCompression(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
    case Version2.DRAFT_06:
      return false;
    default:
      return true;
  }
}
function versionName2(v3) {
  return VERSION_NAMES2[v3] ?? `unknown(0x${v3.toString(16)})`;
}
var Version2, ALPN2, ALPN_03, ALPN_04, ALPN_05, ALPN_06, ALPN_07_WIP, VERSION_NAMES2;
var init_version2 = __esm({
  "../../node_modules/@moq/net/lite/version.js"() {
    Version2 = {
      DRAFT_01: 4279086337,
      DRAFT_02: 4279086338,
      DRAFT_03: 4279086339,
      DRAFT_04: 4279086340,
      DRAFT_05: 4279086341,
      /// Lite-06, advertised as the preferred WebTransport subprotocol.
      /// Adds announce ids: each active ANNOUNCE_BROADCAST implicitly assigns the next
      /// ordinal, and ended/restart reference that id instead of repeating the path.
      /// Also adds frame-precise subscribe/fetch bounds and a GROUP frame offset.
      DRAFT_06: 4279086342,
      /// Work-in-progress lite-07, only negotiated when explicitly offered.
      /// Adds the ANNOUNCE_REQUEST hidden opt-in.
      DRAFT_07: 4279086343
    };
    ALPN2 = "moql";
    ALPN_03 = "moq-lite-03";
    ALPN_04 = "moq-lite-04";
    ALPN_05 = "moq-lite-05";
    ALPN_06 = "moq-lite-06";
    ALPN_07_WIP = "moq-lite-07-wip";
    VERSION_NAMES2 = {
      [Version2.DRAFT_01]: "moq-lite-01",
      [Version2.DRAFT_02]: "moq-lite-02",
      [Version2.DRAFT_03]: "moq-lite-03",
      [Version2.DRAFT_04]: "moq-lite-04",
      [Version2.DRAFT_05]: "moq-lite-05",
      [Version2.DRAFT_06]: "moq-lite-06",
      [Version2.DRAFT_07]: "moq-lite-07-wip"
    };
  }
});

// ../../node_modules/@moq/net/util/u64.js
function toNumber(hi, lo) {
  if (hi >= SAFE_HI)
    throw new RangeError(`value larger than 53-bits: ${toBigInt(hi, lo)}`);
  return hi * POW32 + lo;
}
function toBigInt(hi, lo) {
  return hi === 0 ? BigInt(lo) : BigInt(hi) << 32n | BigInt(lo);
}
var POW32, SAFE_HI, U64;
var init_u64 = __esm({
  "../../node_modules/@moq/net/util/u64.js"() {
    POW32 = 4294967296;
    SAFE_HI = 2 ** 21;
    U64 = class _U64 {
      /** The value 0. */
      static ZERO = new _U64(0, 0);
      /** The largest value, 2^64 - 1. */
      static MAX = new _U64(POW32 - 1, POW32 - 1);
      /** The upper 32 bits. */
      hi;
      /** The lower 32 bits. */
      lo;
      /** Join the upper and lower 32 bits, throwing if either is not a u32. */
      constructor(hi, lo) {
        if (!Number.isInteger(hi) || hi < 0 || hi >= POW32)
          throw new RangeError(`invalid upper half: ${hi}`);
        if (!Number.isInteger(lo) || lo < 0 || lo >= POW32)
          throw new RangeError(`invalid lower half: ${lo}`);
        this.hi = hi;
        this.lo = lo;
      }
      /** Convert a non-negative safe integer, throwing on anything else. */
      static fromNumber(v3) {
        if (!Number.isSafeInteger(v3) || v3 < 0)
          throw new RangeError(`invalid u64: ${v3}`);
        return new _U64(Math.floor(v3 / POW32), v3 >>> 0);
      }
      /** Convert a bigint, throwing unless it is in [0, 2^64). */
      static fromBigInt(v3) {
        if (v3 < 0n || v3 >> 64n)
          throw new RangeError(`invalid u64: ${v3}`);
        return new _U64(Number(v3 >> 32n), Number(v3 & 0xffffffffn));
      }
      /** Convert to a `number`, throwing if it is above `Number.MAX_SAFE_INTEGER`. */
      toNumber() {
        return toNumber(this.hi, this.lo);
      }
      /** Convert to a bigint, exactly. */
      toBigInt() {
        return toBigInt(this.hi, this.lo);
      }
      /** The value in decimal. */
      toString() {
        return this.hi < SAFE_HI ? String(this.hi * POW32 + this.lo) : this.toBigInt().toString();
      }
      /** Negative if this is less than `other`, zero if equal, positive if greater. */
      compare(other) {
        return this.hi - other.hi || this.lo - other.lo;
      }
      /** Whether this equals `other`. */
      equals(other) {
        return this.hi === other.hi && this.lo === other.lo;
      }
      /** This plus a non-negative safe integer, throwing if the sum reaches 2^64. */
      add(delta) {
        if (!Number.isSafeInteger(delta) || delta < 0)
          throw new RangeError(`invalid delta: ${delta}`);
        const lo = this.lo + (delta >>> 0);
        const hi = this.hi + Math.floor(delta / POW32) + (lo >= POW32 ? 1 : 0);
        if (hi >= POW32)
          throw new RangeError(`overflow, ${this} + ${delta} exceeds 64 bits`);
        return new _U64(hi, lo >>> 0);
      }
    };
  }
});

// ../../node_modules/@moq/net/util/utf8.js
function decodeUtf8(buffer) {
  return decoder.decode(buffer);
}
var decoder;
var init_utf8 = __esm({
  "../../node_modules/@moq/net/util/utf8.js"() {
    decoder = new TextDecoder("utf-8", { fatal: true });
  }
});

// ../../node_modules/@moq/net/util/varint.js
function split(v3) {
  if (typeof v3 === "number") {
    if (!Number.isInteger(v3))
      throw new RangeError(`not an integer: ${v3}`);
    if (v3 < 0)
      throw new RangeError(`underflow, value is negative: ${v3}`);
    if (v3 >= POW32 * POW32)
      throw new RangeError(`value exceeds 64 bits: ${v3}`);
    parts2.hi = Math.floor(v3 / POW32);
    return v3 >>> 0;
  }
  if (v3 < 0n)
    throw new RangeError(`underflow, value is negative: ${v3}`);
  if (v3 >> 64n)
    throw new RangeError(`value exceeds 64 bits: ${v3}`);
  parts2.hi = Number(v3 >> 32n);
  return Number(v3 & 0xffffffffn);
}
function u32(buf, o) {
  return (buf[o] << 24 | buf[o + 1] << 16 | buf[o + 2] << 8 | buf[o + 3]) >>> 0;
}
function setU32(buf, o, v3) {
  buf[o] = v3 >>> 24;
  buf[o + 1] = v3 >>> 16;
  buf[o + 2] = v3 >>> 8;
  buf[o + 3] = v3;
}
function peekQuic(first) {
  return 1 << (first >> 6);
}
function readQuic(buf, o, size2) {
  const b3 = buf[o] & 63;
  if (size2 === 8) {
    parts2.hi = b3 << 24 | buf[o + 1] << 16 | buf[o + 2] << 8 | buf[o + 3];
    return u32(buf, o + 4);
  }
  parts2.hi = 0;
  if (size2 === 1)
    return b3;
  if (size2 === 2)
    return b3 << 8 | buf[o + 1];
  return b3 << 24 | buf[o + 1] << 16 | buf[o + 2] << 8 | buf[o + 3];
}
function lengthQuic(hi, lo) {
  if (hi === 0) {
    if (lo < 64)
      return 1;
    if (lo < 16384)
      return 2;
    if (lo < 1073741824)
      return 4;
  }
  if (hi >= 1073741824)
    throw new RangeError(`overflow, value larger than 62-bits: ${toBigInt(hi, lo)}`);
  return 8;
}
function writeQuic(dst, hi, lo, size2) {
  if (size2 === 1) {
    dst[0] = lo;
  } else if (size2 === 2) {
    dst[0] = 64 | lo >>> 8;
    dst[1] = lo;
  } else if (size2 === 4) {
    setU32(dst, 0, 2147483648 | lo);
  } else {
    setU32(dst, 0, 3221225472 | hi);
    setU32(dst, 4, lo);
  }
}
function peekLeadingOnes(first) {
  return Math.clz32(~(first << 24)) + 1;
}
function readLeadingOnes(buf, o, size2) {
  const b3 = buf[o];
  switch (size2) {
    case 1:
      parts2.hi = 0;
      return b3;
    case 2:
      parts2.hi = 0;
      return (b3 & 63) << 8 | buf[o + 1];
    case 3:
      parts2.hi = 0;
      return (b3 & 31) << 16 | buf[o + 1] << 8 | buf[o + 2];
    case 4:
      parts2.hi = 0;
      return (b3 & 15) << 24 | buf[o + 1] << 16 | buf[o + 2] << 8 | buf[o + 3];
    case 5:
      parts2.hi = b3 & 7;
      return u32(buf, o + 1);
    case 6:
      parts2.hi = (b3 & 3) << 8 | buf[o + 1];
      return u32(buf, o + 2);
    case 7:
      parts2.hi = (b3 & 1) << 16 | buf[o + 1] << 8 | buf[o + 2];
      return u32(buf, o + 3);
    case 8:
      parts2.hi = buf[o + 1] << 16 | buf[o + 2] << 8 | buf[o + 3];
      return u32(buf, o + 4);
    default:
      parts2.hi = u32(buf, o + 1);
      return u32(buf, o + 5);
  }
}
function lengthLeadingOnes(hi, lo) {
  if (hi === 0) {
    if (lo < 128)
      return 1;
    if (lo < 16384)
      return 2;
    if (lo < 2097152)
      return 3;
    if (lo < 268435456)
      return 4;
  }
  if (hi < 8)
    return 5;
  if (hi < 1024)
    return 6;
  if (hi < 16777216)
    return 8;
  return 9;
}
function writeLeadingOnes(dst, hi, lo, size2) {
  switch (size2) {
    case 1:
      dst[0] = lo;
      return;
    case 2:
      dst[0] = 128 | lo >>> 8;
      dst[1] = lo;
      return;
    case 3:
      dst[0] = 192 | lo >>> 16;
      dst[1] = lo >>> 8;
      dst[2] = lo;
      return;
    case 4:
      setU32(dst, 0, 3758096384 | lo);
      return;
    case 5:
      dst[0] = 240 | hi;
      setU32(dst, 1, lo);
      return;
    case 6:
      dst[0] = 248 | hi >>> 8;
      dst[1] = hi;
      setU32(dst, 2, lo);
      return;
    case 8:
      setU32(dst, 0, 4261412864 | hi);
      setU32(dst, 4, lo);
      return;
    default:
      dst[0] = 255;
      setU32(dst, 1, hi);
      setU32(dst, 5, lo);
  }
}
var parts2;
var init_varint = __esm({
  "../../node_modules/@moq/net/util/varint.js"() {
    init_u64();
    parts2 = { hi: 0 };
  }
});

// ../../node_modules/@moq/net/stream.js
function withCode(reason2, stream) {
  const version2 = asIetf(stream);
  const decoded = fromTransport(reason2, { version: version2 });
  const code = toStreamCode(decoded, { version: version2 });
  return code === StreamCode.Internal && decoded === reason2 ? reason2 : toTransport(code, decoded.message);
}
function sendOptions(options) {
  return { sendOrder: options?.sendOrder, waitUntilAvailable: options?.waitUntilAvailable ?? true };
}
async function openWithin(opening, timeout, discard) {
  try {
    return await withTimeout(opening, timeout, `stream open timed out after ${timeout}ms waiting for a slot`);
  } catch (err2) {
    opening.then(discard).catch(() => void 0);
    throw err2;
  }
}
function isLite(version2) {
  return LITE.has(version2);
}
function asIetf(version2) {
  return isLite(version2) ? void 0 : version2;
}
function isLeadingOnes(version2) {
  switch (version2) {
    case Version.DRAFT_14:
    case Version.DRAFT_15:
    case Version.DRAFT_16:
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
    case Version2.DRAFT_05:
    case Version2.DRAFT_06:
      return false;
    default:
      return true;
  }
}
function encodeTo(dst, hi, lo, version2) {
  let buf;
  if (isLeadingOnes(version2)) {
    buf = new Uint8Array(dst, 0, lengthLeadingOnes(hi, lo));
    writeLeadingOnes(buf, hi, lo, buf.length);
  } else {
    buf = new Uint8Array(dst, 0, lengthQuic(hi, lo));
    writeQuic(buf, hi, lo, buf.length);
  }
  return buf;
}
function encodeVarint(v3, version2) {
  const lo = split(v3);
  return encodeTo(new ArrayBuffer(9), parts2.hi, lo, version2);
}
function setUint8(dst, v3) {
  const buffer = new Uint8Array(dst, 0, 1);
  buffer[0] = v3;
  return buffer;
}
function setUint16(dst, v3) {
  const view = new DataView(dst, 0, 2);
  view.setUint16(0, v3);
  return new Uint8Array(view.buffer, view.byteOffset, view.byteLength);
}
function setInt32(dst, v3) {
  const view = new DataView(dst, 0, 4);
  view.setInt32(0, v3);
  return new Uint8Array(view.buffer, view.byteOffset, view.byteLength);
}
var MAX_U31, MAX_READ_SIZE, OPEN_TIMEOUT_MS, LITE, Stream2, Reader, UnexpectedEnd, Short, EMPTY, Cursor, STRING, BOOL, U8, U16, U53, U62, VARINT, Writer, Readers;
var init_stream = __esm({
  "../../node_modules/@moq/net/stream.js"() {
    init_signals();
    init_error2();
    init_version();
    init_version2();
    init_timeout();
    init_u64();
    init_utf8();
    init_varint();
    MAX_U31 = 2 ** 31 - 1;
    MAX_READ_SIZE = 1024 * 1024 * 64;
    OPEN_TIMEOUT_MS = 1e4;
    LITE = new Set(Object.values(Version2));
    Stream2 = class _Stream {
      reader;
      writer;
      constructor(props) {
        const version2 = props.version;
        const writer = props.writer ?? (props.writable && version2 !== void 0 && new Writer(props.writable, version2));
        const reader = props.reader ?? (props.readable && version2 !== void 0 && new Reader(props.readable, void 0, version2));
        if (!writer || !reader)
          throw new Error("stream needs both halves");
        this.writer = writer;
        this.reader = reader;
      }
      static async accept(quic, version2) {
        for (; ; ) {
          const reader = quic.incomingBidirectionalStreams.getReader();
          const next = await reader.read();
          reader.releaseLock();
          if (next.done)
            return;
          const { readable, writable } = next.value;
          return new _Stream({ readable, writable, version: version2 });
        }
      }
      /**
       * Open an outgoing bidirectional stream.
       * @param quic - The session to open it on
       * @param options - The version its varints encode with, and the send order ranking it
       *   against the session's other streams
       */
      static async open(quic, options) {
        const { readable, writable } = await openWithin(quic.createBidirectionalStream(sendOptions(options)), options?.timeout ?? OPEN_TIMEOUT_MS, (stream) => {
          void stream.writable.abort().catch(() => void 0);
          void stream.readable.cancel().catch(() => void 0);
        });
        return new _Stream({ readable, writable, version: options.version });
      }
      close() {
        this.writer.close();
        this.reader.stop(new Stream(StreamCode.Cancel, { message: "cancel" }));
      }
      abort(reason2) {
        this.writer.reset(reason2);
        this.reader.stop(reason2);
      }
    };
    Reader = class {
      // Contiguous unread bytes, followed by chunks not yet joined onto it. Joining only once a
      // read needs the bytes keeps a frame arriving in N chunks linear rather than quadratic.
      #buffer;
      #chunks = [];
      #chunked = 0;
      // bytes across #chunks
      #stream;
      // if undefined, the buffer is consumed then EOF
      #reader;
      #closed;
      // The decode that last ran short and how far, so a retry can wait for those bytes.
      #short;
      version;
      constructor(stream, buffer, version2) {
        this.#buffer = buffer ?? new Uint8Array();
        this.#stream = stream;
        this.#reader = this.#stream?.getReader();
        this.version = version2;
      }
      // Adds more data to the buffer, returning true if more data was added.
      async #fill() {
        if (!this.#reader) {
          return false;
        }
        const result = await this.#reader.read().catch((err2) => {
          throw fromTransport(err2, { version: asIetf(this.version) });
        });
        if (result.done) {
          return false;
        }
        if (result.value.byteLength === 0) {
          throw new Error("unexpected empty chunk");
        }
        this.#chunks.push(result.value);
        this.#chunked += result.value.byteLength;
        return true;
      }
      // Add more data to the buffer until it's at least size bytes.
      async #fillTo(size2) {
        if (size2 > MAX_READ_SIZE) {
          throw new Error(`read size ${size2} exceeds max size ${MAX_READ_SIZE}`);
        }
        if (this.#buffer.byteLength >= size2)
          return;
        while (this.#buffer.byteLength + this.#chunked < size2) {
          if (!await this.#fill()) {
            throw new UnexpectedEnd();
          }
        }
        this.#join();
      }
      // Move every pending chunk into the buffer, copying only when there's more than one piece.
      #join() {
        if (this.#chunks.length === 0)
          return;
        if (this.#buffer.byteLength === 0 && this.#chunks.length === 1) {
          this.#buffer = this.#chunks[0];
        } else {
          const joined = new Uint8Array(this.#buffer.byteLength + this.#chunked);
          joined.set(this.#buffer);
          let offset = this.#buffer.byteLength;
          for (const chunk of this.#chunks) {
            joined.set(chunk, offset);
            offset += chunk.byteLength;
          }
          this.#buffer = joined;
        }
        this.#chunks = [];
        this.#chunked = 0;
      }
      // Consumes the first size bytes of the buffer.
      #slice(size2) {
        const result = new Uint8Array(this.#buffer.buffer, this.#buffer.byteOffset, size2);
        this.#buffer = new Uint8Array(this.#buffer.buffer, this.#buffer.byteOffset + size2, this.#buffer.byteLength - size2);
        return result;
      }
      /**
       * Run a synchronous decode over the buffered bytes and consume what it read.
       *
       * Returns undefined and consumes nothing when the decode ran past the buffered bytes, so a
       * caller can drain every complete message already here without waiting on the stream.
       */
      tryDecode(decode11) {
        const result = this.#try(decode11);
        return result instanceof Short ? void 0 : result;
      }
      /** Run a synchronous decode, filling from the stream until it has the bytes it needs. */
      async decode(decode11) {
        for (; ; ) {
          const result = this.#try(decode11);
          if (!(result instanceof Short))
            return result;
          await this.#fillTo(result.need);
        }
      }
      // Like decode, but leaves the bytes buffered for the next read.
      async #peek(decode11) {
        for (; ; ) {
          const result = this.#try(decode11, false);
          if (!(result instanceof Short))
            return result;
          await this.#fillTo(result.need);
        }
      }
      /** Like {@link decode}, but returns undefined if the stream ends cleanly first. */
      async decodeMaybe(decode11) {
        if (await this.done())
          return void 0;
        return this.decode(decode11);
      }
      #try(decode11, consume = true) {
        const available = this.#buffer.byteLength + this.#chunked;
        if (available === 0)
          return EMPTY;
        if (decode11 === this.#short?.decode && available < this.#short.err.need)
          return this.#short.err;
        this.#join();
        const cursor = new Cursor(this.#buffer, this.version);
        try {
          const result = decode11(cursor);
          if (consume)
            this.#slice(cursor.offset);
          this.#short = void 0;
          return result;
        } catch (err2) {
          if (!(err2 instanceof Short))
            throw err2;
          if (err2.need <= this.#buffer.byteLength)
            throw new Error("decode ran short of bytes it already had");
          this.#short = { decode: decode11, err: err2 };
          return err2;
        }
      }
      async read(size2) {
        if (size2 === 0)
          return new Uint8Array();
        return this.decode((c2) => c2.read(size2));
      }
      async readAll() {
        while (await this.#fill()) {
        }
        this.#join();
        return this.#slice(this.#buffer.byteLength);
      }
      // Reads to the end of the stream, dropping every byte instead of buffering it.
      async discard() {
        this.#buffer = new Uint8Array();
        do {
          this.#chunks = [];
          this.#chunked = 0;
        } while (await this.#fill());
      }
      async string() {
        return this.decode(STRING);
      }
      async bool() {
        return this.decode(BOOL);
      }
      async u8() {
        return this.decode(U8);
      }
      async u16() {
        return this.decode(U16);
      }
      // Returns a Number using 53-bits, the max Javascript can use for integer math.
      async u53() {
        return this.decode(U53);
      }
      // NOTE: Returns a bigint instead of a number since it may be larger than 53-bits
      async u62() {
        return this.decode(U62);
      }
      /** Like {@link u62}, but leaves the varint buffered, so a stream's type can be read twice. */
      async peekU62() {
        return this.#peek(U62);
      }
      async varint() {
        return this.decode(VARINT);
      }
      // Returns false if there is more data to read, blocking if it hasn't been received yet.
      async done() {
        if (this.#buffer.byteLength > 0 || this.#chunked > 0)
          return false;
        return !await this.#fill();
      }
      stop(reason2) {
        this.#reader?.cancel(withCode(reason2, this.version)).catch(() => void 0);
      }
      // Decoded like #fill: a caller racing this against a read must not get a different error
      // shape depending on which one won. Derived once, so racing it per frame doesn't allocate.
      get closed() {
        this.#closed ??= (this.#reader?.closed ?? Promise.resolve()).catch((err2) => {
          throw fromTransport(err2, { version: asIetf(this.version) });
        });
        return this.#closed;
      }
    };
    UnexpectedEnd = class extends Error {
      constructor() {
        super("unexpected end of stream");
      }
    };
    Short = class {
      need;
      constructor(need) {
        this.need = need;
      }
    };
    EMPTY = new Short(1);
    Cursor = class _Cursor {
      version;
      #buffer;
      #offset = 0;
      // Resolved once, since every varint read branches on it.
      #leadingOnes;
      // First bytes below this are a whole 1-byte varint, and below this + 0x40 a 2-byte one whose
      // value is the low 6 bits and the next byte. Both formats share that shape; only the bound moves.
      #short;
      // First bytes below this are a varint of at most 4 bytes: 0xc0 for QUIC, 0xf0 for leading-ones.
      #word;
      constructor(buffer, version2) {
        this.#buffer = buffer;
        this.version = version2;
        this.#leadingOnes = isLeadingOnes(version2);
        this.#short = this.#leadingOnes ? 128 : 64;
        this.#word = this.#leadingOnes ? 240 : 192;
      }
      /** How many bytes have been read. */
      get offset() {
        return this.#offset;
      }
      /** How many buffered bytes are left to read. */
      get remaining() {
        return this.#buffer.byteLength - this.#offset;
      }
      /**
       * Decode the next `size` bytes on their own. Running past them, or leaving any unread, is
       * malformed rather than a reason to wait for more.
       */
      exact(size2, decode11) {
        const inner = new _Cursor(this.read(size2), this.version);
        let result;
        try {
          result = decode11(inner);
        } catch (err2) {
          if (err2 instanceof Short)
            throw new Error(`message is shorter than its fields: ${size2} bytes`);
          throw err2;
        }
        if (inner.remaining > 0)
          throw new Error(`message has ${inner.remaining} unread bytes`);
        return result;
      }
      #ensure(size2) {
        const need = this.#offset + size2;
        if (need > MAX_READ_SIZE)
          throw new Error(`read size ${need} exceeds max size ${MAX_READ_SIZE}`);
        if (need > this.#buffer.byteLength)
          throw new Short(need);
      }
      /** Read `size` bytes, as a view onto the buffer rather than a copy. */
      read(size2) {
        this.#ensure(size2);
        const start = this.#offset;
        this.#offset += size2;
        return this.#buffer.subarray(start, this.#offset);
      }
      string() {
        return decodeUtf8(this.read(this.u53()));
      }
      bool() {
        const v3 = this.u8();
        if (v3 === 0)
          return false;
        if (v3 === 1)
          return true;
        throw new Error("invalid bool value");
      }
      u8() {
        this.#ensure(1);
        return this.#buffer[this.#offset++];
      }
      u16() {
        this.#ensure(2);
        const b3 = this.#buffer;
        const o = this.#offset;
        this.#offset += 2;
        return b3[o] << 8 | b3[o + 1];
      }
      /** Read a varint as a `number`, throwing if it is above `Number.MAX_SAFE_INTEGER`. */
      u53() {
        this.#ensure(1);
        const b3 = this.#buffer;
        const o = this.#offset;
        const first = b3[o];
        if (first < this.#short) {
          this.#offset = o + 1;
          return first;
        }
        if (first < this.#short + 64) {
          this.#ensure(2);
          this.#offset = o + 2;
          return (first & 63) << 8 | b3[o + 1];
        }
        if (first < this.#word) {
          const size2 = this.#leadingOnes ? peekLeadingOnes(first) : 4;
          this.#ensure(size2);
          this.#offset = o + size2;
          if (size2 === 3)
            return (first & 31) << 16 | b3[o + 1] << 8 | b3[o + 2];
          return (first & (this.#leadingOnes ? 15 : 63)) << 24 | b3[o + 1] << 16 | b3[o + 2] << 8 | b3[o + 3];
        }
        const lo = this.#varint();
        return toNumber(parts2.hi, lo);
      }
      /** Read a varint as a bigint. A leading-ones varint may exceed 62 bits. */
      u62() {
        const lo = this.#varint();
        return toBigInt(parts2.hi, lo);
      }
      /** Read a varint. */
      varint() {
        const lo = this.#varint();
        return new U64(parts2.hi, lo);
      }
      // Decode the next varint in the version's format, returning its lower half and leaving the upper in `parts`.
      #varint() {
        this.#ensure(1);
        const b3 = this.#buffer;
        const o = this.#offset;
        let size2;
        if (this.#leadingOnes) {
          size2 = peekLeadingOnes(b3[o]);
          if (size2 === 7 && this.version === Version.DRAFT_17) {
            throw new Error("invalid leading-ones varint: 1111110x prefix is reserved on draft-17");
          }
          this.#ensure(size2);
          this.#offset += size2;
          return readLeadingOnes(b3, o, size2);
        }
        size2 = peekQuic(b3[o]);
        this.#ensure(size2);
        this.#offset += size2;
        return readQuic(b3, o, size2);
      }
    };
    STRING = (c2) => c2.string();
    BOOL = (c2) => c2.bool();
    U8 = (c2) => c2.u8();
    U16 = (c2) => c2.u16();
    U53 = (c2) => c2.u53();
    U62 = (c2) => c2.u62();
    VARINT = (c2) => c2.varint();
    Writer = class _Writer {
      #writer;
      #stream;
      #closed;
      // Scratch buffer for each primitive write, sized for the longest (a 9-byte leading-ones varint).
      #scratch;
      version;
      constructor(stream, version2) {
        this.#stream = stream;
        this.#scratch = new ArrayBuffer(9);
        this.#writer = this.#stream.getWriter();
        this.version = version2;
      }
      /**
       * Rank this stream against the session's others, where HIGHER values are sent first.
       *
       * A send order only schedules the local end, so a stream the peer opened has to be ranked
       * here rather than at the peer's {@link open}.
       *
       * The spec makes `sendOrder` a settable attribute on every {@link SendStream}. Where the
       * interface isn't implemented (Chrome as of writing, a mock, a polyfill) this just sets an
       * ignored property, the same way an ignored `sendOrder` option does at {@link open}.
       */
      setPriority(sendOrder2) {
        this.#stream.sendOrder = sendOrder2;
      }
      async bool(v3) {
        await this.write(setUint8(this.#scratch, v3 ? 1 : 0));
      }
      async u8(v3) {
        if (!Number.isInteger(v3) || v3 < 0 || v3 > 255) {
          throw new RangeError(`invalid u8: ${v3}`);
        }
        await this.write(setUint8(this.#scratch, v3));
      }
      async u16(v3) {
        await this.write(setUint16(this.#scratch, v3));
      }
      async i32(v3) {
        if (Math.abs(v3) > MAX_U31) {
          throw new Error(`overflow, value larger than 32-bits: ${v3.toString()}`);
        }
        await this.write(setInt32(this.#scratch, v3));
      }
      async u53(v3) {
        if (!Number.isSafeInteger(v3) || v3 < 0) {
          throw new RangeError(`invalid u53: ${v3}`);
        }
        await this.#varint(Math.floor(v3 / POW32), v3 >>> 0);
      }
      async u62(v3) {
        const lo = split(v3);
        await this.#varint(parts2.hi, lo);
      }
      async varint(v3) {
        await this.#varint(v3.hi, v3.lo);
      }
      #varint(hi, lo) {
        return this.write(encodeTo(this.#scratch, hi, lo, this.version));
      }
      async write(v3) {
        await this.#writer.write(v3).catch((err2) => {
          throw fromTransport(err2, { version: asIetf(this.version) });
        });
      }
      async string(str) {
        const data = new TextEncoder().encode(str);
        await this.u53(data.byteLength);
        await this.write(data);
      }
      close() {
        this.#writer.close().catch(() => void 0);
      }
      // Mirrors Reader.closed: a STOP_SENDING reaches a caller racing this with the same
      // typed code it would get from a write.
      get closed() {
        this.#closed ??= this.#writer.closed.catch((err2) => {
          throw fromTransport(err2, { version: asIetf(this.version) });
        });
        return this.#closed;
      }
      reset(reason2) {
        this.#writer.abort(withCode(reason2, this.version)).catch(() => void 0);
      }
      /**
       * Open an outgoing unidirectional stream.
       * @param quic - The session to open it on
       * @param options - The version its varints encode with, and the send order ranking it
       *   against the session's other streams
       */
      static async open(quic, options) {
        const writable = await openWithin(quic.createUnidirectionalStream(sendOptions(options)), options?.timeout ?? OPEN_TIMEOUT_MS, (stream) => void stream.abort().catch(() => void 0));
        return new _Writer(writable, options.version);
      }
      /**
       * Like {@link Writer.open}, but gives up when `cancel` settles or `timeout` elapses,
       * returning undefined so the caller can drop whatever it meant to send. A stream that
       * opens after that is reset rather than leaked. A real transport failure still throws.
       *
       * Worth using even with `waitUntilAvailable: false`, since an implementation may park
       * an over-limit open instead of rejecting it.
       */
      static async tryOpen(quic, options) {
        const open = _Writer.open(quic, options);
        const abandon = () => {
          const abandoned = new Error("abandoned waiting for a stream slot");
          open.then((w4) => w4.reset(abandoned)).catch(() => void 0);
        };
        try {
          const stream = await race([options.cancel, open]);
          if (stream)
            return stream;
        } catch (err2) {
          if (err2 instanceof TimeoutError)
            return void 0;
          abandon();
          throw err2;
        }
        abandon();
        return void 0;
      }
    };
    Readers = class {
      #reader;
      #version;
      constructor(quic, version2) {
        this.#reader = quic.incomingUnidirectionalStreams.getReader();
        this.#version = version2;
      }
      async next() {
        const next = await this.#reader.read();
        if (next.done)
          return;
        return new Reader(next.value, void 0, this.#version);
      }
      close() {
        this.#reader.cancel();
      }
    };
  }
});

// ../../node_modules/@moq/net/varint.js
var varint_exports = {};
__export(varint_exports, {
  MAX_U14: () => MAX_U14,
  MAX_U30: () => MAX_U30,
  MAX_U53: () => MAX_U53,
  MAX_U6: () => MAX_U6,
  decode: () => decode3,
  decodeBigInt: () => decodeBigInt,
  decodeLeadingOnes: () => decodeLeadingOnes,
  encode: () => encode3,
  encodeLeadingOnes: () => encodeLeadingOnes,
  encodeLeadingOnesTo: () => encodeLeadingOnesTo,
  encodeTo: () => encodeTo2,
  size: () => size,
  sizeLeadingOnes: () => sizeLeadingOnes
});
function sizeOf(buf, size2) {
  if (buf.length === 0)
    throw new Error("buffer is empty");
  const n2 = size2(buf[0]);
  if (buf.length < n2)
    throw new Error(`buffer too short: need ${n2} bytes, have ${buf.length}`);
  return n2;
}
function sizeLeadingOnes(v3) {
  const lo = split(v3);
  return lengthLeadingOnes(parts2.hi, lo);
}
function encodeLeadingOnesTo(dst, v3) {
  const lo = split(v3);
  const buf = new Uint8Array(dst, 0, lengthLeadingOnes(parts2.hi, lo));
  writeLeadingOnes(buf, parts2.hi, lo, buf.length);
  return buf;
}
function encodeLeadingOnes(v3) {
  return encodeLeadingOnesTo(new ArrayBuffer(9), v3);
}
function decodeLeadingOnes(buf) {
  const size2 = sizeOf(buf, peekLeadingOnes);
  const lo = readLeadingOnes(buf, 0, size2);
  return [toBigInt(parts2.hi, lo), buf.subarray(size2)];
}
function size(v3) {
  if (v3 <= MAX_U6)
    return 1;
  if (v3 <= MAX_U14)
    return 2;
  if (v3 <= MAX_U30)
    return 4;
  if (v3 <= MAX_U53)
    return 8;
  throw new Error(`overflow, value larger than 53-bits: ${v3}`);
}
function encodeTo2(dst, v3) {
  const lo = split(v3);
  const buf = new Uint8Array(dst, 0, lengthQuic(parts2.hi, lo));
  writeQuic(buf, parts2.hi, lo, buf.length);
  return buf;
}
function encode3(v3) {
  return encodeTo2(new ArrayBuffer(8), v3);
}
function decodeBigInt(buf) {
  const size2 = sizeOf(buf, peekQuic);
  const lo = readQuic(buf, 0, size2);
  return [toBigInt(parts2.hi, lo), buf.subarray(size2)];
}
function decode3(buf) {
  const size2 = sizeOf(buf, peekQuic);
  const lo = readQuic(buf, 0, size2);
  return [toNumber(parts2.hi, lo), buf.subarray(size2)];
}
var MAX_U6, MAX_U14, MAX_U30, MAX_U53;
var init_varint2 = __esm({
  "../../node_modules/@moq/net/varint.js"() {
    init_u64();
    init_varint();
    MAX_U6 = 2 ** 6 - 1;
    MAX_U14 = 2 ** 14 - 1;
    MAX_U30 = 2 ** 30 - 1;
    MAX_U53 = Number.MAX_SAFE_INTEGER;
  }
});

// ../../node_modules/@moq/net/ietf/message.js
async function encode4(writer, f3) {
  let scratch = new Uint8Array();
  const temp = new Writer(new WritableStream({
    write(chunk) {
      const needed = scratch.byteLength + chunk.byteLength;
      if (needed > scratch.buffer.byteLength) {
        const capacity = Math.max(needed, scratch.buffer.byteLength * 2);
        const newBuffer = new ArrayBuffer(capacity);
        const newScratch = new Uint8Array(newBuffer, 0, needed);
        newScratch.set(scratch);
        newScratch.set(chunk, scratch.byteLength);
        scratch = newScratch;
      } else {
        scratch = new Uint8Array(scratch.buffer, 0, needed);
        scratch.set(chunk, needed - chunk.byteLength);
      }
    }
  }), writer.version);
  try {
    await f3(temp);
  } finally {
    temp.close();
  }
  await temp.closed;
  if (scratch.byteLength > 65535) {
    throw new Error(`Message too large: ${scratch.byteLength} bytes (max 65535)`);
  }
  await writer.u16(scratch.byteLength);
  await writer.write(scratch);
}
async function decode4(reader, f3) {
  const size2 = await reader.u16();
  const data = await reader.read(size2);
  const limit = new Reader(void 0, data, reader.version);
  const msg = await f3(limit);
  if (!await limit.done()) {
    throw new Error("Message decoding consumed too few bytes");
  }
  return msg;
}
var init_message = __esm({
  "../../node_modules/@moq/net/ietf/message.js"() {
    init_stream();
  }
});

// ../../node_modules/@moq/net/ietf/goaway.js
var GoAway;
var init_goaway = __esm({
  "../../node_modules/@moq/net/ietf/goaway.js"() {
    init_stream();
    init_time();
    init_message();
    init_version();
    GoAway = class _GoAway {
      static id = 16;
      newSessionUri;
      timeout;
      constructor({ newSessionUri, timeout = 0n }) {
        this.newSessionUri = newSessionUri;
        this.timeout = timeout;
      }
      async #encode(w4, version2) {
        await w4.string(this.newSessionUri);
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16) {
          await w4.u62(this.timeout);
        }
        if (version2 === Version.DRAFT_18) {
          await w4.u62(0n);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _GoAway.#decode(mr, version2));
      }
      /**
       * Decode a body the caller already unframed, as the draft-14 to -16 control stream
       * adapter does before routing a message.
       */
      static async decodeBody(body, version2) {
        const r2 = new Reader(void 0, body, version2);
        const msg = await _GoAway.#decode(r2, version2);
        if (!await r2.done())
          throw new Error("GOAWAY has trailing bytes");
        return msg;
      }
      /** The drain signal this message carries. A zero timeout is the wire saying "none". */
      drain() {
        return {
          uri: this.newSessionUri,
          timeout: this.timeout > 0n ? Milli(Number(this.timeout)) : void 0
        };
      }
      static async #decode(r2, version2) {
        const newSessionUri = await r2.string();
        if (new TextEncoder().encode(newSessionUri).byteLength > 8192) {
          throw new Error("GOAWAY new session URI exceeds 8,192 bytes");
        }
        let timeout = 0n;
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16) {
          timeout = await r2.u62();
        }
        if (version2 === Version.DRAFT_18) {
          await r2.readAll();
        }
        return new _GoAway({ newSessionUri, timeout });
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/namespace.js
function toTuple(namespace) {
  if (namespace === "")
    return [];
  const parts3 = [""];
  for (let i2 = 0; i2 < namespace.length; i2++) {
    const ch = namespace[i2];
    if (ch === "/") {
      parts3.push("");
    } else if (ch === "\\" && (namespace[i2 + 1] === "/" || namespace[i2 + 1] === "\\")) {
      parts3[parts3.length - 1] += namespace[++i2];
    } else {
      parts3[parts3.length - 1] += ch;
    }
  }
  return parts3;
}
function fromTuple(parts3) {
  return parts3.map((part) => part.replaceAll("\\", "\\\\").replaceAll("/", "\\/")).join("/");
}
async function encode5(w4, namespace) {
  const parts3 = toTuple(namespace);
  if (parts3.length > MAX_PARTS) {
    throw new Error(`namespace exceeds ${MAX_PARTS} parts`);
  }
  await w4.u53(parts3.length);
  for (const part of parts3) {
    await w4.string(part);
  }
}
async function decode5(r2) {
  const count2 = await r2.u53();
  if (count2 > MAX_PARTS) {
    throw new Error(`namespace exceeds ${MAX_PARTS} parts`);
  }
  const parts3 = [];
  for (let i2 = 0; i2 < count2; i2++) {
    parts3.push(await r2.string());
  }
  return fromTuple(parts3);
}
var init_namespace = __esm({
  "../../node_modules/@moq/net/ietf/namespace.js"() {
    init_path();
  }
});

// ../../node_modules/@moq/net/ietf/adapter.js
var NativeSession, Route2, ControlStreamAdapter;
var init_adapter = __esm({
  "../../node_modules/@moq/net/ietf/adapter.js"() {
    init_signals();
    init_async_mutex();
    init_error2();
    init_stream();
    init_varint2();
    init_goaway();
    init_namespace();
    init_version();
    NativeSession = class {
      #quic;
      // moq-transport reserves even request IDs for the client and odd for the server,
      // so the two peers' ID spaces never overlap.
      #requestId;
      version;
      constructor(quic, version2, client) {
        this.#quic = quic;
        this.version = version2;
        this.#requestId = client ? 0n : 1n;
      }
      async openBi() {
        return Stream2.open(this.#quic, { version: this.version });
      }
      async acceptBi() {
        return Stream2.accept(this.#quic, this.version);
      }
      async nextRequestId() {
        const id = this.#requestId;
        this.#requestId += 2n;
        return id;
      }
      /** Closes the underlying WebTransport session. */
      close() {
        this.#quic.close();
      }
    };
    Route2 = {
      NewRequest: 0,
      // Create virtual bidi stream, push initial message
      Response: 1,
      // Push message to existing stream (keep open)
      ErrorResponse: 2,
      // Push a final message to existing stream, then close
      CloseStream: 3,
      // Close stream recv (no bytes pushed)
      FollowUp: 4,
      // Push follow-up message to existing stream
      MaxRequestId: 5,
      // Update flow control
      Ignore: 6,
      // Connection-level, no routing
      GoAway: 7
      // Terminal
    };
    ControlStreamAdapter = class {
      // WebTransport session (for opening real bidi streams in v16)
      #quic;
      // Control stream
      #reader;
      #writer;
      #writeMutex = new Mutex();
      version;
      /** The peer's GOAWAY, which draft-14 to -16 carry on the shared control stream. */
      goaway = new Once();
      // Virtual streams keyed by requestId
      #streams = /* @__PURE__ */ new Map();
      // Namespace → requestId reverse lookups for v14/v15 namespace-keyed messages.
      // DONE names an incoming announcement and CANCEL names an outgoing one, so a relay
      // may legitimately hold the same namespace in both maps at once.
      #incomingNamespaces = /* @__PURE__ */ new Map();
      #outgoingNamespaces = /* @__PURE__ */ new Map();
      // requestId → namespace reverse lookup, one entry per request including a refused
      // duplicate, so #forget can clean up whichever request goes away.
      #namespacesByRequestId = /* @__PURE__ */ new Map();
      // SubscribeNamespace requestIds — for routing 0x08/0x0E entries that lack requestId (v14/v15)
      #subscribeNamespaces = /* @__PURE__ */ new Set();
      // Incoming stream queue (for acceptBi)
      #incomingQueue = [];
      #incomingWaiters = [];
      // Request ID flow control. moq-transport reserves even request IDs for the
      // client and odd for the server, so the two peers' ID spaces never overlap.
      // This matters here because a single `#streams` map routes every request by
      // ID: overlapping spaces would let an inbound request clobber the routing
      // entry of an outbound one with the same number (e.g. an inbound
      // PUBLISH_NAMESPACE stealing a pending SUBSCRIBE's slot, so SUBSCRIBE_OK is
      // delivered to the wrong virtual stream).
      #requestId;
      #maxRequestId;
      #maxRequestIdResolves = [];
      #closed = false;
      // Whether this side opened the session. Only a server may name a redirect.
      #client;
      constructor(quic, controlStream, version2, maxRequestId, client) {
        this.#quic = quic;
        this.#reader = controlStream.reader;
        this.#reader.version = version2;
        this.#writer = controlStream.writer;
        this.#writer.version = version2;
        this.version = version2;
        this.#maxRequestId = maxRequestId;
        this.#requestId = client ? 0n : 1n;
        this.#client = client;
      }
      /**
       * Accept the next incoming virtual bidi stream.
       * Blocks until a new request arrives on the control stream.
       */
      async acceptBi() {
        if (this.#closed)
          return void 0;
        const queued = this.#incomingQueue.shift();
        if (queued)
          return queued;
        return new Promise((resolve2) => {
          this.#incomingWaiters.push(resolve2);
        });
      }
      /**
       * Open an outgoing virtual bidi stream.
       * Buffers writes until the first full message is available, parses the
       * requestId (and namespace for PublishNamespace), self-registers, then
       * flushes. Subsequent writes go directly to the control stream.
       */
      openBi() {
        let controller;
        let registeredRequestId;
        const readable = new ReadableStream({
          start(c2) {
            controller = c2;
          },
          cancel: () => {
            if (registeredRequestId !== void 0) {
              this.#forget(registeredRequestId);
            }
          }
        });
        let buffer = new Uint8Array(0);
        let registered = false;
        const sendWritable = new WritableStream({
          write: async (chunk) => {
            const newBuf = new Uint8Array(buffer.length + chunk.length);
            newBuf.set(buffer);
            newBuf.set(chunk, buffer.length);
            buffer = newBuf;
            for (; ; ) {
              const boundary = this.#messageSize(buffer);
              if (boundary === void 0)
                break;
              const toFlush = buffer.subarray(0, boundary);
              buffer = buffer.subarray(boundary);
              if (!registered) {
                const parsed = await this.#tryParseOutgoing(toFlush);
                if (parsed) {
                  registeredRequestId = parsed.requestId;
                  this.#streams.set(parsed.requestId, { controller });
                  registered = true;
                }
              }
              await this.#writeMutex.runExclusive(() => this.#writer.write(toFlush));
            }
          }
        });
        const stream = new Stream2({ readable, writable: sendWritable, version: this.version });
        return stream;
      }
      /**
       * Open a real WebTransport bidi stream (for v16 SubscribeNamespace).
       */
      async openNativeBi() {
        return Stream2.open(this.#quic, { version: this.version });
      }
      /**
       * Allocate the next request ID, blocking if flow control limit reached.
       */
      async nextRequestId() {
        for (; ; ) {
          if (this.#closed)
            return void 0;
          const id = this.#requestId;
          if (id < this.#maxRequestId) {
            this.#requestId += 2n;
            return id;
          }
          await new Promise((resolve2) => {
            this.#maxRequestIdResolves.push(resolve2);
          });
        }
      }
      /**
       * Main run loop — reads control stream messages and routes to virtual streams.
       * Must be called after construction. Runs until the control stream closes.
       */
      async run() {
        let cause;
        try {
          if (this.version === Version.DRAFT_16) {
            void this.#acceptNativeBidis();
          }
          for (; ; ) {
            const done = await this.#reader.done();
            if (done) {
              cause = new ProtocolViolation("control stream closed");
              break;
            }
            const typeId = await this.#reader.u53();
            const size2 = await this.#reader.u16();
            const body = await this.#reader.read(size2);
            const classified = await this.#classify(typeId, body);
            if (classified.route === Route2.GoAway) {
              const msg = await GoAway.decodeBody(body, this.version);
              if (this.goaway.peek() !== void 0)
                throw new ProtocolViolation("duplicate GOAWAY");
              if (!this.#client && msg.newSessionUri !== "") {
                throw new ProtocolViolation("client GOAWAY must not name a redirect");
              }
              this.goaway.set(msg.drain());
              continue;
            }
            const { route, requestId } = classified;
            switch (route) {
              case Route2.NewRequest:
                this.#newRequest(typeId, size2, body, requestId);
                break;
              case Route2.Response:
                this.#pushMessage(requestId, typeId, size2, body);
                break;
              case Route2.ErrorResponse:
                this.#pushMessage(requestId, typeId, size2, body);
                this.#closeStream(requestId);
                break;
              case Route2.CloseStream:
                this.#closeStream(requestId);
                break;
              case Route2.FollowUp:
                this.#pushMessage(requestId, typeId, size2, body);
                break;
              case Route2.MaxRequestId:
                this.#maxRequestId = requestId;
                for (const resolve2 of this.#maxRequestIdResolves)
                  resolve2();
                this.#maxRequestIdResolves = [];
                break;
            }
          }
        } catch (err2) {
          cause = error(err2);
          throw err2;
        } finally {
          this.close(cause);
        }
      }
      /** Accept real WebTransport bidi streams and queue them for acceptBi (v16). */
      async #acceptNativeBidis() {
        try {
          for (; ; ) {
            const stream = await Stream2.accept(this.#quic, this.version);
            if (!stream)
              break;
            const waiter = this.#incomingWaiters.shift();
            if (waiter) {
              waiter(stream);
            } else {
              this.#incomingQueue.push(stream);
            }
          }
        } catch {
        }
      }
      #newRequest(typeId, size2, body, requestId) {
        let controller;
        const readable = new ReadableStream({
          start(c2) {
            controller = c2;
          },
          cancel: () => {
            this.#forget(requestId);
          }
        });
        const sendWritable = this.#createSendWritable();
        const stream = new Stream2({ readable, writable: sendWritable, version: this.version });
        this.#streams.set(requestId, { controller });
        controller.enqueue(this.#encodeRaw(typeId, size2, body));
        const waiter = this.#incomingWaiters.shift();
        if (waiter) {
          waiter(stream);
        } else {
          this.#incomingQueue.push(stream);
        }
      }
      #pushMessage(requestId, typeId, size2, body) {
        const entry = this.#streams.get(requestId);
        if (!entry) {
          console.warn(`adapter: no stream for requestId=${requestId} typeId=0x${typeId.toString(16)}`);
          return;
        }
        try {
          entry.controller.enqueue(this.#encodeRaw(typeId, size2, body));
        } catch {
        }
      }
      #closeStream(requestId) {
        const entry = this.#streams.get(requestId);
        this.#forget(requestId);
        if (!entry)
          return;
        console.debug(`adapter: closing stream requestId=${requestId}`);
        try {
          entry.controller.close();
        } catch {
        }
      }
      /**
       * Drop every routing entry a request owns, keeping the two namespace maps in step.
       *
       * Runs even when the virtual stream is already gone, so a request that was torn down
       * locally still gives its namespace back.
       */
      #forget(requestId) {
        this.#streams.delete(requestId);
        this.#subscribeNamespaces.delete(requestId);
        const registered = this.#namespacesByRequestId.get(requestId);
        if (registered === void 0)
          return;
        this.#namespacesByRequestId.delete(requestId);
        const namespaces = this.#namespaceRequests(registered.direction);
        if (namespaces.get(registered.namespace) === requestId)
          namespaces.delete(registered.namespace);
      }
      /**
       * Returns the total byte size of the first complete message in buffer,
       * or undefined if the buffer doesn't contain a complete message yet.
       * Message format: [typeId varint][size u16 BE][body of `size` bytes]
       */
      #messageSize(buffer) {
        if (buffer.length === 0)
          return void 0;
        const typeSize = 1 << ((buffer[0] & 192) >> 6);
        if (buffer.length < typeSize)
          return void 0;
        const [, afterType] = decode3(buffer);
        if (afterType.length < 2)
          return void 0;
        const size2 = afterType[0] << 8 | afterType[1];
        const totalSize = buffer.length - afterType.length + 2 + size2;
        if (buffer.length < totalSize)
          return void 0;
        return totalSize;
      }
      /**
       * Try to parse the first outgoing message from accumulated bytes.
       * Returns the requestId if enough data is available, undefined otherwise.
       */
      async #tryParseOutgoing(buffer) {
        if (buffer.length === 0)
          return void 0;
        const typeSize = 1 << ((buffer[0] & 192) >> 6);
        if (buffer.length < typeSize)
          return void 0;
        const [typeId, afterType] = decode3(buffer);
        if (afterType.length < 2)
          return void 0;
        const size2 = afterType[0] << 8 | afterType[1];
        const bodyStart = afterType.subarray(2);
        if (bodyStart.length < size2)
          return void 0;
        const body = bodyStart.subarray(0, size2);
        const [reqId] = decode3(body);
        const requestId = BigInt(reqId);
        if (typeId === 6) {
          try {
            await this.#registerNamespace(body, "outgoing");
          } catch {
          }
        }
        if (typeId === 17) {
          this.#subscribeNamespaces.add(requestId);
        }
        return { requestId };
      }
      /**
       * Decode a PublishNamespace body and register its namespace for the v14/v15
       * namespace-keyed withdrawals. Returns the request ID it carried.
       *
       * The one decode site for both directions: outgoing announcements go through
       * #tryParseOutgoing and incoming ones through #classify. The direction selects the
       * map that the peer's DONE or CANCEL will later consult.
       */
      async #registerNamespace(body, direction) {
        const r2 = new Reader(void 0, body, this.version);
        const requestId = await r2.u62();
        const namespace = await decode5(r2);
        const namespaces = this.#namespaceRequests(direction);
        this.#namespacesByRequestId.set(requestId, { namespace, direction });
        if (!namespaces.has(namespace))
          namespaces.set(namespace, requestId);
        return requestId;
      }
      #namespaceRequests(direction) {
        return direction === "incoming" ? this.#incomingNamespaces : this.#outgoingNamespaces;
      }
      /** Create a WritableStream that buffers and writes complete messages to the control stream under mutex. */
      #createSendWritable() {
        let buffer = new Uint8Array(0);
        return new WritableStream({
          write: async (chunk) => {
            const newBuf = new Uint8Array(buffer.length + chunk.length);
            newBuf.set(buffer);
            newBuf.set(chunk, buffer.length);
            buffer = newBuf;
            for (; ; ) {
              const boundary = this.#messageSize(buffer);
              if (boundary === void 0)
                break;
              const toFlush = buffer.subarray(0, boundary);
              buffer = buffer.subarray(boundary);
              await this.#writeMutex.runExclusive(() => this.#writer.write(toFlush));
            }
          }
        });
      }
      /** Encode raw message bytes: [typeId varint][size u16 BE][body] */
      #encodeRaw(typeId, size2, body) {
        const typeIdBytes = encodeTo2(new ArrayBuffer(9), typeId);
        const result = new Uint8Array(typeIdBytes.byteLength + 2 + body.byteLength);
        result.set(typeIdBytes, 0);
        const sizeView = new DataView(result.buffer, typeIdBytes.byteLength, 2);
        sizeView.setUint16(0, size2);
        result.set(body, typeIdBytes.byteLength + 2);
        return result;
      }
      /**
       * Classify a control message and extract its requestId for routing.
       */
      async #classify(typeId, body) {
        const readRequestId = async () => {
          const r2 = new Reader(void 0, body, this.version);
          return await r2.u62();
        };
        const readNamespaceRequestId = async (direction) => {
          const r2 = new Reader(void 0, body, this.version);
          const namespace = await decode5(r2);
          const namespaces = this.#namespaceRequests(direction);
          const requestId = namespaces.get(namespace);
          if (requestId === void 0)
            console.warn(`adapter: no announcement for namespace: ${namespace}`);
          return requestId;
        };
        switch (typeId) {
          // === FollowUp: route to existing stream ===
          case 2: {
            const requestId = await readRequestId();
            return { route: Route2.FollowUp, requestId };
          }
          // === NewRequest: create virtual stream ===
          case 3:
          // Subscribe
          case 22:
          // Fetch
          case 29:
          // Publish
          case 13: {
            const requestId = await readRequestId();
            return { route: Route2.NewRequest, requestId };
          }
          case 6: {
            const requestId = await this.#registerNamespace(body, "incoming");
            return { route: Route2.NewRequest, requestId };
          }
          case 17: {
            if (this.version !== Version.DRAFT_14 && this.version !== Version.DRAFT_15) {
              throw new Error("unexpected SubscribeNamespace on control stream");
            }
            const requestId = await readRequestId();
            return { route: Route2.NewRequest, requestId };
          }
          // === Response: push bytes, keep stream open ===
          case 4: {
            const requestId = await readRequestId();
            return { route: Route2.Response, requestId };
          }
          case 24: {
            const requestId = await readRequestId();
            return { route: Route2.Response, requestId };
          }
          case 30: {
            const requestId = await readRequestId();
            return { route: Route2.Response, requestId };
          }
          case 7: {
            const requestId = await readRequestId();
            return { route: Route2.Response, requestId };
          }
          case 18: {
            if (this.version !== Version.DRAFT_14)
              throw new Error("unexpected SubscribeNamespaceOk");
            const requestId = await readRequestId();
            return { route: Route2.Response, requestId };
          }
          // === ErrorResponse: push bytes + close ===
          case 5: {
            const requestId = await readRequestId();
            return { route: Route2.ErrorResponse, requestId };
          }
          case 25: {
            if (this.version !== Version.DRAFT_14)
              throw new Error("unexpected FetchError");
            const requestId = await readRequestId();
            return { route: Route2.ErrorResponse, requestId };
          }
          case 31: {
            if (this.version !== Version.DRAFT_14)
              throw new Error("unexpected PublishError");
            const requestId = await readRequestId();
            return { route: Route2.ErrorResponse, requestId };
          }
          case 8: {
            if (this.version === Version.DRAFT_14) {
              const requestId = await readRequestId();
              return { route: Route2.ErrorResponse, requestId };
            }
            const subNs08 = this.#subscribeNamespaces.values().next().value;
            if (subNs08 === void 0)
              throw new Error("unexpected message 0x08: no SubscribeNamespace stream");
            return { route: Route2.FollowUp, requestId: subNs08 };
          }
          case 14: {
            if (this.version === Version.DRAFT_14 || this.version === Version.DRAFT_15) {
              throw new Error("unexpected message 0x0e");
            }
            const subNs0e = this.#subscribeNamespaces.values().next().value;
            if (subNs0e === void 0)
              throw new Error("unexpected message 0x0e: no SubscribeNamespace stream");
            return { route: Route2.FollowUp, requestId: subNs0e };
          }
          case 19: {
            if (this.version !== Version.DRAFT_14)
              throw new Error("unexpected SubscribeNamespaceError");
            const requestId = await readRequestId();
            return { route: Route2.ErrorResponse, requestId };
          }
          // === CloseStream: close recv (no bytes pushed) ===
          case 10: {
            const requestId = await readRequestId();
            return { route: Route2.CloseStream, requestId };
          }
          case 11: {
            const requestId = await readRequestId();
            return { route: Route2.ErrorResponse, requestId };
          }
          case 23: {
            const requestId = await readRequestId();
            return { route: Route2.CloseStream, requestId };
          }
          case 9: {
            if (this.version === Version.DRAFT_16) {
              const requestId2 = await readRequestId();
              return { route: Route2.CloseStream, requestId: requestId2 };
            }
            const requestId = await readNamespaceRequestId("incoming");
            if (requestId === void 0)
              return { route: Route2.Ignore, requestId: 0n };
            return { route: Route2.CloseStream, requestId };
          }
          case 12: {
            if (this.version === Version.DRAFT_16) {
              const requestId2 = await readRequestId();
              return { route: Route2.CloseStream, requestId: requestId2 };
            }
            const requestId = await readNamespaceRequestId("outgoing");
            if (requestId === void 0)
              return { route: Route2.Ignore, requestId: 0n };
            return { route: Route2.CloseStream, requestId };
          }
          case 20: {
            if (this.version !== Version.DRAFT_14 && this.version !== Version.DRAFT_15) {
              throw new Error("unexpected UnsubscribeNamespace");
            }
            const requestId = await readRequestId();
            return { route: Route2.CloseStream, requestId };
          }
          // === Utility ===
          case 21: {
            const requestId = await readRequestId();
            return { route: Route2.MaxRequestId, requestId };
          }
          case 26: {
            await readRequestId();
            return { route: Route2.Ignore, requestId: 0n };
          }
          // === Terminal ===
          case 16:
            return { route: Route2.GoAway };
          default:
            throw new Error(`unknown control message type: 0x${typeId.toString(16)}`);
        }
      }
      /**
       * Ends every virtual stream: cleanly for a deliberate close, or with `err` when the
       * control stream died under them, since every request riding it was cut off.
       */
      close(err2) {
        if (this.#closed)
          return;
        this.#closed = true;
        console.debug("adapter: close() called");
        for (const entry of this.#streams.values()) {
          try {
            if (err2)
              entry.controller.error(err2);
            else
              entry.controller.close();
          } catch {
          }
        }
        this.#streams.clear();
        for (const waiter of this.#incomingWaiters) {
          waiter(void 0);
        }
        this.#incomingWaiters = [];
        this.#incomingNamespaces.clear();
        this.#outgoingNamespaces.clear();
        this.#namespacesByRequestId.clear();
        this.#subscribeNamespaces.clear();
        for (const resolve2 of this.#maxRequestIdResolves)
          resolve2();
        this.#maxRequestIdResolves = [];
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/filter.js
function isDraft20(version2) {
  return version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16 && version2 !== Version.DRAFT_17 && version2 !== Version.DRAFT_18 && version2 !== Version.DRAFT_19;
}
function isDraft22(version2) {
  return isDraft20(version2) && version2 !== Version.DRAFT_20 && version2 !== Version.DRAFT_21;
}
function hasRangeFilters(version2) {
  return isDraft20(version2) || version2 === Version.DRAFT_19;
}
function usesLeadingOnes(version2) {
  return version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16;
}
function varint(v3, version2) {
  return usesLeadingOnes(version2) ? encodeLeadingOnes(v3) : encode3(v3);
}
function unvarint(buf, version2) {
  return usesLeadingOnes(version2) ? decodeLeadingOnes(buf) : decodeBigInt(buf);
}
function concat(parts3) {
  const total = parts3.reduce((n2, p3) => n2 + p3.length, 0);
  const out = new Uint8Array(total);
  let offset = 0;
  for (const part of parts3) {
    out.set(part, offset);
    offset += part.length;
  }
  return out;
}
function endDelta(startGroup, endGroup) {
  if (endGroup < startGroup) {
    throw new Error(`filter range runs backwards: ${startGroup} > ${endGroup}`);
  }
  return endGroup - startGroup;
}
function encode6(filter, version2) {
  if (isDraft22(version2))
    return encodeTyped(filter, version2);
  return isDraft20(version2) ? encodeFields(filter, version2) : encodeTag(filter, version2);
}
function encodeParam(filter, version2) {
  const value = encode6(filter, version2);
  return isDraft22(version2) ? value : encodeLengthPrefixed(value, version2);
}
async function decodeParam(r2, version2) {
  if (!isDraft22(version2)) {
    return decode6(await r2.read(await r2.u53()), version2);
  }
  const type = await r2.u62();
  const fields = [];
  for (let i2 = typedFieldCount(type); i2 > 0; i2--) {
    fields.push(await r2.u62());
  }
  return fromTyped(type, fields);
}
function encodeTyped(filter, version2) {
  switch (filter.kind) {
    case "unfiltered":
      return varint(TYPE_NONE, version2);
    case "nextObject":
      return varint(TYPE_NEXT_OBJECT, version2);
    case "relative":
      return concat([varint(TYPE_RELATIVE_START, version2), varint(filter.groups, version2)]);
    case "absolute": {
      const type = filter.endGroup === void 0 ? TYPE_ABSOLUTE_START : filter.endObject === void 0 ? TYPE_ABSOLUTE_GROUP_END : TYPE_ABSOLUTE_RANGE;
      const parts3 = [
        varint(type, version2),
        varint(filter.startGroup, version2),
        varint(filter.startObject, version2)
      ];
      if (filter.endGroup !== void 0) {
        parts3.push(varint(endDelta(filter.startGroup, filter.endGroup), version2));
        if (filter.endObject !== void 0) {
          parts3.push(varint(filter.endObject, version2));
        }
      }
      return concat(parts3);
    }
  }
}
function typedFieldCount(type) {
  switch (type) {
    case TYPE_NONE:
    case TYPE_NEXT_OBJECT:
      return 0;
    case TYPE_RELATIVE_START:
      return 1;
    case TYPE_ABSOLUTE_START:
      return 2;
    case TYPE_ABSOLUTE_GROUP_END:
      return 3;
    case TYPE_ABSOLUTE_RANGE:
      return 4;
    default:
      throw new ProtocolViolation(`unknown Location Filter Type: ${type}`);
  }
}
function fromTyped(type, fields) {
  switch (type) {
    case TYPE_NONE:
      return { kind: "unfiltered" };
    case TYPE_NEXT_OBJECT:
      return { kind: "nextObject" };
    case TYPE_RELATIVE_START:
      return { kind: "relative", groups: fields[0] };
    default: {
      const [startGroup, startObject, delta, endObject] = fields;
      const endGroup = delta === void 0 ? void 0 : startGroup + delta;
      if (endGroup !== void 0 && endGroup > 0xffffffffffffffffn) {
        throw new ProtocolViolation("LOCATION_FILTER end group exceeds 2^64 - 1");
      }
      return { kind: "absolute", startGroup, startObject, endGroup, endObject };
    }
  }
}
function readTyped(data, version2) {
  let [type, rest] = unvarint(data, version2);
  const fields = [];
  for (let i2 = typedFieldCount(type); i2 > 0; i2--) {
    const [field, next] = unvarint(rest, version2);
    fields.push(field);
    rest = next;
  }
  return [fromTyped(type, fields), rest];
}
function encodeFields(filter, version2) {
  switch (filter.kind) {
    case "unfiltered":
      return new Uint8Array();
    case "nextObject":
      return concat([varint(0n, version2), varint(0n, version2)]);
    case "relative":
      return varint(filter.groups, version2);
    case "absolute": {
      if (filter.startGroup === 0n && filter.startObject === 0n && filter.endGroup === void 0) {
        return new Uint8Array();
      }
      const parts3 = [varint(filter.startGroup, version2), varint(filter.startObject, version2)];
      if (filter.endGroup !== void 0) {
        parts3.push(varint(endDelta(filter.startGroup, filter.endGroup), version2));
        if (filter.endObject !== void 0) {
          parts3.push(varint(filter.endObject, version2));
        }
      }
      return concat(parts3);
    }
  }
}
function encodeTag(filter, version2) {
  switch (filter.kind) {
    case "unfiltered":
      return concat([varint(TAG_ABSOLUTE_START, version2), varint(0n, version2), varint(0n, version2)]);
    case "nextObject":
      return varint(TAG_LARGEST_OBJECT, version2);
    case "relative":
      if (filter.groups !== 0n) {
        throw new Error(`relative filter ${filter.groups} needs draft-20`);
      }
      return varint(TAG_NEXT_GROUP, version2);
    case "absolute": {
      if (filter.endObject !== void 0) {
        throw new Error("an object-bounded range needs draft-20");
      }
      const parts3 = [
        varint(filter.endGroup === void 0 ? TAG_ABSOLUTE_START : TAG_ABSOLUTE_RANGE, version2),
        varint(filter.startGroup, version2),
        varint(filter.startObject, version2)
      ];
      if (filter.endGroup !== void 0) {
        parts3.push(varint(endDelta(filter.startGroup, filter.endGroup), version2));
      }
      return concat(parts3);
    }
  }
}
function decode6(data, version2) {
  if (isDraft22(version2)) {
    const [filter, rest] = readTyped(data, version2);
    expectEmpty(rest);
    return filter;
  }
  return isDraft20(version2) ? decodeFields(data, version2) : decodeTag(data, version2);
}
function decodeFields(data, version2) {
  const fields = [];
  let rest = data;
  while (rest.length > 0) {
    if (fields.length === 4) {
      throw new Error("too many fields in LOCATION_FILTER");
    }
    const [value, next] = unvarint(rest, version2);
    fields.push(value);
    rest = next;
  }
  switch (fields.length) {
    case 0:
      return { kind: "unfiltered" };
    case 1:
      return { kind: "relative", groups: fields[0] };
    default: {
      const [startGroup, startObject] = fields;
      if (fields.length === 2 && startGroup === 0n && startObject === 0n) {
        return { kind: "nextObject" };
      }
      const endGroup = fields.length >= 3 ? startGroup + fields[2] : void 0;
      const endObject = fields.length === 4 ? fields[3] : void 0;
      return { kind: "absolute", startGroup, startObject, endGroup, endObject };
    }
  }
}
function decodeTag(data, version2) {
  const [tag, afterTag] = unvarint(data, version2);
  const readLocation = (buf) => {
    const [group, afterGroup] = unvarint(buf, version2);
    const [object3, rest] = unvarint(afterGroup, version2);
    return [group, object3, rest];
  };
  switch (tag) {
    case TAG_NEXT_GROUP:
      expectEmpty(afterTag);
      return { kind: "relative", groups: 0n };
    case TAG_LARGEST_OBJECT:
      expectEmpty(afterTag);
      return { kind: "nextObject" };
    case TAG_ABSOLUTE_START: {
      const [startGroup, startObject, rest] = readLocation(afterTag);
      expectEmpty(rest);
      return { kind: "absolute", startGroup, startObject };
    }
    case TAG_ABSOLUTE_RANGE: {
      const [startGroup, startObject, afterLocation] = readLocation(afterTag);
      const [delta, rest] = unvarint(afterLocation, version2);
      expectEmpty(rest);
      return { kind: "absolute", startGroup, startObject, endGroup: startGroup + delta };
    }
    default:
      throw new Error(`unsupported filter type: ${tag}`);
  }
}
async function decodeInline(r2) {
  const tag = await r2.u62();
  switch (tag) {
    case TAG_NEXT_GROUP:
      return { kind: "relative", groups: 0n };
    case TAG_LARGEST_OBJECT:
      return { kind: "nextObject" };
    case TAG_ABSOLUTE_START:
      return { kind: "absolute", startGroup: await r2.u62(), startObject: await r2.u62() };
    case TAG_ABSOLUTE_RANGE: {
      const startGroup = await r2.u62();
      const startObject = await r2.u62();
      const delta = await r2.u62();
      return { kind: "absolute", startGroup, startObject, endGroup: startGroup + delta };
    }
    default:
      throw new Error(`unsupported filter type: ${tag}`);
  }
}
function expectEmpty(rest) {
  if (rest.length !== 0) {
    throw new Error("trailing bytes in LOCATION_FILTER");
  }
}
function encodeFill(fill, version2) {
  if (fill.filter === void 0) {
    return varint(0n, version2);
  }
  return concat([
    varint(1n, version2),
    // The first type in a scope is not delta encoded, so this is the raw id.
    varint(FILL_LOCATION_FILTER, version2),
    encodeParam(fill.filter, version2)
  ]);
}
function decodeFill(data, version2) {
  const [count2, afterCount] = unvarint(data, version2);
  if (count2 > 64n) {
    throw new Error("too many parameters in FILL_PARAMETERS");
  }
  let rest = afterCount;
  let filter;
  let rangeFilters = false;
  let prev = 0n;
  for (let i2 = 0n; i2 < count2; i2++) {
    const [delta, afterType] = unvarint(rest, version2);
    const key = i2 === 0n ? delta : prev + delta;
    prev = key;
    rest = afterType;
    if (key === FILL_LOCATION_FILTER) {
      if (filter !== void 0) {
        throw new Error("duplicate LOCATION_FILTER inside FILL_PARAMETERS");
      }
      if (isDraft22(version2)) {
        [filter, rest] = readTyped(rest, version2);
      } else {
        let value;
        [value, rest] = readLengthPrefixed(rest, version2);
        filter = decode6(value, version2);
      }
      continue;
    }
    const framing = FILL_ALLOWED.get(key);
    if (framing === void 0) {
      throw new Error(`parameter ${key} is not allowed inside FILL_PARAMETERS`);
    }
    rangeFilters ||= key >= 0x25n && key <= 0x28n;
    if (framing === "varint") {
      [, rest] = unvarint(rest, version2);
      continue;
    }
    if (framing === "byte") {
      if (rest.length < 1)
        throw new Error("truncated value inside FILL_PARAMETERS");
      rest = rest.slice(1);
      continue;
    }
    [, rest] = readLengthPrefixed(rest, version2);
  }
  if (rest.length !== 0) {
    throw new Error("trailing bytes in FILL_PARAMETERS");
  }
  return { filter, rangeFilters };
}
function readLengthPrefixed(data, version2) {
  const [length, afterLength] = unvarint(data, version2);
  if (BigInt(afterLength.length) < length) {
    throw new Error("truncated value inside FILL_PARAMETERS");
  }
  return [afterLength.slice(0, Number(length)), afterLength.slice(Number(length))];
}
function encodeLengthPrefixed(value, version2) {
  return concat([varint(BigInt(value.length), version2), value]);
}
var TAG_NEXT_GROUP, TAG_LARGEST_OBJECT, TAG_ABSOLUTE_START, TAG_ABSOLUTE_RANGE, TYPE_NONE, TYPE_RELATIVE_START, TYPE_ABSOLUTE_START, TYPE_ABSOLUTE_GROUP_END, TYPE_ABSOLUTE_RANGE, TYPE_NEXT_OBJECT, FILL_LOCATION_FILTER, FILL_ALLOWED;
var init_filter = __esm({
  "../../node_modules/@moq/net/ietf/filter.js"() {
    init_error2();
    init_varint2();
    init_version();
    TAG_NEXT_GROUP = 0x1n;
    TAG_LARGEST_OBJECT = 0x2n;
    TAG_ABSOLUTE_START = 0x3n;
    TAG_ABSOLUTE_RANGE = 0x4n;
    TYPE_NONE = 0x0n;
    TYPE_RELATIVE_START = 0x1n;
    TYPE_ABSOLUTE_START = 0x2n;
    TYPE_ABSOLUTE_GROUP_END = 0x3n;
    TYPE_ABSOLUTE_RANGE = 0x4n;
    TYPE_NEXT_OBJECT = 0x5n;
    FILL_LOCATION_FILTER = 0x21n;
    FILL_ALLOWED = /* @__PURE__ */ new Map([
      [0x0an, "varint"],
      // FILL_TIMEOUT
      [0x20n, "byte"],
      // SUBSCRIBER_PRIORITY, a uint8
      [0x22n, "byte"],
      // GROUP_ORDER, a uint8
      [0x25n, "bytes"],
      // SUBGROUP_FILTER
      [0x26n, "bytes"],
      // OBJECTID_FILTER, length prefixed despite an even id
      [0x27n, "bytes"],
      // PRIORITY_FILTER
      [0x28n, "bytes"]
      // OBJECT_PROPERTY_FILTER, likewise
    ]);
  }
});

// ../../node_modules/@moq/net/ietf/parameters.js
function definedSetupOption(id, version2) {
  const legacy = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16;
  switch (id) {
    case SetupOption.MaxRequestId:
      return legacy;
    // The MoQ Cluster extension is only negotiated on draft-17+ (see `cluster.ts`).
    case SetupOption.HopId:
    case SetupOption.RelayCost:
      return !legacy;
    default:
      return SETUP_OPTIONS.includes(id);
  }
}
function messageParamKind(id) {
  switch (id) {
    case MSG_PARAM_DELIVERY_TIMEOUT:
    case MSG_PARAM_FILL_TIMEOUT:
    case MSG_PARAM_NEW_GROUP_REQUEST:
    case MSG_PARAM_SUBGROUP_DELIVERY_TIMEOUT:
    case MSG_PARAM_MAX_CACHE_DURATION:
    case MSG_PARAM_EXPIRES:
    case MSG_PARAM_ROUTE_COST:
    case MSG_PARAM_HIDDEN:
      return "varint";
    case MSG_PARAM_PUBLISHER_PRIORITY:
    case MSG_PARAM_SUBSCRIBER_PRIORITY:
    case MSG_PARAM_GROUP_ORDER:
    case MSG_PARAM_INCLUDE_PROPERTIES:
      return "uint8";
    case MSG_PARAM_FORWARD:
      return "bool";
    case MSG_PARAM_LARGEST_OBJECT:
      return "location";
    case MSG_PARAM_SUBSCRIPTION_FILTER:
      return "filter";
    case MSG_PARAM_AUTHORIZATION_TOKEN:
    case MSG_PARAM_FILL_PARAMETERS:
    case MSG_PARAM_HOP_PATH:
      return "bytes";
    default:
      return MSG_PARAM_REPEATABLE.includes(id) ? "bytes" : void 0;
  }
}
function getMessageParamKind(id) {
  const kind = messageParamKind(id);
  if (kind === void 0)
    throw new Error(`unknown message parameter id: ${id.toString()}`);
  return kind;
}
function decodeLocation(data) {
  const [groupId, objectData] = decodeBigInt(data);
  const [objectId, trailing] = decodeBigInt(objectData);
  if (trailing.length !== 0) {
    throw new Error("trailing bytes in message parameter Location");
  }
  return { groupId, objectId };
}
function encodeLocation({ groupId, objectId }) {
  const group = encode3(groupId);
  const object3 = encode3(objectId);
  const combined = new Uint8Array(group.length + object3.length);
  combined.set(group, 0);
  combined.set(object3, group.length);
  return combined;
}
var SetupOption, SETUP_OPTIONS, SetupOptions, MSG_PARAM_DELIVERY_TIMEOUT, MSG_PARAM_FILL_TIMEOUT, MSG_PARAM_NEW_GROUP_REQUEST, MSG_PARAM_SUBGROUP_DELIVERY_TIMEOUT, MSG_PARAM_MAX_CACHE_DURATION, MSG_PARAM_EXPIRES, MSG_PARAM_PUBLISHER_PRIORITY, MSG_PARAM_FORWARD, MSG_PARAM_SUBSCRIBER_PRIORITY, MSG_PARAM_GROUP_ORDER, MSG_PARAM_INCLUDE_PROPERTIES, MSG_PARAM_ROUTE_COST, MSG_PARAM_HIDDEN, MSG_PARAM_AUTHORIZATION_TOKEN, MSG_PARAM_LARGEST_OBJECT, MSG_PARAM_SUBSCRIPTION_FILTER, MSG_PARAM_FILL_PARAMETERS, MSG_PARAM_HOP_PATH, MSG_PARAM_RANGE_FILTERS, MSG_PARAM_TRACK_PROPERTY_FILTER, MSG_PARAM_REPEATABLE, MSG_PARAM_DRAFT14, MSG_PARAM_AFTER_DRAFT15, Parameters;
var init_parameters = __esm({
  "../../node_modules/@moq/net/ietf/parameters.js"() {
    init_varint2();
    init_filter();
    init_version();
    SetupOption = {
      Path: 1n,
      MaxRequestId: 2n,
      AuthorizationToken: 3n,
      MaxAuthTokenCacheSize: 4n,
      Authority: 5n,
      Implementation: 7n,
      /** HOP_ID, from the MoQ Cluster extension. See `cluster.ts`. */
      HopId: 0x40b54n,
      /** RELAY_COST, from the MoQ Cluster extension. See `cluster.ts`. */
      RelayCost: 0x40b56n,
      /** SOLICIT, from the MoQ Solicit extension. See `solicit.ts`. */
      Solicit: 0x40b5an,
      /** HIDDEN, from the MoQ Hidden extension. See `hidden.ts`. */
      Hidden: 0x40b5cn
    };
    SETUP_OPTIONS = Object.values(SetupOption);
    SetupOptions = class _SetupOptions {
      vars;
      bytes;
      constructor() {
        this.vars = /* @__PURE__ */ new Map();
        this.bytes = /* @__PURE__ */ new Map();
      }
      get size() {
        return this.vars.size + this.bytes.size;
      }
      setBytes(id, value) {
        if (id % 2n !== 1n) {
          throw new Error(`invalid parameter id: ${id.toString()}, must be odd`);
        }
        this.bytes.set(id, value);
      }
      setVarint(id, value) {
        if (id % 2n !== 0n) {
          throw new Error(`invalid parameter id: ${id.toString()}, must be even`);
        }
        this.vars.set(id, value);
      }
      getBytes(id) {
        if (id % 2n !== 1n) {
          throw new Error(`invalid parameter id: ${id.toString()}, must be odd`);
        }
        return this.bytes.get(id);
      }
      getVarint(id) {
        if (id % 2n !== 0n) {
          throw new Error(`invalid parameter id: ${id.toString()}, must be even`);
        }
        return this.vars.get(id);
      }
      removeBytes(id) {
        if (id % 2n !== 1n) {
          throw new Error(`invalid parameter id: ${id.toString()}, must be odd`);
        }
        return this.bytes.delete(id);
      }
      removeVarint(id) {
        if (id % 2n !== 0n) {
          throw new Error(`invalid parameter id: ${id.toString()}, must be even`);
        }
        return this.vars.delete(id);
      }
      async encode(w4, version2) {
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15) {
          if (version2 === Version.DRAFT_16) {
            await w4.u53(this.vars.size + this.bytes.size);
          }
          const all = [];
          for (const id of this.vars.keys())
            all.push({ key: id, isVar: true });
          for (const id of this.bytes.keys())
            all.push({ key: id, isVar: false });
          all.sort((a2, b3) => a2.key < b3.key ? -1 : a2.key > b3.key ? 1 : 0);
          let prevId = 0n;
          for (let i2 = 0; i2 < all.length; i2++) {
            const { key, isVar } = all[i2];
            const delta = i2 === 0 ? key : key - prevId;
            prevId = key;
            await w4.u62(delta);
            if (isVar) {
              await w4.u62(this.vars.get(key));
            } else {
              const value = this.bytes.get(key);
              await w4.u53(value.length);
              await w4.write(value);
            }
          }
        } else {
          await w4.u53(this.vars.size + this.bytes.size);
          for (const [id, value] of this.vars) {
            await w4.u62(id);
            await w4.u62(value);
          }
          for (const [id, value] of this.bytes) {
            await w4.u62(id);
            await w4.u53(value.length);
            await w4.write(value);
          }
        }
      }
      static async decode(r2, version2) {
        const params = new _SetupOptions();
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16) {
          let prevType = 0n;
          let i2 = 0;
          while (!await r2.done()) {
            const delta = await r2.u62();
            const id = i2 === 0 ? delta : prevType + delta;
            prevType = id;
            i2++;
            if (id % 2n === 0n) {
              if (definedSetupOption(id, version2) && params.vars.has(id)) {
                throw new Error(`duplicate parameter id: ${id.toString()}`);
              }
              const varint2 = await r2.u62();
              params.setVarint(id, varint2);
            } else {
              if (definedSetupOption(id, version2) && params.bytes.has(id)) {
                throw new Error(`duplicate parameter id: ${id.toString()}`);
              }
              const size2 = await r2.u53();
              const bytes = await r2.read(size2);
              params.setBytes(id, bytes);
            }
          }
        } else {
          const count2 = await r2.u53();
          let prevType = 0n;
          for (let i2 = 0; i2 < count2; i2++) {
            let id;
            if (version2 === Version.DRAFT_16) {
              const delta = await r2.u62();
              id = i2 === 0 ? delta : prevType + delta;
              prevType = id;
            } else {
              id = await r2.u62();
            }
            if (id % 2n === 0n) {
              if (definedSetupOption(id, version2) && params.vars.has(id)) {
                throw new Error(`duplicate parameter id: ${id.toString()}`);
              }
              const varint2 = await r2.u62();
              params.setVarint(id, varint2);
            } else {
              if (definedSetupOption(id, version2) && params.bytes.has(id)) {
                throw new Error(`duplicate parameter id: ${id.toString()}`);
              }
              const size2 = await r2.u53();
              const bytes = await r2.read(size2);
              params.setBytes(id, bytes);
            }
          }
        }
        return params;
      }
    };
    MSG_PARAM_DELIVERY_TIMEOUT = 0x02n;
    MSG_PARAM_FILL_TIMEOUT = 0x0an;
    MSG_PARAM_NEW_GROUP_REQUEST = 0x32n;
    MSG_PARAM_SUBGROUP_DELIVERY_TIMEOUT = 0x06n;
    MSG_PARAM_MAX_CACHE_DURATION = 0x04n;
    MSG_PARAM_EXPIRES = 0x08n;
    MSG_PARAM_PUBLISHER_PRIORITY = 0x0en;
    MSG_PARAM_FORWARD = 0x10n;
    MSG_PARAM_SUBSCRIBER_PRIORITY = 0x20n;
    MSG_PARAM_GROUP_ORDER = 0x22n;
    MSG_PARAM_INCLUDE_PROPERTIES = 0x35n;
    MSG_PARAM_ROUTE_COST = 0x40b58n;
    MSG_PARAM_HIDDEN = 0x40b5en;
    MSG_PARAM_AUTHORIZATION_TOKEN = 0x03n;
    MSG_PARAM_LARGEST_OBJECT = 0x09n;
    MSG_PARAM_SUBSCRIPTION_FILTER = 0x21n;
    MSG_PARAM_FILL_PARAMETERS = 0x23n;
    MSG_PARAM_HOP_PATH = 0x40b57n;
    MSG_PARAM_RANGE_FILTERS = [0x25n, 0x26n, 0x27n, 0x28n];
    MSG_PARAM_TRACK_PROPERTY_FILTER = 0x29n;
    MSG_PARAM_REPEATABLE = [
      MSG_PARAM_AUTHORIZATION_TOKEN,
      ...MSG_PARAM_RANGE_FILTERS,
      MSG_PARAM_TRACK_PROPERTY_FILTER
    ];
    MSG_PARAM_DRAFT14 = [
      MSG_PARAM_DELIVERY_TIMEOUT,
      MSG_PARAM_AUTHORIZATION_TOKEN,
      MSG_PARAM_MAX_CACHE_DURATION,
      MSG_PARAM_HIDDEN
    ];
    MSG_PARAM_AFTER_DRAFT15 = [
      MSG_PARAM_SUBGROUP_DELIVERY_TIMEOUT,
      MSG_PARAM_FILL_TIMEOUT,
      MSG_PARAM_FILL_PARAMETERS,
      ...MSG_PARAM_RANGE_FILTERS,
      MSG_PARAM_TRACK_PROPERTY_FILTER,
      MSG_PARAM_INCLUDE_PROPERTIES,
      MSG_PARAM_HOP_PATH,
      MSG_PARAM_ROUTE_COST
    ];
    Parameters = class _Parameters {
      vars;
      bytes;
      #locations;
      /** LOCATION_FILTER, kept decoded because its framing depends on the draft. */
      #filter;
      #filterBytes;
      /** Every instance of a parameter that may repeat, decoded only; we never send one. */
      #repeated;
      constructor() {
        this.vars = /* @__PURE__ */ new Map();
        this.bytes = /* @__PURE__ */ new Map();
        this.#locations = /* @__PURE__ */ new Map();
        this.#repeated = /* @__PURE__ */ new Map();
      }
      #repeat(id, value) {
        const values = this.#repeated.get(id) ?? [];
        values.push(value);
        this.#repeated.set(id, values);
      }
      /**
       * Whether the message carried a Range Filter. We advertise no MAX_FILTER_RANGES, so a
       * request with one is refused rather than served unfiltered.
       */
      get rangeFilters() {
        return MSG_PARAM_RANGE_FILTERS.some((id) => this.#repeated.has(id));
      }
      /** Whether the message carried TRACK_PROPERTY_FILTER, which only a SUBSCRIBE_TRACKS may. */
      get trackPropertyFilter() {
        return this.#repeated.has(MSG_PARAM_TRACK_PROPERTY_FILTER);
      }
      /** Whether the message carried an AUTHORIZATION_TOKEN. */
      get authorizationToken() {
        return this.#repeated.has(MSG_PARAM_AUTHORIZATION_TOKEN);
      }
      // --- Numeric accessors ---
      get subscriberPriority() {
        const v3 = this.vars.get(MSG_PARAM_SUBSCRIBER_PRIORITY);
        return v3 !== void 0 ? Number(v3) : void 0;
      }
      set subscriberPriority(v3) {
        this.vars.set(MSG_PARAM_SUBSCRIBER_PRIORITY, BigInt(v3));
      }
      get groupOrder() {
        const v3 = this.vars.get(MSG_PARAM_GROUP_ORDER);
        return v3 !== void 0 ? Number(v3) : void 0;
      }
      set groupOrder(v3) {
        this.vars.set(MSG_PARAM_GROUP_ORDER, BigInt(v3));
      }
      get forward() {
        const v3 = this.vars.get(MSG_PARAM_FORWARD);
        return v3 !== void 0 ? v3 !== 0n : void 0;
      }
      set forward(v3) {
        this.vars.set(MSG_PARAM_FORWARD, v3 ? 1n : 0n);
      }
      get publisherPriority() {
        const v3 = this.vars.get(MSG_PARAM_PUBLISHER_PRIORITY);
        return v3 !== void 0 ? Number(v3) : void 0;
      }
      set publisherPriority(v3) {
        this.vars.set(MSG_PARAM_PUBLISHER_PRIORITY, BigInt(v3));
      }
      get expires() {
        return this.vars.get(MSG_PARAM_EXPIRES);
      }
      set expires(v3) {
        this.vars.set(MSG_PARAM_EXPIRES, v3);
      }
      get deliveryTimeout() {
        return this.vars.get(MSG_PARAM_DELIVERY_TIMEOUT);
      }
      set deliveryTimeout(v3) {
        this.vars.set(MSG_PARAM_DELIVERY_TIMEOUT, v3);
      }
      get maxCacheDuration() {
        return this.vars.get(MSG_PARAM_MAX_CACHE_DURATION);
      }
      set maxCacheDuration(v3) {
        this.vars.set(MSG_PARAM_MAX_CACHE_DURATION, v3);
      }
      /** HIDDEN (MoQ Hidden): also advertise hidden namespaces. Absent and 0 both mean no. */
      get hidden() {
        const v3 = this.vars.get(MSG_PARAM_HIDDEN);
        if (v3 === void 0 || v3 === 0n)
          return false;
        if (v3 === 1n)
          return true;
        throw new Error(`invalid HIDDEN parameter: ${v3}`);
      }
      set hidden(v3) {
        if (v3)
          this.vars.set(MSG_PARAM_HIDDEN, 1n);
        else
          this.vars.delete(MSG_PARAM_HIDDEN);
      }
      // --- Bytes accessors ---
      get largest() {
        const location = this.#locations.get(MSG_PARAM_LARGEST_OBJECT);
        return location && { ...location };
      }
      set largest(v3) {
        this.#locations.set(MSG_PARAM_LARGEST_OBJECT, { ...v3 });
      }
      /** LOCATION_FILTER: which Objects the subscription delivers. See `filter.ts`. */
      get subscriptionFilter() {
        if (this.#filterBytes && this.#filter === void 0) {
          this.#filter = decode6(this.#filterBytes.value, this.#filterBytes.version);
        }
        return this.#filter;
      }
      set subscriptionFilter(v3) {
        this.#filter = v3;
        this.#filterBytes = void 0;
      }
      /** FILL_PARAMETERS: the draft-20 backfill request, as its raw parameter value. */
      get fillParameters() {
        return this.bytes.get(MSG_PARAM_FILL_PARAMETERS);
      }
      set fillParameters(v3) {
        this.bytes.set(MSG_PARAM_FILL_PARAMETERS, v3);
      }
      /** INCLUDE_PROPERTIES: whether the peer wants Track Properties on the response. */
      get includeProperties() {
        const legacy = this.bytes.get(MSG_PARAM_INCLUDE_PROPERTIES);
        const v3 = legacy ? legacy.length === 1 ? BigInt(legacy[0]) : 2n : this.vars.get(MSG_PARAM_INCLUDE_PROPERTIES);
        if (v3 === void 0)
          return void 0;
        if (v3 > 1n)
          throw new Error(`invalid INCLUDE_PROPERTIES value: ${v3}`);
        return v3 === 1n;
      }
      set includeProperties(v3) {
        this.vars.set(MSG_PARAM_INCLUDE_PROPERTIES, v3 ? 1n : 0n);
      }
      /** HOP_PATH: the hop chain an advertisement traversed, as its raw parameter value. */
      get hopPath() {
        return this.bytes.get(MSG_PARAM_HOP_PATH);
      }
      set hopPath(v3) {
        this.bytes.set(MSG_PARAM_HOP_PATH, v3);
      }
      /** ROUTE_COST: the accumulated cost of that path. Absent means 0. */
      get routeCost() {
        return this.vars.get(MSG_PARAM_ROUTE_COST);
      }
      set routeCost(v3) {
        this.vars.set(MSG_PARAM_ROUTE_COST, v3);
      }
      async encode(w4, version2) {
        const filter = this.subscriptionFilter;
        await w4.u53(this.vars.size + this.bytes.size + this.#locations.size + (filter ? 1 : 0));
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15) {
          for (const [id, value] of this.vars) {
            await w4.u62(id);
            await w4.u62(value);
          }
          for (const [id, value] of this.bytes) {
            await w4.u62(id);
            await w4.u53(value.length);
            await w4.write(value);
          }
          for (const [id, value] of this.#locations) {
            const encoded = encodeLocation(value);
            await w4.u62(id);
            await w4.u53(encoded.length);
            await w4.write(encoded);
          }
          if (filter) {
            const encoded = encode6(filter, version2);
            await w4.u62(MSG_PARAM_SUBSCRIPTION_FILTER);
            await w4.u53(encoded.length);
            await w4.write(encoded);
          }
        } else {
          const all = [];
          for (const id of this.vars.keys())
            all.push({ key: id, storage: "var" });
          for (const id of this.bytes.keys())
            all.push({ key: id, storage: "bytes" });
          for (const id of this.#locations.keys())
            all.push({ key: id, storage: "location" });
          if (filter)
            all.push({ key: MSG_PARAM_SUBSCRIPTION_FILTER, storage: "filter" });
          all.sort((a2, b3) => a2.key < b3.key ? -1 : a2.key > b3.key ? 1 : 0);
          let prevId = 0n;
          for (let i2 = 0; i2 < all.length; i2++) {
            const { key, storage: storage2 } = all[i2];
            const delta = i2 === 0 ? key : key - prevId;
            prevId = key;
            await w4.u62(delta);
            if (version2 === Version.DRAFT_16) {
              if (storage2 === "var") {
                await w4.u62(this.vars.get(key));
              } else {
                const value = storage2 === "bytes" ? (
                  // biome-ignore lint/style/noNonNullAssertion: key is guaranteed to exist in bytes map
                  this.bytes.get(key)
                ) : storage2 === "filter" && filter ? encode6(filter, version2) : (
                  // biome-ignore lint/style/noNonNullAssertion: key is guaranteed to exist in locations map
                  encodeLocation(this.#locations.get(key))
                );
                await w4.u53(value.length);
                await w4.write(value);
              }
              continue;
            }
            switch (getMessageParamKind(key)) {
              case "varint": {
                const value = this.vars.get(key);
                if (value === void 0)
                  throw new Error(`invalid varint message parameter: ${key.toString()}`);
                await w4.u62(value);
                break;
              }
              case "uint8": {
                const value = this.vars.get(key);
                if (value === void 0 || value < 0n || value > 0xffn) {
                  throw new Error(`invalid uint8 message parameter: ${key.toString()}`);
                }
                await w4.u8(Number(value));
                break;
              }
              case "bool": {
                const value = this.vars.get(key);
                if (value !== 0n && value !== 1n) {
                  throw new Error(`invalid bool message parameter: ${key.toString()}`);
                }
                await w4.bool(value === 1n);
                break;
              }
              case "location": {
                const location = this.#locations.get(key);
                if (location === void 0)
                  throw new Error(`invalid Location message parameter: ${key.toString()}`);
                await w4.u62(location.groupId);
                await w4.u62(location.objectId);
                break;
              }
              case "filter": {
                if (!filter)
                  throw new Error(`invalid LOCATION_FILTER message parameter: ${key.toString()}`);
                await w4.write(encodeParam(filter, version2));
                break;
              }
              case "bytes": {
                const value = this.bytes.get(key);
                if (value === void 0)
                  throw new Error(`invalid bytes message parameter: ${key.toString()}`);
                await w4.u53(value.length);
                await w4.write(value);
                break;
              }
            }
          }
        }
      }
      static async decode(r2, version2) {
        const count2 = await r2.u53();
        const params = new _Parameters();
        let prevType = 0n;
        for (let i2 = 0; i2 < count2; i2++) {
          let id;
          if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15) {
            id = await r2.u62();
          } else {
            const delta = await r2.u62();
            id = i2 === 0 ? delta : prevType + delta;
            prevType = id;
          }
          const unrecognized = version2 === Version.DRAFT_14 ? !MSG_PARAM_DRAFT14.includes(id) : version2 === Version.DRAFT_15 && (MSG_PARAM_AFTER_DRAFT15.includes(id) || messageParamKind(id) === void 0);
          if (unrecognized) {
            if (id % 2n === 0n)
              await r2.u62();
            else
              await r2.read(await r2.u53());
            continue;
          }
          if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
            if (id % 2n === 0n) {
              if (params.vars.has(id)) {
                throw new Error(`duplicate message parameter id: ${id.toString()}`);
              }
              const varint2 = await r2.u62();
              params.vars.set(id, varint2);
            } else {
              const size2 = await r2.u53();
              const bytes = await r2.read(size2);
              if (MSG_PARAM_REPEATABLE.includes(id)) {
                params.#repeat(id, bytes);
              } else if (id === MSG_PARAM_LARGEST_OBJECT) {
                if (params.#locations.has(id)) {
                  throw new Error(`duplicate message parameter id: ${id.toString()}`);
                }
                params.#locations.set(id, decodeLocation(bytes));
              } else if (id === MSG_PARAM_SUBSCRIPTION_FILTER) {
                if (params.#filterBytes !== void 0 || params.#filter !== void 0) {
                  throw new Error(`duplicate message parameter id: ${id.toString()}`);
                }
                if (version2 === Version.DRAFT_15) {
                  params.#filterBytes = { value: bytes, version: version2 };
                } else {
                  params.#filter = decode6(bytes, version2);
                }
              } else {
                if (params.bytes.has(id)) {
                  throw new Error(`duplicate message parameter id: ${id.toString()}`);
                }
                params.bytes.set(id, bytes);
              }
            }
            continue;
          }
          if (MSG_PARAM_REPEATABLE.includes(id)) {
            const size2 = await r2.u53();
            params.#repeat(id, await r2.read(size2));
            continue;
          }
          const filter = id === MSG_PARAM_SUBSCRIPTION_FILTER && params.#filter !== void 0;
          if (params.vars.has(id) || params.bytes.has(id) || params.#locations.has(id) || filter) {
            throw new Error(`duplicate message parameter id: ${id.toString()}`);
          }
          switch (getMessageParamKind(id)) {
            case "varint":
              params.vars.set(id, await r2.u62());
              break;
            case "uint8":
              params.vars.set(id, BigInt(await r2.u8()));
              break;
            case "bool":
              params.vars.set(id, await r2.bool() ? 1n : 0n);
              break;
            case "location": {
              const groupId = await r2.u62();
              const objectId = await r2.u62();
              params.#locations.set(id, { groupId, objectId });
              break;
            }
            case "filter":
              params.#filter = await decodeParam(r2, version2);
              break;
            case "bytes": {
              const size2 = await r2.u53();
              params.bytes.set(id, await r2.read(size2));
              break;
            }
          }
        }
        return params;
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/cluster.js
var cluster_exports = {};
__export(cluster_exports, {
  advertise: () => advertise,
  apply: () => apply,
  decodeParams: () => decodeParams,
  fromParams: () => fromParams,
  fromSetup: () => fromSetup,
  intoParams: () => intoParams,
  intoSetup: () => intoSetup,
  loops: () => loops,
  negotiated: () => negotiated,
  supported: () => supported,
  updateFromParams: () => updateFromParams,
  updateIntoParams: () => updateIntoParams
});
function supported(version2) {
  return version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16;
}
function fromSetup(params, version2) {
  if (!supported(version2))
    return void 0;
  const value = params.getVarint(SetupOption.HopId);
  if (value === void 0)
    return void 0;
  return HopSchema.parse(value);
}
function intoSetup(params, self2, version2) {
  if (!supported(version2))
    return;
  params.setVarint(SetupOption.HopId, self2);
}
function negotiated(ids) {
  return ids?.peer !== void 0;
}
function advertise(ids) {
  if (ids === void 0 || ids.peer === void 0)
    return void 0;
  return { hops: [ids.self], cost: 0n };
}
function loops(advert, self2) {
  return self2 !== UNKNOWN_HOP && advert.hops.includes(self2);
}
function intoParams(advert) {
  const params = new Parameters();
  params.hopPath = encodeHops(advert.hops);
  if (advert.cost !== 0n)
    params.routeCost = advert.cost;
  return params;
}
function updateIntoParams(update) {
  const params = new Parameters();
  if (update.hops !== void 0)
    params.hopPath = encodeHops(update.hops);
  if (update.cost !== void 0)
    params.routeCost = update.cost;
  return params;
}
function encodeHops(hops) {
  validate2(hops);
  const encoded = hops.map((hop) => encodeLeadingOnes(hop));
  const value = new Uint8Array(encoded.reduce((total, hop) => total + hop.length, 0));
  let offset = 0;
  for (const hop of encoded) {
    value.set(hop, offset);
    offset += hop.length;
  }
  return value;
}
async function decodeParams(r2, version2) {
  let params;
  try {
    params = await Parameters.decode(r2, version2);
  } catch (err2) {
    throw new ProtocolViolation(reason(err2), { cause: err2 });
  }
  return fromParams(params);
}
function fromParams(params) {
  try {
    const value = params.hopPath;
    if (value === void 0)
      throw new Error("advertisement is missing HOP_PATH");
    return { hops: decodeHops(value), cost: params.routeCost ?? 0n };
  } catch (err2) {
    throw new ProtocolViolation(reason(err2), { cause: err2 });
  }
}
function updateFromParams(params) {
  try {
    const value = params.hopPath;
    return { hops: value === void 0 ? void 0 : decodeHops(value), cost: params.routeCost };
  } catch (err2) {
    throw new ProtocolViolation(reason(err2), { cause: err2 });
  }
}
function apply(held, update) {
  return { hops: update.hops ?? held.hops, cost: update.cost ?? held.cost };
}
function decodeHops(value) {
  const hops = [];
  let rest = value;
  while (rest.length > 0) {
    const [hop, remain] = decodeLeadingOnes(rest);
    hops.push(HopSchema.parse(hop));
    rest = remain;
    if (hops.length > MAX_HOPS)
      throw new Error(`hop count exceeds maximum ${MAX_HOPS}`);
  }
  validate2(hops);
  return hops;
}
function validate2(hops) {
  if (hops.length === 0)
    throw new Error("hop path is empty");
  if (hops.length > MAX_HOPS)
    throw new Error(`hop count ${hops.length} exceeds maximum ${MAX_HOPS}`);
  for (let i2 = 0; i2 < hops.length; i2++) {
    const hop = hops[i2];
    if (hop === UNKNOWN_HOP)
      continue;
    if (hops.indexOf(hop, i2 + 1) !== -1)
      throw new Error(`hop ${hop} appears twice in the hop path`);
  }
}
var init_cluster = __esm({
  "../../node_modules/@moq/net/ietf/cluster.js"() {
    init_error2();
    init_hop();
    init_varint2();
    init_parameters();
    init_version();
  }
});

// ../../node_modules/@moq/net/connection/stats.js
async function transportStats(quic) {
  const getStats = quic.getStats;
  if (typeof getStats !== "function")
    return {};
  try {
    const stats = await getStats.call(quic);
    return {
      rtt: stats.smoothedRtt !== void 0 ? Milli(stats.smoothedRtt) : void 0,
      estimatedSendRate: stats.estimatedSendRate ?? void 0,
      bytesSent: stats.bytesSent,
      bytesReceived: stats.bytesReceived,
      bytesLost: stats.bytesLost,
      packetsSent: stats.packetsSent,
      packetsReceived: stats.packetsReceived,
      packetsLost: stats.packetsLost
    };
  } catch {
    return {};
  }
}
var init_stats = __esm({
  "../../node_modules/@moq/net/connection/stats.js"() {
    init_time();
  }
});

// ../../node_modules/@moq/web-socket-stream/index.js
function validCloseCode(code) {
  return code !== void 0 && (code === 1e3 || code >= 3e3 && code <= 4999);
}
function drain(ws, highWaterMark) {
  if (ws.bufferedAmount <= highWaterMark())
    return void 0;
  return (async () => {
    while (ws.bufferedAmount > highWaterMark()) {
      if (ws.readyState > OPEN)
        throw new Error("WebSocket is closing");
      await new Promise((resolve2) => setTimeout(resolve2, 10));
    }
  })();
}
function openWebSocketStream(url2, options = {}) {
  const href = typeof url2 === "string" ? url2 : url2.toString();
  const Native = globalThis.WebSocketStream;
  if (Native && Native !== WebSocketStream && !options.webSocket) {
    const native = new Native(href, { protocols: options.protocols, signal: options.signal });
    return {
      url: native.url,
      opened: native.opened.then((event) => ({
        ...event,
        readable: event.readable.pipeThrough(new TransformStream({
          transform(chunk, controller) {
            controller.enqueue(chunk instanceof ArrayBuffer ? new Uint8Array(chunk) : chunk);
          }
        }))
      })),
      closed: native.closed,
      close: (closeInfo) => native.close(closeInfo)
    };
  }
  return new WebSocketStream(href, options);
}
var CONNECTING, OPEN, DEFAULT_HIGH_WATER_MARK, WebSocketStream;
var init_web_socket_stream = __esm({
  "../../node_modules/@moq/web-socket-stream/index.js"() {
    CONNECTING = 0;
    OPEN = 1;
    DEFAULT_HIGH_WATER_MARK = 64 * 1024;
    WebSocketStream = class _WebSocketStream {
      url;
      opened;
      closed;
      #ws;
      #highWaterMark;
      /** Dial `url`, or wrap a socket you already have (see {@link WebSocketStream.adopt}). */
      constructor(source, options = {}) {
        let ws;
        if (typeof source === "string") {
          const Ctor = options.webSocket ?? globalThis.WebSocket;
          if (!Ctor) {
            throw new Error("No WebSocket implementation found; pass options.webSocket");
          }
          ws = new Ctor(source, options.protocols);
          this.url = source;
        } else {
          ws = source;
          this.url = source.url ?? "";
        }
        ws.binaryType = "arraybuffer";
        this.#ws = ws;
        this.#highWaterMark = Math.max(1, Math.floor(options.highWaterMark ?? DEFAULT_HIGH_WATER_MARK));
        const opened = Promise.withResolvers();
        const closed = Promise.withResolvers();
        this.opened = opened.promise;
        this.closed = closed.promise;
        this.opened.catch(() => {
        });
        let controller;
        const readable = new ReadableStream({
          start: (c2) => {
            controller = c2;
          },
          cancel: () => ws.close()
        });
        const writable = new WritableStream({
          write: (chunk) => {
            ws.send(chunk);
            return drain(ws, () => this.#highWaterMark);
          },
          // A WebSocket has no half-close, so closing/aborting the writable closes
          // the whole socket. Without this, `writer.close()` would leave it open.
          close: () => ws.close(),
          abort: () => ws.close()
        });
        ws.onopen = () => {
          opened.resolve({ readable, writable, extensions: ws.extensions, protocol: ws.protocol });
        };
        ws.onmessage = (event) => {
          const data = event.data;
          if (typeof data === "string") {
            controller?.enqueue(data);
          } else if (data instanceof ArrayBuffer) {
            controller?.enqueue(new Uint8Array(data));
          } else if (ArrayBuffer.isView(data)) {
            const view = data;
            controller?.enqueue(new Uint8Array(view.buffer, view.byteOffset, view.byteLength));
          }
        };
        ws.onerror = () => {
          const err2 = new Error("WebSocket connection error");
          opened.reject(err2);
          try {
            controller?.error(err2);
          } catch {
          }
        };
        ws.onclose = (event) => {
          opened.reject(new Error("WebSocket closed before opening"));
          try {
            controller?.close();
          } catch {
          }
          closed.resolve({ closeCode: event.code ?? 1006, reason: event.reason ?? "" });
        };
        if (ws.readyState !== CONNECTING) {
          if (ws.readyState === OPEN) {
            opened.resolve({ readable, writable, extensions: ws.extensions, protocol: ws.protocol });
          } else {
            opened.reject(new Error("WebSocket is already closed"));
            try {
              controller?.close();
            } catch {
            }
            closed.resolve({ closeCode: 1006, reason: "" });
          }
        }
        const { signal } = options;
        if (signal) {
          if (signal.aborted)
            ws.close();
          else
            signal.addEventListener("abort", () => ws.close(), { once: true });
        }
      }
      /** Wrap a socket that already exists — typically one a server accepted from an
       *  HTTP upgrade (`Deno.upgradeWebSocket`, `ws`, ...), where there is no URL to
       *  dial and the handshake (including subprotocol selection) is already done.
       *
       *  Ownership transfers: this overwrites the socket's `onopen`/`onmessage`/
       *  `onerror`/`onclose` handlers, so adopt it before anything else reads from
       *  it — messages delivered before adoption are dropped by the platform, not
       *  buffered. A socket that is already open resolves {@link opened} without
       *  waiting for an `onopen` that has already fired (or was never going to).
       *
       *  `options.protocols` and `options.webSocket` are ignored; the socket exists. */
      static adopt(ws, options = {}) {
        return new _WebSocketStream(ws, options);
      }
      close(closeInfo = {}) {
        if (validCloseCode(closeInfo.closeCode)) {
          this.#ws.close(closeInfo.closeCode, closeInfo.reason);
        } else {
          this.#ws.close();
        }
      }
      /** The current write-backpressure high-water mark, in bytes. */
      get highWaterMark() {
        return this.#highWaterMark;
      }
      /** Resize the write-backpressure high-water mark at runtime (bytes).
       *
       * Set this to roughly the bandwidth-delay product (RTT × estimated
       * throughput): large enough to keep the socket busy, small enough that
       * queued bytes can still be reprioritized rather than committed to the OS
       * send buffer. Takes effect immediately, including for an in-progress drain.
       * Clamped to a minimum of 1 byte. */
      setHighWaterMark(bytes) {
        this.#highWaterMark = Math.max(1, Math.floor(bytes));
      }
    };
  }
});

// ../../node_modules/@moq/qmux/credit.js
function replenishWindow(consumed, currentMax, window2) {
  if (window2 === 0n)
    return null;
  if (currentMax - consumed <= window2 / 2n)
    return consumed + window2;
  return null;
}
var Credit;
var init_credit = __esm({
  "../../node_modules/@moq/qmux/credit.js"() {
    Credit = class {
      #used;
      #max;
      #released = 0n;
      #closed = false;
      #closeReason;
      #waiters = [];
      constructor(max) {
        this.#used = 0n;
        this.#max = max;
      }
      /** Try to claim up to `limit` units. Returns amount claimed (0n if none available). */
      tryClaim(limit) {
        if (limit === 0n)
          return 0n;
        const available = this.#max - this.#used;
        if (available <= 0n)
          return 0n;
        const claimed = limit < available ? limit : available;
        this.#used += claimed;
        return claimed;
      }
      /** Claim up to `limit` units, waiting until credit is available.
       *  Rejects if the credit has been closed. Returns 0n for zero-limit requests. */
      async claim(limit) {
        if (limit === 0n)
          return 0n;
        while (true) {
          if (this.#closed)
            throw this.#closeReason ?? new Error("closed");
          const claimed = this.tryClaim(limit);
          if (claimed > 0n)
            return claimed;
          await new Promise((resolve2, reject) => {
            this.#waiters.push({ resolve: resolve2, reject });
          });
        }
      }
      /** Return previously claimed credit (for rollback). */
      release(amount) {
        this.#used = this.#used > amount ? this.#used - amount : 0n;
        this.#wake();
      }
      /** Increase the max. Returns false if new_max < current max. */
      increaseMax(newMax) {
        if (newMax < this.#max)
          return false;
        if (newMax === this.#max)
          return true;
        this.#max = newMax;
        this.#wake();
        return true;
      }
      /** Close the credit, rejecting all pending and future `claim()` calls.
       *  `reason` (if provided) becomes the rejection error; the first reason wins. */
      close(reason2) {
        this.#closed = true;
        this.#closeReason ??= reason2 ?? new Error("closed");
        const waiters = this.#waiters;
        this.#waiters = [];
        for (const { reject } of waiters)
          reject(this.#closeReason);
      }
      /** Set used to max(used, value). Returns false if value > max (flow control violation). */
      receiveUpTo(value) {
        if (value > this.#max)
          return false;
        if (value > this.#used)
          this.#used = value;
        return true;
      }
      /** Report that `len` units have been consumed.
       *  Returns the new max if a window update should be sent, or null otherwise. */
      consume(len) {
        this.#released += len;
        if (this.#used + 2n * this.#released > this.#max) {
          const newMax = this.#max + this.#released;
          this.#max = newMax;
          this.#released = 0n;
          this.#wake();
          return newMax;
        }
        return null;
      }
      /** Get current available credit (max - used). */
      get available() {
        const avail = this.#max - this.#used;
        return avail > 0n ? avail : 0n;
      }
      /** Get the current max value. */
      get max() {
        return this.#max;
      }
      /** Get the current used value. */
      get used() {
        return this.#used;
      }
      #wake() {
        const waiters = this.#waiters;
        this.#waiters = [];
        for (const { resolve: resolve2 } of waiters)
          resolve2();
      }
    };
  }
});

// ../../node_modules/@moq/qmux/error.js
function resetCode(reason2) {
  if (typeof reason2 !== "object" || reason2 === null)
    return 0;
  const { streamErrorCode } = reason2;
  if (typeof streamErrorCode !== "number")
    return 0;
  return streamErrorCode >>> 0;
}
function streamCode2(code) {
  return Number(BigInt.asUintN(32, code));
}
var SessionError, StreamError;
var init_error3 = __esm({
  "../../node_modules/@moq/qmux/error.js"() {
    SessionError = class extends Error {
      source = "session";
      streamErrorCode = null;
      constructor(message, options) {
        super(message, options);
        this.name = "WebTransportError";
      }
    };
    StreamError = class extends Error {
      source = "stream";
      streamErrorCode;
      constructor(code, message = "stream reset") {
        super(`${message}: ${code}`);
        this.name = "WebTransportError";
        this.streamErrorCode = code;
      }
    };
  }
});

// ../../node_modules/@moq/qmux/varint.js
var VarInt;
var init_varint3 = __esm({
  "../../node_modules/@moq/qmux/varint.js"() {
    VarInt = class _VarInt {
      static MAX = (1n << 62n) - 1n;
      static MAX_SIZE = 8;
      value;
      constructor(value) {
        if (value < 0n || value > _VarInt.MAX) {
          throw new Error(`VarInt value out of range: ${value}`);
        }
        this.value = value;
      }
      static from(value) {
        return new _VarInt(BigInt(value));
      }
      size() {
        const x4 = this.value;
        if (x4 < 2n ** 6n)
          return 1;
        if (x4 < 2n ** 14n)
          return 2;
        if (x4 < 2n ** 30n)
          return 4;
        if (x4 < 2n ** 62n)
          return 8;
        throw new Error("VarInt value too large");
      }
      // Append to the provided buffer
      encode(dst) {
        const x4 = this.value;
        const size2 = this.size();
        if (dst.byteOffset + dst.byteLength + size2 > dst.buffer.byteLength) {
          throw new Error("destination buffer too small");
        }
        const view = new DataView(dst.buffer, dst.byteOffset + dst.byteLength, size2);
        if (size2 === 1) {
          view.setUint8(0, Number(x4));
        } else if (size2 === 2) {
          view.setUint16(0, 1 << 14 | Number(x4), false);
        } else if (size2 === 4) {
          view.setUint32(0, 2 << 30 | Number(x4), false);
        } else if (size2 === 8) {
          view.setBigUint64(0, 3n << 62n | x4, false);
        } else {
          throw new Error("VarInt value too large");
        }
        return new Uint8Array(dst.buffer, dst.byteOffset, dst.byteLength + size2);
      }
      static decode(buffer) {
        if (buffer.byteLength < 1) {
          throw new Error("Unexpected end of buffer");
        }
        const view = new DataView(buffer.buffer, buffer.byteOffset);
        const firstByte = view.getUint8(0);
        const tag = firstByte >> 6;
        let value;
        let bytesRead;
        switch (tag) {
          case 0:
            value = BigInt(firstByte & 63);
            bytesRead = 1;
            break;
          case 1:
            if (2 > buffer.length) {
              throw new Error("Unexpected end of buffer");
            }
            value = BigInt(view.getUint16(0, false) & 16383);
            bytesRead = 2;
            break;
          case 2:
            if (4 > buffer.length) {
              throw new Error("Unexpected end of buffer");
            }
            value = BigInt(view.getUint32(0, false) & 1073741823);
            bytesRead = 4;
            break;
          case 3:
            if (8 > buffer.length) {
              throw new Error("Unexpected end of buffer");
            }
            value = view.getBigUint64(0, false) & 0x3fffffffffffffffn;
            bytesRead = 8;
            break;
          default:
            throw new Error("Invalid VarInt tag");
        }
        const remaining = new Uint8Array(buffer.buffer, buffer.byteOffset + bytesRead, buffer.byteLength - bytesRead);
        return [new _VarInt(value), remaining];
      }
    };
  }
});

// ../../node_modules/@moq/qmux/stream.js
var Dir, Id;
var init_stream2 = __esm({
  "../../node_modules/@moq/qmux/stream.js"() {
    init_varint3();
    Dir = {
      Bi: 0,
      Uni: 1
    };
    Id = class _Id {
      value;
      constructor(value) {
        this.value = value;
      }
      static create(id, dir, isServer) {
        let streamId = id << 2n;
        if (dir === Dir.Uni) {
          streamId |= 0x02n;
        }
        if (isServer) {
          streamId |= 0x01n;
        }
        return new _Id(VarInt.from(streamId));
      }
      get dir() {
        return (this.value.value & 0x02n) !== 0n ? Dir.Uni : Dir.Bi;
      }
      get serverInitiated() {
        return (this.value.value & 0x01n) !== 0n;
      }
      /** Returns the 0-based sequence index of this stream. */
      get index() {
        return this.value.value >> 2n;
      }
      canRecv(isServer) {
        if (this.dir === Dir.Uni) {
          return this.serverInitiated !== isServer;
        }
        return true;
      }
      canSend(isServer) {
        if (this.dir === Dir.Uni) {
          return this.serverInitiated === isServer;
        }
        return true;
      }
    };
  }
});

// ../../node_modules/@moq/qmux/frame.js
function maxLengthPrefixedPayload(available) {
  let best = 0n;
  for (const max of VARINT_MAX) {
    const width = BigInt(VarInt.from(max).size());
    if (available < width)
      break;
    const candidate = available - width < max ? available - width : max;
    if (VarInt.from(candidate).size() === Number(width) && candidate > best)
      best = candidate;
  }
  return best;
}
function maxStreamPayload(version2, budget, id, offset) {
  const header2 = BigInt(1 + id.value.size());
  if (version2 === "webtransport") {
    return budget > header2 ? budget - header2 : 0n;
  }
  const fixed = header2 + BigInt(VarInt.from(offset).size());
  return maxLengthPrefixedPayload(budget > fixed ? budget - fixed : 0n);
}
function encode7(frame, version2 = "webtransport") {
  if (version2 === "webtransport") {
    return encodeWebTransport(frame);
  }
  return encodeQMux(frame);
}
function isQmux(version2) {
  return version2 === "qmux-00" || version2 === "qmux-01" || version2 === "qmux-02";
}
function usesRecords(version2) {
  return version2 === "qmux-01" || version2 === "qmux-02";
}
function encodeWebTransport(frame) {
  switch (frame.type) {
    case "stream": {
      let buffer = new Uint8Array(new ArrayBuffer(1 + 8 + frame.data.length), 0, 1);
      buffer[0] = frame.fin ? 9 : 8;
      buffer = frame.id.value.encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + frame.data.length);
      buffer.set(frame.data, buffer.byteLength - frame.data.length);
      return buffer;
    }
    case "reset_stream": {
      let buffer = new Uint8Array(new ArrayBuffer(1 + 8 + 8), 0, 1);
      buffer[0] = 4;
      buffer = frame.id.value.encode(buffer);
      buffer = frame.code.encode(buffer);
      return buffer;
    }
    case "stop_sending": {
      let buffer = new Uint8Array(new ArrayBuffer(1 + 8 + 8), 0, 1);
      buffer[0] = 5;
      buffer = frame.id.value.encode(buffer);
      buffer = frame.code.encode(buffer);
      return buffer;
    }
    // The legacy WebTransport format keeps the reason as the rest of the buffer
    // (no Frame Type / length fields); only the type byte differs.
    case "connection_close":
    case "application_close": {
      const body = new TextEncoder().encode(frame.reason);
      let buffer = new Uint8Array(new ArrayBuffer(1 + 8 + body.length), 0, 1);
      buffer[0] = frame.type === "application_close" ? 29 : 28;
      buffer = frame.code.encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + body.length);
      buffer.set(body, buffer.byteLength - body.length);
      return buffer;
    }
    default:
      throw new Error("flow control frames are not supported in WebTransport version");
  }
}
function encodeQMux(frame) {
  switch (frame.type) {
    case "stream": {
      const frameType = VarInt.from(14 | (frame.fin ? 1 : 0));
      const offsetVi = VarInt.from(frame.offset ?? 0n);
      const lengthVi = VarInt.from(frame.data.length);
      const maxSize = 8 + 8 + 8 + 8 + frame.data.length;
      let buffer = new Uint8Array(new ArrayBuffer(maxSize), 0, 0);
      buffer = frameType.encode(buffer);
      buffer = frame.id.value.encode(buffer);
      buffer = offsetVi.encode(buffer);
      buffer = lengthVi.encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + frame.data.length);
      buffer.set(frame.data, buffer.byteLength - frame.data.length);
      return buffer;
    }
    case "reset_stream": {
      const frameType = VarInt.from(4);
      const finalSize = VarInt.from(frame.finalSize);
      let buffer = new Uint8Array(new ArrayBuffer(8 + 8 + 8 + 8), 0, 0);
      buffer = frameType.encode(buffer);
      buffer = frame.id.value.encode(buffer);
      buffer = frame.code.encode(buffer);
      buffer = finalSize.encode(buffer);
      return buffer;
    }
    case "stop_sending": {
      const frameType = VarInt.from(5);
      let buffer = new Uint8Array(new ArrayBuffer(8 + 8 + 8), 0, 0);
      buffer = frameType.encode(buffer);
      buffer = frame.id.value.encode(buffer);
      buffer = frame.code.encode(buffer);
      return buffer;
    }
    case "connection_close": {
      const frameType = VarInt.from(28);
      const causingFrameType = VarInt.from(0);
      const body = new TextEncoder().encode(frame.reason);
      const reasonLength = VarInt.from(body.length);
      let buffer = new Uint8Array(new ArrayBuffer(8 + 8 + 8 + 8 + body.length), 0, 0);
      buffer = frameType.encode(buffer);
      buffer = frame.code.encode(buffer);
      buffer = causingFrameType.encode(buffer);
      buffer = reasonLength.encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + body.length);
      buffer.set(body, buffer.byteLength - body.length);
      return buffer;
    }
    case "application_close": {
      const frameType = VarInt.from(29);
      const body = new TextEncoder().encode(frame.reason);
      const reasonLength = VarInt.from(body.length);
      let buffer = new Uint8Array(new ArrayBuffer(8 + 8 + 8 + body.length), 0, 0);
      buffer = frameType.encode(buffer);
      buffer = frame.code.encode(buffer);
      buffer = reasonLength.encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + body.length);
      buffer.set(body, buffer.byteLength - body.length);
      return buffer;
    }
    case "max_data": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(16).encode(buffer);
      buffer = VarInt.from(frame.max).encode(buffer);
      return buffer;
    }
    case "max_stream_data": {
      let buffer = new Uint8Array(new ArrayBuffer(24), 0, 0);
      buffer = VarInt.from(17).encode(buffer);
      buffer = frame.id.value.encode(buffer);
      buffer = VarInt.from(frame.max).encode(buffer);
      return buffer;
    }
    case "max_streams_bidi": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(18).encode(buffer);
      buffer = VarInt.from(frame.max).encode(buffer);
      return buffer;
    }
    case "max_streams_uni": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(19).encode(buffer);
      buffer = VarInt.from(frame.max).encode(buffer);
      return buffer;
    }
    case "data_blocked": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(20).encode(buffer);
      buffer = VarInt.from(frame.limit).encode(buffer);
      return buffer;
    }
    case "stream_data_blocked": {
      let buffer = new Uint8Array(new ArrayBuffer(24), 0, 0);
      buffer = VarInt.from(21).encode(buffer);
      buffer = frame.id.value.encode(buffer);
      buffer = VarInt.from(frame.limit).encode(buffer);
      return buffer;
    }
    case "streams_blocked_bidi": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(22).encode(buffer);
      buffer = VarInt.from(frame.limit).encode(buffer);
      return buffer;
    }
    case "streams_blocked_uni": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(23).encode(buffer);
      buffer = VarInt.from(frame.limit).encode(buffer);
      return buffer;
    }
    case "transport_parameters": {
      const payload = encodeTransportParams(frame.params);
      let buffer = new Uint8Array(new ArrayBuffer(8 + 8 + payload.byteLength), 0, 0);
      buffer = VarInt.from(0x3f5153300d0a0d0an).encode(buffer);
      buffer = VarInt.from(payload.byteLength).encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + payload.byteLength);
      buffer.set(payload, buffer.byteLength - payload.byteLength);
      return buffer;
    }
    case "ping_request": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(QX_PING_REQUEST).encode(buffer);
      buffer = VarInt.from(frame.sequence).encode(buffer);
      return buffer;
    }
    case "ping_response": {
      let buffer = new Uint8Array(new ArrayBuffer(16), 0, 0);
      buffer = VarInt.from(QX_PING_RESPONSE).encode(buffer);
      buffer = VarInt.from(frame.sequence).encode(buffer);
      return buffer;
    }
    case "datagram": {
      const lengthVi = VarInt.from(frame.data.length);
      let buffer = new Uint8Array(new ArrayBuffer(8 + 8 + frame.data.length), 0, 0);
      buffer = VarInt.from(49).encode(buffer);
      buffer = lengthVi.encode(buffer);
      buffer = new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength + frame.data.length);
      buffer.set(frame.data, buffer.byteLength - frame.data.length);
      return buffer;
    }
  }
}
function encodeTransportParams(params) {
  let buffer = new Uint8Array(new ArrayBuffer(256), 0, 0);
  function writeParam(buf, id, value) {
    if (value === 0n)
      return buf;
    const valVi = VarInt.from(value);
    buf = VarInt.from(id).encode(buf);
    buf = VarInt.from(valVi.size()).encode(buf);
    buf = valVi.encode(buf);
    return buf;
  }
  buffer = writeParam(buffer, 1, params.maxIdleTimeout);
  buffer = writeParam(buffer, 4, params.initialMaxData);
  buffer = writeParam(buffer, 5, params.initialMaxStreamDataBidiLocal);
  buffer = writeParam(buffer, 6, params.initialMaxStreamDataBidiRemote);
  buffer = writeParam(buffer, 7, params.initialMaxStreamDataUni);
  buffer = writeParam(buffer, 8, params.initialMaxStreamsBidi);
  buffer = writeParam(buffer, 9, params.initialMaxStreamsUni);
  buffer = writeParam(buffer, 32, params.maxDatagramFrameSize);
  buffer = writeParam(buffer, MAX_RECORD_SIZE_ID, params.maxRecordSize);
  if (params.resetStreamAt) {
    buffer = VarInt.from(RESET_STREAM_AT_PARAM_ID).encode(buffer);
    buffer = VarInt.from(0).encode(buffer);
  }
  return buffer;
}
function decodeTransportParams(buffer) {
  const params = { ...DEFAULT_TRANSPORT_PARAMS };
  const seen = /* @__PURE__ */ new Set();
  let v3;
  while (buffer.byteLength > 0) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = v3.value;
    [v3, buffer] = VarInt.decode(buffer);
    const len = Number(v3.value);
    if (buffer.byteLength < len) {
      throw new Error("transport parameter truncated");
    }
    const paramData = buffer.slice(0, len);
    buffer = buffer.slice(len);
    if (RECOGNIZED_PARAM_IDS.has(id)) {
      if (seen.has(id)) {
        throw new Error(`duplicate transport parameter 0x${id.toString(16)}`);
      }
      seen.add(id);
    }
    if (id === APPLICATION_PROTOCOLS_ID) {
      throw new Error("unexpected application_protocols parameter over WebSocket");
    }
    if (id === RESET_STREAM_AT_PARAM_ID) {
      if (paramData.byteLength !== 0) {
        throw new Error("reset_stream_at transport parameter must be empty");
      }
      params.resetStreamAt = true;
      continue;
    }
    if (id === 0x00n || id === 0x02n || id === 0x03n || id >= 0x0an && id <= 0x10n) {
      throw new Error(`forbidden QUIC v1 transport parameter 0x${id.toString(16)}`);
    }
    if (!RECOGNIZED_PARAM_IDS.has(id)) {
      continue;
    }
    const [paramValueVarInt, remaining] = VarInt.decode(paramData);
    if (remaining.byteLength !== 0) {
      throw new Error(`transport parameter 0x${id.toString(16)} has trailing bytes`);
    }
    const paramValue = paramValueVarInt.value;
    switch (id) {
      case 0x01n:
        params.maxIdleTimeout = paramValue;
        break;
      case 0x04n:
        params.initialMaxData = paramValue;
        break;
      case 0x05n:
        params.initialMaxStreamDataBidiLocal = paramValue;
        break;
      case 0x06n:
        params.initialMaxStreamDataBidiRemote = paramValue;
        break;
      case 0x07n:
        params.initialMaxStreamDataUni = paramValue;
        break;
      case 0x08n:
        params.initialMaxStreamsBidi = paramValue;
        break;
      case 0x09n:
        params.initialMaxStreamsUni = paramValue;
        break;
      case 0x20n:
        params.maxDatagramFrameSize = paramValue;
        break;
      case MAX_RECORD_SIZE_ID:
        params.maxRecordSize = paramValue;
        break;
      default:
        throw new Error(`unhandled recognized transport parameter 0x${id.toString(16)}`);
    }
  }
  return params;
}
function decode7(buffer, version2 = "webtransport") {
  if (buffer.length === 0) {
    throw new Error("Invalid frame: empty buffer");
  }
  if (version2 === "webtransport") {
    return decodeWebTransport(buffer);
  }
  return decodeQMux(buffer);
}
function take(buffer, len) {
  if (buffer.byteLength < len) {
    throw new Error(`frame truncated: need ${len} bytes, have ${buffer.byteLength}`);
  }
  return [buffer.slice(0, len), buffer.slice(len)];
}
function decodeRecord(buffer) {
  const frames = [];
  while (buffer.byteLength > 0) {
    const result = decodeQMuxOne(buffer);
    if (result === null)
      break;
    const [frame, remaining] = result;
    if (frame !== null) {
      frames.push(frame);
    }
    buffer = remaining;
  }
  return frames;
}
function decodeWebTransport(buffer) {
  const frameType = buffer[0];
  buffer = buffer.slice(1);
  let v3;
  if (frameType === 4) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    return { type: "reset_stream", id, code, finalSize: 0n };
  }
  if (frameType === 5) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    return { type: "stop_sending", id, code };
  }
  if (frameType === 29 || frameType === 28) {
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    const reason2 = new TextDecoder().decode(buffer);
    return frameType === 29 ? { type: "application_close", code, reason: reason2 } : { type: "connection_close", code, reason: reason2 };
  }
  if (frameType === 8 || frameType === 9) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    return {
      type: "stream",
      id,
      data: buffer,
      fin: frameType === 9
    };
  }
  throw new Error(`Invalid frame type: ${frameType}`);
}
function decodeQMux(buffer) {
  let v3;
  [v3, buffer] = VarInt.decode(buffer);
  const frameType = v3.value;
  if (frameType === 0x00n) {
    return null;
  }
  if (frameType >= 0x08n && frameType <= 0x0fn) {
    const hasOff = (frameType & 0x04n) !== 0n;
    const hasLen = (frameType & 0x02n) !== 0n;
    const hasFin = (frameType & 0x01n) !== 0n;
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    let offset = 0n;
    if (hasOff) {
      [v3, buffer] = VarInt.decode(buffer);
      offset = v3.value;
    }
    let data;
    if (hasLen) {
      [v3, buffer] = VarInt.decode(buffer);
      const len = Number(v3.value);
      [data, buffer] = take(buffer, len);
    } else {
      data = buffer;
    }
    return { type: "stream", id, offset, data, fin: hasFin };
  }
  if (frameType === 0x04n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    [v3, buffer] = VarInt.decode(buffer);
    const finalSize = v3.value;
    return { type: "reset_stream", id, code, finalSize };
  }
  if (frameType === RESET_STREAM_AT) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    [v3, buffer] = VarInt.decode(buffer);
    const finalSize = v3.value;
    [v3, buffer] = VarInt.decode(buffer);
    const reliableSize = v3.value;
    if (reliableSize > finalSize) {
      throw new Error("RESET_STREAM_AT reliable_size exceeds final_size");
    }
    return { type: "reset_stream", id, code, finalSize, reliableSize };
  }
  if (frameType === 0x05n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    return { type: "stop_sending", id, code };
  }
  if (frameType === 0x1cn || frameType === 0x1dn) {
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    if (frameType === 0x1cn) {
      [v3, buffer] = VarInt.decode(buffer);
    }
    [v3, buffer] = VarInt.decode(buffer);
    const reasonLen = Number(v3.value);
    let reasonBytes;
    [reasonBytes, buffer] = take(buffer, reasonLen);
    const reason2 = new TextDecoder().decode(reasonBytes);
    return frameType === 0x1dn ? { type: "application_close", code, reason: reason2 } : { type: "connection_close", code, reason: reason2 };
  }
  if (frameType === 0x10n) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "max_data", max: v3.value };
  }
  if (frameType === 0x11n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "max_stream_data", id, max: v3.value };
  }
  if (frameType === 0x12n) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "max_streams_bidi", max: v3.value };
  }
  if (frameType === 0x13n) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "max_streams_uni", max: v3.value };
  }
  if (frameType === 0x14n) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "data_blocked", limit: v3.value };
  }
  if (frameType === 0x15n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "stream_data_blocked", id, limit: v3.value };
  }
  if (frameType === 0x16n) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "streams_blocked_bidi", limit: v3.value };
  }
  if (frameType === 0x17n) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "streams_blocked_uni", limit: v3.value };
  }
  if (frameType === 0x3f5153300d0a0d0an) {
    [v3, buffer] = VarInt.decode(buffer);
    const len = Number(v3.value);
    let payload;
    [payload, buffer] = take(buffer, len);
    const params = decodeTransportParams(payload);
    return { type: "transport_parameters", params };
  }
  if (frameType === QX_PING_REQUEST) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "ping_request", sequence: v3.value };
  }
  if (frameType === QX_PING_RESPONSE) {
    [v3, buffer] = VarInt.decode(buffer);
    return { type: "ping_response", sequence: v3.value };
  }
  if (frameType === 0x30n) {
    return { type: "datagram", data: buffer, lengthPrefixed: false };
  }
  if (frameType === 0x31n) {
    [v3, buffer] = VarInt.decode(buffer);
    const len = Number(v3.value);
    let data;
    [data, buffer] = take(buffer, len);
    return { type: "datagram", data, lengthPrefixed: true };
  }
  throw new Error(`Invalid QMux frame type: 0x${frameType.toString(16)}`);
}
function decodeQMuxOne(buffer) {
  if (buffer.byteLength === 0)
    return null;
  let v3;
  [v3, buffer] = VarInt.decode(buffer);
  const frameType = v3.value;
  if (frameType === 0x00n) {
    return [null, buffer];
  }
  if (frameType >= 0x08n && frameType <= 0x0fn) {
    const hasOff = (frameType & 0x04n) !== 0n;
    const hasLen = (frameType & 0x02n) !== 0n;
    const hasFin = (frameType & 0x01n) !== 0n;
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    let offset = 0n;
    if (hasOff) {
      [v3, buffer] = VarInt.decode(buffer);
      offset = v3.value;
    }
    let data;
    if (hasLen) {
      [v3, buffer] = VarInt.decode(buffer);
      const len = Number(v3.value);
      [data, buffer] = take(buffer, len);
    } else {
      data = buffer;
      buffer = buffer.slice(buffer.byteLength);
    }
    return [{ type: "stream", id, offset, data, fin: hasFin }, buffer];
  }
  if (frameType === 0x04n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    [v3, buffer] = VarInt.decode(buffer);
    const finalSize = v3.value;
    return [{ type: "reset_stream", id, code, finalSize }, buffer];
  }
  if (frameType === RESET_STREAM_AT) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    [v3, buffer] = VarInt.decode(buffer);
    const finalSize = v3.value;
    [v3, buffer] = VarInt.decode(buffer);
    const reliableSize = v3.value;
    if (reliableSize > finalSize) {
      throw new Error("RESET_STREAM_AT reliable_size exceeds final_size");
    }
    return [{ type: "reset_stream", id, code, finalSize, reliableSize }, buffer];
  }
  if (frameType === 0x05n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    return [{ type: "stop_sending", id, code }, buffer];
  }
  if (frameType === 0x1cn || frameType === 0x1dn) {
    [v3, buffer] = VarInt.decode(buffer);
    const code = v3;
    if (frameType === 0x1cn) {
      [v3, buffer] = VarInt.decode(buffer);
    }
    [v3, buffer] = VarInt.decode(buffer);
    const reasonLen = Number(v3.value);
    let reasonBytes;
    [reasonBytes, buffer] = take(buffer, reasonLen);
    const reason2 = new TextDecoder().decode(reasonBytes);
    const close = frameType === 0x1dn ? { type: "application_close", code, reason: reason2 } : { type: "connection_close", code, reason: reason2 };
    return [close, buffer];
  }
  if (frameType === 0x10n) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "max_data", max: v3.value }, buffer];
  }
  if (frameType === 0x11n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "max_stream_data", id, max: v3.value }, buffer];
  }
  if (frameType === 0x12n) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "max_streams_bidi", max: v3.value }, buffer];
  }
  if (frameType === 0x13n) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "max_streams_uni", max: v3.value }, buffer];
  }
  if (frameType === 0x14n) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "data_blocked", limit: v3.value }, buffer];
  }
  if (frameType === 0x15n) {
    [v3, buffer] = VarInt.decode(buffer);
    const id = new Id(v3);
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "stream_data_blocked", id, limit: v3.value }, buffer];
  }
  if (frameType === 0x16n) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "streams_blocked_bidi", limit: v3.value }, buffer];
  }
  if (frameType === 0x17n) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "streams_blocked_uni", limit: v3.value }, buffer];
  }
  if (frameType === 0x3f5153300d0a0d0an) {
    [v3, buffer] = VarInt.decode(buffer);
    const len = Number(v3.value);
    let payload;
    [payload, buffer] = take(buffer, len);
    const params = decodeTransportParams(payload);
    return [{ type: "transport_parameters", params }, buffer];
  }
  if (frameType === QX_PING_REQUEST) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "ping_request", sequence: v3.value }, buffer];
  }
  if (frameType === QX_PING_RESPONSE) {
    [v3, buffer] = VarInt.decode(buffer);
    return [{ type: "ping_response", sequence: v3.value }, buffer];
  }
  if (frameType === 0x30n) {
    const data = buffer;
    return [{ type: "datagram", data, lengthPrefixed: false }, buffer.slice(buffer.byteLength)];
  }
  if (frameType === 0x31n) {
    [v3, buffer] = VarInt.decode(buffer);
    const len = Number(v3.value);
    let data;
    [data, buffer] = take(buffer, len);
    return [{ type: "datagram", data, lengthPrefixed: true }, buffer];
  }
  throw new Error(`Invalid QMux frame type: 0x${frameType.toString(16)}`);
}
var MAX_FRAME_SIZE, MAX_FRAME_PAYLOAD, VARINT_MAX, DEFAULT_MAX_RECORD_SIZE, DEFAULT_TRANSPORT_PARAMS, QX_PING_REQUEST, QX_PING_RESPONSE, RESET_STREAM_AT, MAX_RECORD_SIZE_ID, APPLICATION_PROTOCOLS_ID, RESET_STREAM_AT_PARAM_ID, RECOGNIZED_PARAM_IDS;
var init_frame = __esm({
  "../../node_modules/@moq/qmux/frame.js"() {
    init_stream2();
    init_varint3();
    MAX_FRAME_SIZE = 16384;
    MAX_FRAME_PAYLOAD = MAX_FRAME_SIZE - 32;
    VARINT_MAX = [63n, 16383n, 1073741823n, 4611686018427387903n];
    DEFAULT_MAX_RECORD_SIZE = 16382n;
    DEFAULT_TRANSPORT_PARAMS = {
      maxIdleTimeout: 0n,
      initialMaxData: 0n,
      initialMaxStreamDataBidiLocal: 0n,
      initialMaxStreamDataBidiRemote: 0n,
      initialMaxStreamDataUni: 0n,
      initialMaxStreamsBidi: 0n,
      initialMaxStreamsUni: 0n,
      maxDatagramFrameSize: 0n,
      maxRecordSize: DEFAULT_MAX_RECORD_SIZE,
      resetStreamAt: false
    };
    QX_PING_REQUEST = 0x348c67529ef8c7bdn;
    QX_PING_RESPONSE = 0x348c67529ef8c7ben;
    RESET_STREAM_AT = 0x24n;
    MAX_RECORD_SIZE_ID = 0x0571c59429cd0845n;
    APPLICATION_PROTOCOLS_ID = 0x3d4f9c2a8b1e6075n;
    RESET_STREAM_AT_PARAM_ID = 0x1dn;
    RECOGNIZED_PARAM_IDS = /* @__PURE__ */ new Set([
      0x01n,
      0x04n,
      0x05n,
      0x06n,
      0x07n,
      0x08n,
      0x09n,
      0x20n,
      MAX_RECORD_SIZE_ID,
      APPLICATION_PROTOCOLS_ID,
      RESET_STREAM_AT_PARAM_ID
    ]);
  }
});

// ../../node_modules/@moq/qmux/recv.js
var RecvStream;
var init_recv = __esm({
  "../../node_modules/@moq/qmux/recv.js"() {
    RecvStream = class {
      #queue = [];
      #fin = false;
      #error;
      #wake;
      #terminal = false;
      #onTerminal;
      /** The application-facing readable. */
      readable;
      /**
       * @param onConsume Invoked with each chunk's byte length as it is delivered
       *   to the reader. Drives MAX_STREAM_DATA.
       * @param onCancel Invoked with the number of discarded buffered bytes, and the reason the
       *   application passed to `cancel()`, when the application cancels the readable
       *   (→ STOP_SENDING, whose code comes from that reason).
       * @param onTerminal Invoked once when FIN, RESET_STREAM, or local cancellation
       *   makes the receive side terminal.
       */
      constructor(onConsume, onCancel, onTerminal = () => {
      }) {
        this.#onTerminal = onTerminal;
        this.readable = new ReadableStream({
          pull: async (controller) => {
            while (this.#queue.length === 0) {
              if (this.#error) {
                controller.error(this.#error);
                return;
              }
              if (this.#fin) {
                controller.close();
                return;
              }
              await new Promise((resolve2) => {
                this.#wake = resolve2;
              });
            }
            const chunk = this.#queue.shift();
            controller.enqueue(chunk);
            onConsume(chunk.byteLength);
          },
          cancel: (reason2) => {
            this.#error ??= new Error("stream cancelled");
            onCancel(this.#discard(), reason2);
            this.#notifyTerminal();
            this.#signal();
          }
        }, { highWaterMark: 0 });
      }
      /** Buffer a received chunk for delivery. Ignored after FIN/error. */
      push(chunk) {
        if (this.#fin || this.#error)
          return false;
        this.#queue.push(chunk);
        this.#signal();
        return true;
      }
      /** Mark end-of-stream; the readable closes once buffered data drains. */
      finish() {
        this.#fin = true;
        this.#notifyTerminal();
        this.#signal();
      }
      /** Abort the readable because the peer reset its sending side. */
      reset(err2) {
        const discarded = this.error(err2);
        this.#notifyTerminal();
        return discarded;
      }
      /** Abort the readable, discarding undelivered buffered data. */
      error(err2) {
        if (this.#error)
          return 0;
        this.#error = err2;
        const discarded = this.#discard();
        this.#signal();
        return discarded;
      }
      #discard() {
        let bytes = 0;
        for (const chunk of this.#queue)
          bytes += chunk.byteLength;
        this.#queue = [];
        return bytes;
      }
      #notifyTerminal() {
        if (this.#terminal)
          return;
        this.#terminal = true;
        this.#onTerminal();
      }
      #signal() {
        const wake = this.#wake;
        if (wake) {
          this.#wake = void 0;
          wake();
        }
      }
    };
  }
});

// ../../node_modules/@moq/qmux/scheduler.js
var WritableStreamSink, DEFAULT_SEND_ORDER, DATAGRAM_QUEUE_LIMIT, SendScheduler;
var init_scheduler = __esm({
  "../../node_modules/@moq/qmux/scheduler.js"() {
    WritableStreamSink = class {
      #writer;
      constructor(writable) {
        this.#writer = writable.getWriter();
      }
      ready() {
        return this.#writer.ready;
      }
      write(bytes) {
        return this.#writer.write(bytes);
      }
      wantsMore() {
        const desired = this.#writer.desiredSize;
        return desired !== null && desired > 0;
      }
    };
    DEFAULT_SEND_ORDER = 0;
    DATAGRAM_QUEUE_LIMIT = 1024;
    SendScheduler = class {
      #sink;
      #onActivity;
      #controlHighWater;
      #closed;
      // Control frames preempt all stream data, FIFO among themselves.
      #control = [];
      #controlBytes = 0;
      // Datagrams: serviced after control, ahead of stream data. Bounded and lossy
      // (unlike #control) since unreliable datagrams are meant to be droppable —
      // shed on transport backpressure or a full lane.
      #datagrams = [];
      // Per-stream send priority and the single pending frame per ready stream.
      // Invariant: a stream has at most one Waiter at a time, because its writer
      // task awaits each enqueue before producing the next frame. This keeps
      // per-stream byte order (offsets) sequential.
      #sendOrders = /* @__PURE__ */ new Map();
      #ready = /* @__PURE__ */ new Map();
      #seq = 0;
      // Resolver for the loop when it's parked with no work.
      #wake;
      constructor(sink, options) {
        this.#sink = sink;
        this.#onActivity = options?.onActivity ?? (() => {
        });
        this.#controlHighWater = options?.controlHighWater ?? 256 * 1024;
        void this.#run();
      }
      /** Queue a pre-encoded control frame. Preempts all stream data. */
      enqueueControl(bytes) {
        if (this.#closed)
          throw this.#closed;
        this.#control.push(bytes);
        this.#controlBytes += bytes.byteLength;
        if (this.#controlBytes > this.#controlHighWater) {
          console.warn(`qmux: control backlog ${this.#controlBytes} bytes exceeds high-water`);
        }
        this.#signal();
      }
      /** Queue a datagram frame — best-effort, serviced after control but ahead of
       *  stream data. Dropped (rather than queued) when:
       *   - the scheduler is closed;
       *   - the transport is backpressured — the socket is already queuing stream/
       *     control data, so a datagram behind it would arrive stale; or
       *   - the datagram lane is full, bounding a synchronous burst that outruns the
       *     writer loop even while the transport has room.
       *  An unreliable datagram is meant to be droppable, so this sheds rather than
       *  applying backpressure to the caller. */
      enqueueDatagram(bytes) {
        if (this.#closed)
          return;
        if (!this.#sink.wantsMore())
          return;
        if (this.#datagrams.length >= DATAGRAM_QUEUE_LIMIT)
          return;
        this.#datagrams.push(bytes);
        this.#signal();
      }
      /** Set (or update) a stream's send priority. Takes effect immediately,
       *  including for the stream's already-queued frame (priority is read at
       *  selection time), so promoting a stream lets it jump a lower-priority
       *  backlog without reordering its own bytes. */
      setSendOrder(streamId, order) {
        this.#sendOrders.set(streamId, order);
      }
      /** Queue a stream-data frame. Resolves once the bytes hit the socket;
       *  rejects if the session closes or the stream is dropped first. */
      enqueueStream(streamId, bytes) {
        if (this.#closed)
          return Promise.reject(this.#closed);
        if (this.#ready.has(streamId)) {
          return Promise.reject(new Error(`stream ${streamId} already has a queued frame`));
        }
        return new Promise((resolve2, reject) => {
          this.#ready.set(streamId, { seq: this.#seq++, bytes, resolve: resolve2, reject });
          this.#signal();
        });
      }
      /** Drop a stream's pending data (reset / abort). Rejects its in-flight frame. */
      dropStream(streamId, err2) {
        this.#sendOrders.delete(streamId);
        const waiter = this.#ready.get(streamId);
        if (waiter) {
          this.#ready.delete(streamId);
          waiter.reject(err2);
        }
      }
      /** Forget a stream that finished cleanly (its FIN is already queued/sent).
       *  Frees the per-stream priority entry so it doesn't accumulate. */
      forget(streamId) {
        this.#sendOrders.delete(streamId);
      }
      /** Close the scheduler: reject all pending stream frames, but let the loop
       *  flush any already-queued control frames (e.g. CONNECTION_CLOSE). */
      close(err2) {
        if (this.#closed)
          return;
        this.#closed = err2;
        for (const waiter of this.#ready.values())
          waiter.reject(err2);
        this.#ready.clear();
        this.#sendOrders.clear();
        this.#datagrams.length = 0;
        this.#signal();
      }
      #signal() {
        const wake = this.#wake;
        if (wake) {
          this.#wake = void 0;
          wake();
        }
      }
      /** Pick the next stream to service: highest sendOrder, oldest seq to break
       *  ties (round-robin, since a stream re-arms with a fresh seq each frame). */
      #pickStream() {
        let bestId;
        let bestOrder = Number.NEGATIVE_INFINITY;
        let bestSeq = Number.POSITIVE_INFINITY;
        for (const [id, waiter] of this.#ready) {
          const order = this.#sendOrders.get(id) ?? DEFAULT_SEND_ORDER;
          if (order > bestOrder || order === bestOrder && waiter.seq < bestSeq) {
            bestOrder = order;
            bestSeq = waiter.seq;
            bestId = id;
          }
        }
        return bestId;
      }
      // biome-ignore lint/correctness/noUnusedPrivateClassMembers: invoked from the constructor; Biome's analysis misses the call into this infinite writer loop.
      async #run() {
        try {
          while (true) {
            if (this.#control.length === 0 && this.#datagrams.length === 0 && this.#ready.size === 0) {
              if (this.#closed)
                return;
              await new Promise((resolve2) => {
                this.#wake = resolve2;
              });
              continue;
            }
            await this.#sink.ready();
            if (this.#control.length > 0) {
              const bytes = this.#control.shift();
              this.#controlBytes -= bytes.byteLength;
              await this.#sink.write(bytes);
              this.#onActivity();
              continue;
            }
            if (this.#datagrams.length > 0) {
              const bytes = this.#datagrams.shift();
              await this.#sink.write(bytes);
              this.#onActivity();
              continue;
            }
            if (this.#closed)
              return;
            if (this.#ready.size === 0)
              continue;
            const id = this.#pickStream();
            const waiter = this.#ready.get(id);
            this.#ready.delete(id);
            try {
              await this.#sink.write(waiter.bytes);
            } catch (err2) {
              waiter.reject(err2 instanceof Error ? err2 : new Error(String(err2)));
              throw err2;
            }
            this.#onActivity();
            waiter.resolve();
          }
        } catch (err2) {
          this.#fail(err2 instanceof Error ? err2 : new Error(String(err2)));
        }
      }
      #fail(err2) {
        this.#closed ??= err2;
        for (const waiter of this.#ready.values())
          waiter.reject(err2);
        this.#ready.clear();
        this.#control.length = 0;
        this.#controlBytes = 0;
        this.#datagrams.length = 0;
      }
    };
  }
});

// ../../node_modules/@moq/qmux/session.js
function configToTransportParams(config2) {
  return {
    maxIdleTimeout: config2.maxIdleTimeout,
    initialMaxData: config2.maxData,
    initialMaxStreamDataBidiLocal: config2.maxStreamDataBidiLocal,
    initialMaxStreamDataBidiRemote: config2.maxStreamDataBidiRemote,
    initialMaxStreamDataUni: config2.maxStreamDataUni,
    initialMaxStreamsBidi: config2.maxStreamsBidi,
    initialMaxStreamsUni: config2.maxStreamsUni,
    // Clamp to maxRecordSize so we never advertise a datagram larger than our
    // record layer accepts.
    maxDatagramFrameSize: config2.maxDatagramFrameSize < config2.maxRecordSize ? config2.maxDatagramFrameSize : config2.maxRecordSize,
    maxRecordSize: config2.maxRecordSize,
    // Version-gated in #startSession (only advertised on qmux-02).
    resetStreamAt: false
  };
}
function toWebSocketStream(socket, highWaterMark) {
  return "opened" in socket ? socket : WebSocketStream.adopt(socket, { highWaterMark });
}
function versionPrefix(version2) {
  switch (version2) {
    case "qmux-02":
      return "qmux-02.";
    case "qmux-01":
      return "qmux-01.";
    case "qmux-00":
      return "qmux-00.";
  }
}
function toWebSocketUrl(url2) {
  const u2 = typeof url2 === "string" ? new URL(url2) : url2;
  let scheme;
  switch (u2.protocol) {
    case "https:":
    case "wss:":
      scheme = "wss:";
      break;
    case "http:":
    case "ws:":
      scheme = "ws:";
      break;
    default:
      throw new Error(`Unsupported protocol: ${u2.protocol}`);
  }
  return `${scheme}//${u2.host}${u2.pathname}${u2.search}`;
}
function resolveSubprotocols(protocols, versions, requireProtocol) {
  const out = [];
  for (const entry of protocols) {
    const known = QMUX_VERSIONS.find((v3) => entry.startsWith(versionPrefix(v3)));
    if (known !== void 0) {
      out.push(entry);
      continue;
    }
    if (!(entry in versions)) {
      throw new Error(`Sec-WebSocket-Protocol entry ${JSON.stringify(entry)} has no qmux prefix and no versions mapping`);
    }
    const value = versions[entry];
    const expanded = value === null ? QMUX_VERSIONS : Array.isArray(value) ? value : [value];
    for (const v3 of expanded) {
      out.push(`${versionPrefix(v3)}${entry}`);
    }
  }
  if (!requireProtocol) {
    out.push(...BARE_ALPNS);
  }
  return out;
}
function detectVersion(negotiated2) {
  for (const v3 of QMUX_VERSIONS) {
    if (negotiated2 === v3 || negotiated2.startsWith(versionPrefix(v3))) {
      return v3;
    }
  }
  return "webtransport";
}
function parseProtocol(raw, version2) {
  if (raw === "" || version2 === "webtransport")
    return "";
  if (raw === version2)
    return "";
  const prefix = versionPrefix(version2);
  return raw.startsWith(prefix) ? raw.slice(prefix.length) : "";
}
var DEFAULT_CONFIG, Datagrams, IncomingStreamQueue, DEFAULT_SEND_BUFFER_SIZE, QMUX_VERSIONS, BARE_ALPNS, RecvOpen, Session2;
var init_session = __esm({
  "../../node_modules/@moq/qmux/session.js"() {
    init_web_socket_stream();
    init_credit();
    init_error3();
    init_frame();
    init_frame();
    init_recv();
    init_scheduler();
    init_stream2();
    init_varint3();
    DEFAULT_CONFIG = {
      maxStreamsBidi: 100n,
      maxStreamsUni: 100n,
      maxData: 1048576n,
      maxStreamDataBidiLocal: 262144n,
      maxStreamDataBidiRemote: 262144n,
      maxStreamDataUni: 262144n,
      maxIdleTimeout: 30000n,
      maxRecordSize: DEFAULT_MAX_RECORD_SIZE,
      // Fill a full record by default; the record layer bounds the size.
      maxDatagramFrameSize: DEFAULT_MAX_RECORD_SIZE
    };
    Datagrams = class {
      send;
      incomingHighWaterMark = 1024;
      incomingMaxAge = null;
      outgoingHighWaterMark = 1024;
      outgoingMaxAge = null;
      readable;
      writable;
      #incoming;
      // Resolved from the peer's transport parameters once the handshake completes;
      // 0 until then (and forever if the peer doesn't accept datagrams).
      #maxDatagramSize = 0;
      /** @param send Enqueue a datagram payload onto the wire (best-effort). */
      constructor(send) {
        this.send = send;
        this.readable = new ReadableStream({
          start: (controller) => {
            this.#incoming = controller;
          }
        }, { highWaterMark: this.incomingHighWaterMark });
        this.writable = new WritableStream({
          write: (chunk) => {
            if (this.#maxDatagramSize > 0 && chunk.byteLength <= this.#maxDatagramSize) {
              this.send(chunk);
            }
          }
        });
      }
      get maxDatagramSize() {
        return this.#maxDatagramSize;
      }
      /** Resolve the send-payload limit from the negotiated parameters. */
      setMaxDatagramSize(size2) {
        this.#maxDatagramSize = size2;
      }
      /** Deliver an inbound datagram to the reader, dropping it if the queue is full. */
      push(data) {
        if (this.#incoming.desiredSize === null || this.#incoming.desiredSize <= 0) {
          return;
        }
        this.#incoming.enqueue(data);
      }
      /** Close the inbound readable when the session ends. */
      close(err2) {
        try {
          if (err2)
            this.#incoming.error(err2);
          else
            this.#incoming.close();
        } catch {
        }
      }
    };
    IncomingStreamQueue = class {
      readable;
      #controller;
      #pending = [];
      #pullResolve;
      #cancelled = false;
      #closed = false;
      constructor() {
        this.readable = new ReadableStream({
          start: (controller) => {
            this.#controller = controller;
          },
          pull: () => {
            if (this.#deliver())
              return;
            return new Promise((resolve2) => {
              this.#pullResolve = resolve2;
            });
          },
          cancel: () => {
            this.#cancelled = true;
            this.#dropPending(new Error("incoming stream acceptor cancelled"));
            this.#resolvePull();
          }
        }, { highWaterMark: 0 });
      }
      push(value, onAccept, onDrop) {
        if (this.#cancelled || this.#closed)
          return false;
        this.#pending.push({ value, onAccept, onDrop });
        if (this.#pullResolve) {
          this.#deliver();
          this.#resolvePull();
        }
        return true;
      }
      close(err2) {
        if (this.#closed || this.#cancelled)
          return;
        this.#closed = true;
        this.#dropPending(err2 ?? new Error("session closed"));
        try {
          if (err2)
            this.#controller.error(err2);
          else
            this.#controller.close();
        } catch {
        }
        this.#resolvePull();
      }
      #deliver() {
        const item = this.#pending.shift();
        if (!item)
          return false;
        try {
          this.#controller.enqueue(item.value);
          item.onAccept();
        } catch {
          item.onDrop(new Error("incoming stream acceptor cancelled"));
        }
        return true;
      }
      #dropPending(err2) {
        const pending = this.#pending;
        this.#pending = [];
        for (const item of pending)
          item.onDrop(err2);
      }
      #resolvePull() {
        const resolve2 = this.#pullResolve;
        this.#pullResolve = void 0;
        resolve2?.();
      }
    };
    DEFAULT_SEND_BUFFER_SIZE = 64 * 1024;
    QMUX_VERSIONS = ["qmux-02", "qmux-01", "qmux-00"];
    BARE_ALPNS = ["qmux-02", "qmux-01", "qmux-00", "webtransport"];
    RecvOpen = class {
      #createdMax;
      #holes = /* @__PURE__ */ new Set();
      isClosed(index2) {
        return this.#createdMax !== void 0 && index2 <= this.#createdMax && !this.#holes.has(index2);
      }
      record(index2) {
        if (this.#createdMax !== void 0 && index2 <= this.#createdMax) {
          this.#holes.delete(index2);
          return;
        }
        for (let hole = (this.#createdMax ?? -1n) + 1n; hole < index2; hole++) {
          this.#holes.add(hole);
        }
        this.#createdMax = index2;
      }
    };
    Session2 = class _Session {
      // The transport: a native `WebSocketStream` when the platform has one (real
      // backpressure), otherwise the `@moq/web-socket-stream` ponyfill over a plain
      // `WebSocket` (bufferedAmount-based backpressure). Either way, one API.
      #wss;
      #scheduler;
      #sendBufferSize;
      // The stream-id role: false dials (client), true accepts (server). Set by
      // [[Session.accept]]; every id we mint and every id we allow the peer to mint
      // keys off it.
      #isServer = false;
      // [[AcceptOptions.protocol]]: stands in for `socket.protocol` when the host
      // doesn't expose the negotiated subprotocol.
      #protocolOverride;
      #closed;
      #closeReason;
      #sendStreams = /* @__PURE__ */ new Map();
      #recvStreams = /* @__PURE__ */ new Map();
      #nextUniStreamId = 0n;
      #nextBiStreamId = 0n;
      // Default to the legacy wire format until the WebSocket opens and the
      // negotiated subprotocol tells us otherwise. #handleOpen overrides this
      // with the actual version derived from `ws.protocol`.
      #version = "webtransport";
      /** The negotiated application-level subprotocol, or empty string if none.
       *
       * The prefix is stripped; this returns only the application protocol name.
       */
      #protocol = "";
      get protocol() {
        return this.#protocol;
      }
      ready;
      #readyResolve;
      #readyReject;
      closed;
      #closedResolve;
      #closedReject;
      incomingBidirectionalStreams;
      #incomingBidirectionalQueue;
      incomingUnidirectionalStreams;
      #incomingUnidirectionalQueue;
      datagrams = new Datagrams((data) => this.#sendDatagram(data));
      // Flow control state
      #config;
      #ourParams;
      #peerParams = { ...DEFAULT_TRANSPORT_PARAMS };
      #paramsReceived = false;
      // Send credits start at the legacy wire format's "unlimited" values to
      // match the default #version. #handleOpen replaces them with QMux-shaped
      // zero-credits (waiting for TRANSPORT_PARAMETERS) when the negotiated
      // version turns out to be a QMux draft.
      #connCredit = new Credit(BigInt(Number.MAX_SAFE_INTEGER));
      // Connection-level recv flow control
      #recvDataOffset = 0n;
      #recvDataMax = 0n;
      #recvDataConsumed = 0n;
      // Per-stream flow control
      #streamFlow = /* @__PURE__ */ new Map();
      #recvOpenBi = new RecvOpen();
      #recvOpenUni = new RecvOpen();
      // Stream count tracking via Credit (for sending — peer's limits).
      // Initialized to "unlimited" matching the default webtransport version;
      // #handleOpen replaces them when a QMux draft is negotiated.
      #bidiStreamCredit = new Credit(BigInt(Number.MAX_SAFE_INTEGER));
      #uniStreamCredit = new Credit(BigInt(Number.MAX_SAFE_INTEGER));
      // Stream count tracking via Credit (for receiving — our limits)
      #recvBiCredit;
      #recvUniCredit;
      // QMux01 idle-timeout tracking (engaged once we've received the peer's params).
      #lastRecvAt = Date.now();
      #lastSendAt = Date.now();
      // Deadline bookkeeping for #idleActivityAt: the newest receive observed, the
      // send last allowed to restart the deadline, and whether a send may restart it.
      #recvSeen = 0;
      #sendResetAt = 0;
      #sendCredit = true;
      #nextPingSeq = 0;
      // Highest sequence seen in a received QX_PING request (draft-02 requires them
      // to strictly increase). Undefined until the first request arrives.
      #lastPingRecv;
      #idleTimer;
      /** Open a QMux session as the **client**, dialing `url`.
       *
       * The polyfill constructs the underlying `WebSocket` itself. Pass the
       * application-level ALPNs in `options.protocols` plus a `versions`
       * map saying which QMux wire-format version each bare ALPN rides on. The
       * wire form `{qmux-VV}.{alpn}` is built automatically; entries already in
       * pair form (e.g. `"qmux-00.moq-transport-17"`) pass through unchanged.
       *
       * Once the handshake completes, the QMux wire-format version is derived
       * from the negotiated `Sec-WebSocket-Protocol`. `.protocol` exposes the
       * application protocol with the QMux prefix stripped.
       *
       * Pass an already-connected `WebSocket` (or `WebSocketStream`) instead of a
       * URL to run the client role over a socket you opened yourself — the
       * subprotocol was chosen when you created it, so `options.protocols` and
       * `options.versions` are ignored. See [[Session.accept]] for the server role.
       */
      constructor(source, options) {
        if (options?.requireUnreliable) {
          throw new Error("not allowed to use WebSocket; requireUnreliable is true");
        }
        if (options?.serverCertificateHashes) {
          console.warn("serverCertificateHashes is not supported; trying anyway");
        }
        const dial2 = typeof source === "string" || source instanceof URL;
        const subprotocols = dial2 ? resolveSubprotocols(options?.protocols ?? [], options?.versions ?? {}, options?.requireProtocol ?? false) : [];
        this.#config = { ...DEFAULT_CONFIG, ...options?.config };
        this.#ourParams = configToTransportParams(this.#config);
        this.#sendBufferSize = options?.sendBufferSize ?? DEFAULT_SEND_BUFFER_SIZE;
        this.#recvBiCredit = new Credit(this.#config.maxStreamsBidi);
        this.#recvUniCredit = new Credit(this.#config.maxStreamsUni);
        const ready = Promise.withResolvers();
        this.ready = ready.promise;
        this.#readyResolve = ready.resolve;
        this.#readyReject = ready.reject;
        this.ready.catch(() => {
        });
        const closed = Promise.withResolvers();
        this.closed = closed.promise;
        this.#closedResolve = closed.resolve;
        this.#closedReject = closed.reject;
        this.closed.catch(() => {
        });
        this.#incomingBidirectionalQueue = new IncomingStreamQueue();
        this.incomingBidirectionalStreams = this.#incomingBidirectionalQueue.readable;
        this.#incomingUnidirectionalQueue = new IncomingStreamQueue();
        this.incomingUnidirectionalStreams = this.#incomingUnidirectionalQueue.readable;
        this.#attach(dial2 ? (
          // Open the transport via `WebSocketStream` — native when present (real
          // backpressure), else the ponyfill over a plain `WebSocket`. One code
          // path for both, so the path exercised in tests is the one Chromium
          // runs natively.
          openWebSocketStream(toWebSocketUrl(source), {
            protocols: subprotocols,
            highWaterMark: this.#sendBufferSize
          })
        ) : toWebSocketStream(source, this.#sendBufferSize));
      }
      /** Open a QMux session as the **server**, over a socket you have already
       *  accepted from an HTTP upgrade.
       *
       * The host performs the WebSocket handshake (`Deno.upgradeWebSocket`, `ws`,
       * ...), so by the time you get here the subprotocol is already negotiated:
       * the wire-format version and `.protocol` are read off the socket rather than
       * advertised. Use [[selectSubprotocol]] to pick that value during the upgrade.
       *
       * The returned session is a `WebTransport`, identical to a client session
       * apart from the stream-id role — so it accepts peer-initiated streams and
       * opens server-initiated ones.
       *
       * @example
       * ```ts
       * const { socket, response } = Deno.upgradeWebSocket(req, { protocol });
       * const session = Session.accept(socket, { config });
       * await session.ready;
       * ```
       */
      static accept(socket, options) {
        const session = new _Session(socket, options);
        session.#isServer = true;
        session.#protocolOverride = options?.protocol;
        return session;
      }
      /** Drive the session off an opened transport, whichever way we got it. */
      #attach(wss) {
        this.#wss = wss;
        wss.opened.then((conn) => {
          if (this.#closed)
            return;
          this.#startSession(this.#protocolOverride ?? conn.protocol, new WritableStreamSink(conn.writable));
          void this.#readLoop(conn.readable.getReader());
        }, (err2) => {
          this.#closeReason ??= err2 instanceof Error ? err2 : new Error("WebSocketStream failed to open");
          this.#abort(1006, "WebSocketStream error");
        });
        wss.closed.then((info) => {
          this.#closeReason ??= new Error(`Connection closed: ${info.closeCode ?? 0} ${info.reason ?? ""}`);
          this.#abort(info.closeCode ?? 1006, info.reason ?? "");
        }, (err2) => {
          this.#closeReason ??= err2 instanceof Error ? err2 : new Error("WebSocketStream closed");
          this.#abort(1006, "WebSocketStream error");
        });
      }
      async #readLoop(reader) {
        try {
          while (true) {
            const { value, done } = await reader.read();
            if (done)
              break;
            if (typeof value === "string") {
              this.#sendConnectionClose(1003, "text frames are not valid for QMux");
              this.#abort(1003, "text frames are not valid for QMux");
              return;
            }
            this.#onData(value instanceof ArrayBuffer ? new Uint8Array(value) : value);
          }
        } catch (err2) {
          this.#closeReason ??= err2 instanceof Error ? err2 : new Error("WebSocketStream read error");
          this.#abort(1006, "WebSocketStream read error");
        }
      }
      /** Derive the wire-format version, start the send scheduler, and (for QMux
       *  drafts) exchange transport parameters. Shared by both transports. */
      #startSession(rawProtocol, sink) {
        const version2 = detectVersion(rawProtocol);
        this.#version = version2;
        this.#protocol = parseProtocol(rawProtocol, version2);
        this.#ourParams = {
          ...this.#ourParams,
          maxDatagramFrameSize: usesRecords(version2) ? this.#ourParams.maxDatagramFrameSize : 0n,
          resetStreamAt: version2 === "qmux-02"
        };
        this.#scheduler = new SendScheduler(sink, {
          onActivity: () => {
            this.#lastSendAt = Date.now();
          }
        });
        if (isQmux(version2)) {
          this.#connCredit.close();
          this.#bidiStreamCredit.close();
          this.#uniStreamCredit.close();
          this.#connCredit = new Credit(0n);
          this.#bidiStreamCredit = new Credit(0n);
          this.#uniStreamCredit = new Credit(0n);
          this.#recvDataMax = this.#ourParams.initialMaxData;
          this.#sendTransportParameters();
        }
        this.#readyResolve();
      }
      #onData(data) {
        this.#lastRecvAt = Date.now();
        try {
          if (usesRecords(this.#version)) {
            if (BigInt(data.byteLength) > this.#ourParams.maxRecordSize) {
              throw new Error(`record exceeds our max_record_size (${data.byteLength} > ${this.#ourParams.maxRecordSize})`);
            }
            const frames = decodeRecord(data);
            for (const frame of frames) {
              this.#recvFrame(frame);
            }
          } else {
            if (this.#version === "qmux-00" && data.byteLength > MAX_FRAME_SIZE) {
              throw new Error(`frame exceeds max_frame_size (${data.byteLength} > ${MAX_FRAME_SIZE})`);
            }
            const frame = decode7(data, this.#version);
            if (frame !== null) {
              this.#recvFrame(frame);
            }
          }
        } catch (error2) {
          console.error("Protocol violation:", error2);
          this.#sendConnectionClose(1002, "Protocol violation");
          this.#abort(1002, "Protocol violation", error2);
        }
      }
      #recvFrame(frame) {
        if (this.#version === "qmux-02") {
          const isParams = frame.type === "transport_parameters";
          if (isParams === this.#paramsReceived) {
            throw new Error("QX_TRANSPORT_PARAMETERS must be the first frame");
          }
        }
        if (frame.type === "stream") {
          this.#handleStreamFrame(frame);
        } else if (frame.type === "reset_stream") {
          this.#handleResetStream(frame);
        } else if (frame.type === "stop_sending") {
          this.#handleStopSending(frame);
        } else if (frame.type === "application_close" || frame.type === "connection_close") {
          this.#closeReason ??= new Error(`Connection closed: ${frame.code.value} ${frame.reason}`);
          if (frame.type === "application_close") {
            this.#close(Number(frame.code.value), frame.reason);
          } else {
            this.#abort(Number(frame.code.value), frame.reason);
          }
          this.#transportClose();
        } else if (frame.type === "transport_parameters") {
          this.#handleTransportParameters(frame.params);
        } else if (frame.type === "max_data") {
          this.#connCredit.increaseMax(frame.max);
        } else if (frame.type === "max_stream_data") {
          const flow = this.#streamFlow.get(frame.id.value.value);
          if (flow)
            flow.sendCredit.increaseMax(frame.max);
        } else if (frame.type === "max_streams_bidi") {
          this.#bidiStreamCredit.increaseMax(frame.max);
        } else if (frame.type === "max_streams_uni") {
          this.#uniStreamCredit.increaseMax(frame.max);
        } else if (frame.type === "datagram") {
          if (this.#ourParams.maxDatagramFrameSize === 0n) {
            throw new Error("received a DATAGRAM but did not advertise datagram support");
          }
          const len = frame.data.byteLength;
          const header2 = frame.lengthPrefixed === false ? 1 : 1 + VarInt.from(len).size();
          const frameSize = BigInt(header2 + len);
          if (frameSize > this.#ourParams.maxDatagramFrameSize) {
            throw new Error("received a DATAGRAM larger than our advertised max_datagram_frame_size");
          }
          this.datagrams.push(frame.data);
        } else if (frame.type === "ping_request") {
          if (this.#version === "qmux-02") {
            if (this.#lastPingRecv !== void 0 && frame.sequence <= this.#lastPingRecv) {
              throw new Error("QX_PING request sequence must strictly increase");
            }
            this.#lastPingRecv = frame.sequence;
          }
          this.#sendPriorityFrame({ type: "ping_response", sequence: frame.sequence });
        } else if (frame.type === "ping_response") {
          if (this.#version === "qmux-02" && frame.sequence >= BigInt(this.#nextPingSeq)) {
            throw new Error("QX_PING response echoed a sequence we never sent");
          }
        } else if (frame.type === "data_blocked" || frame.type === "stream_data_blocked" || frame.type === "streams_blocked_bidi" || frame.type === "streams_blocked_uni") {
        }
      }
      #handleTransportParameters(params) {
        if (this.#paramsReceived)
          return;
        if (usesRecords(this.#version) && params.maxRecordSize < DEFAULT_MAX_RECORD_SIZE) {
          throw new Error("max_record_size below the default minimum");
        }
        this.#paramsReceived = true;
        this.#peerParams = params;
        this.#connCredit.increaseMax(params.initialMaxData);
        this.#bidiStreamCredit.increaseMax(params.initialMaxStreamsBidi);
        this.#uniStreamCredit.increaseMax(params.initialMaxStreamsUni);
        if (usesRecords(this.#version) && params.maxDatagramFrameSize > 0n) {
          const cap = params.maxRecordSize < params.maxDatagramFrameSize ? params.maxRecordSize : params.maxDatagramFrameSize;
          const overhead = BigInt(1 + VarInt.from(cap).size());
          const payload = cap > overhead ? cap - overhead : 0n;
          this.datagrams.setMaxDatagramSize(Number(payload));
        }
        for (const [streamIdVal, flow] of this.#streamFlow) {
          const id = new Id(VarInt.from(streamIdVal));
          const sendLimit = id.dir === Dir.Bi ? params.initialMaxStreamDataBidiRemote : params.initialMaxStreamDataUni;
          flow.sendCredit.increaseMax(sendLimit);
        }
        this.#startIdleTimerIfEnabled();
      }
      /** Effective idle timeout in ms, or 0 if disabled.
       *
       * Per RFC 9000 §10.1, the effective value is `min(our, peer)` of the non-zero advertised values
       * (or the single non-zero one). If both are zero, idle timeouts are disabled.
       */
      #effectiveIdleTimeoutMs() {
        if (!usesRecords(this.#version))
          return 0n;
        const a2 = this.#ourParams.maxIdleTimeout;
        const b3 = this.#peerParams.maxIdleTimeout;
        if (a2 === 0n && b3 === 0n)
          return 0n;
        if (a2 === 0n)
          return b3;
        if (b3 === 0n)
          return a2;
        return a2 < b3 ? a2 : b3;
      }
      #startIdleTimerIfEnabled() {
        const timeoutMs = this.#effectiveIdleTimeoutMs();
        if (timeoutMs === 0n)
          return;
        const tickMs = Math.max(50, Number(timeoutMs) / 6);
        this.#idleTimer = setInterval(() => this.#idleTick(Number(timeoutMs)), tickMs);
      }
      /**
       * Newest activity that counts toward the idle deadline.
       *
       * A received frame always restarts the timer: it is the only direct proof the
       * peer is still there. A send restarts it too, but at most once per receive
       * (RFC 9000 §10.1). That proviso is what keeps the deadline reachable: our own
       * keep-alive pings advance `#lastSendAt`, so counting every send would let them
       * restart the very deadline they exist to test, and a peer that goes silent
       * while its socket still accepts our writes would never be reclaimed.
       *
       * Crediting the first send after each receive is what still lets a mostly
       * one-way sender stay open — its peer answers the keep-alive, and each answer
       * re-arms the credit.
       */
      #idleActivityAt() {
        if (this.#lastRecvAt > this.#recvSeen) {
          this.#recvSeen = this.#lastRecvAt;
          this.#sendCredit = true;
        }
        if (this.#sendCredit && this.#lastSendAt > this.#sendResetAt) {
          this.#sendResetAt = this.#lastSendAt;
          this.#sendCredit = false;
        }
        return Math.max(this.#recvSeen, this.#sendResetAt);
      }
      #idleTick(timeoutMs) {
        if (this.#closed) {
          if (this.#idleTimer)
            clearInterval(this.#idleTimer);
          return;
        }
        const now = Date.now();
        if (now - this.#idleActivityAt() > timeoutMs) {
          this.#closeReason ??= new Error("idle timeout");
          this.#abort(0, "idle timeout");
          this.#transportClose();
          return;
        }
        if (now - this.#lastSendAt > timeoutMs / 3) {
          const seq = this.#nextPingSeq;
          this.#nextPingSeq += 1;
          try {
            this.#sendPriorityFrame({ type: "ping_request", sequence: BigInt(seq) });
          } catch (e5) {
            console.warn("qmux: keep-alive ping failed", e5);
          }
        }
      }
      async #claimSendCredit(streamId, desired) {
        const flow = this.#streamFlow.get(streamId);
        if (!flow)
          return desired;
        while (true) {
          const streamClaimed = flow.sendCredit.tryClaim(desired);
          if (streamClaimed === 0n) {
            if (this.#closed)
              throw this.#closed;
            const claimed = await flow.sendCredit.claim(desired);
            flow.sendCredit.release(claimed);
            continue;
          }
          const connClaimed = this.#connCredit.tryClaim(streamClaimed);
          if (connClaimed === 0n) {
            flow.sendCredit.release(streamClaimed);
            if (this.#closed)
              throw this.#closed;
            const claimed = await this.#connCredit.claim(1n);
            this.#connCredit.release(claimed);
            continue;
          }
          if (connClaimed < streamClaimed) {
            flow.sendCredit.release(streamClaimed - connClaimed);
          }
          return connClaimed;
        }
      }
      #accountRecv(streamId, bytes) {
        if (!isQmux(this.#version) || bytes === 0)
          return true;
        const bytesN = BigInt(bytes);
        if (this.#recvDataOffset + bytesN > this.#recvDataMax) {
          return false;
        }
        this.#recvDataOffset += bytesN;
        const flow = this.#streamFlow.get(streamId);
        if (flow) {
          if (flow.recvOffset + bytesN > flow.recvMax) {
            return false;
          }
          flow.recvOffset += bytesN;
        }
        return true;
      }
      /** Connection-level credit. Accounted when bytes are delivered to the
       *  application or deliberately discarded, never merely on receipt. This keeps
       *  completed-but-unread streams inside the aggregate receive-memory window.
       *  `recvDataConsumed` is cumulative. */
      #accountConnConsumed(bytes) {
        if (!isQmux(this.#version) || bytes === 0 || bytes === 0n)
          return;
        this.#recvDataConsumed += BigInt(bytes);
        this.#maybeSendMaxData();
      }
      /** Stream-level credit. Accounted on *delivery* to the application (driven by
       *  RecvStream.onConsume), so MAX_STREAM_DATA tracks the read rate and the peer
       *  can't buffer more than one window ahead of a slow reader. `recvConsumed`
       *  is cumulative. */
      #accountStreamConsumed(streamId, bytes) {
        if (!isQmux(this.#version) || bytes === 0)
          return;
        const flow = this.#streamFlow.get(streamId);
        if (flow) {
          flow.recvConsumed += BigInt(bytes);
          this.#maybeSendMaxStreamData(streamId, flow);
        }
      }
      #maybeSendMaxData() {
        const newMax = replenishWindow(this.#recvDataConsumed, this.#recvDataMax, this.#ourParams.initialMaxData);
        if (newMax !== null) {
          this.#recvDataMax = newMax;
          this.#sendPriorityFrame({ type: "max_data", max: newMax });
        }
      }
      #maybeSendMaxStreamData(streamId, flow) {
        const id = new Id(VarInt.from(streamId));
        let initialWindow;
        if (id.dir === Dir.Bi) {
          initialWindow = id.serverInitiated === this.#isServer ? this.#ourParams.initialMaxStreamDataBidiLocal : this.#ourParams.initialMaxStreamDataBidiRemote;
        } else {
          initialWindow = this.#ourParams.initialMaxStreamDataUni;
        }
        const newMax = replenishWindow(flow.recvConsumed, flow.recvMax, initialWindow);
        if (newMax !== null) {
          flow.recvMax = newMax;
          this.#sendPriorityFrame({ type: "max_stream_data", id, max: newMax });
        }
      }
      /** Replenish stream count credit for a peer-initiated stream and send MAX_STREAMS if needed. */
      #replenishStreamCredit(dir) {
        if (!isQmux(this.#version))
          return;
        const credit = dir === Dir.Bi ? this.#recvBiCredit : this.#recvUniCredit;
        const newMax = credit.consume(1n);
        if (newMax !== null) {
          if (dir === Dir.Bi) {
            this.#sendPriorityFrame({ type: "max_streams_bidi", max: newMax });
          } else {
            this.#sendPriorityFrame({ type: "max_streams_uni", max: newMax });
          }
        }
      }
      #recvOpen(dir) {
        return dir === Dir.Bi ? this.#recvOpenBi : this.#recvOpenUni;
      }
      /** Account the previously-unseen tail declared by RESET_STREAM.
       *
       * Drafts through -02 were emitted by implementations that used an incorrect
       * zero final size, so tolerate a value below the bytes already received. The
       * stricter FINAL_SIZE_ERROR check starts with draft-03; meanwhile the larger
       * of the two values still prevents a reset from undoing flow-control usage. */
      #accountReset(frame) {
        if (!isQmux(this.#version))
          return 0n;
        const streamId = frame.id.value.value;
        const flow = this.#streamFlow.get(streamId);
        const received3 = flow?.recvOffset ?? 0n;
        const finalSize = frame.finalSize > received3 ? frame.finalSize : received3;
        const gap = finalSize - received3;
        const recvMax = flow?.recvMax ?? (frame.id.dir === Dir.Bi ? this.#ourParams.initialMaxStreamDataBidiRemote : this.#ourParams.initialMaxStreamDataUni);
        if (finalSize > recvMax || this.#recvDataOffset + gap > this.#recvDataMax) {
          return null;
        }
        this.#recvDataOffset += gap;
        if (flow)
          flow.recvOffset = finalSize;
        return gap;
      }
      /** Delete stream flow state only when both send and recv sides are gone. */
      #maybeDeleteStreamFlow(streamId) {
        if (!this.#sendStreams.has(streamId) && !this.#recvStreams.has(streamId)) {
          const flow = this.#streamFlow.get(streamId);
          if (flow) {
            flow.sendCredit.close();
            this.#streamFlow.delete(streamId);
          }
        }
      }
      #handleStreamFrame(frame) {
        if (this.#closed)
          return;
        const streamId = frame.id.value.value;
        if (!frame.id.canRecv(this.#isServer)) {
          throw new Error("Invalid stream ID direction");
        }
        let recv = this.#recvStreams.get(streamId);
        if (isQmux(this.#version) && frame.id.serverInitiated !== this.#isServer && !recv && this.#recvOpen(frame.id.dir).isClosed(frame.id.index)) {
          const late = BigInt(frame.data.byteLength);
          if (this.#recvDataOffset + late > this.#recvDataMax) {
            this.#sendConnectionClose(1002, "flow control error");
            this.#abort(1002, "flow control error");
            return;
          }
          this.#recvDataOffset += late;
          this.#accountConnConsumed(late);
          return;
        }
        if (!recv) {
          if (frame.id.serverInitiated === this.#isServer) {
            return;
          }
          if (!frame.id.canRecv(this.#isServer)) {
            throw new Error("received write-only stream");
          }
          if (isQmux(this.#version)) {
            const credit = frame.id.dir === Dir.Bi ? this.#recvBiCredit : this.#recvUniCredit;
            if (!credit.receiveUpTo(frame.id.index + 1n)) {
              this.#sendConnectionClose(1002, "stream limit exceeded");
              this.#abort(1002, "stream limit exceeded");
              return;
            }
            this.#recvOpen(frame.id.dir).record(frame.id.index);
          }
          if (isQmux(this.#version)) {
            const recvMax = frame.id.dir === Dir.Bi ? this.#ourParams.initialMaxStreamDataBidiRemote : this.#ourParams.initialMaxStreamDataUni;
            const sendMax = frame.id.dir === Dir.Bi ? this.#peerParams.initialMaxStreamDataBidiLocal : 0n;
            this.#streamFlow.set(streamId, {
              sendCredit: new Credit(sendMax),
              sendOffset: 0n,
              recvMax,
              recvOffset: 0n,
              recvConsumed: 0n
            });
          }
          if (!this.#accountRecv(streamId, frame.data.byteLength)) {
            this.#sendConnectionClose(1002, "flow control error");
            this.#abort(1002, "flow control error");
            return;
          }
          let accepted = false;
          let terminal = false;
          let streamCreditReplenished = false;
          const maybeReplenishStreamCredit = () => {
            if (!accepted || !terminal || streamCreditReplenished)
              return;
            streamCreditReplenished = true;
            this.#replenishStreamCredit(frame.id.dir);
          };
          const onAccept = () => {
            accepted = true;
            maybeReplenishStreamCredit();
          };
          const onTerminal = () => {
            terminal = true;
            maybeReplenishStreamCredit();
          };
          const recvStream = new RecvStream((bytes) => {
            this.#accountStreamConsumed(streamId, bytes);
            this.#accountConnConsumed(bytes);
          }, (discarded, reason2) => {
            this.#accountConnConsumed(discarded);
            this.#sendPriorityFrame({
              type: "stop_sending",
              id: frame.id,
              code: VarInt.from(resetCode(reason2))
            });
            this.#recvStreams.delete(streamId);
            this.#maybeDeleteStreamFlow(streamId);
          }, onTerminal);
          this.#recvStreams.set(streamId, recvStream);
          recv = recvStream;
          const reader = recvStream.readable;
          const onDrop = (err2) => {
            this.#accountConnConsumed(recvStream.error(err2));
          };
          if (frame.id.dir === Dir.Bi) {
            const writer = new WritableStream({
              start: (controller) => {
                this.#sendStreams.set(streamId, controller);
              },
              write: async (chunk) => {
                await this.#sendStreamData(frame.id, chunk);
              },
              abort: (e5) => {
                this.#scheduler?.dropStream(streamId, e5 instanceof Error ? e5 : new Error("stream aborted"));
                this.#sendPriorityFrame({
                  type: "reset_stream",
                  id: frame.id,
                  code: VarInt.from(resetCode(e5)),
                  finalSize: this.#sendFinalSize(streamId)
                });
                this.#sendStreams.delete(streamId);
                this.#maybeDeleteStreamFlow(streamId);
              },
              close: async () => {
                await this.#sendStreamFin(frame.id);
                this.#sendStreams.delete(streamId);
                this.#scheduler?.forget(streamId);
                this.#maybeDeleteStreamFlow(streamId);
              }
            });
            this.#attachSendOrder(writer, streamId, DEFAULT_SEND_ORDER);
            if (!this.#incomingBidirectionalQueue.push({ readable: reader, writable: writer }, onAccept, onDrop)) {
              onDrop(new Error("incoming stream acceptor cancelled"));
            }
          } else {
            if (!this.#incomingUnidirectionalQueue.push(reader, onAccept, onDrop)) {
              onDrop(new Error("incoming stream acceptor cancelled"));
            }
          }
        } else {
          if (!this.#accountRecv(streamId, frame.data.byteLength)) {
            this.#sendConnectionClose(1002, "flow control error");
            this.#abort(1002, "flow control error");
            return;
          }
        }
        if (frame.data.byteLength > 0) {
          if (!recv.push(frame.data))
            this.#accountConnConsumed(frame.data.byteLength);
        }
        if (frame.fin) {
          recv.finish();
          this.#recvStreams.delete(streamId);
          this.#maybeDeleteStreamFlow(streamId);
        }
      }
      #handleResetStream(frame) {
        if (frame.reliableSize !== void 0 && !this.#ourParams.resetStreamAt) {
          throw new Error("RESET_STREAM_AT received without advertising reset_stream_at");
        }
        if (!frame.id.canRecv(this.#isServer)) {
          throw new Error("Invalid stream ID direction");
        }
        const streamId = frame.id.value.value;
        const recv = this.#recvStreams.get(streamId);
        const peerInitiated = frame.id.serverInitiated !== this.#isServer;
        if (!recv) {
          if (isQmux(this.#version) && peerInitiated && this.#recvOpen(frame.id.dir).isClosed(frame.id.index)) {
            return;
          }
          if (!peerInitiated)
            return;
          if (isQmux(this.#version)) {
            const credit = frame.id.dir === Dir.Bi ? this.#recvBiCredit : this.#recvUniCredit;
            if (!credit.receiveUpTo(frame.id.index + 1n)) {
              this.#sendConnectionClose(1002, "stream limit exceeded");
              this.#abort(1002, "stream limit exceeded");
              return;
            }
          }
        }
        const resetGap = this.#accountReset(frame);
        if (resetGap === null) {
          this.#sendConnectionClose(1002, "flow control error");
          this.#abort(1002, "flow control error");
          return;
        }
        if (!recv) {
          this.#accountConnConsumed(resetGap);
          if (isQmux(this.#version))
            this.#recvOpen(frame.id.dir).record(frame.id.index);
          this.#replenishStreamCredit(frame.id.dir);
          return;
        }
        const discarded = recv.reset(new StreamError(streamCode2(frame.code.value), "RESET_STREAM"));
        this.#accountConnConsumed(resetGap + BigInt(discarded));
        this.#recvStreams.delete(streamId);
        this.#maybeDeleteStreamFlow(streamId);
      }
      #handleStopSending(frame) {
        const streamId = frame.id.value.value;
        const stream = this.#sendStreams.get(streamId);
        if (!stream)
          return;
        const stopped = new StreamError(streamCode2(frame.code.value), "STOP_SENDING");
        stream.error(stopped);
        this.#sendStreams.delete(streamId);
        this.#scheduler?.dropStream(streamId, stopped);
        this.#sendPriorityFrame({
          type: "reset_stream",
          id: frame.id,
          code: frame.code,
          finalSize: this.#sendFinalSize(streamId)
        });
        this.#maybeDeleteStreamFlow(streamId);
      }
      #sendFinalSize(streamId) {
        return this.#streamFlow.get(streamId)?.sendOffset ?? 0n;
      }
      #sendTransportParameters() {
        this.#sendPriorityFrame({ type: "transport_parameters", params: this.#ourParams });
      }
      /** The largest STREAM frame the peer accepts, in bytes.
       *
       * Record-framed drafts negotiate it: a frame rides in one record, so the
       * peer's `max_record_size` is the limit (the draft-01 default until its
       * TRANSPORT_PARAMETERS arrive, so we never send something it would reject).
       * draft-00 and the legacy binding have no record layer and negotiate nothing,
       * so draft-00's whole-frame `max_frame_size` stands in. */
      #sendFrameBudget() {
        if (!usesRecords(this.#version))
          return BigInt(MAX_FRAME_SIZE);
        return this.#paramsReceived ? this.#peerParams.maxRecordSize : DEFAULT_MAX_RECORD_SIZE;
      }
      /** The largest payload we may send in one STREAM frame at `offset`.
       *
       * This respects the peer's frame budget and the send-only compatibility
       * ceiling for released receivers. A `bigint`: the peer's `max_record_size` is
       * a varint, so it can exceed what `number` holds exactly. Callers clamp it to
       * the bytes they actually have before converting. */
      #maxStreamPayload(id, offset) {
        const peerMax = maxStreamPayload(this.#version, this.#sendFrameBudget(), id, offset);
        const compatibilityMax = BigInt(MAX_FRAME_PAYLOAD);
        const max = peerMax < compatibilityMax ? peerMax : compatibilityMax;
        if (max === 0n)
          throw new Error("peer frame limit leaves no room for stream data");
        return max;
      }
      /** Validate an encoded record against the peer's max_record_size (QMux01+). */
      #validateRecordSize(bytes) {
        if (usesRecords(this.#version)) {
          const limit = this.#paramsReceived ? this.#peerParams.maxRecordSize : DEFAULT_MAX_RECORD_SIZE;
          if (BigInt(bytes.byteLength) > limit) {
            throw new Error(`record exceeds peer max_record_size (${bytes.byteLength} > ${limit})`);
          }
        }
      }
      /** Encode and enqueue a stream-data/fin frame, resolving once it hits the wire. */
      async #enqueueStreamFrame(streamId, frame) {
        const scheduler = this.#scheduler;
        if (!scheduler)
          throw this.#closed ?? new Error("session not open");
        const bytes = encode7(frame, this.#version);
        this.#validateRecordSize(bytes);
        await scheduler.enqueueStream(streamId, bytes);
      }
      async #sendStreamDataWithFlowControl(id, streamId, data) {
        const flow = this.#streamFlow.get(streamId);
        if (!flow)
          throw new Error(`missing flow state for stream ${streamId}`);
        for (let offset = 0; offset < data.byteLength; ) {
          const remaining = BigInt(data.byteLength - offset);
          const payloadMax = this.#maxStreamPayload(id, flow.sendOffset);
          const chunkMax = Number(payloadMax < remaining ? payloadMax : remaining);
          const allowed = await this.#claimSendCredit(streamId, BigInt(chunkMax));
          const sendable = Number(allowed);
          const chunk = data.subarray(offset, offset + sendable);
          const sendOffset = flow.sendOffset;
          try {
            await this.#enqueueStreamFrame(streamId, {
              type: "stream",
              id,
              offset: sendOffset,
              data: chunk,
              fin: false
            });
          } catch (e5) {
            if (sendable > 0) {
              const flow2 = this.#streamFlow.get(streamId);
              if (flow2)
                flow2.sendCredit.release(BigInt(sendable));
              this.#connCredit.release(BigInt(sendable));
            }
            throw e5;
          }
          flow.sendOffset += BigInt(sendable);
          offset += sendable;
        }
      }
      async #sendStreamData(id, data) {
        const streamId = id.value.value;
        if (isQmux(this.#version)) {
          await this.#sendStreamDataWithFlowControl(id, streamId, data);
        } else {
          const chunkMax = Number(this.#maxStreamPayload(id, 0n));
          for (let offset = 0; offset < data.byteLength; offset += chunkMax) {
            const end = Math.min(offset + chunkMax, data.byteLength);
            const chunk = data.subarray(offset, end);
            await this.#enqueueStreamFrame(streamId, { type: "stream", id, data: chunk, fin: false });
          }
        }
      }
      /** Send the FIN. Routed through the stream's own queue so it stays ordered
       *  after that stream's data (not via the control lane, which would jump ahead). */
      async #sendStreamFin(id) {
        const streamId = id.value.value;
        const offset = isQmux(this.#version) ? this.#streamFlow.get(streamId)?.sendOffset : void 0;
        if (isQmux(this.#version) && offset === void 0) {
          throw new Error(`missing flow state for stream ${streamId}`);
        }
        await this.#enqueueStreamFrame(streamId, { type: "stream", id, offset, data: new Uint8Array(), fin: true });
      }
      /** Enqueue a DATAGRAM frame on the scheduler's bounded, lossy datagram lane —
       *  dropped under transport backpressure or once closed, rather than piling up
       *  on the (lossless, unbounded) control lane. Size/support checks happen in
       *  {@link Datagrams} before we get here. */
      #sendDatagram(data) {
        if (this.#closed)
          return;
        const bytes = encode7({ type: "datagram", data }, this.#version);
        this.#validateRecordSize(bytes);
        this.#scheduler?.enqueueDatagram(bytes);
      }
      #sendPriorityFrame(frame) {
        if (this.#closed)
          return;
        const bytes = encode7(frame, this.#version);
        this.#validateRecordSize(bytes);
        this.#scheduler?.enqueueControl(bytes);
      }
      /** Register a stream's initial send priority and expose a mutable `sendOrder`
       *  accessor on its writable (matching the W3C `WebTransportSendStream` API).
       *  Updating it re-prioritizes the stream's queued data immediately. */
      #attachSendOrder(writable, streamId, initial) {
        this.#scheduler?.setSendOrder(streamId, initial);
        let order = initial;
        Object.defineProperty(writable, "sendOrder", {
          configurable: true,
          enumerable: true,
          get: () => order,
          set: (value) => {
            order = value;
            this.#scheduler?.setSendOrder(streamId, value);
          }
        });
      }
      async createBidirectionalStream(options) {
        await this.ready;
        if (this.#closed) {
          throw this.#closed;
        }
        const sendOrder2 = options?.sendOrder ?? DEFAULT_SEND_ORDER;
        await this.#bidiStreamCredit.claim(1n);
        const streamId = Id.create(this.#nextBiStreamId++, Dir.Bi, this.#isServer);
        const streamIdVal = streamId.value.value;
        if (isQmux(this.#version)) {
          this.#streamFlow.set(streamIdVal, {
            sendCredit: new Credit(this.#peerParams.initialMaxStreamDataBidiRemote),
            sendOffset: 0n,
            recvMax: this.#ourParams.initialMaxStreamDataBidiLocal,
            recvOffset: 0n,
            recvConsumed: 0n
          });
        }
        const writer = new WritableStream({
          start: (controller) => {
            this.#sendStreams.set(streamIdVal, controller);
          },
          write: async (chunk) => {
            await this.#sendStreamData(streamId, chunk);
          },
          abort: (e5) => {
            this.#scheduler?.dropStream(streamIdVal, e5 instanceof Error ? e5 : new Error("stream aborted"));
            this.#sendPriorityFrame({
              type: "reset_stream",
              id: streamId,
              code: VarInt.from(resetCode(e5)),
              finalSize: this.#sendFinalSize(streamIdVal)
            });
            this.#sendStreams.delete(streamIdVal);
            this.#maybeDeleteStreamFlow(streamIdVal);
          },
          close: async () => {
            await this.#sendStreamFin(streamId);
            this.#sendStreams.delete(streamIdVal);
            this.#scheduler?.forget(streamIdVal);
            this.#maybeDeleteStreamFlow(streamIdVal);
          }
        });
        this.#attachSendOrder(writer, streamIdVal, sendOrder2);
        const recvStream = new RecvStream((bytes) => {
          this.#accountStreamConsumed(streamIdVal, bytes);
          this.#accountConnConsumed(bytes);
        }, (discarded, reason2) => {
          this.#accountConnConsumed(discarded);
          this.#sendPriorityFrame({
            type: "stop_sending",
            id: streamId,
            code: VarInt.from(resetCode(reason2))
          });
          this.#recvStreams.delete(streamIdVal);
          this.#maybeDeleteStreamFlow(streamIdVal);
        });
        this.#recvStreams.set(streamIdVal, recvStream);
        return { readable: recvStream.readable, writable: writer };
      }
      async createUnidirectionalStream(options) {
        await this.ready;
        if (this.#closed) {
          throw this.#closed;
        }
        const sendOrder2 = options?.sendOrder ?? DEFAULT_SEND_ORDER;
        await this.#uniStreamCredit.claim(1n);
        const streamId = Id.create(this.#nextUniStreamId++, Dir.Uni, this.#isServer);
        const streamIdVal = streamId.value.value;
        if (isQmux(this.#version)) {
          this.#streamFlow.set(streamIdVal, {
            sendCredit: new Credit(this.#peerParams.initialMaxStreamDataUni),
            sendOffset: 0n,
            recvMax: 0n,
            recvOffset: 0n,
            recvConsumed: 0n
          });
        }
        const session = this;
        const writer = new WritableStream({
          start: (controller) => {
            session.#sendStreams.set(streamIdVal, controller);
          },
          async write(chunk) {
            await session.#sendStreamData(streamId, chunk);
          },
          abort(e5) {
            session.#scheduler?.dropStream(streamIdVal, e5 instanceof Error ? e5 : new Error("stream aborted"));
            session.#sendPriorityFrame({
              type: "reset_stream",
              id: streamId,
              code: VarInt.from(resetCode(e5)),
              finalSize: session.#sendFinalSize(streamIdVal)
            });
            session.#sendStreams.delete(streamIdVal);
            session.#maybeDeleteStreamFlow(streamIdVal);
          },
          async close() {
            await session.#sendStreamFin(streamId);
            session.#sendStreams.delete(streamIdVal);
            session.#scheduler?.forget(streamIdVal);
            session.#maybeDeleteStreamFlow(streamIdVal);
          }
        });
        this.#attachSendOrder(writer, streamIdVal, sendOrder2);
        return writer;
      }
      /** Shared teardown for both terminal transitions: tears down streams,
       *  credits, and the scheduler. The caller has already marked the session
       *  closed and settled `ready`/`closed` — the only thing that differs between
       *  a clean shutdown and a dropped session is which way `closed` settled, and
       *  {@link #close} vs {@link #abort} own that choice. */
      #teardown() {
        if (this.#idleTimer) {
          clearInterval(this.#idleTimer);
          this.#idleTimer = void 0;
        }
        this.#incomingBidirectionalQueue.close(this.#closeReason);
        this.#incomingUnidirectionalQueue.close(this.#closeReason);
        this.datagrams.close(this.#closeReason);
        for (const c2 of this.#sendStreams.values()) {
          try {
            c2.error(this.#closed);
          } catch {
          }
        }
        const closeErr = this.#closed ?? this.#closeReason ?? new Error("Connection closed");
        for (const recv of this.#recvStreams.values()) {
          try {
            recv.error(closeErr);
          } catch {
          }
        }
        this.#sendStreams.clear();
        this.#recvStreams.clear();
        for (const flow of this.#streamFlow.values()) {
          flow.sendCredit.close(closeErr);
        }
        this.#streamFlow.clear();
        this.#connCredit.close(closeErr);
        this.#bidiStreamCredit.close(closeErr);
        this.#uniStreamCredit.close(closeErr);
        this.#recvBiCredit.close(closeErr);
        this.#recvUniCredit.close(closeErr);
        this.#scheduler?.close(closeErr);
      }
      /** Graceful terminal transition: `closed` **fulfills** with the close code
       *  and reason. Per the WebTransport contract this is the only clean outcome —
       *  reached by a local {@link close} (which first puts an APPLICATION_CLOSE on
       *  the wire) or by receiving a peer's APPLICATION_CLOSE (0x1d). A peer's
       *  CONNECTION_CLOSE (0x1c) routes to {@link #abort} instead. Idempotent. */
      #close(code, reason2) {
        if (this.#closed)
          return;
        this.#closed = this.#closeReason ?? new Error(`Connection closed: ${code} ${reason2}`);
        this.#readyReject(this.#closed);
        this.#closedResolve({ closeCode: code, reason: reason2 });
        this.#teardown();
      }
      /** Abnormal terminal transition: `closed` **rejects** with a
       *  `WebTransportError`. Reached on everything that is not a clean shutdown —
       *  socket failure, read error, idle timeout, a protocol violation we detected
       *  locally, or a peer's CONNECTION_CLOSE (0x1c). Close codes cannot carry this
       *  distinction, since they are
       *  application-defined (an app closing with 1006 must not look like a dropped
       *  socket). `cause`, when given, is preserved as the close reason so the
       *  original failure survives on `closed`. Idempotent. */
      #abort(code, reason2, cause) {
        if (this.#closed)
          return;
        if (cause !== void 0) {
          this.#closeReason ??= cause instanceof Error ? cause : new Error(String(cause));
        }
        this.#closed = this.#closeReason ?? new Error(`Connection closed: ${code} ${reason2}`);
        this.#readyReject(this.#closed);
        this.#closedReject(new SessionError(this.#closed.message, { cause: this.#closed }));
        this.#teardown();
      }
      /** Tear down the underlying transport. The meaningful close code/reason
       *  already travels in the CONNECTION_CLOSE frame, so the WebSocket-level
       *  close is bare (avoids the WebSocket close-code validity constraints). */
      #transportClose() {
        try {
          this.#wss?.close();
        } catch {
        }
      }
      /** APPLICATION_CLOSE (0x1d): a graceful, app-initiated close the peer surfaces
       *  by *fulfilling* its `closed`. Pairs with the {@link #close} transition. */
      #sendApplicationClose(code, reason2) {
        this.#sendPriorityFrame({ type: "application_close", code: VarInt.from(code), reason: reason2 });
        setTimeout(() => {
          this.#transportClose();
        }, 100);
      }
      /** CONNECTION_CLOSE (0x1c): a protocol violation or transport error we detected,
       *  which the peer surfaces by *rejecting* its `closed`. Pairs with the
       *  {@link #abort} transition. */
      #sendConnectionClose(code, reason2) {
        this.#sendPriorityFrame({ type: "connection_close", code: VarInt.from(code), reason: reason2 });
        setTimeout(() => {
          this.#transportClose();
        }, 100);
      }
      close(info) {
        if (this.#closed)
          return;
        const code = info?.closeCode ?? 0;
        const reason2 = info?.reason ?? "";
        this.#sendApplicationClose(code, reason2);
        this.#close(code, reason2);
      }
      /** Resize the send-buffer high-water mark (bytes) used for write
       *  backpressure. A QMux extension beyond the standard `WebTransport` API:
       *  set this to roughly the bandwidth-delay product (RTT × estimated
       *  throughput) to keep the pipe full while leaving as much queued data as
       *  possible reprioritizable by the send scheduler.
       *
       *  No-op when a native `WebSocketStream` is in use (it sizes its own send
       *  buffer); effective with the `@moq/web-socket-stream` ponyfill fallback. */
      setSendBufferSize(bytes) {
        this.#sendBufferSize = Math.max(1, Math.floor(bytes));
        this.#wss?.setHighWaterMark?.(this.#sendBufferSize);
      }
      get congestionControl() {
        return "default";
      }
    };
  }
});

// ../../node_modules/@moq/qmux/index.js
var qmux_default;
var init_qmux = __esm({
  "../../node_modules/@moq/qmux/index.js"() {
    init_session();
    init_error3();
    init_session();
    qmux_default = Session2;
  }
});

// ../../node_modules/@moq/net/connection/transport.js
function transportOf(quic) {
  return quic instanceof qmux_default ? "websocket" : "webtransport";
}
var init_transport = __esm({
  "../../node_modules/@moq/net/connection/transport.js"() {
    init_qmux();
  }
});

// ../../node_modules/@moq/net/ietf/fetch.js
var FetchHeader, Fetch, FetchError;
var init_fetch = __esm({
  "../../node_modules/@moq/net/ietf/fetch.js"() {
    init_filter();
    init_message();
    init_namespace();
    init_parameters();
    init_version();
    FetchHeader = class _FetchHeader {
      /** The uni stream type, not a control message id. */
      static type = 5;
      /** The SUBSCRIBE (or FETCH) request this stream carries objects for. */
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      /** Write the header, which the stream type must already precede. */
      async encode(w4, _version) {
        await w4.u62(this.requestId);
      }
      /** Read the header, with the stream type already consumed. */
      static async decode(r2, _version) {
        return new _FetchHeader({ requestId: await r2.u62() });
      }
    };
    Fetch = class _Fetch {
      static id = 22;
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      async #encode(_w) {
        throw new Error("FETCH messages are not supported");
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _Fetch.#decode(mr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = await r2.u62();
        if (version2 === Version.DRAFT_17) {
          await r2.u62();
        }
        if (version2 === Version.DRAFT_14) {
          await r2.u8();
          await r2.u8();
        }
        if (isDraft20(version2)) {
          await decode5(r2);
          await r2.string();
        } else {
          const fetchType = await r2.u53();
          switch (fetchType) {
            case 1:
              await decode5(r2);
              await r2.string();
              for (let i2 = 0; i2 < 4; i2++)
                await r2.u62();
              break;
            case 2:
            // Relative Joining: subscription, group offset
            case 3:
              await r2.u62();
              await r2.u62();
              break;
            default:
              throw new Error(`unknown fetch type: ${fetchType}`);
          }
        }
        const params = await Parameters.decode(r2, version2);
        if (params.rangeFilters && !hasRangeFilters(version2)) {
          throw new Error("Range Filters need draft-19");
        }
        if (params.trackPropertyFilter) {
          throw new Error("TRACK_PROPERTY_FILTER is not allowed on FETCH");
        }
        return new _Fetch({ requestId });
      }
    };
    FetchError = class _FetchError {
      static id = 25;
      requestId;
      errorCode;
      reasonPhrase;
      constructor({ requestId, errorCode, reasonPhrase }) {
        this.requestId = requestId;
        this.errorCode = errorCode;
        this.reasonPhrase = reasonPhrase;
      }
      async #encode(_w) {
        throw new Error("FETCH_ERROR messages are not supported");
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _FetchError.#decode);
      }
      static async #decode(_r) {
        throw new Error("FETCH_ERROR messages are not supported");
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/object.js
function hasFirstObjectBit(version2) {
  switch (version2) {
    case Version.DRAFT_14:
    case Version.DRAFT_15:
    case Version.DRAFT_16:
    case Version.DRAFT_17:
      return false;
    default:
      return true;
  }
}
function hasDeltaObjectPropertyTypes(version2) {
  switch (version2) {
    case Version.DRAFT_14:
    case Version.DRAFT_15:
      return false;
    default:
      return true;
  }
}
async function encodeObjectPropertyType(w4, id, prev, version2) {
  const encoded = hasDeltaObjectPropertyTypes(version2) ? id - prev : id;
  await w4.u62(encoded);
}
async function encodeObjectTime(w4, timestamp, timescale, version2) {
  const value = Math.round(timestamp.value * timescale / timestamp.scale);
  await encodeObjectPropertyType(w4, PROP_TIMESTAMP, 0n, version2);
  await w4.u62(BigInt(value));
}
async function encodeObjectExtensions(timestamp, timescale, version2) {
  if (timestamp === void 0) {
    return new Uint8Array();
  }
  const chunks = [];
  const writer = new Writer(new WritableStream({
    write(chunk) {
      chunks.push(new Uint8Array(chunk));
    }
  }), version2);
  await encodeObjectTime(writer, timestamp, timescale, version2);
  writer.close();
  await writer.closed;
  const size2 = chunks.reduce((total, chunk) => total + chunk.byteLength, 0);
  const result = new Uint8Array(size2);
  let offset = 0;
  for (const chunk of chunks) {
    result.set(chunk, offset);
    offset += chunk.byteLength;
  }
  return result;
}
function decodeObjectTime(c2, timescale) {
  let timestamp;
  let overrideScale;
  let prevType = 0n;
  let first = true;
  while (c2.remaining > 0) {
    const step = c2.u62();
    const id = !hasDeltaObjectPropertyTypes(asIetf(c2.version)) || first ? step : prevType + step;
    first = false;
    prevType = id;
    if (id % 2n === 0n) {
      const value = c2.u62();
      if (id === PROP_TIMESTAMP || id === PROP_TIMESTAMP_DRAFT03) {
        timestamp = value;
      } else if (id === PROP_TIMESCALE) {
        overrideScale = value;
      }
    } else {
      c2.read(c2.u53());
    }
  }
  if (timestamp === void 0) {
    return void 0;
  }
  return new Timestamp(Number(timestamp), overrideScale !== void 0 ? Timescale(Number(overrideScale)) : timescale);
}
var MAX_OBJECT_EXTENSIONS, GROUP_END, END_OF_TRACK, PROP_TIMESCALE, PROP_TIMESTAMP, PROP_TIMESTAMP_DRAFT03, FIRST_OBJECT_BIT, Group, Frame, FETCH_OBJECT_ID, FETCH_GROUP_ID, FETCH_PRIORITY, FETCH_PROPERTIES, FetchFrame;
var init_object = __esm({
  "../../node_modules/@moq/net/ietf/object.js"() {
    init_error2();
    init_stream();
    init_time();
    init_version();
    MAX_OBJECT_EXTENSIONS = 64 * 1024;
    GROUP_END = 3;
    END_OF_TRACK = 4;
    PROP_TIMESCALE = 0x08n;
    PROP_TIMESTAMP = 0x10n;
    PROP_TIMESTAMP_DRAFT03 = 0x06n;
    FIRST_OBJECT_BIT = 64;
    Group = class _Group {
      flags;
      trackAlias;
      groupId;
      subGroupId;
      publisherPriority;
      constructor({ trackAlias, groupId, subGroupId, publisherPriority, flags }) {
        this.flags = flags;
        this.trackAlias = trackAlias;
        this.groupId = groupId;
        this.subGroupId = subGroupId;
        this.publisherPriority = publisherPriority;
      }
      async encode(w4, version2) {
        if (!this.flags.hasSubgroup && this.subGroupId !== 0) {
          throw new Error(`Subgroup ID must be 0 if hasSubgroup is false: ${this.subGroupId}`);
        }
        const base2 = this.flags.hasPriority ? 16 : 48;
        let id = base2;
        if (this.flags.hasExtensions) {
          id |= 1;
        }
        if (this.flags.hasSubgroupObject) {
          id |= 2;
        }
        if (this.flags.hasSubgroup) {
          id |= 4;
        }
        if (this.flags.hasEnd) {
          id |= 8;
        }
        if (this.flags.firstObject && hasFirstObjectBit(version2)) {
          id |= FIRST_OBJECT_BIT;
        }
        await w4.u53(id);
        await w4.u62(this.trackAlias);
        await w4.u53(this.groupId);
        if (this.flags.hasSubgroup) {
          await w4.u53(this.subGroupId);
        }
        if (this.flags.hasPriority) {
          await w4.u8(this.publisherPriority);
        }
      }
      /** Decode a SUBGROUP_HEADER. Pass `type` when the caller already read it to classify the stream. */
      static async decode(r2, version2, type) {
        const raw = type ?? await r2.u53();
        const legacy = !hasFirstObjectBit(version2);
        const firstObject = legacy || (raw & FIRST_OBJECT_BIT) !== 0;
        const id = legacy ? raw : raw & ~FIRST_OBJECT_BIT;
        const known = id >= 16 && id <= 31 || id >= 48 && id <= 63;
        if (!known || (id & 6) === 6) {
          throw new ProtocolViolation(`Unsupported group type: ${raw}`);
        }
        const hasPriority = id < 48;
        const baseId = hasPriority ? id : id - (48 - 16);
        const flags = {
          hasExtensions: (baseId & 1) !== 0,
          hasSubgroupObject: (baseId & 2) !== 0,
          hasSubgroup: (baseId & 4) !== 0,
          hasEnd: (baseId & 8) !== 0,
          hasPriority,
          firstObject
        };
        const trackAlias = await r2.u62();
        const groupId = await r2.u53();
        const subGroupId = flags.hasSubgroup ? await r2.u53() : 0;
        const publisherPriority = hasPriority ? await r2.u8() : 128;
        return new _Group({ trackAlias, groupId, subGroupId, publisherPriority, flags });
      }
    };
    Frame = class _Frame {
      /** The object payload, or `undefined` for an end of group or end of track marker. */
      payload;
      /** The presentation timestamp carried in object properties, when present. */
      timestamp;
      /**
       * An END_OF_TRACK marker: no object at or past its location exists. At object 0 its group
       * does not exist either, so the track ends at that group; later in a group it ends after it.
       */
      endOfTrack;
      constructor({ payload, timestamp, endOfTrack = false } = {}) {
        this.payload = payload;
        this.timestamp = timestamp;
        this.endOfTrack = endOfTrack;
      }
      /**
       * Encode this frame using the group flags and negotiated IETF version.
       *
       * `idDelta` is the first object's absolute Object ID and zero for every later one, so a
       * group whose head was trimmed by a filter still puts the true numbering on the wire.
       */
      async encode(w4, flags, timescale, version2, idDelta = 0) {
        await w4.u53(idDelta);
        if (flags.hasExtensions) {
          const extensions = await encodeObjectExtensions(this.timestamp, timescale, version2);
          await w4.u53(extensions.byteLength);
          await w4.write(extensions);
        }
        if (this.endOfTrack) {
          await w4.u53(0);
          await w4.u53(END_OF_TRACK);
        } else if (this.payload !== void 0) {
          await w4.u53(this.payload.byteLength);
          if (this.payload.byteLength === 0) {
            await w4.u53(0);
          } else {
            await w4.write(this.payload);
          }
        } else {
          await w4.u53(0);
          await w4.u53(GROUP_END);
        }
      }
      /** Decode a frame using the group flags, at the cursor's negotiated IETF version. */
      static decode(c2, flags, timescale) {
        const delta = c2.u53();
        if (delta !== 0) {
          throw new Error(`object IDs must start at 0 and increment by 1, got a delta of ${delta}`);
        }
        let timestamp;
        if (flags.hasExtensions) {
          const extensionsLength = c2.u53();
          if (extensionsLength > MAX_OBJECT_EXTENSIONS) {
            throw new Stream(StreamCode.MalformedTrack, { message: "object extensions exceed 64 KiB" });
          }
          if (timescale !== void 0) {
            timestamp = c2.exact(extensionsLength, (e5) => decodeObjectTime(e5, timescale));
          } else {
            c2.read(extensionsLength);
          }
        }
        const payloadLength = c2.u53();
        if (payloadLength > 0) {
          const payload = c2.read(payloadLength);
          return new _Frame({ payload, timestamp });
        }
        const status = c2.u53();
        if (status === END_OF_TRACK)
          return new _Frame({ endOfTrack: true });
        if (status === GROUP_END)
          return new _Frame();
        if (flags.hasEnd) {
          if (status === 0)
            return new _Frame({ payload: new Uint8Array(0), timestamp });
        } else if (status === 0) {
          return new _Frame();
        }
        throw new Error(`Unsupported object status: ${status}`);
      }
    };
    FETCH_OBJECT_ID = 4;
    FETCH_GROUP_ID = 8;
    FETCH_PRIORITY = 16;
    FETCH_PROPERTIES = 32;
    FetchFrame = class {
      /** The object payload. */
      payload;
      /** The presentation timestamp carried in object properties, when present. */
      timestamp;
      constructor({ payload, timestamp }) {
        this.payload = payload;
        this.timestamp = timestamp;
      }
      /** Encode this object at `position`, stamping it in the track's timescale. */
      async encode(w4, position, timescale, version2) {
        if (position.first) {
          const properties = this.timestamp !== void 0 ? FETCH_PROPERTIES : 0;
          await w4.u53(FETCH_GROUP_ID | FETCH_OBJECT_ID | FETCH_PRIORITY | properties);
          await w4.u53(position.group);
          await w4.u53(position.object);
          await w4.u8(0);
        } else {
          await w4.u53(this.timestamp !== void 0 ? FETCH_PROPERTIES : 0);
        }
        if (this.timestamp !== void 0) {
          const extensions = await encodeObjectExtensions(this.timestamp, timescale, version2);
          await w4.u53(extensions.byteLength);
          await w4.write(extensions);
        }
        await w4.u53(this.payload.byteLength);
        if (this.payload.byteLength > 0) {
          await w4.write(this.payload);
        }
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/properties.js
async function encode8(w4, properties, version2) {
  if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
    return;
  }
  let prevType = 0n;
  if (properties.timescale !== void 0) {
    await w4.u62(TIMESCALE);
    await w4.u62(BigInt(properties.timescale));
    prevType = TIMESCALE;
  }
  if (properties.priority !== void 0) {
    if (!Number.isInteger(properties.priority) || properties.priority < 0 || properties.priority > 255) {
      throw new RangeError(`invalid publisher priority: ${properties.priority}`);
    }
    await w4.u62(DEFAULT_PUBLISHER_PRIORITY - prevType);
    await w4.u62(BigInt(properties.priority));
    prevType = DEFAULT_PUBLISHER_PRIORITY;
  }
  if (properties.groupOrder !== void 0) {
    await w4.u62(DEFAULT_PUBLISHER_GROUP_ORDER - prevType);
    await w4.u62(BigInt(properties.groupOrder));
  }
}
async function decode8(r2, version2) {
  if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15) {
    return {};
  }
  const properties = {};
  let prevType = 0n;
  let i2 = 0;
  while (!await r2.done()) {
    const delta = await r2.u62();
    const abs = i2 === 0 ? delta : prevType + delta;
    prevType = abs;
    i2++;
    if (abs % 2n === 0n) {
      const value = await r2.u62();
      if (abs === TIMESCALE && value > 0n) {
        properties.timescale = Timescale(Number(value));
      } else if (abs === DEFAULT_PUBLISHER_PRIORITY) {
        if (value > 255n)
          throw new Error(`invalid publisher priority: ${value}`);
        properties.priority = Number(value);
      } else if (abs === DEFAULT_PUBLISHER_GROUP_ORDER) {
        if (value < 1n || value > 2n) {
          throw new Error(`unknown group order: ${value}`);
        }
        properties.groupOrder = Number(value);
      }
    } else {
      const len = await r2.u53();
      await r2.read(len);
    }
  }
  return properties;
}
var TIMESCALE, DEFAULT_PUBLISHER_PRIORITY, DEFAULT_PUBLISHER_GROUP_ORDER, DESCENDING;
var init_properties = __esm({
  "../../node_modules/@moq/net/ietf/properties.js"() {
    init_time();
    init_version();
    TIMESCALE = 0x08n;
    DEFAULT_PUBLISHER_PRIORITY = 0x0en;
    DEFAULT_PUBLISHER_GROUP_ORDER = 0x22n;
    DESCENDING = 2;
  }
});

// ../../node_modules/@moq/net/ietf/publish.js
function publishDoneClean(statusCode, version2) {
  if (statusCode === PublishDoneStatus.TRACK_ENDED)
    return true;
  if (statusCode !== PublishDoneStatus.SUBSCRIPTION_ENDED)
    return false;
  switch (version2) {
    case Version.DRAFT_14:
    case Version.DRAFT_15:
    case Version.DRAFT_16:
    case Version.DRAFT_17:
    case Version.DRAFT_18:
    case Version.DRAFT_19:
      return true;
    default:
      return false;
  }
}
var Publish, PublishError, PublishDoneStatus, PublishDone;
var init_publish = __esm({
  "../../node_modules/@moq/net/ietf/publish.js"() {
    init_message();
    init_namespace();
    init_parameters();
    init_properties();
    init_version();
    Publish = class _Publish {
      static id = 29;
      requestId;
      trackNamespace;
      trackName;
      trackAlias;
      groupOrder;
      priority;
      contentExists;
      largest;
      forward;
      constructor({ requestId, trackNamespace, trackName, trackAlias, groupOrder, priority, contentExists, largest, forward }) {
        this.requestId = requestId;
        this.trackNamespace = trackNamespace;
        this.trackName = trackName;
        this.trackAlias = trackAlias;
        this.groupOrder = groupOrder;
        this.priority = priority;
        this.contentExists = contentExists;
        this.largest = largest;
        this.forward = forward;
      }
      async #encode(w4, version2) {
        await w4.u62(this.requestId);
        if (version2 === Version.DRAFT_17) {
          await w4.u62(0n);
        }
        await encode5(w4, this.trackNamespace);
        await w4.string(this.trackName);
        await w4.u62(this.trackAlias);
        if (version2 === Version.DRAFT_14) {
          await w4.u8(this.groupOrder);
          await w4.bool(this.contentExists);
          if (this.contentExists !== !!this.largest) {
            throw new Error("contentExists and largest must both be true or false");
          }
          if (this.largest) {
            await w4.u62(this.largest.groupId);
            await w4.u62(this.largest.objectId);
          }
          await w4.bool(this.forward);
          await w4.u53(0);
        } else {
          if (this.contentExists !== !!this.largest) {
            throw new Error("contentExists and largest must both be true or false");
          }
          const params = new Parameters();
          if (version2 === Version.DRAFT_15) {
            params.groupOrder = this.groupOrder;
          }
          params.forward = this.forward;
          if (this.largest) {
            params.largest = this.largest;
          }
          await params.encode(w4, version2);
          await encode8(w4, { groupOrder: this.groupOrder, priority: this.priority }, version2);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _Publish.#decode(mr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = await r2.u62();
        if (version2 === Version.DRAFT_17) {
          await r2.u62();
        }
        const trackNamespace = await decode5(r2);
        const trackName = await r2.string();
        const trackAlias = await r2.u62();
        if (version2 === Version.DRAFT_14) {
          const groupOrder2 = await r2.u8();
          const contentExists = await r2.bool();
          const largest2 = contentExists ? { groupId: await r2.u62(), objectId: await r2.u62() } : void 0;
          const forward2 = await r2.bool();
          await Parameters.decode(r2, version2);
          return new _Publish({
            requestId,
            trackNamespace,
            trackName,
            trackAlias,
            groupOrder: groupOrder2,
            contentExists,
            largest: largest2,
            forward: forward2
          });
        }
        const params = await Parameters.decode(r2, version2);
        const properties = await decode8(r2, version2);
        const groupOrder = properties.groupOrder ?? params.groupOrder ?? 2;
        const forward = params.forward ?? true;
        const largest = params.largest;
        return new _Publish({
          requestId,
          trackNamespace,
          trackName,
          trackAlias,
          groupOrder,
          priority: properties.priority,
          contentExists: !!largest,
          largest,
          forward
        });
      }
    };
    PublishError = class _PublishError {
      static id = 31;
      requestId;
      errorCode;
      reasonPhrase;
      constructor({ requestId, errorCode, reasonPhrase }) {
        this.requestId = requestId;
        this.errorCode = errorCode;
        this.reasonPhrase = reasonPhrase;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
        await w4.u62(BigInt(this.errorCode));
        await w4.string(this.reasonPhrase);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _PublishError.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        const errorCode = Number(await r2.u62());
        const reasonPhrase = await r2.string();
        return new _PublishError({ requestId, errorCode, reasonPhrase });
      }
    };
    PublishDoneStatus = {
      INTERNAL_ERROR: 0,
      TRACK_ENDED: 2,
      UPDATE_FAILED: 8,
      /** Removed in draft-20, where 0x3 is unassigned. */
      SUBSCRIPTION_ENDED: 3
    };
    PublishDone = class _PublishDone {
      static id = 11;
      requestId;
      statusCode;
      /**
       * How many data streams the publisher opened for the subscription, fill streams included.
       * A hint: a peer may send 0 or the "unknown" sentinel regardless.
       */
      streamCount;
      reasonPhrase;
      constructor({ requestId, statusCode, streamCount = 0n, reasonPhrase }) {
        this.requestId = requestId;
        this.statusCode = statusCode;
        this.streamCount = streamCount;
        this.reasonPhrase = reasonPhrase;
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          if (this.requestId === void 0)
            throw new Error("requestId required for draft14-16");
          await w4.u62(this.requestId);
        }
        await w4.u62(BigInt(this.statusCode));
        await w4.u62(this.streamCount);
        await w4.string(this.reasonPhrase);
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _PublishDone.#decode(mr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? await r2.u62() : void 0;
        const statusCode = Number(await r2.u62());
        const streamCount = await r2.u62();
        const reasonPhrase = await r2.string();
        return new _PublishDone({ requestId, statusCode, streamCount, reasonPhrase });
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/publish_namespace.js
var PublishNamespace, PublishNamespaceUpdate, PublishNamespaceOk, PublishNamespaceError, PublishNamespaceDone;
var init_publish_namespace = __esm({
  "../../node_modules/@moq/net/ietf/publish_namespace.js"() {
    init_error2();
    init_cluster();
    init_message();
    init_namespace();
    init_parameters();
    init_version();
    PublishNamespace = class _PublishNamespace {
      static id = 6;
      requestId;
      trackNamespace;
      /** The MoQ Cluster parameters (see {@link Cluster}). Set on a session that negotiated
       * the extension and `undefined` on one that did not, which is what decides whether they
       * appear on the wire at all. */
      cluster;
      constructor({ requestId, trackNamespace, cluster }) {
        this.requestId = requestId;
        this.trackNamespace = trackNamespace;
        this.cluster = cluster;
      }
      async #encode(w4, version2) {
        await w4.u62(this.requestId);
        if (version2 === Version.DRAFT_17) {
          await w4.u62(0n);
        }
        await encode5(w4, this.trackNamespace);
        const params = this.cluster ? intoParams(this.cluster) : new Parameters();
        await params.encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      /**
       * Decode the message, expecting the cluster parameters when the session negotiated the
       * extension.
       *
       * The negotiation is session state rather than anything in the message, so the caller
       * supplies it. A negotiated session that omits HOP_PATH is a protocol violation, which
       * surfaces here as a throw.
       */
      static async decode(r2, version2, negotiated2 = false) {
        return decode4(r2, (rd) => _PublishNamespace.#decode(rd, version2, negotiated2));
      }
      static async #decode(r2, version2, negotiated2) {
        const requestId = await r2.u62();
        if (version2 === Version.DRAFT_17) {
          await r2.u62();
        }
        const trackNamespace = await decode5(r2);
        if (negotiated2) {
          const cluster = await decodeParams(r2, version2);
          return new _PublishNamespace({ requestId, trackNamespace, cluster });
        }
        await Parameters.decode(r2, version2);
        return new _PublishNamespace({ requestId, trackNamespace });
      }
    };
    PublishNamespaceUpdate = class _PublishNamespaceUpdate {
      static id = 2;
      /** The update's own Request ID; every REQUEST_UPDATE consumes one. */
      requestId;
      update;
      constructor({ requestId, update }) {
        this.requestId = requestId;
        this.update = update;
      }
      async #encode(w4, version2) {
        _PublishNamespaceUpdate.#modern(version2);
        await w4.u62(this.requestId);
        if (version2 === Version.DRAFT_17) {
          await w4.u62(0n);
        }
        await updateIntoParams(this.update).encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      /**
       * Decode the message. A truncated or trailing body, a draft with no such message, or a
       * malformed parameter block surfaces as a {@link ProtocolViolation}, which the session
       * dispatch closes over. A stream reset or session ending remains transport-local.
       */
      static async decode(r2, version2) {
        try {
          return await decode4(r2, (rd) => _PublishNamespaceUpdate.#decode(rd, version2));
        } catch (err2) {
          if (err2 instanceof ProtocolViolation || err2 instanceof Session || err2 instanceof Stream)
            throw err2;
          if (typeof err2 === "object" && err2 !== null) {
            const source = err2.source;
            if (source === "session" || source === "stream")
              throw err2;
          }
          throw new ProtocolViolation(reason(err2), { cause: err2 });
        }
      }
      static #modern(version2) {
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          throw new Error("REQUEST_UPDATE on PUBLISH_NAMESPACE requires draft-17+");
        }
      }
      static async #decode(r2, version2) {
        _PublishNamespaceUpdate.#modern(version2);
        const requestId = await r2.u62();
        if (version2 === Version.DRAFT_17) {
          await r2.u62();
        }
        const params = await Parameters.decode(r2, version2);
        return new _PublishNamespaceUpdate({ requestId, update: updateFromParams(params) });
      }
    };
    PublishNamespaceOk = class _PublishNamespaceOk {
      static id = 7;
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _PublishNamespaceOk.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        return new _PublishNamespaceOk({ requestId });
      }
    };
    PublishNamespaceError = class _PublishNamespaceError {
      static id = 8;
      requestId;
      errorCode;
      reasonPhrase;
      constructor({ requestId, errorCode, reasonPhrase }) {
        this.requestId = requestId;
        this.errorCode = errorCode;
        this.reasonPhrase = reasonPhrase;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
        await w4.u62(BigInt(this.errorCode));
        await w4.string(this.reasonPhrase);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _PublishNamespaceError.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        const errorCode = Number(await r2.u62());
        const reasonPhrase = await r2.string();
        return new _PublishNamespaceError({ requestId, errorCode, reasonPhrase });
      }
    };
    PublishNamespaceDone = class _PublishNamespaceDone {
      static id = 9;
      trackNamespace;
      requestId;
      // v16: uses request_id instead of track_namespace
      constructor({ trackNamespace = "", requestId = 0n } = {}) {
        this.trackNamespace = trackNamespace;
        this.requestId = requestId;
      }
      async #encode(w4, version2) {
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16) {
          throw new Error("PublishNamespaceDone removed in draft-17+");
        }
        if (version2 === Version.DRAFT_16) {
          await w4.u62(this.requestId);
        } else {
          await encode5(w4, this.trackNamespace);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (rd) => _PublishNamespaceDone.#decode(rd, version2));
      }
      static async #decode(r2, version2) {
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16) {
          throw new Error("PublishNamespaceDone removed in draft-17+");
        }
        if (version2 === Version.DRAFT_16) {
          const requestId = await r2.u62();
          return new _PublishNamespaceDone({ requestId });
        }
        const trackNamespace = await decode5(r2);
        return new _PublishNamespaceDone({ trackNamespace });
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/priority.js
function fromWire(priority) {
  return 255 - priority;
}
function toWire(priority) {
  return 255 - priority;
}
var init_priority = __esm({
  "../../node_modules/@moq/net/ietf/priority.js"() {
  }
});

// ../../node_modules/@moq/net/ietf/request.js
var RequestOk, RequestError;
var init_request = __esm({
  "../../node_modules/@moq/net/ietf/request.js"() {
    init_message();
    init_parameters();
    init_properties();
    init_version();
    RequestOk = class _RequestOk {
      static id = 7;
      requestId;
      parameters;
      constructor({ requestId, parameters = new Parameters() }) {
        this.requestId = requestId;
        this.parameters = parameters;
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          if (this.requestId === void 0)
            throw new Error("requestId required for draft14-16");
          await w4.u62(this.requestId);
        }
        await this.parameters.encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? await r2.u62() : void 0;
        const parameters = await Parameters.decode(r2, version2);
        await decode8(r2, version2);
        return new _RequestOk({ requestId, parameters });
      }
      static async decode(r2, version2) {
        return decode4(r2, (rd) => _RequestOk.#decode(rd, version2));
      }
    };
    RequestError = class _RequestError {
      static id = 5;
      requestId;
      errorCode;
      reasonPhrase;
      retryInterval;
      constructor({ requestId, errorCode, reasonPhrase, retryInterval = 0n }) {
        this.requestId = requestId;
        this.errorCode = errorCode;
        this.reasonPhrase = reasonPhrase;
        this.retryInterval = retryInterval;
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          if (this.requestId === void 0)
            throw new Error("requestId required for draft14-16");
          await w4.u62(this.requestId);
        }
        await w4.u62(BigInt(this.errorCode));
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15) {
          await w4.u62(this.retryInterval);
        }
        await w4.string(this.reasonPhrase);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? await r2.u62() : void 0;
        const errorCode = Number(await r2.u62());
        const retryInterval = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 ? 0n : await r2.u62();
        const reasonPhrase = await r2.string();
        return new _RequestError({ requestId, errorCode, reasonPhrase, retryInterval });
      }
      static async decode(r2, version2) {
        return decode4(r2, (rd) => _RequestError.#decode(rd, version2));
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/request_stream.js
function finCancels(version2) {
  return version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 || version2 === Version.DRAFT_17 || version2 === Version.DRAFT_18;
}
async function cancelled(stream, version2) {
  const read2 = stream.reader.closed.then(() => finCancels(version2) ? void 0 : stream.writer.closed);
  if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16)
    return read2.catch(() => void 0);
  await race([read2, stream.writer.closed]).catch(() => void 0);
}
var init_request_stream = __esm({
  "../../node_modules/@moq/net/ietf/request_stream.js"() {
    init_signals();
    init_version();
  }
});

// ../../node_modules/@moq/net/ietf/subscribe.js
function joinFilter(version2) {
  return isDraft20(version2) ? { kind: "relative", groups: 1n } : { kind: "unfiltered" };
}
var GROUP_ORDER, Subscribe, SubscribeOk, SubscribeError, SubscribeUpdate, Unsubscribe;
var init_subscribe = __esm({
  "../../node_modules/@moq/net/ietf/subscribe.js"() {
    init_filter();
    init_message();
    init_namespace();
    init_parameters();
    init_properties();
    init_version();
    GROUP_ORDER = 2;
    Subscribe = class _Subscribe {
      static id = 3;
      requestId;
      trackNamespace;
      trackName;
      subscriberPriority;
      /** Which Objects the subscription delivers, resolved by the publisher against the live edge. */
      filter;
      /** The draft-20 backfill requested alongside it, or `undefined` for none. */
      fill;
      /** Whether the subscriber wants Track Properties on the response (INCLUDE_PROPERTIES). */
      propertiesWanted;
      /** Whether Objects are forwarded (FORWARD). We only serve forwarding subscriptions. */
      forward;
      /** Whether the request carried a Range Filter, which we refuse. Never encoded. */
      rangeFilters;
      constructor({ requestId, trackNamespace, trackName, subscriberPriority, filter, fill, propertiesWanted, forward, rangeFilters }) {
        this.requestId = requestId;
        this.trackNamespace = trackNamespace;
        this.trackName = trackName;
        this.subscriberPriority = subscriberPriority;
        this.filter = filter ?? { kind: "unfiltered" };
        this.fill = fill;
        this.propertiesWanted = propertiesWanted ?? true;
        this.forward = forward ?? true;
        this.rangeFilters = rangeFilters ?? false;
      }
      async #encode(w4, version2) {
        await w4.u62(this.requestId);
        if (version2 === Version.DRAFT_17) {
          await w4.u62(0n);
        }
        await encode5(w4, this.trackNamespace);
        await w4.string(this.trackName);
        if (version2 === Version.DRAFT_14) {
          await w4.u8(this.subscriberPriority);
          await w4.u8(GROUP_ORDER);
          await w4.bool(this.forward);
          await w4.write(encode6(this.filter, version2));
          await w4.u53(0);
        } else {
          const params = new Parameters();
          params.subscriberPriority = this.subscriberPriority;
          params.groupOrder = GROUP_ORDER;
          params.forward = this.forward;
          params.subscriptionFilter = this.filter;
          if (isDraft20(version2)) {
            if (this.fill) {
              params.fillParameters = encodeFill(this.fill, version2);
            }
            if (!this.propertiesWanted) {
              params.includeProperties = false;
            }
          }
          await params.encode(w4, version2);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _Subscribe.#decode(mr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = await r2.u62();
        if (version2 === Version.DRAFT_17) {
          await r2.u62();
        }
        const trackNamespace = await decode5(r2);
        const trackName = await r2.string();
        if (version2 === Version.DRAFT_14) {
          const subscriberPriority2 = await r2.u8();
          let groupOrder2 = await r2.u8();
          if (groupOrder2 > 2) {
            throw new Error(`unknown group order: ${groupOrder2}`);
          }
          if (groupOrder2 === 0) {
            groupOrder2 = GROUP_ORDER;
          }
          const forward = await r2.bool();
          const filter2 = await decodeInline(r2);
          await Parameters.decode(r2, version2);
          return new _Subscribe({ requestId, trackNamespace, trackName, subscriberPriority: subscriberPriority2, filter: filter2, forward });
        }
        const params = await Parameters.decode(r2, version2);
        const subscriberPriority = params.subscriberPriority ?? 128;
        let groupOrder = params.groupOrder ?? GROUP_ORDER;
        if (groupOrder > 2) {
          throw new Error(`unknown group order: ${groupOrder}`);
        }
        if (groupOrder === 0) {
          groupOrder = GROUP_ORDER;
        }
        const draft20 = isDraft20(version2);
        if ((params.fillParameters !== void 0 || params.includeProperties !== void 0) && !draft20) {
          throw new Error("FILL_PARAMETERS and INCLUDE_PROPERTIES need draft-20");
        }
        if (params.rangeFilters && !hasRangeFilters(version2)) {
          throw new Error("Range Filters need draft-19");
        }
        if (params.trackPropertyFilter) {
          throw new Error("TRACK_PROPERTY_FILTER is not allowed on SUBSCRIBE");
        }
        const filter = params.subscriptionFilter ?? { kind: "unfiltered" };
        const rawFill = params.fillParameters;
        const fill = rawFill !== void 0 ? decodeFill(rawFill, version2) : void 0;
        return new _Subscribe({
          requestId,
          trackNamespace,
          trackName,
          subscriberPriority,
          filter,
          fill,
          // Defaults to 1, so an absent parameter means the subscriber wants them.
          propertiesWanted: params.includeProperties ?? true,
          forward: params.forward ?? true,
          rangeFilters: params.rangeFilters
        });
      }
    };
    SubscribeOk = class _SubscribeOk {
      static id = 4;
      requestId;
      trackAlias;
      /**
       * The largest Location in the track (LARGEST_OBJECT), which the draft requires once the
       * track has content. It is what a subscriber sizes a fill against.
       */
      largest;
      /**
       * The Track Properties to send (draft-17+): the track's Timescale and our group order.
       *
       * Empty opts the response out of properties entirely, which is what a peer that sent
       * INCLUDE_PROPERTIES=0 asked for; declaring no Timescale also opts the track out of
       * timestamps, so the subscriber times objects by arrival.
       */
      properties;
      constructor({ requestId, trackAlias, largest, properties }) {
        this.requestId = requestId;
        this.trackAlias = trackAlias;
        this.largest = largest;
        this.properties = properties ?? {};
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          if (this.requestId === void 0)
            throw new Error("requestId required for draft14-16");
          await w4.u62(this.requestId);
        }
        await w4.u62(this.trackAlias);
        if (version2 === Version.DRAFT_14) {
          await w4.u62(0n);
          await w4.u8(this.properties.groupOrder ?? GROUP_ORDER);
          await w4.bool(this.largest !== void 0);
          if (this.largest !== void 0) {
            await w4.u62(this.largest.groupId);
            await w4.u62(this.largest.objectId);
          }
          await w4.u53(0);
        } else {
          const params = new Parameters();
          if (version2 === Version.DRAFT_15 && this.properties.groupOrder !== void 0) {
            params.groupOrder = this.properties.groupOrder;
          }
          if (this.largest !== void 0) {
            params.largest = this.largest;
          }
          await params.encode(w4, version2);
          await encode8(w4, this.properties, version2);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _SubscribeOk.#decode(mr, version2));
      }
      static async #decode(r2, version2) {
        const requestId = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? await r2.u62() : void 0;
        const trackAlias = await r2.u62();
        let largest;
        let properties = {};
        if (version2 === Version.DRAFT_14) {
          await r2.u62();
          await r2.u8();
          const contentExists = await r2.bool();
          if (contentExists) {
            const groupId = await r2.u62();
            const objectId = await r2.u62();
            largest = { groupId, objectId };
          }
          await Parameters.decode(r2, version2);
        } else {
          largest = (await Parameters.decode(r2, version2)).largest;
          properties = await decode8(r2, version2);
        }
        return new _SubscribeOk({ requestId, trackAlias, largest, properties });
      }
    };
    SubscribeError = class _SubscribeError {
      static id = 5;
      requestId;
      errorCode;
      reasonPhrase;
      constructor({ requestId, errorCode, reasonPhrase }) {
        this.requestId = requestId;
        this.errorCode = errorCode;
        this.reasonPhrase = reasonPhrase;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
        await w4.u62(BigInt(this.errorCode));
        await w4.string(this.reasonPhrase);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _SubscribeError.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        const errorCode = Number(await r2.u62());
        const reasonPhrase = await r2.string();
        return new _SubscribeError({ requestId, errorCode, reasonPhrase });
      }
    };
    SubscribeUpdate = class _SubscribeUpdate {
      static id = 2;
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_14) {
          await w4.u62(this.requestId);
          await w4.u62(0n);
          await w4.u62(0n);
          await w4.u62(0n);
          await w4.u62(0n);
          await w4.u8(128);
          await w4.bool(true);
          await w4.u53(0);
        } else if (version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          await w4.u62(this.requestId);
          await w4.u62(0n);
          const params = new Parameters();
          await params.encode(w4, version2);
        } else {
          await w4.u62(this.requestId);
          if (version2 === Version.DRAFT_17) {
            await w4.u62(0n);
          }
          const params = new Parameters();
          await params.encode(w4, version2);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _SubscribeUpdate.#decode(mr, version2));
      }
      static async #decode(r2, version2) {
        if (version2 === Version.DRAFT_14) {
          const requestId = await r2.u62();
          await r2.u62();
          await r2.u62();
          await r2.u62();
          await r2.u62();
          await r2.u8();
          await r2.bool();
          await Parameters.decode(r2, version2);
          return new _SubscribeUpdate({ requestId });
        } else if (version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          const requestId = await r2.u62();
          await r2.u62();
          await Parameters.decode(r2, version2);
          return new _SubscribeUpdate({ requestId });
        } else {
          const requestId = await r2.u62();
          if (version2 === Version.DRAFT_17) {
            await r2.u62();
          }
          await Parameters.decode(r2, version2);
          return new _SubscribeUpdate({ requestId });
        }
      }
    };
    Unsubscribe = class _Unsubscribe {
      static id = 10;
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _Unsubscribe.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        return new _Unsubscribe({ requestId });
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/subscribe_namespace.js
function isLegacyVersion(version2) {
  switch (version2) {
    case Version.DRAFT_14:
    case Version.DRAFT_15:
    case Version.DRAFT_16:
    case Version.DRAFT_17:
      return true;
    default:
      return false;
  }
}
var SubscribeNamespace, SubscribeNamespaceLegacy, SUBSCRIBE_TRACKS_ID, SubscribeNamespaceOk, UnsubscribeNamespace, SubscribeNamespaceEntry, SubscribeNamespaceEntryDone, PublishBlocked;
var init_subscribe_namespace = __esm({
  "../../node_modules/@moq/net/ietf/subscribe_namespace.js"() {
    init_cluster();
    init_message();
    init_namespace();
    init_parameters();
    init_version();
    SubscribeNamespace = class _SubscribeNamespace {
      static id = 80;
      namespace;
      requestId;
      /** MoQ Hidden: also advertise hidden namespaces. Only sent to a peer that declared it. */
      hidden;
      constructor({ namespace, requestId, hidden = false }) {
        this.namespace = namespace;
        this.requestId = requestId;
        this.hidden = hidden;
      }
      async #encode(w4, version2) {
        if (isLegacyVersion(version2)) {
          throw new Error(`SUBSCRIBE_NAMESPACE (0x50) is draft-18+ only, not ${version2}`);
        }
        await w4.u62(this.requestId);
        await encode5(w4, this.namespace);
        const params = new Parameters();
        params.hidden = this.hidden;
        await params.encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (rd) => _SubscribeNamespace.#decode(rd, version2));
      }
      static async #decode(r2, version2) {
        if (isLegacyVersion(version2)) {
          throw new Error(`SUBSCRIBE_NAMESPACE (0x50) is draft-18+ only, not ${version2}`);
        }
        const requestId = await r2.u62();
        const namespace = await decode5(r2);
        const params = await Parameters.decode(r2, version2);
        return new _SubscribeNamespace({ namespace, requestId, hidden: params.hidden });
      }
    };
    SubscribeNamespaceLegacy = class _SubscribeNamespaceLegacy {
      static id = 17;
      namespace;
      requestId;
      subscribeOptions;
      // v16/v17: default 0x01 (NAMESPACE only)
      /** MoQ Hidden: see {@link SubscribeNamespace.hidden}. */
      hidden;
      constructor({ namespace, requestId, subscribeOptions = 1, hidden = false }) {
        this.namespace = namespace;
        this.requestId = requestId;
        this.subscribeOptions = subscribeOptions;
        this.hidden = hidden;
      }
      async #encode(w4, version2) {
        if (!isLegacyVersion(version2)) {
          throw new Error(`legacy SUBSCRIBE_NAMESPACE (0x11) is draft-14..17 only, not ${version2}`);
        }
        await w4.u62(this.requestId);
        if (version2 === Version.DRAFT_17) {
          await w4.u62(0n);
        }
        await encode5(w4, this.namespace);
        if (version2 === Version.DRAFT_16 || version2 === Version.DRAFT_17) {
          await w4.u53(this.subscribeOptions);
        }
        const params = new Parameters();
        params.hidden = this.hidden;
        await params.encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      static async decode(r2, version2) {
        return decode4(r2, (rd) => _SubscribeNamespaceLegacy.#decode(rd, version2));
      }
      static async #decode(r2, version2) {
        if (!isLegacyVersion(version2)) {
          throw new Error(`legacy SUBSCRIBE_NAMESPACE (0x11) is draft-14..17 only, not ${version2}`);
        }
        const requestId = await r2.u62();
        if (version2 === Version.DRAFT_17) {
          await r2.u62();
        }
        const namespace = await decode5(r2);
        let subscribeOptions = 1;
        if (version2 === Version.DRAFT_16 || version2 === Version.DRAFT_17) {
          subscribeOptions = await r2.u53();
        }
        const params = await Parameters.decode(r2, version2);
        const forward = params.vars.get(0x10n);
        if (version2 !== Version.DRAFT_14 && forward !== void 0 && forward > 1n) {
          throw new Error(`invalid FORWARD parameter: ${forward}`);
        }
        return new _SubscribeNamespaceLegacy({ namespace, requestId, subscribeOptions, hidden: params.hidden });
      }
    };
    SUBSCRIBE_TRACKS_ID = 81;
    SubscribeNamespaceOk = class _SubscribeNamespaceOk {
      static id = 18;
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _SubscribeNamespaceOk.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        return new _SubscribeNamespaceOk({ requestId });
      }
    };
    UnsubscribeNamespace = class _UnsubscribeNamespace {
      static id = 20;
      requestId;
      constructor({ requestId }) {
        this.requestId = requestId;
      }
      async #encode(w4) {
        await w4.u62(this.requestId);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _UnsubscribeNamespace.#decode);
      }
      static async #decode(r2) {
        const requestId = await r2.u62();
        return new _UnsubscribeNamespace({ requestId });
      }
    };
    SubscribeNamespaceEntry = class _SubscribeNamespaceEntry {
      static id = 8;
      suffix;
      /**
       * The MoQ Cluster parameters. Set selects the extended form, `undefined` the base one.
       * An endpoint must not append them on a session that did not negotiate.
       */
      cluster;
      constructor({ suffix, cluster }) {
        this.suffix = suffix;
        this.cluster = cluster;
      }
      async #encode(w4, version2) {
        await encode5(w4, this.suffix);
        if (this.cluster)
          await intoParams(this.cluster).encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (wr) => this.#encode(wr, version2));
      }
      /**
       * Decode the message, expecting the extended form when the session negotiated the MoQ
       * Cluster extension. See {@link PublishNamespace.decode}.
       */
      static async decode(r2, version2, negotiated2 = false) {
        return decode4(r2, (rd) => _SubscribeNamespaceEntry.#decode(rd, version2, negotiated2));
      }
      static async #decode(r2, version2, negotiated2) {
        const suffix = await decode5(r2);
        if (!negotiated2)
          return new _SubscribeNamespaceEntry({ suffix });
        return new _SubscribeNamespaceEntry({ suffix, cluster: await decodeParams(r2, version2) });
      }
    };
    SubscribeNamespaceEntryDone = class _SubscribeNamespaceEntryDone {
      static id = 14;
      suffix;
      constructor({ suffix }) {
        this.suffix = suffix;
      }
      async #encode(w4) {
        await encode5(w4, this.suffix);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _SubscribeNamespaceEntryDone.#decode);
      }
      static async #decode(r2) {
        const suffix = await decode5(r2);
        return new _SubscribeNamespaceEntryDone({ suffix });
      }
    };
    PublishBlocked = class _PublishBlocked {
      static id = 15;
      suffix;
      trackName;
      constructor({ suffix, trackName }) {
        this.suffix = suffix;
        this.trackName = trackName;
      }
      async #encode(w4) {
        await encode5(w4, this.suffix);
        await w4.string(this.trackName);
      }
      async encode(w4, _version) {
        return encode4(w4, this.#encode.bind(this));
      }
      static async decode(r2, _version) {
        return decode4(r2, _PublishBlocked.#decode);
      }
      static async #decode(r2) {
        const suffix = await decode5(r2);
        const trackName = await r2.string();
        return new _PublishBlocked({ suffix, trackName });
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/publisher.js
function clusterFor(base2, route) {
  if (!base2)
    return void 0;
  const self2 = base2.hops.at(-1);
  if (self2 === void 0)
    return void 0;
  const hops = route.hops.at(-1) === self2 ? [...route.hops] : [...route.hops, self2];
  return { hops, cost: route.cost.warm };
}
function change(base2, held, next) {
  if (held === void 0 || next === void 0 || held.identity !== next.identity)
    return "restart";
  const from2 = clusterFor(base2, held.route);
  const to = clusterFor(base2, next.route);
  if (from2 === void 0 || to === void 0)
    return from2 === to ? "same" : "restart";
  if (from2.cost === to.cost && sameHops(from2.hops, to.hops))
    return "same";
  return { from: from2, to };
}
function sameHops(a2, b3) {
  return a2.length === b3.length && a2.every((hop, i2) => hop === b3[i2]);
}
function retryAfter(delay) {
  return new Promise((resolve2) => setTimeout(resolve2, delay * (0.5 + Math.random() / 2)));
}
function takeGroup(cache, sequence) {
  for (; ; ) {
    const group = cache.tryRecvGroup();
    if (!group)
      throw new Error(`group not found: ${sequence}`);
    if (group.sequence === sequence)
      return group;
    group.close();
    if (group.sequence > sequence)
      throw new Error(`group not found: ${sequence}`);
  }
}
function saturatingSub(a2, b3) {
  return a2 > b3 ? a2 - b3 : 0n;
}
function liveEdge(track) {
  const latest = track.latest();
  if (latest === void 0)
    return {};
  const largest = track.largest();
  if (!largest)
    return { latest: BigInt(latest), next: { group: BigInt(latest), object: 0n } };
  const group = BigInt(largest.group);
  const object3 = BigInt(largest.frame);
  return { latest: BigInt(latest), largest: { group, object: object3 }, next: { group, object: object3 + 1n } };
}
function subscribeRange(msg, edge, version2) {
  if (!isDraft20(version2)) {
    if (msg.filter.kind !== "nextObject" && msg.filter.kind !== "unfiltered") {
      console.warn(`filter not supported before draft-20, ignoring: ${msg.filter.kind}`);
    }
    return {};
  }
  return filterRange(msg.filter, edge);
}
function filterRange(filter, edge) {
  switch (filter.kind) {
    // No restriction. moq-lite starts at the beginning of the latest group, which is the
    // join point it is built around; a subscription passes objects as they are published,
    // so an absent filter is not a request to replay history.
    case "unfiltered":
      return {};
    // `{Largest.Group, Largest.Object + 1}`. Everything below it, including the already
    // published head of the current group, is outside the requested range, so the join is
    // mid-group by construction. The draft pairs this with a fill when the subscriber
    // wants the head; see {@link Publisher.runFill}.
    case "nextObject":
      return { start: edge.next };
    // `{Largest.Group + 1 - groups, 0}`: 0 is the next group and 1 is the current one.
    // Counted from `Largest.Group`, which sits below the newest group while that group has
    // no objects yet; only with no largest at all does the newest group stand in for it.
    case "relative": {
      const base2 = edge.largest?.group ?? edge.latest;
      if (base2 === void 0)
        return {};
      return { start: { group: saturatingSub(base2 + 1n, filter.groups), object: 0n } };
    }
    case "absolute":
      return {
        start: { group: filter.startGroup, object: filter.startObject },
        end: filter.endGroup === void 0 ? void 0 : { group: filter.endGroup, object: filter.endObject }
      };
  }
}
function groupSlice(range, sequence) {
  const at2 = BigInt(sequence);
  return {
    skip: range.start?.group === at2 ? Number(range.start.object) : 0,
    until: range.end?.group === at2 && range.end.object !== void 0 ? Number(range.end.object) + 1 : void 0
  };
}
function fillRange(fill, subscription, largest) {
  if (fill.rangeFilters)
    return { kind: "unsupported" };
  const filter = fill.filter ?? subscription;
  if (!largest)
    return { kind: "empty" };
  let start;
  switch (filter.kind) {
    // A Fetch without a filter is the whole track up to Largest Object.
    case "unfiltered":
      start = { group: 0n, object: 0n };
      break;
    // One past the edge, which for a Fetch is always empty.
    case "nextObject":
      return { kind: "empty" };
    case "relative":
      start = { group: saturatingSub(largest.group + 1n, filter.groups), object: 0n };
      break;
    case "absolute":
      start = { group: filter.startGroup, object: filter.startObject };
      break;
  }
  let end = { group: largest.group, object: largest.object };
  if (filter.kind === "absolute" && filter.endGroup !== void 0) {
    const below = filter.endGroup < largest.group || filter.endGroup === largest.group && filter.endObject !== void 0 && filter.endObject < largest.object;
    if (below)
      end = { group: filter.endGroup, object: filter.endObject };
  }
  if (start.group > end.group || start.group === end.group && end.object !== void 0 && end.object < start.object) {
    return { kind: "empty" };
  }
  if (start.group !== end.group)
    return { kind: "unsupported" };
  return {
    kind: "group",
    sequence: start.group,
    skip: start.object,
    until: end.object === void 0 ? void 0 : end.object + 1n
  };
}
var RETRY_BASE, RETRY_MAX, ADVERTISE_TIMEOUT_MS, Publisher, UpdateFailed;
var init_publisher = __esm({
  "../../node_modules/@moq/net/ietf/publisher.js"() {
    init_signals();
    init_error2();
    init_internal();
    init_path();
    init_stream();
    init_time();
    init_timeout();
    init_varint2();
    init_wire();
    init_cluster();
    init_error();
    init_fetch();
    init_filter();
    init_message();
    init_object();
    init_parameters();
    init_priority();
    init_properties();
    init_publish();
    init_publish_namespace();
    init_request();
    init_request_stream();
    init_subscribe();
    init_subscribe_namespace();
    init_version();
    RETRY_BASE = 100;
    RETRY_MAX = 5e3;
    ADVERTISE_TIMEOUT_MS = 5e3;
    Publisher = class {
      #quic;
      #session;
      #requiresSolicitation;
      #hidden;
      // The origin this session serves, borrowed: it outlives the session, and closing the
      // session leaves its broadcasts alone. The namespaces are advertised with an unsolicited
      // PUBLISH_NAMESPACE (see {@link runPublishNamespaces}), or on request if the peer asked
      // for that (see {@link runSubscribeNamespace}).
      #advertised;
      #publish;
      // What every advertisement carries on a session that negotiated the MoQ Cluster
      // extension: a hop path holding our own id, so the peer can tell that what it hears
      // back came from us. `undefined` when nothing negotiated it.
      #advert;
      /**
       * Creates a new Publisher instance.
       *
       * @internal
       */
      constructor({ quic, session, publish: publish5, requiresSolicitation, hidden = false, cluster }) {
        this.#quic = quic;
        this.#session = session;
        const origin = publish5 && wireOf(publish5);
        this.#advertised = origin?.advertised ?? new Signal(/* @__PURE__ */ new Map());
        this.#publish = publish5;
        this.#requiresSolicitation = requiresSolicitation;
        this.#hidden = hidden;
        this.#advert = advertise(cluster);
      }
      /**
       * Handles an incoming SUBSCRIBE request on a bidi stream.
       * Owns the full lifecycle: sends response, serves track data, waits for close.
       *
       * @internal
       */
      async runSubscribe(msg, stream) {
        const version2 = this.#session.version;
        const name = msg.trackNamespace;
        let broadcast2;
        let refusal;
        const unsupported = !msg.forward ? "FORWARD=0 not supported" : msg.rangeFilters ? "range filters not supported" : void 0;
        if (unsupported) {
          refusal = { errorCode: toRequestCode("not_supported", "subscribe", version2), reasonPhrase: unsupported };
        } else {
          try {
            broadcast2 = this.#publish && (wireOf(this.#publish).local(name) ?? await wireOf(this.#publish).demand(name));
            if (!broadcast2) {
              refusal = {
                errorCode: toRequestCode("does_not_exist", "subscribe", version2),
                reasonPhrase: "broadcast not found"
              };
            }
          } catch (err2) {
            const e5 = error(err2);
            const condition = e5 instanceof Stream && e5.code === StreamCode.NotFound ? "does_not_exist" : "internal";
            refusal = { errorCode: toRequestCode(condition, "subscribe", version2), reasonPhrase: reason(e5) };
          }
        }
        if (refusal) {
          if (version2 === Version.DRAFT_14) {
            await stream.writer.u53(SubscribeError.id);
            const err2 = new SubscribeError({
              requestId: msg.requestId,
              errorCode: refusal.errorCode,
              reasonPhrase: refusal.reasonPhrase
            });
            await err2.encode(stream.writer, version2);
          } else {
            await stream.writer.u53(RequestError.id);
            const err2 = new RequestError({
              requestId: version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? msg.requestId : void 0,
              errorCode: refusal.errorCode,
              reasonPhrase: refusal.reasonPhrase
            });
            await err2.encode(stream.writer, version2);
          }
          stream.close();
          return;
        }
        if (!broadcast2)
          return;
        const priority = fromWire(msg.subscriberPriority);
        const track = wireOf(broadcast2).subscribe(msg.trackName, {
          priority,
          // moq-transport has no subscriber latency parameter. Keep everything the
          // producer retained and let the receiving subscriber enforce its own budget.
          // Keep the sentinel encodable if this demand crosses a Lite hop before the
          // producer's retention bound is known.
          maxAge: Milli(MAX_U53)
        });
        let cache;
        try {
          const info = await track.info();
          const timescale = info.timescale;
          const publisherPriority = toWire(info.priority);
          const edge = liveEdge(track);
          const range = subscribeRange(msg, edge, version2);
          track.update({
            priority,
            maxAge: Milli(MAX_U53),
            groups: {
              start: range.start ? { included: Number(range.start.group) } : void 0,
              end: range.end ? { included: Number(range.end.group) } : void 0
            }
          });
          const startGroup = range.start ? Number(range.start.group) : track.latest();
          if (startGroup !== void 0)
            track.setGroups({ start: { included: startGroup } });
          const fill = msg.fill && isDraft20(version2) ? fillRange(msg.fill, msg.filter, edge.largest) : void 0;
          cache = fill && fill.kind !== "empty" ? track.fork({ priority, maxAge: Milli(MAX_U53) }) : void 0;
          await stream.writer.u53(SubscribeOk.id);
          const ok = new SubscribeOk({
            requestId: version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? msg.requestId : void 0,
            trackAlias: msg.requestId,
            // Required once the track has content; a fill-requesting subscriber sizes its
            // backfill against this. Below draft-20 round it down to the start of its
            // group, matching what the subscription serves there: a draft-20 subscriber
            // recovers a group's head with a FILL, which we serve, while older drafts
            // recover it with a joining FETCH, which we do not, so naming a mid-group
            // start would strand them.
            largest: edge.largest && (isDraft20(version2) ? { groupId: edge.largest.group, objectId: edge.largest.object } : { groupId: edge.largest.group, objectId: 0n }),
            properties: msg.propertiesWanted ? (
              // Declaring the timescale is what opts the track into timestamps; every
              // object Timestamp below is in these units. We serve the newest group
              // first, matching moq-lite.
              { timescale, priority: publisherPriority, groupOrder: DESCENDING }
            ) : (
              // INCLUDE_PROPERTIES=0. The block stays present but empty, which also means
              // the track opts out of timestamps for this subscriber.
              {}
            )
          });
          await ok.encode(stream.writer, version2);
          console.debug(`publish ok: broadcast=${name} track=${track.name}`);
          let finished = false;
          let unsubscribe;
          const unsubscribed = new Promise((resolve2) => {
            unsubscribe = resolve2;
          });
          let replies = Promise.resolve();
          let replied = false;
          const reply = (write2) => {
            const sent = replies.then(() => replied ? void 0 : write2());
            replies = sent.catch(() => void 0);
            return sent;
          };
          let publishError;
          const updates = (async () => {
            if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16)
              return stream.reader.closed;
            for (; ; ) {
              if (await stream.reader.done()) {
                if (finCancels(version2))
                  return;
                return stream.writer.closed;
              }
              if (await stream.reader.u53() !== 2)
                throw new Error("unexpected message on subscribe stream");
              const params = await decode4(stream.reader, async (r2) => {
                await r2.u62();
                if (version2 === Version.DRAFT_17)
                  await r2.u62();
                return Parameters.decode(r2, version2);
              });
              const unsupported2 = params.forward === false || params.bytes.size > 0 || params.subscriptionFilter !== void 0 || params.largest !== void 0 || params.rangeFilters || params.trackPropertyFilter || params.authorizationToken || [...params.vars.keys()].some((key) => key !== 0x10n && key !== 0x20n);
              if (unsupported2) {
                const failed = new UpdateFailed();
                publishError = failed;
                await reply(async () => {
                  await stream.writer.u53(RequestError.id);
                  await new RequestError({
                    requestId: void 0,
                    errorCode: toRequestCode("not_supported", "subscribe", version2),
                    reasonPhrase: "REQUEST_UPDATE parameters not supported"
                  }).encode(stream.writer, version2);
                });
                throw failed;
              }
              if (params.subscriberPriority !== void 0)
                track.update({ ...track.subscription.peek(), priority: fromWire(params.subscriberPriority) });
              await reply(async () => {
                await stream.writer.u53(RequestOk.id);
                await new RequestOk({ requestId: void 0 }).encode(stream.writer, version2);
              });
            }
          })();
          const requestEnded = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? updates : race([updates, stream.writer.closed]);
          void requestEnded.then(
            () => {
              if (!finished)
                unsubscribe();
            },
            // Updates can fail after the serving loop ends while its last groups drain.
            (err2) => {
              publishError = error(err2);
              unsubscribe();
            }
          );
          const groups2 = /* @__PURE__ */ new Set();
          const streams2 = { opened: 0 };
          const serving = (async () => {
            for (; ; ) {
              const group = await track.recvGroup();
              if (!group)
                return;
              if (range.end !== void 0 && BigInt(group.sequence) > range.end.group) {
                group.close();
                continue;
              }
              const task = this.#runGroup({
                requestId: msg.requestId,
                group,
                timescale,
                publisherPriority,
                stamped: msg.propertiesWanted,
                slice: groupSlice(range, group.sequence),
                unsubscribed,
                streams: streams2
              });
              groups2.add(task);
              void task.finally(() => groups2.delete(task));
            }
          })();
          const filling = fill && cache ? this.#runFill({
            requestId: msg.requestId,
            priority,
            fill,
            cache,
            timescale,
            stamped: msg.propertiesWanted,
            unsubscribed,
            streams: streams2
          }) : Promise.resolve();
          let ended = false;
          try {
            const served = /* @__PURE__ */ Symbol("served");
            ended = await race([Promise.all([serving, filling]).then(() => served), requestEnded]) === served;
          } catch (err2) {
            publishError = error(err2);
          }
          await race([Promise.all(groups2), unsubscribed]);
          if (publishError && !(publishError instanceof Stream)) {
            track.close(publishError);
            await Promise.all([...groups2, filling]);
          }
          const final = track.final();
          if (ended && !publishError && final !== void 0) {
            await this.#runEndOfTrack({
              requestId: msg.requestId,
              final,
              publisherPriority,
              unsubscribed,
              streams: streams2
            });
          }
          console.debug(`publish done: broadcast=${name} track=${track.name}`);
          if (publishError) {
            console.warn(`publish error: broadcast=${name} track=${track.name} error=${reason(publishError)}`);
          }
          try {
            await reply(async () => {
              replied = true;
              await stream.writer.u53(PublishDone.id);
              const done = new PublishDone({
                requestId: version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? msg.requestId : void 0,
                statusCode: publishError instanceof UpdateFailed ? PublishDoneStatus.UPDATE_FAILED : publishError ? PublishDoneStatus.INTERNAL_ERROR : PublishDoneStatus.TRACK_ENDED,
                streamCount: BigInt(streams2.opened),
                reasonPhrase: publishError instanceof UpdateFailed ? "update failed" : publishError ? "internal error" : "track ended"
              });
              await done.encode(stream.writer, version2);
            });
          } catch {
          }
          finished = true;
          stream.close();
        } catch (err2) {
          const e5 = error(err2);
          console.warn(`publish error: broadcast=${name} track=${track.name} error=${reason(e5)}`);
          stream.abort(e5);
        } finally {
          track.close();
          cache?.close();
        }
      }
      /**
       * Runs a group and sends its frames using ObjectStream (Subgroup delivery mode).
       */
      async #runGroup(options) {
        const { requestId, group, timescale, publisherPriority, stamped, slice, unsubscribed, streams: streams2 } = options;
        try {
          const stream = await Writer.tryOpen(this.#quic, {
            cancel: unsubscribed,
            version: this.#session.version,
            waitUntilAvailable: false
          });
          if (!stream) {
            group.close(new Error("no stream slot"));
            return;
          }
          streams2.opened += 1;
          const header2 = new Group({
            trackAlias: requestId,
            groupId: group.sequence,
            subGroupId: 0,
            publisherPriority,
            flags: {
              // The object properties carry the timestamp, so there is nothing to write
              // when the track declared no units to read one in.
              hasExtensions: stamped,
              hasSubgroup: false,
              hasSubgroupObject: false,
              // A stream capped by the range stops before the group may end, so its FIN
              // cannot claim END_OF_GROUP.
              hasEnd: slice.until === void 0,
              hasPriority: true,
              // Only honest when the stream really starts at the group's first object;
              // a trimmed head starts partway through.
              firstObject: slice.skip === 0
            }
          });
          try {
            await hooks.guardGroup(group, () => header2.encode(stream, this.#session.version));
            let first = true;
            let next = slice.skip;
            for (; ; ) {
              if (slice.until !== void 0 && next >= slice.until)
                break;
              const read2 = await race([hooks.readGroupFrame(group, slice.skip), stream.closed]);
              if (!read2)
                break;
              next = read2.sequence + 1;
              if (slice.until !== void 0 && read2.sequence >= slice.until) {
                read2.complete();
                break;
              }
              try {
                const obj = new Frame({ payload: read2.frame.payload, timestamp: read2.frame.timestamp });
                const delta = first ? read2.sequence : 0;
                first = false;
                await hooks.guardGroup(group, () => obj.encode(stream, header2.flags, timescale, this.#session.version, delta));
              } finally {
                read2.complete();
              }
            }
            stream.close();
          } catch (err2) {
            stream.reset(error(err2));
          }
        } finally {
          group.close();
        }
      }
      /**
       * Mark the track's end with an END_OF_TRACK object on its own stream, at object 0 of the
       * group that will never exist.
       *
       * The last group's stream has usually finished before the track ends, so the marker cannot
       * ride on it. A failure only costs the subscriber the early boundary.
       */
      async #runEndOfTrack(options) {
        const { requestId, final, publisherPriority, unsubscribed, streams: streams2 } = options;
        const version2 = this.#session.version;
        const stream = await Writer.tryOpen(this.#quic, { cancel: unsubscribed, version: version2 }).catch(() => void 0);
        if (!stream)
          return;
        streams2.opened += 1;
        try {
          const header2 = new Group({
            trackAlias: requestId,
            groupId: final,
            subGroupId: 0,
            publisherPriority,
            flags: {
              hasExtensions: false,
              hasSubgroup: false,
              hasSubgroupObject: false,
              hasEnd: false,
              hasPriority: true,
              firstObject: true
            }
          });
          await header2.encode(stream, version2);
          await new Frame({ endOfTrack: true }).encode(stream, header2.flags, Timescale.MILLI, version2);
          stream.close();
        } catch (err2) {
          stream.reset(error(err2));
        }
      }
      /**
       * Serve a draft-20 fill on its own fetch stream: the requested range, read from the
       * group cache, capped at the Largest Object snapshot.
       *
       * A fill is a promise once requested. An empty range opens no stream, but a range we
       * cannot serve still opens one and resets it right after the FETCH_HEADER, the draft's
       * fill-failure signal. Nothing here touches the subscription either way.
       */
      async #runFill(options) {
        const { requestId, fill, cache, timescale, stamped, unsubscribed, streams: streams2 } = options;
        const version2 = this.#session.version;
        let stream;
        try {
          if (fill.kind === "empty")
            return;
          stream = await Writer.tryOpen(this.#quic, { cancel: unsubscribed, version: version2 });
          if (!stream) {
            console.debug(`fill stream failed to open: fill=${requestId}`);
            return;
          }
          streams2.opened += 1;
          await stream.u53(FetchHeader.type);
          await new FetchHeader({ requestId }).encode(stream, version2);
          if (fill.kind !== "group") {
            throw new Error("a fill spanning several groups is not supported");
          }
          const group = takeGroup(cache, Number(fill.sequence));
          try {
            await this.#writeFillGroup(stream, group, fill, timescale, stamped, unsubscribed);
          } finally {
            group.close();
          }
          stream.close();
          console.debug(`fill complete: fill=${requestId}`);
        } catch (err2) {
          const e5 = error(err2);
          console.debug(`fill failed, resetting its stream: fill=${requestId} error=${reason(e5)}`);
          stream?.reset(e5);
        } finally {
          cache.close();
        }
      }
      /**
       * Write one cached group's frames as draft-20 fetch objects.
       *
       * The cap is the Largest Object snapshot: the group may keep growing, but everything
       * past the snapshot belongs to the subscription, not the fill.
       */
      async #writeFillGroup(stream, group, fill, timescale, stamped, unsubscribed) {
        let first = true;
        let next = 0n;
        let left = false;
        const cancelled2 = unsubscribed.then(() => {
          left = true;
          return void 0;
        });
        for (; ; ) {
          if (fill.until !== void 0 && next >= fill.until)
            break;
          const frame = await race([group.readFrameSequence({ from: Number(fill.skip) }), stream.closed, cancelled2]);
          if (left)
            throw new Error("unsubscribed before the fill finished");
          if (!frame)
            break;
          next = BigInt(frame.sequence) + 1n;
          if (fill.until !== void 0 && BigInt(frame.sequence) >= fill.until)
            break;
          const obj = new FetchFrame({ payload: frame.payload, timestamp: stamped ? frame.timestamp : void 0 });
          await obj.encode(stream, { group: Number(fill.sequence), object: frame.sequence, first }, timescale, this.#session.version);
          first = false;
        }
      }
      /**
       * Handles an incoming SUBSCRIBE_NAMESPACE on a bidi stream.
       *
       * Draft-16+ fills the stream with every visible match, independently of unsolicited
       * discovery. Draft-14/15 use PUBLISH_NAMESPACE requests instead and suppress matches
       * already announced on the unsolicited path. Hidden visibility applies to both.
       *
       * @internal
       */
      async runSubscribeNamespace(msg, stream) {
        const version2 = this.#session.version;
        const prefix = msg.namespace;
        const legacy = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15;
        const requests = /* @__PURE__ */ new Map();
        const ending = cancelled(stream, version2);
        try {
          if (version2 === Version.DRAFT_14) {
            await stream.writer.u53(SubscribeNamespaceOk.id);
            const ok = new SubscribeNamespaceOk({ requestId: msg.requestId });
            await ok.encode(stream.writer, version2);
          } else {
            await stream.writer.u53(RequestOk.id);
            const ok = new RequestOk({
              requestId: version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? msg.requestId : void 0
            });
            await ok.encode(stream.writer, version2);
          }
          const carries = (covered) => (!this.#hidden || msg.hidden || !hiddenBelow(prefix, covered)) && (!legacy || this.#requiresSolicitation || this.#hidden && hiddenBelow(empty(), covered));
          const namespace = async (suffix, snap) => {
            await stream.writer.u53(SubscribeNamespaceEntry.id);
            const cluster = clusterFor(this.#advert, snap.route);
            await new SubscribeNamespaceEntry({ suffix, cluster }).encode(stream.writer, version2);
            return "held";
          };
          const target3 = legacy ? {
            advertise: (suffix, snap) => this.#advertise(join(prefix, suffix), requests, clusterFor(this.#advert, snap.route)),
            update: (suffix, _snap, reprice) => this.#update(join(prefix, suffix), requests, reprice),
            withdraw: (suffix) => this.#withdraw(join(prefix, suffix), requests)
          } : {
            advertise: namespace,
            update: namespace,
            withdraw: async (suffix) => {
              await stream.writer.u53(SubscribeNamespaceEntryDone.id);
              await new SubscribeNamespaceEntryDone({ suffix }).encode(stream.writer, version2);
            }
          };
          const ns = { active: /* @__PURE__ */ new Map(), refused: /* @__PURE__ */ new Map(), offered: /* @__PURE__ */ new Map() };
          let retry = 0;
          for (; ; ) {
            let dispose;
            const changed = new Promise((resolve2) => {
              dispose = this.#advertised.changed(resolve2);
            });
            const advertised = this.#advertised.peek();
            if (!advertised) {
              dispose();
              break;
            }
            const outstanding = await this.#reconcile(ns, presented(prefix, advertised, carries), target3);
            retry = outstanding ? Math.min(retry ? retry * 2 : RETRY_BASE, RETRY_MAX) : 0;
            const next = await (retry ? race([changed, ending, retryAfter(retry).then(() => advertised)]) : race([changed, ending]));
            dispose();
            if (!next)
              break;
          }
          stream.close();
        } catch (err2) {
          const e5 = error(err2);
          console.debug(`subscribe_namespace stream error: ${reason(e5)}`);
          stream.abort(e5);
        } finally {
          for (const path of [...requests.keys()]) {
            await this.#withdraw(path, requests);
          }
        }
      }
      /**
       * Advertise every published broadcast with an unsolicited PUBLISH_NAMESPACE, until
       * the publisher is closed.
       *
       * The peers that never send SUBSCRIBE_NAMESPACE are exactly the ones expecting a
       * publisher to announce itself, so announcing is the default. A peer that would
       * rather ask says so in its SETUP (MoQ Solicit) and this does nothing, leaving
       * {@link runSubscribeNamespace} to carry the advertisements instead. Modern peers
       * may also discover the namespace through an inline subscription fill.
       *
       * @internal
       */
      async runPublishNamespaces() {
        if (this.#requiresSolicitation) {
          return;
        }
        const requests = /* @__PURE__ */ new Map();
        const target3 = {
          advertise: (path, snap) => this.#advertise(path, requests, clusterFor(this.#advert, snap.route)),
          update: (path, _snap, reprice) => this.#update(path, requests, reprice),
          withdraw: (path) => this.#withdraw(path, requests)
        };
        const closed = this.#quic.closed.then(() => void 0, () => void 0);
        let dispose;
        try {
          const ns = { active: /* @__PURE__ */ new Map(), refused: /* @__PURE__ */ new Map(), offered: /* @__PURE__ */ new Map() };
          let retry = 0;
          for (; ; ) {
            const changed = new Promise((resolve2) => {
              dispose = this.#advertised.changed(resolve2);
            });
            const advertised = this.#advertised.peek();
            if (!advertised) {
              dispose?.();
              break;
            }
            const updated = /* @__PURE__ */ new Map();
            for (const [covered, candidates] of advertised) {
              if (this.#hidden && hiddenBelow(empty(), covered) || candidates.length === 0)
                continue;
              updated.set(covered, candidates[0]);
            }
            const outstanding = await this.#reconcile(ns, updated, target3);
            retry = outstanding ? Math.min(retry ? retry * 2 : RETRY_BASE, RETRY_MAX) : 0;
            const next = await (retry ? race([changed, closed, retryAfter(retry).then(() => advertised)]) : race([changed, closed]));
            dispose?.();
            if (!next)
              break;
          }
        } catch (err2) {
          console.warn(`publish_namespace loop failed: ${reason(error(err2))}`);
        } finally {
          dispose?.();
          for (const path of [...requests.keys()]) {
            await this.#withdraw(path, requests);
          }
        }
      }
      /**
       * Bring the peer's view in line with `updated`, one namespace at a time, and report
       * whether anything it should hold is still missing and worth coming back for.
       *
       * Nothing the peer cannot see is sent, a reprice updates the namespace in place, and
       * anything else is withdrawn first so a republish reads as withdraw-then-advertise.
       * `ns` records what the peer holds rather than what we attempted: a declined
       * advertisement or update stays out of it, so the next turn offers it fresh instead
       * of believing it is already up.
       */
      async #reconcile(ns, updated, target3) {
        for (const key of [...ns.refused.keys()]) {
          const snap = updated.get(key);
          if (snap === void 0 || ns.offered.get(key) !== snap.identity) {
            ns.refused.delete(key);
            ns.offered.delete(key);
          }
        }
        const held = new Map(ns.active);
        for (const [key, snap] of ns.active) {
          if (change(this.#advert, snap, updated.get(key)) !== "restart")
            continue;
          await target3.withdraw(key);
          held.delete(key);
        }
        for (const [key, snap] of updated) {
          const prev = held.get(key);
          const diff2 = change(this.#advert, prev, snap);
          if (diff2 === "same")
            continue;
          let answer;
          if (prev !== void 0 && diff2 !== "restart") {
            answer = await target3.update(key, snap, diff2);
          } else {
            if (!this.#offerable(key, ns.refused))
              continue;
            answer = await target3.advertise(key, snap);
          }
          if (answer === "held") {
            held.set(key, snap);
            ns.refused.delete(key);
            ns.offered.delete(key);
          } else {
            held.delete(key);
            if (answer !== "dropped") {
              ns.refused.set(key, answer);
              ns.offered.set(key, snap.identity);
            }
          }
        }
        ns.active = held;
        return [...updated].some(([key, snap]) => change(this.#advert, held.get(key), snap) !== "same" && this.#pending(key, ns.refused));
      }
      /**
       * Whether a namespace may be offered to the peer right now.
       *
       * A peer that asked never to be offered it again means it, whatever brought us back;
       * one that named a minimum wait gets it, even when our own backoff comes round sooner.
       */
      #offerable(key, refused) {
        const entry = refused.get(key);
        if (entry === void 0)
          return true;
        return entry !== "never" && Date.now() >= entry;
      }
      /**
       * Whether the loop should keep coming back to a namespace the peer does not hold.
       *
       * Distinct from {@link offerable}, and the difference is what arms the retry: a
       * namespace waiting out a minimum is not offerable yet but is still pending, and
       * gating the timer on offerable instead would disarm it for exactly the wait it is
       * supposed to be counting. Only a refusal that forbids retrying ends it.
       */
      #pending(key, refused) {
        return refused.get(key) !== "never";
      }
      /**
       * What a REQUEST_ERROR's retry interval, in milliseconds, says about re-offering the
       * namespace.
       *
       * Draft-14/15 carry no such field, so a 0 there says nothing and our own backoff
       * stands; everywhere else 0 means the peer does not want this again.
       */
      #refusal(err2) {
        const version2 = this.#session.version;
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15)
          return "dropped";
        return err2.retryInterval === 0n ? "never" : Date.now() + Number(err2.retryInterval);
      }
      /**
       * Advertise one namespace on its own PUBLISH_NAMESPACE request. A declined request
       * is logged and skipped: a peer that wants none of this rejects each one and stays
       * connected.
       */
      async #advertise(path, requests, cluster = this.#advert) {
        const requestId = await this.#session.nextRequestId();
        if (requestId === void 0)
          return "dropped";
        let request;
        try {
          request = await this.#session.openBi();
          const stream = request;
          const answer = await withTimeout((async () => {
            await stream.writer.u53(PublishNamespace.id);
            const msg = new PublishNamespace({ requestId, trackNamespace: path, cluster });
            await msg.encode(stream.writer, this.#session.version);
            const respTypeId = await stream.reader.u53();
            if (respTypeId === RequestError.id) {
              const err2 = await RequestError.decode(stream.reader, this.#session.version);
              const why = requestReason(err2.errorCode, err2.reasonPhrase, "publish_namespace", this.#session.version);
              console.warn(`announce refused: broadcast=${path} error=${why}`);
              stream.abort(new Error(`PublishNamespace rejected: ${why}`));
              return this.#refusal(err2);
            }
            if (respTypeId !== RequestOk.id) {
              throw new Error(`PublishNamespace rejected: typeId=0x${respTypeId.toString(16)}`);
            }
            if (this.#session.version === Version.DRAFT_14) {
              await PublishNamespaceOk.decode(stream.reader, this.#session.version);
            } else {
              await RequestOk.decode(stream.reader, this.#session.version);
            }
            return "held";
          })(), ADVERTISE_TIMEOUT_MS, `advertisement timed out after ${ADVERTISE_TIMEOUT_MS}ms waiting for the peer's answer`);
          if (answer === "held")
            requests.set(path, { path, requestId, stream });
          return answer;
        } catch (err2) {
          const e5 = err2 instanceof TimeoutError ? controlTimeout(err2) : error(err2);
          console.warn(`announce failed: broadcast=${path} error=${reason(e5)}`);
          request?.abort(e5);
          return "dropped";
        }
      }
      /**
       * Update a namespace the peer holds: REQUEST_UPDATE on the request that carries it,
       * with only the parameters that changed, then its answer.
       *
       * Waiting for the answer keeps one update outstanding per stream, which satisfies any
       * MAX_REQUEST_UPDATES the peer set without reading it; a change landing meanwhile waits
       * for the next turn. The answer decides whether the peer still holds the namespace: a
       * REQUEST_ERROR closes the peer's side and withdraws the advertisement, so ours is
       * finished too, and an unanswered update is dropped abruptly, since a peer that ignored
       * it cannot be assumed to hold either price. Either way the retry re-offers it fresh.
       *
       * A different original publisher is an update like any other: the receiver drains what
       * it already serves from the old one and never splices the two.
       */
      async #update(path, requests, { from: from2, to }) {
        const request = requests.get(path);
        if (!request)
          return "dropped";
        const update = {
          hops: sameHops(from2.hops, to.hops) ? void 0 : to.hops,
          cost: from2.cost === to.cost ? void 0 : to.cost
        };
        const version2 = this.#session.version;
        let answer;
        try {
          const requestId = await this.#session.nextRequestId();
          if (requestId === void 0)
            throw new Error("no request ID for the update");
          answer = await withTimeout((async () => {
            const { writer, reader } = request.stream;
            await writer.u53(PublishNamespaceUpdate.id);
            await new PublishNamespaceUpdate({ requestId, update }).encode(writer, version2);
            const typeId = await reader.u53();
            if (typeId === RequestError.id) {
              const err2 = await RequestError.decode(reader, version2);
              const why = requestReason(err2.errorCode, err2.reasonPhrase, "publish_namespace", version2);
              console.warn(`publish_namespace update refused: broadcast=${path} error=${why}`);
              return this.#refusal(err2);
            }
            if (typeId !== RequestOk.id) {
              throw new Error(`unexpected answer to the update: typeId=0x${typeId.toString(16)}`);
            }
            await RequestOk.decode(reader, version2);
            return "held";
          })(), ADVERTISE_TIMEOUT_MS, `update timed out after ${ADVERTISE_TIMEOUT_MS}ms waiting for the peer's answer`);
        } catch (err2) {
          const e5 = err2 instanceof TimeoutError ? controlTimeout(err2) : error(err2);
          console.warn(`publish_namespace update failed: broadcast=${path} error=${reason(e5)}`);
          requests.delete(path);
          request.stream.abort(e5);
          return "dropped";
        }
        if (answer !== "held")
          await this.#withdraw(path, requests).catch(() => void 0);
        return answer;
      }
      /**
       * Close out a namespace's PUBLISH_NAMESPACE request with PUBLISH_NAMESPACE_DONE.
       */
      async #withdraw(path, requests) {
        const request = requests.get(path);
        if (!request)
          return;
        requests.delete(path);
        const version2 = this.#session.version;
        if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          try {
            await request.stream.writer.u53(PublishNamespaceDone.id);
            const done = new PublishNamespaceDone({ trackNamespace: request.path, requestId: request.requestId });
            await done.encode(request.stream.writer, version2);
          } catch {
          }
          request.stream.close();
          return;
        }
        request.stream.close();
        await request.stream.writer.closed;
      }
      /**
       * Handles an incoming TRACK_STATUS_REQUEST on a bidi stream.
       *
       * @internal
       */
      async runTrackStatusRequest(msg, stream) {
        await this.#refuseUnsupported(stream, msg.requestId, "track_status", 15, "TRACK_STATUS is not supported");
      }
      /**
       * Refuses an incoming SUBSCRIBE_TRACKS (draft-18+): we never send the PUBLISH it asks for.
       * The reply carries no Request ID, so the message body is left unread.
       *
       * @internal
       */
      async runSubscribeTracks(stream) {
        const version2 = this.#session.version;
        await stream.writer.u53(RequestError.id);
        await new RequestError({
          errorCode: toRequestCode("not_supported", "subscribe_namespace", version2),
          reasonPhrase: "SUBSCRIBE_TRACKS is not supported"
        }).encode(stream.writer, version2);
        stream.close();
      }
      /**
       * Handles an incoming FETCH on a bidi stream. We serve none.
       *
       * @internal
       */
      async runFetch(msg, stream) {
        await this.#refuseUnsupported(stream, msg.requestId, "fetch", FetchError.id, "FETCH is not supported");
      }
      /**
       * Refuse a request NOT_SUPPORTED. Draft-14 gives each request its own error message,
       * `errorId14`, with the SUBSCRIBE_ERROR body; later drafts use REQUEST_ERROR.
       */
      async #refuseUnsupported(stream, requestId, kind, errorId14, reasonPhrase) {
        const version2 = this.#session.version;
        const errorCode = toRequestCode("not_supported", kind, version2);
        if (version2 === Version.DRAFT_14) {
          await stream.writer.u53(errorId14);
          await new SubscribeError({ requestId, errorCode, reasonPhrase }).encode(stream.writer, version2);
        } else {
          await stream.writer.u53(RequestError.id);
          await new RequestError({
            requestId: version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? requestId : void 0,
            errorCode,
            reasonPhrase
          }).encode(stream.writer, version2);
        }
        stream.close();
      }
    };
    UpdateFailed = class extends Error {
      constructor() {
        super("subscription update failed");
      }
    };
  }
});

// ../../node_modules/@moq/net/consume.js
var BroadcastCache;
var init_consume = __esm({
  "../../node_modules/@moq/net/consume.js"() {
    BroadcastCache = class {
      // The base handle per path; callers get reference-counted clones of it.
      #cache = /* @__PURE__ */ new Map();
      /** A shared handle to the live broadcast cached for `path`, or `undefined` on a miss. */
      get(path) {
        const base2 = this.#cache.get(path);
        if (base2 && base2.closed.peek() === void 0)
          return base2.clone();
        return void 0;
      }
      /**
       * Cache `consumer` as the base handle for `path` (evicting it once it closes) and return it.
       * Call on a {@link get} miss, after wiring up the fresh consumer's subscribe loop.
       */
      insert(path, consumer) {
        this.#cache.set(path, consumer);
        void consumer.closed.then(() => {
          if (this.#cache.get(path) === consumer)
            this.#cache.delete(path);
        });
        return consumer;
      }
      /**
       * Stop sharing the broadcast cached for `path`, so the next request subscribes fresh.
       *
       * Call when the path's advertisement goes away. A handle only leaves the cache on its own
       * once *every* holder has closed it, so one holder outliving the publisher (a second
       * watcher, or a caller consuming the path directly) would otherwise keep the dead
       * generation's cached tracks alive and hand them to whoever consumes the path next.
       * Existing handles are left alone: they belong to their holders, and the wire resets
       * whatever they still have open.
       *
       * Eviction is unconditional, which costs a dedup miss when two announcement streams watch
       * one path: the second stream's retraction can arrive after the first has already seen the
       * replacement, dropping the fresh entry so the next request subscribes again instead of
       * sharing. Telling that stale retraction from a live one needs a generation id on the
       * advertisement (moq-lite's `Epoch`, not yet on the wire), so until then this errs toward a
       * duplicate subscription rather than risk handing out a dead one.
       */
      evict(path) {
        this.#cache.delete(path);
      }
    };
  }
});

// ../../node_modules/@moq/net/tail.js
var TAIL_GRACE_MS, MAX_TIMEOUT_MS2, Tail;
var init_tail = __esm({
  "../../node_modules/@moq/net/tail.js"() {
    init_signals();
    init_time();
    TAIL_GRACE_MS = Milli(1e3);
    MAX_TIMEOUT_MS2 = 2 ** 31 - 1;
    Tail = class {
      // Disjoint, sorted, non-adjacent runs of accounted sequences. A gap older than the grace
      // can no longer be waited for, so it folds into the runs around it, which bounds this by
      // the gaps opened within the grace rather than every gap in the subscription. A fold is
      // final: a later, longer grace or a lowered floor cannot reopen it.
      #runs = [];
      // Group streams whose header arrived, and those still being read.
      #streams = 0;
      #active = 0;
      #changed = new Signal(0);
      #grace;
      #now;
      constructor(options = {}) {
        this.#grace = options.grace ?? (() => TAIL_GRACE_MS);
        this.#now = options.now ?? (() => performance.now());
      }
      /** Group streams whose header arrived, whether they finished or were reset. */
      get streams() {
        return this.#streams;
      }
      /**
       * Record a group stream whose header arrived. Returns the call that marks it read to
       * its end, which is idempotent.
       */
      open(sequence) {
        this.#streams += 1;
        this.#active += 1;
        this.#account(sequence, sequence + 1);
        let closed = false;
        return () => {
          if (closed)
            return;
          closed = true;
          this.#active -= 1;
          this.#bump();
        };
      }
      /** Record sequences `[start, end)` as accounted for without a stream: dropped, or a datagram. */
      account(start, end) {
        this.#account(start, end);
      }
      /** Restart the age of every gap reaching into `[start, end)`, which the demand newly asks for. */
      demand(start, end) {
        if (start >= end)
          return;
        const now = this.#now();
        let below = 0;
        this.#runs = this.#runs.map((run) => {
          const reached = below < end && start < run.start;
          below = run.end;
          return reached ? { ...run, since: now } : run;
        });
      }
      /** Whether every sequence in `[start, end)` is accounted for. */
      covers(start, end) {
        if (start >= end)
          return true;
        return this.#runs.some((run) => run.start <= start && end <= run.end);
      }
      /**
       * Wait until every stream is read to its end and `complete()` holds, or the grace passes
       * with nothing left being read, or `closed` settles.
       *
       * A stream still being read is always waited for: a group ends on its own stream's FIN
       * or reset, never because its track ended. The grace only gives up on streams that never
       * arrived.
       */
      async settle(complete, closed) {
        this.#expire(this.#now());
        let expired = false;
        const timer = setTimeout(() => {
          expired = true;
          this.#bump();
        }, Math.min(this.#grace(), MAX_TIMEOUT_MS2));
        try {
          while (closed.peek() === void 0) {
            if (this.#active === 0 && (expired || complete()))
              return;
            await Signal.race(this.#changed, closed);
          }
        } finally {
          clearTimeout(timer);
        }
      }
      #account(start, end) {
        if (start >= end)
          return;
        const now = this.#now();
        const runs = [];
        let merged;
        let placed = false;
        for (const run of this.#runs) {
          if (run.end < start) {
            runs.push(run);
          } else if (end < run.start) {
            if (!placed)
              runs.push(merged ?? { start, end, since: run.since });
            placed = true;
            runs.push(run);
          } else {
            merged = {
              start: Math.min(merged?.start ?? start, run.start),
              end: Math.max(merged?.end ?? end, run.end),
              since: merged?.since ?? run.since
            };
          }
        }
        if (!placed)
          runs.push(merged ?? { start, end, since: now });
        this.#runs = runs;
        this.#expire(now);
        this.#bump();
      }
      // Fold every gap older than the grace into the runs around it.
      #expire(now) {
        const grace = this.#grace();
        const runs = [];
        for (const run of this.#runs) {
          const below = runs.at(-1);
          if (below && now - run.since >= grace) {
            runs[runs.length - 1] = { ...below, end: run.end };
          } else {
            runs.push(run);
          }
        }
        this.#runs = runs;
      }
      #bump() {
        this.#changed.update((revision) => revision + 1);
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/aliases.js
function sameTrack(a2, b3) {
  return a2.broadcast === b3.broadcast && a2.name === b3.name;
}
var TRACK_ALIAS_TIMEOUT_MS, RETIRED_ALIAS_CAPACITY, RetiredTrackAlias, SharedTrackAlias, DuplicateTrackAlias, TrackAliases;
var init_aliases = __esm({
  "../../node_modules/@moq/net/ietf/aliases.js"() {
    TRACK_ALIAS_TIMEOUT_MS = 1e3;
    RETIRED_ALIAS_CAPACITY = 64;
    RetiredTrackAlias = class extends Error {
      constructor(alias) {
        super(`track alias retired: ${alias}`);
        this.name = "RetiredTrackAlias";
      }
    };
    SharedTrackAlias = class extends Error {
      constructor(alias) {
        super(`track alias shared by another subscription: ${alias}`);
        this.name = "SharedTrackAlias";
      }
    };
    DuplicateTrackAlias = class extends Error {
      constructor(alias) {
        super(`duplicate track alias: ${alias}`);
        this.name = "DuplicateTrackAlias";
      }
    };
    TrackAliases = class {
      #active = /* @__PURE__ */ new Map();
      #pending = /* @__PURE__ */ new Map();
      /** Aliases whose subscription we cancelled, in retirement order so the oldest is forgotten first. */
      #retired = [];
      #retiredSet = /* @__PURE__ */ new Set();
      /**
       * Waits briefly for an alias to be established by SUBSCRIBE_OK or PUBLISH.
       *
       * Throws {@link RetiredTrackAlias} at once for an alias we cancelled, rather than
       * waiting out the timeout for a binding that is never coming.
       */
      async get(alias) {
        const bound = this.#active.get(alias);
        if (bound !== void 0)
          return bound.value;
        if (this.#retiredSet.has(alias))
          throw new RetiredTrackAlias(alias);
        const { promise, resolve: resolve2 } = Promise.withResolvers();
        let resolvers = this.#pending.get(alias);
        if (!resolvers) {
          resolvers = /* @__PURE__ */ new Set();
          this.#pending.set(alias, resolvers);
        }
        resolvers.add(resolve2);
        let timer;
        const timeout = new Promise((_3, reject) => {
          timer = setTimeout(() => reject(new Error(`unknown track alias: ${alias}`)), TRACK_ALIAS_TIMEOUT_MS);
        });
        try {
          return await Promise.race([promise, timeout]);
        } finally {
          clearTimeout(timer);
          resolvers.delete(resolve2);
          if (this.#pending.get(alias) === resolvers && resolvers.size === 0)
            this.#pending.delete(alias);
        }
      }
      /**
       * Establishes an alias and releases any data streams waiting for it.
       *
       * `track` is the full track name the alias was bound to, which is what decides whether a
       * repeat is the legal sharing of an alias across subscriptions to one track
       * ({@link SharedTrackAlias}) or the collision that must fail the session
       * ({@link DuplicateTrackAlias}).
       */
      set(alias, value, track) {
        const active = this.#active.get(alias);
        if (active !== void 0) {
          if (active.value === value)
            return;
          throw sameTrack(active.track, track) ? new SharedTrackAlias(alias) : new DuplicateTrackAlias(alias);
        }
        this.#forget(alias);
        this.#active.set(alias, { value, track });
        const resolvers = this.#pending.get(alias);
        this.#pending.delete(alias);
        for (const resolve2 of resolvers ?? [])
          resolve2(value);
      }
      /**
       * Retires an alias whose subscription was cancelled, so groups still in flight for it
       * are discarded promptly instead of reported as unknown.
       *
       * Only retires an alias that still belongs to the supplied value: a later subscription
       * may already have reclaimed it, and that binding outranks a departing owner.
       *
       * Returns whether this caller still owned the binding, so metadata keyed by the alias is
       * only torn down by the owner and never out from under whoever reclaimed it.
       */
      retire(alias, value) {
        if (this.#active.get(alias)?.value !== value)
          return false;
        this.#active.delete(alias);
        if (this.#retiredSet.has(alias))
          return true;
        this.#retiredSet.add(alias);
        this.#retired.push(alias);
        while (this.#retired.length > RETIRED_ALIAS_CAPACITY) {
          const oldest = this.#retired.shift();
          if (oldest !== void 0)
            this.#retiredSet.delete(oldest);
        }
        return true;
      }
      #forget(alias) {
        if (!this.#retiredSet.delete(alias))
          return;
        const at2 = this.#retired.indexOf(alias);
        if (at2 !== -1)
          this.#retired.splice(at2, 1);
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/subscriber.js
function sees(filter, path) {
  return scopeOverlaps(filter.scope, path) && (filter.hidden || !hiddenBelow(filter.prefix, path));
}
var SUBSCRIBE_OK_TIMEOUT_MS, Subscriber2, ConsumeBroadcast;
var init_subscriber = __esm({
  "../../node_modules/@moq/net/ietf/subscriber.js"() {
    init_signals();
    init_announced();
    init_broadcast();
    init_consume();
    init_error2();
    init_group();
    init_hop();
    init_internal();
    init_path();
    init_stream();
    init_tail();
    init_time();
    init_timeout();
    init_wire();
    init_aliases();
    init_cluster();
    init_error();
    init_object();
    init_priority();
    init_publish();
    init_publish_namespace();
    init_request();
    init_subscribe();
    init_subscribe_namespace();
    init_version();
    SUBSCRIBE_OK_TIMEOUT_MS = 1e4;
    Subscriber2 = class {
      #session;
      #localClose = false;
      // The transport, so a request cut off by the session's close ends with the session's
      // error. Optional for tests that drive a bare session.
      #quic;
      // The Hop IDs this session declared; see {@link Cluster}. What the peer declared is what
      // says whether an advertisement carries a hop path, and ours is what a path looping back
      // to us contains.
      #cluster;
      // Publisher-chosen aliases used by incoming group streams.
      #aliases = new TrackAliases();
      // Units for each track's object Timestamps, from the TIMESCALE Track Property in
      // SUBSCRIBE_OK. A track missing from this map declared no timeline, so the publisher
      // opted out of timestamps and its frames are stamped on arrival instead.
      #timescales = /* @__PURE__ */ new Map();
      // Dedup consumed broadcasts per path: repeat consume() calls share one subscription.
      #consumes = new BroadcastCache();
      // A random Hop ID of this connection's own, written as the first hop of any path that
      // names no publisher, so a publisher that reconnects reads as a new one.
      #stamp = randomHop();
      // Paths with a legacy PUBLISH_NAMESPACE request in flight, reserved synchronously.
      // The count below is only taken once the OK is written, and two requests that both
      // got past the duplicate check before either attached would both take one.
      #legacyRequests = /* @__PURE__ */ new Set();
      // Every announced path, counted by how many live advertisements reference it.
      //
      // A peer may advertise one namespace twice on a session: an unsolicited
      // PUBLISH_NAMESPACE and an inline NAMESPACE answering our own SUBSCRIBE_NAMESPACE are
      // two messages about one source, which the MoQ Solicit draft requires us to tolerate.
      // Counting them is what keeps the second from duplicating the announce and the first
      // to end from retracting what the other still holds.
      #announced = /* @__PURE__ */ new Map();
      // Any consumers that want each new announcement, keyed by their local filter.
      #announcedConsumers = /* @__PURE__ */ new Map();
      // Whether the peer understands the HIDDEN parameter (MoQ Hidden).
      #hidden;
      /** Marks this subscriber's deliberate local session close. @internal */
      close() {
        this.#localClose = true;
      }
      /**
       * Creates a new Subscriber instance.
       *
       * @internal
       */
      constructor({ session, quic, cluster, hidden = false }) {
        this.#session = session;
        this.#quic = quic;
        this.#cluster = cluster;
        this.#hidden = hidden;
      }
      /**
       * Whether an advertisement is ours coming back: its hop path already ran through us, so
       * subscribing via it would route us back to ourselves.
       *
       * A conforming peer withholds these (it knows our Hop ID), so this is the backstop that
       * keeps a mesh working when one member does not. A session that negotiated nothing
       * carries no path, and there is nothing to check.
       */
      #reflected(advert) {
        return advert !== void 0 && this.#cluster !== void 0 && loops(advert, this.#cluster.self);
      }
      /**
       * The route an advertisement carries; one without a path is free. A path that names no
       * publisher, or none at all, gets this connection's stamp in front of a 0.
       */
      #route(advert) {
        if (advert === void 0)
          return { hops: [this.#stamp, UNKNOWN_HOP], cost: Cost.zero };
        const hops = stampHops(advert.hops, this.#stamp) ?? [...advert.hops];
        return { hops, cost: { warm: advert.cost, cold: advert.cost } };
      }
      /**
       * Gets an announced reader matching `scope`. Paths are relative to the session,
       * not the scope.
       *
       * The peer is asked with SUBSCRIBE_NAMESPACE regardless of what it declared, and an
       * unsolicited PUBLISH_NAMESPACE lands here too, so a peer that only tells and one
       * that only answers are both discovered.
       *
       * Hidden routes (a `.`-prefixed segment below the scope's head) are left out unless
       * `options.hidden` opts in. The opt-in rides the SUBSCRIBE_NAMESPACE when the peer
       * understands it (MoQ Hidden); the rule is also applied here, since an unsolicited
       * PUBLISH_NAMESPACE or a peer that never heard of it hides nothing.
       */
      announced(scope = Pattern.all(), options) {
        const prefix = scopeHead(scope);
        const filter = { scope, prefix, hidden: options?.hidden ?? false };
        const announced = new Producer();
        for (const [active, info] of this.#announced) {
          if (!sees(filter, active))
            continue;
          announced.append({
            prefix: active,
            captures: scopeCaptures(scope, active),
            kind: "announced",
            route: info.route
          });
        }
        this.#announcedConsumers.set(announced, filter);
        void this.#runAnnounced(announced, prefix, filter.hidden && this.#hidden).finally(() => {
          this.#announcedConsumers.delete(announced);
          announced.close();
        });
        return announced.consume();
      }
      /**
       * Record one more advertisement for a path, telling consumers only when it is the
       * first. A second one is the same namespace said twice, not news.
       */
      #attachAnnounce(path, route) {
        const existing = this.#announced.get(path);
        if (existing) {
          existing.count += 1;
          return;
        }
        this.#announced.set(path, { count: 1, route });
        console.debug(`announced: broadcast=${path} active=true`);
        for (const [consumer, filter] of this.#announcedConsumers) {
          if (!sees(filter, path))
            continue;
          const scope = filter.scope;
          consumer.append({ prefix: path, captures: scopeCaptures(scope, path), kind: "announced", route });
        }
      }
      /**
       * Replace the stored route for a path that is already announced. A no-op when the
       * hops and cost did not change; otherwise consumers hear `updated` so a forwarder
       * can reprice without retracting.
       *
       * A new first hop is a new publisher: holders keep their broadcast to drain, but the
       * next consume starts fresh rather than reusing the old publisher's cached track info.
       */
      #updateAnnounce(path, route) {
        const existing = this.#announced.get(path);
        if (existing === void 0 || routesEqual(existing.route, route))
          return;
        if (existing.route.hops[0] !== route.hops[0])
          this.#consumes.evict(path);
        existing.route = route;
        console.debug(`announced: broadcast=${path} rerouted`);
        for (const [consumer, filter] of this.#announcedConsumers) {
          if (!sees(filter, path))
            continue;
          const scope = filter.scope;
          consumer.append({ prefix: path, captures: scopeCaptures(scope, path), kind: "updated", route });
        }
      }
      /**
       * Drop one advertisement for a path, retracting it only once the last one goes.
       */
      #detachAnnounce(path) {
        const existing = this.#announced.get(path);
        if (existing === void 0)
          return;
        if (existing.count > 1) {
          existing.count -= 1;
          return;
        }
        this.#announced.delete(path);
        this.#consumes.evict(path);
        console.debug(`announced: broadcast=${path} active=false`);
        for (const [consumer, filter] of this.#announcedConsumers) {
          if (!sees(filter, path))
            continue;
          const scope = filter.scope;
          try {
            consumer.append({
              prefix: path,
              captures: scopeCaptures(scope, path),
              kind: "retracted",
              route: existing.route
            });
          } catch {
          }
        }
      }
      async #runAnnounced(announced, prefix, hidden) {
        const version2 = this.#session.version;
        const live = /* @__PURE__ */ new Set();
        let released = false;
        const requestId = await this.#session.nextRequestId();
        if (requestId === void 0)
          return;
        try {
          const stream = version2 === Version.DRAFT_16 && this.#session.openNativeBi ? await this.#session.openNativeBi() : await this.#session.openBi();
          try {
            if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 || version2 === Version.DRAFT_17) {
              await stream.writer.u53(SubscribeNamespaceLegacy.id);
              await new SubscribeNamespaceLegacy({ namespace: prefix, requestId, hidden }).encode(stream.writer, version2);
            } else {
              await stream.writer.u53(SubscribeNamespace.id);
              await new SubscribeNamespace({ namespace: prefix, requestId, hidden }).encode(stream.writer, version2);
            }
            console.debug(`subscribe_namespace written: requestId=${requestId}`);
            const respTypeId = await stream.reader.u53();
            if (respTypeId === RequestOk.id) {
              await RequestOk.decode(stream.reader, version2);
            } else if (respTypeId === SubscribeNamespaceOk.id) {
              const size2 = await stream.reader.u16();
              await stream.reader.read(size2);
            } else {
              throw new Error(`SubscribeNamespace rejected: typeId=0x${respTypeId.toString(16)}`);
            }
            const readLoop = (async () => {
              for (; ; ) {
                const done = await stream.reader.done();
                if (done)
                  break;
                const msgType = await stream.reader.u53();
                if (msgType === SubscribeNamespaceEntry.id) {
                  const entry = await SubscribeNamespaceEntry.decode(stream.reader, version2, negotiated(this.#cluster));
                  if (released)
                    break;
                  const path = join(prefix, entry.suffix);
                  if (this.#reflected(entry.cluster)) {
                    console.debug(`dropping reflected namespace: broadcast=${path}`);
                    if (live.delete(path))
                      this.#detachAnnounce(path);
                    continue;
                  }
                  const route = this.#route(entry.cluster);
                  if (live.has(path)) {
                    this.#updateAnnounce(path, route);
                  } else {
                    live.add(path);
                    this.#attachAnnounce(path, route);
                  }
                } else if (msgType === SubscribeNamespaceEntryDone.id) {
                  const entry = await SubscribeNamespaceEntryDone.decode(stream.reader, version2);
                  if (released)
                    break;
                  const path = join(prefix, entry.suffix);
                  if (live.delete(path)) {
                    this.#detachAnnounce(path);
                  }
                } else if (msgType === PublishBlocked.id && version2 === Version.DRAFT_17) {
                  const blocked = await PublishBlocked.decode(stream.reader, version2);
                  console.debug(`publish_blocked: suffix=${blocked.suffix} track=${blocked.trackName}`);
                } else {
                  throw new Error(`unexpected message on subscribe_namespace stream: 0x${msgType.toString(16)}`);
                }
              }
            })();
            readLoop.catch((err2) => {
              if (err2 instanceof ProtocolViolation)
                this.#session.close();
            });
            await race([readLoop, announced.closed]);
            if (version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15) {
              try {
                await stream.writer.u53(UnsubscribeNamespace.id);
                const unsub = new UnsubscribeNamespace({ requestId });
                await unsub.encode(stream.writer, version2);
              } catch {
              }
            }
            stream.close();
          } catch (err2) {
            stream.abort(error(err2));
            throw err2;
          }
        } catch (err2) {
          const e5 = error(err2);
          console.warn(`subscribe_namespace error: ${reason(e5)}`);
          if (e5 instanceof ProtocolViolation)
            this.#session.close();
          announced.close(e5);
        } finally {
          released = true;
          for (const path of live) {
            this.#detachAnnounce(path);
          }
          live.clear();
        }
      }
      /**
       * Consumes a broadcast from the connection.
       *
       * Deduplicated per path: repeat calls for the same still-live path share one reference-counted
       * broadcast (and one upstream subscription). The shared broadcast closes once every caller has
       * closed its handle, so callers close normally.
       */
      consume(path) {
        return this.#consumes.get(path) ?? this.#consumes.insert(path, this.#createConsume(path));
      }
      #createConsume(path) {
        const consumer = new ConsumeBroadcast();
        void (async () => {
          for (; ; ) {
            const request = await wireOf(consumer).requested();
            if (!request)
              break;
            void this.#runSubscribe(path, request);
          }
        })();
        return consumer;
      }
      // The adapter is gone. If the transport has already closed, that close is the
      // error. A still-open transport, such as a GOAWAY drain, has no peer code yet,
      // so this does not wait for it.
      async #closedSession() {
        const quic = this.#quic;
        if (!quic)
          return new Error("session closed");
        return Promise.race([
          closeError(quic),
          new Promise((resolve2) => queueMicrotask(() => resolve2(new Error("session closed"))))
        ]);
      }
      async #runSubscribe(broadcast2, request) {
        const requestId = await this.#session.nextRequestId();
        if (requestId === void 0) {
          request.reject(await this.#closedSession());
          return;
        }
        console.debug(`subscribe start: id=${requestId} broadcast=${broadcast2} track=${request.name}`);
        const producer = hooks.pendingTrackProducer(request);
        const subscription = { track: producer, tail: new Tail() };
        const state = {};
        const setup = this.#openSubscribe(state, broadcast2, request, subscription, requestId);
        const waitAbandoned = async () => {
          while (!producer.used.peek() && producer.closed.peek() === void 0) {
            await Signal.race(producer.used, producer.closed);
          }
          for (; ; ) {
            await producer.unused();
            if (producer.closed.peek() !== void 0 || !producer.used.peek())
              return null;
          }
        };
        let stream;
        let trackAlias;
        try {
          const result = await race([
            withTimeout(setup, SUBSCRIBE_OK_TIMEOUT_MS, `subscribe timed out after ${SUBSCRIBE_OK_TIMEOUT_MS}ms waiting for SUBSCRIBE_OK (browser stream limit reached?)`),
            waitAbandoned()
          ]);
          if (result === null)
            throw new Error("subscribe abandoned before it was accepted");
          stream = result.stream;
          trackAlias = result.alias;
          console.debug(`subscribe ok: id=${requestId} broadcast=${broadcast2} track=${request.name}`);
        } catch (err2) {
          const e5 = err2 instanceof TimeoutError ? controlTimeout(err2) : await sessionCause(this.#quic, err2);
          request.reject(e5);
          console.warn(`subscribe error: id=${requestId} broadcast=${broadcast2} track=${request.name} error=${reason(e5)}`);
          let torn = false;
          const cleanup = async (afterSetup) => {
            state.cancelled = true;
            if (state.registeredAlias !== void 0 && this.#aliases.retire(state.registeredAlias, subscription)) {
              this.#timescales.delete(state.registeredAlias);
            }
            if (!state.stream || torn)
              return;
            if (!state.sent && !afterSetup)
              return;
            torn = true;
            if (state.sent && !state.rejected)
              await this.#cancelSubscribe(state.stream, requestId);
            state.stream.abort(e5);
          };
          void cleanup(false);
          setup.then(() => cleanup(true), () => cleanup(true));
          return;
        }
        try {
          const publisherEnded = /* @__PURE__ */ Symbol("publisher");
          const localEnded = /* @__PURE__ */ Symbol("local");
          const idle = /* @__PURE__ */ Symbol("idle");
          const done = race([
            this.#runPublishDone(stream, subscription).then(() => publisherEnded),
            producer.closed.then(() => localEnded)
          ]);
          let terminal = localEnded;
          for (; ; ) {
            const reason2 = await race([done, producer.unused().then(() => idle)]);
            if (reason2 === idle && producer.closed.peek() === void 0 && producer.used.peek())
              continue;
            terminal = reason2;
            break;
          }
          producer.close();
          if (terminal !== publisherEnded)
            await this.#cancelSubscribe(stream, requestId);
          stream.close();
          console.debug(`subscribe close: id=${requestId} broadcast=${broadcast2} track=${request.name}`);
        } catch (err2) {
          const e5 = await sessionCause(this.#quic, err2);
          producer.close(this.#localClose ? void 0 : e5);
          stream.abort(e5);
          console.warn(`subscribe error: id=${requestId} broadcast=${broadcast2} track=${request.name} error=${reason(e5)}`);
        } finally {
          if (this.#aliases.retire(trackAlias, subscription))
            this.#timescales.delete(trackAlias);
        }
      }
      /**
       * Read the PUBLISH_DONE that ends a subscription, then wait for the data streams it counts.
       *
       * An error status aborts the track with it. A clean one leaves streams in flight, since
       * QUIC does not order them, so wait until the Stream Count many have been read, or a
       * bounded grace for the ones that never arrive (the draft says to use a timeout). The count
       * is only a hint: a peer may send 0 regardless, so 0 waits out the grace. A request
       * stream that FINs without PUBLISH_DONE is a protocol violation.
       */
      async #runPublishDone(stream, subscription) {
        const version2 = this.#session.version;
        if (await stream.reader.done())
          throw new ProtocolViolation("subscribe stream ended without PUBLISH_DONE");
        const typeId = await stream.reader.u53();
        if (typeId !== PublishDone.id) {
          throw new ProtocolViolation(`unexpected message on a subscription: 0x${typeId.toString(16)}`);
        }
        const done = await PublishDone.decode(stream.reader, version2);
        if (!publishDoneClean(done.statusCode, version2)) {
          throw new Error(`publish done: status=0x${done.statusCode.toString(16)} reason=${done.reasonPhrase}`);
        }
        const count2 = done.streamCount;
        const { tail, track } = subscription;
        const complete = () => count2 > 0n && BigInt(tail.streams) >= count2;
        await tail.settle(complete, track.closed);
      }
      /**
       * Tell the publisher to stop serving a subscription we are walking away from.
       *
       * v14-16 cancel with UNSUBSCRIBE (draft-16 section 9.12), which is what lets the
       * publisher destroy the subscription (section 5.1.1); v17+ removed the message and
       * rely on the stream reset instead. Every path that abandons an Established
       * subscription goes through here, because those versions carry the request over a
       * virtual stream whose reset never reaches the peer.
       */
      async #cancelSubscribe(stream, requestId) {
        const version2 = this.#session.version;
        if (version2 !== Version.DRAFT_14 && version2 !== Version.DRAFT_15 && version2 !== Version.DRAFT_16)
          return;
        try {
          await stream.writer.u53(Unsubscribe.id);
          await new Unsubscribe({ requestId }).encode(stream.writer, version2);
        } catch {
        }
      }
      // Opens the subscribe stream, sends SUBSCRIBE, and reads the response.
      // `state` is populated as soon as the stream opens and again when the
      // trackAlias is registered, so the caller can clean both up on timeout
      // even before this promise settles.
      async #openSubscribe(state, broadcast2, request, subscription, requestId) {
        const version2 = this.#session.version;
        state.stream = await this.#session.openBi();
        if (state.cancelled)
          throw new Error("subscribe cancelled before it was sent");
        await state.stream.writer.u53(Subscribe.id);
        const msg = new Subscribe({
          requestId,
          trackNamespace: broadcast2,
          trackName: request.name,
          subscriberPriority: toWire(request.priority),
          // No fill is requested: the fill's fetch stream and the live subscription split
          // the group across two streams, and this subscriber does not reassemble them into
          // one group yet. A lenient publisher (like ours) replays the whole in-range group
          // on the subscription instead; a strict one only delivers from the next published
          // object, and that mid-group stream is dropped, degrading the join to the next
          // group boundary.
          filter: joinFilter(version2)
        });
        await msg.encode(state.stream.writer, version2);
        state.sent = true;
        if (state.cancelled)
          throw new Error("subscribe cancelled while it was being sent");
        console.debug(`subscribe written: id=${requestId} broadcast=${broadcast2} track=${request.name}`);
        const respTypeId = await state.stream.reader.u53();
        if (respTypeId !== SubscribeOk.id) {
          let reasonPhrase = "unknown error";
          try {
            if (respTypeId === RequestError.id) {
              const err2 = version2 === Version.DRAFT_14 ? await SubscribeError.decode(state.stream.reader, version2) : await RequestError.decode(state.stream.reader, version2);
              reasonPhrase = requestReason(err2.errorCode, err2.reasonPhrase, "subscribe", version2);
            }
          } catch {
          }
          state.rejected = true;
          throw new Error(`SUBSCRIBE error: ${reasonPhrase}`);
        }
        const ok = await SubscribeOk.decode(state.stream.reader, version2);
        if (state.cancelled)
          throw new Error("subscribe cancelled before acceptance");
        request.accept({ priority: fromWire(ok.properties.priority ?? 128) });
        try {
          this.#aliases.set(ok.trackAlias, subscription, { broadcast: broadcast2, name: request.name });
          const timescale = ok.properties.timescale;
          if (timescale !== void 0) {
            this.#timescales.set(ok.trackAlias, timescale);
          }
        } catch (err2) {
          if (err2 instanceof DuplicateTrackAlias)
            this.#session.close();
          throw err2;
        }
        state.registeredAlias = ok.trackAlias;
        return { stream: state.stream, alias: ok.trackAlias };
      }
      /**
       * Handles an incoming PUBLISH_NAMESPACE on a bidi stream.
       * Tracks announced broadcasts and notifies consumers.
       *
       * @internal
       */
      async runPublishNamespace(msg, stream) {
        const version2 = this.#session.version;
        const path = msg.trackNamespace;
        if (this.#reflected(msg.cluster)) {
          console.debug(`dropping reflected publish_namespace: broadcast=${path}`);
          await stream.writer.u53(RequestError.id);
          await new RequestError({
            requestId: msg.requestId,
            errorCode: toRequestCode("uninterested", "publish_namespace", version2),
            reasonPhrase: "route loops back"
          }).encode(stream.writer, version2);
          stream.close();
          return;
        }
        const legacy = version2 === Version.DRAFT_14 || version2 === Version.DRAFT_15;
        if (legacy && (this.#announced.has(path) || this.#legacyRequests.has(path))) {
          console.warn("duplicate PublishNamespace");
          const errorCode = toRequestCode("internal", "publish_namespace", version2);
          if (version2 === Version.DRAFT_14) {
            await stream.writer.u53(PublishNamespaceError.id);
            await new PublishNamespaceError({
              requestId: msg.requestId,
              errorCode,
              reasonPhrase: "duplicate namespace"
            }).encode(stream.writer, version2);
          } else {
            await stream.writer.u53(RequestError.id);
            await new RequestError({
              requestId: msg.requestId,
              errorCode,
              reasonPhrase: "duplicate namespace"
            }).encode(stream.writer, version2);
          }
          stream.close();
          return;
        }
        if (legacy)
          this.#legacyRequests.add(path);
        let attached = false;
        try {
          if (version2 === Version.DRAFT_14) {
            await stream.writer.u53(PublishNamespaceOk.id);
            const ok = new PublishNamespaceOk({ requestId: msg.requestId });
            await ok.encode(stream.writer, version2);
          } else {
            await stream.writer.u53(RequestOk.id);
            const ok = new RequestOk({
              requestId: version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? msg.requestId : void 0
            });
            await ok.encode(stream.writer, version2);
          }
          attached = true;
          this.#attachAnnounce(path, this.#route(msg.cluster));
          let held = msg.cluster;
          const done = version2 === Version.DRAFT_16 || legacy;
          for (; ; ) {
            if (await stream.reader.done())
              break;
            const typeId = await stream.reader.u53();
            if (done && typeId === PublishNamespaceDone.id) {
              await PublishNamespaceDone.decode(stream.reader, version2);
              break;
            }
            if (typeId !== PublishNamespaceUpdate.id) {
              throw new ProtocolViolation(`unexpected message on publish_namespace stream: 0x${typeId.toString(16)}`);
            }
            const update = await PublishNamespaceUpdate.decode(stream.reader, version2);
            if (held === void 0) {
              if (update.update.hops !== void 0 || update.update.cost !== void 0) {
                throw new ProtocolViolation("cluster parameters on a session that negotiated none");
              }
            } else {
              held = apply(held, update.update);
            }
            if (this.#reflected(held)) {
              if (attached) {
                attached = false;
                console.debug(`publish_namespace now loops back, detaching: broadcast=${path}`);
                this.#detachAnnounce(path);
              }
            } else if (!attached) {
              attached = true;
              this.#attachAnnounce(path, this.#route(held));
            } else {
              this.#updateAnnounce(path, this.#route(held));
            }
            await stream.writer.u53(RequestOk.id);
            await new RequestOk({}).encode(stream.writer, version2);
          }
        } finally {
          if (legacy)
            this.#legacyRequests.delete(path);
          if (attached) {
            this.#detachAnnounce(path);
          }
        }
      }
      /**
       * Handles an incoming PUBLISH on a bidi stream.
       * We don't support reverse publish, so send error.
       *
       * @internal
       */
      async runPublish(msg, stream) {
        const version2 = this.#session.version;
        const errorCode = toRequestCode("not_supported", "publish", version2);
        if (version2 === Version.DRAFT_14) {
          await stream.writer.u53(PublishError.id);
          const err2 = new PublishError({
            requestId: msg.requestId,
            errorCode,
            reasonPhrase: "publish not supported"
          });
          await err2.encode(stream.writer, version2);
        } else {
          await stream.writer.u53(RequestError.id);
          const err2 = new RequestError({
            requestId: version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16 ? msg.requestId : void 0,
            errorCode,
            reasonPhrase: "publish not supported"
          });
          await err2.encode(stream.writer, version2);
        }
        stream.close();
      }
      /**
       * Handles an ObjectStream message (group + frames on uni stream).
       *
       * @internal
       */
      async handleGroup(group, stream) {
        if (group.subGroupId !== 0) {
          throw new Error("subgroups are not supported");
        }
        let subscription;
        try {
          subscription = await this.#aliases.get(group.trackAlias);
        } catch (err2) {
          const e5 = await sessionCause(this.#quic, err2);
          if (e5 instanceof RetiredTrackAlias) {
            console.debug(`dropping group for a cancelled subscription: alias=${group.trackAlias}`);
          }
          stream.stop(e5);
          return;
        }
        const { track, tail } = subscription;
        const read2 = tail.open(group.groupId);
        let producer;
        const open = () => {
          if (!producer) {
            if (subscription.end !== void 0 && group.groupId >= subscription.end) {
              throw new ProtocolViolation(`group ${group.groupId} is at or past the declared end ${subscription.end}`);
            }
            producer = new Producer2(group.groupId);
            track.writeGroup(producer);
          }
          return producer;
        };
        try {
          const legacy = !hasFirstObjectBit(this.#session.version);
          if (!group.flags.firstObject || legacy) {
            let id;
            try {
              id = await stream.peekU62();
            } catch (err2) {
              if (!(err2 instanceof UnexpectedEnd))
                throw err2;
            }
            if (id !== 0n && !(legacy && id === void 0)) {
              console.debug(`dropping a group with no head: alias=${group.trackAlias} group=${group.groupId}`);
              stream.stop(new Error("a group must start at object 0"));
              return;
            }
          }
          if (!group.flags.hasPriority)
            group.publisherPriority = toWire((await track.info()).priority);
          const decode11 = (c2) => Frame.decode(c2, group.flags, this.#timescales.get(group.trackAlias));
          for (; ; ) {
            const frame = stream.tryDecode(decode11) ?? await (producer ? race([stream.decodeMaybe(decode11), producer.closed]) : stream.decodeMaybe(decode11));
            if (!frame || frame instanceof Error)
              break;
            if (frame.endOfTrack) {
              const end = producer ? group.groupId + 1 : group.groupId;
              producer?.close();
              try {
                track.finishAt(end);
              } catch (err2) {
                throw new ProtocolViolation(`invalid END_OF_TRACK: ${reason(error(err2))}`);
              }
              subscription.end ??= end;
              return;
            }
            if (frame.payload === void 0)
              break;
            open().writeFrame({ payload: frame.payload, timestamp: frame.timestamp ?? Timestamp.now() });
          }
          open().close();
        } catch (err2) {
          const e5 = await sessionCause(this.#quic, err2);
          if (e5 instanceof ProtocolViolation) {
            producer?.close(e5);
            track.close(e5);
          } else {
            try {
              open().close(e5);
            } catch {
            }
          }
          stream.stop(e5);
        } finally {
          read2();
        }
      }
    };
    ConsumeBroadcast = class _ConsumeBroadcast extends Consumer4 {
      constructor(state) {
        super(state);
        overrideBroadcastWire(this, {
          fetchGroup: () => Promise.reject(new Error("fetch group is not supported for moq-transport"))
        });
      }
      // Preserve the subclass when the consume cache shares this broadcast across callers.
      clone() {
        return new _ConsumeBroadcast(this.shareState());
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/track.js
var GROUP_ORDER2, TrackStatusRequest;
var init_track2 = __esm({
  "../../node_modules/@moq/net/ietf/track.js"() {
    init_message();
    init_namespace();
    init_parameters();
    init_subscribe();
    init_version();
    GROUP_ORDER2 = 2;
    TrackStatusRequest = class _TrackStatusRequest {
      static id = 13;
      requestId;
      trackNamespace;
      trackName;
      constructor({ requestId, trackNamespace, trackName }) {
        this.requestId = requestId;
        this.trackNamespace = trackNamespace;
        this.trackName = trackName;
      }
      async #encode(w4, version2) {
        await w4.u62(this.requestId);
        if (version2 === Version.DRAFT_17) {
          await w4.u62(0n);
        }
        await encode5(w4, this.trackNamespace);
        await w4.string(this.trackName);
        if (version2 === Version.DRAFT_14) {
          await w4.u8(0);
          await w4.u8(GROUP_ORDER2);
          await w4.bool(false);
          await w4.u53(2);
          await w4.u53(0);
        } else {
          const params = new Parameters();
          await params.encode(w4, version2);
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      /**
       * Every draft defines TRACK_STATUS as identical to SUBSCRIBE, so it decodes as one and
       * keeps only what names the track. We refuse the request, so the rest goes unread.
       */
      static async decode(r2, version2) {
        const { requestId, trackNamespace, trackName } = await Subscribe.decode(r2, version2);
        return new _TrackStatusRequest({ requestId, trackNamespace, trackName });
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/connection.js
var PADDING, Connection;
var init_connection = __esm({
  "../../node_modules/@moq/net/ietf/connection.js"() {
    init_signals();
    init_stats();
    init_transport();
    init_error2();
    init_stream();
    init_wire();
    init_adapter();
    init_cluster();
    init_fetch();
    init_goaway();
    init_object();
    init_publish();
    init_publish_namespace();
    init_publisher();
    init_subscribe();
    init_subscribe_namespace();
    init_subscriber();
    init_track2();
    init_version();
    PADDING = 0x132b3e28n;
    Connection = class {
      // The URL of the connection.
      url;
      // The negotiated protocol version.
      version;
      // The wire transport this session runs over.
      transport;
      /** Whether the relay supports broadcast discovery; see {@link Established.discovery}. */
      discovery;
      /** moq-transport has no PROBE, so this stays empty; see {@link Established.probe}. */
      probe = new Signal({});
      // The established WebTransport session.
      #quic;
      // Whether this side opened the session. Only a server may name a redirect.
      #client;
      // Session abstraction: adapter for v14-v16, native for v17.
      #session;
      // Module for contributing tracks.
      #publisher;
      // Module for distributing tracks.
      #subscriber;
      // What the peer declared about being solicited; see {@link Ietf.solicitFromSetup}.
      #solicit;
      // The Hop IDs this session declared; see {@link Cluster}.
      #cluster;
      // The peer's GOAWAY: read here on v17+, by the control stream adapter before that.
      #goaway;
      // Just to avoid logging when `close()` is called.
      #closed = false;
      /**
       * Creates a new Connection instance.
       * @param url - The URL of the connection
       * @param quic - The WebTransport session
       * @param control - The control/setup stream
       * @param maxRequestId - The initial max request ID
       * @param version - The negotiated protocol version
       * @param solicit - What the peer's SETUP declared (undefined when it declared nothing)
       * @param cluster - The Hop IDs the SETUP exchange settled, on the versions that negotiate them
       * @param early - Uni streams that arrived before the peer's SETUP
       *
       * @internal
       */
      constructor({ url: url2, quic, control, maxRequestId, version: version2, client, discovery = true, publish: publish5, solicit, hidden = false, cluster, early = [] }) {
        this.url = url2;
        this.discovery = discovery;
        this.version = versionName(version2);
        this.transport = transportOf(quic);
        this.#quic = quic;
        this.#client = client;
        if (version2 >= Version.DRAFT_17) {
          this.#session = new NativeSession(quic, version2, client);
          this.#goaway = new Once();
          void this.#runGoAway(control, version2);
        } else {
          const adapter = new ControlStreamAdapter(quic, control, version2, maxRequestId, client);
          this.#session = adapter;
          this.#goaway = adapter.goaway;
          void adapter.run().catch((err2) => {
            if (!this.#closed)
              console.error("adapter error", err2);
            this.#close();
          });
        }
        this.#publisher = new Publisher({
          quic: this.#quic,
          session: this.#session,
          publish: publish5,
          requiresSolicitation: solicit ?? false,
          hidden,
          cluster
        });
        this.#solicit = solicit;
        this.#cluster = cluster;
        this.#subscriber = new Subscriber2({ session: this.#session, quic, cluster, hidden });
        registerWire(this, { consume: (path) => this.#subscriber.consume(path), goaway: this.#goaway });
        void this.#run(early);
      }
      /** Snapshot the transport's counters; see {@link Established.stats}. */
      async stats() {
        return transportStats(this.#quic);
      }
      /**
       * Closes the connection.
       */
      close() {
        if (this.#closed)
          return;
        this.#subscriber.close();
        this.#close();
      }
      // Close with the session code the peer should see, a clean close by default.
      #close(info) {
        if (this.#closed)
          return;
        this.#closed = true;
        try {
          this.#quic.close(info);
        } catch {
        }
        this.#session.close();
      }
      // The peer broke the protocol, so losing the stream is not enough: nothing stops it
      // repeating the violation on the next one.
      #violated(err2) {
        this.#close({ closeCode: SessionCode.ProtocolViolation, reason: err2.message });
      }
      async #run(early) {
        try {
          await Promise.all([this.#runBidis(), this.#runUnis(early), this.#publisher.runPublishNamespaces()]);
        } catch (err2) {
          if (!this.#closed) {
            console.error("fatal error running connection", err2);
          }
        } finally {
          this.#close();
        }
      }
      /** Gets an announced reader for `scope`; see {@link Established.announced}. */
      announced(scope, options) {
        return this.#subscriber.announced(scope, options);
      }
      /**
       * Accepts bidi streams (virtual for v14-v16, real for v17) and dispatches.
       */
      async #runBidis() {
        for (; ; ) {
          const stream = await this.#session.acceptBi();
          if (!stream)
            break;
          void this.#runBidi(stream).catch((err2) => {
            console.error("error processing bidi stream", err2);
            stream.abort(new Error("bidi stream error"));
            if (err2 instanceof ProtocolViolation)
              this.#violated(err2);
          });
        }
      }
      /**
       * Unified bidi stream dispatch. Reads typeId and routes to handler.
       * Matches the lite module's runBidi pattern.
       */
      async #runBidi(stream) {
        const typeId = await stream.reader.u53();
        switch (typeId) {
          // Draft-18 SUBSCRIBE_NAMESPACE (0x50) and the legacy 0x11 message decode
          // to the same request_id + namespace; the legacy options field is ignored.
          case SubscribeNamespace.id: {
            const msg = await SubscribeNamespace.decode(stream.reader, this.#session.version);
            await this.#publisher.runSubscribeNamespace(msg, stream);
            break;
          }
          case SubscribeNamespaceLegacy.id: {
            const legacy = await SubscribeNamespaceLegacy.decode(stream.reader, this.#session.version);
            const msg = new SubscribeNamespace({
              requestId: legacy.requestId,
              namespace: legacy.namespace,
              hidden: legacy.hidden
            });
            await this.#publisher.runSubscribeNamespace(msg, stream);
            break;
          }
          case SubscribeUpdate.id: {
            stream.abort(new Error("unexpected REQUEST_UPDATE as initial message"));
            break;
          }
          // Publisher handles incoming requests
          case Subscribe.id: {
            const msg = await Subscribe.decode(stream.reader, this.#session.version);
            await this.#publisher.runSubscribe(msg, stream);
            break;
          }
          case SUBSCRIBE_TRACKS_ID: {
            if (this.#session.version < Version.DRAFT_18) {
              throw new ProtocolViolation("SUBSCRIBE_TRACKS before draft-18");
            }
            await this.#publisher.runSubscribeTracks(stream);
            break;
          }
          case TrackStatusRequest.id: {
            const msg = await TrackStatusRequest.decode(stream.reader, this.#session.version);
            await this.#publisher.runTrackStatusRequest(msg, stream);
            break;
          }
          case Fetch.id: {
            const msg = await Fetch.decode(stream.reader, this.#session.version);
            await this.#publisher.runFetch(msg, stream);
            break;
          }
          // Subscriber handles incoming notifications
          case PublishNamespace.id: {
            const msg = await PublishNamespace.decode(stream.reader, this.#session.version, negotiated(this.#cluster));
            const legacy = this.#session.version === Version.DRAFT_14 || this.#session.version === Version.DRAFT_15;
            if (this.#solicit !== void 0 && !legacy) {
              console.error(`unsolicited publish_namespace from a peer that implements MoQ Solicit: broadcast=${msg.trackNamespace}`);
              this.#close();
              break;
            }
            await this.#subscriber.runPublishNamespace(msg, stream);
            break;
          }
          case Publish.id: {
            const msg = await Publish.decode(stream.reader, this.#session.version);
            await this.#subscriber.runPublish(msg, stream);
            break;
          }
          default:
            console.warn(`unexpected bidi stream type: 0x${typeId.toString(16)}`);
            stream.abort(new Error("unexpected stream type"));
        }
      }
      /**
       * Handles unidirectional streams for media delivery (groups).
       */
      async #runUnis(early) {
        for (const stream of early)
          this.#spawnUni(stream);
        const readers = new Readers(this.#quic, this.#session.version);
        for (; ; ) {
          const stream = await readers.next();
          if (!stream)
            break;
          this.#spawnUni(stream);
        }
      }
      #spawnUni(stream) {
        this.#runUni(stream).then(() => {
          stream.stop(new Stream(StreamCode.Cancel, { message: "cancel" }));
        }).catch((err2) => {
          console.error("error processing object stream", err2);
          stream.stop(err2);
          if (err2 instanceof ProtocolViolation)
            this.#violated(err2);
        });
      }
      async #runUni(stream) {
        const version2 = this.#session.version;
        const type = await stream.u62();
        if (type <= 0xffn && (type & 0x90n) === 0x10n) {
          const header2 = await Group.decode(stream, version2, Number(type));
          await this.#subscriber.handleGroup(header2, stream);
          return;
        }
        if (type === PADDING && version2 >= Version.DRAFT_18) {
          await stream.discard();
          return;
        }
        if (type === BigInt(FetchHeader.type))
          throw new Error("unexpected fetch stream");
        throw new ProtocolViolation(`unknown uni stream type: 0x${type.toString(16)}`);
      }
      /**
       * v17+ only: reads GoAway from the setup/control stream.
       *
       * The session keeps serving after a GOAWAY so its groups in flight can finish while the
       * caller migrates; only the stream ending, or a second GOAWAY, closes it here.
       */
      async #runGoAway(controlStream, version2) {
        try {
          for (; ; ) {
            const done = await controlStream.reader.done();
            if (done)
              return;
            const typeId = await controlStream.reader.u53();
            if (typeId !== GoAway.id) {
              console.warn(`unexpected message on setup stream: 0x${typeId.toString(16)}`);
              return;
            }
            const msg = await GoAway.decode(controlStream.reader, version2);
            if (this.#goaway.peek() !== void 0)
              throw new ProtocolViolation("duplicate GOAWAY");
            if (!this.#client && msg.newSessionUri !== "") {
              throw new ProtocolViolation("client GOAWAY must not name a redirect");
            }
            this.#goaway.set(msg.drain());
          }
        } catch (err2) {
          if (!this.#closed) {
            console.error("error reading setup stream", err2);
          }
        } finally {
          this.#close();
        }
      }
      /** Resolves when the session closes, decoding the peer's close code; see {@link Established.closed}. */
      get closed() {
        return this.#quic.closed.then(fromClose, (err2) => error(err2));
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/hidden.js
function hiddenFromSetup(params) {
  return params.getVarint(SetupOption.Hidden) !== void 0;
}
function hiddenIntoSetup(params) {
  params.setVarint(SetupOption.Hidden, 1n);
}
var init_hidden = __esm({
  "../../node_modules/@moq/net/ietf/hidden.js"() {
    init_parameters();
  }
});

// ../../node_modules/@moq/net/ietf/setup.js
var Setup, MAX_VERSIONS, ClientSetup, ServerSetup;
var init_setup = __esm({
  "../../node_modules/@moq/net/ietf/setup.js"() {
    init_message();
    init_parameters();
    init_version();
    Setup = class _Setup {
      static id = 12032;
      parameters;
      constructor({ parameters = new SetupOptions() } = {}) {
        this.parameters = parameters;
      }
      async #encode(w4, version2) {
        await this.parameters.encode(w4, version2);
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async #decode(r2, version2) {
        const parameters = await SetupOptions.decode(r2, version2);
        return new _Setup({ parameters });
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _Setup.#decode(mr, version2));
      }
    };
    MAX_VERSIONS = 128;
    ClientSetup = class _ClientSetup {
      static id = 32;
      versions;
      parameters;
      constructor({ versions, parameters = new SetupOptions() }) {
        this.versions = versions;
        this.parameters = parameters;
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          await this.parameters.encode(w4, version2);
        } else if (version2 === Version.DRAFT_14) {
          await w4.u53(this.versions.length);
          for (const v3 of this.versions) {
            await w4.u53(v3);
          }
          await this.parameters.encode(w4, version2);
        } else {
          throw new Error("ClientSetup not used for this version");
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async #decode(r2, version2) {
        if (version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          const parameters = await SetupOptions.decode(r2, version2);
          return new _ClientSetup({ versions: [version2], parameters });
        } else if (version2 === Version.DRAFT_14) {
          const numVersions = await r2.u53();
          if (numVersions > MAX_VERSIONS) {
            throw new Error(`too many versions: ${numVersions}`);
          }
          const supportedVersions = [];
          for (let i2 = 0; i2 < numVersions; i2++) {
            const v3 = await r2.u53();
            supportedVersions.push(v3);
          }
          const parameters = await SetupOptions.decode(r2, version2);
          return new _ClientSetup({ versions: supportedVersions, parameters });
        } else {
          throw new Error("ClientSetup not used for this version");
        }
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _ClientSetup.#decode(mr, version2));
      }
    };
    ServerSetup = class _ServerSetup {
      static id = 33;
      version;
      parameters;
      constructor({ version: version2, parameters = new SetupOptions() }) {
        this.version = version2;
        this.parameters = parameters;
      }
      async #encode(w4, version2) {
        if (version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          await this.parameters.encode(w4, version2);
        } else if (version2 === Version.DRAFT_14) {
          await w4.u53(this.version);
          await this.parameters.encode(w4, version2);
        } else {
          throw new Error("ServerSetup not used for this version");
        }
      }
      async encode(w4, version2) {
        return encode4(w4, (mw) => this.#encode(mw, version2));
      }
      static async #decode(r2, version2) {
        if (version2 === Version.DRAFT_15 || version2 === Version.DRAFT_16) {
          const parameters = await SetupOptions.decode(r2, version2);
          return new _ServerSetup({ version: version2, parameters });
        } else if (version2 === Version.DRAFT_14) {
          const selectedVersion = await r2.u53();
          const parameters = await SetupOptions.decode(r2, version2);
          return new _ServerSetup({ version: selectedVersion, parameters });
        } else {
          throw new Error("ServerSetup not used for this version");
        }
      }
      static async decode(r2, version2) {
        return decode4(r2, (mr) => _ServerSetup.#decode(mr, version2));
      }
    };
  }
});

// ../../node_modules/@moq/net/ietf/solicit.js
function solicitFromSetup(params) {
  const value = params.getVarint(SetupOption.Solicit);
  return value === void 0 ? void 0 : value !== 0n;
}
function solicitIntoSetup(params) {
  params.setVarint(SetupOption.Solicit, 1n);
}
var init_solicit = __esm({
  "../../node_modules/@moq/net/ietf/solicit.js"() {
    init_parameters();
  }
});

// ../../node_modules/@moq/net/ietf/token.js
var init_token = __esm({
  "../../node_modules/@moq/net/ietf/token.js"() {
  }
});

// ../../node_modules/@moq/net/ietf/index.js
var init_ietf = __esm({
  "../../node_modules/@moq/net/ietf/index.js"() {
    init_adapter();
    init_cluster();
    init_connection();
    init_fetch();
    init_goaway();
    init_hidden();
    init_object();
    init_parameters();
    init_publish();
    init_publish_namespace();
    init_publisher();
    init_request();
    init_setup();
    init_solicit();
    init_subscribe();
    init_subscribe_namespace();
    init_subscriber();
    init_token();
    init_track2();
    init_version();
  }
});

// ../../node_modules/@moq/net/lite/message.js
async function encode9(writer, f3, max = MAX_SIZE) {
  let scratch = new Uint8Array();
  const temp = new Writer(new WritableStream({
    write(chunk) {
      const needed = scratch.byteLength + chunk.byteLength;
      if (needed > scratch.buffer.byteLength) {
        const capacity = Math.max(needed, scratch.buffer.byteLength * 2);
        const newBuffer = new ArrayBuffer(capacity);
        const newScratch = new Uint8Array(newBuffer, 0, needed);
        newScratch.set(scratch);
        newScratch.set(chunk, scratch.byteLength);
        scratch = newScratch;
      } else {
        scratch = new Uint8Array(scratch.buffer, 0, needed);
        scratch.set(chunk, needed - chunk.byteLength);
      }
    }
  }), writer.version);
  await f3(temp);
  temp.close();
  await temp.closed;
  if (scratch.byteLength > max) {
    throw new Error(`message too large: ${scratch.byteLength} bytes (max ${max})`);
  }
  await writer.u53(scratch.byteLength);
  if (scratch.byteLength > 0) {
    await writer.write(scratch);
  }
}
async function decode9(reader, f3, max = MAX_SIZE) {
  const size2 = await reader.u53();
  if (size2 > max) {
    throw new Error(`message too large: ${size2} bytes (max ${max})`);
  }
  const data = await reader.read(size2);
  const limit = new Reader(void 0, data, reader.version);
  const msg = await f3(limit);
  if (!await limit.done()) {
    throw new Error("Message decoding consumed too few bytes");
  }
  return msg;
}
async function decodeMaybe(reader, f3) {
  if (await reader.done())
    return;
  return await decode9(reader, f3);
}
var MAX_SIZE;
var init_message2 = __esm({
  "../../node_modules/@moq/net/lite/message.js"() {
    init_stream();
    MAX_SIZE = 64 * 1024 * 1024;
  }
});

// ../../node_modules/@moq/net/lite/announce.js
function checkHops(hops) {
  if (hops.length > MAX_HOPS) {
    throw new ProtocolViolation(`hop count ${hops.length} exceeds maximum ${MAX_HOPS}`);
  }
  for (let i2 = 0; i2 < hops.length; i2++) {
    const hop = hops[i2];
    if (hop === UNKNOWN_HOP)
      continue;
    if (hops.indexOf(hop, i2 + 1) !== -1) {
      throw new ProtocolViolation(`hop ${hop} appears twice in the chain`);
    }
  }
}
async function encodeHops2(w4, version2, hops) {
  checkHops(hops);
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
      break;
    case Version2.DRAFT_03:
      await w4.u53(hops.length);
      break;
    default:
      await w4.u53(hops.length);
      for (const origin of hops) {
        await w4.u62(origin);
      }
      break;
  }
}
async function decodeHops2(r2, version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
      return [];
    case Version2.DRAFT_03: {
      const count2 = await r2.u53();
      if (count2 > MAX_HOPS)
        throw new Error(`hop count ${count2} exceeds maximum ${MAX_HOPS}`);
      return new Array(count2).fill(UNKNOWN_HOP);
    }
    default: {
      const count2 = await r2.u53();
      if (count2 > MAX_HOPS)
        throw new Error(`hop count ${count2} exceeds maximum ${MAX_HOPS}`);
      const hops = [];
      for (let i2 = 0; i2 < count2; i2++) {
        hops.push(HopSchema.parse(await r2.u62()));
      }
      checkHops(hops);
      return hops;
    }
  }
}
function checkBase(version2, base2) {
  if (base2 && !hasAnnounceCompression(version2)) {
    throw new Error("announce compression not supported for this version");
  }
}
function toBase(distance, keep) {
  if (distance !== 0n)
    return { distance, keep };
  if (keep !== 0)
    throw new ProtocolViolation("announce keep without a base");
  return void 0;
}
async function encodePath(w4, version2, suffix, base2) {
  checkBase(version2, base2);
  if (hasAnnounceCompression(version2)) {
    await w4.u62(base2?.distance ?? 0n);
    await w4.u53(base2?.keep ?? 0);
  }
  await w4.string(encode2(suffix));
}
async function decodePath(r2, version2) {
  if (!hasAnnounceCompression(version2))
    return { suffix: decode2(await r2.string()) };
  const pathBase = toBase(await r2.u62(), await r2.u53());
  const suffix = decode2(await r2.string());
  return pathBase ? { suffix, pathBase } : { suffix };
}
async function encodeHopsBlock(w4, version2, hops, base2) {
  checkBase(version2, base2);
  if (!hasAnnounceCompression(version2))
    return encodeHops2(w4, version2, hops);
  await w4.u62(base2?.distance ?? 0n);
  await encodeHops2(w4, version2, hops);
  await w4.u53(base2?.keep ?? 0);
}
async function decodeHopsBlock(r2, version2) {
  if (!hasAnnounceCompression(version2))
    return { hops: await decodeHops2(r2, version2) };
  const distance = await r2.u62();
  const hops = await decodeHops2(r2, version2);
  const hopBase = toBase(distance, await r2.u53());
  return hopBase ? { hops, hopBase } : { hops };
}
async function encodeRouteCost(w4, version2, cost) {
  if (!hasRouteCost(version2))
    return;
  await w4.u62(saturate(cost?.warm ?? 0n));
  await w4.u62(saturate(cost?.cold ?? 0n));
}
async function decodeRouteCost(r2, version2) {
  if (!hasRouteCost(version2))
    return void 0;
  return { warm: saturate(await r2.u62()), cold: saturate(await r2.u62()) };
}
async function encodeAnnounce06Body(w4, msg, version2) {
  switch (msg.status) {
    case "active":
      await encodePath(w4, version2, msg.suffix, msg.pathBase);
      await encodeHopsBlock(w4, version2, msg.hops, msg.hopBase);
      await encodeRouteCost(w4, version2, msg.cost);
      break;
    case "endedId":
      await w4.u62(msg.id);
      break;
    case "restart":
      await w4.u62(msg.id);
      await encodeHopsBlock(w4, version2, msg.hops, msg.hopBase);
      await encodeRouteCost(w4, version2, msg.cost);
      break;
    case "ended":
      throw new Error("ended-by-path not supported for this version");
    case "skipped":
      throw new Error("decode-only announce type cannot be encoded");
  }
}
function announce06Type(msg) {
  switch (msg.status) {
    case "active":
      return ANNOUNCE_START;
    case "endedId":
      return ANNOUNCE_END;
    case "restart":
      return ANNOUNCE_RESTART;
    case "ended":
      throw new Error("ended-by-path not supported for this version");
    case "skipped":
      throw new Error("decode-only announce type cannot be encoded");
  }
}
async function decodeAnnounce06Body(r2, typ, version2) {
  switch (typ) {
    case ANNOUNCE_START: {
      const path = await decodePath(r2, version2);
      const hops = await decodeHopsBlock(r2, version2);
      return { status: "active", ...path, ...hops, cost: await decodeRouteCost(r2, version2) };
    }
    case ANNOUNCE_END:
      return { status: "endedId", id: await r2.u62() };
    case ANNOUNCE_RESTART: {
      const id = await r2.u62();
      const hops = await decodeHopsBlock(r2, version2);
      return { status: "restart", id, ...hops, cost: await decodeRouteCost(r2, version2) };
    }
    default:
      await r2.readAll();
      return { status: "skipped" };
  }
}
async function encodeLegacyBody(w4, msg, version2) {
  switch (msg.status) {
    case "active":
      checkBase(version2, msg.pathBase ?? msg.hopBase);
      await w4.u8(STATUS_ACTIVE);
      await w4.string(encode2(msg.suffix));
      await encodeHops2(w4, version2, msg.hops);
      break;
    case "ended":
      await w4.u8(STATUS_ENDED);
      await w4.string(encode2(msg.suffix));
      await encodeHops2(w4, version2, []);
      break;
    case "endedId":
    case "restart":
    case "skipped":
      throw new Error("announce ids not supported for this version");
  }
}
async function decodeLegacyBody(r2, version2) {
  const status = await r2.u8();
  const active = status === STATUS_ACTIVE || status === STATUS_RESTART && hasAnnounceOk(version2);
  if (status !== STATUS_ENDED && !active) {
    throw new Error("invalid announce status");
  }
  const suffix = decode2(await r2.string());
  const hops = await decodeHops2(r2, version2);
  return active ? { status: "active", suffix, hops } : { status: "ended", suffix };
}
async function encodeAnnounceBroadcast(w4, msg, version2) {
  if (hasAnnounceId(version2)) {
    await w4.u53(announce06Type(msg));
    return encode9(w4, (w5) => encodeAnnounce06Body(w5, msg, version2));
  }
  return encode9(w4, (w5) => encodeLegacyBody(w5, msg, version2));
}
async function decodeAnnounceBroadcastMaybe(r2, version2) {
  if (hasAnnounceId(version2)) {
    if (await r2.done())
      return void 0;
    const typ = await r2.u53();
    return decode9(r2, (r3) => decodeAnnounce06Body(r3, typ, version2));
  }
  return decodeMaybe(r2, (r3) => decodeLegacyBody(r3, version2));
}
var STATUS_ENDED, STATUS_ACTIVE, STATUS_RESTART, ANNOUNCE_START, ANNOUNCE_END, ANNOUNCE_RESTART, MAX_COST, saturate, AnnounceHistory, AnnounceRequest, AnnounceInit, AnnounceOk;
var init_announce2 = __esm({
  "../../node_modules/@moq/net/lite/announce.js"() {
    init_error2();
    init_hop();
    init_path();
    init_message2();
    init_version2();
    STATUS_ENDED = 0;
    STATUS_ACTIVE = 1;
    STATUS_RESTART = 2;
    ANNOUNCE_START = 0;
    ANNOUNCE_END = 1;
    ANNOUNCE_RESTART = 2;
    MAX_COST = 2n ** 62n - 1n;
    saturate = (v3) => v3 > MAX_COST ? MAX_COST : v3;
    AnnounceHistory = class {
      #next = 0n;
      #live = /* @__PURE__ */ new Map();
      #base(base2) {
        const live = this.#live.get(this.#next - base2.distance);
        if (!live)
          throw new ProtocolViolation(`announce base ${base2.distance} is not live`);
        return live;
      }
      #hops(hops, base2) {
        if (!base2)
          return hops;
        const tail = this.#base(base2).hops;
        if (base2.keep > tail.length)
          throw new ProtocolViolation(`announce keeps ${base2.keep} of ${tail.length} hops`);
        const resolved = [...hops, ...tail.slice(tail.length - base2.keep)];
        checkHops(resolved);
        return resolved;
      }
      /** An ANNOUNCE_START: resolve it and assign it the next id. */
      start(msg) {
        let suffix = msg.suffix;
        if (msg.pathBase) {
          const head = parts(this.#base(msg.pathBase).suffix);
          const keep = msg.pathBase.keep;
          if (keep > head.length)
            throw new ProtocolViolation(`announce keeps ${keep} of ${head.length} segments`);
          suffix = join(from(...head.slice(0, keep)), suffix);
          if (parts(suffix).length > MAX_PARTS) {
            throw new ProtocolViolation(`path exceeds ${MAX_PARTS} parts`);
          }
        }
        const hops = this.#hops(msg.hops, msg.hopBase);
        this.#live.set(this.#next++, { suffix, hops });
        return { suffix, hops };
      }
      /** An ANNOUNCE_UPDATE: resolve its chain before replacing the old one, which it may be based on. */
      update(msg) {
        const hops = this.#hops(msg.hops, msg.hopBase);
        const live = this.#live.get(msg.id);
        if (!live)
          throw new ProtocolViolation(`unknown announce id: ${msg.id}`);
        this.#live.set(msg.id, { suffix: live.suffix, hops });
        return { suffix: live.suffix, hops };
      }
      /** An ANNOUNCE_END: retire the id, returning its suffix. */
      end(id) {
        const live = this.#live.get(id);
        if (!live)
          throw new ProtocolViolation(`unknown announce id: ${id}`);
        this.#live.delete(id);
        return live.suffix;
      }
    };
    AnnounceRequest = class _AnnounceRequest {
      prefix;
      /** Lite04/05 only: the 62-bit Hop id of the peer asking for announces, which the
       * publisher uses to skip announces that already passed through it. Zero means "no
       * exclusion". Not on the wire elsewhere, so a value set here is ignored when encoding
       * for another version and decodes as zero.
       *
       * Must be a bigint: peer origins are up to 62 bits and overflow u53. */
      excludeHop;
      /** Lite07+: also announce routes with a `.`-prefixed segment below the prefix. Not on
       * the wire earlier, so a value set here is ignored when encoding for an older version
       * and decodes as false. */
      hidden;
      constructor(prefix, excludeHop = 0n, hidden = false) {
        this.prefix = prefix;
        this.excludeHop = excludeHop;
        this.hidden = hidden;
      }
      async #encode(w4, version2) {
        await w4.string(encode2(this.prefix));
        if (hasExcludeHop(version2)) {
          await w4.u62(this.excludeHop);
        }
        if (hasHidden(version2)) {
          await w4.bool(this.hidden);
        }
      }
      static async #decode(r2, version2) {
        const prefix = decode2(await r2.string());
        const excludeHop = hasExcludeHop(version2) ? await r2.u62() : 0n;
        const hidden = hasHidden(version2) ? await r2.bool() : false;
        return new _AnnounceRequest(prefix, excludeHop, hidden);
      }
      async encode(w4, version2) {
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        return decode9(r2, (r3) => _AnnounceRequest.#decode(r3, version2));
      }
    };
    AnnounceInit = class _AnnounceInit {
      suffixes;
      constructor(paths) {
        this.suffixes = paths;
      }
      static #guard(version2) {
        switch (version2) {
          case Version2.DRAFT_01:
          case Version2.DRAFT_02:
            break;
          default:
            throw new Error("announce init not supported for this version");
        }
      }
      async #encode(w4) {
        await w4.u53(this.suffixes.length);
        for (const path of this.suffixes) {
          await w4.string(encode2(path));
        }
      }
      static async #decode(r2) {
        const count2 = await r2.u53();
        const suffixes = [];
        for (let i2 = 0; i2 < count2; i2++) {
          suffixes.push(decode2(await r2.string()));
        }
        return new _AnnounceInit(suffixes);
      }
      async encode(w4, version2) {
        _AnnounceInit.#guard(version2);
        return encode9(w4, this.#encode.bind(this));
      }
      static async decode(r2, version2) {
        _AnnounceInit.#guard(version2);
        return decode9(r2, _AnnounceInit.#decode);
      }
    };
    AnnounceOk = class _AnnounceOk {
      hop;
      active;
      constructor(hop, active) {
        this.hop = hop;
        this.active = active;
      }
      static #guard(version2) {
        if (!hasAnnounceOk(version2)) {
          throw new Error("announce ok not supported for this version");
        }
      }
      async #encode(w4) {
        await w4.u62(this.hop);
        await w4.u53(this.active);
      }
      static async #decode(r2) {
        const origin = HopSchema.parse(await r2.u62());
        const active = await r2.u53();
        return new _AnnounceOk(origin, active);
      }
      async encode(w4, version2) {
        _AnnounceOk.#guard(version2);
        return encode9(w4, this.#encode.bind(this));
      }
      static async decode(r2, version2) {
        _AnnounceOk.#guard(version2);
        return decode9(r2, _AnnounceOk.#decode);
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/fetch.js
function guardFetch(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
      throw new Error("fetch not supported for this version");
    default:
      break;
  }
}
var Fetch2;
var init_fetch2 = __esm({
  "../../node_modules/@moq/net/lite/fetch.js"() {
    init_path();
    init_message2();
    init_version2();
    Fetch2 = class _Fetch {
      broadcast;
      track;
      priority;
      group;
      /** Index of the first frame to return; 0 is the start of the group. Lite-06+. */
      startFrame;
      /**
       * Index of the last frame to return (inclusive), or undefined for through the end
       * of the group. Lite-06+.
       */
      endFrame;
      constructor({ broadcast: broadcast2, track, priority, group, startFrame = 0, endFrame }) {
        this.broadcast = broadcast2;
        this.track = track;
        this.priority = priority;
        this.group = group;
        this.startFrame = startFrame;
        this.endFrame = endFrame;
      }
      async #encode(w4, version2) {
        await w4.string(encode2(this.broadcast));
        await w4.string(this.track);
        await w4.u8(this.priority);
        await w4.u53(this.group);
        if (hasFrameBounds(version2)) {
          await w4.u53(this.startFrame);
          await w4.u53(this.endFrame !== void 0 ? this.endFrame + 1 : 0);
        } else if (this.startFrame !== 0 || this.endFrame !== void 0) {
          throw new Error("frame bounds not supported for this version");
        }
      }
      static async #decode(r2, version2) {
        const broadcast2 = decode2(await r2.string());
        const track = await r2.string();
        const priority = await r2.u8();
        const group = await r2.u53();
        if (!hasFrameBounds(version2)) {
          return new _Fetch({ broadcast: broadcast2, track, priority, group });
        }
        const startFrame = await r2.u53();
        const endFrame = await r2.u53();
        if (endFrame > 0 && endFrame - 1 < startFrame) {
          throw new Error("fetch frame range ends before it starts");
        }
        return new _Fetch({
          broadcast: broadcast2,
          track,
          priority,
          group,
          startFrame,
          endFrame: endFrame > 0 ? endFrame - 1 : void 0
        });
      }
      async encode(w4, version2) {
        guardFetch(version2);
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        guardFetch(version2);
        return decode9(r2, (r3) => _Fetch.#decode(r3, version2));
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/goaway.js
function guardGoaway(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
      throw new Error("goaway not supported for this version");
    default:
      break;
  }
}
var Goaway;
var init_goaway2 = __esm({
  "../../node_modules/@moq/net/lite/goaway.js"() {
    init_message2();
    init_version2();
    Goaway = class _Goaway {
      uri;
      constructor(uri) {
        this.uri = uri;
      }
      async #encode(w4) {
        await w4.string(this.uri);
      }
      static async #decode(r2) {
        const uri = await r2.string();
        if (new TextEncoder().encode(uri).byteLength > 8192) {
          throw new Error("GOAWAY URI exceeds 8,192 bytes");
        }
        return new _Goaway(uri);
      }
      async encode(w4, version2) {
        guardGoaway(version2);
        return encode9(w4, this.#encode.bind(this));
      }
      static async decode(r2, version2) {
        guardGoaway(version2);
        return decode9(r2, _Goaway.#decode);
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/group.js
function unzigzag(v3) {
  return v3 >> 1n ^ -(v3 & 1n);
}
function frameDecoder(scale) {
  if (scale === 0) {
    return (c2) => ({ payload: c2.read(c2.u53()), timestamp: Timestamp.now() });
  }
  const timescale = Timescale(scale);
  let prevTs = 0n;
  return (c2) => {
    const delta = unzigzag(c2.u62());
    const payload = c2.read(c2.u53());
    prevTs += delta;
    return { payload, timestamp: new Timestamp(Number(prevTs), timescale) };
  };
}
async function readFrames(stream, producer, scale) {
  const decode11 = frameDecoder(scale);
  for (; ; ) {
    const frame = stream.tryDecode(decode11) ?? await race([stream.decodeMaybe(decode11), producer.closed]);
    if (!frame || frame instanceof Error)
      return;
    producer.writeFrame(frame);
  }
}
var Group2;
var init_group2 = __esm({
  "../../node_modules/@moq/net/lite/group.js"() {
    init_signals();
    init_time();
    init_message2();
    init_version2();
    Group2 = class _Group {
      subscribe;
      sequence;
      /**
       * The index of the first frame on this stream within the group.
       *
       * 0 (the common case) means the stream carries the group from its beginning. A
       * higher value means the leading frames are not here, either because the
       * subscription started partway into the group or because the publisher only holds
       * the tail. Lite-06+; older versions always start at 0.
       */
      frameStart;
      constructor({ subscribe: subscribe5, sequence, frameStart = 0 }) {
        this.subscribe = subscribe5;
        this.sequence = sequence;
        this.frameStart = frameStart;
      }
      async #encode(w4, version2) {
        await w4.u62(this.subscribe);
        await w4.u53(this.sequence);
        if (hasFrameBounds(version2)) {
          await w4.u53(this.frameStart);
        } else if (this.frameStart !== 0) {
          throw new Error("frame offsets not supported for this version");
        }
      }
      static async #decode(r2, version2) {
        const subscribe5 = await r2.u62();
        const sequence = await r2.u53();
        const frameStart = hasFrameBounds(version2) ? await r2.u53() : 0;
        return new _Group({ subscribe: subscribe5, sequence, frameStart });
      }
      async encode(w4, version2) {
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        return decode9(r2, (r3) => _Group.#decode(r3, version2));
      }
      static async decodeMaybe(r2, version2) {
        return decodeMaybe(r2, (r3) => _Group.#decode(r3, version2));
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/datagram.js
var Datagram;
var init_datagram = __esm({
  "../../node_modules/@moq/net/lite/datagram.js"() {
    init_stream();
    Datagram = class _Datagram {
      /** Subscribe ID this datagram is delivered on. */
      subscribe;
      /** Group sequence number (shared with the track's group namespace). */
      sequence;
      /** Absolute presentation timestamp, in the track's negotiated timescale. */
      timestamp;
      /** The frame payload, delimited by the datagram boundary. */
      payload;
      constructor(subscribe5, sequence, timestamp, payload) {
        this.subscribe = subscribe5;
        this.sequence = sequence;
        this.timestamp = timestamp;
        this.payload = payload;
      }
      /** Encode the body to a single `Uint8Array` (no length prefix; the datagram boundary delimits it). */
      encode(version2) {
        const subscribe5 = encodeVarint(this.subscribe, version2);
        const sequence = encodeVarint(this.sequence, version2);
        const timestamp = encodeVarint(this.timestamp, version2);
        const out = new Uint8Array(subscribe5.byteLength + sequence.byteLength + timestamp.byteLength + this.payload.byteLength);
        let offset = 0;
        out.set(subscribe5, offset);
        offset += subscribe5.byteLength;
        out.set(sequence, offset);
        offset += sequence.byteLength;
        out.set(timestamp, offset);
        offset += timestamp.byteLength;
        out.set(this.payload, offset);
        return out;
      }
      /** Decode a datagram body from the raw bytes of one QUIC datagram. */
      static async decode(data, version2) {
        const r2 = new Reader(void 0, data, version2);
        const subscribe5 = await r2.u62();
        const sequence = await r2.u53();
        const timestamp = await r2.u53();
        const payload = await r2.readAll();
        return new _Datagram(subscribe5, sequence, timestamp, payload);
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/datagram_stream.js
function datagrams(quic) {
  return quic.datagrams;
}
function maxDatagramSize(quic) {
  const size2 = datagrams(quic)?.maxDatagramSize;
  return typeof size2 === "number" && size2 > 0 ? size2 : 0;
}
function datagramReader(quic) {
  const readable = datagrams(quic)?.readable;
  if (!readable) {
    console.warn("datagram receive disabled: WebTransport datagrams.readable is unavailable");
    return void 0;
  }
  try {
    return readable.getReader();
  } catch (err2) {
    console.warn("datagram receive disabled: failed to open WebTransport datagram reader", err2);
    return void 0;
  }
}
function datagramWriter(quic) {
  const stream = datagrams(quic);
  if (!stream || maxDatagramSize(quic) === 0)
    return void 0;
  try {
    const writable = typeof stream.createWritable === "function" ? stream.createWritable() : stream.writable;
    if (!writable) {
      console.warn("datagram send disabled: WebTransport datagram writable stream is unavailable");
      return void 0;
    }
    return writable.getWriter();
  } catch (err2) {
    console.warn("datagram send disabled: failed to open WebTransport datagram writer", err2);
    return void 0;
  }
}
var init_datagram_stream = __esm({
  "../../node_modules/@moq/net/lite/datagram_stream.js"() {
  }
});

// ../../node_modules/@moq/net/lite/priority.js
function sendOrder({ priority, position = 0 }) {
  return -((MAX_PRIORITY - clamp(priority, MAX_PRIORITY)) * GROUP_SPAN + clamp(position, GROUP_SPAN - 1) + 1);
}
function clamp(value, max) {
  return Math.min(Math.max(Math.trunc(value), 0), max);
}
var GROUP_SPAN, MAX_PRIORITY, Priority;
var init_priority2 = __esm({
  "../../node_modules/@moq/net/lite/priority.js"() {
    GROUP_SPAN = 2 ** 44;
    MAX_PRIORITY = 255;
    Priority = class {
      #track;
      #streams = /* @__PURE__ */ new Map();
      #dispose;
      #closed = false;
      /** Follow `track`'s subscription until {@link close}. */
      constructor(track) {
        this.#track = track;
        this.#dispose = track.subscription.subscribe(() => this.#rerank());
      }
      /** The send order for a group at `sequence`, whether or not it has a stream yet. */
      rank(sequence) {
        return sendOrder({
          priority: this.#track.subscription.peek()?.priority ?? 0,
          position: this.#position(sequence)
        });
      }
      /** Rank a group's stream now, and again whenever the ranking changes, until {@link remove}. */
      add(stream, sequence) {
        this.#streams.set(stream, sequence);
        this.#rerank();
      }
      /** Stop ranking a finished group's stream, promoting whatever was queued behind it. */
      remove(stream) {
        if (!this.#streams.delete(stream))
          return;
        if (this.#closed && this.#streams.size === 0) {
          this.#dispose();
        } else {
          this.#rerank();
        }
      }
      /**
       * Stop taking new groups, and release the subscription listener once the last one leaves.
       *
       * The track can finish while several groups are still draining, and those are the ones the
       * subscriber is still waiting on. They keep being promoted as the groups ahead of them
       * finish, rather than being stranded at whatever position they held when the track ended.
       */
      close() {
        this.#closed = true;
        if (this.#streams.size === 0)
          this.#dispose();
      }
      // How many of this subscription's groups in flight should be sent before `sequence`.
      // Sequences are unique within a subscription, so a group already registered never counts
      // itself.
      #position(sequence) {
        let ahead = 0;
        for (const other of this.#streams.values()) {
          if (other > sequence)
            ahead++;
        }
        return ahead;
      }
      #rerank() {
        const priority = this.#track.subscription.peek()?.priority ?? 0;
        for (const [stream, sequence] of this.#streams) {
          stream.setPriority(sendOrder({ priority, position: this.#position(sequence) }));
        }
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/probe.js
function guardProbe(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
      throw new Error("probe not supported for this version");
    default:
      break;
  }
}
var Probe;
var init_probe = __esm({
  "../../node_modules/@moq/net/lite/probe.js"() {
    init_message2();
    init_version2();
    Probe = class _Probe {
      /** Estimated send bitrate in bits per second, or undefined if unknown. */
      bitrate;
      /** Smoothed round-trip time in milliseconds, or undefined if unknown. */
      rtt;
      // Named rather than positional: the two fields share a type, so positional
      // arguments could be swapped without a type error.
      constructor({ bitrate, rtt } = {}) {
        this.bitrate = bitrate;
        this.rtt = rtt;
      }
      async #encode(w4, version2) {
        await w4.u53(this.bitrate !== void 0 ? Math.max(this.bitrate, 1) : 0);
        if (hasProbeRtt(version2)) {
          await w4.u53(this.rtt !== void 0 ? Math.max(this.rtt, 1) : 0);
        }
      }
      static async #decode(r2, version2) {
        const bitrateWire = await r2.u53();
        const bitrate = bitrateWire === 0 ? void 0 : bitrateWire;
        let rtt;
        if (hasProbeRtt(version2)) {
          const wire = await r2.u53();
          rtt = wire === 0 ? void 0 : wire;
        }
        return new _Probe({ bitrate, rtt });
      }
      async encode(w4, version2) {
        guardProbe(version2);
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        guardProbe(version2);
        return decode9(r2, (r3) => _Probe.#decode(r3, version2));
      }
      static async decodeMaybe(r2, version2) {
        guardProbe(version2);
        return decodeMaybe(r2, (r3) => _Probe.#decode(r3, version2));
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/subscribe.js
async function encodeStartGroup(w4, version2, startGroup) {
  if (resolvesStart(version2)) {
    await w4.u53(startGroup ?? 0);
    return;
  }
  await w4.u53(startGroup === void 0 ? 0 : startGroup + 1);
}
async function decodeStartGroup(r2, version2) {
  const value = await r2.u53();
  if (resolvesStart(version2))
    return value;
  return value > 0 ? value - 1 : void 0;
}
function canonicalStartGroup(version2, startGroup, startFrame) {
  if (resolvesStart(version2) && startGroup === 0 && startFrame === 0)
    return void 0;
  return startGroup;
}
async function encodeFrameBounds(w4, version2, { startGroup, startFrame, endGroup, endFrame }) {
  if (startFrame !== 0 && startGroup === void 0 || endFrame !== void 0 && endGroup === void 0) {
    throw new Error("frame bound without a group bound");
  }
  if (!hasFrameBounds(version2)) {
    if (startFrame !== 0 || endFrame !== void 0) {
      throw new Error("frame bounds not supported for this version");
    }
    return;
  }
  await w4.u53(startFrame);
  await w4.u53(endFrame !== void 0 ? endFrame + 1 : 0);
}
async function decodeFrameBounds(r2, version2, startGroup, endGroup) {
  if (!hasFrameBounds(version2)) {
    return { startFrame: 0 };
  }
  const startFrame = await r2.u53();
  const endFrame = await r2.u53();
  if (startFrame !== 0 && startGroup === void 0 || endFrame !== 0 && endGroup === void 0) {
    throw new Error("frame bound without a group bound");
  }
  return { startFrame, endFrame: endFrame > 0 ? endFrame - 1 : void 0 };
}
async function skipGroupOrder(r2, version2) {
  if (hasGroupOrder(version2))
    await r2.bool();
}
async function padGroupOrder(w4, version2) {
  if (hasGroupOrder(version2))
    await w4.bool(false);
}
function exclusiveGroupEnd(inclusive) {
  return inclusive === void 0 ? void 0 : inclusive + 1;
}
function inclusiveGroupEnd(exclusive) {
  if (exclusive === void 0)
    return void 0;
  if (exclusive === 0)
    throw new Error(EMPTY_RANGE);
  return exclusive - 1;
}
function emptyRange({ startGroup, endGroup }) {
  return endGroup !== void 0 && (startGroup ?? 0) >= endGroup;
}
async function encodeSubscribeResponse(w4, resp, version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
      if ("ok" in resp) {
        await resp.ok.encode(w4, version2);
      } else {
        throw new Error("only SUBSCRIBE_OK is supported for this version");
      }
      break;
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      if ("ok" in resp) {
        await w4.u53(0);
        await resp.ok.encode(w4, version2);
      } else if ("drop" in resp) {
        await w4.u53(1);
        await resp.drop.encode(w4);
      } else {
        throw new Error("SUBSCRIBE_START/END not supported for this version");
      }
      break;
    default:
      if ("start" in resp) {
        await w4.u53(0);
        await resp.start.encode(w4);
      } else if ("end" in resp) {
        await w4.u53(1);
        await resp.end.encode(w4, version2);
      } else if ("drop" in resp && !hasStreamCount(version2)) {
        await w4.u53(2);
        await resp.drop.encode(w4);
      } else {
        throw new Error("subscribe response not supported for this version");
      }
      break;
  }
}
async function decodeSubscribeResponse(r2, version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
      return { ok: await SubscribeOk2.decode(r2, version2) };
    case Version2.DRAFT_03:
    case Version2.DRAFT_04: {
      const typ = await r2.u53();
      switch (typ) {
        case 0:
          return { ok: await SubscribeOk2.decode(r2, version2) };
        case 1:
          return { drop: await SubscribeDrop.decode(r2) };
        default:
          throw new Error(`unknown subscribe response type: ${typ}`);
      }
    }
    default: {
      const typ = await r2.u53();
      switch (typ) {
        case 0:
          return { start: await SubscribeStart.decode(r2) };
        case 1:
          return { end: await SubscribeEnd.decode(r2, version2) };
        case 2:
          if (hasStreamCount(version2))
            throw new Error(`unknown subscribe response type: ${typ}`);
          return { drop: await SubscribeDrop.decode(r2) };
        default:
          throw new Error(`unknown subscribe response type: ${typ}`);
      }
    }
  }
}
async function decodeSubscribeResponseMaybe(r2, version2) {
  if (await r2.done())
    return void 0;
  return decodeSubscribeResponse(r2, version2);
}
var EMPTY_RANGE, SubscribeUpdate2, Subscribe2, SubscribeOk2, SubscribeStart, SubscribeEnd, SubscribeDrop;
var init_subscribe2 = __esm({
  "../../node_modules/@moq/net/lite/subscribe.js"() {
    init_path();
    init_message2();
    init_version2();
    EMPTY_RANGE = "empty subscription range cannot be encoded";
    SubscribeUpdate2 = class _SubscribeUpdate {
      priority;
      /** Subscriber max latency in milliseconds; zero skips once a newer group is available. */
      maxAge;
      startGroup;
      endGroup;
      /** See {@link Subscribe.startFrame}. */
      startFrame;
      /** See {@link Subscribe.endFrame}. */
      endFrame;
      constructor(props) {
        this.priority = props.priority;
        this.maxAge = props.maxAge ?? 0;
        this.startGroup = props.startGroup;
        this.endGroup = props.endGroup;
        this.startFrame = props.startFrame ?? 0;
        this.endFrame = props.endFrame;
      }
      async #encode(w4, version2) {
        switch (version2) {
          case Version2.DRAFT_01:
          case Version2.DRAFT_02:
            await w4.u8(this.priority);
            break;
          default:
            await w4.u8(this.priority);
            await padGroupOrder(w4, version2);
            await w4.u53(this.maxAge);
            await encodeStartGroup(w4, version2, this.startGroup);
            await w4.u53(this.endGroup !== void 0 ? this.endGroup + 1 : 0);
            await encodeFrameBounds(w4, version2, this);
            break;
        }
      }
      static async #decode(r2, version2) {
        switch (version2) {
          case Version2.DRAFT_01:
          case Version2.DRAFT_02:
            return new _SubscribeUpdate({ priority: await r2.u8() });
          default: {
            const priority = await r2.u8();
            await skipGroupOrder(r2, version2);
            const maxAge = await r2.u53();
            const startGroup = await decodeStartGroup(r2, version2);
            const endGroup = await r2.u53() || void 0;
            const end = endGroup !== void 0 ? endGroup - 1 : void 0;
            const frames = await decodeFrameBounds(r2, version2, startGroup, end);
            return new _SubscribeUpdate({
              priority,
              maxAge,
              startGroup: canonicalStartGroup(version2, startGroup, frames.startFrame),
              endGroup: end,
              ...frames
            });
          }
        }
      }
      async encode(w4, version2) {
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        return decode9(r2, (r3) => _SubscribeUpdate.#decode(r3, version2));
      }
      static async decodeMaybe(r2, version2) {
        return decodeMaybe(r2, (r3) => _SubscribeUpdate.#decode(r3, version2));
      }
    };
    Subscribe2 = class _Subscribe {
      id;
      broadcast;
      track;
      priority;
      /** Subscriber max latency in milliseconds; zero skips once a newer group is available. */
      maxAge;
      startGroup;
      endGroup;
      /**
       * First frame to deliver within `startGroup`'s group; 0 is the whole group.
       * Lite-06+. It qualifies the named group, so it needs `startGroup` to name one
       * (defined, including 0: group 0 can host a mid-group resume).
       */
      startFrame;
      /**
       * Last frame to deliver (inclusive) within `endGroup`'s group, or undefined for the
       * whole group. Lite-06+, and meaningless without an explicit `endGroup`.
       */
      endFrame;
      constructor(props) {
        this.id = props.id;
        this.broadcast = props.broadcast;
        this.track = props.track;
        this.priority = props.priority;
        this.maxAge = props.maxAge ?? 0;
        this.startGroup = props.startGroup;
        this.endGroup = props.endGroup;
        this.startFrame = props.startFrame ?? 0;
        this.endFrame = props.endFrame;
      }
      async #encode(w4, version2) {
        await w4.u62(this.id);
        await w4.string(encode2(this.broadcast));
        await w4.string(this.track);
        await w4.u8(this.priority);
        switch (version2) {
          case Version2.DRAFT_01:
          case Version2.DRAFT_02:
            break;
          default:
            await padGroupOrder(w4, version2);
            await w4.u53(this.maxAge);
            await encodeStartGroup(w4, version2, this.startGroup);
            await w4.u53(this.endGroup !== void 0 ? this.endGroup + 1 : 0);
            await encodeFrameBounds(w4, version2, this);
            break;
        }
      }
      static async #decode(r2, version2) {
        const id = await r2.u62();
        const broadcast2 = decode2(await r2.string());
        const track = await r2.string();
        const priority = await r2.u8();
        switch (version2) {
          case Version2.DRAFT_01:
          case Version2.DRAFT_02:
            return new _Subscribe({ id, broadcast: broadcast2, track, priority });
          default: {
            await skipGroupOrder(r2, version2);
            const maxAge = await r2.u53();
            const startGroup = await decodeStartGroup(r2, version2);
            const endGroup = await r2.u53() || void 0;
            const end = endGroup !== void 0 ? endGroup - 1 : void 0;
            const frames = await decodeFrameBounds(r2, version2, startGroup, end);
            return new _Subscribe({
              id,
              broadcast: broadcast2,
              track,
              priority,
              maxAge,
              startGroup: canonicalStartGroup(version2, startGroup, frames.startFrame),
              endGroup: end,
              ...frames
            });
          }
        }
      }
      async encode(w4, version2) {
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        return decode9(r2, (r3) => _Subscribe.#decode(r3, version2));
      }
    };
    SubscribeOk2 = class _SubscribeOk {
      priority;
      /** Accepted subscriber max latency in milliseconds. */
      maxAge;
      startGroup;
      endGroup;
      constructor({ priority = 0, maxAge = 0, startGroup = void 0, endGroup = void 0 }) {
        this.priority = priority;
        this.maxAge = maxAge;
        this.startGroup = startGroup;
        this.endGroup = endGroup;
      }
      async #encode(w4, version2) {
        switch (version2) {
          case Version2.DRAFT_02:
            break;
          case Version2.DRAFT_01:
            await w4.u8(this.priority ?? 0);
            break;
          // Draft-05+ never sends SUBSCRIBE_OK, but keep the field layout matching
          // Draft-03/04 so a stray future use stays well-formed.
          default:
            await w4.u8(this.priority);
            await padGroupOrder(w4, version2);
            await w4.u53(this.maxAge);
            await w4.u53(this.startGroup !== void 0 ? this.startGroup + 1 : 0);
            await w4.u53(this.endGroup !== void 0 ? this.endGroup + 1 : 0);
            break;
        }
      }
      static async #decode(version2, r2) {
        let priority;
        let maxAge;
        let startGroup;
        let endGroup;
        switch (version2) {
          case Version2.DRAFT_02:
            break;
          case Version2.DRAFT_01:
            priority = await r2.u8();
            break;
          default:
            priority = await r2.u8();
            await skipGroupOrder(r2, version2);
            maxAge = await r2.u53();
            startGroup = await r2.u53();
            endGroup = await r2.u53();
            break;
        }
        return new _SubscribeOk({
          priority,
          maxAge,
          startGroup: startGroup !== void 0 && startGroup > 0 ? startGroup - 1 : void 0,
          endGroup: endGroup !== void 0 && endGroup > 0 ? endGroup - 1 : void 0
        });
      }
      async encode(w4, version2) {
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        return decode9(r2, _SubscribeOk.#decode.bind(_SubscribeOk, version2));
      }
    };
    SubscribeStart = class _SubscribeStart {
      group;
      constructor(group) {
        this.group = group;
      }
      async encode(w4) {
        return encode9(w4, async (w5) => {
          await w5.u53(this.group);
        });
      }
      static async decode(r2) {
        return decode9(r2, async (r3) => new _SubscribeStart(await r3.u53()));
      }
    };
    SubscribeEnd = class _SubscribeEnd {
      /** The exclusive final group sequence: the first sequence that will never be produced. */
      group;
      /**
       * The number of group streams the publisher opened for this subscription.
       * Draft-07+ only; not on the wire before, where it decodes as 0.
       */
      streams;
      constructor(group, streams2 = 0) {
        this.group = group;
        this.streams = streams2;
      }
      async encode(w4, version2) {
        return encode9(w4, async (w5) => {
          await w5.u53(this.group);
          if (hasStreamCount(version2))
            await w5.u53(this.streams);
        });
      }
      static async decode(r2, version2) {
        return decode9(r2, async (r3) => new _SubscribeEnd(await r3.u53(), hasStreamCount(version2) ? await r3.u53() : 0));
      }
    };
    SubscribeDrop = class _SubscribeDrop {
      start;
      end;
      error;
      constructor(props) {
        this.start = props.start;
        this.end = props.end;
        this.error = props.error;
      }
      async #encode(w4) {
        await w4.u53(this.start);
        await w4.u53(this.end);
        await w4.u53(this.error);
      }
      static async #decode(r2) {
        return new _SubscribeDrop({ start: await r2.u53(), end: await r2.u53(), error: await r2.u53() });
      }
      async encode(w4) {
        return encode9(w4, this.#encode.bind(this));
      }
      static async decode(r2) {
        return decode9(r2, _SubscribeDrop.#decode);
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/track.js
function guardTrack(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      throw new Error("track stream not supported for this version");
    default:
      break;
  }
}
var Track, TrackInfo;
var init_track3 = __esm({
  "../../node_modules/@moq/net/lite/track.js"() {
    init_path();
    init_time();
    init_message2();
    init_version2();
    Track = class _Track {
      broadcast;
      track;
      constructor(broadcast2, track) {
        this.broadcast = broadcast2;
        this.track = track;
      }
      async #encode(w4) {
        await w4.string(encode2(this.broadcast));
        await w4.string(this.track);
      }
      static async #decode(r2) {
        const broadcast2 = decode2(await r2.string());
        const track = await r2.string();
        return new _Track(broadcast2, track);
      }
      async encode(w4, version2) {
        guardTrack(version2);
        return encode9(w4, (w5) => this.#encode(w5));
      }
      static async decode(r2, version2) {
        guardTrack(version2);
        return decode9(r2, (r3) => _Track.#decode(r3));
      }
    };
    TrackInfo = class _TrackInfo {
      /** The publisher's tie-break priority for this track. */
      priority;
      /**
       * Publisher Max Age: an upper bound (milliseconds) on how long the publisher
       * caches a non-latest group past the arrival of a newer one.
       */
      maxAge;
      /**
       * Per-frame timestamp scale (units per second). Mandatory on Lite05: a real
       * (non-zero) scale, and every frame on the wire is prefixed with a zigzag-delta
       * timestamp at this scale.
       */
      timescale;
      constructor({ priority = 0, maxAge = 0, timescale = Timescale.MILLI }) {
        if (!Number.isInteger(priority) || priority < 0 || priority > 255) {
          throw new RangeError(`priority must be an integer in 0..=255: ${priority}`);
        }
        if (!Number.isSafeInteger(maxAge) || maxAge < 0) {
          throw new RangeError(`maxAge must be a safe non-negative integer: ${maxAge}`);
        }
        this.priority = priority;
        this.maxAge = maxAge;
        this.timescale = Timescale(timescale);
      }
      async #encode(w4, version2) {
        await w4.u8(this.priority);
        if (hasGroupOrder(version2))
          await w4.bool(false);
        await w4.u53(this.maxAge);
        await w4.u53(this.timescale);
      }
      static async #decode(r2, version2) {
        const priority = await r2.u8();
        if (hasGroupOrder(version2))
          await r2.bool();
        const maxAge = await r2.u53();
        const timescale = await r2.u53();
        return new _TrackInfo({ priority, maxAge, timescale });
      }
      async encode(w4, version2) {
        guardTrack(version2);
        if (!Number.isInteger(this.priority) || this.priority < 0 || this.priority > 255) {
          throw new RangeError(`priority must be an integer in 0..=255: ${this.priority}`);
        }
        if (!Number.isSafeInteger(this.maxAge) || this.maxAge < 0) {
          throw new RangeError(`maxAge must be a safe non-negative integer: ${this.maxAge}`);
        }
        Timescale(this.timescale);
        return encode9(w4, (w5) => this.#encode(w5, version2));
      }
      static async decode(r2, version2) {
        guardTrack(version2);
        return decode9(r2, (r3) => _TrackInfo.#decode(r3, version2));
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/publisher.js
function zigzag(delta) {
  return delta >= 0n ? delta << 1n : (-delta << 1n) - 1n;
}
function supportsTrackStream(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      return false;
    default:
      return true;
  }
}
function frameRange(bounds, sequence) {
  return {
    start: bounds.startGroup === sequence ? bounds.startFrame : 0,
    end: bounds.endGroup === sequence ? bounds.endFrame : void 0
  };
}
function waitForSubscription(controls, subscriber) {
  return new Promise((resolve2) => {
    let settled = false;
    const dispose = [];
    const wake = () => {
      if (settled)
        return;
      settled = true;
      for (const close of dispose)
        close();
      resolve2();
    };
    dispose.push(controls.changed(wake), hooks.groupChanged(subscriber, wake));
  });
}
function servingMaxAge(version2, requested) {
  return carriesMaxAge(version2) ? requested ?? 0 : Number.MAX_SAFE_INTEGER;
}
function carriesMaxAge(version2) {
  return version2 !== Version2.DRAFT_01 && version2 !== Version2.DRAFT_02;
}
function positionCursor(track, version2, startGroup) {
  if (resolvesStart(version2) || startGroup !== void 0)
    return;
  const latest = track.latest();
  if (latest !== void 0)
    hooks.replaceGroups(track, { start: { included: latest } });
}
var PROBE_INTERVAL, PROBE_MAX_AGE, PROBE_MAX_DELTA, PROBE_RTT_DELTA, SubscriptionControls, yieldToControls, Publisher2;
var init_publisher2 = __esm({
  "../../node_modules/@moq/net/lite/publisher.js"() {
    init_signals();
    init_error2();
    init_hop();
    init_internal();
    init_stream();
    init_time();
    init_wire();
    init_announce2();
    init_datagram();
    init_datagram_stream();
    init_group2();
    init_priority2();
    init_probe();
    init_subscribe2();
    init_track3();
    init_version2();
    PROBE_INTERVAL = 100;
    PROBE_MAX_AGE = 1e4;
    PROBE_MAX_DELTA = 0.25;
    PROBE_RTT_DELTA = 0.25;
    SubscriptionControls = class {
      #writer;
      #update;
      // Sticky, first one wins: null once the stream is over, an Error once it failed.
      #end;
      #ended;
      #resolveEnd;
      #changed = new Signal(0);
      /** Settles once decoding stops, so teardown can wait for it rather than leaving it running. */
      decoding;
      constructor({ reader, writer, version: version2, apply: apply2 }) {
        this.#writer = writer;
        this.#ended = new Promise((resolve2) => {
          this.#resolveEnd = resolve2;
        });
        this.decoding = this.#decode(reader, version2, apply2);
        void writer.closed.then(() => this.#finish(null), (err2) => this.#finish(error(err2)));
      }
      /** The next control to apply, or undefined while the peer is quiet. */
      take() {
        const update = this.#update;
        this.#update = void 0;
        if (update)
          return { kind: "update", update };
        if (this.#end === void 0)
          return void 0;
        return this.#end === null ? { kind: "done" } : { kind: "error", error: this.#end };
      }
      /** Calls `fn` once {@link take} may answer differently. */
      changed(fn) {
        return this.#changed.changed(fn);
      }
      /** Returns false when peer departure supersedes a blocked response write. */
      async response(pending) {
        const result = await race([
          pending.then(() => ({ kind: "sent" }), (err2) => ({ kind: "error", error: error(err2) })),
          this.#ended
        ]);
        if (result !== null && !(result instanceof Error)) {
          if (result.kind === "sent")
            return true;
          throw result.error;
        }
        this.#writer.reset(result ?? new Stream(StreamCode.Cancel, { message: "cancel" }));
        if (result)
          throw result;
        return false;
      }
      /** Settles once the stream is over: `null` when it ended cleanly, or the failure. */
      get ended() {
        return this.#ended;
      }
      #finish(end) {
        if (this.#end !== void 0)
          return;
        this.#end = end;
        this.#resolveEnd(end);
        this.#changed.update((value) => value + 1);
      }
      async #decode(reader, version2, apply2) {
        try {
          while (this.#end === void 0) {
            const update = await SubscribeUpdate2.decodeMaybe(reader, version2);
            if (!update)
              break;
            apply2(update);
            this.#update = update;
            this.#changed.update((value) => value + 1);
          }
        } catch (err2) {
          this.#finish(error(err2));
          return;
        }
        this.#finish(null);
      }
    };
    yieldToControls = () => new Promise((resolve2) => setTimeout(resolve2, 0));
    Publisher2 = class {
      // The version of the connection.
      version;
      // Per-connection origin appended to outbound Announce hops, so the peer
      // can detect loops and prefer shorter paths. Created by Connection and
      // shared with Subscriber, which can optionally use it to filter out its
      // own announcements.
      hop;
      #quic;
      // The one writer for the outbound datagram stream (getWriter locks it), acquired once at
      // construction when this version + transport carry datagrams, released in close(). Its
      // presence is the gate: undefined means datagrams aren't served on this connection. All
      // subscriptions share it, since a second getWriter on the same stream would throw.
      #datagramWriter;
      // Originated advertisements this session forwards.
      #advertised;
      #publish;
      // TRACK_INFO is immutable per track, so resolve it from the application once
      // (via a throwaway subscribe whose info() resolves when the app calls accept)
      // and reuse it for every later TRACK request of the same track. Keyed by the
      // routing front rather than the path: immutability holds for one broadcast, and a
      // republish puts a different one on the path, so its entries must not be reused.
      // A rejected lookup is evicted so a retry can re-probe.
      #trackInfo = /* @__PURE__ */ new WeakMap();
      /**
       * Creates a new Publisher instance.
       * @param quic - The WebTransport session to use
       * @param version - Negotiated protocol version
       * @param origin - Hop id shared with the Subscriber
       * @param publish - The origin whose broadcasts this session serves; omit to publish nothing
       *
       * @internal
       */
      constructor(quic, version2, hop, publish5) {
        this.#quic = quic;
        this.version = version2;
        this.hop = hop;
        const origin = publish5 && wireOf(publish5);
        this.#advertised = origin?.advertised ?? new Signal(/* @__PURE__ */ new Map());
        this.#publish = publish5;
        if (hasDatagrams(version2)) {
          this.#datagramWriter = datagramWriter(quic);
        }
      }
      /**
       * Handles an announce interest message.
       * @param msg - The announce interest message
       * @param stream - The stream to write announcements to
       *
       * @internal
       */
      async runAnnounce(msg, stream) {
        console.debug(`announce: prefix=${msg.prefix}`);
        let active = /* @__PURE__ */ new Map();
        let nextAnnounceId = 0n;
        const announceIds = /* @__PURE__ */ new Map();
        const wireHops = (route) => {
          if (hasAnnounceOk(this.version))
            return route.hops;
          return [...route.hops, this.hop];
        };
        const onWire = (route) => hasRouteCost(this.version) ? route : { ...route, cost: Cost.zero };
        const announce = async (suffix, route) => {
          console.debug(`announce: broadcast=${suffix} active=true`);
          if (hasAnnounceId(this.version))
            announceIds.set(suffix, nextAnnounceId++);
          await encodeAnnounceBroadcast(stream.writer, { status: "active", suffix, hops: wireHops(route), cost: route.cost }, this.version);
        };
        const restart = async (suffix, route) => {
          if (!hasAnnounceId(this.version)) {
            await retract(suffix);
            await announce(suffix, route);
            return;
          }
          const id = announceIds.get(suffix);
          if (id === void 0) {
            await announce(suffix, route);
            return;
          }
          console.debug(`announce: broadcast=${suffix} restart=true`);
          await encodeAnnounceBroadcast(stream.writer, { status: "restart", id, hops: wireHops(route), cost: route.cost }, this.version);
        };
        const retract = async (suffix) => {
          console.debug(`announce: broadcast=${suffix} active=false`);
          if (!hasAnnounceId(this.version)) {
            await encodeAnnounceBroadcast(stream.writer, { status: "ended", suffix }, this.version);
            return;
          }
          const id = announceIds.get(suffix);
          announceIds.delete(suffix);
          if (id === void 0)
            return;
          await encodeAnnounceBroadcast(stream.writer, { status: "endedId", id }, this.version);
        };
        let dispose;
        let changed = new Promise((resolve2) => {
          dispose = this.#advertised.changed(resolve2);
        });
        const carries = (covered) => msg.hidden || !hiddenBelow(msg.prefix, covered);
        try {
          const initial = this.#advertised.peek();
          if (!initial)
            return;
          for (const [name, snap] of presented(msg.prefix, initial, carries)) {
            active.set(name, snap);
          }
          switch (this.version) {
            case Version2.DRAFT_01:
            case Version2.DRAFT_02: {
              for (const suffix of active.keys()) {
                console.debug(`announce: broadcast=${suffix} active=true`);
              }
              const init = new AnnounceInit([...active.keys()]);
              await init.encode(stream.writer, this.version);
              break;
            }
            default: {
              if (!hasAnnounceOk(this.version)) {
                for (const [suffix, snap] of active) {
                  await announce(suffix, snap.route);
                }
                break;
              }
              const ok = new AnnounceOk(this.hop, active.size);
              await ok.encode(stream.writer, this.version);
              for (const [suffix, snap] of active) {
                await announce(suffix, snap.route);
              }
              break;
            }
          }
          for (; ; ) {
            const advertised = await race([changed, stream.reader.closed]);
            dispose();
            if (!advertised)
              break;
            changed = new Promise((resolve2) => {
              dispose = this.#advertised.changed(resolve2);
            });
            const latest = this.#advertised.peek();
            if (!latest)
              break;
            const updated = /* @__PURE__ */ new Map();
            for (const [name, snap] of presented(msg.prefix, latest, carries)) {
              updated.set(name, snap);
            }
            for (const [suffix, snap] of active) {
              const cur = updated.get(suffix);
              if (!cur || cur.identity !== snap.identity)
                await retract(suffix);
            }
            for (const [suffix, snap] of updated) {
              const prev = active.get(suffix);
              if (!prev || prev.identity !== snap.identity) {
                await announce(suffix, snap.route);
              } else if (!routesEqual(onWire(prev.route), onWire(snap.route))) {
                await restart(suffix, snap.route);
              }
            }
            active = updated;
          }
        } finally {
          dispose();
        }
      }
      /**
       * Handles a subscribe message.
       * @param msg - The subscribe message
       * @param stream - The stream to write track data to
       *
       * @internal
       */
      async runSubscribe(msg, stream) {
        let front;
        try {
          front = this.#publish && (wireOf(this.#publish).local(msg.broadcast) ?? await wireOf(this.#publish).demand(msg.broadcast));
        } catch (err2) {
          stream.writer.reset(error(err2));
          return;
        }
        if (!front) {
          console.debug(`publish unknown: broadcast=${msg.broadcast}`);
          stream.writer.reset(new NotFound(`broadcast ${msg.broadcast}`));
          return;
        }
        const endGroup = exclusiveGroupEnd(msg.endGroup);
        const track = wireOf(front).subscribe(msg.track, {
          priority: msg.priority,
          maxAge: Milli(servingMaxAge(this.version, msg.maxAge)),
          groups: {
            start: msg.startGroup === void 0 ? void 0 : { included: msg.startGroup },
            end: endGroup === void 0 ? void 0 : { excluded: endGroup }
          }
        });
        positionCursor(track, this.version, msg.startGroup);
        hooks.replaceGroups(track, { end: endGroup === void 0 ? void 0 : { excluded: endGroup } });
        let datagrams2 = Promise.resolve();
        let controls;
        try {
          let timescale = Timescale.MILLI;
          if (supportsTrackStream(this.version)) {
            const info = await track.info();
            timescale = info.timescale;
          } else {
            const ok = new SubscribeOk2({
              priority: msg.priority,
              maxAge: msg.maxAge,
              startGroup: msg.startGroup,
              endGroup: msg.endGroup
            });
            await encodeSubscribeResponse(stream.writer, { ok }, this.version);
          }
          console.debug(`publish ok: broadcast=${msg.broadcast} track=${track.name}`);
          if (this.#datagramWriter) {
            datagrams2 = this.#runDatagrams(msg.id, track, timescale);
          }
          controls = new SubscriptionControls({
            reader: stream.reader,
            writer: stream.writer,
            version: this.version,
            apply: (update) => {
              const end = exclusiveGroupEnd(update.endGroup);
              track.update({
                priority: update.priority,
                maxAge: Milli(servingMaxAge(this.version, update.maxAge)),
                groups: {
                  start: update.startGroup === void 0 ? void 0 : { included: update.startGroup },
                  end: end === void 0 ? void 0 : { excluded: end }
                }
              });
            }
          });
          await this.#runTrack(track, stream.writer, controls, {
            sub: msg.id,
            broadcast: msg.broadcast,
            timescale,
            bounds: {
              startGroup: msg.startGroup,
              startFrame: msg.startFrame,
              endGroup: msg.endGroup,
              endFrame: msg.endFrame
            }
          });
          console.debug(`publish done: broadcast=${msg.broadcast} track=${track.name}`);
          stream.close();
          track.close();
          await Promise.all([datagrams2, controls.decoding]);
        } catch (err2) {
          const e5 = error(err2);
          console.warn(`publish error: broadcast=${msg.broadcast} track=${track.name} error=${reason(e5)}`);
          track.close(e5);
          stream.abort(e5);
          await Promise.all([datagrams2, controls?.decoding]);
        }
      }
      /**
       * Handles a FETCH stream by serving one group as bare frame records (lite-05+).
       *
       * @internal
       */
      async runFetch(msg, stream) {
        if (!supportsTrackStream(this.version)) {
          stream.writer.reset(new Error("fetch requires moq-lite-05 or newer"));
          return;
        }
        let front;
        try {
          front = this.#publish && (wireOf(this.#publish).local(msg.broadcast) ?? await wireOf(this.#publish).demand(msg.broadcast));
        } catch (err2) {
          stream.writer.reset(error(err2));
          return;
        }
        if (!front) {
          console.debug(`fetch unknown: broadcast=${msg.broadcast}`);
          stream.writer.reset(new NotFound(`broadcast ${msg.broadcast}`));
          return;
        }
        stream.writer.setPriority(sendOrder({ priority: msg.priority }));
        let group;
        try {
          const info = await this.#resolveTrackInfo(front, msg.track);
          group = await wireOf(front).fetchGroup(msg.track, msg.group, { priority: msg.priority });
          await this.#runFetchGroup(group, stream.writer, {
            timescale: Timescale(info.timescale),
            start: msg.startFrame,
            end: msg.endFrame
          });
          console.debug(`fetch done: broadcast=${msg.broadcast} track=${msg.track} group=${msg.group}`);
          stream.close();
          group.close();
        } catch (err2) {
          const e5 = error(err2);
          console.warn(`fetch error: broadcast=${msg.broadcast} track=${msg.track} group=${msg.group} error=${reason(e5)}`);
          group?.close(e5);
          stream.abort(e5);
        }
      }
      /**
       * Runs a track and sends its data to the stream.
       * @param sub - The subscription ID
       * @param broadcast - The broadcast name
       * @param track - The track to run
       * @param stream - The stream to write to
       *
       * @internal
       */
      async #runTrack(track, stream, controls, serving) {
        const { sub, broadcast: broadcast2, timescale, bounds } = serving;
        const emitRange = supportsTrackStream(this.version);
        let startSent = false;
        let endSent = false;
        const countStreams = hasStreamCount(this.version);
        let streams2 = 0;
        const opening = /* @__PURE__ */ new Set();
        const boundary = () => track.final() ?? (track.latest() ?? -1) + 1;
        const sendEnd = async () => {
          endSent = true;
          if (!emitRange)
            return true;
          return controls.response((async () => {
            if (countStreams)
              while (opening.size > 0)
                await Promise.all(opening);
            const end = new SubscribeEnd(boundary(), streams2);
            await encodeSubscribeResponse(stream, { end }, this.version);
          })());
        };
        const priority = new Priority(track);
        const groups2 = /* @__PURE__ */ new Set();
        let finished = false;
        let unsubscribe;
        const unsubscribed = new Promise((resolve2) => {
          unsubscribe = resolve2;
        });
        try {
          for (; ; ) {
            const control = controls.take();
            if (control) {
              switch (control.kind) {
                case "done":
                  return;
                case "error":
                  throw control.error;
                case "update": {
                  const update = control.update;
                  console.debug(`subscribe update: broadcast=${broadcast2} track=${track.name}`);
                  const start = update.startGroup === void 0 && bounds.startGroup !== void 0 && !resolvesStart(this.version) ? track.latest() ?? 0 : update.startGroup;
                  hooks.replaceGroups(track, {
                    start: start === void 0 ? void 0 : { included: start },
                    end: update.endGroup === void 0 ? void 0 : { included: update.endGroup }
                  });
                  bounds.startGroup = update.startGroup;
                  bounds.startFrame = update.startFrame;
                  bounds.endGroup = update.endGroup;
                  bounds.endFrame = update.endFrame;
                  await yieldToControls();
                  continue;
                }
              }
            }
            const recv = hooks.tryRecvGroup(track);
            switch (recv.kind) {
              case "error":
                throw recv.error;
              case "idle":
                if (!endSent && !countStreams && track.final() !== void 0) {
                  if (!await sendEnd())
                    return;
                  continue;
                }
                await waitForSubscription(controls, track);
                continue;
              case "boundary":
                if (!endSent && !countStreams) {
                  if (!await sendEnd())
                    return;
                  continue;
                }
                await waitForSubscription(controls, track);
                continue;
              case "done": {
                if (!endSent) {
                  if (!await sendEnd())
                    return;
                  continue;
                }
                const drained = /* @__PURE__ */ Symbol("drained");
                const end = await Promise.race([Promise.all(groups2).then(() => drained), controls.ended]);
                if (end instanceof Error)
                  throw end;
                if (end !== drained)
                  return;
                finished = true;
                return;
              }
            }
            const group = recv.group;
            const range = frameRange(bounds, group.sequence);
            if (emitRange && !startSent) {
              startSent = true;
              if (bounds.startGroup === void 0 && !resolvesStart(this.version)) {
                hooks.replaceGroups(track, {
                  start: { included: group.sequence },
                  end: bounds.endGroup === void 0 ? void 0 : { included: bounds.endGroup }
                });
              }
              if (!await controls.response(encodeSubscribeResponse(stream, { start: new SubscribeStart(group.sequence) }, this.version)))
                return;
            }
            const options = {
              sub,
              group,
              timescale,
              priority,
              unsubscribed,
              start: range.start,
              end: range.end
            };
            const opened = this.#openGroup(options);
            const task = opened.then(async (writer) => {
              if (!writer)
                return;
              streams2 += 1;
              await this.#serveGroup(writer, options);
            });
            groups2.add(task);
            void task.finally(() => groups2.delete(task));
            opening.add(opened);
            void opened.finally(() => opening.delete(opened));
          }
        } finally {
          if (!finished)
            unsubscribe();
          priority.close();
        }
      }
      /**
       * Answers a TRACK stream (0x6) with a single TRACK_INFO, then FINs.
       *
       * @internal
       */
      async runTrackInfo(msg, stream) {
        try {
          const front = this.#publish && (wireOf(this.#publish).local(msg.broadcast) ?? await wireOf(this.#publish).demand(msg.broadcast));
          if (!front)
            throw new NotFound(`broadcast ${msg.broadcast}`);
          const info = await this.#resolveTrackInfo(front, msg.track);
          await info.encode(stream.writer, this.version);
          console.debug(`track info: broadcast=${msg.broadcast} track=${msg.track}`);
          stream.close();
        } catch (err2) {
          console.debug(`track unknown: broadcast=${msg.broadcast} track=${msg.track}`);
          stream.writer.reset(error(err2));
        }
      }
      // Resolve (and cache) a track's immutable TRACK_INFO by asking the application.
      // `resolveTrackInfo` triggers a TrackRequest the app answers with accept(TrackInfo);
      // only the immutable properties are needed (not the groups). Cached because they're
      // fixed for the track's lifetime. Rejects if the track is unavailable.
      #resolveTrackInfo(front, track) {
        let tracks = this.#trackInfo.get(front);
        if (!tracks) {
          tracks = /* @__PURE__ */ new Map();
          this.#trackInfo.set(front, tracks);
        }
        const cached2 = tracks.get(track);
        if (cached2 !== void 0)
          return cached2;
        const pending = (async () => {
          const info = await wireOf(front).resolveTrackInfo(track);
          return new TrackInfo({
            priority: info.priority,
            // Publisher Max Age: the publisher's retention bound, advertised so
            // relays re-serve with the same window.
            maxAge: info.maxAge,
            // Lite05 mandates per-frame timestamps. Advertise the track's timescale;
            // `#serveGroup` emits each frame converted to it.
            timescale: info.timescale
          });
        })();
        pending.catch(() => tracks.delete(track));
        tracks.set(track, pending);
        return pending;
      }
      /**
       * Forwards a track's datagrams best-effort over QUIC datagrams (lite-05 §6.4), parallel to
       * its groups. Each datagram is dropped (there is no group fallback) if the encoded body
       * doesn't fit the transport's datagram limit or the send fails. Returns once the track
       * finishes; a failure never tears down the subscription.
       *
       * @internal
       */
      async #runDatagrams(sub, track, timescale) {
        const writer = this.#datagramWriter;
        if (!writer)
          return;
        const maxSize = maxDatagramSize(this.#quic);
        try {
          for (; ; ) {
            const datagram = await track.recvDatagram();
            if (!datagram)
              return;
            const ts = Math.round(datagram.timestamp.as(timescale));
            const body = new Datagram(sub, datagram.sequence, ts, datagram.payload).encode(this.version);
            if (body.byteLength > maxSize) {
              console.debug(`dropping oversize datagram: sub=${sub} size=${body.byteLength} max=${maxSize}`);
              continue;
            }
            await writer.ready;
            await writer.write(body);
          }
        } catch (err2) {
          console.debug(`datagram send stopped: sub=${sub} error=${reason(err2)}`);
        }
      }
      // Serialize a fetched group's frames onto the FETCH stream as bare records: each a
      // zigzag-delta timestamp (at the track's advertised timescale) followed by size + bytes.
      async #runFetchGroup(group, stream, { timescale, start: startFrame, end: endFrame }) {
        for (let i2 = 0; i2 < startFrame; i2++) {
          if (!await race([group.readFrame(), stream.closed])) {
            throw new Error(`fetch group ended at frame ${i2}, before the requested start ${startFrame}`);
          }
        }
        let prevTs = 0n;
        for (let index2 = startFrame; endFrame === void 0 || index2 <= endFrame; index2++) {
          const frame = await race([group.readFrame(), stream.closed]);
          if (!frame)
            break;
          const ts = BigInt(Math.round(frame.timestamp.as(timescale)));
          await stream.u62(zigzag(ts - prevTs));
          prevTs = ts;
          await stream.u53(frame.payload.byteLength);
          await stream.write(frame.payload);
        }
      }
      /**
       * Opens the unidirectional stream for one group, or closes the group and resolves
       * `undefined` when it cannot get one.
       *
       * @internal
       */
      async #openGroup(options) {
        const { group, priority, unsubscribed } = options;
        try {
          const stream = await Writer.tryOpen(this.#quic, {
            version: this.version,
            sendOrder: priority.rank(group.sequence),
            cancel: unsubscribed,
            waitUntilAvailable: false
          });
          if (!stream)
            group.close(new Error("no stream slot"));
          return stream;
        } catch (err2) {
          group.close(error(err2));
          return void 0;
        }
      }
      /**
       * Serves one group on the stream {@link #openGroup} opened for it.
       *
       * @internal
       */
      async #serveGroup(stream, options) {
        const { sub, group, timescale, priority, start: startFrame, end: endFrame } = options;
        const msg = new Group2({ subscribe: sub, sequence: group.sequence, frameStart: startFrame });
        try {
          priority.add(stream, group.sequence);
          await hooks.guardGroup(group, async () => {
            await stream.u53(0);
            await msg.encode(stream, this.version);
          });
          const timestamps = supportsTrackStream(this.version);
          let prevTs = 0n;
          let reached = startFrame === 0;
          for (; ; ) {
            const read2 = await race([hooks.readGroupFrame(group), stream.closed]);
            if (!read2) {
              if (!reached)
                throw new Error(`group ended before frame ${startFrame}`);
              break;
            }
            try {
              if (read2.sequence + 1 >= startFrame)
                reached = true;
              if (read2.sequence < startFrame)
                continue;
              if (endFrame !== void 0 && read2.sequence > endFrame)
                break;
              if (timestamps) {
                const ts = BigInt(Math.round(read2.frame.timestamp.as(timescale)));
                await hooks.guardGroup(group, () => stream.u62(zigzag(ts - prevTs)));
                prevTs = ts;
              }
              await hooks.guardGroup(group, () => stream.u53(read2.frame.payload.byteLength));
              await hooks.guardGroup(group, () => stream.write(read2.frame.payload));
            } finally {
              read2.complete();
            }
          }
          stream.close();
          group.close();
        } catch (err2) {
          const e5 = error(err2);
          stream.reset(e5);
          group.close(e5);
        } finally {
          priority.remove(stream);
        }
      }
      /**
       * Handles a probe stream by periodically reporting estimated bitrate.
       * @param stream - The probe bidi stream
       *
       * @internal
       */
      async runProbe(stream) {
        const quic = this.#quic;
        if (!quic.getStats) {
          stream.close();
          return;
        }
        let lastSent;
        let lastSentTime;
        const moved = (prev, next, threshold = 0) => {
          if (prev === void 0 && next === void 0)
            return false;
          if (prev === void 0 || next === void 0)
            return true;
          if (prev === 0)
            return next !== 0;
          return Math.abs(next - prev) / prev >= threshold;
        };
        try {
          for (; ; ) {
            const timeout = new Promise((resolve2) => setTimeout(() => resolve2("timeout"), PROBE_INTERVAL));
            const result = await race([timeout, stream.reader.closed]);
            if (result !== "timeout")
              break;
            const stats = await quic.getStats();
            const rtt = stats.smoothedRtt != null ? Math.round(stats.smoothedRtt) : void 0;
            const report = new Probe({
              bitrate: stats.estimatedSendRate ?? void 0,
              rtt: hasProbeRtt(this.version) ? rtt : void 0
            });
            if (report.bitrate === void 0 && report.rtt === void 0) {
              const retracts = lastSent !== void 0 && (lastSent.bitrate !== void 0 || lastSent.rtt !== void 0);
              if (!retracts)
                continue;
            }
            let shouldSend;
            if (lastSent === void 0 || lastSentTime === void 0) {
              shouldSend = true;
            } else {
              const elapsed = performance.now() - lastSentTime;
              const t = Math.max(PROBE_INTERVAL, Math.min(PROBE_MAX_AGE, elapsed));
              const range = PROBE_MAX_AGE - PROBE_INTERVAL;
              const threshold = PROBE_MAX_DELTA * (PROBE_MAX_AGE - t) / range;
              shouldSend = elapsed >= PROBE_MAX_AGE || moved(lastSent.bitrate, report.bitrate, threshold) || moved(lastSent.rtt, report.rtt, PROBE_RTT_DELTA);
            }
            if (shouldSend) {
              await report.encode(stream.writer, this.version);
              lastSent = report;
              lastSentTime = performance.now();
            }
          }
        } catch (err2) {
          console.warn("probe stream error", err2);
          stream.close();
        }
      }
      close() {
        this.#datagramWriter?.releaseLock();
        this.#datagramWriter = void 0;
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/session.js
var SessionInfo;
var init_session2 = __esm({
  "../../node_modules/@moq/net/lite/session.js"() {
    init_message2();
    init_version2();
    SessionInfo = class _SessionInfo {
      bitrate;
      constructor(bitrate) {
        this.bitrate = bitrate;
      }
      static #guard(version2) {
        switch (version2) {
          case Version2.DRAFT_01:
          case Version2.DRAFT_02:
            break;
          default:
            throw new Error("session info not supported for this version");
        }
      }
      async #encode(w4) {
        await w4.u53(this.bitrate);
      }
      static async #decode(r2) {
        const bitrate = await r2.u53();
        return new _SessionInfo(bitrate);
      }
      async encode(w4, version2) {
        _SessionInfo.#guard(version2);
        return encode9(w4, this.#encode.bind(this));
      }
      static async decode(r2, version2) {
        _SessionInfo.#guard(version2);
        return decode9(r2, _SessionInfo.#decode);
      }
      static async decodeMaybe(r2, version2) {
        _SessionInfo.#guard(version2);
        return decodeMaybe(r2, _SessionInfo.#decode);
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/setup.js
function probeFromCode(code) {
  switch (code) {
    case 0n:
      return ProbeLevel.None;
    case 1n:
      return ProbeLevel.Report;
    default:
      return ProbeLevel.Increase;
  }
}
function roleFromCode(code) {
  switch (code) {
    case 1n:
      return Role.Publisher;
    case 2n:
      return Role.Subscriber;
    default:
      return Role.Both;
  }
}
var PARAM_PROBE, PARAM_PATH, PARAM_ROLE, PARAM_HOP, MAX_PARAMS, MAX_SETUP_SIZE, ProbeLevel, Role, Parameters2, Setup2;
var init_setup2 = __esm({
  "../../node_modules/@moq/net/lite/setup.js"() {
    init_hop();
    init_stream();
    init_utf8();
    init_message2();
    init_version2();
    PARAM_PROBE = 0x1n;
    PARAM_PATH = 0x2n;
    PARAM_ROLE = 0x3n;
    PARAM_HOP = 0x5n;
    MAX_PARAMS = 64;
    MAX_SETUP_SIZE = 64 * 1024;
    ProbeLevel = {
      /** No probing. Equivalent to omitting the parameter. */
      None: 0,
      /** The publisher can measure and periodically report its estimated bitrate. */
      Report: 1,
      /** The publisher can additionally pad the connection (or send redundant data). */
      Increase: 2
    };
    Role = {
      /** The client may do either, or declined to say. Equivalent to omitting the parameter. */
      Both: 0,
      /** The client will publish tracks (ingest); the server must consume. */
      Publisher: 1,
      /** The client will subscribe to tracks (egress); the server must publish. */
      Subscriber: 2
    };
    Parameters2 = class _Parameters {
      #entries = /* @__PURE__ */ new Map();
      /** Set a parameter to a raw byte value, replacing any existing entry. */
      setBytes(id, value) {
        this.#entries.set(id, value);
      }
      /** Return a parameter's raw byte value, if present. */
      getBytes(id) {
        return this.#entries.get(id);
      }
      /** Set a parameter to a varint value in `version`'s encoding, replacing any existing entry. */
      setVarint(id, value, version2) {
        this.#entries.set(id, encodeVarint(value, version2));
      }
      /** Decode a parameter as a single varint in `version`'s encoding, if present. Throws if trailing bytes remain. */
      async getVarint(id, version2) {
        const bytes = this.#entries.get(id);
        if (bytes === void 0)
          return void 0;
        const r2 = new Reader(void 0, bytes, version2);
        const value = await r2.u62();
        if (!await r2.done()) {
          throw new Error("trailing bytes after varint parameter");
        }
        return value;
      }
      async encode(w4) {
        if (this.#entries.size > MAX_PARAMS) {
          throw new Error("too many parameters");
        }
        await w4.u53(this.#entries.size);
        for (const [id, value] of this.#entries) {
          await w4.u62(id);
          await w4.u53(value.byteLength);
          await w4.write(value);
        }
      }
      static async decode(r2) {
        const params = new _Parameters();
        const count2 = await r2.u53();
        if (count2 > MAX_PARAMS) {
          throw new Error("too many parameters");
        }
        for (let i2 = 0; i2 < count2; i2++) {
          const id = await r2.u62();
          if (params.#entries.has(id)) {
            throw new Error(`duplicate parameter id: ${id.toString()}`);
          }
          const size2 = await r2.u53();
          const value = await r2.read(size2);
          params.#entries.set(id, value);
        }
        return params;
      }
    };
    Setup2 = class _Setup {
      /** The probe capability this endpoint supports. {@link ProbeLevel.None} when absent. */
      probe;
      /**
       * The request path, for transports that carry no request URI (native QUIC, qmux over
       * TCP/TLS, unix sockets), with `?` and the URI query appended when there is one. Sent
       * only by the client; a server never sends one and a relay never forwards it.
       * `undefined` on URI-carrying bindings such as WebTransport, where sending one is a
       * protocol violation. An empty string means the same as `undefined`.
       */
      path;
      /**
       * The client's intended {@link Role}. `Both` is sent as the absence of the parameter, so
       * a client that never sets it decodes back to `Both`. Sent only by the client; a server
       * never sends one and a relay never forwards it.
       */
      role;
      /**
       * This endpoint's Hop ID. The peer uses it to filter announcements and
       * subscriptions whose route flows through this endpoint (lite-06 removed the
       * per-stream `exclude_hop` in its favor). `undefined` when the endpoint declares
       * no identity; a wire value of 0 decodes the same way.
       */
      hop;
      constructor({ probe, path, role, hop } = {}) {
        this.probe = probe ?? ProbeLevel.None;
        this.path = path;
        this.role = role ?? Role.Both;
        this.hop = hop;
      }
      static #guard(version2) {
        if (!hasSetupStream(version2)) {
          throw new Error("setup stream not supported for this version");
        }
      }
      async #encode(w4, version2) {
        const params = new Parameters2();
        if (this.probe !== ProbeLevel.None) {
          params.setVarint(PARAM_PROBE, this.probe, version2);
        }
        if (this.path !== void 0) {
          params.setBytes(PARAM_PATH, new TextEncoder().encode(this.path));
        }
        if (this.role !== Role.Both) {
          params.setVarint(PARAM_ROLE, this.role, version2);
        }
        if (this.hop !== void 0 && this.hop !== 0n) {
          params.setVarint(PARAM_HOP, this.hop, version2);
        }
        await params.encode(w4);
      }
      static async #decode(r2, version2) {
        const params = await Parameters2.decode(r2);
        const probeCode = await params.getVarint(PARAM_PROBE, version2);
        const probe = probeCode === void 0 ? ProbeLevel.None : probeFromCode(probeCode);
        const pathBytes = params.getBytes(PARAM_PATH);
        const path = pathBytes === void 0 ? void 0 : decodeUtf8(pathBytes);
        const roleCode = await params.getVarint(PARAM_ROLE, version2);
        const role = roleCode === void 0 ? Role.Both : roleFromCode(roleCode);
        const hopRaw = await params.getVarint(PARAM_HOP, version2);
        const hop = hopRaw === void 0 || hopRaw === 0n ? void 0 : HopSchema.parse(hopRaw);
        return new _Setup({ probe, path, role, hop });
      }
      /** Encode the SETUP message with its size prefix. Throws on pre-lite-05 versions. */
      async encode(w4, version2) {
        _Setup.#guard(version2);
        return encode9(w4, (w5) => this.#encode(w5, version2), MAX_SETUP_SIZE);
      }
      /** Decode a SETUP message with its size prefix. Throws on pre-lite-05 versions. */
      static async decode(r2, version2) {
        _Setup.#guard(version2);
        return decode9(r2, (r3) => _Setup.#decode(r3, version2), MAX_SETUP_SIZE);
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/stream.js
var StreamId, DataType;
var init_stream3 = __esm({
  "../../node_modules/@moq/net/lite/stream.js"() {
    StreamId = {
      Session: 0,
      Announce: 1,
      Subscribe: 2,
      Fetch: 3,
      Probe: 4,
      Goaway: 5,
      Track: 6,
      ClientCompat: 32,
      ServerCompat: 33
    };
    DataType = {
      Group: 0,
      Setup: 1
    };
  }
});

// ../../node_modules/@moq/net/lite/subscriber.js
function supportsTrackStream2(version2) {
  switch (version2) {
    case Version2.DRAFT_01:
    case Version2.DRAFT_02:
    case Version2.DRAFT_03:
    case Version2.DRAFT_04:
      return false;
    default:
      return true;
  }
}
function closeReason(text) {
  const encoder2 = new TextEncoder();
  const buf = new Uint8Array(MAX_CLOSE_REASON);
  const { read: read2 } = encoder2.encodeInto(text, buf);
  return text.slice(0, read2);
}
async function untilClosed(group, step) {
  const value = await race([step, group.closed]);
  const closed = group.closed.peek();
  if (closed !== void 0)
    throw closed ?? new Error("fetch closed before it was accepted");
  return value;
}
async function untilAbandoned(group, step) {
  const idle = /* @__PURE__ */ Symbol("idle");
  for (; ; ) {
    const value = await untilClosed(group, race([step, group.unused().then(() => idle)]));
    if (value !== idle)
      return value;
    if (!group.used.peek())
      throw new Stream(StreamCode.Cancel, { message: "cancel" });
  }
}
var SUBSCRIBE_SETUP_TIMEOUT_MS, PROTOCOL_VIOLATION_CODE, MAX_CLOSE_REASON, Subscriber3, ConsumeBroadcast2;
var init_subscriber2 = __esm({
  "../../node_modules/@moq/net/lite/subscriber.js"() {
    init_signals();
    init_announced();
    init_broadcast();
    init_consume();
    init_error2();
    init_group();
    init_hop();
    init_internal();
    init_path();
    init_stream();
    init_tail();
    init_time();
    init_abort();
    init_timeout();
    init_wire();
    init_announce2();
    init_datagram();
    init_datagram_stream();
    init_fetch2();
    init_group2();
    init_priority2();
    init_probe();
    init_setup2();
    init_stream3();
    init_subscribe2();
    init_track3();
    init_version2();
    SUBSCRIBE_SETUP_TIMEOUT_MS = 1e4;
    PROTOCOL_VIOLATION_CODE = 15;
    MAX_CLOSE_REASON = 1024;
    Subscriber3 = class {
      #quic;
      // The version of the connection.
      version;
      // Shared with the Publisher so reflected announces can be dropped on receipt.
      hop;
      // Our subscribed tracks. `timescale` resolves once known (from TRACK_INFO on
      // lite-05+, or implicit defaults on older drafts); group streams block on it
      // before decoding any frame, since a group's QUIC stream can race ahead.
      #subscribes = /* @__PURE__ */ new Map();
      #subscribeNext = 0n;
      // Dedup consumed broadcasts per path: repeat consume() calls share one subscription.
      #consumes = new BroadcastCache();
      // A random Hop ID of this connection's own, written as the first hop of any chain that
      // names no publisher, so a publisher that reconnects reads as a new one.
      #stamp;
      // Dedup in-flight one-shot fetches, keyed by [broadcast, track, sequence]. Concurrent (or
      // repeat, while still open) fetchGroup() calls for the same group share one FETCH stream and
      // each get an independent mirror; the entry is evicted once the group closes.
      #fetches = /* @__PURE__ */ new Map();
      // The peer's PROBE estimates, written as they arrive (Lite03+ only).
      #probe;
      // The peer's SETUP (lite-05+), undefined until it arrives. Gates opening the PROBE
      // stream on the peer having advertised Probe >= Report.
      #peerSetup;
      // Distinguishes failures from streams torn down by Subscriber.close().
      #closed = new AbortController();
      /**
       * Creates a new Subscriber instance.
       * @param quic - The WebTransport session to use
       * @param version - The protocol version
       * @param origin - Hop id shared with the Publisher
       * @param probe - Optional sink for the peer's PROBE estimates
       * @param peerSetup - Optional peer SETUP slot for capability gating (lite-05+)
       *
       * @internal
       */
      constructor(quic, version2, hop, probe, peerSetup) {
        this.#quic = quic;
        this.version = version2;
        this.hop = hop;
        this.#stamp = randomHop();
        this.#probe = probe;
        this.#peerSetup = peerSetup;
      }
      /**
       * Subscribe to broadcast announcements matching `scope`. Paths are relative
       * to the session, not the scope.
       *
       * Reflected announces (those whose hop chain already includes this
       * connection) are always dropped: moq-lite-06 has none to keep, and older
       * versions stay consistent with that.
       *
       * Hidden routes (a `.`-prefixed segment below the scope's head) are left out unless
       * `options.hidden` opts in. The opt-in rides the request on lite-07+; an older peer
       * never hides anything, so the rule is also applied here.
       */
      announced(scope = Pattern.all(), options) {
        const announced = new Producer();
        void this.#runAnnounced(announced, scopeHead(scope), scope, options?.hidden ?? false);
        return announced.consume();
      }
      async #runAnnounced(announced, prefix, scope, hidden) {
        console.debug(`announced: prefix=${prefix}`);
        const msg = new AnnounceRequest(prefix, this.hop, hidden);
        const visible = (path) => scopeOverlaps(scope, path) && (hidden || !hiddenBelow(prefix, path));
        let stream;
        try {
          stream = await Stream2.open(this.#quic, { version: this.version });
        } catch (err2) {
          announced.close(error(err2));
          return;
        }
        try {
          await stream.writer.u53(StreamId.Announce);
          await msg.encode(stream.writer, this.version);
          let responderOrigin;
          if (hasAnnounceOk(this.version)) {
            const ok = await AnnounceOk.decode(stream.reader, this.version);
            responderOrigin = ok.hop;
          }
          const advertised = /* @__PURE__ */ new Map();
          switch (this.version) {
            case Version2.DRAFT_01:
            case Version2.DRAFT_02: {
              const init = await AnnounceInit.decode(stream.reader, this.version);
              for (const suffix of init.suffixes) {
                const path = join(prefix, suffix);
                if (advertised.has(path)) {
                  throw new ProtocolViolation(`duplicate announce for ${path}`);
                }
                const route = { hops: [this.#stamp, UNKNOWN_HOP], cost: Cost.zero };
                const live = visible(path);
                const captures = scopeCaptures(scope, path);
                advertised.set(path, { publisher: this.#stamp, live, route, captures });
                if (!live)
                  continue;
                console.debug(`announced: broadcast=${path} active=true`);
                announced.append({ prefix: path, captures, kind: "announced", route });
              }
              break;
            }
            default:
              break;
          }
          const history = new AnnounceHistory();
          for (; ; ) {
            const announce = await race([
              decodeAnnounceBroadcastMaybe(stream.reader, this.version),
              announced.closed
            ]);
            if (!announce)
              break;
            if (announce instanceof Error)
              throw announce;
            let path;
            let active;
            let hops;
            let cost;
            switch (announce.status) {
              case "active": {
                const resolved = hasAnnounceId(this.version) ? history.start(announce) : announce;
                path = join(prefix, resolved.suffix);
                active = true;
                hops = resolved.hops;
                cost = announce.cost;
                break;
              }
              case "ended":
                path = join(prefix, announce.suffix);
                active = false;
                break;
              case "endedId":
                path = join(prefix, history.end(announce.id));
                active = false;
                break;
              case "restart": {
                const resolved = history.update(announce);
                path = join(prefix, resolved.suffix);
                active = true;
                hops = resolved.hops;
                cost = announce.cost;
                break;
              }
              case "skipped":
                continue;
            }
            const duplicateIsRestart = restartSupported(this.version) && !hasAnnounceId(this.version);
            if (announce.status === "active" && !duplicateIsRestart && advertised.has(path)) {
              throw new ProtocolViolation(`duplicate announce for ${path}`);
            }
            const retract = () => {
              const previous2 = advertised.get(path);
              advertised.delete(path);
              if (!previous2?.live)
                return;
              this.#consumes.evict(path);
              console.debug(`announced: broadcast=${path} active=false`);
              announced.append({
                prefix: path,
                captures: previous2.captures,
                kind: "retracted",
                route: previous2.route
              });
            };
            if (hops !== void 0) {
              const full = responderOrigin !== void 0 ? [...hops, responderOrigin] : hops;
              if (full.includes(this.hop)) {
                retract();
                advertised.set(path, {
                  publisher: void 0,
                  live: false,
                  route: { hops: full, cost: Cost.zero },
                  captures: void 0
                });
                continue;
              }
            }
            if (!active) {
              retract();
              continue;
            }
            const fullHops = stampHops(hops !== void 0 && responderOrigin !== void 0 ? [...hops, responderOrigin] : [...hops ?? []], this.#stamp);
            if (fullHops === void 0 || fullHops.length > MAX_HOPS) {
              console.debug(`announced: broadcast=${path} dropped (hop chain at MAX_HOPS)`);
              advertised.set(path, {
                publisher: void 0,
                live: false,
                route: { hops: [], cost: Cost.zero },
                captures: void 0
              });
              continue;
            }
            const publisher = fullHops[0];
            const route = { hops: fullHops, cost: cost ?? Cost.zero };
            const captures = scopeCaptures(scope, path);
            if (!visible(path)) {
              advertised.set(path, { publisher, live: false, route, captures });
              continue;
            }
            const previous = advertised.get(path);
            if (previous?.live) {
              if (previous.publisher !== publisher)
                this.#consumes.evict(path);
              advertised.set(path, { publisher, live: true, route, captures });
              console.debug(`announced: broadcast=${path} rerouted`);
              if (!routesEqual(previous.route, route)) {
                announced.append({ prefix: path, captures, kind: "updated", route });
              }
              continue;
            }
            advertised.set(path, { publisher, live: true, route, captures });
            console.debug(`announced: broadcast=${path} active=true`);
            announced.append({ prefix: path, captures, kind: "announced", route });
          }
          announced.close();
        } catch (err2) {
          const e5 = error(err2);
          stream.abort(e5);
          announced.close(e5);
          if (e5 instanceof ProtocolViolation) {
            this.#quic.close({ closeCode: PROTOCOL_VIOLATION_CODE, reason: closeReason(reason(e5)) });
          }
        }
      }
      /**
       * Consumes a broadcast from the connection.
       *
       * Deduplicated per path: repeat calls for the same still-live path share one reference-counted
       * broadcast (and one upstream subscription). The shared broadcast closes once every caller has
       * closed its handle, so callers close normally.
       *
       * @param name - The name of the broadcast to consume
       * @returns A Broadcast instance
       */
      consume(path) {
        return this.#consumes.get(path) ?? this.#consumes.insert(path, this.#createConsume(path));
      }
      #createConsume(path) {
        const consumer = new ConsumeBroadcast2(this, path);
        void (async () => {
          for (; ; ) {
            const request = await wireOf(consumer).requested();
            if (!request)
              break;
            void this.#runSubscribe(path, request);
          }
        })();
        return consumer;
      }
      async #runSubscribe(broadcast2, request) {
        const id = this.#subscribeNext++;
        const subscription = request.subscription;
        const initialBounds = groupBounds(subscription.groups);
        if (emptyRange({ startGroup: initialBounds.start, endGroup: initialBounds.end })) {
          request.reject(new Error(EMPTY_RANGE));
          return;
        }
        const timescale = new Signal(void 0);
        console.debug(`subscribe start: id=${id} broadcast=${broadcast2} track=${request.name}`);
        const bounds = groupBounds(subscription.groups);
        const msg = new Subscribe2({
          id,
          broadcast: broadcast2,
          track: request.name,
          priority: subscription.priority ?? 0,
          maxAge: subscription.maxAge,
          startGroup: subscription.groups?.start === void 0 ? void 0 : bounds.start,
          endGroup: inclusiveGroupEnd(bounds.end)
        });
        const state = {};
        const setup = this.#openSubscribe(state, msg, request, id, timescale);
        let opened;
        try {
          opened = await withTimeout(setup, SUBSCRIBE_SETUP_TIMEOUT_MS, `subscribe timed out after ${SUBSCRIBE_SETUP_TIMEOUT_MS}ms waiting for the first response (browser stream limit reached?)`);
          console.debug(`subscribe ok: id=${id} broadcast=${broadcast2} track=${request.name}`);
        } catch (err2) {
          const e5 = err2 instanceof TimeoutError ? controlTimeout(err2) : await sessionCause(this.#quic, err2);
          request.reject(e5);
          this.#subscribes.delete(id);
          console.warn(`subscribe error: id=${id} broadcast=${broadcast2} track=${request.name} error=${reason(e5)}`);
          setup.then(() => state.stream?.abort(e5), () => state.stream?.abort(e5));
          return;
        }
        const { stream, entry } = opened;
        const producer = entry.track;
        try {
          const responses = supportsTrackStream2(this.version) ? this.runResponses(stream, entry) : stream.reader.closed;
          const closed = responses.then(() => this.#settleTail(entry));
          closed.catch(() => {
          });
          const subscriptionUpdates = this.version === Version2.DRAFT_01 || this.version === Version2.DRAFT_02 ? void 0 : this.#runSubscriptionUpdates(id, broadcast2, entry, msg, stream);
          const terminal = [closed, producer.closed];
          if (subscriptionUpdates !== void 0)
            terminal.push(subscriptionUpdates.then(() => closed));
          const done = race(terminal);
          const idle = /* @__PURE__ */ Symbol("idle");
          for (; ; ) {
            const reason2 = await race([done, producer.unused().then(() => idle)]);
            if (reason2 === idle && producer.closed.peek() === void 0 && producer.used.peek())
              continue;
            break;
          }
          producer.close();
          stream.close();
          console.debug(`subscribe close: id=${id} broadcast=${broadcast2} track=${request.name}`);
        } catch (err2) {
          const e5 = await sessionCause(this.#quic, err2);
          producer.close(e5);
          console.warn(`subscribe error: id=${id} broadcast=${broadcast2} track=${request.name} error=${reason(e5)}`);
          stream.abort(e5);
        } finally {
          this.#subscribes.delete(id);
        }
      }
      // Determine the track's immutable properties, accept the request (so the
      // application's track.Subscriber resolves and incoming groups have a producer to
      // write into), register it, then open the subscribe stream. `state.stream` is
      // populated as soon as the subscribe stream opens so the caller can clean it up
      // on timeout even before this promise settles.
      //
      // On lite-05+ the properties come from a TRACK stream opened first, and the
      // SUBSCRIBE is accepted implicitly (no SUBSCRIBE_OK). Older drafts carry no
      // per-track properties, so they resolve to defaults and just drain SUBSCRIBE_OK.
      async #openSubscribe(state, msg, request, id, timescale) {
        let producer;
        let drainOk = false;
        if (supportsTrackStream2(this.version)) {
          const info = await this.#trackInfo(msg.broadcast, msg.track);
          producer = request.accept(this.#toModelInfo(info));
          timescale.set(info.timescale);
        } else {
          producer = request.accept();
          timescale.set(0);
          drainOk = true;
        }
        const entry = {
          track: producer,
          timescale,
          // The effective max age is the stopgap grace: the wrong clock (it bounds
          // presentation-time drift), but it is how long the subscriber was willing to wait
          // for a late group anyway. Already the smaller of the subscriber's and the track's.
          tail: new Tail({
            grace: () => {
              const maxAge = producer.subscription.peek()?.maxAge ?? Milli.zero;
              return maxAge > 0 ? maxAge : TAIL_GRACE_MS;
            }
          }),
          requested: msg.startGroup
        };
        this.#subscribes.set(id, entry);
        state.stream = await Stream2.open(this.#quic, { version: this.version });
        await state.stream.writer.u53(StreamId.Subscribe);
        await msg.encode(state.stream.writer, this.version);
        if (drainOk) {
          const resp = await decodeSubscribeResponse(state.stream.reader, this.version);
          if (!("ok" in resp)) {
            throw new Error("first subscribe response must be SUBSCRIBE_OK");
          }
        }
        return { stream: state.stream, entry };
      }
      // Opens a TRACK stream, reads the single TRACK_INFO, and FINs. Lite-05+ only.
      async #trackInfo(broadcast2, track) {
        return this.#exchange({ version: this.version }, async (stream) => {
          await stream.writer.u53(StreamId.Track);
          await new Track(broadcast2, track).encode(stream.writer, this.version);
          const info = await TrackInfo.decode(stream.reader, this.version);
          stream.close();
          return info;
        });
      }
      // Opens a stream and runs a request/response exchange on it, resetting the stream if `run`
      // fails. Subscriber.close() also resets it while `run` is pending, so a peer that never
      // answers cannot hold it open, and a stream that opens after the close is reset at once.
      async #exchange(options, run) {
        const closed = this.#closed.signal;
        closed.throwIfAborted();
        const stream = await Stream2.open(this.#quic, options);
        const abort = () => stream.abort(error(closed.reason));
        closed.addEventListener("abort", abort);
        try {
          closed.throwIfAborted();
          return await run(stream);
        } catch (err2) {
          stream.abort(error(err2));
          throw err2;
        } finally {
          closed.removeEventListener("abort", abort);
        }
      }
      // Map the wire TRACK_INFO onto the model track.Info a producer/consumer holds.
      #toModelInfo(info) {
        return {
          timescale: Timescale(info.timescale),
          // Publisher Max Age rides on the wire, so the local retention window
          // matches what the upstream advertises (relays re-serve with the same bound).
          maxAge: Milli(info.maxAge),
          priority: info.priority
        };
      }
      // Resolve a track's immutable model info via a TRACK stream (lite-05+), for the
      // ConsumeBroadcast backing track.Consumer.query(). On older drafts there's no TRACK
      // stream, so this rejects rather than fabricating defaults.
      async resolveTrackInfo(broadcast2, track) {
        if (!supportsTrackStream2(this.version)) {
          throw new Error("track info requires moq-lite-05 or newer");
        }
        return this.#toModelInfo(await this.#trackInfo(broadcast2, track));
      }
      // Open a FETCH stream for one group and stream its bare frames into a group, for the
      // ConsumeBroadcast backing track.Consumer.fetchGroup() (lite-05+).
      async fetchGroup(broadcast2, track, sequence, options = {}) {
        options.signal?.throwIfAborted();
        const key = JSON.stringify([broadcast2, track, sequence]);
        let entry = this.#fetches.get(key);
        let consumer;
        if (entry && !entry.group.isClosed) {
          consumer = entry.group.mirror();
        } else {
          const group = new Producer2(sequence);
          consumer = group.mirror();
          entry = { group, accepted: this.#runFetch(broadcast2, track, sequence, options.priority ?? 0, group) };
          this.#fetches.set(key, entry);
          void group.closed.then(() => {
            if (this.#fetches.get(key)?.group === group)
              this.#fetches.delete(key);
          });
        }
        try {
          await untilAborted(entry.accepted, options.signal);
          return consumer;
        } catch (err2) {
          consumer.close();
          throw err2;
        }
      }
      // Open the FETCH stream and pump the response into the shared group. Setup errors close the
      // group, evict the entry, and reject every caller waiting for acceptance. A setup every caller
      // has abandoned is cancelled the same way.
      async #runFetch(broadcast2, track, sequence, priority, group) {
        try {
          if (!supportsTrackStream2(this.version)) {
            throw new Error("fetch group requires moq-lite-05 or newer");
          }
          const setup = this.#fetchSetup(broadcast2, track, sequence, priority, group);
          let accepted;
          try {
            accepted = await untilAbandoned(group, setup);
          } catch (err2) {
            void setup.then(({ stream }) => stream.abort(error(err2)), () => void 0);
            throw err2;
          }
          void this.#runFetchResponse(accepted.stream, group, Timescale(accepted.info.timescale));
        } catch (err2) {
          group.close(error(err2));
          throw err2;
        }
      }
      // Resolve the track's timescale, then open the FETCH stream and wait for it to be accepted.
      // Closing the group during that wait resets the stream.
      async #fetchSetup(broadcast2, track, sequence, priority, group) {
        const info = await untilClosed(group, this.#trackInfo(broadcast2, track));
        return this.#exchange({ sendOrder: sendOrder({ priority }), version: this.version }, async (stream) => {
          await stream.writer.u53(StreamId.Fetch);
          await new Fetch2({ broadcast: broadcast2, track, priority, group: sequence }).encode(stream.writer, this.version);
          await untilClosed(group, stream.reader.done());
          return { stream, info };
        });
      }
      // Read the FETCH response (bare zigzag-delta-timestamped frames) into the group, then
      // FIN. A stream-level failure aborts the group so its reader observes the gap.
      async #runFetchResponse(stream, group, timescale) {
        try {
          const decode11 = frameDecoder(timescale);
          const idle = /* @__PURE__ */ Symbol("idle");
          let unused = group.unused().then(() => idle);
          let pending;
          for (; ; ) {
            let frame = pending === void 0 ? stream.reader.tryDecode(decode11) : void 0;
            if (!frame) {
              pending ??= stream.reader.decodeMaybe(decode11);
              const next = await race([pending, group.closed, unused]);
              if (next === idle) {
                if (group.isClosed)
                  break;
                if (group.used.peek()) {
                  unused = group.unused().then(() => idle);
                  continue;
                }
                throw new Stream(StreamCode.Cancel, { message: "cancel" });
              }
              pending = void 0;
              if (!next || next instanceof Error)
                break;
              frame = next;
            }
            group.writeFrame(frame);
          }
          group.close();
          stream.close();
        } catch (err2) {
          const e5 = error(err2);
          group.close(e5);
          stream.abort(e5);
        }
      }
      // Reads SUBSCRIBE_START/END/DROP on the subscribe stream until FIN (lite-05+), recording
      // the range the tail is accounted against. SUBSCRIBE_END declares the track's end right
      // away, so a consumer learns it before the last groups arrive. The publisher must declare
      // the end before FIN unless we cancelled locally; resets and malformed responses reject.
      async runResponses(stream, entry) {
        for (; ; ) {
          const resp = await decodeSubscribeResponseMaybe(stream.reader, this.version);
          if (!resp) {
            if (entry.end === void 0 && entry.track.closed.peek() === void 0)
              throw new ProtocolViolation("subscribe stream ended without SUBSCRIBE_END");
            return;
          }
          if ("start" in resp) {
            entry.start = resp.start.group;
            if (entry.requested !== void 0)
              entry.tail.account(entry.requested, entry.start);
          } else if ("end" in resp) {
            if (entry.end !== void 0)
              throw new ProtocolViolation("duplicate SUBSCRIBE_END");
            entry.end = resp.end.group;
            if (hasStreamCount(this.version))
              entry.streams = resp.end.streams;
            if (entry.track.closed.peek() !== void 0)
              continue;
            try {
              entry.track.finishAt(entry.end);
            } catch (err2) {
              if (this.version !== Version2.DRAFT_05) {
                throw new ProtocolViolation(`invalid SUBSCRIBE_END: ${reason(error(err2))}`);
              }
              console.warn(`invalid SUBSCRIBE_END: ${reason(error(err2))}`);
            }
          } else if ("drop" in resp) {
            entry.tail.account(resp.drop.start, resp.drop.end + 1);
          }
        }
      }
      // Wait for the group streams the publisher still owes once it has ended the subscription.
      //
      // lite-07 counts streams, so skipped sequences owe nothing. Older drafts account for
      // the range using received headers and SUBSCRIBE_DROP. A counted stream reset before
      // its header leaves no trace, so the grace still bounds that wait. Streams whose
      // headers arrived keep reading until their own FIN or reset.
      #settleTail(entry) {
        const { tail, track } = entry;
        const complete = () => {
          if (entry.streams !== void 0)
            return tail.streams >= entry.streams;
          if (entry.end === void 0)
            return false;
          if (entry.start === void 0)
            return true;
          const groups2 = track.subscription.peek()?.groups;
          const bounds = groupBounds(groups2 ?? {});
          const start = groups2?.start === void 0 ? entry.start : bounds.start;
          const end = bounds.end === void 0 ? entry.end : Math.min(entry.end, bounds.end);
          return tail.covers(start, end);
        };
        return tail.settle(complete, track.closed);
      }
      /**
       * Send SUBSCRIBE_UPDATE messages whenever the track's aggregate subscription changes.
       *
       * Resolves cleanly when the stream or track closes, so the caller can include
       * this in a race without leaving a dangling pending write that would
       * become an unhandled rejection if the user calls update after close.
       *
       * Peeks the signal at the top of every iteration so that updates which landed
       * before SubscribeOk arrived (or between iterations, before .next() registered
       * its listener) aren't lost.
       */
      async #runSubscriptionUpdates(id, broadcast2, entry, msg, stream) {
        const track = entry.track;
        const stopped = race([track.closed, stream.reader.closed]).then(() => null);
        let lastSent = {
          priority: msg.priority,
          maxAge: Milli(msg.maxAge),
          groups: {
            start: msg.startGroup === void 0 ? void 0 : { included: msg.startGroup },
            end: msg.endGroup === void 0 ? void 0 : { excluded: exclusiveGroupEnd(msg.endGroup) ?? 0 }
          }
        };
        for (; ; ) {
          const current = track.subscription.peek();
          if (current === void 0 || this.#sameSubscription(current, lastSent)) {
            const next = await race([track.subscription.changed(), stopped]);
            if (next === null)
              return;
            continue;
          }
          const bounds = groupBounds(current.groups);
          if (emptyRange({ startGroup: bounds.start, endGroup: bounds.end }))
            throw new Error(EMPTY_RANGE);
          if (current.groups?.start !== void 0) {
            const floor = lastSent.groups?.start === void 0 ? entry.start : groupBounds(lastSent.groups).start;
            entry.tail.demand(bounds.start, floor ?? Number.POSITIVE_INFINITY);
          }
          const update = new SubscribeUpdate2({
            priority: current.priority ?? 0,
            maxAge: current.maxAge,
            startGroup: current.groups?.start === void 0 ? void 0 : bounds.start,
            endGroup: inclusiveGroupEnd(bounds.end)
          });
          await update.encode(stream.writer, this.version);
          lastSent = { ...current };
          console.debug(`subscribe update: id=${id} broadcast=${broadcast2} track=${track.name}`);
        }
      }
      #sameSubscription(a2, b3) {
        const ag = groupBounds(a2.groups);
        const bg = groupBounds(b3.groups);
        const sameStart = resolvesStart(this.version) || a2.groups?.start === void 0 === (b3.groups?.start === void 0);
        return (a2.priority ?? 0) === (b3.priority ?? 0) && (a2.maxAge ?? 0) === (b3.maxAge ?? 0) && sameStart && ag.start === bg.start && ag.end === bg.end;
      }
      /**
       * Handles a group message.
       * @param group - The group message
       * @param stream - The stream to read frames from
       *
       * @internal
       */
      async runGroup(group, stream) {
        const entry = this.#subscribes.get(group.subscribe);
        if (!entry) {
          if (group.subscribe >= this.#subscribeNext) {
            throw new Error(`unknown subscription: id=${group.subscribe}`);
          }
          return;
        }
        const { track, timescale, tail } = entry;
        const producer = new Producer2(group.sequence);
        const read2 = tail.open(group.sequence);
        try {
          if (entry.end !== void 0 && group.sequence >= entry.end && this.version !== Version2.DRAFT_05) {
            const violation = new ProtocolViolation(`group ${group.sequence} is at or past the declared end ${entry.end}`);
            track.close(violation);
            throw violation;
          }
          track.writeGroup(producer);
          let scale = timescale.peek();
          while (scale === void 0) {
            if (track.closed.peek() !== void 0) {
              producer.close();
              stream.stop(new Stream(StreamCode.Cancel, { message: "cancel" }));
              return;
            }
            await Signal.race(timescale, track.closed);
            scale = timescale.peek();
          }
          await readFrames(stream, producer, scale);
          producer.close();
          stream.stop(new Stream(StreamCode.Cancel, { message: "cancel" }));
        } catch (err2) {
          const e5 = await sessionCause(this.#quic, err2);
          producer.close(e5);
          stream.stop(e5);
        } finally {
          read2();
        }
      }
      /**
       * Receives QUIC datagrams and routes each to its subscription's track producer (lite-05 §6.4).
       *
       * Returns immediately on a non-datagram transport or pre-lite-05 version. A decode error or an
       * unknown subscribe id drops that datagram without tearing down the session (best-effort); the
       * loop ends only when the datagram stream closes.
       *
       * @internal
       */
      async runDatagrams() {
        if (!hasDatagrams(this.version) || maxDatagramSize(this.#quic) === 0) {
          return;
        }
        const reader = datagramReader(this.#quic);
        if (!reader)
          return;
        try {
          try {
            for (; ; ) {
              const { value, done } = await reader.read();
              if (done)
                break;
              if (!value)
                continue;
              try {
                await this.#routeDatagram(value);
              } catch (err2) {
                console.debug(`dropping datagram: ${reason(err2)}`);
              }
            }
          } finally {
            reader.releaseLock();
          }
        } catch (err2) {
          const e5 = error(err2);
          if (e5.message === "The session is closed.") {
            console.debug(`datagram receive stopped: ${e5.message}`);
          } else {
            console.warn("datagram stream error", err2);
          }
        }
      }
      // Decode one datagram body and hand it to the matching subscription's producer. Drops the
      // datagram (best-effort) if the subscription is unknown/closed or its timescale isn't resolved.
      async #routeDatagram(payload) {
        const dg = await Datagram.decode(payload, this.version);
        const entry = this.#subscribes.get(dg.subscribe);
        if (!entry)
          return;
        const scale = entry.timescale.peek();
        if (!scale)
          return;
        const timestamp = new Timestamp(dg.timestamp, Timescale(scale));
        entry.tail.account(dg.sequence, dg.sequence + 1);
        entry.track.insertDatagram(dg.sequence, timestamp, dg.payload);
      }
      /**
       * Opens a PROBE bidi stream to receive bandwidth estimates from the publisher.
       * Returns immediately if recv bandwidth is not supported.
       *
       * Probe is best-effort telemetry: a stream-level failure (peer reset, FIN,
       * missing peer support, transport hiccup) is caught and logged, never
       * propagated to the connection. On exit the bandwidth/RTT signals are
       * cleared so consumers see them as stale.
       *
       * @internal
       */
      // Await the peer's advertised probe level, blocking until its SETUP arrives. The peer
      // MUST send exactly one SETUP, so this resolves once that stream is read.
      async #peerProbeLevel(peerSetup) {
        let setup = peerSetup.peek();
        while (setup === void 0) {
          setup = await peerSetup.changed();
        }
        return setup.probe;
      }
      async runProbe() {
        if (!this.#probe)
          return;
        if (this.version === Version2.DRAFT_01 || this.version === Version2.DRAFT_02)
          return;
        if (this.#peerSetup) {
          const probe = await this.#peerProbeLevel(this.#peerSetup);
          if (probe < ProbeLevel.Report)
            return;
        }
        try {
          const stream = await Stream2.open(this.#quic, { version: this.version });
          await stream.writer.u53(StreamId.Probe);
          for (; ; ) {
            const probe = await Probe.decodeMaybe(stream.reader, this.version);
            if (!probe)
              break;
            const prev = this.#probe.peek();
            const rtt = probe.rtt !== void 0 ? Milli(probe.rtt) : void 0;
            this.#probe.set({
              // `undefined` is the peer reporting "unknown", not an estimate of
              // zero; letting it through would become a real 0 bps ABR target.
              estimatedRecvRate: probe.bitrate,
              rtt: hasProbeRtt(this.version) ? rtt : rtt ?? prev.rtt
            });
          }
        } catch (err2) {
          if (!this.#closed.signal.aborted) {
            console.warn("probe stream error", err2);
          }
        } finally {
          this.#probe.set({});
        }
      }
      /**
       * Ends every subscribed track: cleanly for a deliberate close, or with `err` when the
       * session died, since those tracks were cut off rather than ended.
       */
      close(err2) {
        const cut = err2 ?? new Stream(StreamCode.SessionClosed, { message: "session closed" });
        this.#closed.abort(cut);
        for (const { track } of this.#subscribes.values()) {
          track.close(err2);
        }
        this.#subscribes.clear();
        for (const { group } of this.#fetches.values()) {
          group.close(cut);
        }
      }
    };
    ConsumeBroadcast2 = class _ConsumeBroadcast extends Consumer4 {
      #subscriber;
      #path;
      constructor(subscriber, path, state) {
        super(state);
        overrideBroadcastWire(this, {
          resolveTrackInfo: (name) => subscriber.resolveTrackInfo(path, name),
          fetchGroup: (name, sequence, options) => subscriber.fetchGroup(path, name, sequence, options)
        });
        this.#subscriber = subscriber;
        this.#path = path;
      }
      // Preserve the subclass (and its wire-backed info/fetchGroup) when the consume cache shares
      // this broadcast across callers.
      clone() {
        return new _ConsumeBroadcast(this.#subscriber, this.#path, this.shareState());
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/connection.js
async function probeLevel(quic, version2) {
  const getStats = quic.getStats;
  if (typeof getStats !== "function")
    return ProbeLevel.None;
  let stats;
  try {
    stats = await getStats.call(quic);
  } catch {
    return ProbeLevel.None;
  }
  const rtt = hasProbeRtt(version2) ? stats.smoothedRtt : void 0;
  return stats.estimatedSendRate != null || rtt != null ? ProbeLevel.Report : ProbeLevel.None;
}
var Connection2;
var init_connection2 = __esm({
  "../../node_modules/@moq/net/lite/connection.js"() {
    init_signals();
    init_stats();
    init_transport();
    init_error2();
    init_hop();
    init_stream();
    init_wire();
    init_announce2();
    init_fetch2();
    init_goaway2();
    init_group2();
    init_publisher2();
    init_session2();
    init_setup2();
    init_stream3();
    init_subscribe2();
    init_subscriber2();
    init_track3();
    init_version2();
    Connection2 = class {
      // The URL of the connection.
      url;
      // The version of the connection as a human-readable string.
      version;
      // The wire transport this session runs over.
      transport;
      /** Whether the relay supports broadcast discovery; see {@link Established.discovery}. */
      discovery;
      // The version used for encoding/decoding.
      #version;
      // The established WebTransport session.
      #quic;
      // Use to receive/send session messages.
      #session;
      // Module for contributing tracks.
      #publisher;
      // Module for distributing tracks.
      #subscriber;
      /** The peer's PROBE estimates; see {@link Established.probe}. */
      probe;
      /** Random per-connection Hop ID. Shared by Publisher (for outbound hop
       * chains) and Subscriber (available for optional self-filtering on announces). */
      hop;
      // The peer's SETUP, recorded once its Setup stream is read (lite-05+). Streams whose
      // encoding depends on a negotiated capability (e.g. PROBE) wait on this. undefined
      // until the peer's SETUP arrives; stays undefined forever on older drafts.
      #peerSetup = new Signal(void 0);
      // Mirrors the role out of #peerSetup, so the public surface exposes the peer's declared
      // direction without handing out the whole SETUP (whose probe level gates our own streams).
      #peerRole = new Signal(void 0);
      // Written by the Subscriber as PROBE messages arrive.
      #probe = new Signal({});
      // The peer's GOAWAY. Lite carries no deadline, so only the URI is set.
      #goaway = new Once();
      /**
       * The {@link Role} the peer advertised in its SETUP, for a server deciding whether the
       * peer's authorization grants the direction it intends to use.
       *
       * `undefined` until the peer's SETUP arrives, and forever on pre-lite-05 versions, which
       * carry no in-band role. {@link Role.Both} is the absence of the parameter, so it is what
       * a peer reports when it declines to declare a direction, sends a value we don't
       * recognize, or is a server (which never sends one).
       */
      get peerRole() {
        return this.#peerRole;
      }
      /**
       * Creates a new Connection instance.
       *
       * @internal
       */
      constructor({ url: url2, quic, version: version2, session, discovery = true, publish: publish5, hop }) {
        this.url = url2;
        this.#quic = quic;
        this.#session = session;
        if (session) {
          session.reader.version = version2;
          session.writer.version = version2;
        }
        this.version = versionName2(version2);
        this.#version = version2;
        this.transport = transportOf(quic);
        this.discovery = discovery;
        this.probe = this.#probe;
        this.hop = hop ?? randomHop();
        this.#publisher = new Publisher2(this.#quic, this.#version, this.hop, publish5);
        this.#subscriber = new Subscriber3(this.#quic, this.#version, this.hop, this.#probe, this.#peerSetup);
        this.goaway = this.#goaway;
        this.admitted = hasSetupStream(version2) ? this.#peerSetup.changed().then(() => true) : Promise.resolve(true);
        registerWire(this, { consume: (path) => this.#subscriber.consume(path), goaway: this.#goaway });
        void this.#run();
      }
      /**
       * Closes the connection.
       */
      close() {
        this.#publisher.close();
        this.#subscriber.close();
        try {
          this.#quic.close();
        } catch {
        }
      }
      async #run() {
        const tasks = [this.#runSession(), this.#runBidis(), this.#runUnis()];
        if (hasSetupStream(this.#version)) {
          tasks.push(this.#sendSetup());
        }
        tasks.push(this.#subscriber.runProbe());
        if (hasDatagrams(this.#version)) {
          tasks.push(this.#subscriber.runDatagrams());
        }
        let fatal;
        try {
          await Promise.all(tasks);
        } catch (err2) {
          console.error("fatal error running connection", err2);
          fatal = await sessionCause(this.#quic, err2);
        } finally {
          this.#subscriber.close(fatal ?? await closeError(this.#quic));
          this.close();
        }
      }
      announced(scope, options) {
        return this.#subscriber.announced(scope, options);
      }
      async #runSession() {
        if (!this.#session) {
          return;
        }
        try {
          for (; ; ) {
            const msg = await SessionInfo.decodeMaybe(this.#session.reader, this.#version);
            if (!msg)
              break;
          }
        } finally {
          console.debug("session stream closed");
        }
      }
      // Open the unidirectional Setup Stream, send our single SETUP, and FIN (lite-05+).
      // The browser uses WebTransport, which carries the request URI, so we advertise no
      // path and leave routing to the URL. The probe level reflects what this transport
      // can actually measure; we never pad, so we never advertise Increase.
      // Role stays Both: the publish origin starts empty and fills later, and consume is
      // called after this point, so there is nothing to narrow yet. The origin declares
      // our session identity so the peer can filter
      // reflected announcements (lite-06 removed ANNOUNCE_REQUEST's exclude_hop for it).
      async #sendSetup() {
        const writer = await Writer.open(this.#quic, { version: this.#version });
        try {
          await writer.u53(DataType.Setup);
          const probe = await probeLevel(this.#quic, this.#version);
          await new Setup2({ probe, hop: this.hop }).encode(writer, this.#version);
          writer.close();
        } catch (err2) {
          writer.reset(err2);
          throw err2;
        }
      }
      async #runBidis() {
        for (; ; ) {
          const stream = await Stream2.accept(this.#quic, this.#version);
          if (!stream)
            break;
          this.#runBidi(stream).catch((err2) => {
            stream.writer.reset(err2);
            if (err2 instanceof ProtocolViolation)
              this.close();
          }).finally(() => {
            stream.writer.close();
          });
        }
      }
      async #runBidi(stream) {
        const typ = await stream.reader.u53();
        if (typ === StreamId.Session) {
          throw new Error("duplicate session stream");
        } else if (typ === StreamId.Announce) {
          const msg = await AnnounceRequest.decode(stream.reader, this.#version);
          await this.#publisher.runAnnounce(msg, stream);
        } else if (typ === StreamId.Subscribe) {
          const msg = await Subscribe2.decode(stream.reader, this.#version);
          await this.#publisher.runSubscribe(msg, stream);
        } else if (typ === StreamId.Fetch) {
          const msg = await Fetch2.decode(stream.reader, this.#version);
          await this.#publisher.runFetch(msg, stream);
        } else if (typ === StreamId.Track) {
          const msg = await Track.decode(stream.reader, this.#version);
          await this.#publisher.runTrackInfo(msg, stream);
        } else if (typ === StreamId.Probe) {
          await this.#publisher.runProbe(stream);
        } else if (typ === StreamId.Goaway) {
          const msg = await Goaway.decode(stream.reader, this.#version);
          if (this.#goaway.peek() !== void 0)
            throw new ProtocolViolation("duplicate GOAWAY");
          this.#goaway.set({ uri: msg.uri });
        } else {
          throw new Error(`unknown stream type: ${typ.toString()}`);
        }
      }
      async #runUnis() {
        const readers = new Readers(this.#quic, this.#version);
        for (; ; ) {
          const stream = await readers.next();
          if (!stream)
            break;
          this.#runUni(stream).then(() => {
            stream.stop(new Stream(StreamCode.Cancel, { message: "cancel" }));
          }).catch((err2) => {
            stream.stop(err2);
          });
        }
      }
      async #runUni(stream) {
        const typ = await stream.u53();
        if (typ === DataType.Group) {
          const msg = await Group2.decode(stream, this.#version);
          await this.#subscriber.runGroup(msg, stream);
        } else if (typ === DataType.Setup) {
          const setup = await Setup2.decode(stream, this.#version);
          this.#peerSetup.set(setup);
          this.#peerRole.set(setup.role);
        } else {
          throw new Error(`unknown stream type: ${typ.toString()}`);
        }
      }
      /** Snapshot the transport's counters; see {@link Established.stats}. */
      async stats() {
        return transportStats(this.#quic);
      }
      /** Resolves when the session closes, decoding the peer's close code; see {@link Established.closed}. */
      get closed() {
        return this.#quic.closed.then(fromClose, (err2) => error(err2));
      }
    };
  }
});

// ../../node_modules/@moq/net/lite/index.js
var init_lite = __esm({
  "../../node_modules/@moq/net/lite/index.js"() {
    init_announce2();
    init_connection2();
    init_datagram();
    init_fetch2();
    init_goaway2();
    init_group2();
    init_probe();
    init_session2();
    init_setup2();
    init_stream3();
    init_subscribe2();
    init_track3();
    init_version2();
  }
});

// ../../node_modules/@moq/net/connection/forward.js
function forwardAnnounced(conn, origin) {
  const originWire = wireOf(origin);
  let detach = originWire.attach(conn.discovery);
  let dead = false;
  let discovering = conn.discovery;
  void conn.closed.then(() => {
    dead = true;
    detach();
  });
  void serveRequests(conn, origin);
  if (!conn.discovery) {
    console.warn("relay does not support broadcast discovery; broadcasts resolve on request only.");
    return;
  }
  for (const prefix of originWire.interests()) {
    const announced = conn.announced(Pattern.subtree(prefix), { hidden: true });
    const inserted = /* @__PURE__ */ new Map();
    void conn.closed.then(() => announced.close());
    void (async () => {
      let failure2;
      try {
        for (; ; ) {
          const event = await announced.next();
          if (!event)
            break;
          if (!originWire.accepts(event.prefix))
            continue;
          if (isActive(event.kind)) {
            const existing = inserted.get(event.prefix);
            if (existing) {
              existing.update(event.route);
            } else {
              const handle = originWire.receive(event.prefix, event.route);
              inserted.set(event.prefix, handle);
              void drive(handle, conn);
            }
          } else {
            const handle = inserted.get(event.prefix);
            inserted.delete(event.prefix);
            handle?.close();
          }
        }
      } catch (err2) {
        failure2 = err2;
      } finally {
        for (const handle of inserted.values())
          handle.close();
        inserted.clear();
        announced.close();
        if (!dead && discovering) {
          discovering = false;
          console.warn("broadcast discovery failed; broadcasts resolve on request only.", failure2);
          detach();
          detach = originWire.attach(false);
        }
      }
    })();
  }
}
async function drive(handle, conn) {
  const session = wireOf(conn);
  try {
    for await (const request of handle.requested()) {
      request.accept(session.consume(request.path));
    }
  } catch {
    handle.close();
  }
}
async function serveRequests(conn, origin) {
  const table = wireOf(origin);
  const session = wireOf(conn);
  const answered = /* @__PURE__ */ new Map();
  let dead = false;
  const closed = conn.closed.then(() => {
    dead = true;
  });
  for (; ; ) {
    const map = table.requests.peek();
    if (!map || dead)
      break;
    for (const [path, slot2] of map) {
      if (slot2.blind === 0)
        continue;
      if (answered.get(path)?.slot === slot2 || slot2.answer !== void 0)
        continue;
      if (table.routes(path))
        continue;
      const withdraw = table.answer(path, session.consume(path));
      if (withdraw)
        answered.set(path, { slot: slot2, withdraw });
    }
    for (const [path, entry] of [...answered]) {
      if (map.get(path) === entry.slot && entry.slot.blind > 0)
        continue;
      answered.delete(path);
      entry.withdraw();
    }
    await race([table.changed(), closed]);
  }
  for (const { withdraw } of answered.values()) {
    withdraw();
  }
  answered.clear();
}
var init_forward = __esm({
  "../../node_modules/@moq/net/connection/forward.js"() {
    init_signals();
    init_announced();
    init_path();
    init_wire();
  }
});

// ../../node_modules/@moq/net/connection/handshake.js
async function exchangeSetup(transport, version2, implementation) {
  const encoder2 = new TextEncoder();
  const params = new SetupOptions();
  params.setBytes(SetupOption.Implementation, encoder2.encode(implementation));
  solicitIntoSetup(params);
  hiddenIntoSetup(params);
  const self2 = randomHop();
  cluster_exports.intoSetup(params, self2, version2);
  const setupMsg = new Setup({ parameters: params });
  const [writer, received3] = await Promise.all([
    sendSetup(transport, version2, setupMsg),
    receiveSetup(transport, version2)
  ]);
  return {
    control: new Stream2({ writer, reader: received3.reader }),
    early: received3.early,
    solicit: received3.solicit,
    hidden: received3.hidden,
    cluster: { self: self2, peer: received3.cluster }
  };
}
async function sendSetup(transport, version2, setupMsg) {
  const writer = await Writer.open(transport, { version: version2 });
  await writer.u53(Setup.id);
  await setupMsg.encode(writer, version2);
  return writer;
}
async function receiveSetup(transport, version2) {
  const uniReader = transport.incomingUnidirectionalStreams.getReader();
  const early = [];
  let reader;
  try {
    for (; ; ) {
      const next = await uniReader.read();
      if (next.done)
        throw new Error("no incoming uni stream for SETUP");
      const stream = new Reader(next.value, void 0, version2);
      if (await stream.done().catch(() => true))
        continue;
      const streamType = await stream.peekU62().catch((err2) => {
        if (err2 instanceof Stream || err2 instanceof UnexpectedEnd)
          return void 0;
        throw err2;
      });
      if (streamType === void 0)
        continue;
      if (streamType === BigInt(Setup.id)) {
        reader = stream;
        break;
      }
      early.push(stream);
    }
  } finally {
    uniReader.releaseLock();
  }
  await reader.u53();
  const setup = await Setup.decode(reader, version2);
  return {
    reader,
    early,
    solicit: solicitFromSetup(setup.parameters),
    hidden: hiddenFromSetup(setup.parameters),
    cluster: cluster_exports.fromSetup(setup.parameters, version2)
  };
}
var init_handshake = __esm({
  "../../node_modules/@moq/net/connection/handshake.js"() {
    init_error2();
    init_hop();
    init_ietf();
    init_stream();
  }
});

// ../../node_modules/@moq/net/connection/accept.js
async function accept({ transport, url: url2, ...props }) {
  const connection = await acceptInner(transport, url2, props);
  if (props.consume)
    forwardAnnounced(connection, props.consume);
  return connection;
}
async function acceptInner(transport, url2, props) {
  const protocol = transport.protocol;
  const wiring = {
    discovery: props.discovery ?? true,
    publish: props.publish
  };
  if (protocol === ALPN.DRAFT_22) {
    return acceptAlpn(transport, url2, Version.DRAFT_22, wiring);
  }
  if (protocol === ALPN.DRAFT_21) {
    return acceptAlpn(transport, url2, Version.DRAFT_21, wiring);
  }
  if (protocol === ALPN.DRAFT_20) {
    return acceptAlpn(transport, url2, Version.DRAFT_20, wiring);
  }
  if (protocol === ALPN.DRAFT_19) {
    return acceptAlpn(transport, url2, Version.DRAFT_19, wiring);
  } else if (protocol === ALPN.DRAFT_18) {
    return acceptAlpn(transport, url2, Version.DRAFT_18, wiring);
  } else if (protocol === ALPN.DRAFT_17) {
    return acceptAlpn(transport, url2, Version.DRAFT_17, wiring);
  } else if (protocol === ALPN.DRAFT_16) {
    return acceptSetup(transport, url2, Version.DRAFT_16, wiring);
  } else if (protocol === ALPN.DRAFT_15) {
    return acceptSetup(transport, url2, Version.DRAFT_15, wiring);
  } else if (protocol === ALPN_07_WIP) {
    return new Connection2({ url: url2, quic: transport, version: Version2.DRAFT_07, ...wiring });
  } else if (protocol === ALPN_06) {
    return new Connection2({ url: url2, quic: transport, version: Version2.DRAFT_06, ...wiring });
  } else if (protocol === ALPN_05) {
    return new Connection2({ url: url2, quic: transport, version: Version2.DRAFT_05, ...wiring });
  } else if (protocol === ALPN_04) {
    return new Connection2({ url: url2, quic: transport, version: Version2.DRAFT_04, ...wiring });
  } else if (protocol === ALPN_03) {
    return new Connection2({ url: url2, quic: transport, version: Version2.DRAFT_03, ...wiring });
  } else if (protocol === ALPN2 || protocol === "" || protocol === void 0) {
    return acceptNegotiated(transport, url2, wiring, props.version);
  } else {
    throw new Error(`unsupported WebTransport protocol: ${protocol}`);
  }
}
async function acceptAlpn(transport, url2, version2, wiring) {
  const { control, early, solicit, hidden, cluster } = await exchangeSetup(transport, version2, "moq-lite-js");
  return new Connection({
    ...wiring,
    client: false,
    url: url2,
    quic: transport,
    control,
    early,
    solicit,
    hidden,
    cluster,
    // v17+ uses NativeSession which manages its own request IDs; maxRequestId is unused.
    maxRequestId: 0n,
    version: version2
  });
}
async function acceptSetup(transport, url2, version2, wiring) {
  const stream = await Stream2.accept(transport, version2);
  if (!stream)
    throw new Error("no incoming bidi stream for SETUP");
  const clientCompat = await stream.reader.u53();
  if (clientCompat !== StreamId.ClientCompat) {
    throw new Error(`unexpected client message type: 0x${clientCompat.toString(16)}`);
  }
  const client = await ClientSetup.decode(stream.reader, version2);
  await stream.writer.u53(StreamId.ServerCompat);
  const encoder2 = new TextEncoder();
  const params = new SetupOptions();
  params.setVarint(SetupOption.MaxRequestId, 42069n);
  params.setBytes(SetupOption.Implementation, encoder2.encode("moq-lite-js"));
  solicitIntoSetup(params);
  hiddenIntoSetup(params);
  const server = new ServerSetup({ version: version2, parameters: params });
  await server.encode(stream.writer, version2);
  const maxRequestId = 42069n;
  return new Connection({
    ...wiring,
    client: false,
    url: url2,
    quic: transport,
    control: stream,
    maxRequestId,
    version: version2,
    solicit: solicitFromSetup(client.parameters),
    hidden: hiddenFromSetup(client.parameters)
  });
}
async function acceptNegotiated(transport, url2, wiring, version2) {
  const setupVersion = Version.DRAFT_14;
  const stream = await Stream2.accept(transport, setupVersion);
  if (!stream)
    throw new Error("no incoming bidi stream for SETUP");
  const clientCompat = await stream.reader.u53();
  if (clientCompat !== StreamId.ClientCompat) {
    throw new Error(`unexpected client message type: 0x${clientCompat.toString(16)}`);
  }
  const client = await ClientSetup.decode(stream.reader, setupVersion);
  const allVersions = [...Object.values(Version2), ...Object.values(Version)];
  let selectedVersion;
  if (version2 !== void 0) {
    selectedVersion = version2;
  } else {
    const match = client.versions.find((v3) => allVersions.includes(v3));
    if (match === void 0) {
      throw new Error(`no common version found; client offered: ${client.versions.map((v3) => v3.toString(16)).join(", ")}`);
    }
    selectedVersion = match;
  }
  await stream.writer.u53(StreamId.ServerCompat);
  const encoder2 = new TextEncoder();
  const params = new SetupOptions();
  params.setVarint(SetupOption.MaxRequestId, 42069n);
  params.setBytes(SetupOption.Implementation, encoder2.encode("moq-lite-js"));
  solicitIntoSetup(params);
  hiddenIntoSetup(params);
  const server = new ServerSetup({ version: selectedVersion, parameters: params });
  await server.encode(stream.writer, setupVersion);
  if (Object.values(Version2).includes(selectedVersion)) {
    return new Connection2({
      url: url2,
      quic: transport,
      version: selectedVersion,
      session: stream,
      ...wiring
    });
  } else if (Object.values(Version).includes(selectedVersion)) {
    const maxRequestId = client.parameters.getVarint(SetupOption.MaxRequestId) ?? 0n;
    return new Connection({
      ...wiring,
      client: false,
      url: url2,
      quic: transport,
      control: stream,
      maxRequestId,
      version: selectedVersion,
      solicit: solicitFromSetup(client.parameters),
      hidden: hiddenFromSetup(client.parameters)
    });
  } else {
    throw new Error(`unsupported version: ${selectedVersion.toString(16)}`);
  }
}
var init_accept = __esm({
  "../../node_modules/@moq/net/connection/accept.js"() {
    init_ietf();
    init_lite();
    init_stream();
    init_forward();
    init_handshake();
  }
});

// ../../node_modules/bowser/es5.js
var require_es5 = __commonJS({
  "../../node_modules/bowser/es5.js"(exports, module) {
    !(function(e5, t) {
      "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.bowser = t() : e5.bowser = t();
    })(exports, (function() {
      return (function(e5) {
        var t = {};
        function r2(i2) {
          if (t[i2]) return t[i2].exports;
          var n2 = t[i2] = { i: i2, l: false, exports: {} };
          return e5[i2].call(n2.exports, n2, n2.exports, r2), n2.l = true, n2.exports;
        }
        return r2.m = e5, r2.c = t, r2.d = function(e6, t2, i2) {
          r2.o(e6, t2) || Object.defineProperty(e6, t2, { enumerable: true, get: i2 });
        }, r2.r = function(e6) {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e6, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(e6, "__esModule", { value: true });
        }, r2.t = function(e6, t2) {
          if (1 & t2 && (e6 = r2(e6)), 8 & t2) return e6;
          if (4 & t2 && "object" == typeof e6 && e6 && e6.__esModule) return e6;
          var i2 = /* @__PURE__ */ Object.create(null);
          if (r2.r(i2), Object.defineProperty(i2, "default", { enumerable: true, value: e6 }), 2 & t2 && "string" != typeof e6) for (var n2 in e6) r2.d(i2, n2, function(t3) {
            return e6[t3];
          }.bind(null, n2));
          return i2;
        }, r2.n = function(e6) {
          var t2 = e6 && e6.__esModule ? function() {
            return e6.default;
          } : function() {
            return e6;
          };
          return r2.d(t2, "a", t2), t2;
        }, r2.o = function(e6, t2) {
          return Object.prototype.hasOwnProperty.call(e6, t2);
        }, r2.p = "", r2(r2.s = 90);
      })({ 17: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2 = r2(18), n2 = (function() {
          function e6() {
          }
          return e6.getFirstMatch = function(e7, t2) {
            var r3 = t2.match(e7);
            return r3 && r3.length > 0 && r3[1] || "";
          }, e6.getSecondMatch = function(e7, t2) {
            var r3 = t2.match(e7);
            return r3 && r3.length > 1 && r3[2] || "";
          }, e6.matchAndReturnConst = function(e7, t2, r3) {
            if (e7.test(t2)) return r3;
          }, e6.getWindowsVersionName = function(e7) {
            switch (e7) {
              case "NT":
                return "NT";
              case "XP":
                return "XP";
              case "NT 5.0":
                return "2000";
              case "NT 5.1":
                return "XP";
              case "NT 5.2":
                return "2003";
              case "NT 6.0":
                return "Vista";
              case "NT 6.1":
                return "7";
              case "NT 6.2":
                return "8";
              case "NT 6.3":
                return "8.1";
              case "NT 10.0":
                return "10";
              default:
                return;
            }
          }, e6.getMacOSVersionName = function(e7) {
            var t2 = e7.split(".").splice(0, 2).map((function(e8) {
              return parseInt(e8, 10) || 0;
            }));
            t2.push(0);
            var r3 = t2[0], i3 = t2[1];
            if (10 === r3) switch (i3) {
              case 5:
                return "Leopard";
              case 6:
                return "Snow Leopard";
              case 7:
                return "Lion";
              case 8:
                return "Mountain Lion";
              case 9:
                return "Mavericks";
              case 10:
                return "Yosemite";
              case 11:
                return "El Capitan";
              case 12:
                return "Sierra";
              case 13:
                return "High Sierra";
              case 14:
                return "Mojave";
              case 15:
                return "Catalina";
              default:
                return;
            }
            switch (r3) {
              case 11:
                return "Big Sur";
              case 12:
                return "Monterey";
              case 13:
                return "Ventura";
              case 14:
                return "Sonoma";
              case 15:
                return "Sequoia";
              default:
                return;
            }
          }, e6.getAndroidVersionName = function(e7) {
            var t2 = e7.split(".").splice(0, 2).map((function(e8) {
              return parseInt(e8, 10) || 0;
            }));
            if (t2.push(0), !(1 === t2[0] && t2[1] < 5)) return 1 === t2[0] && t2[1] < 6 ? "Cupcake" : 1 === t2[0] && t2[1] >= 6 ? "Donut" : 2 === t2[0] && t2[1] < 2 ? "Eclair" : 2 === t2[0] && 2 === t2[1] ? "Froyo" : 2 === t2[0] && t2[1] > 2 ? "Gingerbread" : 3 === t2[0] ? "Honeycomb" : 4 === t2[0] && t2[1] < 1 ? "Ice Cream Sandwich" : 4 === t2[0] && t2[1] < 4 ? "Jelly Bean" : 4 === t2[0] && t2[1] >= 4 ? "KitKat" : 5 === t2[0] ? "Lollipop" : 6 === t2[0] ? "Marshmallow" : 7 === t2[0] ? "Nougat" : 8 === t2[0] ? "Oreo" : 9 === t2[0] ? "Pie" : void 0;
          }, e6.getVersionPrecision = function(e7) {
            return e7.split(".").length;
          }, e6.compareVersions = function(t2, r3, i3) {
            void 0 === i3 && (i3 = false);
            var n3 = e6.getVersionPrecision(t2), a2 = e6.getVersionPrecision(r3), o = Math.max(n3, a2), s = 0, u2 = e6.map([t2, r3], (function(t3) {
              var r4 = o - e6.getVersionPrecision(t3), i4 = t3 + new Array(r4 + 1).join(".0");
              return e6.map(i4.split("."), (function(e7) {
                return new Array(20 - e7.length).join("0") + e7;
              })).reverse();
            }));
            for (i3 && (s = o - Math.min(n3, a2)), o -= 1; o >= s; ) {
              if (u2[0][o] > u2[1][o]) return 1;
              if (u2[0][o] === u2[1][o]) {
                if (o === s) return 0;
                o -= 1;
              } else if (u2[0][o] < u2[1][o]) return -1;
            }
          }, e6.map = function(e7, t2) {
            var r3, i3 = [];
            if (Array.prototype.map) return Array.prototype.map.call(e7, t2);
            for (r3 = 0; r3 < e7.length; r3 += 1) i3.push(t2(e7[r3]));
            return i3;
          }, e6.find = function(e7, t2) {
            var r3, i3;
            if (Array.prototype.find) return Array.prototype.find.call(e7, t2);
            for (r3 = 0, i3 = e7.length; r3 < i3; r3 += 1) {
              var n3 = e7[r3];
              if (t2(n3, r3)) return n3;
            }
          }, e6.assign = function(e7) {
            for (var t2, r3, i3 = e7, n3 = arguments.length, a2 = new Array(n3 > 1 ? n3 - 1 : 0), o = 1; o < n3; o++) a2[o - 1] = arguments[o];
            if (Object.assign) return Object.assign.apply(Object, [e7].concat(a2));
            var s = function() {
              var e8 = a2[t2];
              "object" == typeof e8 && null !== e8 && Object.keys(e8).forEach((function(t3) {
                i3[t3] = e8[t3];
              }));
            };
            for (t2 = 0, r3 = a2.length; t2 < r3; t2 += 1) s();
            return e7;
          }, e6.getBrowserAlias = function(e7) {
            return i2.BROWSER_ALIASES_MAP[e7];
          }, e6.getBrowserTypeByAlias = function(e7) {
            return i2.BROWSER_MAP[e7] || "";
          }, e6;
        })();
        t.default = n2, e5.exports = t.default;
      }, 18: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
        t.BROWSER_ALIASES_MAP = { AmazonBot: "amazonbot", "Amazon Silk": "amazon_silk", "Android Browser": "android", BaiduSpider: "baiduspider", Bada: "bada", BingCrawler: "bingcrawler", Brave: "brave", BlackBerry: "blackberry", "ChatGPT-User": "chatgpt_user", Chrome: "chrome", ClaudeBot: "claudebot", Chromium: "chromium", Diffbot: "diffbot", DuckDuckBot: "duckduckbot", DuckDuckGo: "duckduckgo", Electron: "electron", Epiphany: "epiphany", FacebookExternalHit: "facebookexternalhit", Firefox: "firefox", Focus: "focus", Generic: "generic", "Google Search": "google_search", Googlebot: "googlebot", GPTBot: "gptbot", "Internet Explorer": "ie", InternetArchiveCrawler: "internetarchivecrawler", "K-Meleon": "k_meleon", LibreWolf: "librewolf", Linespider: "linespider", Maxthon: "maxthon", "Meta-ExternalAds": "meta_externalads", "Meta-ExternalAgent": "meta_externalagent", "Meta-ExternalFetcher": "meta_externalfetcher", "Meta-WebIndexer": "meta_webindexer", "Microsoft Edge": "edge", "MZ Browser": "mz", "NAVER Whale Browser": "naver", "OAI-SearchBot": "oai_searchbot", Omgilibot: "omgilibot", Opera: "opera", "Opera Coast": "opera_coast", "Pale Moon": "pale_moon", PerplexityBot: "perplexitybot", "Perplexity-User": "perplexity_user", PhantomJS: "phantomjs", PingdomBot: "pingdombot", Puffin: "puffin", QQ: "qq", QQLite: "qqlite", QupZilla: "qupzilla", Roku: "roku", Safari: "safari", Sailfish: "sailfish", "Samsung Internet for Android": "samsung_internet", SlackBot: "slackbot", SeaMonkey: "seamonkey", Sleipnir: "sleipnir", "Sogou Browser": "sogou", Swing: "swing", Tizen: "tizen", "UC Browser": "uc", Vivaldi: "vivaldi", "WebOS Browser": "webos", WeChat: "wechat", YahooSlurp: "yahooslurp", "Yandex Browser": "yandex", YandexBot: "yandexbot", YouBot: "youbot" };
        t.BROWSER_MAP = { amazonbot: "AmazonBot", amazon_silk: "Amazon Silk", android: "Android Browser", baiduspider: "BaiduSpider", bada: "Bada", bingcrawler: "BingCrawler", blackberry: "BlackBerry", brave: "Brave", chatgpt_user: "ChatGPT-User", chrome: "Chrome", claudebot: "ClaudeBot", chromium: "Chromium", diffbot: "Diffbot", duckduckbot: "DuckDuckBot", duckduckgo: "DuckDuckGo", edge: "Microsoft Edge", electron: "Electron", epiphany: "Epiphany", facebookexternalhit: "FacebookExternalHit", firefox: "Firefox", focus: "Focus", generic: "Generic", google_search: "Google Search", googlebot: "Googlebot", gptbot: "GPTBot", ie: "Internet Explorer", internetarchivecrawler: "InternetArchiveCrawler", k_meleon: "K-Meleon", librewolf: "LibreWolf", linespider: "Linespider", maxthon: "Maxthon", meta_externalads: "Meta-ExternalAds", meta_externalagent: "Meta-ExternalAgent", meta_externalfetcher: "Meta-ExternalFetcher", meta_webindexer: "Meta-WebIndexer", mz: "MZ Browser", naver: "NAVER Whale Browser", oai_searchbot: "OAI-SearchBot", omgilibot: "Omgilibot", opera: "Opera", opera_coast: "Opera Coast", pale_moon: "Pale Moon", perplexitybot: "PerplexityBot", perplexity_user: "Perplexity-User", phantomjs: "PhantomJS", pingdombot: "PingdomBot", puffin: "Puffin", qq: "QQ Browser", qqlite: "QQ Browser Lite", qupzilla: "QupZilla", roku: "Roku", safari: "Safari", sailfish: "Sailfish", samsung_internet: "Samsung Internet for Android", seamonkey: "SeaMonkey", slackbot: "SlackBot", sleipnir: "Sleipnir", sogou: "Sogou Browser", swing: "Swing", tizen: "Tizen", uc: "UC Browser", vivaldi: "Vivaldi", webos: "WebOS Browser", wechat: "WeChat", yahooslurp: "YahooSlurp", yandex: "Yandex Browser", yandexbot: "YandexBot", youbot: "YouBot" };
        t.PLATFORMS_MAP = { bot: "bot", desktop: "desktop", mobile: "mobile", tablet: "tablet", tv: "tv" };
        t.OS_MAP = { Android: "Android", Bada: "Bada", BlackBerry: "BlackBerry", ChromeOS: "Chrome OS", HarmonyOS: "HarmonyOS", iOS: "iOS", Linux: "Linux", MacOS: "macOS", PlayStation4: "PlayStation 4", Roku: "Roku", Tizen: "Tizen", WebOS: "WebOS", Windows: "Windows", WindowsPhone: "Windows Phone" };
        t.ENGINE_MAP = { Blink: "Blink", EdgeHTML: "EdgeHTML", Gecko: "Gecko", Presto: "Presto", Trident: "Trident", WebKit: "WebKit" };
      }, 90: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2, n2 = (i2 = r2(91)) && i2.__esModule ? i2 : { default: i2 }, a2 = r2(18);
        function o(e6, t2) {
          for (var r3 = 0; r3 < t2.length; r3++) {
            var i3 = t2[r3];
            i3.enumerable = i3.enumerable || false, i3.configurable = true, "value" in i3 && (i3.writable = true), Object.defineProperty(e6, i3.key, i3);
          }
        }
        var s = (function() {
          function e6() {
          }
          var t2, r3, i3;
          return e6.getParser = function(e7, t3, r4) {
            if (void 0 === t3 && (t3 = false), void 0 === r4 && (r4 = null), "string" != typeof e7) throw new Error("UserAgent should be a string");
            return new n2.default(e7, t3, r4);
          }, e6.parse = function(e7, t3) {
            return void 0 === t3 && (t3 = null), new n2.default(e7, t3).getResult();
          }, t2 = e6, i3 = [{ key: "BROWSER_MAP", get: function() {
            return a2.BROWSER_MAP;
          } }, { key: "ENGINE_MAP", get: function() {
            return a2.ENGINE_MAP;
          } }, { key: "OS_MAP", get: function() {
            return a2.OS_MAP;
          } }, { key: "PLATFORMS_MAP", get: function() {
            return a2.PLATFORMS_MAP;
          } }], (r3 = null) && o(t2.prototype, r3), i3 && o(t2, i3), e6;
        })();
        t.default = s, e5.exports = t.default;
      }, 91: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2 = u2(r2(92)), n2 = u2(r2(93)), a2 = u2(r2(94)), o = u2(r2(95)), s = u2(r2(17));
        function u2(e6) {
          return e6 && e6.__esModule ? e6 : { default: e6 };
        }
        var d2 = (function() {
          function e6(e7, t3, r3) {
            if (void 0 === t3 && (t3 = false), void 0 === r3 && (r3 = null), null == e7 || "" === e7) throw new Error("UserAgent parameter can't be empty");
            this._ua = e7;
            var i3 = false;
            "boolean" == typeof t3 ? (i3 = t3, this._hints = r3) : this._hints = null != t3 && "object" == typeof t3 ? t3 : null, this.parsedResult = {}, true !== i3 && this.parse();
          }
          var t2 = e6.prototype;
          return t2.getHints = function() {
            return this._hints;
          }, t2.hasBrand = function(e7) {
            if (!this._hints || !Array.isArray(this._hints.brands)) return false;
            var t3 = e7.toLowerCase();
            return this._hints.brands.some((function(e8) {
              return e8.brand && e8.brand.toLowerCase() === t3;
            }));
          }, t2.getBrandVersion = function(e7) {
            if (this._hints && Array.isArray(this._hints.brands)) {
              var t3 = e7.toLowerCase(), r3 = this._hints.brands.find((function(e8) {
                return e8.brand && e8.brand.toLowerCase() === t3;
              }));
              return r3 ? r3.version : void 0;
            }
          }, t2.getUA = function() {
            return this._ua;
          }, t2.test = function(e7) {
            return e7.test(this._ua);
          }, t2.parseBrowser = function() {
            var e7 = this;
            this.parsedResult.browser = {};
            var t3 = s.default.find(i2.default, (function(t4) {
              if ("function" == typeof t4.test) return t4.test(e7);
              if (Array.isArray(t4.test)) return t4.test.some((function(t5) {
                return e7.test(t5);
              }));
              throw new Error("Browser's test function is not valid");
            }));
            return t3 && (this.parsedResult.browser = t3.describe(this.getUA(), this)), this.parsedResult.browser;
          }, t2.getBrowser = function() {
            return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
          }, t2.getBrowserName = function(e7) {
            return e7 ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
          }, t2.getBrowserVersion = function() {
            return this.getBrowser().version;
          }, t2.getOS = function() {
            return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
          }, t2.parseOS = function() {
            var e7 = this;
            this.parsedResult.os = {};
            var t3 = s.default.find(n2.default, (function(t4) {
              if ("function" == typeof t4.test) return t4.test(e7);
              if (Array.isArray(t4.test)) return t4.test.some((function(t5) {
                return e7.test(t5);
              }));
              throw new Error("Browser's test function is not valid");
            }));
            return t3 && (this.parsedResult.os = t3.describe(this.getUA())), this.parsedResult.os;
          }, t2.getOSName = function(e7) {
            var t3 = this.getOS().name;
            return e7 ? String(t3).toLowerCase() || "" : t3 || "";
          }, t2.getOSVersion = function() {
            return this.getOS().version;
          }, t2.getPlatform = function() {
            return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
          }, t2.getPlatformType = function(e7) {
            void 0 === e7 && (e7 = false);
            var t3 = this.getPlatform().type;
            return e7 ? String(t3).toLowerCase() || "" : t3 || "";
          }, t2.parsePlatform = function() {
            var e7 = this;
            this.parsedResult.platform = {};
            var t3 = s.default.find(a2.default, (function(t4) {
              if ("function" == typeof t4.test) return t4.test(e7);
              if (Array.isArray(t4.test)) return t4.test.some((function(t5) {
                return e7.test(t5);
              }));
              throw new Error("Browser's test function is not valid");
            }));
            return t3 && (this.parsedResult.platform = t3.describe(this.getUA())), this.parsedResult.platform;
          }, t2.getEngine = function() {
            return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
          }, t2.getEngineName = function(e7) {
            return e7 ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
          }, t2.parseEngine = function() {
            var e7 = this;
            this.parsedResult.engine = {};
            var t3 = s.default.find(o.default, (function(t4) {
              if ("function" == typeof t4.test) return t4.test(e7);
              if (Array.isArray(t4.test)) return t4.test.some((function(t5) {
                return e7.test(t5);
              }));
              throw new Error("Browser's test function is not valid");
            }));
            return t3 && (this.parsedResult.engine = t3.describe(this.getUA())), this.parsedResult.engine;
          }, t2.parse = function() {
            return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
          }, t2.getResult = function() {
            return s.default.assign({}, this.parsedResult);
          }, t2.satisfies = function(e7) {
            var t3 = this, r3 = {}, i3 = 0, n3 = {}, a3 = 0;
            if (Object.keys(e7).forEach((function(t4) {
              var o3 = e7[t4];
              "string" == typeof o3 ? (n3[t4] = o3, a3 += 1) : "object" == typeof o3 && (r3[t4] = o3, i3 += 1);
            })), i3 > 0) {
              var o2 = Object.keys(r3), u3 = s.default.find(o2, (function(e8) {
                return t3.isOS(e8);
              }));
              if (u3) {
                var d3 = this.satisfies(r3[u3]);
                if (void 0 !== d3) return d3;
              }
              var c2 = s.default.find(o2, (function(e8) {
                return t3.isPlatform(e8);
              }));
              if (c2) {
                var f3 = this.satisfies(r3[c2]);
                if (void 0 !== f3) return f3;
              }
            }
            if (a3 > 0) {
              var l2 = Object.keys(n3), b3 = s.default.find(l2, (function(e8) {
                return t3.isBrowser(e8, true);
              }));
              if (void 0 !== b3) return this.compareVersion(n3[b3]);
            }
          }, t2.isBrowser = function(e7, t3) {
            void 0 === t3 && (t3 = false);
            var r3 = this.getBrowserName().toLowerCase(), i3 = e7.toLowerCase(), n3 = s.default.getBrowserTypeByAlias(i3);
            return t3 && n3 && (i3 = n3.toLowerCase()), i3 === r3;
          }, t2.compareVersion = function(e7) {
            var t3 = [0], r3 = e7, i3 = false, n3 = this.getBrowserVersion();
            if ("string" == typeof n3) return ">" === e7[0] || "<" === e7[0] ? (r3 = e7.substr(1), "=" === e7[1] ? (i3 = true, r3 = e7.substr(2)) : t3 = [], ">" === e7[0] ? t3.push(1) : t3.push(-1)) : "=" === e7[0] ? r3 = e7.substr(1) : "~" === e7[0] && (i3 = true, r3 = e7.substr(1)), t3.indexOf(s.default.compareVersions(n3, r3, i3)) > -1;
          }, t2.isOS = function(e7) {
            return this.getOSName(true) === String(e7).toLowerCase();
          }, t2.isPlatform = function(e7) {
            return this.getPlatformType(true) === String(e7).toLowerCase();
          }, t2.isEngine = function(e7) {
            return this.getEngineName(true) === String(e7).toLowerCase();
          }, t2.is = function(e7, t3) {
            return void 0 === t3 && (t3 = false), this.isBrowser(e7, t3) || this.isOS(e7) || this.isPlatform(e7);
          }, t2.some = function(e7) {
            var t3 = this;
            return void 0 === e7 && (e7 = []), e7.some((function(e8) {
              return t3.is(e8);
            }));
          }, e6;
        })();
        t.default = d2, e5.exports = t.default;
      }, 92: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2, n2 = (i2 = r2(17)) && i2.__esModule ? i2 : { default: i2 };
        var a2 = /version\/(\d+(\.?_?\d+)+)/i, o = [{ test: [/gptbot/i], describe: function(e6) {
          var t2 = { name: "GPTBot" }, r3 = n2.default.getFirstMatch(/gptbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/chatgpt-user/i], describe: function(e6) {
          var t2 = { name: "ChatGPT-User" }, r3 = n2.default.getFirstMatch(/chatgpt-user\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/oai-searchbot/i], describe: function(e6) {
          var t2 = { name: "OAI-SearchBot" }, r3 = n2.default.getFirstMatch(/oai-searchbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/claudebot/i, /claude-web/i, /claude-user/i, /claude-searchbot/i], describe: function(e6) {
          var t2 = { name: "ClaudeBot" }, r3 = n2.default.getFirstMatch(/(?:claudebot|claude-web|claude-user|claude-searchbot)\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/omgilibot/i, /webzio-extended/i], describe: function(e6) {
          var t2 = { name: "Omgilibot" }, r3 = n2.default.getFirstMatch(/(?:omgilibot|webzio-extended)\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/diffbot/i], describe: function(e6) {
          var t2 = { name: "Diffbot" }, r3 = n2.default.getFirstMatch(/diffbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/perplexitybot/i], describe: function(e6) {
          var t2 = { name: "PerplexityBot" }, r3 = n2.default.getFirstMatch(/perplexitybot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/perplexity-user/i], describe: function(e6) {
          var t2 = { name: "Perplexity-User" }, r3 = n2.default.getFirstMatch(/perplexity-user\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/youbot/i], describe: function(e6) {
          var t2 = { name: "YouBot" }, r3 = n2.default.getFirstMatch(/youbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/meta-webindexer/i], describe: function(e6) {
          var t2 = { name: "Meta-WebIndexer" }, r3 = n2.default.getFirstMatch(/meta-webindexer\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/meta-externalads/i], describe: function(e6) {
          var t2 = { name: "Meta-ExternalAds" }, r3 = n2.default.getFirstMatch(/meta-externalads\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/meta-externalagent/i], describe: function(e6) {
          var t2 = { name: "Meta-ExternalAgent" }, r3 = n2.default.getFirstMatch(/meta-externalagent\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/meta-externalfetcher/i], describe: function(e6) {
          var t2 = { name: "Meta-ExternalFetcher" }, r3 = n2.default.getFirstMatch(/meta-externalfetcher\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/googlebot/i], describe: function(e6) {
          var t2 = { name: "Googlebot" }, r3 = n2.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/linespider/i], describe: function(e6) {
          var t2 = { name: "Linespider" }, r3 = n2.default.getFirstMatch(/(?:linespider)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/amazonbot/i], describe: function(e6) {
          var t2 = { name: "AmazonBot" }, r3 = n2.default.getFirstMatch(/amazonbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/bingbot/i], describe: function(e6) {
          var t2 = { name: "BingCrawler" }, r3 = n2.default.getFirstMatch(/bingbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/baiduspider/i], describe: function(e6) {
          var t2 = { name: "BaiduSpider" }, r3 = n2.default.getFirstMatch(/baiduspider\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/duckduckbot/i], describe: function(e6) {
          var t2 = { name: "DuckDuckBot" }, r3 = n2.default.getFirstMatch(/duckduckbot\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/ia_archiver/i], describe: function(e6) {
          var t2 = { name: "InternetArchiveCrawler" }, r3 = n2.default.getFirstMatch(/ia_archiver\/(\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/facebookexternalhit/i, /facebookcatalog/i], describe: function() {
          return { name: "FacebookExternalHit" };
        } }, { test: [/slackbot/i, /slack-imgProxy/i], describe: function(e6) {
          var t2 = { name: "SlackBot" }, r3 = n2.default.getFirstMatch(/(?:slackbot|slack-imgproxy)(?:-[-\w]+)?[\s/](\d+(\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/yahoo!?[\s/]*slurp/i], describe: function() {
          return { name: "YahooSlurp" };
        } }, { test: [/yandexbot/i, /yandexmobilebot/i], describe: function() {
          return { name: "YandexBot" };
        } }, { test: [/pingdom/i], describe: function() {
          return { name: "PingdomBot" };
        } }, { test: [/opera/i], describe: function(e6) {
          var t2 = { name: "Opera" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/opr\/|opios/i], describe: function(e6) {
          var t2 = { name: "Opera" }, r3 = n2.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/SamsungBrowser/i], describe: function(e6) {
          var t2 = { name: "Samsung Internet for Android" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/Whale/i], describe: function(e6) {
          var t2 = { name: "NAVER Whale Browser" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/PaleMoon/i], describe: function(e6) {
          var t2 = { name: "Pale Moon" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:PaleMoon)[\s/](\d+(?:\.\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/MZBrowser/i], describe: function(e6) {
          var t2 = { name: "MZ Browser" }, r3 = n2.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/focus/i], describe: function(e6) {
          var t2 = { name: "Focus" }, r3 = n2.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/swing/i], describe: function(e6) {
          var t2 = { name: "Swing" }, r3 = n2.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/coast/i], describe: function(e6) {
          var t2 = { name: "Opera Coast" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/opt\/\d+(?:.?_?\d+)+/i], describe: function(e6) {
          var t2 = { name: "Opera Touch" }, r3 = n2.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/yabrowser/i], describe: function(e6) {
          var t2 = { name: "Yandex Browser" }, r3 = n2.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/ucbrowser/i], describe: function(e6) {
          var t2 = { name: "UC Browser" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/Maxthon|mxios/i], describe: function(e6) {
          var t2 = { name: "Maxthon" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/epiphany/i], describe: function(e6) {
          var t2 = { name: "Epiphany" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/puffin/i], describe: function(e6) {
          var t2 = { name: "Puffin" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/sleipnir/i], describe: function(e6) {
          var t2 = { name: "Sleipnir" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/k-meleon/i], describe: function(e6) {
          var t2 = { name: "K-Meleon" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/micromessenger/i], describe: function(e6) {
          var t2 = { name: "WeChat" }, r3 = n2.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/qqbrowser/i], describe: function(e6) {
          var t2 = { name: /qqbrowserlite/i.test(e6) ? "QQ Browser Lite" : "QQ Browser" }, r3 = n2.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/msie|trident/i], describe: function(e6) {
          var t2 = { name: "Internet Explorer" }, r3 = n2.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/\sedg\//i], describe: function(e6) {
          var t2 = { name: "Microsoft Edge" }, r3 = n2.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/edg([ea]|ios)/i], describe: function(e6) {
          var t2 = { name: "Microsoft Edge" }, r3 = n2.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/vivaldi/i], describe: function(e6) {
          var t2 = { name: "Vivaldi" }, r3 = n2.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/seamonkey/i], describe: function(e6) {
          var t2 = { name: "SeaMonkey" }, r3 = n2.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/sailfish/i], describe: function(e6) {
          var t2 = { name: "Sailfish" }, r3 = n2.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/silk/i], describe: function(e6) {
          var t2 = { name: "Amazon Silk" }, r3 = n2.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/phantom/i], describe: function(e6) {
          var t2 = { name: "PhantomJS" }, r3 = n2.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/slimerjs/i], describe: function(e6) {
          var t2 = { name: "SlimerJS" }, r3 = n2.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function(e6) {
          var t2 = { name: "BlackBerry" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/(web|hpw)[o0]s/i], describe: function(e6) {
          var t2 = { name: "WebOS Browser" }, r3 = n2.default.getFirstMatch(a2, e6) || n2.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/bada/i], describe: function(e6) {
          var t2 = { name: "Bada" }, r3 = n2.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/tizen/i], describe: function(e6) {
          var t2 = { name: "Tizen" }, r3 = n2.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/qupzilla/i], describe: function(e6) {
          var t2 = { name: "QupZilla" }, r3 = n2.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/librewolf/i], describe: function(e6) {
          var t2 = { name: "LibreWolf" }, r3 = n2.default.getFirstMatch(/(?:librewolf)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/firefox|iceweasel|fxios/i], describe: function(e6) {
          var t2 = { name: "Firefox" }, r3 = n2.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/electron/i], describe: function(e6) {
          var t2 = { name: "Electron" }, r3 = n2.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/sogoumobilebrowser/i, /metasr/i, /se 2\.[x]/i], describe: function(e6) {
          var t2 = { name: "Sogou Browser" }, r3 = n2.default.getFirstMatch(/(?:sogoumobilebrowser)[\s/](\d+(\.?_?\d+)+)/i, e6), i3 = n2.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e6), a3 = n2.default.getFirstMatch(/se ([\d.]+)x/i, e6), o2 = r3 || i3 || a3;
          return o2 && (t2.version = o2), t2;
        } }, { test: [/MiuiBrowser/i], describe: function(e6) {
          var t2 = { name: "Miui" }, r3 = n2.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: function(e6) {
          return !!e6.hasBrand("DuckDuckGo") || e6.test(/\sDdg\/[\d.]+$/i);
        }, describe: function(e6, t2) {
          var r3 = { name: "DuckDuckGo" };
          if (t2) {
            var i3 = t2.getBrandVersion("DuckDuckGo");
            if (i3) return r3.version = i3, r3;
          }
          var a3 = n2.default.getFirstMatch(/\sDdg\/([\d.]+)$/i, e6);
          return a3 && (r3.version = a3), r3;
        } }, { test: function(e6) {
          return e6.hasBrand("Brave");
        }, describe: function(e6, t2) {
          var r3 = { name: "Brave" };
          if (t2) {
            var i3 = t2.getBrandVersion("Brave");
            if (i3) return r3.version = i3, r3;
          }
          return r3;
        } }, { test: [/chromium/i], describe: function(e6) {
          var t2 = { name: "Chromium" }, r3 = n2.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e6) || n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/chrome|crios|crmo/i], describe: function(e6) {
          var t2 = { name: "Chrome" }, r3 = n2.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/GSA/i], describe: function(e6) {
          var t2 = { name: "Google Search" }, r3 = n2.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: function(e6) {
          var t2 = !e6.test(/like android/i), r3 = e6.test(/android/i);
          return t2 && r3;
        }, describe: function(e6) {
          var t2 = { name: "Android Browser" }, r3 = n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/playstation 4/i], describe: function(e6) {
          var t2 = { name: "PlayStation 4" }, r3 = n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/safari|applewebkit/i], describe: function(e6) {
          var t2 = { name: "Safari" }, r3 = n2.default.getFirstMatch(a2, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/.*/i], describe: function(e6) {
          var t2 = -1 !== e6.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
          return { name: n2.default.getFirstMatch(t2, e6), version: n2.default.getSecondMatch(t2, e6) };
        } }];
        t.default = o, e5.exports = t.default;
      }, 93: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2, n2 = (i2 = r2(17)) && i2.__esModule ? i2 : { default: i2 }, a2 = r2(18);
        var o = [{ test: [/Roku\/DVP/], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e6);
          return { name: a2.OS_MAP.Roku, version: t2 };
        } }, { test: [/windows phone/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e6);
          return { name: a2.OS_MAP.WindowsPhone, version: t2 };
        } }, { test: [/windows /i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e6), r3 = n2.default.getWindowsVersionName(t2);
          return { name: a2.OS_MAP.Windows, version: t2, versionName: r3 };
        } }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: function(e6) {
          var t2 = { name: a2.OS_MAP.iOS }, r3 = n2.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/macintosh/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e6).replace(/[_\s]/g, "."), r3 = n2.default.getMacOSVersionName(t2), i3 = { name: a2.OS_MAP.MacOS, version: t2 };
          return r3 && (i3.versionName = r3), i3;
        } }, { test: [/(ipod|iphone|ipad)/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e6).replace(/[_\s]/g, ".");
          return { name: a2.OS_MAP.iOS, version: t2 };
        } }, { test: [/OpenHarmony/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/OpenHarmony\s+(\d+(\.\d+)*)/i, e6);
          return { name: a2.OS_MAP.HarmonyOS, version: t2 };
        } }, { test: function(e6) {
          var t2 = !e6.test(/like android/i), r3 = e6.test(/android/i);
          return t2 && r3;
        }, describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e6), r3 = n2.default.getAndroidVersionName(t2), i3 = { name: a2.OS_MAP.Android, version: t2 };
          return r3 && (i3.versionName = r3), i3;
        } }, { test: [/(web|hpw)[o0]s/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e6), r3 = { name: a2.OS_MAP.WebOS };
          return t2 && t2.length && (r3.version = t2), r3;
        } }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e6) || n2.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e6) || n2.default.getFirstMatch(/\bbb(\d+)/i, e6);
          return { name: a2.OS_MAP.BlackBerry, version: t2 };
        } }, { test: [/bada/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e6);
          return { name: a2.OS_MAP.Bada, version: t2 };
        } }, { test: [/tizen/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e6);
          return { name: a2.OS_MAP.Tizen, version: t2 };
        } }, { test: [/linux/i], describe: function() {
          return { name: a2.OS_MAP.Linux };
        } }, { test: [/CrOS/], describe: function() {
          return { name: a2.OS_MAP.ChromeOS };
        } }, { test: [/PlayStation 4/], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e6);
          return { name: a2.OS_MAP.PlayStation4, version: t2 };
        } }];
        t.default = o, e5.exports = t.default;
      }, 94: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2, n2 = (i2 = r2(17)) && i2.__esModule ? i2 : { default: i2 }, a2 = r2(18);
        var o = [{ test: [/googlebot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Google" };
        } }, { test: [/linespider/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Line" };
        } }, { test: [/amazonbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Amazon" };
        } }, { test: [/gptbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "OpenAI" };
        } }, { test: [/chatgpt-user/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "OpenAI" };
        } }, { test: [/oai-searchbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "OpenAI" };
        } }, { test: [/baiduspider/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Baidu" };
        } }, { test: [/bingbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Bing" };
        } }, { test: [/duckduckbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "DuckDuckGo" };
        } }, { test: [/claudebot/i, /claude-web/i, /claude-user/i, /claude-searchbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Anthropic" };
        } }, { test: [/omgilibot/i, /webzio-extended/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Webz.io" };
        } }, { test: [/diffbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Diffbot" };
        } }, { test: [/perplexitybot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Perplexity AI" };
        } }, { test: [/perplexity-user/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Perplexity AI" };
        } }, { test: [/youbot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "You.com" };
        } }, { test: [/ia_archiver/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Internet Archive" };
        } }, { test: [/meta-webindexer/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Meta" };
        } }, { test: [/meta-externalads/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Meta" };
        } }, { test: [/meta-externalagent/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Meta" };
        } }, { test: [/meta-externalfetcher/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Meta" };
        } }, { test: [/facebookexternalhit/i, /facebookcatalog/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Meta" };
        } }, { test: [/slackbot/i, /slack-imgProxy/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Slack" };
        } }, { test: [/yahoo/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Yahoo" };
        } }, { test: [/yandexbot/i, /yandexmobilebot/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Yandex" };
        } }, { test: [/pingdom/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.bot, vendor: "Pingdom" };
        } }, { test: [/huawei/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/(can-l01)/i, e6) && "Nova", r3 = { type: a2.PLATFORMS_MAP.mobile, vendor: "Huawei" };
          return t2 && (r3.model = t2), r3;
        } }, { test: [/nexus\s*(?:7|8|9|10).*/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet, vendor: "Nexus" };
        } }, { test: [/ipad/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
        } }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet, vendor: "Apple", model: "iPad" };
        } }, { test: [/kftt build/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet, vendor: "Amazon", model: "Kindle Fire HD 7" };
        } }, { test: [/silk/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet, vendor: "Amazon" };
        } }, { test: [/tablet(?! pc)/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet };
        } }, { test: function(e6) {
          var t2 = e6.test(/ipod|iphone/i), r3 = e6.test(/like (ipod|iphone)/i);
          return t2 && !r3;
        }, describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/(ipod|iphone)/i, e6);
          return { type: a2.PLATFORMS_MAP.mobile, vendor: "Apple", model: t2 };
        } }, { test: [/nexus\s*[0-6].*/i, /galaxy nexus/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.mobile, vendor: "Nexus" };
        } }, { test: [/Nokia/i], describe: function(e6) {
          var t2 = n2.default.getFirstMatch(/Nokia\s+([0-9]+(\.[0-9]+)?)/i, e6), r3 = { type: a2.PLATFORMS_MAP.mobile, vendor: "Nokia" };
          return t2 && (r3.model = t2), r3;
        } }, { test: [/[^-]mobi/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.mobile };
        } }, { test: function(e6) {
          return "blackberry" === e6.getBrowserName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.mobile, vendor: "BlackBerry" };
        } }, { test: function(e6) {
          return "bada" === e6.getBrowserName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.mobile };
        } }, { test: function(e6) {
          return "windows phone" === e6.getBrowserName();
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.mobile, vendor: "Microsoft" };
        } }, { test: function(e6) {
          var t2 = Number(String(e6.getOSVersion()).split(".")[0]);
          return "android" === e6.getOSName(true) && t2 >= 3;
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.tablet };
        } }, { test: function(e6) {
          return "android" === e6.getOSName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.mobile };
        } }, { test: [/smart-?tv|smarttv/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tv };
        } }, { test: [/netcast/i], describe: function() {
          return { type: a2.PLATFORMS_MAP.tv };
        } }, { test: function(e6) {
          return "macos" === e6.getOSName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.desktop, vendor: "Apple" };
        } }, { test: function(e6) {
          return "windows" === e6.getOSName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.desktop };
        } }, { test: function(e6) {
          return "linux" === e6.getOSName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.desktop };
        } }, { test: function(e6) {
          return "playstation 4" === e6.getOSName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.tv };
        } }, { test: function(e6) {
          return "roku" === e6.getOSName(true);
        }, describe: function() {
          return { type: a2.PLATFORMS_MAP.tv };
        } }];
        t.default = o, e5.exports = t.default;
      }, 95: function(e5, t, r2) {
        "use strict";
        t.__esModule = true, t.default = void 0;
        var i2, n2 = (i2 = r2(17)) && i2.__esModule ? i2 : { default: i2 }, a2 = r2(18);
        var o = [{ test: function(e6) {
          return "microsoft edge" === e6.getBrowserName(true);
        }, describe: function(e6) {
          if (/\sedg\//i.test(e6)) return { name: a2.ENGINE_MAP.Blink };
          var t2 = n2.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e6);
          return { name: a2.ENGINE_MAP.EdgeHTML, version: t2 };
        } }, { test: [/trident/i], describe: function(e6) {
          var t2 = { name: a2.ENGINE_MAP.Trident }, r3 = n2.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: function(e6) {
          return e6.test(/presto/i);
        }, describe: function(e6) {
          var t2 = { name: a2.ENGINE_MAP.Presto }, r3 = n2.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: function(e6) {
          var t2 = e6.test(/gecko/i), r3 = e6.test(/like gecko/i);
          return t2 && !r3;
        }, describe: function(e6) {
          var t2 = { name: a2.ENGINE_MAP.Gecko }, r3 = n2.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }, { test: [/(apple)?webkit\/537\.36/i], describe: function() {
          return { name: a2.ENGINE_MAP.Blink };
        } }, { test: [/(apple)?webkit/i], describe: function(e6) {
          var t2 = { name: a2.ENGINE_MAP.WebKit }, r3 = n2.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e6);
          return r3 && (t2.version = r3), t2;
        } }];
        t.default = o, e5.exports = t.default;
      } });
    }));
  }
});

// ../../node_modules/@moq/net/connection/browser.js
function isWebTransportUserAgentSupported(userAgent) {
  const browser = import_bowser.default.getParser(userAgent);
  if (browser.getEngine().name === "WebKit" || browser.getOS().name === "iOS")
    return false;
  const supported2 = browser.satisfies({
    // Fixed with 153.0.0, Firefox only allows two concurrent remote-initiated streams:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=2046262
    firefox: ">=153.0"
  });
  if (supported2 === void 0) {
    return true;
  }
  return supported2;
}
function isWebTransportSupported() {
  if (typeof globalThis.WebTransport === "undefined")
    return false;
  if (typeof navigator === "undefined")
    return true;
  return isWebTransportUserAgentSupported(navigator.userAgent);
}
var import_bowser;
var init_browser = __esm({
  "../../node_modules/@moq/net/connection/browser.js"() {
    import_bowser = __toESM(require_es5(), 1);
  }
});

// ../../node_modules/@moq/net/util/hex.js
function toBytes(hex) {
  hex = hex.startsWith("0x") ? hex.slice(2) : hex;
  if (hex.length % 2) {
    throw new Error("invalid hex string length");
  }
  const matches = hex.match(/.{2}/g);
  if (!matches) {
    throw new Error("invalid hex string format");
  }
  return new Uint8Array(matches.map((byte) => parseInt(byte, 16)));
}
var init_hex = __esm({
  "../../node_modules/@moq/net/util/hex.js"() {
  }
});

// ../../node_modules/@moq/net/util/log.js
function redact(url2) {
  return `${url2.origin}${url2.pathname}`;
}
function dev() {
  const env = import.meta.env;
  if (typeof env === "undefined")
    return false;
  if (typeof env.DEV === "boolean")
    return env.DEV;
  return env.NODE_ENV !== "production" && env.MODE !== "production";
}
var init_log = __esm({
  "../../node_modules/@moq/net/util/log.js"() {
  }
});

// ../../node_modules/@moq/net/connection/connect.js
async function connect({ url: url2, ...props }) {
  const signal = props.signal ?? NEVER_ABORTED;
  signal.throwIfAborted();
  const { promise: abort, resolve: resolve2 } = Promise.withResolvers();
  const onAbort = () => resolve2();
  signal.addEventListener("abort", onAbort, { once: true });
  const pending = connectInner(url2, props, abort);
  try {
    const connection = await Promise.race([pending, abort.then(() => void 0)]);
    if (connection && !signal.aborted) {
      if (props.consume) {
        const consume = props.consume;
        void Promise.race([connection.admitted ?? true, connection.closed.then(() => false)]).then((admitted) => admitted && forwardAnnounced(connection, consume));
      }
      return connection;
    }
    pending.then((conn) => conn.close()).catch(() => {
    });
    throw signal.reason;
  } finally {
    signal.removeEventListener("abort", onAbort);
  }
}
async function connectInner(url2, props, abort) {
  const wiring = {
    discovery: props.discovery ?? true,
    publish: props.publish,
    // Tablebox: the connection's own Hop ID across its sessions (tablebox.io patches.mjs).
    hop: props.hop
  };
  if (props.transport) {
    const transport = props.transport;
    void abort.then(() => transport.close());
    return connectTransport(url2, transport, wiring);
  }
  const { promise: raced, resolve: done } = Promise.withResolvers();
  const cancel = Promise.race([raced, abort]);
  const webtransport = isWebTransportSupported() ? connectWebTransport(url2, cancel, props.webtransport) : void 0;
  const headstart = !webtransport || websocketWon.has(url2.toString()) ? 0 : props.websocket?.delay ?? DEFAULT_WEBSOCKET_DELAY_MS;
  const websocket = props.websocket?.enabled !== false ? connectWebSocket(props.websocket?.url ?? url2, headstart, cancel) : void 0;
  if (!websocket && !webtransport) {
    throw new Error("no transport available; WebTransport not supported and WebSocket is disabled");
  }
  const session = await Promise.any(webtransport !== void 0 ? websocket !== void 0 ? [websocket, webtransport] : [webtransport] : [websocket]);
  done();
  if (!session)
    throw new Error("no transport available");
  void abort.then(() => session.close());
  if (session instanceof qmux_default) {
    if (dev())
      console.warn(redact(url2), "connected via WebSocket");
    websocketWon.add(url2.toString());
  } else if (dev()) {
    console.debug(redact(url2), "connected via WebTransport");
  }
  return await connectTransport(url2, session, wiring);
}
async function connectTransport(url2, session, wiring) {
  const closed = session.closed.then(fromClose, error);
  const terminal = closed.then((cause) => {
    throw cause ?? new Error("session closed during SETUP");
  });
  try {
    return await Promise.race([terminal, negotiate(url2, session, wiring)]);
  } catch (cause) {
    const pending = /* @__PURE__ */ Symbol("session close pending");
    const final = await Promise.race([
      closed,
      new Promise((resolve2) => setTimeout(() => resolve2(pending), SETUP_CLOSE_GRACE_MS))
    ]);
    if (final !== pending) {
      if (final)
        throw final;
      throw cause;
    }
    session.close();
    throw cause;
  }
}
async function negotiate(url2, session, wiring) {
  const protocol = session.protocol || void 0;
  if (dev())
    console.debug(redact(url2), "negotiated ALPN:", protocol ?? "(none)");
  let setupVersion;
  const modernVersion = protocol === ALPN.DRAFT_22 ? Version.DRAFT_22 : protocol === ALPN.DRAFT_21 ? Version.DRAFT_21 : protocol === ALPN.DRAFT_20 ? Version.DRAFT_20 : protocol === ALPN.DRAFT_19 ? Version.DRAFT_19 : protocol === ALPN.DRAFT_18 ? Version.DRAFT_18 : protocol === ALPN.DRAFT_17 ? Version.DRAFT_17 : void 0;
  if (modernVersion !== void 0) {
    return await handshakeAlpn(url2, session, modernVersion, wiring);
  } else if (protocol === ALPN.DRAFT_16) {
    setupVersion = Version.DRAFT_16;
  } else if (protocol === ALPN.DRAFT_15) {
    setupVersion = Version.DRAFT_15;
  } else if (protocol === ALPN_07_WIP) {
    return new Connection2({ url: url2, quic: session, version: Version2.DRAFT_07, ...wiring });
  } else if (protocol === ALPN_06) {
    return new Connection2({ url: url2, quic: session, version: Version2.DRAFT_06, ...wiring });
  } else if (protocol === ALPN_05) {
    return new Connection2({ url: url2, quic: session, version: Version2.DRAFT_05, ...wiring });
  } else if (protocol === ALPN_04) {
    return new Connection2({ url: url2, quic: session, version: Version2.DRAFT_04, ...wiring });
  } else if (protocol === ALPN_03) {
    return new Connection2({ url: url2, quic: session, version: Version2.DRAFT_03, ...wiring });
  } else if (protocol === ALPN2 || protocol === "" || protocol === void 0) {
    setupVersion = Version.DRAFT_14;
  } else {
    throw new Error(`unsupported WebTransport protocol: ${protocol}`);
  }
  const stream = await Stream2.open(session, { version: setupVersion });
  await stream.writer.u53(StreamId.ClientCompat);
  const encoder2 = new TextEncoder();
  const params = new SetupOptions();
  params.setVarint(SetupOption.MaxRequestId, 42069n);
  params.setBytes(SetupOption.Implementation, encoder2.encode("moq-lite-js"));
  solicitIntoSetup(params);
  hiddenIntoSetup(params);
  const client = new ClientSetup({
    versions: setupVersion === Version.DRAFT_16 ? [Version.DRAFT_16] : setupVersion === Version.DRAFT_15 ? [Version.DRAFT_15] : [Version2.DRAFT_02, Version2.DRAFT_01, Version.DRAFT_14],
    parameters: params
  });
  await client.encode(stream.writer, setupVersion);
  const serverCompat = await stream.reader.u53();
  if (serverCompat !== StreamId.ServerCompat) {
    throw new Error(`unsupported server message type: ${serverCompat.toString()}`);
  }
  const server = await ServerSetup.decode(stream.reader, setupVersion);
  if (Object.values(Version2).includes(server.version)) {
    return new Connection2({
      url: url2,
      quic: session,
      version: server.version,
      session: stream,
      ...wiring
    });
  } else if (Object.values(Version).includes(server.version)) {
    const maxRequestId = server.parameters.getVarint(SetupOption.MaxRequestId) ?? 0n;
    return new Connection({
      ...wiring,
      client: true,
      url: url2,
      quic: session,
      control: stream,
      maxRequestId,
      version: server.version,
      solicit: solicitFromSetup(server.parameters),
      hidden: hiddenFromSetup(server.parameters)
    });
  } else {
    throw new Error(`unsupported server version: ${server.version.toString()}`);
  }
}
async function handshakeAlpn(url2, session, version2, wiring) {
  const { control, early, solicit, hidden, cluster } = await exchangeSetup(session, version2, "moq-lite-js");
  return new Connection({
    ...wiring,
    client: true,
    url: url2,
    quic: session,
    control,
    early,
    solicit,
    hidden,
    cluster,
    // v17+ uses NativeSession which manages its own request IDs; maxRequestId is unused.
    maxRequestId: 0n,
    version: version2
  });
}
function pemToDer(pem) {
  const match = pem.match(/-----BEGIN CERTIFICATE-----([\s\S]+?)-----END CERTIFICATE-----/);
  if (!match) {
    throw new Error("invalid PEM certificate: missing -----BEGIN/END CERTIFICATE----- armor");
  }
  const binary = atob(match[1].replace(/\s+/g, ""));
  const der = new Uint8Array(binary.length);
  for (let i2 = 0; i2 < binary.length; i2++) {
    der[i2] = binary.charCodeAt(i2);
  }
  return der;
}
async function certificateHash(cert) {
  const der = typeof cert === "string" ? pemToDer(cert) : cert;
  const digest = await crypto.subtle.digest("SHA-256", der);
  return new Uint8Array(digest);
}
async function resolveCertificateHashes(options) {
  const hashes = [];
  for (const hash of options?.serverCertificateHashes ?? []) {
    const value = typeof hash.value === "string" ? toBytes(hash.value) : hash.value;
    hashes.push({ algorithm: hash.algorithm ?? "sha-256", value });
  }
  if (options?.serverCertificate !== void 0) {
    hashes.push({ algorithm: "sha-256", value: await certificateHash(options.serverCertificate) });
  }
  return hashes.length > 0 ? hashes : void 0;
}
async function connectWebTransport(url2, cancel, options) {
  let finalUrl = url2;
  const { serverCertificate: _cert, serverCertificateHashes: _hashes, ...webtransport } = options ?? {};
  const finalOptions = {
    allowPooling: false,
    congestionControl: "low-latency",
    protocols: [
      ALPN_06,
      ALPN_05,
      ALPN_04,
      ALPN_03,
      ALPN2,
      ALPN.DRAFT_22,
      ALPN.DRAFT_21,
      ALPN.DRAFT_20,
      ALPN.DRAFT_19,
      ALPN.DRAFT_18,
      ALPN.DRAFT_17,
      ALPN.DRAFT_16,
      ALPN.DRAFT_15
    ],
    ...webtransport
  };
  const hashes = await resolveCertificateHashes(options) ?? [];
  if (url2.protocol === "http:") {
    const fingerprintUrl = new URL(url2);
    fingerprintUrl.pathname = "/certificate.sha256";
    fingerprintUrl.search = "";
    if (dev()) {
      console.debug(redact(fingerprintUrl), "performing an insecure fingerprint fetch; use https:// in production");
    }
    const fingerprint = await Promise.race([fetch(fingerprintUrl), cancel]);
    if (!fingerprint)
      return void 0;
    const fingerprintText = await Promise.race([fingerprint.text(), cancel]);
    if (fingerprintText === void 0)
      return void 0;
    hashes.push({ algorithm: "sha-256", value: toBytes(fingerprintText) });
    finalUrl = new URL(url2);
    finalUrl.protocol = "https:";
  }
  if (hashes.length > 0) {
    finalOptions.serverCertificateHashes = hashes;
  }
  const quic = new WebTransport(finalUrl, finalOptions);
  quic.closed.catch(() => {
  });
  const loaded = await Promise.race([quic.ready.then(() => true), cancel]);
  if (!loaded) {
    quic.close();
    return void 0;
  }
  return quic;
}
async function connectWebSocket(url2, delay, cancel) {
  const timer = new Promise((resolve2) => setTimeout(resolve2, delay));
  const active = await Promise.race([cancel, timer.then(() => true)]);
  if (!active)
    return void 0;
  const versions = {
    // Lite.ALPN_07_WIP omitted on purpose: lite-07 is work-in-progress, not advertised by default.
    [ALPN_06]: null,
    [ALPN_05]: null,
    [ALPN_04]: null,
    [ALPN_03]: null,
    [ALPN2]: null,
    [ALPN.DRAFT_22]: "qmux-01",
    [ALPN.DRAFT_21]: "qmux-01",
    [ALPN.DRAFT_20]: "qmux-01",
    [ALPN.DRAFT_19]: "qmux-01",
    [ALPN.DRAFT_18]: "qmux-01",
    [ALPN.DRAFT_17]: null,
    [ALPN.DRAFT_16]: null,
    [ALPN.DRAFT_15]: null
  };
  const quic = new qmux_default(url2, {
    protocols: Object.keys(versions),
    versions
  });
  const loaded = await Promise.race([quic.ready.then(() => true), cancel]);
  if (!loaded) {
    quic.close();
    return void 0;
  }
  return quic;
}
var DEFAULT_WEBSOCKET_DELAY_MS, SETUP_CLOSE_GRACE_MS, websocketWon, NEVER_ABORTED;
var init_connect = __esm({
  "../../node_modules/@moq/net/connection/connect.js"() {
    init_qmux();
    init_error2();
    init_ietf();
    init_lite();
    init_stream();
    init_time();
    init_hex();
    init_log();
    init_browser();
    init_forward();
    init_handshake();
    DEFAULT_WEBSOCKET_DELAY_MS = Milli(500);
    SETUP_CLOSE_GRACE_MS = 100;
    websocketWon = /* @__PURE__ */ new Set();
    NEVER_ABORTED = new AbortController().signal;
  }
});

// ../../node_modules/@moq/net/origin.js
var origin_exports = {};
__export(origin_exports, {
  Consumer: () => Consumer5,
  Dynamic: () => Dynamic,
  Producer: () => Producer5,
  Request: () => Request2,
  Requesting: () => Requesting,
  isAnonymous: () => isAnonymous
});
function advertOverlaps(advert, prefix, pattern) {
  return advert.claim ? advert.claim.overlaps(pattern) : scopeOverlaps(pattern, prefix);
}
function compareCandidates(a2, b3) {
  return compareRoutes(a2.route, b3.route) || Number(b3.exact) - Number(a2.exact) || a2.route.hops.length - b3.route.hops.length;
}
function compareRoutes(a2, b3) {
  const anonymous = Number(isAnonymous(a2)) - Number(isAnonymous(b3));
  if (anonymous !== 0)
    return anonymous;
  if (a2.cost.warm !== b3.cost.warm)
    return a2.cost.warm < b3.cost.warm ? -1 : 1;
  if (a2.cost.cold !== b3.cost.cold)
    return a2.cost.cold < b3.cost.cold ? -1 : 1;
  return 0;
}
function preferredEntry(entries, skip) {
  let best;
  for (const entry of entries) {
    if (skip?.(entry))
      continue;
    if (!best) {
      best = entry;
      continue;
    }
    const a2 = entry.route.peek();
    const b3 = best.route.peek();
    const order = compareRoutes(a2, b3) || a2.hops.length - b3.hops.length;
    if (order < 0)
      best = entry;
  }
  return best;
}
function received(entry) {
  return !entry.originated;
}
function noCapacity() {
  return new Stream(StreamCode.NoCapacity, { message: "no capacity" });
}
var Scope, CoveringRoot, ServeState, VersionedSignal, OriginState, Producer5, makeConsumer4, makeRequesting, makeDynamic, makeRequest, finishRequest, Requesting, Consumer5, Dynamic, Request2;
var init_origin = __esm({
  "../../node_modules/@moq/net/origin.js"() {
    init_signals();
    init_announced();
    init_broadcast();
    init_error2();
    init_hop();
    init_internal();
    init_path();
    init_wire();
    init_hop();
    Scope = class _Scope {
      static all = new _Scope(empty());
      root;
      allowed;
      constructor(root, allowed) {
        this.root = root;
        this.allowed = allowed;
      }
      narrow(root, patterns) {
        const joined = encode2(join(this.root, root));
        const rooted = patterns.rooted(joined);
        const allowed = this.allowed?.intersect(rooted) ?? rooted;
        if (allowed.size === 0)
          throw new Error("origin scopes do not overlap");
        return new _Scope(joined, allowed);
      }
      matches(path) {
        return this.allowed?.matches(path) ?? true;
      }
      path(path) {
        const joined = encode2(join(this.root, path));
        if (!this.matches(joined))
          throw new Error("path is outside the origin scope");
        return joined;
      }
      prefix(prefix) {
        const joined = encode2(join(this.root, prefix));
        if (this.allowed && !this.allowed.overlaps(Pattern.subtree(joined))) {
          throw new Error("prefix is outside the origin scope");
        }
        return joined;
      }
      patterns(pattern = Pattern.all()) {
        const rooted = new Patterns([pattern.rooted(this.root)]);
        return this.allowed?.intersect(rooted) ?? rooted;
      }
      /** Omit nested heads because the outer subscription already carries their routes. */
      heads() {
        if (!this.allowed)
          return [empty()];
        const heads = [...new Set([...this.allowed.rebase(this.root)].map(scopeHead))].sort();
        return heads.filter((head) => !heads.some((other) => other !== head && hasPrefix(other, head)));
      }
      /** The exact paths within this scope, relative to its root. */
      projectPaths(values) {
        if (!values || this === _Scope.all)
          return values;
        const out = /* @__PURE__ */ new Map();
        for (const [path, value] of values) {
          if (!this.matches(path))
            continue;
          const relative2 = stripPrefix(this.root, path);
          if (relative2 !== null)
            out.set(relative2, value);
        }
        return out;
      }
      /**
       * The advertisements that may serve this scope, relative to its root. Every prefix at or
       * above the root presents as the empty path, most specific first, since that is the order
       * a request beneath the root resolves in.
       */
      projectRoutes(values) {
        if (!values || this === _Scope.all)
          return values;
        const out = /* @__PURE__ */ new Map();
        const covering = [];
        const allowed = this.allowed && [...this.allowed];
        for (const [path, candidates] of values) {
          const relative2 = stripPrefix(this.root, path);
          const above = relative2 === null || relative2 === empty();
          if (above && !hasPrefix(path, this.root))
            continue;
          const visible = candidates.filter((value) => !allowed || allowed.some((pattern) => advertOverlaps(value, path, pattern))).map((value) => value.claim ? { ...value, claim: value.claim.rebase(this.root) } : value);
          if (visible.length === 0)
            continue;
          if (!above) {
            out.set(relative2, visible);
            continue;
          }
          if (covering.length === 0)
            out.set(empty(), []);
          covering.push([path, visible]);
        }
        if (covering.length > 0) {
          covering.sort(([a2], [b3]) => b3.length - a2.length);
          out.set(empty(), covering.flatMap(([, visible]) => visible));
        }
        return out;
      }
    };
    CoveringRoot = class {
      #root;
      #covering;
      constructor(root) {
        this.#root = root;
      }
      /** The presented path for `path`, or undefined when it is outside the root or a broader cover. */
      relative(path) {
        const relative2 = stripPrefix(this.#root, path);
        if (relative2 !== null && relative2 !== empty())
          return relative2;
        if (relative2 === null && !hasPrefix(path, this.#root))
          return void 0;
        if (this.#covering !== void 0 && !hasPrefix(this.#covering, path))
          return void 0;
        this.#covering = path;
        return empty();
      }
    };
    ServeState = class {
      root;
      constructor(root) {
        this.root = root;
      }
      queue = new Signal([]);
      pending = /* @__PURE__ */ new Map();
      served = /* @__PURE__ */ new Map();
      rejected = /* @__PURE__ */ new Map();
      // demand() is the only reader of `rejected`. A Consumer.request refusal never
      // re-enqueues, so storing the error without a waiter would pin every unique
      // path until the route dies.
      demanding = /* @__PURE__ */ new Map();
      closed = new Once();
      settled = new Signal(0);
      onChange = () => {
      };
      onReject = () => {
      };
      enqueue(path) {
        if (this.closed.peek() !== void 0)
          return;
        this.rejected.delete(path);
        if (this.pending.has(path))
          return;
        const live = this.served.get(path);
        if (live && live.closed.peek() === void 0)
          return;
        const request = makeRequest(stripPrefix(this.root, path) ?? empty(), this);
        this.pending.set(path, request);
        this.queue.mutate((queue) => {
          queue.push(request);
        });
      }
      accept(request, front) {
        const path = join(this.root, request.path);
        if (this.closed.peek() !== void 0 || this.pending.get(path) !== request) {
          front.close();
          return;
        }
        this.pending.delete(path);
        const existing = this.served.get(path);
        if (existing && existing.closed.peek() === void 0) {
          front.close();
          this.onChange(path);
          this.settled.update((n2) => n2 + 1);
          return;
        }
        this.served.set(path, front);
        void front.closed.then(() => {
          if (this.served.get(path) !== front)
            return;
          this.served.delete(path);
          this.onChange(path);
        });
        this.onChange(path);
        this.settled.update((n2) => n2 + 1);
      }
      reject(request, err2) {
        const path = join(this.root, request.path);
        if (this.pending.get(path) !== request)
          return;
        this.pending.delete(path);
        if (this.demanding.has(path))
          this.rejected.set(path, err2);
        this.onReject(path, err2);
        this.settled.update((n2) => n2 + 1);
      }
      close(abort) {
        if (this.closed.peek() !== void 0)
          return;
        const err2 = abort ?? noCapacity();
        this.closed.set(err2);
        const queued = [...this.pending.values()];
        this.pending.clear();
        this.queue.mutate((queue) => {
          queue.length = 0;
        });
        for (const request of queued) {
          finishRequest(request, err2);
        }
        for (const [path, front] of this.served) {
          front.close();
          this.onChange(path);
        }
        this.served.clear();
        this.rejected.clear();
        this.demanding.clear();
        this.settled.update((n2) => n2 + 1);
      }
    };
    VersionedSignal = class extends Signal {
      version = 0;
      set(value, notify) {
        this.version++;
        super.set(value, notify);
      }
    };
    OriginState = class {
      // Both tables decouple the application producing into the origin from the
      // connections serving or feeding it. Undefined once the origin closes, so late
      // writes fail loudly.
      //
      // Created is what this endpoint publishes, keyed by exact path, announced or not.
      // Local is the announced subset, with its route in advertisedLocal: a broadcast
      // exists for nobody, here or at a peer, until it announces. Routes is the
      // advertisement table: prefixes a dynamic handle or a received session covers,
      // newest first. Local and routes stay separate so a session can never announce a
      // received entry back to a peer, which is what makes an origin shared by both
      // directions echo-free.
      created = /* @__PURE__ */ new Map();
      local = new VersionedSignal(/* @__PURE__ */ new Map());
      advertisedLocal = new VersionedSignal(/* @__PURE__ */ new Map());
      routes = new VersionedSignal(/* @__PURE__ */ new Map());
      #snapshotVersion = "";
      #snapshot = { candidates: /* @__PURE__ */ new Map(), routes: /* @__PURE__ */ new Map(), visible: /* @__PURE__ */ new Map() };
      /** The full route table is built once per mutation, regardless of observer count. */
      available = new Derived([this.local, this.advertisedLocal, this.routes], () => this.snapshot().routes);
      /** {@link available} without hidden routes, for unscoped readers that did not opt in. */
      visible = new Derived([this.local, this.advertisedLocal, this.routes], () => this.snapshot().visible);
      snapshot() {
        const version2 = `${this.local.version}/${this.advertisedLocal.version}/${this.routes.version}`;
        if (version2 === this.#snapshotVersion)
          return this.#snapshot;
        const candidates = this.candidates();
        const available = /* @__PURE__ */ new Map();
        const visible = /* @__PURE__ */ new Map();
        for (const [path, [best]] of candidates) {
          available.set(path, best.route);
          if (!hiddenBelow(empty(), path))
            visible.set(path, best.route);
        }
        this.#snapshot = { candidates, routes: available, visible };
        this.#snapshotVersion = version2;
        return this.#snapshot;
      }
      /**
       * Every advertisement per prefix, most preferred first, without the `skip`ped entries.
       * Readers select after filtering by their scope, so a cheaper route they cannot see
       * never hides one they can.
       */
      candidates(skip) {
        const out = /* @__PURE__ */ new Map();
        for (const [path, entries] of this.routes.peek() ?? []) {
          const list = [];
          for (const entry of entries) {
            if (skip?.(entry))
              continue;
            list.push({ identity: entry.identity, route: entry.route.peek(), claim: entry.claim, exact: false });
          }
          if (list.length > 0)
            out.set(path, list);
        }
        const advertised = this.advertisedLocal.peek();
        for (const [path, front] of this.local.peek() ?? []) {
          const local = { identity: front, route: advertised?.get(path) ?? Route.default, exact: true };
          const list = out.get(path);
          if (list)
            list.push(local);
          else
            out.set(path, [local]);
        }
        for (const list of out.values()) {
          if (list.length > 1)
            list.sort(compareCandidates);
        }
        return out;
      }
      // Originated advertisements sessions should forward: exact-path announces plus
      // originated dynamics. Identity is the local front or the route entry, so a
      // republish diffs as retract-then-announce and a re-price as another active.
      originated = new Signal(/* @__PURE__ */ new Map());
      // Broadcasts materialized from a served route, keyed by exact path. Shared by every
      // request for the path so repeats reuse one accept; dropped (and closed) when the
      // providing route goes away or the last request releases it.
      materialized = /* @__PURE__ */ new Map();
      // Paths consumers asked for without waiting for an announcement; attached sessions
      // answer them with blind subscriptions. Never announced: an answered request is assumed
      // present, not known live, so it must not read as an availability claim.
      requests = new Signal(/* @__PURE__ */ new Map());
      // How many sessions are attached, and how many of those support broadcast discovery.
      // What backs the public `discovery` getter.
      sessions = new Signal({ total: 0, discovery: 0 });
      // How many things are prepared to answer a request: attached sessions, plus reconnecting
      // connections that have no session right now but will. Zero means an unrouted path is
      // unroutable rather than merely unanswered, which is the whole difference between "wait,
      // this is coming" and "nothing here can ever serve you".
      answerers = new Signal(0);
      closed = new Once();
      /**
       * Recompute what `path` resolves to, waking only the requests watching that path.
       *
       * A no-op for a path nobody requested, so the common case (publishing into a table
       * nobody is asking about) costs a map lookup. Call after any write that could change
       * the answer for a single path.
       */
      refresh(path) {
        const slot2 = this.requests.peek()?.get(path);
        if (!slot2)
          return;
        slot2.route.set(this.route(path, slot2));
      }
      /**
       * `entry` refused `path` with `err`. A request still serving another source skips the
       * refuser; one with nothing serving ends with `err`.
       */
      refuse(path, entry, err2) {
        const slot2 = this.requests.peek()?.get(path);
        if (!slot2)
          return;
        if (this.bestEntry(path, (candidate) => slot2.refused.has(candidate)) !== entry)
          return;
        const serving = slot2.route.peek();
        if (serving && serving.closed.peek() === void 0) {
          slot2.refused.add(entry);
          slot2.route.set(this.route(path, slot2));
          return;
        }
        this.requests.mutate((map) => {
          if (map?.get(path) === slot2)
            map.delete(path);
        });
        slot2.answer?.close();
        slot2.answer = void 0;
        slot2.route.set(void 0);
        this.releaseMaterialized(path);
        for (const closed of slot2.handles)
          closed.set(err2);
        slot2.handles.clear();
      }
      /**
       * Recompute every open request covered by `prefix`, after a route was inserted or
       * removed there: a route covers many paths, so a single-path refresh is not enough.
       * Every materialized broadcast belongs to an open request, so rerouting them also
       * releases a retracted route's session subscription even when nothing reads it again.
       */
      refreshPrefix(prefix) {
        for (const [path, slot2] of this.requests.peek() ?? []) {
          if (hasPrefix(prefix, path))
            slot2.route.set(this.route(path, slot2));
        }
      }
      /** Rebuild the publisher-facing originated table after an advertisement write. */
      rebuildOriginated() {
        if (!this.local.peek() && !this.advertisedLocal.peek() && !this.routes.peek()) {
          this.originated.set(void 0);
          return;
        }
        this.originated.set(this.candidates(received));
      }
      /**
       * Release the materialized broadcast for `path`, once its last request is gone: the
       * cache exists to share one session subscription between requests, not to outlive
       * them.
       */
      releaseMaterialized(path) {
        const cached2 = this.materialized.get(path);
        if (!cached2)
          return;
        this.materialized.delete(path);
        cached2.front.close();
      }
      /** The preferred entry on the most specific route covering `path`, ignoring skipped entries, if any. */
      bestEntry(path, skip) {
        let bestPrefix;
        let best;
        for (const [prefix, entries] of this.routes.peek() ?? []) {
          if (!hasPrefix(prefix, path))
            continue;
          const entry = preferredEntry(entries, (candidate) => !candidate.scope.matches(path) || (skip?.(candidate) ?? false));
          if (!entry)
            continue;
          if (bestPrefix === void 0 || prefix.length > bestPrefix.length) {
            bestPrefix = prefix;
            best = entry;
          }
        }
        return best;
      }
      /**
       * Whether the announced local broadcast at `path` wins over `entry`, the best route a
       * session or dynamic handle announced there. Cost decides, as for any two routes: an
       * identified route strictly cheaper than the local one wins, and the local broadcast
       * wins a tie. A route at a shorter prefix never competes, since the most specific
       * prefix wins outright. False when nothing is announced locally at `path`.
       */
      localWins(path, entry) {
        const local = this.advertisedLocal.peek()?.get(path);
        if (!local || !this.local.peek()?.has(path))
          return false;
        if (!entry || !this.routes.peek()?.get(path)?.includes(entry))
          return true;
        return compareRoutes(local, entry.route.peek()) <= 0;
      }
      /**
       * What `path` resolves to: an announced local publish, a broadcast materialized from
       * the best covering route, or the blind answer.
       *
       * Materialization is lazy and cached per path: the first request under a route opens
       * the providing session's subscription and repeats share it. A better route is made
       * before the old one breaks: the current front keeps serving until the new route
       * answers (then swaps) or refuses (then is skipped). A retracted route swaps at once.
       */
      route(path, slot2) {
        const entry = this.bestEntry(path, (candidate) => slot2.refused.has(candidate));
        const local = this.local.peek()?.get(path);
        if (local && this.localWins(path, entry)) {
          this.releaseMaterialized(path);
          return local;
        }
        let cached2 = this.materialized.get(path);
        if (cached2 && cached2.front.closed.peek() !== void 0) {
          this.materialized.delete(path);
          cached2 = void 0;
        }
        if (cached2 && cached2.entry === entry)
          return cached2.front;
        if (!entry?.server) {
          this.releaseMaterialized(path);
          return slot2.answer;
        }
        const served = entry.server.served.get(path);
        if (served && served.closed.peek() === void 0) {
          cached2?.front.close();
          this.materialized.set(path, { entry, front: served });
          return served;
        }
        entry.server.enqueue(path);
        return cached2?.front;
      }
    };
    Producer5 = class _Producer {
      #state = new OriginState();
      #scope = Scope.all;
      #requests;
      // The reader backing the passthroughs, so holding a Producer never requires the
      // consume().x() stutter for everyday reads. One instance, so `discovery` keeps its
      // identity across reads.
      #reader = makeConsumer4(this.#state, this.#scope);
      constructor() {
        const thisProducer = this;
        registerWire(this, {
          receive: (prefix, route) => this.#receive(prefix, route),
          interests: () => this.#scope.heads(),
          accepts: (prefix) => !this.#scope.allowed || this.#scope.allowed.overlaps(Pattern.subtree(join(this.#scope.root, prefix))),
          attach: (discovery) => this.#attach(discovery),
          expect: () => this.#expect(),
          get requests() {
            if (thisProducer.#scope === Scope.all)
              return thisProducer.#state.requests;
            thisProducer.#requests ??= new Derived([thisProducer.#state.requests], (requests) => thisProducer.#scope.projectPaths(requests));
            return thisProducer.#requests;
          },
          changed: () => this.#changed(),
          answer: (path, front) => this.#answer(this.#scope.path(path), front),
          routes: (path) => wireOf(this.#reader).routes(path)
        });
      }
      /** Narrow this handle to patterns beneath root, presenting paths relative to that root. */
      scope(root, patterns) {
        const scope = this.#scope.narrow(root, patterns);
        const producer = new _Producer();
        producer.#state = this.#state;
        producer.#scope = scope;
        producer.#reader = makeConsumer4(this.#state, scope);
        return producer;
      }
      /**
       * Settles once the origin closes: `null` on a clean close, or the abort {@link Error}.
       * Peek it synchronously (`undefined` while open), observe it reactively, or `await` it.
       */
      get closed() {
        return this.#state.closed;
      }
      /**
       * Create a broadcast at `path`, returning its producer.
       *
       * The broadcast exists for nobody until {@link broadcast.Producer.announce}: announce
       * streams skip it and requests for its path find nothing, on this origin exactly as at
       * a peer. Announce once its tracks exist; {@link broadcast.Producer.unannounce}
       * withdraws it from everyone again.
       *
       * Close the producer to drop it. Creating a path again supersedes the previous
       * broadcast: the origin drops its handle on the old one, which closes it unless the
       * application still holds a consumer clone. An announced local broadcast competes with
       * a remote route at the same path on cost, winning ties.
       */
      createBroadcast(path) {
        path = this.#scope.path(path);
        const created = this.#state.created;
        if (!created)
          throw new Error("origin is closed");
        const producer = new Producer4();
        hooks.stampPath(producer, path);
        const front = producer.consume();
        hooks.attachAnnouncer(producer, {
          announce: (route) => this.#advertiseExact(path, front, route),
          unannounce: () => this.#retractExact(path, front)
        });
        const previous = created.get(path);
        created.set(path, front);
        if (previous) {
          this.#retractExact(path, previous);
          previous.close();
        }
        void front.closed.then(() => {
          this.#retractExact(path, front);
          if (this.#state.created?.get(path) === front)
            this.#state.created.delete(path);
        });
        return producer;
      }
      #advertiseExact(path, front, route) {
        if (!this.#state.local.peek())
          throw new Error("origin is closed");
        if (this.#state.created?.get(path) !== front)
          throw new Error("broadcast is closed");
        this.#state.local.mutate((broadcasts) => {
          broadcasts?.set(path, front);
        });
        this.#state.advertisedLocal.mutate((advertised) => {
          advertised?.set(path, route);
        });
        this.#state.rebuildOriginated();
        this.#state.refresh(path);
      }
      #retractExact(path, front) {
        if (this.#state.local.peek()?.get(path) !== front)
          return;
        this.#state.local.mutate((broadcasts) => {
          broadcasts?.delete(path);
        });
        this.#state.advertisedLocal.mutate((advertised) => {
          advertised?.delete(path);
        });
        this.#state.rebuildOriginated();
        this.#state.refresh(path);
      }
      /**
       * Advertise `prefix` and serve the requests beneath it.
       *
       * A route is always a prefix: it claims `prefix` and every path beneath it (the
       * empty prefix claims every path). A service that only serves some of them
       * advertises the covering prefix and rejects the rest as they are requested;
       * consumers narrow with a {@link Path.Pattern} locally. The advertisement is
       * visible to {@link Consumer.announced} and forwarded by sessions for as long as
       * the returned {@link Dynamic} lives. A consumer resolving a path under it that
       * no announced local broadcast wins is handed to the handle as a {@link Request}.
       */
      dynamic(prefix, route = Route.default) {
        return this.#insertRoute(prefix, Route.normalize(route), true);
      }
      /**
       * Land a route a peer announced, served through the returned handle. Same as
       * {@link dynamic} but not originated, so a session never announces it back.
       *
       * @internal
       */
      #receive(prefix, route = Route.default) {
        return this.#insertRoute(prefix, Route.normalize(route), false);
      }
      #insertRoute(prefix, route, originated) {
        prefix = this.#scope.prefix(prefix);
        const server = new ServeState(this.#scope.root);
        server.onChange = (path) => this.#state.refresh(path);
        const entry = {
          identity: {},
          scope: this.#scope,
          claim: this.#scope.allowed?.intersect(new Patterns([Pattern.subtree(prefix)])),
          route: new Signal(route),
          originated,
          server
        };
        server.onReject = (path, err2) => this.#state.refuse(path, entry, err2);
        let closed = false;
        this.#state.routes.mutate((routes) => {
          if (!routes) {
            closed = true;
            return;
          }
          const entries = routes.get(prefix);
          if (entries)
            entries.unshift(entry);
          else
            routes.set(prefix, [entry]);
        });
        if (closed) {
          server.close();
          return makeDynamic(prefix, entry, this.#state, () => {
          });
        }
        this.#state.rebuildOriginated();
        this.#state.refreshPrefix(prefix);
        const retract = () => {
          this.#state.routes.mutate((routes) => {
            const entries = routes?.get(prefix);
            if (!entries)
              return;
            const index2 = entries.indexOf(entry);
            if (index2 < 0)
              return;
            entries.splice(index2, 1);
            if (entries.length === 0)
              routes?.delete(prefix);
          });
          for (const slot2 of this.#state.requests.peek()?.values() ?? [])
            slot2.refused.delete(entry);
          server.close();
          this.#state.rebuildOriginated();
          this.#state.refreshPrefix(prefix);
        };
        return makeDynamic(prefix, entry, this.#state, retract);
      }
      /**
       * Register an attached session, counting it toward the `discovery` state. Returns the
       * detach; call it exactly once when the session dies.
       *
       * @internal
       */
      #attach(discovery) {
        this.#sessions(1, discovery);
        const release = this.#expect();
        let detached = false;
        return () => {
          if (detached)
            return;
          detached = true;
          this.#sessions(-1, discovery);
          release();
        };
      }
      #sessions(delta, discovery) {
        this.#state.sessions.update(({ total, discovery: d2 }) => ({
          total: total + delta,
          discovery: d2 + (discovery ? delta : 0)
        }));
      }
      /**
       * Declare that something will answer requests on this origin, even with no session
       * attached right now.
       *
       * A reconnecting connection holds one for its whole life, so a request made during a
       * reconnect (or before the first session establishes) stays pending instead of reading as
       * unroutable. Without it, {@link Request.unroutable} would fire on every page load, in the
       * window between wiring the origin up and the handshake completing. Call the returned
       * dispose when the connection is done for good.
       *
       * @internal
       */
      #expect() {
        this.#state.answerers.update((count2) => count2 + 1);
        let released = false;
        return () => {
          if (released)
            return;
          released = true;
          this.#state.answerers.update((count2) => Math.max(0, count2 - 1));
        };
      }
      /**
       * Resolves once anything a serving session scans changes: the open requests, or either
       * side of the routing table.
       *
       * @internal
       */
      #changed() {
        return Signal.race(this.#state.requests, this.#state.local, this.#state.routes, this.#state.advertisedLocal);
      }
      /**
       * Provide `front` as the answer for the open request on `path`, taking ownership of it.
       *
       * Returns undefined (releasing the front) when the request is gone or already answered;
       * first session in wins, and a loser must stay eligible to answer later. The returned
       * withdraw releases the front and, if it was the standing answer, vacates the slot and
       * wakes the other serving loops so a standby session answers immediately; call it when
       * the session dies.
       *
       * @internal
       */
      #answer(path, front) {
        const slot2 = this.#state.requests.peek()?.get(path);
        if (!slot2 || slot2.answer !== void 0) {
          front.close();
          return void 0;
        }
        slot2.answer = front;
        this.#state.refresh(path);
        return () => {
          if (slot2.answer === front) {
            slot2.answer = void 0;
            this.#state.refresh(path);
            this.#state.requests.mutate(() => {
            });
          }
          front.close();
        };
      }
      /** A read handle for this origin, the side a connection's `publish` option borrows. */
      consume() {
        return makeConsumer4(this.#state, this.#scope);
      }
      /** Whether every attached session announces into the table; see {@link Consumer.discovery}. */
      get discovery() {
        return this.#reader.discovery;
      }
      /** Resolve `path`, optionally waiting for an announcement; see {@link Consumer.request}. */
      request(path, options) {
        return this.#reader.request(path, options);
      }
      /** The available announcements under `scope`, as a live map; see {@link Consumer.broadcasts}. */
      broadcasts(scope, options) {
        return this.#reader.broadcasts(scope, options);
      }
      /** The available broadcasts under `scope`, as a live stream; see {@link Consumer.announced}. */
      announced(scope, options) {
        return this.#reader.announced(scope, options);
      }
      /** Close the origin, every broadcast it still routes, and its announcement streams. Idempotent. */
      close(abort) {
        if (this.#state.closed.peek() !== void 0)
          return;
        this.#state.closed.set(abort ?? null);
        for (const front of this.#state.created?.values() ?? []) {
          front.close();
        }
        this.#state.created = void 0;
        this.#state.local.update(() => void 0);
        this.#state.advertisedLocal.update(() => void 0);
        this.#state.routes.update((routes) => {
          for (const entries of routes?.values() ?? []) {
            for (const entry of entries)
              entry.server?.close(abort);
          }
          return void 0;
        });
        this.#state.originated.update(() => void 0);
        for (const cached2 of this.#state.materialized.values()) {
          cached2.front.close();
        }
        this.#state.materialized.clear();
        this.#state.answerers.set(0);
        this.#state.requests.update((requests) => {
          for (const slot2 of requests?.values() ?? []) {
            slot2.answer?.close();
            slot2.answer = void 0;
            slot2.route.set(void 0);
          }
          return void 0;
        });
      }
    };
    Requesting = class _Requesting {
      /** The requested path. */
      path;
      /**
       * The resolved broadcast, or undefined while nothing provides the path.
       *
       * The table's route when it has one: a local publish (no round trip) or an announced
       * broadcast, swapping when a republish takes the path. Otherwise a session's blind
       * answer, which is assumed present rather than known live: a missing broadcast
       * surfaces as a reset on the first track subscription, not here. Drops back to
       * undefined when the providing route dies and resolves again when another appears.
       *
       * Yours for as long as the request is open: it is a handle of this request's own, so
       * closing it ends your view of the path rather than the route everyone else reads.
       * {@link close} releases whatever is current.
       */
      active;
      /**
       * Whether nothing can serve this path, as opposed to not having served it yet.
       *
       * True when the origin routes nothing here and nothing is prepared to answer: no session
       * attached and no connection reconnecting toward one. False whenever {@link active} is
       * set, and false while a connection is still coming up, so the ordinary page-load window
       * before the first handshake reads as pending rather than as a missing broadcast. Waiting
       * on this is futile by definition; wait for an announcement instead, via the origin's
       * `announced`. True once the request is refused.
       */
      unroutable;
      /**
       * Settles with the error a route's handler refused the path with, or `null` once you
       * {@link close} the request. A refusal is final: no other route is asked, and a fresh
       * request is needed to try again.
       */
      closed;
      #dispose;
      #disposed = false;
      constructor(path, active, unroutable, closed, dispose) {
        this.path = path;
        this.active = active;
        this.unroutable = unroutable;
        this.closed = closed;
        this.#dispose = dispose;
      }
      static {
        makeRequesting = (path, active, unroutable, closed, dispose) => new _Requesting(path, active, unroutable, closed, dispose);
      }
      /** Withdraw the request. The path stays routed for any other open request. Idempotent. */
      close() {
        if (this.#disposed)
          return;
        this.#disposed = true;
        this.#dispose();
      }
    };
    Consumer5 = class _Consumer {
      #state;
      #scope;
      constructor(state, scope) {
        this.#state = state;
        this.#scope = scope;
        this.#discovery = new Derived([state.sessions], ({ total, discovery }) => total === 0 ? void 0 : discovery === total);
        registerWire(this, {
          routes: (path) => this.#routes(scope.path(path)),
          broadcasts: scope === Scope.all ? state.local : new Derived([state.local], (local) => scope.projectPaths(local)),
          advertised: scope === Scope.all ? state.originated : new Derived([state.originated], (routes) => scope.projectRoutes(routes)),
          local: (path) => this.#local(scope.path(path)),
          demand: (path) => this.#demand(scope.path(path))
        });
      }
      static {
        makeConsumer4 = (state, scope) => new _Consumer(state, scope);
      }
      /** Settles once the origin closes; see {@link Producer.closed}. */
      get closed() {
        return this.#state.closed;
      }
      /**
       * Whether the announcement table sees everything the attached sessions can serve.
       *
       * Undefined while no session is attached (nothing is known yet), true when every attached
       * session announces into the table, and false as soon as one does not, where
       * {@link announced} cannot be complete and consumers should {@link request} paths instead
       * of waiting. One blind session among several is still false: the paths only it carries
       * never reach the table, so a consumer that trusted the gate would never see them.
       */
      get discovery() {
        return this.#discovery;
      }
      // Derived per access rather than cached: a lightweight mapped view over the session
      // counts, avoiding a Computed's lifecycle.
      #discovery;
      /**
       * Whether the table routes `path`, by an announced local publish or an announced
       * route covering it.
       *
       * Availability, not a handle: {@link request} is the only way to consume by path. A
       * request on a routed path resolves to that route and never to a blind answer, which is
       * why a serving session leaves it alone.
       *
       * @internal
       */
      #routes(path) {
        if (this.#state.local.peek()?.has(path))
          return true;
        return this.#state.bestEntry(path) !== void 0;
      }
      /**
       * Resolve `path`, optionally waiting for an announcement.
       *
       * The one way to consume by path. {@link Requesting.active} follows whatever the table
       * routes (an announced local publish, or any feeding session's announcement, swapping
       * on a republish or a retraction); when nothing does, the request stands and whichever
       * attached session answers first provides a blind subscription instead, re-answered
       * across reconnects.
       * With `announced: true`, an unrouted request waits while discovery is supported and
       * falls back to that blind behavior only when discovery is unavailable. Close the request
       * when done. On a closed origin it never resolves.
       *
       * With several sessions on one origin the first to answer wins, and it may be one that
       * does not carry the path. Nothing corrects that: a missing broadcast surfaces as a reset
       * on the first track and deliberately leaves the handle open, since the wire cannot tell
       * "not here" from "not yet" and a blind handle is expected to survive until a publisher
       * arrives. It matters only on an origin mixing sessions that announce with sessions that
       * cannot, where a path only the silent session carries may sit behind another session's
       * answer. Prefer {@link unroutable} and announcements over blind requests when the origin
       * feeds from more than one connection.
       */
      request(path, options = {}) {
        const relative2 = path;
        path = this.#scope.path(path);
        const requests = this.#state.requests.peek();
        if (!requests) {
          const closed2 = new Once();
          return makeRequesting(relative2, new Signal(void 0), getter(true), closed2, () => closed2.set(null));
        }
        let slot2 = requests.get(path);
        if (!slot2) {
          const refused = /* @__PURE__ */ new Set();
          const created = {
            blind: 0,
            handles: /* @__PURE__ */ new Set(),
            refused,
            route: new Signal(this.#state.route(path, { refused }))
          };
          slot2 = created;
          this.#state.requests.mutate((map) => {
            map?.set(path, created);
          });
        }
        const closed = new Once();
        slot2.handles.add(closed);
        let blind = !options.announced || this.#discovery.peek() === false;
        if (blind)
          slot2.blind += 1;
        this.#state.requests.mutate(() => {
        });
        const unsubscribeDiscovery = options.announced ? this.#discovery.subscribe((discovery) => {
          const next = discovery === false;
          if (next === blind)
            return;
          blind = next;
          slot2.blind += next ? 1 : -1;
          this.#state.requests.mutate(() => {
          });
        }) : () => {
        };
        const taken = slot2;
        let released = false;
        let source;
        let handle;
        const own2 = (front) => {
          if (released)
            return void 0;
          if (front !== source) {
            const previous = handle;
            source = front;
            handle = front?.clone();
            if (handle)
              hooks.stampPath(handle, relative2);
            previous?.close();
          }
          return handle;
        };
        const route = taken.route;
        const active = new Derived([route], own2);
        const unsubscribe = route.subscribe(own2);
        const unroutable = new Derived([route, this.#state.answerers, closed], (front, answerers, ended) => ended !== void 0 || !front && answerers === 0);
        return makeRequesting(relative2, active, unroutable, closed, () => {
          released = true;
          unsubscribeDiscovery();
          unsubscribe();
          handle?.close();
          handle = void 0;
          source = void 0;
          taken.handles.delete(closed);
          if (closed.peek() === void 0)
            closed.set(null);
          if (blind)
            taken.blind -= 1;
          this.#state.requests.mutate(() => {
          });
          if (taken.handles.size > 0)
            return;
          queueMicrotask(() => {
            if (taken.handles.size > 0)
              return;
            if (this.#state.requests.peek()?.get(path) !== taken)
              return;
            this.#state.requests.mutate((map) => {
              map?.delete(path);
            });
            taken.answer?.close();
            taken.answer = void 0;
            taken.route.set(void 0);
            this.#state.releaseMaterialized(path);
          });
        });
      }
      /**
       * The announced routes matching `scope`, as a live map from covered prefix to route.
       * Local broadcasts appear once announced; received and dynamic routes retain their
       * advertised prefixes. Reads are synchronous, and the getter needs no teardown.
       * Hidden routes are left out unless `options.hidden` opts in (see {@link announce.Options}).
       * Unscoped readers share one snapshot; each distinct scope filters the table on changes.
       */
      broadcasts(scope, options) {
        const hidden = options?.hidden ?? false;
        if (!scope && this.#scope === Scope.all)
          return hidden ? this.#state.available : this.#state.visible;
        const patterns = this.#scope.patterns(scope);
        return new Derived([this.#state.available], () => {
          const routes = /* @__PURE__ */ new Map();
          for (const [path, entry] of this.#listed(patterns, hidden))
            routes.set(path, entry.route);
          return routes;
        });
      }
      /**
       * The announced routes matching `scope`, as a live stream: every currently advertised
       * route arrives first as active, then additions and retractions as they happen.
       * Any pattern is accepted. A local broadcast appears once it announces, exactly as a
       * peer sees it. A dynamic or received route announces the prefix it covers when its
       * subtree overlaps the scope. The stream ends when the origin closes or the consumer is
       * closed. Hidden routes are left out unless `options.hidden` opts in (see {@link announce.Options}).
       */
      announced(scope = Pattern.all(), options) {
        const producer = new Producer();
        void this.#runAnnounced(producer, this.#scope.patterns(scope), options?.hidden ?? false);
        return producer.consume();
      }
      /** One snapshot shared by map readers and announcement-stream diffing. */
      #listed(patterns, hidden) {
        const next = /* @__PURE__ */ new Map();
        const covering = new CoveringRoot(this.#scope.root);
        const scopes = [...patterns].sort((a2, b3) => compareSpecificity(b3.specificity(), a2.specificity())).map((pattern) => ({ pattern, head: scopeHead(pattern) }));
        for (const [path, candidates] of this.#state.snapshot().candidates) {
          let entry;
          let scope;
          for (const candidate of candidates) {
            scope = scopes.find(({ pattern, head }) => (candidate.exact ? pattern.matches(path) : advertOverlaps(candidate, path, pattern)) && (hidden || !hiddenBelow(head, path)));
            if (scope) {
              entry = candidate;
              break;
            }
          }
          if (!entry || !scope)
            continue;
          const relative2 = covering.relative(path);
          if (relative2 === void 0)
            continue;
          next.set(relative2, {
            identity: entry.identity,
            route: entry.route,
            captures: scopeCaptures(scope.pattern, path)
          });
        }
        return next;
      }
      async #runAnnounced(producer, patterns, hidden) {
        let active = /* @__PURE__ */ new Map();
        try {
          for (; ; ) {
            const local = this.#state.local.peek();
            const advertisedLocal = this.#state.advertisedLocal.peek();
            const routes = this.#state.routes.peek();
            if (local === void 0 && advertisedLocal === void 0 && routes === void 0)
              break;
            const next = this.#listed(patterns, hidden);
            for (const [path, snap] of active) {
              const cur = next.get(path);
              if (!cur || cur.identity !== snap.identity)
                producer.append({
                  prefix: path,
                  captures: snap.captures,
                  kind: "retracted",
                  route: snap.route
                });
            }
            for (const [path, snap] of next) {
              const prev = active.get(path);
              if (!prev || prev.identity !== snap.identity) {
                producer.append({
                  prefix: path,
                  captures: snap.captures,
                  kind: "announced",
                  route: snap.route
                });
              } else if (!routesEqual(prev.route, snap.route)) {
                producer.append({ prefix: path, captures: snap.captures, kind: "updated", route: snap.route });
              }
            }
            active = next;
            await Signal.race(this.#state.local, this.#state.advertisedLocal, this.#state.routes, producer.closed);
            if (producer.closed.peek() !== void 0)
              return;
          }
        } catch {
        }
        producer.close();
      }
      /**
       * The local table, borrowed by the wire publishers to answer subscribes.
       *
       * Deliberately excludes received routes: a session never re-announces what a peer
       * told it, so an origin wired to both directions of a connection cannot echo.
       * Borrowed, not owned: do not close the fronts. Undefined once the origin closes.
       *
       * @internal
       */
      /**
       * Originated advertisements a session should forward: exact-path announces plus
       * originated dynamics. Undefined once the origin closes.
       *
       * @internal
       */
      /**
       * The announced local broadcast at `path`, when it beats the originated routes there.
       * Resolves through what rebuildOriginated advertised: a peer never sees received routes.
       */
      #local(path) {
        const local = this.#state.local.peek()?.get(path);
        if (local && this.#state.localWins(path, this.#state.bestEntry(path, received)))
          return local;
        return void 0;
      }
      /**
       * Resolve `path` for serving: an announced local broadcast, or wait for an originated
       * dynamic to accept it. Undefined when nothing here can serve the path.
       *
       * @internal
       */
      async #demand(path) {
        const local = this.#local(path);
        if (local)
          return local;
        const entry = this.#state.bestEntry(path, received);
        if (!entry?.server)
          return void 0;
        const server = entry.server;
        const live = server.served.get(path);
        if (live && live.closed.peek() === void 0)
          return live;
        server.enqueue(path);
        server.demanding.set(path, (server.demanding.get(path) ?? 0) + 1);
        try {
          for (; ; ) {
            const served = server.served.get(path);
            if (served && served.closed.peek() === void 0)
              return served;
            const rejected = server.rejected.get(path);
            if (rejected) {
              server.rejected.delete(path);
              throw rejected;
            }
            const closed = server.closed.peek();
            if (closed !== void 0) {
              if (closed)
                throw closed;
              return void 0;
            }
            if (!server.pending.has(path))
              return void 0;
            await Signal.race(server.settled, server.closed);
          }
        } finally {
          const n2 = (server.demanding.get(path) ?? 1) - 1;
          if (n2 <= 0)
            server.demanding.delete(path);
          else
            server.demanding.set(path, n2);
        }
      }
    };
    Dynamic = class _Dynamic {
      /** The prefix this handle advertises. */
      prefix;
      #entry;
      #state;
      #retract;
      #closed = false;
      constructor(prefix, entry, state, retract) {
        this.prefix = stripPrefix(entry.scope.root, prefix) ?? empty();
        this.#entry = entry;
        this.#state = state;
        this.#retract = retract;
      }
      static {
        makeDynamic = (prefix, entry, state, retract) => new _Dynamic(prefix, entry, state, retract);
      }
      /** Re-price the route in place. The prefix is fixed at announce time. */
      update(route) {
        if (this.#closed)
          throw new Error("dynamic is closed");
        this.#entry.route.set(Route.normalize(route));
        this.#state.rebuildOriginated();
        this.#state.refreshPrefix(join(this.#entry.scope.root, this.prefix));
        this.#state.routes.mutate(() => {
        });
      }
      /** Retract the route and reject anything still waiting. Idempotent. */
      close() {
        if (this.#closed)
          return;
        this.#closed = true;
        this.#retract();
      }
      /** Requests under this prefix, as they arrive, each to {@link Request.accept} or reject. */
      async *requested() {
        const server = this.#entry.server;
        if (!server)
          return;
        let current;
        const drop = () => {
          current?.reject(noCapacity());
          current = void 0;
        };
        try {
          for (; ; ) {
            const next = server.queue.peek()[0];
            if (next) {
              drop();
              server.queue.mutate((queue) => {
                queue.shift();
              });
              current = next;
              yield next;
              continue;
            }
            if (server.closed.peek() !== void 0)
              return;
            await Signal.race(server.queue, server.closed);
          }
        } finally {
          drop();
        }
      }
    };
    Request2 = class _Request {
      /** The path that was requested. */
      path;
      #server;
      #done = false;
      constructor(path, server) {
        this.path = path;
        this.#server = server;
      }
      static {
        makeRequest = (path, server) => new _Request(path, server);
        finishRequest = (request, err2) => {
          request.#done = true;
          void err2;
        };
      }
      /**
       * Accept the request, resolving every awaiting requester with `broadcast`.
       *
       * The caller keeps producing into `broadcast`; repeat requests for the path share
       * it for as long as it stays live.
       */
      accept(source) {
        if (this.#done)
          return;
        this.#done = true;
        const front = source instanceof Producer4 ? source.consume() : source;
        this.#server.accept(this, front);
      }
      /** Reject the request, resolving every awaiting requester with `err`. */
      reject(err2) {
        if (this.#done)
          return;
        this.#done = true;
        this.#server.reject(this, err2);
      }
    };
  }
});

// ../../node_modules/@moq/net/connection/goaway.js
function handover(cap, timeout) {
  return timeout !== void 0 && timeout > 0 ? Milli(Math.min(cap, timeout)) : cap;
}
function dialed(primary, transport, websocket) {
  return transport === "websocket" && websocket ? websocket : primary;
}
function pinnedTransport(transport, configured) {
  return configured && transport === "webtransport";
}
function target(policy, uri, current, pinned) {
  if (uri === "")
    return void 0;
  let next;
  try {
    next = new URL(uri);
  } catch {
    throw new RefusedRedirect("the GOAWAY URI is malformed");
  }
  if (policy === "ignore")
    return void 0;
  if (schemeTier(next.protocol) < schemeTier(current.protocol)) {
    throw new RefusedRedirect("the GOAWAY redirect downgrades the scheme");
  }
  if (isLocal(next) && !isLocal(current)) {
    throw new RefusedRedirect("the GOAWAY redirect widens reachability to a local address");
  }
  const sameHost = next.hostname === current.hostname;
  if (policy === "same-host" && !sameHost) {
    throw new RefusedRedirect("the GOAWAY redirect leaves the current host");
  }
  if (pinned && !sameHost) {
    throw new RefusedRedirect("the GOAWAY redirect leaves the host a certificate pin verifies");
  }
  return next;
}
function schemeTier(protocol) {
  switch (protocol) {
    case "https:":
    case "wss:":
    case "moqt:":
    case "moql:":
      return 2;
    case "http:":
    case "ws:":
    case "tcp:":
      return 1;
    default:
      return 0;
  }
}
function isLocal(url2) {
  const host = url2.hostname.toLowerCase();
  if (host === "")
    return true;
  if (host === "localhost" || host.endsWith(".localhost"))
    return true;
  if (host.startsWith("[") && host.endsWith("]")) {
    const segments = parseIpv6(host.slice(1, -1));
    return segments !== void 0 && isLocalV6(segments);
  }
  const v4 = parseIpv4(host);
  return v4 !== void 0 && isLocalV4(v4);
}
function parseIpv4(host) {
  const parts3 = host.split(".");
  if (parts3.length !== 4)
    return void 0;
  const octets = parts3.map((part) => /^\d{1,3}$/.test(part) ? Number(part) : Number.NaN);
  return octets.every((octet) => octet <= 255) ? octets : void 0;
}
function isLocalV4([a2, b3, c2, d2]) {
  return a2 === 127 || a2 === 10 || a2 === 172 && b3 >= 16 && b3 <= 31 || a2 === 192 && b3 === 168 || a2 === 169 && b3 === 254 || a2 === 0 && b3 === 0 && c2 === 0 && d2 === 0;
}
function parseIpv6(host) {
  let text = host.split("%")[0] ?? "";
  const lastColon = text.lastIndexOf(":");
  const quad = parseIpv4(text.slice(lastColon + 1));
  if (quad) {
    const [a2 = 0, b3 = 0, c2 = 0, d2 = 0] = quad;
    const word = (hi, lo) => (hi << 8 | lo).toString(16);
    text = `${text.slice(0, lastColon + 1)}${word(a2, b3)}:${word(c2, d2)}`;
  }
  const halves = text.split("::");
  if (halves.length > 2)
    return void 0;
  const words = (part) => part === "" ? [] : part.split(":");
  const head = words(halves[0] ?? "");
  const rest = halves.length === 2 ? words(halves[1] ?? "") : [];
  const missing = 8 - head.length - rest.length;
  if (halves.length === 2 ? missing < 0 : missing !== 0)
    return void 0;
  const all = [...head, ...Array(missing).fill("0"), ...rest];
  const segments = all.map((word) => /^[0-9a-f]{1,4}$/i.test(word) ? Number.parseInt(word, 16) : Number.NaN);
  return segments.some(Number.isNaN) ? void 0 : segments;
}
function isLocalV6(segments) {
  if (segments.slice(0, 5).every((s) => s === 0) && segments[5] === 65535) {
    const [hi = 0, lo = 0] = segments.slice(6);
    return isLocalV4([hi >> 8, hi & 255, lo >> 8, lo & 255]);
  }
  const first = segments[0] ?? 0;
  const zeroPrefix = segments.slice(0, 7).every((s) => s === 0);
  const last = segments[7] ?? 0;
  return (
    // Loopback (::1) and unspecified (::).
    zeroPrefix && (last === 1 || last === 0) || // Unique local (fc00::/7) and link local (fe80::/10).
    (first & 65024) === 64512 || (first & 65472) === 65152
  );
}
var DEFAULT_HANDOVER;
var init_goaway3 = __esm({
  "../../node_modules/@moq/net/connection/goaway.js"() {
    init_error2();
    init_time();
    DEFAULT_HANDOVER = Milli(1e4);
  }
});

// ../../node_modules/@moq/net/connection/reload.js
var DEFAULT_DELAY, BANDWIDTH_POLL, Reload, Draining;
var init_reload = __esm({
  "../../node_modules/@moq/net/connection/reload.js"() {
    init_signals();
    init_announced();
    init_bandwidth();
    init_error2();
    init_path();
    init_time();
    init_wire();
    init_connect();
    init_goaway3();
    DEFAULT_DELAY = {
      initial: Milli(1e3),
      multiplier: 2,
      max: Milli(5e3),
      timeout: Milli(1e4)
    };
    BANDWIDTH_POLL = 100;
    Reload = class {
      /** Relay URL to connect to; updating it triggers a reconnect. */
      url;
      /** Whether reconnecting is active. */
      enabled;
      /** Current connection status. */
      status = new Signal("disconnected");
      /**
       * The failure that stopped retrying the current URL, or undefined while the loop is live.
       *
       * Set on an auth rejection or when the retry window expires. Cleared when a new URL or a
       * disable/re-enable starts another sequence, not on a page hide/show. Transient drops
       * that are still being retried leave this empty.
       */
      error;
      /** The currently established session, or undefined while disconnected. */
      established = new Signal(void 0);
      /**
       * The current connection's PROBE estimates, spanning reconnects.
       *
       * Undefined while disconnected: the estimates belong to a single connection.
       * See {@link Established.probe}.
       */
      probe;
      /**
       * Divides this connection's send-rate estimate among the tracks sharing it.
       *
       * The same instance across reconnects, so reservations survive a drop. The
       * estimate is `undefined` while disconnected, which tells a sender to hold
       * its rate rather than encode at zero.
       */
      bandwidth;
      /** WebTransport options applied to each connection attempt (not reactive). */
      webtransport;
      /** WebSocket fallback options applied to each connection attempt (not reactive). */
      websocket;
      /**
       * Whether the relay supports broadcast discovery, applied to each connection attempt (not
       * reactive). Undefined defers to the default for the URL. See {@link Established.discovery}.
       */
      discovery;
      /**
       * The origin whose broadcasts are served, spanning reconnects (not reactive).
       *
       * Each session announces the origin's table when it attaches, so a broadcast published
       * while offline surfaces on the next connection and a reconnect re-announces everything
       * still published. See the `publish` connect option.
       */
      publish;
      /**
       * The origin fed with the peer's announced broadcasts, spanning reconnects (not
       * reactive).
       *
       * The entries a session fed retract when it dies, and the next session re-populates the
       * table, so a consumer watching the origin sees offline/online transitions across a
       * reconnect. See the `consume` connect option.
       */
      consume;
      /** Backoff settings for the reconnect loop; an unset field uses its default. */
      delay;
      /** How to react to the peer's GOAWAY (not reactive). */
      goaway;
      /**
       * The URL an accepted GOAWAY redirect assigned, or undefined while the loop dials
       * {@link Reload.url}. Sticky across reconnects: a redirect is an assignment, not a
       * detour. Cleared when a new URL or a disable/re-enable starts another sequence.
       */
      redirect;
      /** The reactive effect scope driving the connect loop; closed by {@link Reload.close}. */
      #signals = new Effect();
      // Sampled from the live session; undefined while disconnected or the transport has none.
      #estimate = new Signal(void 0);
      /**
       * Settles once this loop is disposed via {@link Reload.close}: `null` on a clean close,
       * or the abort {@link Error}. Peek it synchronously (`undefined` while open), observe it
       * reactively, or `await` it. Attempt failures live on {@link Reload.error} instead.
       */
      get closed() {
        return this.#closed;
      }
      #closed = new Once();
      #error = new Signal(void 0);
      #redirect = new Signal(void 0);
      // The configured href the redirect was assigned for.
      #redirectHref;
      // A session the peer sent GOAWAY on, serving its groups in flight while the replacement
      // dials. Retired when it closes, at its handover cap, or when the sequence ends.
      #draining;
      // Whether a connect attempt is in flight, so a retiring predecessor reports the right status.
      #dialing = false;
      // The current wait between attempts, doubling per failure, and when the retry window expires.
      // Both are undefined between sequences, so a later edit to `delay` applies to the next one.
      #delay;
      #deadline;
      // The URL the current retry sequence is for. Cleared when disabled, URL-less, or given
      // up, so the next attempt starts a fresh backoff window.
      #sequenceHref;
      // The href that exhausted its retry sequence. Survives a page hide/show so resume does
      // not redial credentials the peer already refused. Cleared when the URL changes or the
      // loop is disabled.
      #givenUpHref;
      // Increased by 1 each time to trigger a reload.
      #tick = new Signal(0);
      // True after the browser freezes or hides the page until it visibly resumes.
      #suspended = new Signal(false);
      // Use the serialized URL as the reactive connection key. URL objects use identity
      // equality, but replacing one with an equivalent instance should not reconnect.
      #url;
      constructor(props) {
        this.url = Signal.from(props?.url);
        this.enabled = Signal.from(props?.enabled ?? true);
        this.delay = props?.delay ?? {};
        this.goaway = props?.goaway ?? {};
        this.redirect = this.#redirect;
        this.webtransport = props?.webtransport;
        this.websocket = props?.websocket;
        this.discovery = props?.discovery;
        this.publish = props?.publish;
        this.consume = props?.consume;
        if (this.consume) {
          this.#signals.cleanup(wireOf(this.consume).expect());
        }
        this.error = this.#error;
        const win = globalThis.window;
        const doc = globalThis.document;
        if (typeof win !== "undefined" && typeof doc !== "undefined") {
          this.#signals.event(win, "pagehide", () => this.#suspended.set(true));
          this.#signals.event(win, "pageshow", () => this.#suspended.set(false));
          this.#signals.event(win, "unload", () => this.#suspended.set(true));
          this.#signals.event(doc, "visibilitychange", () => {
            if (!doc.hidden)
              this.#suspended.set(false);
          });
        }
        this.probe = this.#signals.computed((effect) => {
          const connection = effect.get(this.established);
          return connection && effect.get(connection.probe);
        });
        this.bandwidth = new Allocator(this.#estimate);
        this.#signals.cleanup(() => this.bandwidth.close());
        this.#signals.run((effect) => {
          effect.set(this.#estimate, void 0);
          const connection = effect.get(this.established);
          if (!connection)
            return;
          let pending = false;
          const sample = async () => {
            if (pending)
              return;
            pending = true;
            try {
              const stats = await effect.race(connection.stats());
              if (stats)
                this.#estimate.set(stats.estimatedSendRate);
            } finally {
              pending = false;
            }
          };
          void sample();
          effect.interval(() => void sample(), BANDWIDTH_POLL);
        });
        this.#url = this.#signals.computed((effect) => effect.get(this.url)?.href);
        this.#signals.run(this.#connect.bind(this));
      }
      #connect(effect) {
        effect.get(this.#tick);
        const enabled = effect.get(this.enabled);
        if (!enabled) {
          this.#givenUpHref = void 0;
          this.#resetSequence();
          this.#redirect.set(void 0);
          return;
        }
        const suspended = effect.get(this.#suspended);
        if (suspended) {
          this.#resetSequence();
          return;
        }
        const href = effect.get(this.#url);
        if (!href) {
          this.#givenUpHref = void 0;
          this.#resetSequence();
          this.#redirect.set(void 0);
          return;
        }
        const url2 = new URL(href);
        if (this.#givenUpHref === href) {
          return;
        }
        if (this.#sequenceHref !== href) {
          this.#resetSequence();
          if (this.#redirectHref !== href)
            this.#redirect.set(void 0);
          this.#sequenceHref = href;
          this.#error.set(void 0);
          this.#givenUpHref = void 0;
        }
        if (!this.#draining)
          this.status.set("connecting");
        const signal = effect.abort;
        let current;
        effect.cleanup(() => {
          if (current) {
            current.close();
            if (this.established.peek() === current)
              this.established.set(void 0);
            current = void 0;
          }
          if (this.established.peek() === void 0)
            this.status.set("disconnected");
        });
        effect.spawn(async () => {
          let connected;
          try {
            for (; ; ) {
              const dialing = this.#redirect.peek() ?? url2;
              this.#dialing = true;
              let connection;
              try {
                connection = await connect({
                  url: dialing,
                  // A redirect names the relay; a fallback URL pinned for the old one does not follow.
                  websocket: this.#redirect.peek() ? { ...this.websocket, url: void 0 } : this.websocket,
                  webtransport: this.webtransport,
                  discovery: this.discovery,
                  publish: this.publish,
                  consume: this.consume,
                  signal
                });
              } finally {
                this.#dialing = false;
              }
              if (signal.aborted) {
                connection.close();
                return;
              }
              current = connection;
              this.established.set(connection);
              this.status.set("connected");
              connected = performance.now();
              const ended = await effect.race(connection.closed, wireOf(connection).goaway);
              if (ended === void 0)
                return;
              if (ended === null || ended instanceof Error) {
                console.warn("connection closed, reconnecting");
                if (this.established.peek() === connection)
                  this.established.set(void 0);
                this.#retry(effect, connected, ended ?? void 0);
                return;
              }
              current = void 0;
              const socket = this.#redirect.peek() ? void 0 : this.websocket?.url;
              if (!this.#migrate(connection, dialed(dialing, connection.transport, socket), ended))
                return;
              if (performance.now() - connected < this.#initial()) {
                this.#retry(effect, connected, new Error("peer redirected immediately"));
                return;
              }
              this.#delay = void 0;
              this.#deadline = void 0;
            }
          } catch (err2) {
            if (signal.aborted)
              return;
            console.warn("connection error:", err2);
            this.#retry(effect, connected, err2);
          }
        });
      }
      /**
       * Act on the peer's GOAWAY for `connection`, which was dialed at `dialing`: resolve where
       * to go next and leave the old session serving until it drains. Returns false when the
       * redirect is refused, which ends the sequence rather than redialing.
       */
      #migrate(connection, dialing, drain2) {
        const hashes = this.webtransport?.serverCertificateHashes?.length ?? 0;
        const configured = hashes > 0 || this.webtransport?.serverCertificate !== void 0;
        const pinned = pinnedTransport(connection.transport, configured);
        let next;
        try {
          next = target(this.goaway.redirect ?? "same-host", drain2.uri, dialing, pinned);
        } catch (err2) {
          console.warn("GOAWAY redirect refused:", err2);
          connection.close();
          this.established.set(void 0);
          this.status.set("disconnected");
          this.#giveUp(error(err2));
          return false;
        }
        if (next) {
          this.#redirect.set(next);
          this.#redirectHref = this.#sequenceHref;
        }
        console.info("GOAWAY received; migrating");
        this.#draining?.retire();
        const cap = handover(this.goaway.handover ?? DEFAULT_HANDOVER, drain2.timeout);
        const draining = new Draining(connection, cap, () => {
          if (this.#draining === draining)
            this.#draining = void 0;
          if (this.established.peek() !== connection)
            return;
          this.established.set(void 0);
          this.status.set(this.#dialing ? "connecting" : "disconnected");
        });
        this.#draining = draining;
        return true;
      }
      #initial() {
        return this.delay?.initial ?? DEFAULT_DELAY.initial;
      }
      /**
       * Schedule the next connect attempt after the current backoff, or stop once the retry window
       * has expired. `connected` is when the dead session was established, if it ever was, and
       * `cause` the error that killed it, if it died with one.
       */
      #retry(effect, connected, cause) {
        const delay = this.delay ?? {};
        const initial = this.#initial();
        const multiplier = delay.multiplier ?? DEFAULT_DELAY.multiplier;
        const max = delay.max ?? DEFAULT_DELAY.max;
        const timeout = delay.timeout ?? DEFAULT_DELAY.timeout;
        if (this.established.peek() === void 0)
          this.status.set("disconnected");
        if (connected !== void 0 && performance.now() - connected >= initial) {
          this.#delay = void 0;
          this.#deadline = void 0;
        }
        if (cause instanceof Session && cause.code === SessionCode.Unauthorized) {
          console.warn("session rejected as unauthorized, not retrying");
          this.#giveUp(cause);
          return;
        }
        const now = performance.now();
        this.#delay ??= initial;
        this.#deadline ??= timeout > 0 ? now + timeout : Number.POSITIVE_INFINITY;
        if (now >= this.#deadline) {
          console.warn("reconnect timed out");
          this.#giveUp(cause === void 0 ? new Error("reconnect timed out") : error(cause));
          return;
        }
        const wait = Math.min(this.#delay * (0.5 + Math.random() / 2), this.#deadline - now);
        this.#delay = Math.min(this.#delay * multiplier, max);
        const tick = this.#tick.peek() + 1;
        effect.timer(() => this.#tick.update((prev) => Math.max(prev, tick)), wait);
      }
      #giveUp(cause) {
        this.#error.set(cause);
        this.#givenUpHref = this.#sequenceHref;
        this.#resetSequence();
      }
      #resetSequence() {
        this.#delay = void 0;
        this.#deadline = void 0;
        this.#sequenceHref = void 0;
        this.#draining?.retire();
      }
      /**
       * Subscribe to broadcast announcements matching `scope`, spanning reconnects.
       *
       * The same {@link Announce.Consumer} stream as {@link Established.announced}, but everything active
       * is retracted (a `retracted` update) whenever the connection drops and re-announced on
       * reconnect, so a consumer draining `next()` never clings to a dead route across a reconnect.
       *
       * Stays empty while the relay lacks {@link Established.discovery}.
       */
      announced(scope = Pattern.all(), options) {
        if (this.consume)
          return this.consume.announced(scope, options);
        const producer = new Producer();
        const consumer = producer.consume();
        const pump = new Effect();
        pump.run((effect) => {
          const conn = effect.get(this.established);
          if (!conn)
            return;
          if (!conn.discovery)
            return;
          const upstream = conn.announced(scope, options);
          effect.cleanup(() => upstream.close());
          const active = /* @__PURE__ */ new Map();
          effect.spawn(async () => {
            try {
              for (; ; ) {
                const entry = await effect.race(upstream.next());
                if (!entry)
                  break;
                if (isActive(entry.kind))
                  active.set(entry.prefix, entry);
                else
                  active.delete(entry.prefix);
                producer.append(entry);
              }
            } catch {
            } finally {
              if (consumer.closed.peek() === void 0) {
                for (const entry of active.values()) {
                  producer.append({ ...entry, kind: "retracted" });
                }
              }
            }
          });
        });
        this.#signals.cleanup(() => pump.close());
        void consumer.closed.then(() => pump.close());
        return consumer;
      }
      /**
       * Snapshot the live connection's transport counters, or undefined while disconnected.
       * See {@link Established.stats}.
       */
      async stats() {
        return this.established.peek()?.stats();
      }
      /** Stop reconnecting, close the current connection, and settle {@link Reload.closed}. Idempotent. */
      close(abort) {
        this.#signals.close();
        this.#draining?.retire();
        if (this.#closed.peek() === void 0)
          this.#closed.set(abort ?? null);
      }
    };
    Draining = class {
      #connection;
      #timer;
      #onRetire;
      #retired = false;
      constructor(connection, handover2, onRetire) {
        this.#connection = connection;
        this.#onRetire = onRetire;
        this.#timer = setTimeout(() => {
          console.warn("old session did not drain in time; closing");
          this.retire();
        }, handover2);
        void connection.closed.then(() => this.retire());
      }
      /** Close the old session now, whatever remains of its window. Idempotent. */
      retire() {
        if (this.#retired)
          return;
        this.#retired = true;
        clearTimeout(this.#timer);
        this.#connection.close();
        this.#onRetire();
      }
    };
  }
});

// ../../node_modules/@moq/net/connection/pool.js
function refuse(props) {
  if (!props)
    return;
  const extra = props;
  if (extra.transport) {
    throw new Error("a supplied transport cannot reconnect; call Connection.connect() instead");
  }
  if (extra.signal) {
    throw new Error("a Connection owns its abort signal; do not pass one");
  }
  if (props.share !== true || !requiresPrivate(props))
    return;
  if (props.publish || props.consume) {
    throw new Error("caller-owned origins cannot be shared; pass share: false");
  }
  const hashes = props.webtransport?.serverCertificateHashes?.length ?? 0;
  if (props.webtransport?.serverCertificate !== void 0 || hashes > 0) {
    throw new Error("a pinned certificate cannot be shared; pass share: false");
  }
  if (props.webtransport !== void 0) {
    throw new Error("webtransport options cannot be shared; pass share: false");
  }
  if (props.websocket !== void 0) {
    throw new Error("websocket options cannot be shared; pass share: false");
  }
  if (props.discovery !== void 0) {
    throw new Error("discovery cannot be shared; pass share: false");
  }
  if (props.delay !== void 0) {
    throw new Error("delay cannot be shared; pass share: false");
  }
  if (props.goaway !== void 0) {
    throw new Error("goaway cannot be shared; pass share: false");
  }
}
function requiresPrivate(props) {
  return props.webtransport !== void 0 || props.websocket !== void 0 || props.discovery !== void 0 || props.delay !== void 0 || props.goaway !== void 0 || props.publish !== void 0 || props.consume !== void 0;
}
function acquire(key, linger) {
  let entry = pool.get(key);
  if (!entry) {
    const origin = new Producer5();
    const connection = new Reload({
      url: new URL(key),
      enabled: true,
      publish: origin.consume(),
      consume: origin,
      // Nobody observes a shared loop's `closed`, so giving up would strand every handle
      // on this URL offline until the page reloads. Retry for as long as the entry lives
      // instead; an auth rejection still stops this URL, and evicts below.
      delay: { timeout: Milli(0) }
    });
    const created = { key, origin, connection, refs: 0, linger: linger ?? LINGER_MS };
    connection.error.subscribe((err2) => {
      if (err2 !== void 0 && pool.get(created.key) === created)
        pool.delete(created.key);
    });
    connection.redirect.subscribe((redirect) => {
      if (!redirect || redirect.href === created.key)
        return;
      if (pool.get(created.key) === created)
        pool.delete(created.key);
      created.key = redirect.href;
      if (!pool.has(created.key))
        pool.set(created.key, created);
    });
    entry = created;
    pool.set(key, created);
  }
  const taken = entry;
  taken.linger = Milli(Math.max(taken.linger, linger ?? LINGER_MS));
  taken.refs += 1;
  if (taken.timer !== void 0) {
    clearTimeout(taken.timer);
    taken.timer = void 0;
  }
  let released = false;
  return {
    ...taken,
    release: () => {
      if (released)
        return;
      released = true;
      taken.refs -= 1;
      if (taken.refs > 0)
        return;
      taken.timer = setTimeout(() => {
        if (pool.get(taken.key) === taken)
          pool.delete(taken.key);
        taken.connection.close();
        taken.origin.close();
      }, taken.linger);
      taken.timer.unref?.();
    }
  };
}
var LINGER_MS, Connection3, pool;
var init_pool = __esm({
  "../../node_modules/@moq/net/connection/pool.js"() {
    init_signals();
    init_announced();
    init_origin();
    init_path();
    init_time();
    init_accept();
    init_browser();
    init_connect();
    init_reload();
    LINGER_MS = Milli(2e3);
    Connection3 = class {
      /** Establish a one-shot session; a supplied transport belongs here, not in the reconnect loop. */
      static connect = connect;
      /** Accept a one-shot session on an already-open transport. */
      static accept = accept;
      /** SHA-256 of a certificate, for pinning via `webtransport.serverCertificateHashes`. */
      static certificateHash = certificateHash;
      /** Whether this runtime can connect with WebTransport. */
      static isWebTransportSupported = isWebTransportSupported;
      /** Relay URL to connect to; updating it reconnects to that URL. */
      url;
      /** Whether to hold a connection at all; clearing it releases this handle's share. */
      enabled;
      /** Current status of the connection. */
      status;
      /**
       * The failure that stopped retrying the current URL, or undefined while the loop is live.
       *
       * Set on an auth rejection or when a private retry window expires. Cleared when a new URL
       * or a disable/re-enable starts another sequence, not on a page hide/show.
       */
      error;
      /**
       * The wire transport the current session runs over, or undefined while disconnected.
       *
       * The session itself is deliberately not exposed: it is shared, so no handle may close
       * or reconfigure it, and everything else it offers is reachable through {@link origin}.
       */
      transport;
      /** The current connection's PROBE estimates, or undefined while disconnected. */
      probe;
      /**
       * The send-side bandwidth allocator for the current URL, or undefined
       * while disabled or URL-less.
       *
       * Every handle on this URL shares the same instance, so publishers reserve
       * against one registry. Borrowed, not owned: the type has no close, since
       * closing it would starve every other handle.
       */
      bandwidth;
      /**
       * The origin for the current URL, or undefined while disabled or URL-less.
       *
       * Publish into it or consume from it; a shared handle's origin is the same one every
       * other handle on this URL uses, and it spans the connection's reconnects. Borrowed,
       * not owned: the type has no close, since closing it would tear the origin down under
       * every other handle.
       */
      origin;
      /**
       * Settles once this handle is released via {@link close}: `null` on a clean close, or
       * the abort {@link Error}. Peek it synchronously (`undefined` while open), observe it
       * reactively, or `await` it. Attempt failures live on {@link error} instead.
       */
      get closed() {
        return this.#closed;
      }
      #closed = new Once();
      #status = new Signal("disconnected");
      #established = new Signal(void 0);
      #probe = new Signal(void 0);
      #origin = new Signal(void 0);
      #bandwidth = new Signal(void 0);
      #error = new Signal(void 0);
      #signals;
      /**
       * Take a handle on the connection for {@link ConnectionProps.url}.
       *
       * Dials immediately when a URL is given and `enabled` is not false; otherwise waits for
       * the signals to say go. The handle owns nothing but its own share: {@link close}
       * releases it, and the underlying connection and origin live for as long as any handle
       * (plus the linger window) wants them.
       */
      constructor(props) {
        refuse(props);
        this.#signals = new Effect();
        this.url = Signal.from(props?.url);
        this.enabled = Signal.from(props?.enabled ?? true);
        this.status = this.#status;
        this.error = this.#error;
        this.probe = this.#probe;
        this.origin = this.#origin;
        this.bandwidth = this.#bandwidth;
        this.transport = this.#signals.computed((effect) => effect.get(this.#established)?.transport);
        const linger = props?.linger;
        const href = this.#signals.computed((effect) => effect.get(this.url)?.href);
        if (props && (props.share === false || requiresPrivate(props))) {
          this.#runPrivate(props, href);
          return;
        }
        this.#signals.run((effect) => {
          if (!effect.get(this.enabled))
            return;
          const key = effect.get(href);
          if (!key)
            return;
          const lease = acquire(key, linger);
          effect.cleanup(lease.release);
          effect.set(this.#origin, lease.origin, void 0);
          effect.set(this.#bandwidth, lease.connection.bandwidth, void 0);
          effect.run((nested) => nested.set(this.#status, nested.get(lease.connection.status), "disconnected"));
          effect.run((nested) => nested.set(this.#established, nested.get(lease.connection.established), void 0));
          effect.run((nested) => nested.set(this.#probe, nested.get(lease.connection.probe), void 0));
          effect.run((nested) => nested.set(this.#error, nested.get(lease.connection.error), void 0));
        });
      }
      #runPrivate(props, href) {
        const owned = props.consume === void 0;
        const origin = props.consume ?? new Producer5();
        if (owned)
          this.#signals.cleanup(() => origin.close());
        const loop = new Reload({
          url: this.url,
          enabled: this.enabled,
          publish: props.publish ?? (owned ? origin.consume() : void 0),
          consume: origin,
          webtransport: props.webtransport,
          websocket: props.websocket,
          discovery: props.discovery,
          // A handle nobody watches wants unlimited retries; an auth rejection still
          // stops this URL, and a new one starts another sequence.
          delay: { timeout: Milli(0), ...props.delay },
          goaway: props.goaway
        });
        this.#signals.cleanup(() => loop.close());
        this.#signals.run((effect) => {
          if (!effect.get(this.enabled) || !effect.get(href))
            return;
          effect.set(this.#origin, origin, void 0);
          effect.set(this.#bandwidth, loop.bandwidth, void 0);
        });
        this.#signals.run((effect) => effect.set(this.#status, effect.get(loop.status), "disconnected"));
        this.#signals.run((effect) => effect.set(this.#established, effect.get(loop.established), void 0));
        this.#signals.run((effect) => effect.set(this.#probe, effect.get(loop.probe), void 0));
        this.#signals.run((effect) => effect.set(this.#error, effect.get(loop.error), void 0));
      }
      /**
       * Subscribe to broadcast announcements matching `scope`, spanning reconnects
       * and URL switches: a switch retracts everything from
       * the old relay's origin, then the new one's arrivals stream in.
       */
      announced(scope = Pattern.all(), options) {
        const producer = new Producer();
        const consumer = producer.consume();
        let closed = false;
        void consumer.closed.then(() => {
          closed = true;
        });
        const stop = this.#signals.run((effect) => {
          const origin = effect.get(this.#origin);
          if (!origin)
            return;
          const upstream = origin.announced(scope, options);
          effect.cleanup(() => upstream.close());
          const active = /* @__PURE__ */ new Map();
          effect.spawn(async () => {
            try {
              for (; ; ) {
                const entry = await effect.race(upstream.next());
                if (!entry)
                  break;
                if (isActive(entry.kind))
                  active.set(entry.prefix, entry);
                else
                  active.delete(entry.prefix);
                producer.append(entry);
              }
            } finally {
              if (!closed) {
                for (const entry of active.values()) {
                  producer.append({ ...entry, kind: "retracted" });
                }
              }
            }
          });
        });
        void consumer.closed.then(stop);
        return consumer;
      }
      /** Snapshot the live connection's transport counters, or undefined while disconnected. */
      async stats() {
        return this.#established.peek()?.stats();
      }
      /**
       * Release this handle. The shared connection closes once its last handle is gone and
       * the linger window passes; other handles on the URL are unaffected. Idempotent.
       */
      close(abort) {
        this.#signals.close();
        if (this.#closed.peek() === void 0)
          this.#closed.set(abort ?? null);
      }
    };
    pool = /* @__PURE__ */ new Map();
  }
});

// ../../node_modules/@moq/net/connection/index.js
var init_connection3 = __esm({
  "../../node_modules/@moq/net/connection/index.js"() {
    init_pool();
  }
});

// ../../node_modules/@moq/net/errors.js
var errors_exports2 = {};
__export(errors_exports2, {
  FrameTooLarge: () => FrameTooLarge,
  GroupTooLarge: () => GroupTooLarge,
  NotFound: () => NotFound,
  ProtocolViolation: () => ProtocolViolation,
  RefusedRedirect: () => RefusedRedirect,
  Session: () => Session,
  Stream: () => Stream,
  TooFarBehind: () => TooFarBehind
});
var init_errors2 = __esm({
  "../../node_modules/@moq/net/errors.js"() {
    init_error2();
  }
});

// ../../node_modules/@moq/net/index.js
var net_exports = {};
__export(net_exports, {
  Announce: () => announce_exports,
  Bandwidth: () => bandwidth_api_exports,
  Broadcast: () => broadcast_exports,
  Connection: () => Connection3,
  Error: () => errors_exports2,
  Group: () => group_exports,
  Origin: () => origin_exports,
  Path: () => path_exports,
  SessionCode: () => SessionCode,
  Signals: () => signals_exports,
  StreamCode: () => StreamCode,
  Time: () => time_exports,
  Track: () => track_exports,
  Varint: () => varint_exports
});
var init_net = __esm({
  "../../node_modules/@moq/net/index.js"() {
    init_signals();
    init_announce();
    init_bandwidth_api();
    init_broadcast();
    init_connection3();
    init_error2();
    init_errors2();
    init_group();
    init_origin();
    init_path();
    init_time();
    init_track();
    init_varint2();
  }
});

// src/room.ts
function isRoom(room) {
  const segments = typeof room === "string" ? room.split("/") : [];
  return segments.length > 0 && segments.length <= 27 && segments.every((one) => one !== "" && one !== "~" && !one.startsWith(".") && !one.includes("*"));
}
var USER, ID;
var init_room = __esm({
  "src/room.ts"() {
    "use strict";
    USER = /^(?!\.)[!-)+-.0-}]{1,64}$/u;
    ID = /^(?:(?!\.)[!-)+-.0-}]{1,64}~)?[A-Za-z0-9_-]{22}$/u;
  }
});

// ../../node_modules/@moq/json/diff.js
function isObject2(value) {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
function diff(oldVal, newVal) {
  if (isObject2(oldVal) && isObject2(newVal)) {
    const patch = {};
    const forced = { value: false };
    diffObjects(oldVal, newVal, patch, forced);
    return { patch, forcedSnapshot: forced.value };
  }
  return { patch: newVal, forcedSnapshot: true };
}
function diffObjects(oldObj, newObj, patch, forced) {
  for (const key of Object.keys(oldObj)) {
    if (!(key in newObj))
      patch[key] = null;
  }
  for (const key of Object.keys(newObj)) {
    const newV = newObj[key];
    const oldV = oldObj[key];
    const inOld = key in oldObj;
    if (inOld && deepEqual(oldV, newV))
      continue;
    if (isObject2(oldV) && isObject2(newV)) {
      const sub = {};
      diffObjects(oldV, newV, sub, forced);
      if (Object.keys(sub).length > 0)
        patch[key] = sub;
      continue;
    }
    if (newV === null) {
      forced.value = true;
    }
    patch[key] = newV;
  }
}
function merge2(target3, patch) {
  if (!isObject2(patch))
    return patch;
  const base2 = isObject2(target3) ? { ...target3 } : {};
  for (const [key, value] of Object.entries(patch)) {
    if (value === null) {
      delete base2[key];
    } else {
      base2[key] = merge2(base2[key], value);
    }
  }
  return base2;
}
function deepEqual(a2, b3) {
  if (a2 === b3)
    return true;
  if (Array.isArray(a2) && Array.isArray(b3)) {
    return a2.length === b3.length && a2.every((item, i2) => deepEqual(item, b3[i2]));
  }
  if (isObject2(a2) && isObject2(b3)) {
    const keys = Object.keys(a2);
    if (keys.length !== Object.keys(b3).length)
      return false;
    return keys.every((key) => key in b3 && deepEqual(a2[key], b3[key]));
  }
  return false;
}
var init_diff = __esm({
  "../../node_modules/@moq/json/diff.js"() {
  }
});

// ../../node_modules/@moq/json/error.js
var MissingSnapshot;
var init_error4 = __esm({
  "../../node_modules/@moq/json/error.js"() {
    MissingSnapshot = class extends Error {
      constructor() {
        super("delta before snapshot");
        this.name = "MissingSnapshot";
      }
    };
  }
});

// ../../node_modules/pako/dist/pako.mjs
function zero$1(buf) {
  let len = buf.length;
  while (--len >= 0) buf[len] = 0;
}
function inflate_fast(strm, start) {
  let _in;
  let last;
  let _out;
  let beg;
  let end;
  let dmax;
  let wsize;
  let whave;
  let wnext;
  let s_window;
  let hold;
  let bits;
  let lcode;
  let dcode;
  let lmask;
  let dmask;
  let here;
  let op;
  let len;
  let dist;
  let from2;
  let from_source;
  let input, output;
  const state = strm.state;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
  dmax = state.dmax;
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;
  top: do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }
    here = lcode[hold & lmask];
    dolen: for (; ; ) {
      op = here >>> 24;
      hold >>>= op;
      bits -= op;
      op = here >>> 16 & 255;
      if (op === 0) output[_out++] = here & 65535;
      else if (op & 16) {
        len = here & 65535;
        op &= 15;
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & (1 << op) - 1;
          hold >>>= op;
          bits -= op;
        }
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];
        dodist: for (; ; ) {
          op = here >>> 24;
          hold >>>= op;
          bits -= op;
          op = here >>> 16 & 255;
          if (op & 16) {
            dist = here & 65535;
            op &= 15;
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & (1 << op) - 1;
            if (dist > dmax) {
              strm.msg = "invalid distance too far back";
              state.mode = BAD$1;
              break top;
            }
            hold >>>= op;
            bits -= op;
            op = _out - beg;
            if (dist > op) {
              op = dist - op;
              if (op > whave) {
                if (state.sane) {
                  strm.msg = "invalid distance too far back";
                  state.mode = BAD$1;
                  break top;
                }
              }
              from2 = 0;
              from_source = s_window;
              if (wnext === 0) {
                from2 += wsize - op;
                if (op < len) {
                  len -= op;
                  do
                    output[_out++] = s_window[from2++];
                  while (--op);
                  from2 = _out - dist;
                  from_source = output;
                }
              } else if (wnext < op) {
                from2 += wsize + wnext - op;
                op -= wnext;
                if (op < len) {
                  len -= op;
                  do
                    output[_out++] = s_window[from2++];
                  while (--op);
                  from2 = 0;
                  if (wnext < len) {
                    op = wnext;
                    len -= op;
                    do
                      output[_out++] = s_window[from2++];
                    while (--op);
                    from2 = _out - dist;
                    from_source = output;
                  }
                }
              } else {
                from2 += wnext - op;
                if (op < len) {
                  len -= op;
                  do
                    output[_out++] = s_window[from2++];
                  while (--op);
                  from2 = _out - dist;
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from2++];
                output[_out++] = from_source[from2++];
                output[_out++] = from_source[from2++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from2++];
                if (len > 1) output[_out++] = from_source[from2++];
              }
            } else {
              from2 = _out - dist;
              do {
                output[_out++] = output[from2++];
                output[_out++] = output[from2++];
                output[_out++] = output[from2++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from2++];
                if (len > 1) output[_out++] = output[from2++];
              }
            }
          } else if ((op & 64) === 0) {
            here = dcode[(here & 65535) + (hold & (1 << op) - 1)];
            continue dodist;
          } else {
            strm.msg = "invalid distance code";
            state.mode = BAD$1;
            break top;
          }
          break;
        }
      } else if ((op & 64) === 0) {
        here = lcode[(here & 65535) + (hold & (1 << op) - 1)];
        continue dolen;
      } else if (op & 32) {
        state.mode = TYPE$1;
        break top;
      } else {
        strm.msg = "invalid literal/length code";
        state.mode = BAD$1;
        break top;
      }
      break;
    }
  } while (_in < last && _out < end);
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
  strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
  state.hold = hold;
  state.bits = bits;
}
var Z_FIXED, Z_BINARY, Z_TEXT, Z_UNKNOWN, STORED_BLOCK, STATIC_TREES, DYN_TREES, LENGTH_CODES, LITERALS, L_CODES, D_CODES, BL_CODES, HEAP_SIZE$1, MAX_BITS, Buf_size, MAX_BL_BITS, END_BLOCK, REP_3_6, REPZ_3_10, REPZ_11_138, extra_lbits, extra_dbits, extra_blbits, bl_order, DIST_CODE_LEN, static_ltree, static_dtree, _dist_code, _length_code, base_length, base_dist, StaticTreeDesc, static_l_desc, static_d_desc, static_bl_desc, TreeDesc, d_code, put_short, send_bits, send_code, bi_reverse, bi_flush, gen_bitlen, gen_codes, tr_static_init, init_block, bi_windup, smaller, pqdownheap, compress_block, build_tree, scan_tree, send_tree, build_bl_tree, send_all_trees, detect_data_type, static_init_done, _tr_init, _tr_stored_block, _tr_align, _tr_flush_block, _tr_tally, adler32, makeTable, crcTable, crc32, messages_default, Z_SYNC_FLUSH, MAX_MEM_LEVEL, HEAP_SIZE, MIN_MATCH, MAX_MATCH, MIN_LOOKAHEAD, PRESET_DICT, INIT_STATE, GZIP_STATE, EXTRA_STATE, NAME_STATE, COMMENT_STATE, HCRC_STATE, BUSY_STATE, FINISH_STATE, BS_NEED_MORE, BS_BLOCK_DONE, BS_FINISH_STARTED, BS_FINISH_DONE, OS_CODE, err, rank, zero, slide_hash, HASH, INSERT_STRING, flush_pending, flush_block_only, put_byte, putShortMSB, read_buf, longest_match, fill_window, deflate_stored, deflate_fast, deflate_slow, deflate_rle, deflate_huff, Config, configuration_table, lm_init, DeflateState, deflateStateCheck, deflateResetKeep, deflateReset, deflateInit2, deflate$1, deflateEnd, deflateSetDictionary, BAD$1, TYPE$1, MAXBITS, ENOUGH_LENS$1, ENOUGH_DISTS$1, CODES$1, LENS$1, DISTS$1, lbase, lext, dbase, dext, inflate_table, CODES2, LENS, DISTS, HEAD, FLAGS, TIME, OS, EXLEN, EXTRA, NAME, COMMENT, HCRC, DICTID, DICT, TYPE, TYPEDO, STORED, COPY_, COPY, TABLE, LENLENS, CODELENS, LEN_, LEN, LENEXT, DIST, DISTEXT, MATCH, LIT, CHECK, LENGTH, DONE, BAD, MEM, SYNC, ENOUGH_LENS, ENOUGH_DISTS, zswap32, InflateState, inflateStateCheck, inflateResetKeep, inflateReset, inflateReset2, inflateInit2, virgin, lenfix, distfix, fixedtables, updatewindow, inflate$1, inflateEnd, inflateSetDictionary, ZStream, flattenChunks, toString$1, defaultOptions$1, Deflate, toString, defaultOptions, Inflate;
var init_pako = __esm({
  "../../node_modules/pako/dist/pako.mjs"() {
    Z_FIXED = 4;
    Z_BINARY = 0;
    Z_TEXT = 1;
    Z_UNKNOWN = 2;
    STORED_BLOCK = 0;
    STATIC_TREES = 1;
    DYN_TREES = 2;
    LENGTH_CODES = 29;
    LITERALS = 256;
    L_CODES = 286;
    D_CODES = 30;
    BL_CODES = 19;
    HEAP_SIZE$1 = 573;
    MAX_BITS = 15;
    Buf_size = 16;
    MAX_BL_BITS = 7;
    END_BLOCK = 256;
    REP_3_6 = 16;
    REPZ_3_10 = 17;
    REPZ_11_138 = 18;
    extra_lbits = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      1,
      1,
      1,
      2,
      2,
      2,
      2,
      3,
      3,
      3,
      3,
      4,
      4,
      4,
      4,
      5,
      5,
      5,
      5,
      0
    ]);
    extra_dbits = new Uint8Array([
      0,
      0,
      0,
      0,
      1,
      1,
      2,
      2,
      3,
      3,
      4,
      4,
      5,
      5,
      6,
      6,
      7,
      7,
      8,
      8,
      9,
      9,
      10,
      10,
      11,
      11,
      12,
      12,
      13,
      13
    ]);
    extra_blbits = new Uint8Array([
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      3,
      7
    ]);
    bl_order = new Uint8Array([
      16,
      17,
      18,
      0,
      8,
      7,
      9,
      6,
      10,
      5,
      11,
      4,
      12,
      3,
      13,
      2,
      14,
      1,
      15
    ]);
    DIST_CODE_LEN = 512;
    static_ltree = new Array(288 * 2);
    zero$1(static_ltree);
    static_dtree = new Array(D_CODES * 2);
    zero$1(static_dtree);
    _dist_code = new Array(DIST_CODE_LEN);
    zero$1(_dist_code);
    _length_code = new Array(256);
    zero$1(_length_code);
    base_length = new Array(LENGTH_CODES);
    zero$1(base_length);
    base_dist = new Array(D_CODES);
    zero$1(base_dist);
    StaticTreeDesc = class {
      constructor(static_tree, extra_bits, extra_base, elems, max_length) {
        this.static_tree = static_tree;
        this.extra_bits = extra_bits;
        this.extra_base = extra_base;
        this.elems = elems;
        this.max_length = max_length;
        this.has_stree = static_tree && static_tree.length;
      }
    };
    TreeDesc = class {
      constructor(dyn_tree, stat_desc) {
        this.dyn_tree = dyn_tree;
        this.max_code = 0;
        this.stat_desc = stat_desc;
      }
    };
    d_code = (dist) => {
      return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
    };
    put_short = (s, w4) => {
      s.pending_buf[s.pending++] = w4 & 255;
      s.pending_buf[s.pending++] = w4 >>> 8 & 255;
    };
    send_bits = (s, value, length) => {
      if (s.bi_valid > Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 65535;
        put_short(s, s.bi_buf);
        s.bi_buf = value >> Buf_size - s.bi_valid;
        s.bi_valid += length - Buf_size;
      } else {
        s.bi_buf |= value << s.bi_valid & 65535;
        s.bi_valid += length;
      }
    };
    send_code = (s, c2, tree) => {
      send_bits(s, tree[c2 * 2], tree[c2 * 2 + 1]);
    };
    bi_reverse = (code, len) => {
      let res = 0;
      do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
      } while (--len > 0);
      return res >>> 1;
    };
    bi_flush = (s) => {
      if (s.bi_valid === 16) {
        put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
      } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 255;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
      }
    };
    gen_bitlen = (s, desc) => {
      const tree = desc.dyn_tree;
      const max_code = desc.max_code;
      const stree = desc.stat_desc.static_tree;
      const has_stree = desc.stat_desc.has_stree;
      const extra = desc.stat_desc.extra_bits;
      const base2 = desc.stat_desc.extra_base;
      const max_length = desc.stat_desc.max_length;
      let h3;
      let n2, m3;
      let bits;
      let xbits;
      let f3;
      let overflow = 0;
      for (bits = 0; bits <= MAX_BITS; bits++) s.bl_count[bits] = 0;
      tree[s.heap[s.heap_max] * 2 + 1] = 0;
      for (h3 = s.heap_max + 1; h3 < HEAP_SIZE$1; h3++) {
        n2 = s.heap[h3];
        bits = tree[tree[n2 * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
          bits = max_length;
          overflow++;
        }
        tree[n2 * 2 + 1] = bits;
        if (n2 > max_code) continue;
        s.bl_count[bits]++;
        xbits = 0;
        if (n2 >= base2) xbits = extra[n2 - base2];
        f3 = tree[n2 * 2];
        s.opt_len += f3 * (bits + xbits);
        if (has_stree) s.static_len += f3 * (stree[n2 * 2 + 1] + xbits);
      }
      if (overflow === 0) return;
      do {
        bits = max_length - 1;
        while (s.bl_count[bits] === 0) bits--;
        s.bl_count[bits]--;
        s.bl_count[bits + 1] += 2;
        s.bl_count[max_length]--;
        overflow -= 2;
      } while (overflow > 0);
      for (bits = max_length; bits !== 0; bits--) {
        n2 = s.bl_count[bits];
        while (n2 !== 0) {
          m3 = s.heap[--h3];
          if (m3 > max_code) continue;
          if (tree[m3 * 2 + 1] !== bits) {
            s.opt_len += (bits - tree[m3 * 2 + 1]) * tree[m3 * 2];
            tree[m3 * 2 + 1] = bits;
          }
          n2--;
        }
      }
    };
    gen_codes = (tree, max_code, bl_count) => {
      const next_code = new Array(16);
      let code = 0;
      let bits;
      let n2;
      for (bits = 1; bits <= MAX_BITS; bits++) {
        code = code + bl_count[bits - 1] << 1;
        next_code[bits] = code;
      }
      for (n2 = 0; n2 <= max_code; n2++) {
        let len = tree[n2 * 2 + 1];
        if (len === 0) continue;
        tree[n2 * 2] = bi_reverse(next_code[len]++, len);
      }
    };
    tr_static_init = () => {
      let n2;
      let bits;
      let length;
      let code;
      let dist;
      const bl_count = new Array(16);
      length = 0;
      for (code = 0; code < LENGTH_CODES - 1; code++) {
        base_length[code] = length;
        for (n2 = 0; n2 < 1 << extra_lbits[code]; n2++) _length_code[length++] = code;
      }
      _length_code[length - 1] = code;
      dist = 0;
      for (code = 0; code < 16; code++) {
        base_dist[code] = dist;
        for (n2 = 0; n2 < 1 << extra_dbits[code]; n2++) _dist_code[dist++] = code;
      }
      dist >>= 7;
      for (; code < D_CODES; code++) {
        base_dist[code] = dist << 7;
        for (n2 = 0; n2 < 1 << extra_dbits[code] - 7; n2++) _dist_code[256 + dist++] = code;
      }
      for (bits = 0; bits <= MAX_BITS; bits++) bl_count[bits] = 0;
      n2 = 0;
      while (n2 <= 143) {
        static_ltree[n2 * 2 + 1] = 8;
        n2++;
        bl_count[8]++;
      }
      while (n2 <= 255) {
        static_ltree[n2 * 2 + 1] = 9;
        n2++;
        bl_count[9]++;
      }
      while (n2 <= 279) {
        static_ltree[n2 * 2 + 1] = 7;
        n2++;
        bl_count[7]++;
      }
      while (n2 <= 287) {
        static_ltree[n2 * 2 + 1] = 8;
        n2++;
        bl_count[8]++;
      }
      gen_codes(static_ltree, 287, bl_count);
      for (n2 = 0; n2 < D_CODES; n2++) {
        static_dtree[n2 * 2 + 1] = 5;
        static_dtree[n2 * 2] = bi_reverse(n2, 5);
      }
      static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, 257, L_CODES, MAX_BITS);
      static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
      static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);
    };
    init_block = (s) => {
      let n2;
      for (n2 = 0; n2 < L_CODES; n2++) s.dyn_ltree[n2 * 2] = 0;
      for (n2 = 0; n2 < D_CODES; n2++) s.dyn_dtree[n2 * 2] = 0;
      for (n2 = 0; n2 < BL_CODES; n2++) s.bl_tree[n2 * 2] = 0;
      s.dyn_ltree[END_BLOCK * 2] = 1;
      s.opt_len = s.static_len = 0;
      s.sym_next = s.matches = 0;
    };
    bi_windup = (s) => {
      if (s.bi_valid > 8) put_short(s, s.bi_buf);
      else if (s.bi_valid > 0) s.pending_buf[s.pending++] = s.bi_buf;
      s.bi_buf = 0;
      s.bi_valid = 0;
    };
    smaller = (tree, n2, m3, depth) => {
      const _n2 = n2 * 2;
      const _m2 = m3 * 2;
      return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n2] <= depth[m3];
    };
    pqdownheap = (s, tree, k2) => {
      const v3 = s.heap[k2];
      let j2 = k2 << 1;
      while (j2 <= s.heap_len) {
        if (j2 < s.heap_len && smaller(tree, s.heap[j2 + 1], s.heap[j2], s.depth)) j2++;
        if (smaller(tree, v3, s.heap[j2], s.depth)) break;
        s.heap[k2] = s.heap[j2];
        k2 = j2;
        j2 <<= 1;
      }
      s.heap[k2] = v3;
    };
    compress_block = (s, ltree, dtree) => {
      let dist;
      let lc;
      let sx = 0;
      let code;
      let extra;
      if (s.sym_next !== 0) do {
        dist = s.pending_buf[s.sym_buf + sx++] & 255;
        dist += (s.pending_buf[s.sym_buf + sx++] & 255) << 8;
        lc = s.pending_buf[s.sym_buf + sx++];
        if (dist === 0) send_code(s, lc, ltree);
        else {
          code = _length_code[lc];
          send_code(s, code + LITERALS + 1, ltree);
          extra = extra_lbits[code];
          if (extra !== 0) {
            lc -= base_length[code];
            send_bits(s, lc, extra);
          }
          dist--;
          code = d_code(dist);
          send_code(s, code, dtree);
          extra = extra_dbits[code];
          if (extra !== 0) {
            dist -= base_dist[code];
            send_bits(s, dist, extra);
          }
        }
      } while (sx < s.sym_next);
      send_code(s, END_BLOCK, ltree);
    };
    build_tree = (s, desc) => {
      const tree = desc.dyn_tree;
      const stree = desc.stat_desc.static_tree;
      const has_stree = desc.stat_desc.has_stree;
      const elems = desc.stat_desc.elems;
      let n2, m3;
      let max_code = -1;
      let node;
      s.heap_len = 0;
      s.heap_max = HEAP_SIZE$1;
      for (n2 = 0; n2 < elems; n2++) if (tree[n2 * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n2;
        s.depth[n2] = 0;
      } else tree[n2 * 2 + 1] = 0;
      while (s.heap_len < 2) {
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1];
      }
      desc.max_code = max_code;
      for (n2 = s.heap_len >> 1; n2 >= 1; n2--) pqdownheap(s, tree, n2);
      node = elems;
      do {
        n2 = s.heap[1];
        s.heap[1] = s.heap[s.heap_len--];
        pqdownheap(s, tree, 1);
        m3 = s.heap[1];
        s.heap[--s.heap_max] = n2;
        s.heap[--s.heap_max] = m3;
        tree[node * 2] = tree[n2 * 2] + tree[m3 * 2];
        s.depth[node] = (s.depth[n2] >= s.depth[m3] ? s.depth[n2] : s.depth[m3]) + 1;
        tree[n2 * 2 + 1] = tree[m3 * 2 + 1] = node;
        s.heap[1] = node++;
        pqdownheap(s, tree, 1);
      } while (s.heap_len >= 2);
      s.heap[--s.heap_max] = s.heap[1];
      gen_bitlen(s, desc);
      gen_codes(tree, max_code, s.bl_count);
    };
    scan_tree = (s, tree, max_code) => {
      let n2;
      let prevlen = -1;
      let curlen;
      let nextlen = tree[1];
      let count2 = 0;
      let max_count = 7;
      let min_count = 4;
      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }
      tree[(max_code + 1) * 2 + 1] = 65535;
      for (n2 = 0; n2 <= max_code; n2++) {
        curlen = nextlen;
        nextlen = tree[(n2 + 1) * 2 + 1];
        if (++count2 < max_count && curlen === nextlen) continue;
        else if (count2 < min_count) s.bl_tree[curlen * 2] += count2;
        else if (curlen !== 0) {
          if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
          s.bl_tree[REP_3_6 * 2]++;
        } else if (count2 <= 10) s.bl_tree[REPZ_3_10 * 2]++;
        else s.bl_tree[REPZ_11_138 * 2]++;
        count2 = 0;
        prevlen = curlen;
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        } else if (curlen === nextlen) {
          max_count = 6;
          min_count = 3;
        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    };
    send_tree = (s, tree, max_code) => {
      let n2;
      let prevlen = -1;
      let curlen;
      let nextlen = tree[1];
      let count2 = 0;
      let max_count = 7;
      let min_count = 4;
      if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
      }
      for (n2 = 0; n2 <= max_code; n2++) {
        curlen = nextlen;
        nextlen = tree[(n2 + 1) * 2 + 1];
        if (++count2 < max_count && curlen === nextlen) continue;
        else if (count2 < min_count) do
          send_code(s, curlen, s.bl_tree);
        while (--count2 !== 0);
        else if (curlen !== 0) {
          if (curlen !== prevlen) {
            send_code(s, curlen, s.bl_tree);
            count2--;
          }
          send_code(s, REP_3_6, s.bl_tree);
          send_bits(s, count2 - 3, 2);
        } else if (count2 <= 10) {
          send_code(s, REPZ_3_10, s.bl_tree);
          send_bits(s, count2 - 3, 3);
        } else {
          send_code(s, REPZ_11_138, s.bl_tree);
          send_bits(s, count2 - 11, 7);
        }
        count2 = 0;
        prevlen = curlen;
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        } else if (curlen === nextlen) {
          max_count = 6;
          min_count = 3;
        } else {
          max_count = 7;
          min_count = 4;
        }
      }
    };
    build_bl_tree = (s) => {
      let max_blindex;
      scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
      scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
      build_tree(s, s.bl_desc);
      for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) if (s.bl_tree[bl_order[max_blindex] * 2 + 1] !== 0) break;
      s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
      return max_blindex;
    };
    send_all_trees = (s, lcodes, dcodes, blcodes) => {
      let rank2;
      send_bits(s, lcodes - 257, 5);
      send_bits(s, dcodes - 1, 5);
      send_bits(s, blcodes - 4, 4);
      for (rank2 = 0; rank2 < blcodes; rank2++) send_bits(s, s.bl_tree[bl_order[rank2] * 2 + 1], 3);
      send_tree(s, s.dyn_ltree, lcodes - 1);
      send_tree(s, s.dyn_dtree, dcodes - 1);
    };
    detect_data_type = (s) => {
      let block_mask = 4093624447;
      let n2;
      for (n2 = 0; n2 <= 31; n2++, block_mask >>>= 1) if (block_mask & 1 && s.dyn_ltree[n2 * 2] !== 0) return Z_BINARY;
      if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return Z_TEXT;
      for (n2 = 32; n2 < LITERALS; n2++) if (s.dyn_ltree[n2 * 2] !== 0) return Z_TEXT;
      return Z_BINARY;
    };
    static_init_done = false;
    _tr_init = (s) => {
      if (!static_init_done) {
        tr_static_init();
        static_init_done = true;
      }
      s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
      s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
      s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
      s.bi_buf = 0;
      s.bi_valid = 0;
      init_block(s);
    };
    _tr_stored_block = (s, buf, stored_len, last) => {
      send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);
      bi_windup(s);
      put_short(s, stored_len);
      put_short(s, ~stored_len);
      if (stored_len) s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
      s.pending += stored_len;
    };
    _tr_align = (s) => {
      send_bits(s, STATIC_TREES << 1, 3);
      send_code(s, END_BLOCK, static_ltree);
      bi_flush(s);
    };
    _tr_flush_block = (s, buf, stored_len, last) => {
      let opt_lenb, static_lenb;
      let max_blindex = 0;
      if (s.level > 0) {
        if (s.strm.data_type === Z_UNKNOWN) s.strm.data_type = detect_data_type(s);
        build_tree(s, s.l_desc);
        build_tree(s, s.d_desc);
        max_blindex = build_bl_tree(s);
        opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        if (static_lenb <= opt_lenb || s.strategy === Z_FIXED) opt_lenb = static_lenb;
      } else opt_lenb = static_lenb = stored_len + 5;
      if (stored_len + 4 <= opt_lenb && buf !== -1) _tr_stored_block(s, buf, stored_len, last);
      else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
        send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
        compress_block(s, static_ltree, static_dtree);
      } else {
        send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
        send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        compress_block(s, s.dyn_ltree, s.dyn_dtree);
      }
      init_block(s);
      if (last) bi_windup(s);
    };
    _tr_tally = (s, dist, lc) => {
      s.pending_buf[s.sym_buf + s.sym_next++] = dist;
      s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
      s.pending_buf[s.sym_buf + s.sym_next++] = lc;
      if (dist === 0) s.dyn_ltree[lc * 2]++;
      else {
        s.matches++;
        dist--;
        s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]++;
        s.dyn_dtree[d_code(dist) * 2]++;
      }
      return s.sym_next === s.sym_end;
    };
    adler32 = (adler, buf, len, pos) => {
      let s1 = adler & 65535 | 0, s2 = adler >>> 16 & 65535 | 0, n2 = 0;
      while (len !== 0) {
        n2 = len > 2e3 ? 2e3 : len;
        len -= n2;
        do {
          s1 = s1 + buf[pos++] | 0;
          s2 = s2 + s1 | 0;
        } while (--n2);
        s1 %= 65521;
        s2 %= 65521;
      }
      return s1 | s2 << 16 | 0;
    };
    makeTable = () => {
      let c2, table = [];
      for (var n2 = 0; n2 < 256; n2++) {
        c2 = n2;
        for (var k2 = 0; k2 < 8; k2++) c2 = c2 & 1 ? 3988292384 ^ c2 >>> 1 : c2 >>> 1;
        table[n2] = c2;
      }
      return table;
    };
    crcTable = new Uint32Array(makeTable());
    crc32 = (crc, buf, len, pos) => {
      const t = crcTable;
      const end = pos + len;
      crc ^= -1;
      for (let i2 = pos; i2 < end; i2++) crc = crc >>> 8 ^ t[(crc ^ buf[i2]) & 255];
      return crc ^ -1;
    };
    messages_default = {
      2: "need dictionary",
      1: "stream end",
      0: "",
      "-1": "file error",
      "-2": "stream error",
      "-3": "data error",
      "-4": "insufficient memory",
      "-5": "buffer error",
      "-6": "incompatible version"
    };
    Z_SYNC_FLUSH = 2;
    MAX_MEM_LEVEL = 9;
    HEAP_SIZE = 573;
    MIN_MATCH = 3;
    MAX_MATCH = 258;
    MIN_LOOKAHEAD = 262;
    PRESET_DICT = 32;
    INIT_STATE = 42;
    GZIP_STATE = 57;
    EXTRA_STATE = 69;
    NAME_STATE = 73;
    COMMENT_STATE = 91;
    HCRC_STATE = 103;
    BUSY_STATE = 113;
    FINISH_STATE = 666;
    BS_NEED_MORE = 1;
    BS_BLOCK_DONE = 2;
    BS_FINISH_STARTED = 3;
    BS_FINISH_DONE = 4;
    OS_CODE = 3;
    err = (strm, errorCode) => {
      strm.msg = messages_default[errorCode];
      return errorCode;
    };
    rank = (f3) => {
      return f3 * 2 - (f3 > 4 ? 9 : 0);
    };
    zero = (buf) => {
      let len = buf.length;
      while (--len >= 0) buf[len] = 0;
    };
    slide_hash = (s) => {
      let n2, m3;
      let p3;
      let wsize = s.w_size;
      n2 = s.hash_size;
      p3 = n2;
      do {
        m3 = s.head[--p3];
        s.head[p3] = m3 >= wsize ? m3 - wsize : 0;
      } while (--n2);
      n2 = wsize;
      p3 = n2;
      do {
        m3 = s.prev[--p3];
        s.prev[p3] = m3 >= wsize ? m3 - wsize : 0;
      } while (--n2);
    };
    HASH = (s, prev, data) => (prev << s.hash_shift ^ data) & s.hash_mask;
    INSERT_STRING = (s, str) => {
      let h3;
      if (s.legacy_hash) h3 = s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);
      else {
        const w4 = s.window;
        const value = w4[str] | w4[str + 1] << 8 | w4[str + 2] << 16 | w4[str + 3] << 24;
        h3 = s.ins_h = Math.imul(value, 66521) + 66521 >>> 16 & s.hash_mask;
      }
      const hash_head = s.prev[str & s.w_mask] = s.head[h3];
      s.head[h3] = str;
      return hash_head;
    };
    flush_pending = (strm) => {
      const s = strm.state;
      let len = s.pending;
      if (len > strm.avail_out) len = strm.avail_out;
      if (len === 0) return;
      strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
      strm.next_out += len;
      s.pending_out += len;
      strm.total_out += len;
      strm.avail_out -= len;
      s.pending -= len;
      if (s.pending === 0) s.pending_out = 0;
    };
    flush_block_only = (s, last) => {
      _tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
      s.block_start = s.strstart;
      flush_pending(s.strm);
    };
    put_byte = (s, b3) => {
      s.pending_buf[s.pending++] = b3;
    };
    putShortMSB = (s, b3) => {
      s.pending_buf[s.pending++] = b3 >>> 8 & 255;
      s.pending_buf[s.pending++] = b3 & 255;
    };
    read_buf = (strm, buf, start, size2) => {
      let len = strm.avail_in;
      if (len > size2) len = size2;
      if (len === 0) return 0;
      strm.avail_in -= len;
      buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
      if (strm.state.wrap === 1) strm.adler = adler32(strm.adler, buf, len, start);
      else if (strm.state.wrap === 2) strm.adler = crc32(strm.adler, buf, len, start);
      strm.next_in += len;
      strm.total_in += len;
      return len;
    };
    longest_match = (s, cur_match) => {
      let chain_length = s.max_chain_length;
      let scan = s.strstart;
      let match;
      let len;
      let best_len = s.prev_length;
      let nice_match = s.nice_match;
      const limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0;
      const _win = s.window;
      const wmask = s.w_mask;
      const prev = s.prev;
      const strend = s.strstart + MAX_MATCH;
      let scan_end1 = _win[scan + best_len - 1];
      let scan_end = _win[scan + best_len];
      if (s.prev_length >= s.good_match) chain_length >>= 2;
      if (nice_match > s.lookahead) nice_match = s.lookahead;
      do {
        match = cur_match;
        if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        scan += 2;
        match++;
        do
          ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        len = MAX_MATCH - (strend - scan);
        scan = strend - MAX_MATCH;
        if (len > best_len) {
          s.match_start = cur_match;
          best_len = len;
          if (len >= nice_match) break;
          scan_end1 = _win[scan + best_len - 1];
          scan_end = _win[scan + best_len];
        }
      } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
      if (best_len <= s.lookahead) return best_len;
      return s.lookahead;
    };
    fill_window = (s) => {
      const _w_size = s.w_size;
      let n2, more, str;
      do {
        more = s.window_size - s.lookahead - s.strstart;
        if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
          s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
          s.match_start -= _w_size;
          s.strstart -= _w_size;
          s.block_start -= _w_size;
          if (s.insert > s.strstart) s.insert = s.strstart;
          slide_hash(s);
          more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        n2 = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n2;
        if (!s.legacy_hash) {
          if (s.lookahead + s.insert > MIN_MATCH) {
            str = s.strstart - s.insert;
            while (s.insert) {
              INSERT_STRING(s, str);
              str++;
              s.insert--;
              if (s.lookahead + s.insert <= MIN_MATCH) break;
            }
          }
        } else if (s.lookahead + s.insert >= MIN_MATCH) {
          str = s.strstart - s.insert;
          s.ins_h = s.window[str];
          s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
          while (s.insert) {
            INSERT_STRING(s, str);
            str++;
            s.insert--;
            if (s.lookahead + s.insert < MIN_MATCH) break;
          }
        }
      } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);
    };
    deflate_stored = (s, flush) => {
      let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;
      let len, left, have, last = 0;
      let used = s.strm.avail_in;
      do {
        len = 65535;
        have = s.bi_valid + 42 >> 3;
        if (s.strm.avail_out < have) break;
        have = s.strm.avail_out - have;
        left = s.strstart - s.block_start;
        if (len > left + s.strm.avail_in) len = left + s.strm.avail_in;
        if (len > have) len = have;
        if (len < min_block && (len === 0 && flush !== 4 || flush === 0 || len !== left + s.strm.avail_in)) break;
        last = flush === 4 && len === left + s.strm.avail_in ? 1 : 0;
        _tr_stored_block(s, 0, 0, last);
        s.pending_buf[s.pending - 4] = len;
        s.pending_buf[s.pending - 3] = len >> 8;
        s.pending_buf[s.pending - 2] = ~len;
        s.pending_buf[s.pending - 1] = ~len >> 8;
        flush_pending(s.strm);
        if (left) {
          if (left > len) left = len;
          s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
          s.strm.next_out += left;
          s.strm.avail_out -= left;
          s.strm.total_out += left;
          s.block_start += left;
          len -= left;
        }
        if (len) {
          read_buf(s.strm, s.strm.output, s.strm.next_out, len);
          s.strm.next_out += len;
          s.strm.avail_out -= len;
          s.strm.total_out += len;
        }
      } while (last === 0);
      used -= s.strm.avail_in;
      if (used) {
        if (used >= s.w_size) {
          s.matches = 2;
          s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
          s.strstart = s.w_size;
          s.insert = s.strstart;
        } else {
          if (s.window_size - s.strstart <= used) {
            s.strstart -= s.w_size;
            s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
            if (s.matches < 2) s.matches++;
            if (s.insert > s.strstart) s.insert = s.strstart;
          }
          s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
          s.strstart += used;
          s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
        }
        s.block_start = s.strstart;
      }
      if (s.high_water < s.strstart) s.high_water = s.strstart;
      if (last) return BS_FINISH_DONE;
      if (flush !== 0 && flush !== 4 && s.strm.avail_in === 0 && s.strstart === s.block_start) return BS_BLOCK_DONE;
      have = s.window_size - s.strstart;
      if (s.strm.avail_in > have && s.block_start >= s.w_size) {
        s.block_start -= s.w_size;
        s.strstart -= s.w_size;
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) s.matches++;
        have += s.w_size;
        if (s.insert > s.strstart) s.insert = s.strstart;
      }
      if (have > s.strm.avail_in) have = s.strm.avail_in;
      if (have) {
        read_buf(s.strm, s.window, s.strstart, have);
        s.strstart += have;
        s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
      }
      if (s.high_water < s.strstart) s.high_water = s.strstart;
      have = s.bi_valid + 42 >> 3;
      have = s.pending_buf_size - have > 65535 ? 65535 : s.pending_buf_size - have;
      min_block = have > s.w_size ? s.w_size : have;
      left = s.strstart - s.block_start;
      if (left >= min_block || (left || flush === 4) && flush !== 0 && s.strm.avail_in === 0 && left <= have) {
        len = left > have ? have : left;
        last = flush === 4 && s.strm.avail_in === 0 && len === left ? 1 : 0;
        _tr_stored_block(s, s.block_start, len, last);
        s.block_start += len;
        flush_pending(s.strm);
      }
      return last ? BS_FINISH_STARTED : BS_NEED_MORE;
    };
    deflate_fast = (s, flush) => {
      let hash_head;
      let bflush;
      for (; ; ) {
        if (s.lookahead < MIN_LOOKAHEAD) {
          fill_window(s);
          if (s.lookahead < MIN_LOOKAHEAD && flush === 0) return BS_NEED_MORE;
          if (s.lookahead === 0) break;
        }
        hash_head = 0;
        if (s.lookahead >= MIN_MATCH) hash_head = INSERT_STRING(s, s.strstart);
        if (hash_head !== 0 && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) s.match_length = longest_match(s, hash_head);
        if (s.match_length >= MIN_MATCH) {
          bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
          s.lookahead -= s.match_length;
          if (s.match_length <= s.max_lazy_match && s.lookahead >= MIN_MATCH) {
            s.match_length--;
            do {
              s.strstart++;
              hash_head = INSERT_STRING(s, s.strstart);
            } while (--s.match_length !== 0);
            s.strstart++;
          } else {
            s.strstart += s.match_length;
            s.match_length = 0;
            if (s.legacy_hash) {
              s.ins_h = s.window[s.strstart];
              s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);
            }
          }
        } else {
          bflush = _tr_tally(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
        }
        if (bflush) {
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) return BS_NEED_MORE;
        }
      }
      s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
      if (flush === 4) {
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
      }
      return BS_BLOCK_DONE;
    };
    deflate_slow = (s, flush) => {
      let hash_head;
      let bflush;
      let max_insert;
      for (; ; ) {
        if (s.lookahead < MIN_LOOKAHEAD) {
          fill_window(s);
          if (s.lookahead < MIN_LOOKAHEAD && flush === 0) return BS_NEED_MORE;
          if (s.lookahead === 0) break;
        }
        hash_head = 0;
        if (s.lookahead >= MIN_MATCH) hash_head = INSERT_STRING(s, s.strstart);
        s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = MIN_MATCH - 1;
        if (hash_head !== 0 && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
          s.match_length = longest_match(s, hash_head);
          if (s.match_length <= 5 && (s.strategy === 1 || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096)) s.match_length = MIN_MATCH - 1;
        }
        if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
          max_insert = s.strstart + s.lookahead - MIN_MATCH;
          bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
          s.lookahead -= s.prev_length - 1;
          s.prev_length -= 2;
          do
            if (++s.strstart <= max_insert) hash_head = INSERT_STRING(s, s.strstart);
          while (--s.prev_length !== 0);
          s.match_available = 0;
          s.match_length = MIN_MATCH - 1;
          s.strstart++;
          if (bflush) {
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) return BS_NEED_MORE;
          }
        } else if (s.match_available) {
          bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
          if (bflush)
            flush_block_only(s, false);
          s.strstart++;
          s.lookahead--;
          if (s.strm.avail_out === 0) return BS_NEED_MORE;
        } else {
          s.match_available = 1;
          s.strstart++;
          s.lookahead--;
        }
      }
      if (s.match_available) {
        bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
      }
      s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
      if (flush === 4) {
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
      }
      return BS_BLOCK_DONE;
    };
    deflate_rle = (s, flush) => {
      let bflush;
      let prev;
      let scan, strend;
      const _win = s.window;
      for (; ; ) {
        if (s.lookahead <= MAX_MATCH) {
          fill_window(s);
          if (s.lookahead <= MAX_MATCH && flush === 0) return BS_NEED_MORE;
          if (s.lookahead === 0) break;
        }
        s.match_length = 0;
        if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
          scan = s.strstart - 1;
          prev = _win[scan];
          if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
            strend = s.strstart + MAX_MATCH;
            do
              ;
            while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
            s.match_length = MAX_MATCH - (strend - scan);
            if (s.match_length > s.lookahead) s.match_length = s.lookahead;
          }
        }
        if (s.match_length >= MIN_MATCH) {
          bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);
          s.lookahead -= s.match_length;
          s.strstart += s.match_length;
          s.match_length = 0;
        } else {
          bflush = _tr_tally(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
        }
        if (bflush) {
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) return BS_NEED_MORE;
        }
      }
      s.insert = 0;
      if (flush === 4) {
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
      }
      return BS_BLOCK_DONE;
    };
    deflate_huff = (s, flush) => {
      let bflush;
      for (; ; ) {
        if (s.lookahead === 0) {
          fill_window(s);
          if (s.lookahead === 0) {
            if (flush === 0) return BS_NEED_MORE;
            break;
          }
        }
        s.match_length = 0;
        bflush = _tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) return BS_NEED_MORE;
        }
      }
      s.insert = 0;
      if (flush === 4) {
        flush_block_only(s, true);
        if (s.strm.avail_out === 0) return BS_FINISH_STARTED;
        return BS_FINISH_DONE;
      }
      if (s.sym_next) {
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) return BS_NEED_MORE;
      }
      return BS_BLOCK_DONE;
    };
    Config = class {
      constructor(good_length, max_lazy, nice_length, max_chain, func) {
        this.good_length = good_length;
        this.max_lazy = max_lazy;
        this.nice_length = nice_length;
        this.max_chain = max_chain;
        this.func = func;
      }
    };
    configuration_table = [
      new Config(0, 0, 0, 0, deflate_stored),
      new Config(4, 4, 8, 4, deflate_fast),
      new Config(4, 5, 16, 8, deflate_fast),
      new Config(4, 6, 32, 32, deflate_fast),
      new Config(4, 4, 16, 16, deflate_slow),
      new Config(8, 16, 32, 32, deflate_slow),
      new Config(8, 16, 128, 128, deflate_slow),
      new Config(8, 32, 128, 256, deflate_slow),
      new Config(32, 128, 258, 1024, deflate_slow),
      new Config(32, 258, 258, 4096, deflate_slow)
    ];
    lm_init = (s) => {
      s.window_size = 2 * s.w_size;
      zero(s.head);
      s.max_lazy_match = configuration_table[s.level].max_lazy;
      s.good_match = configuration_table[s.level].good_length;
      s.nice_match = configuration_table[s.level].nice_length;
      s.max_chain_length = configuration_table[s.level].max_chain;
      s.strstart = 0;
      s.block_start = 0;
      s.lookahead = 0;
      s.insert = 0;
      s.match_length = s.prev_length = MIN_MATCH - 1;
      s.match_available = 0;
      s.ins_h = 0;
    };
    DeflateState = class {
      constructor() {
        this.strm = null;
        this.status = 0;
        this.pending_buf = null;
        this.pending_buf_size = 0;
        this.pending_out = 0;
        this.pending = 0;
        this.wrap = 0;
        this.gzhead = null;
        this.gzindex = 0;
        this.method = 8;
        this.last_flush = -1;
        this.w_size = 0;
        this.w_bits = 0;
        this.w_mask = 0;
        this.window = null;
        this.window_size = 0;
        this.prev = null;
        this.head = null;
        this.ins_h = 0;
        this.legacy_hash = 0;
        this.hash_size = 0;
        this.hash_bits = 0;
        this.hash_mask = 0;
        this.hash_shift = 0;
        this.block_start = 0;
        this.match_length = 0;
        this.prev_match = 0;
        this.match_available = 0;
        this.strstart = 0;
        this.match_start = 0;
        this.lookahead = 0;
        this.prev_length = 0;
        this.max_chain_length = 0;
        this.max_lazy_match = 0;
        this.level = 0;
        this.strategy = 0;
        this.good_match = 0;
        this.nice_match = 0;
        this.dyn_ltree = new Uint16Array(HEAP_SIZE * 2);
        this.dyn_dtree = /* @__PURE__ */ new Uint16Array(122);
        this.bl_tree = /* @__PURE__ */ new Uint16Array(78);
        zero(this.dyn_ltree);
        zero(this.dyn_dtree);
        zero(this.bl_tree);
        this.l_desc = null;
        this.d_desc = null;
        this.bl_desc = null;
        this.bl_count = /* @__PURE__ */ new Uint16Array(16);
        this.heap = /* @__PURE__ */ new Uint16Array(573);
        zero(this.heap);
        this.heap_len = 0;
        this.heap_max = 0;
        this.depth = /* @__PURE__ */ new Uint16Array(573);
        zero(this.depth);
        this.sym_buf = 0;
        this.lit_bufsize = 0;
        this.sym_next = 0;
        this.sym_end = 0;
        this.opt_len = 0;
        this.static_len = 0;
        this.matches = 0;
        this.insert = 0;
        this.bi_buf = 0;
        this.bi_valid = 0;
      }
    };
    deflateStateCheck = (strm) => {
      if (!strm) return 1;
      const s = strm.state;
      if (!s || s.strm !== strm || s.status !== INIT_STATE && s.status !== GZIP_STATE && s.status !== EXTRA_STATE && s.status !== NAME_STATE && s.status !== COMMENT_STATE && s.status !== HCRC_STATE && s.status !== BUSY_STATE && s.status !== FINISH_STATE) return 1;
      return 0;
    };
    deflateResetKeep = (strm) => {
      if (deflateStateCheck(strm)) return err(strm, -2);
      strm.total_in = strm.total_out = 0;
      strm.data_type = 2;
      const s = strm.state;
      s.pending = 0;
      s.pending_out = 0;
      if (s.wrap < 0) s.wrap = -s.wrap;
      s.status = s.wrap === 2 ? GZIP_STATE : s.wrap ? INIT_STATE : BUSY_STATE;
      strm.adler = s.wrap === 2 ? 0 : 1;
      s.last_flush = -2;
      _tr_init(s);
      return 0;
    };
    deflateReset = (strm) => {
      const ret = deflateResetKeep(strm);
      if (ret === 0) lm_init(strm.state);
      return ret;
    };
    deflateInit2 = (strm, level, method, windowBits, memLevel, strategy, legacyHash) => {
      if (!strm) return -2;
      let wrap = 1;
      if (level === -1) level = 6;
      if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
      } else if (windowBits > 15) {
        wrap = 2;
        windowBits -= 16;
      }
      if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== 8 || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > 4 || windowBits === 8 && wrap !== 1) return err(strm, -2);
      if (windowBits === 8) windowBits = 9;
      const s = new DeflateState();
      strm.state = s;
      s.strm = strm;
      s.status = INIT_STATE;
      s.wrap = wrap;
      s.gzhead = null;
      s.w_bits = windowBits;
      s.w_size = 1 << s.w_bits;
      s.w_mask = s.w_size - 1;
      s.legacy_hash = legacyHash ? 1 : 0;
      s.hash_bits = memLevel + 7;
      if (!s.legacy_hash && s.hash_bits < 15) s.hash_bits = 15;
      s.hash_size = 1 << s.hash_bits;
      s.hash_mask = s.hash_size - 1;
      s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
      s.window = new Uint8Array(s.w_size * 2);
      s.head = new Uint16Array(s.hash_size);
      s.prev = new Uint16Array(s.w_size);
      s.lit_bufsize = 1 << memLevel + 6;
      s.pending_buf_size = s.lit_bufsize * 4;
      s.pending_buf = new Uint8Array(s.pending_buf_size);
      s.sym_buf = s.lit_bufsize;
      s.sym_end = (s.lit_bufsize - 1) * 3;
      s.level = level;
      s.strategy = strategy;
      s.method = method;
      return deflateReset(strm);
    };
    deflate$1 = (strm, flush) => {
      if (deflateStateCheck(strm) || flush > 5 || flush < 0) return strm ? err(strm, -2) : -2;
      const s = strm.state;
      if (!strm.output || strm.avail_in !== 0 && !strm.input || s.status === FINISH_STATE && flush !== 4) return err(strm, strm.avail_out === 0 ? -5 : -2);
      const old_flush = s.last_flush;
      s.last_flush = flush;
      if (s.pending !== 0) {
        flush_pending(strm);
        if (strm.avail_out === 0) {
          s.last_flush = -1;
          return 0;
        }
      } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== 4) return err(strm, -5);
      if (s.status === FINISH_STATE && strm.avail_in !== 0) return err(strm, -5);
      if (s.status === INIT_STATE && s.wrap === 0) s.status = BUSY_STATE;
      if (s.status === INIT_STATE) {
        let header2 = 8 + (s.w_bits - 8 << 4) << 8;
        let level_flags = -1;
        if (s.strategy >= 2 || s.level < 2) level_flags = 0;
        else if (s.level < 6) level_flags = 1;
        else if (s.level === 6) level_flags = 2;
        else level_flags = 3;
        header2 |= level_flags << 6;
        if (s.strstart !== 0) header2 |= PRESET_DICT;
        header2 += 31 - header2 % 31;
        putShortMSB(s, header2);
        if (s.strstart !== 0) {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 65535);
        }
        strm.adler = 1;
        s.status = BUSY_STATE;
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return 0;
        }
      }
      if (s.status === GZIP_STATE) {
        strm.adler = 0;
        put_byte(s, 31);
        put_byte(s, 139);
        put_byte(s, 8);
        if (!s.gzhead) {
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, 0);
          put_byte(s, s.level === 9 ? 2 : s.strategy >= 2 || s.level < 2 ? 4 : 0);
          put_byte(s, OS_CODE);
          s.status = BUSY_STATE;
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return 0;
          }
        } else {
          put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
          put_byte(s, s.gzhead.time & 255);
          put_byte(s, s.gzhead.time >> 8 & 255);
          put_byte(s, s.gzhead.time >> 16 & 255);
          put_byte(s, s.gzhead.time >> 24 & 255);
          put_byte(s, s.level === 9 ? 2 : s.strategy >= 2 || s.level < 2 ? 4 : 0);
          put_byte(s, s.gzhead.os & 255);
          if (s.gzhead.extra && s.gzhead.extra.length) {
            put_byte(s, s.gzhead.extra.length & 255);
            put_byte(s, s.gzhead.extra.length >> 8 & 255);
          }
          if (s.gzhead.hcrc) strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
          s.gzindex = 0;
          s.status = EXTRA_STATE;
        }
      }
      if (s.status === EXTRA_STATE) {
        if (s.gzhead.extra) {
          let beg = s.pending;
          let left = (s.gzhead.extra.length & 65535) - s.gzindex;
          while (s.pending + left > s.pending_buf_size) {
            let copy = s.pending_buf_size - s.pending;
            s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
            s.pending = s.pending_buf_size;
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            s.gzindex += copy;
            flush_pending(strm);
            if (s.pending !== 0) {
              s.last_flush = -1;
              return 0;
            }
            beg = 0;
            left -= copy;
          }
          let gzhead_extra = new Uint8Array(s.gzhead.extra);
          s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
          s.pending += left;
          if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          s.gzindex = 0;
        }
        s.status = NAME_STATE;
      }
      if (s.status === NAME_STATE) {
        if (s.gzhead.name) {
          let beg = s.pending;
          let val;
          do {
            if (s.pending === s.pending_buf_size) {
              if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              flush_pending(strm);
              if (s.pending !== 0) {
                s.last_flush = -1;
                return 0;
              }
              beg = 0;
            }
            if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 255;
            else val = 0;
            put_byte(s, val);
          } while (val !== 0);
          if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          s.gzindex = 0;
        }
        s.status = COMMENT_STATE;
      }
      if (s.status === COMMENT_STATE) {
        if (s.gzhead.comment) {
          let beg = s.pending;
          let val;
          do {
            if (s.pending === s.pending_buf_size) {
              if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
              flush_pending(strm);
              if (s.pending !== 0) {
                s.last_flush = -1;
                return 0;
              }
              beg = 0;
            }
            if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 255;
            else val = 0;
            put_byte(s, val);
          } while (val !== 0);
          if (s.gzhead.hcrc && s.pending > beg) strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
        }
        s.status = HCRC_STATE;
      }
      if (s.status === HCRC_STATE) {
        if (s.gzhead.hcrc) {
          if (s.pending + 2 > s.pending_buf_size) {
            flush_pending(strm);
            if (s.pending !== 0) {
              s.last_flush = -1;
              return 0;
            }
          }
          put_byte(s, strm.adler & 255);
          put_byte(s, strm.adler >> 8 & 255);
          strm.adler = 0;
        }
        s.status = BUSY_STATE;
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return 0;
        }
      }
      if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== 0 && s.status !== FINISH_STATE) {
        let bstate = s.level === 0 ? deflate_stored(s, flush) : s.strategy === 2 ? deflate_huff(s, flush) : s.strategy === 3 ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
        if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) s.status = FINISH_STATE;
        if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
          if (strm.avail_out === 0) s.last_flush = -1;
          return 0;
        }
        if (bstate === BS_BLOCK_DONE) {
          if (flush === 1) _tr_align(s);
          else if (flush !== 5) {
            _tr_stored_block(s, 0, 0, false);
            if (flush === 3) {
              zero(s.head);
              if (s.lookahead === 0) {
                s.strstart = 0;
                s.block_start = 0;
                s.insert = 0;
              }
            }
          }
          flush_pending(strm);
          if (strm.avail_out === 0) {
            s.last_flush = -1;
            return 0;
          }
        }
      }
      if (flush !== 4) return 0;
      if (s.wrap <= 0) return 1;
      if (s.wrap === 2) {
        put_byte(s, strm.adler & 255);
        put_byte(s, strm.adler >> 8 & 255);
        put_byte(s, strm.adler >> 16 & 255);
        put_byte(s, strm.adler >> 24 & 255);
        put_byte(s, strm.total_in & 255);
        put_byte(s, strm.total_in >> 8 & 255);
        put_byte(s, strm.total_in >> 16 & 255);
        put_byte(s, strm.total_in >> 24 & 255);
      } else {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 65535);
      }
      flush_pending(strm);
      if (s.wrap > 0) s.wrap = -s.wrap;
      return s.pending !== 0 ? 0 : 1;
    };
    deflateEnd = (strm) => {
      if (deflateStateCheck(strm)) return -2;
      const status = strm.state.status;
      strm.state = null;
      return status === BUSY_STATE ? err(strm, -3) : 0;
    };
    deflateSetDictionary = (strm, dictionary) => {
      let dictLength = dictionary.length;
      if (deflateStateCheck(strm)) return -2;
      const s = strm.state;
      const wrap = s.wrap;
      if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) return -2;
      if (wrap === 1) strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
      s.wrap = 0;
      if (dictLength >= s.w_size) {
        if (wrap === 0) {
          zero(s.head);
          s.strstart = 0;
          s.block_start = 0;
          s.insert = 0;
        }
        let tmpDict = new Uint8Array(s.w_size);
        tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
      }
      const avail = strm.avail_in;
      const next = strm.next_in;
      const input = strm.input;
      strm.avail_in = dictLength;
      strm.next_in = 0;
      strm.input = dictionary;
      fill_window(s);
      while (s.lookahead >= MIN_MATCH) {
        let str = s.strstart;
        let n2 = s.lookahead - (MIN_MATCH - 1);
        do {
          INSERT_STRING(s, str);
          str++;
        } while (--n2);
        s.strstart = str;
        s.lookahead = MIN_MATCH - 1;
        fill_window(s);
      }
      s.strstart += s.lookahead;
      s.block_start = s.strstart;
      s.insert = s.lookahead;
      s.lookahead = 0;
      s.match_length = s.prev_length = MIN_MATCH - 1;
      s.match_available = 0;
      strm.next_in = next;
      strm.input = input;
      strm.avail_in = avail;
      s.wrap = wrap;
      return 0;
    };
    BAD$1 = 16209;
    TYPE$1 = 16191;
    MAXBITS = 15;
    ENOUGH_LENS$1 = 852;
    ENOUGH_DISTS$1 = 592;
    CODES$1 = 0;
    LENS$1 = 1;
    DISTS$1 = 2;
    lbase = new Uint16Array([
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      13,
      15,
      17,
      19,
      23,
      27,
      31,
      35,
      43,
      51,
      59,
      67,
      83,
      99,
      115,
      131,
      163,
      195,
      227,
      258,
      0,
      0
    ]);
    lext = new Uint8Array([
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      16,
      17,
      17,
      17,
      17,
      18,
      18,
      18,
      18,
      19,
      19,
      19,
      19,
      20,
      20,
      20,
      20,
      21,
      21,
      21,
      21,
      16,
      199,
      75
    ]);
    dbase = new Uint16Array([
      1,
      2,
      3,
      4,
      5,
      7,
      9,
      13,
      17,
      25,
      33,
      49,
      65,
      97,
      129,
      193,
      257,
      385,
      513,
      769,
      1025,
      1537,
      2049,
      3073,
      4097,
      6145,
      8193,
      12289,
      16385,
      24577,
      0,
      0
    ]);
    dext = new Uint8Array([
      16,
      16,
      16,
      16,
      17,
      17,
      18,
      18,
      19,
      19,
      20,
      20,
      21,
      21,
      22,
      22,
      23,
      23,
      24,
      24,
      25,
      25,
      26,
      26,
      27,
      27,
      28,
      28,
      29,
      29,
      64,
      64
    ]);
    inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts) => {
      const bits = opts.bits;
      let len = 0;
      let sym = 0;
      let min = 0, max = 0;
      let root = 0;
      let curr = 0;
      let drop = 0;
      let left = 0;
      let used = 0;
      let huff = 0;
      let incr;
      let fill;
      let low;
      let mask;
      let next;
      let base2 = null;
      let match;
      const count2 = /* @__PURE__ */ new Uint16Array(16);
      const offs = /* @__PURE__ */ new Uint16Array(16);
      let extra = null;
      let here_bits, here_op, here_val;
      for (len = 0; len <= MAXBITS; len++) count2[len] = 0;
      for (sym = 0; sym < codes; sym++) count2[lens[lens_index + sym]]++;
      root = bits;
      for (max = MAXBITS; max >= 1; max--) if (count2[max] !== 0) break;
      if (root > max) root = max;
      if (max === 0) {
        table[table_index++] = 20971520;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0;
      }
      for (min = 1; min < max; min++) if (count2[min] !== 0) break;
      if (root < min) root = min;
      left = 1;
      for (len = 1; len <= MAXBITS; len++) {
        left <<= 1;
        left -= count2[len];
        if (left < 0) return -1;
      }
      if (left > 0 && (type === CODES$1 || max !== 1)) return -1;
      offs[1] = 0;
      for (len = 1; len < MAXBITS; len++) offs[len + 1] = offs[len] + count2[len];
      for (sym = 0; sym < codes; sym++) if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
      if (type === CODES$1) {
        base2 = extra = work;
        match = 20;
      } else if (type === LENS$1) {
        base2 = lbase;
        extra = lext;
        match = 257;
      } else {
        base2 = dbase;
        extra = dext;
        match = 0;
      }
      huff = 0;
      sym = 0;
      len = min;
      next = table_index;
      curr = root;
      drop = 0;
      low = -1;
      used = 1 << root;
      mask = used - 1;
      if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
      for (; ; ) {
        here_bits = len - drop;
        if (work[sym] + 1 < match) {
          here_op = 0;
          here_val = work[sym];
        } else if (work[sym] >= match) {
          here_op = extra[work[sym] - match];
          here_val = base2[work[sym] - match];
        } else {
          here_op = 96;
          here_val = 0;
        }
        incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill;
        do {
          fill -= incr;
          table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        } while (fill !== 0);
        incr = 1 << len - 1;
        while (huff & incr) incr >>= 1;
        if (incr !== 0) {
          huff &= incr - 1;
          huff += incr;
        } else huff = 0;
        sym++;
        if (--count2[len] === 0) {
          if (len === max) break;
          len = lens[lens_index + work[sym]];
        }
        if (len > root && (huff & mask) !== low) {
          if (drop === 0) drop = root;
          next += min;
          curr = len - drop;
          left = 1 << curr;
          while (curr + drop < max) {
            left -= count2[curr + drop];
            if (left <= 0) break;
            curr++;
            left <<= 1;
          }
          used += 1 << curr;
          if (type === LENS$1 && used > ENOUGH_LENS$1 || type === DISTS$1 && used > ENOUGH_DISTS$1) return 1;
          low = huff & mask;
          table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
      }
      if (huff !== 0) table[next + huff] = len - drop << 24 | 4194304;
      opts.bits = root;
      return 0;
    };
    CODES2 = 0;
    LENS = 1;
    DISTS = 2;
    HEAD = 16180;
    FLAGS = 16181;
    TIME = 16182;
    OS = 16183;
    EXLEN = 16184;
    EXTRA = 16185;
    NAME = 16186;
    COMMENT = 16187;
    HCRC = 16188;
    DICTID = 16189;
    DICT = 16190;
    TYPE = 16191;
    TYPEDO = 16192;
    STORED = 16193;
    COPY_ = 16194;
    COPY = 16195;
    TABLE = 16196;
    LENLENS = 16197;
    CODELENS = 16198;
    LEN_ = 16199;
    LEN = 16200;
    LENEXT = 16201;
    DIST = 16202;
    DISTEXT = 16203;
    MATCH = 16204;
    LIT = 16205;
    CHECK = 16206;
    LENGTH = 16207;
    DONE = 16208;
    BAD = 16209;
    MEM = 16210;
    SYNC = 16211;
    ENOUGH_LENS = 852;
    ENOUGH_DISTS = 592;
    zswap32 = (q2) => {
      return (q2 >>> 24 & 255) + (q2 >>> 8 & 65280) + ((q2 & 65280) << 8) + ((q2 & 255) << 24);
    };
    InflateState = class {
      constructor() {
        this.strm = null;
        this.mode = 0;
        this.last = false;
        this.wrap = 0;
        this.havedict = false;
        this.flags = 0;
        this.dmax = 0;
        this.check = 0;
        this.total = 0;
        this.head = null;
        this.wbits = 0;
        this.wsize = 0;
        this.whave = 0;
        this.wnext = 0;
        this.window = null;
        this.hold = 0;
        this.bits = 0;
        this.length = 0;
        this.offset = 0;
        this.extra = 0;
        this.lencode = null;
        this.distcode = null;
        this.lenbits = 0;
        this.distbits = 0;
        this.ncode = 0;
        this.nlen = 0;
        this.ndist = 0;
        this.have = 0;
        this.next = null;
        this.lens = /* @__PURE__ */ new Uint16Array(320);
        this.work = /* @__PURE__ */ new Uint16Array(288);
        this.lendyn = null;
        this.distdyn = null;
        this.sane = 0;
        this.back = 0;
        this.was = 0;
      }
    };
    inflateStateCheck = (strm) => {
      if (!strm) return 1;
      const state = strm.state;
      if (!state || state.strm !== strm || state.mode < HEAD || state.mode > SYNC) return 1;
      return 0;
    };
    inflateResetKeep = (strm) => {
      if (inflateStateCheck(strm)) return -2;
      const state = strm.state;
      strm.total_in = strm.total_out = state.total = 0;
      strm.msg = "";
      if (state.wrap) strm.adler = state.wrap & 1;
      state.mode = HEAD;
      state.last = 0;
      state.havedict = 0;
      state.flags = -1;
      state.dmax = 32768;
      state.head = null;
      state.hold = 0;
      state.bits = 0;
      state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
      state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);
      state.sane = 1;
      state.back = -1;
      return 0;
    };
    inflateReset = (strm) => {
      if (inflateStateCheck(strm)) return -2;
      const state = strm.state;
      state.wsize = 0;
      state.whave = 0;
      state.wnext = 0;
      return inflateResetKeep(strm);
    };
    inflateReset2 = (strm, windowBits) => {
      let wrap;
      if (inflateStateCheck(strm)) return -2;
      const state = strm.state;
      if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
      } else {
        wrap = (windowBits >> 4) + 5;
        if (windowBits < 48) windowBits &= 15;
      }
      if (windowBits && (windowBits < 8 || windowBits > 15)) return -2;
      if (state.window !== null && state.wbits !== windowBits) state.window = null;
      state.wrap = wrap;
      state.wbits = windowBits;
      return inflateReset(strm);
    };
    inflateInit2 = (strm, windowBits) => {
      if (!strm) return -2;
      const state = new InflateState();
      strm.state = state;
      state.strm = strm;
      state.window = null;
      state.mode = HEAD;
      const ret = inflateReset2(strm, windowBits);
      if (ret !== 0) strm.state = null;
      return ret;
    };
    virgin = true;
    fixedtables = (state) => {
      if (virgin) {
        lenfix = /* @__PURE__ */ new Int32Array(512);
        distfix = /* @__PURE__ */ new Int32Array(32);
        let sym = 0;
        while (sym < 144) state.lens[sym++] = 8;
        while (sym < 256) state.lens[sym++] = 9;
        while (sym < 280) state.lens[sym++] = 7;
        while (sym < 288) state.lens[sym++] = 8;
        inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, { bits: 9 });
        sym = 0;
        while (sym < 32) state.lens[sym++] = 5;
        inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, { bits: 5 });
        virgin = false;
      }
      state.lencode = lenfix;
      state.lenbits = 9;
      state.distcode = distfix;
      state.distbits = 5;
    };
    updatewindow = (strm, src, end, copy) => {
      let dist;
      const state = strm.state;
      if (state.window === null) state.window = new Uint8Array(1 << state.wbits);
      if (state.wsize === 0) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
      }
      if (copy >= state.wsize) {
        state.window.set(src.subarray(end - state.wsize, end), 0);
        state.wnext = 0;
        state.whave = state.wsize;
      } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
        copy -= dist;
        if (copy) {
          state.window.set(src.subarray(end - copy, end), 0);
          state.wnext = copy;
          state.whave = state.wsize;
        } else {
          state.wnext += dist;
          if (state.wnext === state.wsize) state.wnext = 0;
          if (state.whave < state.wsize) state.whave += dist;
        }
      }
      return 0;
    };
    inflate$1 = (strm, flush) => {
      let state;
      let input, output;
      let next;
      let put;
      let have, left;
      let hold;
      let bits;
      let _in, _out;
      let copy;
      let from2;
      let from_source;
      let here = 0;
      let here_bits, here_op, here_val;
      let last_bits, last_op, last_val;
      let len;
      let ret;
      const hbuf = /* @__PURE__ */ new Uint8Array(4);
      let opts;
      let n2;
      const order = new Uint8Array([
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
      ]);
      if (inflateStateCheck(strm) || !strm.output || !strm.input && strm.avail_in !== 0) return -2;
      state = strm.state;
      if (state.mode === TYPE) state.mode = TYPEDO;
      put = strm.next_out;
      output = strm.output;
      left = strm.avail_out;
      next = strm.next_in;
      input = strm.input;
      have = strm.avail_in;
      hold = state.hold;
      bits = state.bits;
      _in = have;
      _out = left;
      ret = 0;
      inf_leave: for (; ; ) switch (state.mode) {
        case HEAD:
          if (state.wrap === 0) {
            state.mode = TYPEDO;
            break;
          }
          while (bits < 16) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (state.wrap & 2 && hold === 35615) {
            if (state.wbits === 0) state.wbits = 15;
            state.check = 0;
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            state.check = crc32(state.check, hbuf, 2, 0);
            hold = 0;
            bits = 0;
            state.mode = FLAGS;
            break;
          }
          if (state.head) state.head.done = false;
          if (!(state.wrap & 1) || (((hold & 255) << 8) + (hold >> 8)) % 31) {
            strm.msg = "incorrect header check";
            state.mode = BAD;
            break;
          }
          if ((hold & 15) !== 8) {
            strm.msg = "unknown compression method";
            state.mode = BAD;
            break;
          }
          hold >>>= 4;
          bits -= 4;
          len = (hold & 15) + 8;
          if (state.wbits === 0) state.wbits = len;
          if (len > 15 || len > state.wbits) {
            strm.msg = "invalid window size";
            state.mode = BAD;
            break;
          }
          state.dmax = 1 << state.wbits;
          state.flags = 0;
          strm.adler = state.check = 1;
          state.mode = hold & 512 ? DICTID : TYPE;
          hold = 0;
          bits = 0;
          break;
        case FLAGS:
          while (bits < 16) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.flags = hold;
          if ((state.flags & 255) !== 8) {
            strm.msg = "unknown compression method";
            state.mode = BAD;
            break;
          }
          if (state.flags & 57344) {
            strm.msg = "unknown header flags set";
            state.mode = BAD;
            break;
          }
          if (state.head) state.head.text = hold >> 8 & 1;
          if (state.flags & 512 && state.wrap & 4) {
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            state.check = crc32(state.check, hbuf, 2, 0);
          }
          hold = 0;
          bits = 0;
          state.mode = TIME;
        case TIME:
          while (bits < 32) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (state.head) state.head.time = hold >>> 0;
          if (state.flags & 512 && state.wrap & 4) {
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            hbuf[2] = hold >>> 16 & 255;
            hbuf[3] = hold >>> 24 & 255;
            state.check = crc32(state.check, hbuf, 4, 0);
          }
          hold = 0;
          bits = 0;
          state.mode = OS;
        case OS:
          while (bits < 16) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (state.head) {
            state.head.xflags = hold & 255;
            state.head.os = hold >> 8;
          }
          if (state.flags & 512 && state.wrap & 4) {
            hbuf[0] = hold & 255;
            hbuf[1] = hold >>> 8 & 255;
            state.check = crc32(state.check, hbuf, 2, 0);
          }
          hold = 0;
          bits = 0;
          state.mode = EXLEN;
        case EXLEN:
          if (state.flags & 1024) {
            while (bits < 16) {
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            state.length = hold;
            if (state.head) state.head.extra_len = hold;
            if (state.flags & 512 && state.wrap & 4) {
              hbuf[0] = hold & 255;
              hbuf[1] = hold >>> 8 & 255;
              state.check = crc32(state.check, hbuf, 2, 0);
            }
            hold = 0;
            bits = 0;
          } else if (state.head) state.head.extra = null;
          state.mode = EXTRA;
        case EXTRA:
          if (state.flags & 1024) {
            copy = state.length;
            if (copy > have) copy = have;
            if (copy) {
              if (state.head) {
                len = state.head.extra_len - state.length;
                if (!state.head.extra) state.head.extra = new Uint8Array(state.head.extra_len);
                state.head.extra.set(input.subarray(next, next + copy), len);
              }
              if (state.flags & 512 && state.wrap & 4) state.check = crc32(state.check, input, copy, next);
              have -= copy;
              next += copy;
              state.length -= copy;
            }
            if (state.length) break inf_leave;
          }
          state.length = 0;
          state.mode = NAME;
        case NAME:
          if (state.flags & 2048) {
            if (have === 0) break inf_leave;
            copy = 0;
            do {
              len = input[next + copy++];
              if (state.head && len && state.length < 65536) state.head.name += String.fromCharCode(len);
            } while (len && copy < have);
            if (state.flags & 512 && state.wrap & 4) state.check = crc32(state.check, input, copy, next);
            have -= copy;
            next += copy;
            if (len) break inf_leave;
          } else if (state.head) state.head.name = null;
          state.length = 0;
          state.mode = COMMENT;
        case COMMENT:
          if (state.flags & 4096) {
            if (have === 0) break inf_leave;
            copy = 0;
            do {
              len = input[next + copy++];
              if (state.head && len && state.length < 65536) state.head.comment += String.fromCharCode(len);
            } while (len && copy < have);
            if (state.flags & 512 && state.wrap & 4) state.check = crc32(state.check, input, copy, next);
            have -= copy;
            next += copy;
            if (len) break inf_leave;
          } else if (state.head) state.head.comment = null;
          state.mode = HCRC;
        case HCRC:
          if (state.flags & 512) {
            while (bits < 16) {
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            if (state.wrap & 4 && hold !== (state.check & 65535)) {
              strm.msg = "header crc mismatch";
              state.mode = BAD;
              break;
            }
            hold = 0;
            bits = 0;
          }
          if (state.head) {
            state.head.hcrc = state.flags >> 9 & 1;
            state.head.done = true;
          }
          strm.adler = state.check = 0;
          state.mode = TYPE;
          break;
        case DICTID:
          while (bits < 32) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          strm.adler = state.check = zswap32(hold);
          hold = 0;
          bits = 0;
          state.mode = DICT;
        case DICT:
          if (state.havedict === 0) {
            strm.next_out = put;
            strm.avail_out = left;
            strm.next_in = next;
            strm.avail_in = have;
            state.hold = hold;
            state.bits = bits;
            return 2;
          }
          strm.adler = state.check = 1;
          state.mode = TYPE;
        case TYPE:
          if (flush === 5 || flush === 6) break inf_leave;
        case TYPEDO:
          if (state.last) {
            hold >>>= bits & 7;
            bits -= bits & 7;
            state.mode = CHECK;
            break;
          }
          while (bits < 3) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.last = hold & 1;
          hold >>>= 1;
          bits -= 1;
          switch (hold & 3) {
            case 0:
              state.mode = STORED;
              break;
            case 1:
              fixedtables(state);
              state.mode = LEN_;
              if (flush === 6) {
                hold >>>= 2;
                bits -= 2;
                break inf_leave;
              }
              break;
            case 2:
              state.mode = TABLE;
              break;
            case 3:
              strm.msg = "invalid block type";
              state.mode = BAD;
          }
          hold >>>= 2;
          bits -= 2;
          break;
        case STORED:
          hold >>>= bits & 7;
          bits -= bits & 7;
          while (bits < 32) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if ((hold & 65535) !== (hold >>> 16 ^ 65535)) {
            strm.msg = "invalid stored block lengths";
            state.mode = BAD;
            break;
          }
          state.length = hold & 65535;
          hold = 0;
          bits = 0;
          state.mode = COPY_;
          if (flush === 6) break inf_leave;
        case COPY_:
          state.mode = COPY;
        case COPY:
          copy = state.length;
          if (copy) {
            if (copy > have) copy = have;
            if (copy > left) copy = left;
            if (copy === 0) break inf_leave;
            output.set(input.subarray(next, next + copy), put);
            have -= copy;
            next += copy;
            left -= copy;
            put += copy;
            state.length -= copy;
            break;
          }
          state.mode = TYPE;
          break;
        case TABLE:
          while (bits < 14) {
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          state.nlen = (hold & 31) + 257;
          hold >>>= 5;
          bits -= 5;
          state.ndist = (hold & 31) + 1;
          hold >>>= 5;
          bits -= 5;
          state.ncode = (hold & 15) + 4;
          hold >>>= 4;
          bits -= 4;
          if (state.nlen > 286 || state.ndist > 30) {
            strm.msg = "too many length or distance symbols";
            state.mode = BAD;
            break;
          }
          state.have = 0;
          state.mode = LENLENS;
        case LENLENS:
          while (state.have < state.ncode) {
            while (bits < 3) {
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            state.lens[order[state.have++]] = hold & 7;
            hold >>>= 3;
            bits -= 3;
          }
          while (state.have < 19) state.lens[order[state.have++]] = 0;
          state.lencode = state.lendyn;
          state.lenbits = 7;
          opts = { bits: state.lenbits };
          ret = inflate_table(CODES2, state.lens, 0, 19, state.lencode, 0, state.work, opts);
          state.lenbits = opts.bits;
          if (ret) {
            strm.msg = "invalid code lengths set";
            state.mode = BAD;
            break;
          }
          state.have = 0;
          state.mode = CODELENS;
        case CODELENS:
          while (state.have < state.nlen + state.ndist) {
            for (; ; ) {
              here = state.lencode[hold & (1 << state.lenbits) - 1];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 255;
              here_val = here & 65535;
              if (here_bits <= bits) break;
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            if (here_val < 16) {
              hold >>>= here_bits;
              bits -= here_bits;
              state.lens[state.have++] = here_val;
            } else {
              if (here_val === 16) {
                n2 = here_bits + 2;
                while (bits < n2) {
                  if (have === 0) break inf_leave;
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                hold >>>= here_bits;
                bits -= here_bits;
                if (state.have === 0) {
                  strm.msg = "invalid bit length repeat";
                  state.mode = BAD;
                  break;
                }
                len = state.lens[state.have - 1];
                copy = 3 + (hold & 3);
                hold >>>= 2;
                bits -= 2;
              } else if (here_val === 17) {
                n2 = here_bits + 3;
                while (bits < n2) {
                  if (have === 0) break inf_leave;
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                hold >>>= here_bits;
                bits -= here_bits;
                len = 0;
                copy = 3 + (hold & 7);
                hold >>>= 3;
                bits -= 3;
              } else {
                n2 = here_bits + 7;
                while (bits < n2) {
                  if (have === 0) break inf_leave;
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                hold >>>= here_bits;
                bits -= here_bits;
                len = 0;
                copy = 11 + (hold & 127);
                hold >>>= 7;
                bits -= 7;
              }
              if (state.have + copy > state.nlen + state.ndist) {
                strm.msg = "invalid bit length repeat";
                state.mode = BAD;
                break;
              }
              while (copy--) state.lens[state.have++] = len;
            }
          }
          if (state.mode === BAD) break;
          if (state.lens[256] === 0) {
            strm.msg = "invalid code -- missing end-of-block";
            state.mode = BAD;
            break;
          }
          state.lenbits = 9;
          opts = { bits: state.lenbits };
          ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
          state.lenbits = opts.bits;
          if (ret) {
            strm.msg = "invalid literal/lengths set";
            state.mode = BAD;
            break;
          }
          state.distbits = 6;
          state.distcode = state.distdyn;
          opts = { bits: state.distbits };
          ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
          state.distbits = opts.bits;
          if (ret) {
            strm.msg = "invalid distances set";
            state.mode = BAD;
            break;
          }
          state.mode = LEN_;
          if (flush === 6) break inf_leave;
        case LEN_:
          state.mode = LEN;
        case LEN:
          if (have >= 6 && left >= 258) {
            strm.next_out = put;
            strm.avail_out = left;
            strm.next_in = next;
            strm.avail_in = have;
            state.hold = hold;
            state.bits = bits;
            inflate_fast(strm, _out);
            put = strm.next_out;
            output = strm.output;
            left = strm.avail_out;
            next = strm.next_in;
            input = strm.input;
            have = strm.avail_in;
            hold = state.hold;
            bits = state.bits;
            if (state.mode === TYPE) state.back = -1;
            break;
          }
          state.back = 0;
          for (; ; ) {
            here = state.lencode[hold & (1 << state.lenbits) - 1];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 255;
            here_val = here & 65535;
            if (here_bits <= bits) break;
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if (here_op && (here_op & 240) === 0) {
            last_bits = here_bits;
            last_op = here_op;
            last_val = here_val;
            for (; ; ) {
              here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 255;
              here_val = here & 65535;
              if (last_bits + here_bits <= bits) break;
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            hold >>>= last_bits;
            bits -= last_bits;
            state.back += last_bits;
          }
          hold >>>= here_bits;
          bits -= here_bits;
          state.back += here_bits;
          state.length = here_val;
          if (here_op === 0) {
            state.mode = LIT;
            break;
          }
          if (here_op & 32) {
            state.back = -1;
            state.mode = TYPE;
            break;
          }
          if (here_op & 64) {
            strm.msg = "invalid literal/length code";
            state.mode = BAD;
            break;
          }
          state.extra = here_op & 15;
          state.mode = LENEXT;
        case LENEXT:
          if (state.extra) {
            n2 = state.extra;
            while (bits < n2) {
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            state.length += hold & (1 << state.extra) - 1;
            hold >>>= state.extra;
            bits -= state.extra;
            state.back += state.extra;
          }
          state.was = state.length;
          state.mode = DIST;
        case DIST:
          for (; ; ) {
            here = state.distcode[hold & (1 << state.distbits) - 1];
            here_bits = here >>> 24;
            here_op = here >>> 16 & 255;
            here_val = here & 65535;
            if (here_bits <= bits) break;
            if (have === 0) break inf_leave;
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          if ((here_op & 240) === 0) {
            last_bits = here_bits;
            last_op = here_op;
            last_val = here_val;
            for (; ; ) {
              here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
              here_bits = here >>> 24;
              here_op = here >>> 16 & 255;
              here_val = here & 65535;
              if (last_bits + here_bits <= bits) break;
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            hold >>>= last_bits;
            bits -= last_bits;
            state.back += last_bits;
          }
          hold >>>= here_bits;
          bits -= here_bits;
          state.back += here_bits;
          if (here_op & 64) {
            strm.msg = "invalid distance code";
            state.mode = BAD;
            break;
          }
          state.offset = here_val;
          state.extra = here_op & 15;
          state.mode = DISTEXT;
        case DISTEXT:
          if (state.extra) {
            n2 = state.extra;
            while (bits < n2) {
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            state.offset += hold & (1 << state.extra) - 1;
            hold >>>= state.extra;
            bits -= state.extra;
            state.back += state.extra;
          }
          if (state.offset > state.dmax) {
            strm.msg = "invalid distance too far back";
            state.mode = BAD;
            break;
          }
          state.mode = MATCH;
        case MATCH:
          if (left === 0) break inf_leave;
          copy = _out - left;
          if (state.offset > copy) {
            copy = state.offset - copy;
            if (copy > state.whave) {
              if (state.sane) {
                strm.msg = "invalid distance too far back";
                state.mode = BAD;
                break;
              }
            }
            if (copy > state.wnext) {
              copy -= state.wnext;
              from2 = state.wsize - copy;
            } else from2 = state.wnext - copy;
            if (copy > state.length) copy = state.length;
            from_source = state.window;
          } else {
            from_source = output;
            from2 = put - state.offset;
            copy = state.length;
          }
          if (copy > left) copy = left;
          left -= copy;
          state.length -= copy;
          do
            output[put++] = from_source[from2++];
          while (--copy);
          if (state.length === 0) state.mode = LEN;
          break;
        case LIT:
          if (left === 0) break inf_leave;
          output[put++] = state.length;
          left--;
          state.mode = LEN;
          break;
        case CHECK:
          if (state.wrap) {
            while (bits < 32) {
              if (have === 0) break inf_leave;
              have--;
              hold |= input[next++] << bits;
              bits += 8;
            }
            _out -= left;
            strm.total_out += _out;
            state.total += _out;
            if (state.wrap & 4 && _out) strm.adler = state.check = state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
            _out = left;
            if (state.wrap & 4 && (state.flags ? hold : zswap32(hold)) !== state.check) {
              strm.msg = "incorrect data check";
              state.mode = BAD;
              break;
            }
            hold = 0;
            bits = 0;
          }
          state.mode = LENGTH;
        case LENGTH:
          if (state.wrap && state.flags) {
            while (bits < 32) {
              if (have === 0) break inf_leave;
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            if (state.wrap & 4 && hold !== (state.total & 4294967295)) {
              strm.msg = "incorrect length check";
              state.mode = BAD;
              break;
            }
            hold = 0;
            bits = 0;
          }
          state.mode = DONE;
        case DONE:
          ret = 1;
          break inf_leave;
        case BAD:
          ret = -3;
          break inf_leave;
        case MEM:
          return -4;
        case SYNC:
        default:
          return -2;
      }
      strm.next_out = put;
      strm.avail_out = left;
      strm.next_in = next;
      strm.avail_in = have;
      state.hold = hold;
      state.bits = bits;
      if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== 4)) {
        if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
          state.mode = MEM;
          return -4;
        }
      }
      _in -= strm.avail_in;
      _out -= strm.avail_out;
      strm.total_in += _in;
      strm.total_out += _out;
      state.total += _out;
      if (state.wrap & 4 && _out) strm.adler = state.check = state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
      strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
      if ((_in === 0 && _out === 0 || flush === 4) && ret === 0) ret = -5;
      return ret;
    };
    inflateEnd = (strm) => {
      if (inflateStateCheck(strm)) return -2;
      let state = strm.state;
      if (state.window) state.window = null;
      strm.state = null;
      return 0;
    };
    inflateSetDictionary = (strm, dictionary) => {
      const dictLength = dictionary.length;
      let state;
      let dictid;
      let ret;
      if (inflateStateCheck(strm)) return -2;
      state = strm.state;
      if (state.wrap !== 0 && state.mode !== DICT) return -2;
      if (state.mode === DICT) {
        dictid = 1;
        dictid = adler32(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return -3;
      }
      ret = updatewindow(strm, dictionary, dictLength, dictLength);
      if (ret) {
        state.mode = MEM;
        return -4;
      }
      state.havedict = 1;
      return 0;
    };
    ZStream = class {
      constructor() {
        this.input = null;
        this.next_in = 0;
        this.avail_in = 0;
        this.total_in = 0;
        this.output = null;
        this.next_out = 0;
        this.avail_out = 0;
        this.total_out = 0;
        this.msg = "";
        this.state = null;
        this.data_type = 2;
        this.adler = 0;
      }
    };
    flattenChunks = (chunks) => {
      const result = new Uint8Array(chunks.reduce((len, chunk) => len + chunk.length, 0));
      let pos = 0;
      for (const chunk of chunks) {
        result.set(chunk, pos);
        pos += chunk.length;
      }
      return result;
    };
    toString$1 = Object.prototype.toString;
    defaultOptions$1 = {
      level: -1,
      chunkSize: 16384,
      windowBits: 15,
      memLevel: 8,
      strategy: 0,
      raw: false,
      gzip: false,
      legacyHash: false,
      dictionary: /* @__PURE__ */ new Uint8Array(0)
    };
    Deflate = class {
      options;
      /**
      * Error code after deflate finishes. {@link Z_OK} on success.
      * You will not need it in real life, because deflate errors
      * are possible only on wrong options or bad custom `onData` / `onEnd`
      * handlers.
      */
      err;
      /** Error message, if {@link Deflate.err} is not {@link Z_OK}. */
      msg;
      ended;
      started;
      /**
      * Chunks of output data, if {@link Deflate.onData} not overridden.
      * @internal
      */
      chunks;
      strm;
      /**
      * Compressed result, generated by default {@link Deflate.onData}
      * and {@link Deflate.onEnd} handlers. Filled after you push last chunk
      * (call {@link Deflate.push} with {@link Z_FINISH} / `true` param).
      */
      result;
      /**
      * Creates a new deflator instance with the specified params. Throws an
      * exception on bad params. See {@link DeflateOptions} for the list of
      * supported options.
      *
      * @example
      * ```javascript
      * import { Deflate } from 'pako'
      *
      * const chunk1 = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8, 9])
      * const chunk2 = new Uint8Array([10, 11, 12, 13, 14, 15, 16, 17, 18, 19])
      *
      * const deflate = new Deflate({ level: 3 })
      *
      * deflate.push(chunk1, false)
      * deflate.push(chunk2, true)  // true -> last chunk
      *
      * if (deflate.err) throw new Error(deflate.err)
      *
      * console.log(deflate.result)
      * ```
      */
      constructor(options = {}) {
        this.options = Object.assign({}, defaultOptions$1, options);
        const opt = this.options;
        if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
        else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
        this.err = 0;
        this.msg = "";
        this.ended = false;
        this.started = false;
        this.chunks = [];
        this.result = /* @__PURE__ */ new Uint8Array(0);
        this.strm = new ZStream();
        this.strm.avail_out = 0;
        let status = deflateInit2(this.strm, opt.level, 8, opt.windowBits, opt.memLevel, opt.strategy, opt.legacyHash);
        if (status !== 0) throw new Error(messages_default[status]);
        if (toString$1.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        const dictionary = opt.dictionary;
        if (dictionary.length) {
          if (opt.gzip) throw new Error("dictionary is not supported with gzip");
          status = deflateSetDictionary(this.strm, dictionary);
          if (status !== 0) throw new Error(messages_default[status]);
        }
      }
      /**
      * Sends input data to the deflate pipe, generating {@link Deflate.onData} calls
      * with new compressed chunks. Returns `true` on success. The last data block must
      * have `flush_mode` {@link Z_FINISH} (or `true`). That will flush the internal
      * pending buffers and call {@link Deflate.onEnd}.
      *
      * On failure, calls {@link Deflate.onEnd} with the error code and returns false.
      *
      * @param data input data. Strings will be converted to utf8 byte sequence.
      * @param flush_mode 0..6 for corresponding {@link Z_NO_FLUSH}..{@link Z_TREES} modes.
      *   See constants. Skipped or `false` means {@link Z_NO_FLUSH}, `true` means {@link Z_FINISH}.
      *
      * @example
      * ```javascript
      * push(chunk, false) // push one of data chunks
      * ...
      * push(chunk, true)  // push last chunk
      * ```
      */
      push(data, flush_mode = false) {
        const strm = this.strm;
        const chunkSize = this.options.chunkSize;
        let status;
        let _flush_mode;
        if (this.ended) return false;
        if (typeof flush_mode === "number") _flush_mode = flush_mode;
        else _flush_mode = flush_mode === true ? 4 : 0;
        if (typeof data === "string") strm.input = new TextEncoder().encode(data);
        else if (toString$1.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
        else strm.input = data;
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        if (!this.started) {
          this.started = true;
          this.onStart(strm);
        }
        for (; ; ) {
          if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          if ((_flush_mode === 2 || _flush_mode === 3) && strm.avail_out <= 6) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
          }
          status = deflate$1(strm, _flush_mode);
          if (status === -2) break;
          if (status === 1) {
            if (strm.next_out > 0) this.onData(strm.output.subarray(0, strm.next_out));
            status = deflateEnd(this.strm);
            break;
          }
          if (strm.avail_out === 0) {
            this.onData(strm.output);
            continue;
          }
          if (_flush_mode > 0 && strm.next_out > 0) {
            this.onData(strm.output.subarray(0, strm.next_out));
            strm.avail_out = 0;
            continue;
          }
          if (strm.avail_in === 0) return true;
        }
        this.err = status;
        this.msg = strm.msg || messages_default[status];
        this.ended = true;
        this.onEnd(status);
        return status === 0;
      }
      /**
      * Called once before the first low-level deflate call.
      */
      onStart(strm) {
      }
      /**
      * By default, stores data blocks in the {@link Deflate.chunks} property and glues
      * them in {@link Deflate.onEnd}. Override this handler if you need another behaviour.
      */
      onData(chunk) {
        this.chunks.push(chunk);
      }
      /**
      * Called once after you tell deflate that the input stream is
      * complete ({@link Z_FINISH}). By default, joins the collected {@link Deflate.chunks}
      * into the {@link Deflate.result} property.
      *
      * @param status deflate status. {@link Z_OK} on success, other if not.
      */
      onEnd(status) {
        if (status === 0) this.result = flattenChunks(this.chunks);
        this.chunks = [];
      }
    };
    toString = Object.prototype.toString;
    defaultOptions = {
      chunkSize: 1024 * 64,
      windowBits: 15,
      raw: false,
      dictionary: /* @__PURE__ */ new Uint8Array(0)
    };
    Inflate = class {
      options;
      /**
      * Error code after inflate finishes. {@link Z_OK} on success.
      * Should be checked when broken data is possible.
      */
      err;
      /** Error message, if {@link Inflate.err} is not {@link Z_OK}. */
      msg;
      /**
      * `true` once the compressed stream has ended. A stream may end before the
      * caller's data does (trailing bytes), so check this to know when to stop
      * pushing - further {@link Inflate.push} calls are no-ops.
      */
      ended;
      started;
      /**
      * Chunks of output data, if {@link Inflate.onData} not overridden.
      * @internal
      */
      chunks;
      strm;
      /**
      * Uncompressed result, generated by default {@link Inflate.onData}
      * and {@link Inflate.onEnd} handlers. Filled after you push last chunk
      * (call {@link Inflate.push} with {@link Z_FINISH} / `true` param).
      */
      result;
      /**
      * Creates a new inflator instance with the specified params. Throws an
      * exception on bad params. See {@link InflateOptions} for the list of
      * supported options.
      *
      * By default, when no options are set, the deflate/gzip data format is
      * autodetected via the wrapper header.
      *
      * @example
      * ```javascript
      * import { Inflate } from 'pako'
      *
      * const chunk1 = new Uint8Array([1, 2, 3, 4, 5, 6, 7, 8, 9])
      * const chunk2 = new Uint8Array([10, 11, 12, 13, 14, 15, 16, 17, 18, 19])
      *
      * const inflate = new Inflate({ level: 3 })
      *
      * inflate.push(chunk1, false)
      * inflate.push(chunk2, true)  // true -> last chunk
      *
      * if (inflate.err) throw new Error(inflate.err)
      *
      * console.log(inflate.result)
      * ```
      */
      constructor(options = {}) {
        this.options = Object.assign({}, defaultOptions, options);
        const opt = this.options;
        if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
          opt.windowBits = -opt.windowBits;
          if (opt.windowBits === 0) opt.windowBits = -15;
        }
        if (opt.windowBits >= 0 && opt.windowBits < 16 && !options.windowBits) opt.windowBits += 32;
        if (opt.windowBits > 15 && opt.windowBits < 48) {
          if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
        }
        this.err = 0;
        this.msg = "";
        this.ended = false;
        this.started = false;
        this.chunks = [];
        this.result = /* @__PURE__ */ new Uint8Array(0);
        this.strm = new ZStream();
        this.strm.avail_out = 0;
        let status = inflateInit2(this.strm, opt.windowBits);
        if (status !== 0) throw new Error(messages_default[status]);
        if (toString.call(opt.dictionary) === "[object ArrayBuffer]") opt.dictionary = new Uint8Array(opt.dictionary);
        const dictionary = opt.dictionary;
        if (opt.raw && dictionary.length) {
          status = inflateSetDictionary(this.strm, dictionary);
          if (status !== 0) throw new Error(messages_default[status]);
        }
      }
      /**
      * Sends input data to the inflate pipe, generating {@link Inflate.onData} calls
      * with new output chunks. Returns `true` on success. If end of stream is
      * detected, {@link Inflate.onEnd} will be called.
      *
      * `flush_mode` is not needed for normal operation, because end of stream
      * is detected automatically. Pass {@link Z_SYNC_FLUSH} to force the decoder
      * to emit all currently available output — handy when you need to decode
      * data frame-by-frame from a long-running stream.
      *
      * On failure, calls {@link Inflate.onEnd} with the error code and returns false.
      *
      * Once the stream has ended (a compressed stream may end before your data
      * does), further `push` calls are no-ops and return whether the decode
      * finished successfully. The final outcome is in {@link Inflate.result},
      * {@link Inflate.err} and {@link Inflate.msg}.
      *
      * @param flush_mode 0..6 for corresponding {@link Z_NO_FLUSH}..{@link Z_TREES}
      *   flush modes. See constants. Skipped or `false` means {@link Z_NO_FLUSH},
      *   `true` means {@link Z_FINISH}.
      *
      * @example
      * ```javascript
      * push(chunk, false) // push one of data chunks
      * ...
      * push(chunk, true)  // push last chunk
      * ```
      */
      push(data, flush_mode = false) {
        const strm = this.strm;
        const chunkSize = this.options.chunkSize;
        let status;
        let _flush_mode;
        let last_avail_out;
        if (this.ended) return this.err === 0;
        if (typeof flush_mode === "number") _flush_mode = flush_mode;
        else _flush_mode = flush_mode === true ? 4 : 0;
        if (toString.call(data) === "[object ArrayBuffer]") strm.input = new Uint8Array(data);
        else strm.input = data;
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        if (!this.started) {
          this.started = true;
          this.onStart(strm);
        }
        for (; ; ) {
          if (strm.avail_out === 0) {
            strm.output = new Uint8Array(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = inflate$1(strm, _flush_mode);
          if (status === 2) {
            const dictionary = this.options.dictionary;
            if (dictionary.length) {
              status = inflateSetDictionary(strm, dictionary);
              if (status === 0) status = inflate$1(strm, _flush_mode);
              else if (status === -3) status = 2;
            }
          }
          while (strm.avail_in > 0 && status === 1 && strm.state.wrap & 2 && strm.state.flags !== 0 && strm.input[strm.next_in] !== 0) {
            inflateReset(strm);
            status = inflate$1(strm, _flush_mode);
          }
          if (status === -2 || status === -3 || status === 2 || status === -4) break;
          last_avail_out = strm.avail_out;
          if (strm.next_out) {
            if (strm.avail_out === 0 || status === 1 || _flush_mode > 0) {
              this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
              strm.avail_out = 0;
              strm.next_out = 0;
            }
          }
          if ((status === 0 || status === -5) && last_avail_out === 0) continue;
          if (status === 1) {
            status = inflateEnd(this.strm);
            break;
          }
          if (strm.avail_in === 0) {
            if (_flush_mode === 4) {
              status = inflateEnd(this.strm);
              if (status === 0) status = -5;
              break;
            }
            return true;
          }
        }
        this.err = status;
        this.msg = strm.msg || messages_default[status];
        this.ended = true;
        this.onEnd(status);
        return status === 0;
      }
      /**
      * Called once before the first low-level inflate call.
      *
      * Override this handler to attach low-level inflate state, for example to read
      * gzip header metadata:
      *
      * ```javascript
      * import { Inflate, GZheader, zlibInflateGetHeader } from 'pako'
      *
      * const inflator = new Inflate()
      *
      * inflator.onStart = function (strm) {
      *   this.header = new GZheader()
      *   zlibInflateGetHeader(strm, this.header)
      * }
      *
      * inflator.push(data, true)
      * console.log(inflator.header.name)
      * ```
      */
      onStart(strm) {
      }
      /**
      * By default, stores data blocks in the {@link Inflate.chunks} property and glues
      * them in {@link Inflate.onEnd}. Override this handler if you need another behaviour.
      *
      * @param chunk output data.
      */
      onData(chunk) {
        this.chunks.push(chunk);
      }
      /**
      * Called after you tell inflate that the input stream is
      * complete ({@link Z_FINISH}). By default, joins the collected {@link Inflate.chunks},
      * frees memory and fills the {@link Inflate.result} property.
      *
      * @param status inflate status. {@link Z_OK} on success, other if not.
      */
      onEnd(status) {
        if (status === 0) this.result = flattenChunks(this.chunks);
        this.chunks = [];
      }
    };
  }
});

// ../../node_modules/@moq/flate/index.js
function concat2(chunks, total) {
  if (chunks.length === 1)
    return chunks[0];
  const out = new Uint8Array(total);
  let offset = 0;
  for (const chunk of chunks) {
    out.set(chunk, offset);
    offset += chunk.length;
  }
  return out;
}
var DEFAULT_LEVEL, DEFAULT_MAX_FRAME_SIZE, SYNC_FLUSH_TAIL, Encoder, Decoder;
var init_flate = __esm({
  "../../node_modules/@moq/flate/index.js"() {
    init_pako();
    DEFAULT_LEVEL = 6;
    DEFAULT_MAX_FRAME_SIZE = 64 * 1024 * 1024;
    SYNC_FLUSH_TAIL = new Uint8Array([0, 0, 255, 255]);
    Encoder = class {
      #deflate;
      #chunks = [];
      #total = 0;
      /** Start a fresh encoder with a cold window. */
      constructor(options = {}) {
        const level = options.level ?? DEFAULT_LEVEL;
        this.#deflate = new Deflate({ raw: true, level });
        this.#deflate.onData = (chunk) => {
          const bytes = chunk;
          this.#chunks.push(bytes);
          this.#total += bytes.length;
        };
      }
      /**
       * Compress the next frame's `payload`, returning its slice of the stream: the DEFLATE bytes minus
       * the fixed sync-flush marker. Empty in yields empty out. Slices must be produced in frame order.
       */
      frame(payload) {
        if (payload.length === 0)
          return payload;
        this.#chunks = [];
        this.#total = 0;
        this.#deflate.push(payload, Z_SYNC_FLUSH);
        const out = new Uint8Array(this.#total - SYNC_FLUSH_TAIL.length);
        let offset = 0;
        for (const chunk of this.#chunks) {
          if (offset >= out.length)
            break;
          const take2 = Math.min(chunk.length, out.length - offset);
          out.set(chunk.subarray(0, take2), offset);
          offset += take2;
        }
        return out;
      }
    };
    Decoder = class {
      #inflate = new Inflate({ raw: true });
      #chunks = [];
      #total = 0;
      #tooLarge = false;
      #maxFrameSize;
      /** The per-frame decompressed-size cap in bytes, in effect for this decoder. */
      get maxFrameSize() {
        return this.#maxFrameSize;
      }
      /** Start a fresh decoder with a cold window. */
      constructor(options = {}) {
        this.#maxFrameSize = options.maxFrameSize ?? DEFAULT_MAX_FRAME_SIZE;
        this.#inflate.onData = (chunk) => {
          const bytes = chunk;
          this.#total += bytes.length;
          if (this.#total > this.#maxFrameSize) {
            this.#tooLarge = true;
            return;
          }
          this.#chunks.push(bytes);
        };
      }
      /**
       * Decompress the next frame's `slice` back into its payload. Empty in yields empty out. Throws if
       * the input is malformed or inflates past the per-frame size cap.
       */
      frame(slice) {
        if (slice.length === 0)
          return slice;
        this.#chunks = [];
        this.#total = 0;
        this.#tooLarge = false;
        this.#inflate.push(slice, false);
        this.#inflate.push(SYNC_FLUSH_TAIL, Z_SYNC_FLUSH);
        if (this.#inflate.err)
          throw new Error(`decompression failed: ${this.#inflate.msg}`);
        if (this.#tooLarge)
          throw new Error(`decompressed frame exceeded ${this.#maxFrameSize} bytes`);
        return concat2(this.#chunks, this.#total);
      }
    };
  }
});

// ../../node_modules/@moq/json/compression.js
function isDeflate(compression) {
  switch (compression) {
    case void 0:
    case "none":
      return false;
    case "deflate":
      return true;
    default:
      throw new Error(`unsupported compression: ${String(compression)}`);
  }
}
var init_compression = __esm({
  "../../node_modules/@moq/json/compression.js"() {
  }
});

// ../../node_modules/@moq/json/snapshot/decoder.js
var Decoder2;
var init_decoder = __esm({
  "../../node_modules/@moq/json/snapshot/decoder.js"() {
    init_flate();
    init_compression();
    init_diff();
    init_error4();
    Decoder2 = class {
      #schema;
      // Whether frames are `deflate-raw` compressed. Must match the encoder's {@link Config.compression}.
      #decompress;
      // The current group's DEFLATE window, rebuilt at each snapshot.
      #flate;
      // The reconstructed value, `undefined` until the first snapshot.
      #current;
      constructor(config2 = {}) {
        this.#schema = config2.schema;
        this.#decompress = isDeflate(config2.compression);
      }
      /**
       * Apply a group's first frame: a full snapshot that replaces the current value.
       *
       * Also starts the group's DEFLATE window, so this must be called at every group boundary, not
       * only the first.
       */
      snapshot(payload) {
        this.#flate = this.#decompress ? new Decoder() : void 0;
        this.#current = this.#parse(payload);
      }
      /**
       * Apply one of a group's later frames: an RFC 7396 merge patch against the current value.
       *
       * Throws when no snapshot has been applied yet, since a patch has nothing to apply to.
       */
      delta(payload) {
        if (this.#current === void 0)
          throw new MissingSnapshot();
        this.#current = merge2(this.#current, this.#parse(payload));
      }
      /**
       * A copy of the reconstructed value as raw JSON, or `undefined` before the first snapshot.
       *
       * Copied rather than shared: it is the base every later {@link delta} merges into, so a caller
       * mutating it would change fields no frame ever carried.
       */
      get value() {
        return this.#current === void 0 ? void 0 : structuredClone(this.#current);
      }
      /**
       * Materialize the reconstructed value, or `undefined` before the first snapshot.
       *
       * The result is the caller's own copy, for the same reason as {@link value}. (A schema already
       * produces a fresh object, so it only needs cloning without one. The Rust decoder deserializes a
       * fresh `T` every call and never exposes its internal state at all.)
       */
      decode() {
        if (this.#current === void 0)
          return void 0;
        return this.#schema ? this.#schema.parse(this.#current) : structuredClone(this.#current);
      }
      // Decompress a frame against the group's window when compressing, then parse it as JSON.
      #parse(payload) {
        const plain = this.#flate ? this.#flate.frame(payload) : payload;
        return JSON.parse(new TextDecoder().decode(plain));
      }
    };
  }
});

// ../../node_modules/@moq/json/snapshot/consumer.js
var GAPS, Consumer6;
var init_consumer = __esm({
  "../../node_modules/@moq/json/snapshot/consumer.js"() {
    init_net();
    init_decoder();
    GAPS = [
      StreamCode.TooFarBehind,
      StreamCode.Old,
      StreamCode.Evicted,
      StreamCode.GroupTooLarge
    ];
    Consumer6 = class {
      #track;
      #decoder;
      #group;
      #framesRead = 0;
      constructor(config2) {
        this.#track = config2.track.ordered();
        this.#decoder = new Decoder2(config2);
      }
      /**
       * Get the next reconstructed value, or `undefined` once the track ends.
       *
       * Applies every frame already buffered in the group but yields only the latest reconstructed
       * value: the intermediate reconstructions are stale, so a late joiner (or any consumer that has
       * fallen behind) catches up to the head in one step instead of replaying every superseded state.
       * Frames are still decoded in order (the DEFLATE window and merge patches are sequential); only
       * the per-frame yield is skipped.
       */
      async next() {
        for (; ; ) {
          if (this.#group !== void 0) {
            const latest = this.#track.latest();
            if (latest !== void 0 && latest > this.#group.sequence) {
              this.#group.close();
              this.#group = void 0;
            }
          }
          if (!this.#group) {
            const latest = this.#track.latest();
            if (latest !== void 0)
              this.#track.setGroups({ start: { included: latest } });
            this.#group = await this.#track.nextGroup();
            if (!this.#group)
              return void 0;
            this.#framesRead = 0;
          }
          let advanced = false;
          for (let frame2 = this.#group.tryReadFrame(); frame2 !== void 0; frame2 = this.#group.tryReadFrame()) {
            this.#apply(frame2.payload);
            advanced = true;
          }
          if (advanced)
            return this.#decoder.decode();
          let frame;
          try {
            frame = await this.#group.readFrame();
          } catch (err2) {
            if (!(err2 instanceof errors_exports2.Stream && GAPS.includes(err2.code)))
              throw err2;
            this.#group = void 0;
            continue;
          }
          if (frame === void 0) {
            this.#group = void 0;
            continue;
          }
          this.#apply(frame.payload);
          return this.#decoder.decode();
        }
      }
      async *[Symbol.asyncIterator]() {
        for (; ; ) {
          const value = await this.next();
          if (value === void 0)
            return;
          yield value;
        }
      }
      // Frame 0 of a group is a snapshot, the rest are merge patches.
      #apply(payload) {
        if (this.#framesRead === 0) {
          this.#decoder.snapshot(payload);
        } else {
          this.#decoder.delta(payload);
        }
        this.#framesRead += 1;
      }
    };
  }
});

// ../../node_modules/@moq/json/snapshot/encoder.js
var MAX_DELTA_FRAMES, DEFAULT_DELTA_RATIO, DEFAULT_MAX_GROUP_BYTES, Encoder2;
var init_encoder = __esm({
  "../../node_modules/@moq/json/snapshot/encoder.js"() {
    init_flate();
    init_net();
    init_compression();
    init_diff();
    MAX_DELTA_FRAMES = 256;
    DEFAULT_DELTA_RATIO = 8;
    DEFAULT_MAX_GROUP_BYTES = group_exports.MAX_GROUP_CACHE_BYTES;
    Encoder2 = class {
      #config;
      #compress;
      #maxGroupBytes;
      // The last encoded value, normalized through JSON so it matches what landed on the wire. The
      // baseline every delta is diffed against, and `undefined` until the first snapshot.
      #last;
      // Bytes of deltas already emitted into the current group, excluding the snapshot frame. Compressed
      // frame sizes when compressing, raw otherwise, matching {@link #snapshotLen} so the budget check is
      // like-for-like (and identical to the Rust encoder).
      #deltaBytes = 0;
      // Size of the current group's snapshot frame, the reference the delta budget is measured against.
      #snapshotLen = 0;
      // Frames emitted into the current group, snapshot included.
      #groupFrames = 0;
      // The current group's `deflate-raw` stream, swapped for a fresh one (cold window) at each
      // snapshot, so a snapshot and its deltas share one stream.
      #flate;
      // Whether the frame from the last {@link update} is still unacknowledged. An uncommitted frame
      // never reached the wire, so the next update resynchronizes before encoding anything new.
      #pending = false;
      // Bumped for each frame handed out, so a commit that arrives after the encoder has moved on can
      // tell that it is acknowledging a frame that is no longer the outstanding one.
      #generation = 0;
      // Whether the next frame has to be a full snapshot, because a frame was lost or the caller closed
      // the group. Kept separate from {@link #last} so a resync doesn't erase the value: that field is
      // also what {@link Producer.mutate} seeds an edit from, and dropping it there would publish a
      // document with every other field missing.
      #resync = false;
      constructor(config2 = {}) {
        this.#config = config2;
        this.#compress = isDeflate(config2.compression);
        this.#maxGroupBytes = config2.maxGroupBytes ?? DEFAULT_MAX_GROUP_BYTES;
      }
      /**
       * A copy of the last encoded value, or `undefined` before the first snapshot.
       *
       * Copied rather than shared: the baseline is what the next delta is diffed against, so a caller
       * mutating it in place would make a later change look unchanged and never reach consumers.
       */
      get value() {
        return this.#last === void 0 ? void 0 : structuredClone(this.#last);
      }
      /**
       * Force the next {@link update} to emit a full snapshot, even for an unchanged value.
       *
       * Call this whenever the caller closes the current group behind the encoder's back. Without it
       * the next value may be encoded as a delta against a DEFLATE window and a baseline that the new
       * group doesn't carry.
       *
       * {@link value} survives: the snapshot republishes it in full anyway, and it is what a caller
       * editing in place starts from.
       */
      reset() {
        this.#flate = void 0;
        this.#deltaBytes = 0;
        this.#snapshotLen = 0;
        this.#groupFrames = 0;
        this.#resync = true;
        this.#pending = false;
      }
      /**
       * Encode a new value, as a snapshot or a delta.
       *
       * Returns `undefined` when the value is unchanged from the last one encoded, so nothing needs to
       * be written. Otherwise the frame comes back as a {@link Pending} the caller writes and then
       * commits; leaving one uncommitted resynchronizes the encoder here, on the next call.
       */
      update(value) {
        if (this.#pending)
          this.reset();
        const valid = this.#config.schema ? this.#config.schema.parse(value) : value;
        const text = JSON.stringify(valid);
        if (text === void 0) {
          throw new Error("value is not representable as JSON");
        }
        const json = JSON.parse(text);
        if (!this.#resync && this.#last !== void 0 && deepEqual(this.#last, json))
          return void 0;
        const delta = this.#delta(json);
        if (delta) {
          const payload2 = this.#frame(delta);
          if (this.#snapshotLen + this.#deltaBytes + payload2.length <= this.#maxGroupBytes) {
            this.#last = json;
            this.#deltaBytes += payload2.length;
            this.#groupFrames += 1;
            return this.#pend({ payload: payload2, keyframe: false });
          }
        }
        const payload = this.#snapshot(new TextEncoder().encode(text));
        this.#last = json;
        return this.#pend({ payload, keyframe: true });
      }
      // Hand a frame to the caller, marking it unacknowledged until they commit.
      #pend(encoded) {
        this.#pending = true;
        const generation = ++this.#generation;
        return {
          ...encoded,
          commit: () => {
            if (this.#generation === generation)
              this.#pending = false;
          }
        };
      }
      // Resolved delta ratio: the configured value, or the default when unset. `0` disables deltas.
      get #deltaRatio() {
        return this.#config.deltaRatio ?? DEFAULT_DELTA_RATIO;
      }
      // Build a delta frame, or `undefined` to signal that a fresh snapshot should be emitted.
      //
      // The budget gate runs first, against the deltas already written, so rolling a new group costs no
      // merge-patch work. Since the gate excludes the frame about to be written, the delta that tips the
      // group past `ratio * snapshot` still lands: a group overshoots the budget by at most one delta.
      #delta(json) {
        if (this.#resync)
          return void 0;
        const ratio = this.#deltaRatio;
        if (ratio === 0)
          return void 0;
        if (this.#last === void 0)
          return void 0;
        if (this.#groupFrames === 0 || this.#groupFrames >= MAX_DELTA_FRAMES)
          return void 0;
        if (this.#deltaBytes > ratio * this.#snapshotLen)
          return void 0;
        const result = diff(this.#last, json);
        if (result.forcedSnapshot)
          return void 0;
        return new TextEncoder().encode(JSON.stringify(result.patch));
      }
      // Reject plaintext the consumer's decoder could never reproduce. Every consumer decodes with
      // `@moq/flate`'s default output cap, so a frame past it would be unreadable however small it
      // compresses to. Checked before anything is published or the window advances.
      #checkDecodable(frame) {
        if (this.#compress && frame.byteLength > DEFAULT_MAX_FRAME_SIZE) {
          throw new Error(`value larger than the decoder's ${DEFAULT_MAX_FRAME_SIZE} byte limit`);
        }
      }
      // Encode a group's snapshot (frame 0), returning its payload. On the compressed path this opens a
      // fresh stream (cold window), so the snapshot and its deltas share one DEFLATE window.
      #snapshot(frame) {
        this.#checkDecodable(frame);
        const flate = this.#compress ? new Encoder() : void 0;
        const payload = flate ? flate.frame(frame) : frame;
        this.#flate = flate;
        this.#snapshotLen = payload.length;
        this.#deltaBytes = 0;
        this.#groupFrames = 1;
        this.#resync = false;
        return payload;
      }
      // Compress a frame into the current group's window, or pass it through when uncompressed.
      #frame(frame) {
        this.#checkDecodable(frame);
        return this.#flate ? this.#flate.frame(frame) : frame;
      }
    };
  }
});

// ../../node_modules/@moq/json/snapshot/producer.js
var Producer6;
var init_producer = __esm({
  "../../node_modules/@moq/json/snapshot/producer.js"() {
    init_net();
    init_net();
    init_encoder();
    Producer6 = class {
      #track;
      #encoder;
      #initial;
      // The group a delta would be appended to, open only while deltas are enabled.
      #group;
      // Whether the encoder can emit deltas at all. With them off every frame is a snapshot, so a group
      // is closed the moment it's written and never held open.
      #deltas;
      constructor(config2) {
        this.#track = config2.track;
        this.#encoder = new Encoder2(config2);
        this.#initial = config2.initial;
        this.#deltas = (config2.deltaRatio ?? DEFAULT_DELTA_RATIO) !== 0;
      }
      /**
       * Finish the open group, so the deltas already written stop being provisional.
       *
       * No replacement group opens until the next {@link update}, which emits a full snapshot as its
       * first frame even when the value is unchanged. A consumer joining at that group therefore reads
       * the whole value without the deltas that preceded it.
       *
       * Idempotent: cutting when no group is open does nothing, so a caller can cut on its own schedule
       * without tracking what has been published since the last one. Inert when deltas are disabled,
       * where every frame already gets its own group.
       */
      cut() {
        if (!this.#group)
          return;
        this.#encoder.reset();
        const group = this.#group;
        this.#group = void 0;
        group.close();
      }
      /**
       * Publish a new value, emitting a snapshot or delta automatically. No-op if unchanged.
       *
       * `at` is when the value was captured, written as its frame timestamp. Defaults to now.
       */
      update(value, at2 = time_exports.Timestamp.now()) {
        const frame = this.#encoder.update(value);
        if (!frame)
          return;
        this.#write(frame, at2);
        frame.commit();
      }
      #write(encoded, at2) {
        if (encoded.payload.byteLength > group_exports.MAX_GROUP_CACHE_BYTES)
          throw new errors_exports2.FrameTooLarge();
        if (encoded.keyframe) {
          this.#group?.close();
          this.#group = void 0;
          const group = this.#track.appendGroup();
          try {
            group.writeFrame({ payload: encoded.payload, timestamp: at2 });
          } catch (err2) {
            group.close();
            throw err2;
          }
          if (this.#deltas) {
            this.#group = group;
          } else {
            group.close();
            this.#group = void 0;
          }
          return;
        }
        if (!this.#group)
          throw new Error("delta with no open group");
        this.#group.writeFrame({ payload: encoded.payload, timestamp: at2 });
      }
      /**
       * Mutate the current value in place and publish the result.
       *
       * The callback receives a deep clone of the current value: everything published through this
       * producer so far, composed, falling back to {@link Config.initial} if nothing has been (throws if
       * neither exists). Edit it in place; on return the result is published via {@link update}, a no-op
       * if unchanged:
       *
       * ```ts
       * producer.mutate((catalog) => {
       * 	catalog.scte35 = { ... };
       * });
       * ```
       *
       * Independent owners can share a single Producer and each edit only their own keys: every call
       * starts from the latest value, so sections compose instead of clobbering one another. Use
       * {@link update} to replace the whole value instead.
       *
       * After a rejected write the current value is what the producer last *tried* to publish, which
       * consumers never received. That is deliberate: dropping a rejected owner's field would clobber it
       * for whoever edits next, which is the failure this API exists to prevent. The owner whose write
       * failed sees the error, and the next successful publish is a full snapshot carrying the composed
       * value, so consumers converge on it either way.
       */
      mutate(fn) {
        const base2 = this.#encoder.value ?? this.#initial;
        if (base2 === void 0) {
          throw new Error("mutate() requires a prior update() or `initial` in the config");
        }
        const value = structuredClone(base2);
        fn(value);
        this.update(value);
      }
      /** Finish the track, closing any open group. */
      finish() {
        this.#group?.close();
        this.#group = void 0;
        this.#encoder.reset();
        this.#track.close();
      }
    };
  }
});

// ../../node_modules/@moq/json/snapshot/index.js
var snapshot_exports = {};
__export(snapshot_exports, {
  Consumer: () => Consumer6,
  Decoder: () => Decoder2,
  Encoder: () => Encoder2,
  MissingSnapshot: () => MissingSnapshot,
  Producer: () => Producer6
});
var init_snapshot = __esm({
  "../../node_modules/@moq/json/snapshot/index.js"() {
    init_error4();
    init_consumer();
    init_decoder();
    init_encoder();
    init_producer();
  }
});

// ../../node_modules/@moq/json/window/decoder.js
function object2(value, label) {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    throw new Error(`${label} must be an object`);
  }
  return value;
}
function index(value, label) {
  if (typeof value !== "number" || !Number.isSafeInteger(value) || value < 0) {
    throw new Error(`${label} must be a nonnegative safe integer`);
  }
  return value;
}
var Decoder3;
var init_decoder2 = __esm({
  "../../node_modules/@moq/json/window/decoder.js"() {
    init_flate();
    Decoder3 = class {
      #compress;
      #generation = 0;
      // Absolute index of the window's front, once a group header has positioned us.
      #front = 0;
      #len = 0;
      // Next index to deliver, or undefined before the first header. A fresh consumer adopts the first
      // header's offset rather than skipping everything that came before it.
      #delivered;
      #events = [];
      #nextEvent = 0;
      constructor(config2 = {}) {
        this.#compress = config2.compression ?? false;
      }
      /** Create the decoder for one MoQ group. */
      group() {
        const generation = ++this.#generation;
        let flate;
        let positioned = false;
        return {
          decode: (payload) => {
            if (generation !== this.#generation)
              throw new Error("stale window group");
            if (this.#compress)
              flate ??= new Decoder();
            const bytes = flate ? flate.frame(payload) : payload;
            const frame = object2(JSON.parse(new TextDecoder().decode(bytes)), "window frame");
            if (!positioned) {
              if (!Array.isArray(frame.records))
                throw new Error("window header records must be an array");
              const offset = index(frame.offset, "window offset");
              const start = frame.start === void 0 ? offset : index(frame.start, "window checkpoint start");
              this.#applyHeader(offset, start, frame.records);
              positioned = true;
              return;
            }
            const keys = Object.keys(frame);
            if (keys.length !== 1)
              throw new Error("window op must contain exactly one operation");
            switch (keys[0]) {
              case "push":
                this.#applyPush(frame.push);
                break;
              case "pop":
                this.#applyPop(index(frame.pop, "window pop count"));
                break;
              default:
                throw new Error("unrecognized window op");
            }
          }
        };
      }
      /** Absolute index of the oldest record in the window. */
      get offset() {
        return this.#front;
      }
      /** Take the next event produced by the frames decoded so far. */
      next() {
        const queued = this.#events[this.#nextEvent];
        if (!queued) {
          this.#clearEvents();
          return void 0;
        }
        if ("records" in queued) {
          const next = queued.next++;
          const event = { push: { index: queued.offset + next, value: queued.records[next] } };
          if (queued.next >= queued.records.length)
            this.#advanceEvent();
          return event;
        }
        this.#advanceEvent();
        return queued;
      }
      #advanceEvent() {
        this.#nextEvent += 1;
        if (this.#nextEvent >= this.#events.length)
          this.#clearEvents();
      }
      #clearEvents() {
        this.#events = [];
        this.#nextEvent = 0;
      }
      /** Apply a logical window range and its decodable suffix. */
      #applyHeader(offset, start, records) {
        if (start < offset)
          throw new Error("window checkpoint starts before its offset");
        const end = start + records.length;
        if (!Number.isSafeInteger(end))
          throw new Error("window range exceeds the safe integer range");
        let delivered = this.#delivered;
        if (delivered === void 0) {
          delivered = offset;
          this.#range("skip", offset, start);
        } else {
          if (offset < this.#front || end < delivered)
            throw new Error("window header moved backwards");
          this.#range("pop", this.#front, Math.min(delivered, offset));
          this.#range("skip", delivered, start);
        }
        const next = Math.max(delivered - start, 0);
        if (next < records.length) {
          this.#events.push({ offset: start, records, next });
        }
        this.#front = offset;
        this.#len = end - offset;
        this.#delivered = Math.max(delivered, end);
      }
      /** One record joined the back. */
      #applyPush(value) {
        if (this.#delivered === void 0)
          throw new Error("window op before group header");
        const index2 = this.#front + this.#len;
        if (!Number.isSafeInteger(index2 + 1))
          throw new Error("window range exceeds the safe integer range");
        this.#len += 1;
        if (index2 >= this.#delivered) {
          this.#events.push({ push: { index: index2, value } });
          this.#delivered = index2 + 1;
        }
      }
      /** Records left the front. */
      #applyPop(count2) {
        if (this.#delivered === void 0)
          throw new Error("window op before group header");
        if (count2 > this.#len) {
          throw new Error(`pop of ${count2} exceeds the ${this.#len} record(s) in the window`);
        }
        const end = this.#front + count2;
        this.#range("pop", this.#front, Math.min(this.#delivered, end));
        this.#range("skip", Math.max(this.#delivered, this.#front), end);
        this.#front = end;
        this.#len -= count2;
        this.#delivered = Math.max(this.#delivered, this.#front);
      }
      #range(kind, start, end) {
        if (start >= end)
          return;
        this.#events.push(kind === "pop" ? { pop: { start, end } } : { skip: { start, end } });
      }
    };
  }
});

// ../../node_modules/@moq/json/window/consumer.js
var GAPS2, Consumer7;
var init_consumer2 = __esm({
  "../../node_modules/@moq/json/window/consumer.js"() {
    init_net();
    init_decoder2();
    GAPS2 = [
      StreamCode.TooFarBehind,
      StreamCode.Old,
      StreamCode.Evicted,
      StreamCode.GroupTooLarge
    ];
    Consumer7 = class {
      #track;
      #decoder;
      #group;
      #codec;
      #reading = false;
      constructor(config2) {
        this.#track = config2.track.ordered();
        this.#decoder = new Decoder3(config2);
      }
      /** Absolute index of the oldest record in the window. */
      get offset() {
        return this.#decoder.offset;
      }
      /** Get the next event, or `undefined` once the track ends. */
      next() {
        if (this.#reading)
          throw new Error("multiple calls to next not supported");
        this.#reading = true;
        return this.#read().finally(() => {
          this.#reading = false;
        });
      }
      async #read() {
        for (; ; ) {
          const event = this.#decoder.next();
          if (event)
            return event;
          if (!this.#group) {
            this.#group = await this.#track.nextGroup();
            if (!this.#group)
              return void 0;
            this.#codec = this.#decoder.group();
          }
          let frame;
          try {
            frame = await this.#group.readFrame();
          } catch (err2) {
            if (!(err2 instanceof errors_exports2.Stream && GAPS2.includes(err2.code)))
              throw err2;
            this.#group = void 0;
            this.#codec = void 0;
            continue;
          }
          if (frame === void 0) {
            this.#group = void 0;
            this.#codec = void 0;
            continue;
          }
          if (!this.#codec)
            throw new Error("an open MoQ group has a window codec");
          this.#codec.decode(frame.payload);
        }
      }
      /** Iterate over events until the track ends. */
      async *[Symbol.asyncIterator]() {
        for (; ; ) {
          const event = await this.next();
          if (event === void 0)
            return;
          yield event;
        }
      }
    };
  }
});

// ../../node_modules/@moq/json/window/encoder.js
var MAX_GROUP_FRAMES2, DEFAULT_OP_RATIO, Encoder3;
var init_encoder2 = __esm({
  "../../node_modules/@moq/json/window/encoder.js"() {
    init_flate();
    init_net();
    MAX_GROUP_FRAMES2 = 1024;
    DEFAULT_OP_RATIO = 8;
    Encoder3 = class {
      #opRatio;
      #compress;
      #checkpointRecords;
      // The decodable checkpoint suffix. Without a checkpoint bound this is the complete window.
      #window = [];
      // Absolute index of the oldest logically retained record.
      #offset = 0;
      // Absolute index of #window[0], which may follow #offset in checkpoint mode.
      #start = 0;
      #flate;
      // Bytes of pushes and pops in this group, excluding its header frame.
      #opBytes = 0;
      // Reference size the op budget is measured against: this group's header frame.
      #headerLen = 0;
      #groupFrames = 0;
      // Whether the next frame must be a header after a lost frame.
      #resync = true;
      // Whether the frame from the last push/pop is still unacknowledged.
      #pending = false;
      // Bumped per frame handed out, so a commit arriving after the encoder moved on cannot clear the
      // flag belonging to a newer frame.
      #generation = 0;
      constructor(config2 = {}) {
        this.#opRatio = config2.opRatio ?? DEFAULT_OP_RATIO;
        if (!Number.isSafeInteger(this.#opRatio) || this.#opRatio < 0 || this.#opRatio > 4294967295) {
          throw new Error("opRatio must be an unsigned 32-bit integer");
        }
        this.#compress = config2.compression ?? false;
        this.#checkpointRecords = config2.checkpointRecords;
        if (this.#checkpointRecords !== void 0 && (!Number.isSafeInteger(this.#checkpointRecords) || this.#checkpointRecords <= 0)) {
          throw new Error("checkpointRecords must be a positive safe integer");
        }
      }
      /** The retained checkpoint suffix, oldest first. This is complete unless bounded in the config. */
      get window() {
        return this.#window.map((text) => JSON.parse(text));
      }
      /** Absolute index of the oldest retained record. */
      get offset() {
        return this.#offset;
      }
      /** Absolute index the next pushed record will take. */
      get end() {
        return this.#start + this.#window.length;
      }
      /** Discard group-local state after an encoded frame did not reach the wire. */
      #resyncGroup() {
        this.#flate = void 0;
        this.#opBytes = 0;
        this.#headerLen = 0;
        this.#groupFrames = 0;
        this.#resync = true;
        this.#pending = false;
        this.#generation += 1;
      }
      /** Append one record to the back of the window. */
      push(value) {
        if (this.#pending)
          this.#resyncGroup();
        if (this.end >= Number.MAX_SAFE_INTEGER)
          throw new Error("window index exceeds the safe integer range");
        const text = JSON.stringify(value);
        if (text === void 0) {
          throw new Error("record is not representable as JSON");
        }
        const edit = { push: text };
        if (this.#resync || !this.#opAllowed()) {
          return this.#emitPushHeader(text, edit);
        }
        const payload = this.#emitOp(`{"push":${text}}`);
        if (payload)
          return this.#pendingFrame(payload, false, edit);
        return this.#emitPushHeader(text, edit);
      }
      /**
       * Drop `count` records from the front of the window.
       *
       * Returns `undefined` when there is nothing to drop, so a caller can trim unconditionally.
       * Clamped to what the window holds.
       */
      pop(count2) {
        if (!Number.isSafeInteger(count2) || count2 < 0) {
          throw new Error("pop count must be a nonnegative safe integer");
        }
        if (this.#pending)
          this.#resyncGroup();
        const dropped = Math.min(count2, this.end - this.#offset);
        if (dropped <= 0)
          return void 0;
        const offset = this.#offset + dropped;
        const edit = { pop: dropped };
        if (this.#resync || !this.#opAllowed()) {
          return this.#emitPopHeader(offset, edit);
        }
        const payload = this.#emitOp(`{"pop":${dropped}}`);
        if (payload)
          return this.#pendingFrame(payload, false, edit);
        return this.#emitPopHeader(offset, edit);
      }
      /** Whether the pending edit may ride as an op in the open group. */
      #opAllowed() {
        return this.#opRatio !== 0 && this.#groupFrames > 0 && this.#groupFrames < MAX_GROUP_FRAMES2 && this.#opBytes <= this.#opRatio * this.#headerLen;
      }
      /** Compress an already-serialized op into the open group, if its header remains cached. */
      #emitOp(text) {
        const bytes = new TextEncoder().encode(text);
        if (bytes.length > DEFAULT_MAX_FRAME_SIZE) {
          throw new Error("window frame exceeds the decoder's decompressed size limit");
        }
        const payload = this.#flate ? this.#flate.frame(bytes) : bytes;
        this.#opBytes += payload.length;
        this.#groupFrames += 1;
        if (this.#headerLen + this.#opBytes > group_exports.MAX_GROUP_CACHE_BYTES) {
          this.#resyncGroup();
          return void 0;
        }
        return payload;
      }
      #emitPushHeader(text, edit) {
        const records = [...this.#window, text];
        const skip = this.#checkpointRecords === void 0 ? 0 : Math.max(records.length - this.#checkpointRecords, 0);
        return this.#emitHeader(this.#offset, this.#start + skip, records.slice(skip), edit);
      }
      #emitPopHeader(offset, edit) {
        const skip = Math.min(Math.max(offset - this.#start, 0), this.#window.length);
        return this.#emitHeader(offset, this.#start + skip, this.#window.slice(skip), edit);
      }
      /** Emit a checkpoint header and open a new group. */
      #emitHeader(offset, start, window2, edit) {
        const checkpoint = start === offset ? "" : `,"start":${start}`;
        const text = `{"offset":${offset}${checkpoint},"records":[${window2.join(",")}]}`;
        const bytes = new TextEncoder().encode(text);
        if (bytes.length > DEFAULT_MAX_FRAME_SIZE) {
          throw new Error("window header exceeds the decoder's decompressed size limit");
        }
        const flate = this.#compress ? new Encoder() : void 0;
        const payload = flate ? flate.frame(bytes) : bytes;
        if (payload.length > group_exports.MAX_GROUP_CACHE_BYTES) {
          throw new Error("window header exceeds the group cache limit");
        }
        this.#flate = flate;
        this.#headerLen = payload.length;
        this.#opBytes = 0;
        this.#groupFrames = 1;
        this.#resync = false;
        return this.#pendingFrame(payload, true, edit);
      }
      #pendingFrame(payload, keyframe, edit) {
        this.#pending = true;
        const generation = ++this.#generation;
        const encoder2 = this;
        return {
          payload,
          keyframe,
          commit() {
            if (encoder2.#generation !== generation || !encoder2.#pending)
              return;
            encoder2.#commit(edit);
            encoder2.#pending = false;
          }
        };
      }
      /** Apply an edit after its encoded frame reached the wire. */
      #commit(edit) {
        if ("push" in edit) {
          this.#window.push(edit.push);
          if (this.#checkpointRecords !== void 0 && this.#window.length > this.#checkpointRecords) {
            const dropped = this.#window.length - this.#checkpointRecords;
            this.#window.splice(0, dropped);
            this.#start += dropped;
          }
        } else {
          const offset = this.#offset + edit.pop;
          const stored = Math.min(Math.max(offset - this.#start, 0), this.#window.length);
          this.#window.splice(0, stored);
          this.#start += stored;
          this.#offset = offset;
        }
      }
    };
  }
});

// ../../node_modules/@moq/json/window/producer.js
var Producer7;
var init_producer2 = __esm({
  "../../node_modules/@moq/json/window/producer.js"() {
    init_net();
    init_encoder2();
    Producer7 = class {
      #track;
      #encoder;
      #finished = false;
      // The group an op would be appended to, open after a header.
      #group;
      /** Wrap a track to publish a window into it. */
      constructor(config2) {
        this.#track = config2.track;
        this.#encoder = new Encoder3(config2);
      }
      /** The retained checkpoint suffix, oldest first. This is complete unless bounded in the config. */
      get window() {
        return this.#encoder.window;
      }
      /** Absolute index of the oldest retained record. */
      get offset() {
        return this.#encoder.offset;
      }
      /** Append one record to the back of the window. */
      push(value) {
        this.#assertOpen();
        this.#write(this.#encoder.push(value));
      }
      /**
       * Drop `count` records from the front of the window.
       *
       * A no-op when the window is already empty, and clamped to what it holds, so a caller can trim
       * unconditionally.
       */
      pop(count2) {
        this.#assertOpen();
        const frame = this.#encoder.pop(count2);
        if (frame)
          this.#write(frame);
      }
      #assertOpen() {
        if (this.#finished)
          throw new Error("track is closed");
      }
      #write(encoded) {
        if (encoded.keyframe) {
          this.#group?.close();
          this.#group = void 0;
          const group = this.#track.appendGroup();
          try {
            group.writeFrame({ payload: encoded.payload, timestamp: time_exports.Timestamp.now() });
          } catch (err2) {
            group.close();
            throw err2;
          }
          this.#group = group;
          encoded.commit();
          return;
        }
        if (!this.#group)
          throw new Error("op with no open group");
        this.#group.writeFrame({ payload: encoded.payload, timestamp: time_exports.Timestamp.now() });
        encoded.commit();
      }
      /** Finish the track, closing any open group. */
      finish() {
        if (this.#finished)
          return;
        this.#finished = true;
        this.#group?.close();
        this.#group = void 0;
        this.#track.close();
      }
    };
  }
});

// ../../node_modules/@moq/json/window/index.js
var window_exports = {};
__export(window_exports, {
  Consumer: () => Consumer7,
  Decoder: () => Decoder3,
  Encoder: () => Encoder3,
  Producer: () => Producer7
});
var init_window = __esm({
  "../../node_modules/@moq/json/window/index.js"() {
    init_consumer2();
    init_decoder2();
    init_encoder2();
    init_producer2();
  }
});

// ../../node_modules/@moq/json/index.js
var init_json = __esm({
  "../../node_modules/@moq/json/index.js"() {
    init_snapshot();
    init_window();
  }
});

// src/follow.ts
function checkName(name) {
  if (typeof name !== "string" || name === "" || name.startsWith(".") || name.includes("/") || name.includes("*")) throw new TypeError(`not a name: ${String(name)}`);
  return name;
}
function jsonOf(value) {
  const text = JSON.stringify(value);
  if (text === void 0) throw new TypeError("not a JSON value");
  const bytes = new TextEncoder().encode(text).byteLength;
  if (bytes > VALUE_BYTES) throw new RangeError(`${bytes} bytes of JSON: at most ${VALUE_BYTES}`);
  return text;
}
function groups(track) {
  let next;
  return () => {
    next ??= Math.max(Date.now() * 1e3, highest + 1);
    const group = new group_exports.Producer(next++);
    track.writeGroup(group);
    highest = Math.max(highest, group.sequence);
    return group;
  };
}
function later(callback) {
  queueMicrotask(callback);
}
function follow(inside2, route, from2, come) {
  if (from2 === inside2.id) return () => {
  };
  if (from2 !== void 0 && (typeof from2 !== "string" || !ID.test(from2))) throw new TypeError(`not an ID: ${String(from2)}`);
  const people = /* @__PURE__ */ new Map();
  const leaving = /* @__PURE__ */ new Map();
  const pattern = from2 === void 0 ? path_exports.Pattern.parse(`${route}/*`) : path_exports.Pattern.literal(`${route}/${from2}`);
  const announced = inside2.origin.announced(pattern);
  let stopped = false;
  const leave = (id) => {
    clearTimeout(leaving.get(id));
    leaving.delete(id);
    people.get(id)?.();
    people.delete(id);
  };
  void (async () => {
    try {
      for await (const { kind, prefix } of announced) {
        if (stopped) break;
        if (!pattern.matches(prefix)) continue;
        const id = path_exports.parts(prefix).at(-1);
        if (id === inside2.id) continue;
        if (kind === "retracted") {
          if (people.has(id) && !leaving.has(id)) leaving.set(id, setTimeout(() => leave(id)));
        } else if (leaving.has(id)) {
          clearTimeout(leaving.get(id));
          leaving.delete(id);
        } else if (!people.has(id)) people.set(id, come(id));
      }
    } catch {
    }
  })();
  return () => {
    stopped = true;
    announced.close();
    for (const id of [...people.keys()]) leave(id);
  };
}
function reading(inside2, path, read2) {
  const stop = Promise.withResolvers();
  let stopped = false;
  let current;
  const on = () => !stopped && !inside2.isClosed();
  const done = Promise.race([stop.promise, inside2.closed]);
  const request = inside2.origin.request(path_exports.from(path), { announced: true });
  void (async () => {
    try {
      while (on()) {
        const active = request.active.peek();
        if (!active) {
          if (request.closed.peek() !== void 0) return;
          await Promise.race([request.active.changed(), request.closed, done]);
          continue;
        }
        const run = current = read2(active);
        let moved = false;
        const off = request.active.subscribe((now) => now !== active && (moved = true, run.close()));
        await run.ended.catch(() => {
        });
        off();
        run.close();
        if (on() && !moved) await Promise.race([sleep2(RETRY_MS), done]);
      }
    } finally {
      request.close();
    }
  })();
  return () => {
    stopped = true;
    stop.resolve();
    current?.close();
  };
}
var RETRY_MS, VALUE_BYTES, sleep2, highest;
var init_follow = __esm({
  "src/follow.ts"() {
    "use strict";
    init_net();
    init_room();
    RETRY_MS = 1e3;
    VALUE_BYTES = 1024 * 1024;
    sleep2 = (ms2) => new Promise((resolve2) => setTimeout(resolve2, ms2));
    highest = 0;
  }
});

// src/show.ts
function received2(stream, heard) {
  sounds.set(stream, heard);
}
function count(heard, by) {
  if (!heard) return;
  const was = heard.shown > 0;
  heard.shown += by;
  if (heard.shown > 0 !== was) heard.set(!was);
}
function pictureOf(stream) {
  const video = stream.getVideoTracks();
  let picture = pictures.get(stream);
  const had = picture?.getVideoTracks() ?? [];
  if (picture === void 0 || had.length !== video.length || !video.every((track) => had.includes(track))) {
    pictures.set(stream, picture = video.length ? new MediaStream(video) : null);
  }
  return picture;
}
function show(element, stream, options) {
  if (typeof HTMLMediaElement === "undefined") throw new Error("Media needs a browser: @moq/publish and @moq/watch run in browsers only");
  if (!(element instanceof HTMLMediaElement)) throw new TypeError("give a <video> or <audio> element");
  const sound2 = stream && options?.muted !== true ? sounds.get(stream) : void 0;
  count(sound2, 1);
  count(playing.get(element), -1);
  if (sound2) playing.set(element, sound2);
  else playing.delete(element);
  if (!stream) {
    element.srcObject = null;
    return;
  }
  const picture = pictureOf(stream);
  element.muted = true;
  element.setAttribute("playsinline", "");
  element.autoplay = true;
  if (element.srcObject !== picture) element.srcObject = picture;
  if (picture && element.paused) element.play().catch(() => {
  });
}
var sounds, pictures, playing;
var init_show = __esm({
  "src/show.ts"() {
    "use strict";
    sounds = /* @__PURE__ */ new WeakMap();
    pictures = /* @__PURE__ */ new WeakMap();
    playing = /* @__PURE__ */ new WeakMap();
  }
});

// ../../node_modules/@moq/hang/util/aac.js
var aac_exports = {};
__export(aac_exports, {
  SAMPLE_RATES: () => SAMPLE_RATES,
  audioSpecificConfig: () => audioSpecificConfig,
  pickRate: () => pickRate,
  supportsRate: () => supportsRate
});
function supportsRate(rate) {
  return SAMPLE_RATE_INDEX[rate] !== void 0;
}
function pickRate(rate) {
  return SAMPLE_RATES.find((r2) => r2 >= rate) ?? SAMPLE_RATES[SAMPLE_RATES.length - 1];
}
function channelConfig(channelCount) {
  if (Number.isInteger(channelCount) && channelCount >= 1 && channelCount <= 6)
    return channelCount;
  if (channelCount === 8)
    return 7;
  throw new Error(`no AAC channel configuration for ${channelCount} channels`);
}
function audioSpecificConfig(sampleRate, channelCount) {
  const config2 = channelConfig(channelCount);
  const freqIndex = SAMPLE_RATE_INDEX[sampleRate];
  if (freqIndex !== void 0) {
    const byte0 = AAC_LC << 3 | freqIndex >> 1;
    const byte1 = (freqIndex & 1) << 7 | config2 << 3;
    return new Uint8Array([byte0, byte1]);
  }
  let bits = 0n;
  bits |= BigInt(AAC_LC) << 35n;
  bits |= 0xfn << 31n;
  bits |= BigInt(sampleRate) << 7n;
  bits |= BigInt(config2) << 3n;
  const out = new Uint8Array(5);
  for (let i2 = 0; i2 < out.length; i2++) {
    out[i2] = Number(bits >> BigInt((out.length - 1 - i2) * 8) & 0xffn);
  }
  return out;
}
var SAMPLE_RATE_INDEX, SAMPLE_RATES, AAC_LC;
var init_aac = __esm({
  "../../node_modules/@moq/hang/util/aac.js"() {
    SAMPLE_RATE_INDEX = {
      96e3: 0,
      88200: 1,
      64e3: 2,
      48e3: 3,
      44100: 4,
      32e3: 5,
      24e3: 6,
      22050: 7,
      16e3: 8,
      12e3: 9,
      11025: 10,
      8e3: 11,
      7350: 12
    };
    SAMPLE_RATES = Object.freeze(Object.keys(SAMPLE_RATE_INDEX).map(Number).sort((a2, b3) => a2 - b3));
    AAC_LC = 2;
  }
});

// ../../node_modules/@moq/hang/util/gesture.js
var gesture_exports = {};
__export(gesture_exports, {
  unlock: () => unlock
});
function unlock(effect, context) {
  const running = new Signal(context.state === "running");
  effect.event(context, "statechange", () => running.set(context.state === "running"));
  effect.run((inner) => {
    if (inner.get(running))
      return;
    const resume = () => {
      context.resume().catch(() => {
      });
    };
    resume();
    inner.event(document, "pointerdown", resume);
    inner.event(document, "pointerup", resume);
    inner.event(document, "keydown", resume);
  });
  return running;
}
var init_gesture = __esm({
  "../../node_modules/@moq/hang/util/gesture.js"() {
    init_signals();
  }
});

// ../../node_modules/@moq/hang/util/hacks.js
var hacks_exports = {};
__export(hacks_exports, {
  isChrome: () => isChrome,
  isFirefox: () => isFirefox,
  isSafari: () => isSafari
});
var isChrome, isFirefox, isSafari;
var init_hacks = __esm({
  "../../node_modules/@moq/hang/util/hacks.js"() {
    isChrome = navigator.userAgent.toLowerCase().includes("chrome");
    isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
    isSafari = navigator.userAgent.toLowerCase().includes("safari") && !isChrome;
  }
});

// ../../node_modules/@moq/hang/util/hex.js
var hex_exports2 = {};
__export(hex_exports2, {
  fromBytes: () => fromBytes,
  toBytes: () => toBytes2
});
function toBytes2(hex) {
  hex = hex.startsWith("0x") ? hex.slice(2) : hex;
  if (hex.length % 2) {
    throw new Error("invalid hex string length");
  }
  if (!HEX.test(hex)) {
    const index2 = hex.search(/[^0-9a-fA-F]/);
    throw new Error(`invalid hex character '${hex[index2]}' at position ${index2}`);
  }
  const bytes = new Uint8Array(hex.length / 2);
  for (let i2 = 0; i2 < bytes.length; i2++) {
    bytes[i2] = Number.parseInt(hex.slice(i2 * 2, i2 * 2 + 2), 16);
  }
  return bytes;
}
function fromBytes(bytes) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join("");
}
var HEX;
var init_hex2 = __esm({
  "../../node_modules/@moq/hang/util/hex.js"() {
    HEX = /^[0-9a-fA-F]*$/;
  }
});

// ../../node_modules/@libav.js/variant-opus-af/dist/libav-opus-af.mjs
var libav_opus_af_exports = {};
__export(libav_opus_af_exports, {
  AVDISCARD_ALL: () => AVDISCARD_ALL,
  AVDISCARD_BIDIR: () => AVDISCARD_BIDIR,
  AVDISCARD_DEFAULT: () => AVDISCARD_DEFAULT,
  AVDISCARD_NONE: () => AVDISCARD_NONE,
  AVDISCARD_NONINTRA: () => AVDISCARD_NONINTRA,
  AVDISCARD_NONKEY: () => AVDISCARD_NONKEY,
  AVDISCARD_NONREF: () => AVDISCARD_NONREF,
  AVERROR_EOF: () => AVERROR_EOF,
  AVFMT_FLAG_FLUSH_PACKETS: () => AVFMT_FLAG_FLUSH_PACKETS,
  AVFMT_FLAG_NOBUFFER: () => AVFMT_FLAG_NOBUFFER,
  AVIO_FLAG_DIRECT: () => AVIO_FLAG_DIRECT,
  AVIO_FLAG_NONBLOCK: () => AVIO_FLAG_NONBLOCK,
  AVIO_FLAG_READ: () => AVIO_FLAG_READ,
  AVIO_FLAG_READ_WRITE: () => AVIO_FLAG_READ_WRITE,
  AVIO_FLAG_WRITE: () => AVIO_FLAG_WRITE,
  AVMEDIA_TYPE_ATTACHMENT: () => AVMEDIA_TYPE_ATTACHMENT,
  AVMEDIA_TYPE_AUDIO: () => AVMEDIA_TYPE_AUDIO,
  AVMEDIA_TYPE_DATA: () => AVMEDIA_TYPE_DATA,
  AVMEDIA_TYPE_SUBTITLE: () => AVMEDIA_TYPE_SUBTITLE,
  AVMEDIA_TYPE_UNKNOWN: () => AVMEDIA_TYPE_UNKNOWN,
  AVMEDIA_TYPE_VIDEO: () => AVMEDIA_TYPE_VIDEO,
  AVSEEK_FLAG_ANY: () => AVSEEK_FLAG_ANY,
  AVSEEK_FLAG_BACKWARD: () => AVSEEK_FLAG_BACKWARD,
  AVSEEK_FLAG_BYTE: () => AVSEEK_FLAG_BYTE,
  AVSEEK_FLAG_FRAME: () => AVSEEK_FLAG_FRAME,
  AV_LOG_DEBUG: () => AV_LOG_DEBUG,
  AV_LOG_ERROR: () => AV_LOG_ERROR,
  AV_LOG_FATAL: () => AV_LOG_FATAL,
  AV_LOG_INFO: () => AV_LOG_INFO,
  AV_LOG_PANIC: () => AV_LOG_PANIC,
  AV_LOG_QUIET: () => AV_LOG_QUIET,
  AV_LOG_TRACE: () => AV_LOG_TRACE,
  AV_LOG_VERBOSE: () => AV_LOG_VERBOSE,
  AV_LOG_WARNING: () => AV_LOG_WARNING,
  AV_NOPTS_VALUE: () => AV_NOPTS_VALUE,
  AV_NOPTS_VALUE_HI: () => AV_NOPTS_VALUE_HI,
  AV_NOPTS_VALUE_I64: () => AV_NOPTS_VALUE_I64,
  AV_NOPTS_VALUE_LO: () => AV_NOPTS_VALUE_LO,
  AV_OPT_SEARCH_CHILDREN: () => AV_OPT_SEARCH_CHILDREN,
  AV_PIX_FMT_ABGR: () => AV_PIX_FMT_ABGR,
  AV_PIX_FMT_ARGB: () => AV_PIX_FMT_ARGB,
  AV_PIX_FMT_BGR24: () => AV_PIX_FMT_BGR24,
  AV_PIX_FMT_BGR4: () => AV_PIX_FMT_BGR4,
  AV_PIX_FMT_BGR4_BYTE: () => AV_PIX_FMT_BGR4_BYTE,
  AV_PIX_FMT_BGR555BE: () => AV_PIX_FMT_BGR555BE,
  AV_PIX_FMT_BGR555LE: () => AV_PIX_FMT_BGR555LE,
  AV_PIX_FMT_BGR565BE: () => AV_PIX_FMT_BGR565BE,
  AV_PIX_FMT_BGR565LE: () => AV_PIX_FMT_BGR565LE,
  AV_PIX_FMT_BGR8: () => AV_PIX_FMT_BGR8,
  AV_PIX_FMT_BGRA: () => AV_PIX_FMT_BGRA,
  AV_PIX_FMT_GRAY16BE: () => AV_PIX_FMT_GRAY16BE,
  AV_PIX_FMT_GRAY16LE: () => AV_PIX_FMT_GRAY16LE,
  AV_PIX_FMT_GRAY8: () => AV_PIX_FMT_GRAY8,
  AV_PIX_FMT_MONOBLACK: () => AV_PIX_FMT_MONOBLACK,
  AV_PIX_FMT_MONOWHITE: () => AV_PIX_FMT_MONOWHITE,
  AV_PIX_FMT_NONE: () => AV_PIX_FMT_NONE,
  AV_PIX_FMT_NV12: () => AV_PIX_FMT_NV12,
  AV_PIX_FMT_NV21: () => AV_PIX_FMT_NV21,
  AV_PIX_FMT_PAL8: () => AV_PIX_FMT_PAL8,
  AV_PIX_FMT_RGB24: () => AV_PIX_FMT_RGB24,
  AV_PIX_FMT_RGB4: () => AV_PIX_FMT_RGB4,
  AV_PIX_FMT_RGB48BE: () => AV_PIX_FMT_RGB48BE,
  AV_PIX_FMT_RGB48LE: () => AV_PIX_FMT_RGB48LE,
  AV_PIX_FMT_RGB4_BYTE: () => AV_PIX_FMT_RGB4_BYTE,
  AV_PIX_FMT_RGB555BE: () => AV_PIX_FMT_RGB555BE,
  AV_PIX_FMT_RGB555LE: () => AV_PIX_FMT_RGB555LE,
  AV_PIX_FMT_RGB565BE: () => AV_PIX_FMT_RGB565BE,
  AV_PIX_FMT_RGB565LE: () => AV_PIX_FMT_RGB565LE,
  AV_PIX_FMT_RGB8: () => AV_PIX_FMT_RGB8,
  AV_PIX_FMT_RGBA: () => AV_PIX_FMT_RGBA,
  AV_PIX_FMT_UYVY422: () => AV_PIX_FMT_UYVY422,
  AV_PIX_FMT_UYYVYY411: () => AV_PIX_FMT_UYYVYY411,
  AV_PIX_FMT_YUV410P: () => AV_PIX_FMT_YUV410P,
  AV_PIX_FMT_YUV411P: () => AV_PIX_FMT_YUV411P,
  AV_PIX_FMT_YUV420P: () => AV_PIX_FMT_YUV420P,
  AV_PIX_FMT_YUV422P: () => AV_PIX_FMT_YUV422P,
  AV_PIX_FMT_YUV440P: () => AV_PIX_FMT_YUV440P,
  AV_PIX_FMT_YUV444P: () => AV_PIX_FMT_YUV444P,
  AV_PIX_FMT_YUVA420P: () => AV_PIX_FMT_YUVA420P,
  AV_PIX_FMT_YUVJ420P: () => AV_PIX_FMT_YUVJ420P,
  AV_PIX_FMT_YUVJ422P: () => AV_PIX_FMT_YUVJ422P,
  AV_PIX_FMT_YUVJ440P: () => AV_PIX_FMT_YUVJ440P,
  AV_PIX_FMT_YUVJ444P: () => AV_PIX_FMT_YUVJ444P,
  AV_PIX_FMT_YUYV422: () => AV_PIX_FMT_YUYV422,
  AV_PKT_FLAG_CORRUPT: () => AV_PKT_FLAG_CORRUPT,
  AV_PKT_FLAG_DISCARD: () => AV_PKT_FLAG_DISCARD,
  AV_PKT_FLAG_DISPOSABLE: () => AV_PKT_FLAG_DISPOSABLE,
  AV_PKT_FLAG_KEY: () => AV_PKT_FLAG_KEY,
  AV_PKT_FLAG_TRUSTED: () => AV_PKT_FLAG_TRUSTED,
  AV_SAMPLE_FMT_DBL: () => AV_SAMPLE_FMT_DBL,
  AV_SAMPLE_FMT_DBLP: () => AV_SAMPLE_FMT_DBLP,
  AV_SAMPLE_FMT_FLT: () => AV_SAMPLE_FMT_FLT,
  AV_SAMPLE_FMT_FLTP: () => AV_SAMPLE_FMT_FLTP,
  AV_SAMPLE_FMT_NB: () => AV_SAMPLE_FMT_NB,
  AV_SAMPLE_FMT_NONE: () => AV_SAMPLE_FMT_NONE,
  AV_SAMPLE_FMT_S16: () => AV_SAMPLE_FMT_S16,
  AV_SAMPLE_FMT_S16P: () => AV_SAMPLE_FMT_S16P,
  AV_SAMPLE_FMT_S32: () => AV_SAMPLE_FMT_S32,
  AV_SAMPLE_FMT_S32P: () => AV_SAMPLE_FMT_S32P,
  AV_SAMPLE_FMT_S64: () => AV_SAMPLE_FMT_S64,
  AV_SAMPLE_FMT_S64P: () => AV_SAMPLE_FMT_S64P,
  AV_SAMPLE_FMT_U8: () => AV_SAMPLE_FMT_U8,
  AV_SAMPLE_FMT_U8P: () => AV_SAMPLE_FMT_U8P,
  AV_TIME_BASE: () => AV_TIME_BASE,
  AV_VERSION_INT: () => AV_VERSION_INT,
  CONFIG: () => CONFIG,
  DBG: () => DBG,
  E2BIG: () => E2BIG,
  EADDRINUSE: () => EADDRINUSE,
  EADDRNOTAVAIL: () => EADDRNOTAVAIL,
  EAFNOSUPPORT: () => EAFNOSUPPORT,
  EAGAIN: () => EAGAIN,
  EALREADY: () => EALREADY,
  EBADF: () => EBADF,
  EBADMSG: () => EBADMSG,
  EBUSY: () => EBUSY,
  ECANCELED: () => ECANCELED,
  ECHILD: () => ECHILD,
  ECONNABORTED: () => ECONNABORTED,
  ECONNREFUSED: () => ECONNREFUSED,
  ECONNRESET: () => ECONNRESET,
  EDEADLOCK: () => EDEADLOCK,
  EDESTADDRREQ: () => EDESTADDRREQ,
  EDOM: () => EDOM,
  EDQUOT: () => EDQUOT,
  EEXIST: () => EEXIST,
  EFAULT: () => EFAULT,
  EFBIG: () => EFBIG,
  EHOSTUNREACH: () => EHOSTUNREACH,
  EIDRM: () => EIDRM,
  EILSEQ: () => EILSEQ,
  EINPROGRESS: () => EINPROGRESS,
  EINTR: () => EINTR,
  EINVAL: () => EINVAL,
  EIO: () => EIO,
  EISCONN: () => EISCONN,
  EISDIR: () => EISDIR,
  ELOOP: () => ELOOP,
  EMFILE: () => EMFILE,
  EMLINK: () => EMLINK,
  EMSGSIZE: () => EMSGSIZE,
  EMULTIHOP: () => EMULTIHOP,
  ENAMETOOLONG: () => ENAMETOOLONG,
  ENETDOWN: () => ENETDOWN,
  ENETRESET: () => ENETRESET,
  ENETUNREACH: () => ENETUNREACH,
  ENFILE: () => ENFILE,
  ENOBUFS: () => ENOBUFS,
  ENODEV: () => ENODEV,
  ENOENT: () => ENOENT,
  EPERM: () => EPERM,
  LibAV: () => LibAV2,
  VER: () => VER,
  base: () => base,
  bigIntToi64: () => bigIntToi64,
  default: () => libav_opus_af_default,
  f64toi64: () => f64toi64,
  factories: () => factories,
  ff_channel_layout: () => ff_channel_layout,
  ff_channels: () => ff_channels,
  i64ToBigInt: () => i64ToBigInt,
  i64tof64: () => i64tof64,
  isThreadingSupported: () => isThreadingSupported,
  isWebAssemblySupported: () => isWebAssemblySupported,
  target: () => target2
});
var libav, base, isWebAssemblySupported, isThreadingSupported, target2, VER, CONFIG, DBG, factories, i64tof64, f64toi64, i64ToBigInt, bigIntToi64, ff_channel_layout, ff_channels, AV_VERSION_INT, AV_TIME_BASE, AV_NOPTS_VALUE_I64, AV_NOPTS_VALUE_LO, AV_NOPTS_VALUE_HI, AV_NOPTS_VALUE, AV_OPT_SEARCH_CHILDREN, AVMEDIA_TYPE_UNKNOWN, AVMEDIA_TYPE_VIDEO, AVMEDIA_TYPE_AUDIO, AVMEDIA_TYPE_DATA, AVMEDIA_TYPE_SUBTITLE, AVMEDIA_TYPE_ATTACHMENT, AV_SAMPLE_FMT_NONE, AV_SAMPLE_FMT_U8, AV_SAMPLE_FMT_S16, AV_SAMPLE_FMT_S32, AV_SAMPLE_FMT_FLT, AV_SAMPLE_FMT_DBL, AV_SAMPLE_FMT_U8P, AV_SAMPLE_FMT_S16P, AV_SAMPLE_FMT_S32P, AV_SAMPLE_FMT_FLTP, AV_SAMPLE_FMT_DBLP, AV_SAMPLE_FMT_S64, AV_SAMPLE_FMT_S64P, AV_SAMPLE_FMT_NB, AV_PIX_FMT_NONE, AV_PIX_FMT_YUV420P, AV_PIX_FMT_YUYV422, AV_PIX_FMT_RGB24, AV_PIX_FMT_BGR24, AV_PIX_FMT_YUV422P, AV_PIX_FMT_YUV444P, AV_PIX_FMT_YUV410P, AV_PIX_FMT_YUV411P, AV_PIX_FMT_GRAY8, AV_PIX_FMT_MONOWHITE, AV_PIX_FMT_MONOBLACK, AV_PIX_FMT_PAL8, AV_PIX_FMT_YUVJ420P, AV_PIX_FMT_YUVJ422P, AV_PIX_FMT_YUVJ444P, AV_PIX_FMT_UYVY422, AV_PIX_FMT_UYYVYY411, AV_PIX_FMT_BGR8, AV_PIX_FMT_BGR4, AV_PIX_FMT_BGR4_BYTE, AV_PIX_FMT_RGB8, AV_PIX_FMT_RGB4, AV_PIX_FMT_RGB4_BYTE, AV_PIX_FMT_NV12, AV_PIX_FMT_NV21, AV_PIX_FMT_ARGB, AV_PIX_FMT_RGBA, AV_PIX_FMT_ABGR, AV_PIX_FMT_BGRA, AV_PIX_FMT_GRAY16BE, AV_PIX_FMT_GRAY16LE, AV_PIX_FMT_YUV440P, AV_PIX_FMT_YUVJ440P, AV_PIX_FMT_YUVA420P, AV_PIX_FMT_RGB48BE, AV_PIX_FMT_RGB48LE, AV_PIX_FMT_RGB565BE, AV_PIX_FMT_RGB565LE, AV_PIX_FMT_RGB555BE, AV_PIX_FMT_RGB555LE, AV_PIX_FMT_BGR565BE, AV_PIX_FMT_BGR565LE, AV_PIX_FMT_BGR555BE, AV_PIX_FMT_BGR555LE, AVIO_FLAG_READ, AVIO_FLAG_WRITE, AVIO_FLAG_READ_WRITE, AVIO_FLAG_NONBLOCK, AVIO_FLAG_DIRECT, AVFMT_FLAG_NOBUFFER, AVFMT_FLAG_FLUSH_PACKETS, AVSEEK_FLAG_BACKWARD, AVSEEK_FLAG_BYTE, AVSEEK_FLAG_ANY, AVSEEK_FLAG_FRAME, AVDISCARD_NONE, AVDISCARD_DEFAULT, AVDISCARD_NONREF, AVDISCARD_BIDIR, AVDISCARD_NONINTRA, AVDISCARD_NONKEY, AVDISCARD_ALL, AV_LOG_QUIET, AV_LOG_PANIC, AV_LOG_FATAL, AV_LOG_ERROR, AV_LOG_WARNING, AV_LOG_INFO, AV_LOG_VERBOSE, AV_LOG_DEBUG, AV_LOG_TRACE, AV_PKT_FLAG_KEY, AV_PKT_FLAG_CORRUPT, AV_PKT_FLAG_DISCARD, AV_PKT_FLAG_TRUSTED, AV_PKT_FLAG_DISPOSABLE, E2BIG, EPERM, EADDRINUSE, EADDRNOTAVAIL, EAFNOSUPPORT, EAGAIN, EALREADY, EBADF, EBADMSG, EBUSY, ECANCELED, ECHILD, ECONNABORTED, ECONNREFUSED, ECONNRESET, EDEADLOCK, EDESTADDRREQ, EDOM, EDQUOT, EEXIST, EFAULT, EFBIG, EHOSTUNREACH, EIDRM, EILSEQ, EINPROGRESS, EINTR, EINVAL, EIO, EISCONN, EISDIR, ELOOP, EMFILE, EMLINK, EMSGSIZE, EMULTIHOP, ENAMETOOLONG, ENETDOWN, ENETRESET, ENETUNREACH, ENFILE, ENOBUFS, ENODEV, ENOENT, AVERROR_EOF, LibAV2, libav_opus_af_default;
var init_libav_opus_af = __esm({
  "../../node_modules/@libav.js/variant-opus-af/dist/libav-opus-af.mjs"() {
    libav = {};
    (function() {
      function isWebAssemblySupported2(module) {
        module = module || [0, 97, 115, 109, 1, 0, 0, 0];
        if (typeof WebAssembly !== "object" || typeof WebAssembly.instantiate !== "function") return false;
        try {
          var module = new WebAssembly.Module(new Uint8Array(module));
          if (module instanceof WebAssembly.Module) return new WebAssembly.Instance(module) instanceof WebAssembly.Instance;
        } catch (e5) {
        }
        return false;
      }
      function isThreadingSupported2() {
        try {
          var mem = new WebAssembly.Memory({ initial: 1, maximum: 1, shared: true });
          if (!(mem.buffer instanceof SharedArrayBuffer)) return false;
          return true;
        } catch (e5) {
        }
        return false;
      }
      var nodejs = typeof process !== "undefined";
      if (!libav.base) {
        libav.base = import.meta.url;
        libav.base = libav.base.replace(/\/[^\/]*$/, "");
      }
      libav.isWebAssemblySupported = isWebAssemblySupported2;
      libav.isThreadingSupported = isThreadingSupported2;
      function target3(opts) {
        opts = opts || {};
        var wasm = !opts.nowasm && isWebAssemblySupported2();
        var thr = opts.yesthreads && wasm && !opts.nothreads && isThreadingSupported2();
        if (!wasm) return "asm";
        else if (thr) return "thr";
        else return "wasm";
      }
      libav.target = target3;
      libav.VER = "6.10.9.0";
      libav.CONFIG = "opus-af";
      libav.DBG = "";
      libav.factories = {};
      var libavStatics = {};
      libavStatics.i64tof64 = function(lo, hi) {
        if (!hi && lo >= 0) return lo;
        if (hi === -1 && lo < 0) return lo;
        return hi * 4294967296 + lo + (lo < 0 ? 4294967296 : 0);
      };
      libavStatics.f64toi64 = function(val) {
        return [~~val, Math.floor(val / 4294967296)];
      };
      libavStatics.i64ToBigInt = function(lo, hi) {
        var dv = new DataView(new ArrayBuffer(8));
        dv.setInt32(0, lo, true);
        dv.setInt32(4, hi, true);
        return dv.getBigInt64(0, true);
      };
      libavStatics.bigIntToi64 = function(val) {
        var dv = new DataView(new ArrayBuffer(8));
        dv.setBigInt64(0, val, true);
        return [dv.getInt32(0, true), dv.getInt32(4, true)];
      };
      libavStatics.ff_channel_layout = function(frame) {
        if (frame.channel_layout) return frame.channel_layout;
        else if (frame.channels && frame.channels !== 1) return (1 << frame.channels) - 1;
        else return 4;
      };
      libavStatics.ff_channels = function(frame) {
        if (frame.channels) {
          return frame.channels;
        } else if (frame.channel_layout) {
          var channels = 0;
          var cl2 = frame.channel_layout;
          while (cl2) {
            channels += cl2 & 1;
            cl2 >>= 1;
          }
          return channels;
        } else {
          return 1;
        }
      };
      libavStatics.AV_VERSION_INT = function(maj, min, rev) {
        return maj << 16 | min << 8 | rev;
      };
      function enume(vals, first) {
        if (typeof first === "undefined") first = 0;
        var i2 = first;
        vals.forEach((function(val) {
          libavStatics[val] = i2++;
        }));
      }
      libavStatics.AV_TIME_BASE = 1e6;
      libavStatics.AV_NOPTS_VALUE_I64 = [0, ~~2147483648];
      libavStatics.AV_NOPTS_VALUE_LO = 0;
      libavStatics.AV_NOPTS_VALUE_HI = ~~2147483648;
      libavStatics.AV_NOPTS_VALUE = libavStatics.i64tof64(0, ~~2147483648);
      libavStatics.AV_OPT_SEARCH_CHILDREN = 1;
      enume(["AVMEDIA_TYPE_UNKNOWN", "AVMEDIA_TYPE_VIDEO", "AVMEDIA_TYPE_AUDIO", "AVMEDIA_TYPE_DATA", "AVMEDIA_TYPE_SUBTITLE", "AVMEDIA_TYPE_ATTACHMENT"], -1);
      enume(["AV_SAMPLE_FMT_NONE", "AV_SAMPLE_FMT_U8", "AV_SAMPLE_FMT_S16", "AV_SAMPLE_FMT_S32", "AV_SAMPLE_FMT_FLT", "AV_SAMPLE_FMT_DBL", "AV_SAMPLE_FMT_U8P", "AV_SAMPLE_FMT_S16P", "AV_SAMPLE_FMT_S32P", "AV_SAMPLE_FMT_FLTP", "AV_SAMPLE_FMT_DBLP", "AV_SAMPLE_FMT_S64", "AV_SAMPLE_FMT_S64P", "AV_SAMPLE_FMT_NB"], -1);
      enume(["AV_PIX_FMT_NONE", "AV_PIX_FMT_YUV420P", "AV_PIX_FMT_YUYV422", "AV_PIX_FMT_RGB24", "AV_PIX_FMT_BGR24", "AV_PIX_FMT_YUV422P", "AV_PIX_FMT_YUV444P", "AV_PIX_FMT_YUV410P", "AV_PIX_FMT_YUV411P", "AV_PIX_FMT_GRAY8", "AV_PIX_FMT_MONOWHITE", "AV_PIX_FMT_MONOBLACK", "AV_PIX_FMT_PAL8", "AV_PIX_FMT_YUVJ420P", "AV_PIX_FMT_YUVJ422P", "AV_PIX_FMT_YUVJ444P", "AV_PIX_FMT_UYVY422", "AV_PIX_FMT_UYYVYY411", "AV_PIX_FMT_BGR8", "AV_PIX_FMT_BGR4", "AV_PIX_FMT_BGR4_BYTE", "AV_PIX_FMT_RGB8", "AV_PIX_FMT_RGB4", "AV_PIX_FMT_RGB4_BYTE", "AV_PIX_FMT_NV12", "AV_PIX_FMT_NV21", "AV_PIX_FMT_ARGB", "AV_PIX_FMT_RGBA", "AV_PIX_FMT_ABGR", "AV_PIX_FMT_BGRA", "AV_PIX_FMT_GRAY16BE", "AV_PIX_FMT_GRAY16LE", "AV_PIX_FMT_YUV440P", "AV_PIX_FMT_YUVJ440P", "AV_PIX_FMT_YUVA420P", "AV_PIX_FMT_RGB48BE", "AV_PIX_FMT_RGB48LE", "AV_PIX_FMT_RGB565BE", "AV_PIX_FMT_RGB565LE", "AV_PIX_FMT_RGB555BE", "AV_PIX_FMT_RGB555LE", "AV_PIX_FMT_BGR565BE", "AV_PIX_FMT_BGR565LE", "AV_PIX_FMT_BGR555BE", "AV_PIX_FMT_BGR555LE"], -1);
      libavStatics.AVIO_FLAG_READ = 1;
      libavStatics.AVIO_FLAG_WRITE = 2;
      libavStatics.AVIO_FLAG_READ_WRITE = 3;
      libavStatics.AVIO_FLAG_NONBLOCK = 8;
      libavStatics.AVIO_FLAG_DIRECT = 32768;
      libavStatics.AVFMT_FLAG_NOBUFFER = 64;
      libavStatics.AVFMT_FLAG_FLUSH_PACKETS = 512;
      libavStatics.AVSEEK_FLAG_BACKWARD = 1;
      libavStatics.AVSEEK_FLAG_BYTE = 2;
      libavStatics.AVSEEK_FLAG_ANY = 4;
      libavStatics.AVSEEK_FLAG_FRAME = 8;
      libavStatics.AVDISCARD_NONE = -16;
      libavStatics.AVDISCARD_DEFAULT = 0;
      libavStatics.AVDISCARD_NONREF = 8;
      libavStatics.AVDISCARD_BIDIR = 16;
      libavStatics.AVDISCARD_NONINTRA = 24;
      libavStatics.AVDISCARD_NONKEY = 32;
      libavStatics.AVDISCARD_ALL = 48;
      libavStatics.AV_LOG_QUIET = -8;
      libavStatics.AV_LOG_PANIC = 0;
      libavStatics.AV_LOG_FATAL = 8;
      libavStatics.AV_LOG_ERROR = 16;
      libavStatics.AV_LOG_WARNING = 24;
      libavStatics.AV_LOG_INFO = 32;
      libavStatics.AV_LOG_VERBOSE = 40;
      libavStatics.AV_LOG_DEBUG = 48;
      libavStatics.AV_LOG_TRACE = 56;
      libavStatics.AV_PKT_FLAG_KEY = 1;
      libavStatics.AV_PKT_FLAG_CORRUPT = 2;
      libavStatics.AV_PKT_FLAG_DISCARD = 4;
      libavStatics.AV_PKT_FLAG_TRUSTED = 8;
      libavStatics.AV_PKT_FLAG_DISPOSABLE = 16;
      enume(["E2BIG", "EPERM", "EADDRINUSE", "EADDRNOTAVAIL", "EAFNOSUPPORT", "EAGAIN", "EALREADY", "EBADF", "EBADMSG", "EBUSY", "ECANCELED", "ECHILD", "ECONNABORTED", "ECONNREFUSED", "ECONNRESET", "EDEADLOCK", "EDESTADDRREQ", "EDOM", "EDQUOT", "EEXIST", "EFAULT", "EFBIG", "EHOSTUNREACH", "EIDRM", "EILSEQ", "EINPROGRESS", "EINTR", "EINVAL", "EIO", "EISCONN", "EISDIR", "ELOOP", "EMFILE", "EMLINK", "EMSGSIZE", "EMULTIHOP", "ENAMETOOLONG", "ENETDOWN", "ENETRESET", "ENETUNREACH", "ENFILE", "ENOBUFS", "ENODEV", "ENOENT"], 1);
      libavStatics.AVERROR_EOF = -541478725;
      Object.assign(libav, libavStatics);
      libav.LibAV = function(opts) {
        opts = opts || {};
        var base2 = opts.base || libav.base;
        var t = target3(opts);
        var variant = opts.variant || libav.variant || "opus-af";
        var useES6 = true;
        if (useES6 && (opts.noes6 || libav.noes6)) useES6 = false;
        var toImport = opts.toImport || libav.toImport || base2 + "/libav-6.10.9.0-" + variant + "." + t + "." + (useES6 ? "mjs" : "js");
        var ret;
        var mode = "direct";
        if (t === "thr") mode = "threads";
        else if (!nodejs && !opts.noworker && typeof Worker !== "undefined") mode = "worker";
        return Promise.all([]).then((function() {
          if (opts.factory || libav.factory) return opts.factory || libav.factory;
          if (libav.factories[toImport]) return libav.factories[toImport];
          if (mode === "worker") {
          } else if (useES6) {
            return import(toImport).then((function(laf) {
              libav.factories[toImport] = laf.default;
              return laf.default;
            }));
          } else if (nodejs) {
            return libav.factories[toImport] = __require(toImport);
          } else if (typeof importScripts !== "undefined") {
            importScripts(toImport);
            return libav.factories[toImport] = LibAVFactory;
          } else {
            return new Promise((function(res, rej) {
              var scr = document.createElement("script");
              scr.src = toImport;
              scr.addEventListener("load", res);
              scr.addEventListener("error", rej);
              scr.async = true;
              document.body.appendChild(scr);
            })).then((function() {
              return libav.factories[toImport] = LibAVFactory;
            }));
          }
        })).then((function(factory) {
          if (mode === "worker") {
            ret = {};
            ret.worker = new Worker(toImport, { type: useES6 ? "module" : "classic" });
            return new Promise((function(res, rej) {
              ret.worker.onerror = (ev) => {
                console.error(ev);
                rej(ev.error || new Error(ev.message));
              };
              ret.worker.postMessage({ config: { variant: opts.variant || libav.variant, wasmurl: opts.wasmurl || libav.wasmurl } });
              ret.on = 1;
              ret.handlers = { error: [function(ex) {
                rej(ex);
              }, null], onready: [function() {
                res();
              }, null], onwrite: [function(args) {
                if (ret.onwrite) ret.onwrite.apply(ret, args);
              }, null], onread: [function(args) {
                try {
                  var rr = null;
                  if (ret.onread) rr = ret.onread.apply(ret, args);
                  if (rr && rr.then && rr.catch) {
                    rr.catch((function(ex) {
                      ret.ff_reader_dev_send(args[0], null, { error: ex });
                    }));
                  }
                } catch (ex) {
                  ret.ff_reader_dev_send(args[0], null, { error: ex });
                }
              }, null], onblockread: [function(args) {
                try {
                  var brr = null;
                  if (ret.onblockread) brr = ret.onblockread.apply(ret, args);
                  if (brr && brr.then && brr.catch) {
                    brr.catch((function(ex) {
                      ret.ff_block_reader_dev_send(args[0], args[1], null, { error: ex });
                    }));
                  }
                } catch (ex) {
                  ret.ff_block_reader_dev_send(args[0], args[1], null, { error: ex });
                }
              }, null] };
              ret.c = function() {
                var msg = Array.prototype.slice.call(arguments);
                var transfer = [];
                for (var i2 = 0; i2 < msg.length; i2++) {
                  if (msg[i2] && msg[i2].libavjsTransfer) transfer.push.apply(transfer, msg[i2].libavjsTransfer);
                }
                return new Promise((function(res2, rej2) {
                  var id = ret.on++;
                  msg = [id].concat(msg);
                  ret.handlers[id] = [res2, rej2];
                  ret.worker.postMessage(msg, transfer);
                }));
              };
              function onworkermessage(e5) {
                var id = e5.data[0];
                var h3 = ret.handlers[id];
                if (h3) {
                  if (e5.data[2]) h3[0](e5.data[3]);
                  else h3[1](e5.data[3]);
                  if (typeof id === "number") delete ret.handlers[id];
                }
              }
              ret.worker.onmessage = onworkermessage;
              ret.terminate = function() {
                ret.worker.terminate();
              };
            }));
          } else if (mode === "threads") {
            return Promise.all([]).then((function() {
              return factory({ wasmurl: opts.wasmurl || libav.wasmurl, variant: opts.variant || libav.variant });
            })).then((function(x4) {
              ret = x4;
              var pthreadT = ret.libavjs_create_main_thread();
              var worker = ret.PThread.pthreads[pthreadT];
              var ready = 0;
              var on = 1;
              var handlers = {};
              var readyPromiseRes = null;
              var readyPromise = new Promise((function(res) {
                readyPromiseRes = res;
              }));
              ret.c = function() {
                var msg = Array.prototype.slice.call(arguments);
                return new Promise((function(res, rej) {
                  var id = on++;
                  msg = [id].concat(msg);
                  handlers[id] = [res, rej];
                  worker.postMessage({ c: "libavjs_run", a: msg });
                }));
              };
              var origOnmessage = worker.onmessage;
              worker.onmessage = function(e5) {
                if (e5.data && e5.data.c === "libavjs_ret") {
                  var a2 = e5.data.a;
                  var h3 = handlers[a2[0]];
                  if (h3) {
                    if (a2[2]) h3[0](a2[3]);
                    else h3[1](a2[3]);
                    delete handlers[a2[0]];
                  }
                } else if (e5.data && e5.data.c === "libavjs_wait_reader") {
                  if (ret.readerDevReady(e5.data.fd)) {
                    worker.postMessage({ c: "libavjs_wait_reader", fd: e5.data.fd });
                  } else {
                    var name = ret.fdName(e5.data.fd);
                    var waiters = ret.ff_reader_dev_waiters[name];
                    if (!waiters) {
                      waiters = ret.ff_reader_dev_waiters[name] = [];
                    }
                    waiters.push((function() {
                      worker.postMessage({ c: "libavjs_wait_reader", fd: e5.data.fd });
                    }));
                  }
                } else if (e5.data && e5.data.c === "libavjs_ready") {
                  readyPromiseRes();
                } else {
                  return origOnmessage.apply(this, arguments);
                }
              };
              ret.terminate = function() {
                ret.PThread.unusedWorkers.concat(ret.PThread.runningWorkers).forEach((function(worker2) {
                  worker2.terminate();
                }));
              };
              return readyPromise;
            }));
          } else {
            return Promise.all([]).then((function() {
              return factory({ wasmurl: opts.wasmurl || libav.wasmurl, variant: opts.variant || libav.variant });
            })).then((function(x4) {
              ret = x4;
              ret.worker = false;
              ret.c = function(func) {
                var args = Array.prototype.slice.call(arguments, 1);
                return new Promise((function(res, rej) {
                  try {
                    res(ret[func].apply(ret, args));
                  } catch (ex) {
                    rej(ex);
                  }
                }));
              };
              ret.terminate = function() {
              };
            }));
          }
        })).then((function() {
          function indirectors(funcs2) {
            funcs2.forEach((function(f3) {
              ret[f3] = function() {
                return ret.c.apply(ret, [f3].concat(Array.prototype.slice.call(arguments)));
              };
            }));
          }
          function directs(funcs2) {
            funcs2.forEach((function(f3) {
              var real = ret[f3 + "_sync"] = ret[f3];
              ret[f3] = function() {
                var args = arguments;
                return new Promise((function(res, rej) {
                  try {
                    var p3 = real.apply(ret, args);
                    if (typeof p3 === "object" && p3 !== null && p3.then) p3.then(res).catch(rej);
                    else res(p3);
                  } catch (ex) {
                    rej(ex);
                  }
                }));
              };
            }));
          }
          var funcs = ["calloc", "close", "dup2", "free", "malloc", "mallinfo_uordblks", "open", "strerror", "libavjs_create_main_thread", "libavjs_with_swscale", "ff_malloc_int32_list", "ff_malloc_int64_list", "av_compare_ts_js", "av_dict_copy_js", "av_dict_free", "av_dict_iterate", "av_dict_set_js", "av_log_get_level", "av_log_set_level", "av_opt_set", "av_opt_set_int_list_js", "av_strdup", "ff_error", "ff_nothing", "LIBAVUTIL_VERSION_INT", "AVDictionaryEntry_key", "AVDictionaryEntry_value", "av_dict_free_js", "av_find_best_stream", "av_find_input_format", "avformat_alloc_context", "avformat_alloc_output_context2_js", "avformat_close_input", "avformat_find_stream_info", "avformat_flush", "avformat_free_context", "avformat_new_stream", "avformat_open_input", "avformat_open_input_js", "avformat_seek_file", "avformat_seek_file_min", "avformat_seek_file_max", "avformat_seek_file_approx", "avformat_write_header", "av_interleaved_write_frame", "avio_open2_js", "avio_close", "avio_flush", "av_read_frame", "av_seek_frame", "av_write_frame", "av_write_trailer", "LIBAVFORMAT_VERSION_INT", "ff_init_muxer", "ff_free_muxer", "ff_get_demuxer_chapters", "ff_init_demuxer_file", "ff_write_multi", "ff_read_frame_multi", "ff_read_multi", "AVFormatContext_chapters_a", "AVFormatContext_chapters_a_s", "AVFormatContext_duration", "AVFormatContext_duration_s", "AVFormatContext_durationhi", "AVFormatContext_durationhi_s", "AVFormatContext_flags", "AVFormatContext_flags_s", "AVFormatContext_metadata", "AVFormatContext_metadata_s", "AVFormatContext_nb_chapters", "AVFormatContext_nb_chapters_s", "AVFormatContext_nb_streams", "AVFormatContext_nb_streams_s", "AVFormatContext_oformat", "AVFormatContext_oformat_s", "AVFormatContext_pb", "AVFormatContext_pb_s", "AVFormatContext_start_time", "AVFormatContext_start_time_s", "AVFormatContext_start_timehi", "AVFormatContext_start_timehi_s", "AVFormatContext_streams_a", "AVFormatContext_streams_a_s", "AVStream_codecpar", "AVStream_codecpar_s", "AVStream_discard", "AVStream_discard_s", "AVStream_duration", "AVStream_duration_s", "AVStream_durationhi", "AVStream_durationhi_s", "AVStream_metadata", "AVStream_metadata_s", "AVStream_time_base_num", "AVStream_time_base_den", "AVStream_time_base_num_s", "AVStream_time_base_den_s", "AVStream_time_base_s", "AVChapter_end", "AVChapter_end_s", "AVChapter_endhi", "AVChapter_endhi_s", "AVChapter_id", "AVChapter_id_s", "AVChapter_metadata", "AVChapter_metadata_s", "AVChapter_start", "AVChapter_start_s", "AVChapter_starthi", "AVChapter_starthi_s", "AVChapter_time_base_num", "AVChapter_time_base_den", "AVChapter_time_base_num_s", "AVChapter_time_base_den_s", "AVChapter_time_base_s", "avformat_close_input_js", "avcodec_descriptor_get", "avcodec_descriptor_get_by_name", "avcodec_descriptor_next", "av_grow_packet", "av_packet_alloc", "av_packet_clone", "av_packet_free", "av_packet_make_writable", "av_packet_new_side_data", "av_packet_ref", "av_packet_rescale_ts_js", "AVPacketSideData_data", "AVPacketSideData_size", "AVPacketSideData_type", "av_packet_unref", "av_shrink_packet", "ff_codecpar_new_side_data", "LIBAVCODEC_VERSION_INT", "ff_set_packet", "ff_copyout_packet", "ff_copyout_packet_ptr", "ff_copyin_packet", "ff_copyout_dict", "AVCodecDescriptor_id", "AVCodecDescriptor_id_s", "AVCodecDescriptor_long_name", "AVCodecDescriptor_mime_types_a", "AVCodecDescriptor_mime_types_a_s", "AVCodecDescriptor_name", "AVCodecDescriptor_props", "AVCodecDescriptor_props_s", "AVCodecDescriptor_type", "AVCodecDescriptor_type_s", "AVCodecParameters_bit_rate", "AVCodecParameters_bit_rate_s", "AVCodecParameters_channel_layoutmask", "AVCodecParameters_channel_layoutmask_s", "AVCodecParameters_channels", "AVCodecParameters_channels_s", "AVCodecParameters_ch_layout_nb_channels", "AVCodecParameters_ch_layout_nb_channels_s", "AVCodecParameters_chroma_location", "AVCodecParameters_chroma_location_s", "AVCodecParameters_codec_id", "AVCodecParameters_codec_id_s", "AVCodecParameters_codec_tag", "AVCodecParameters_codec_tag_s", "AVCodecParameters_codec_type", "AVCodecParameters_codec_type_s", "AVCodecParameters_coded_side_data", "AVCodecParameters_coded_side_data_s", "AVCodecParameters_color_primaries", "AVCodecParameters_color_primaries_s", "AVCodecParameters_color_range", "AVCodecParameters_color_range_s", "AVCodecParameters_color_space", "AVCodecParameters_color_space_s", "AVCodecParameters_color_trc", "AVCodecParameters_color_trc_s", "AVCodecParameters_extradata", "AVCodecParameters_extradata_s", "AVCodecParameters_extradata_size", "AVCodecParameters_extradata_size_s", "AVCodecParameters_format", "AVCodecParameters_format_s", "AVCodecParameters_framerate_num", "AVCodecParameters_framerate_den", "AVCodecParameters_framerate_num_s", "AVCodecParameters_framerate_den_s", "AVCodecParameters_framerate_s", "AVCodecParameters_height", "AVCodecParameters_height_s", "AVCodecParameters_level", "AVCodecParameters_level_s", "AVCodecParameters_nb_coded_side_data", "AVCodecParameters_nb_coded_side_data_s", "AVCodecParameters_profile", "AVCodecParameters_profile_s", "AVCodecParameters_sample_rate", "AVCodecParameters_sample_rate_s", "AVCodecParameters_width", "AVCodecParameters_width_s", "AVPacket_data", "AVPacket_data_s", "AVPacket_dts", "AVPacket_dts_s", "AVPacket_dtshi", "AVPacket_dtshi_s", "AVPacket_duration", "AVPacket_duration_s", "AVPacket_durationhi", "AVPacket_durationhi_s", "AVPacket_flags", "AVPacket_flags_s", "AVPacket_pos", "AVPacket_pos_s", "AVPacket_poshi", "AVPacket_poshi_s", "AVPacket_pts", "AVPacket_pts_s", "AVPacket_ptshi", "AVPacket_ptshi_s", "AVPacket_side_data", "AVPacket_side_data_s", "AVPacket_side_data_elems", "AVPacket_side_data_elems_s", "AVPacket_size", "AVPacket_size_s", "AVPacket_stream_index", "AVPacket_stream_index_s", "AVPacket_time_base_num", "AVPacket_time_base_den", "AVPacket_time_base_num_s", "AVPacket_time_base_den_s", "AVPacket_time_base_s", "av_packet_free_js", "avcodec_parameters_free_js", "avcodec_alloc_context3", "avcodec_find_decoder", "avcodec_find_decoder_by_name", "avcodec_find_encoder", "avcodec_find_encoder_by_name", "avcodec_flush_buffers", "avcodec_free_context", "avcodec_get_name", "avcodec_open2", "avcodec_open2_js", "avcodec_parameters_alloc", "avcodec_parameters_copy", "avcodec_parameters_free", "avcodec_parameters_from_context", "avcodec_parameters_to_context", "avcodec_receive_frame", "avcodec_receive_packet", "avcodec_send_frame", "avcodec_send_packet", "ff_init_encoder", "ff_init_decoder", "ff_free_encoder", "ff_free_decoder", "ff_encode_multi", "ff_decode_multi", "ff_copyout_codecpar", "ff_copyin_codecpar", "AVCodec_name", "AVCodec_sample_fmts", "AVCodec_sample_fmts_s", "AVCodec_sample_fmts_a", "AVCodec_sample_fmts_a_s", "AVCodec_supported_samplerates", "AVCodec_supported_samplerates_s", "AVCodec_supported_samplerates_a", "AVCodec_supported_samplerates_a_s", "AVCodec_type", "AVCodec_type_s", "AVCodecContext_codec_id", "AVCodecContext_codec_id_s", "AVCodecContext_codec_type", "AVCodecContext_codec_type_s", "AVCodecContext_bit_rate", "AVCodecContext_bit_rate_s", "AVCodecContext_bit_ratehi", "AVCodecContext_bit_ratehi_s", "AVCodecContext_channel_layout", "AVCodecContext_channel_layout_s", "AVCodecContext_channel_layouthi", "AVCodecContext_channel_layouthi_s", "AVCodecContext_channels", "AVCodecContext_channels_s", "AVCodecContext_channel_layoutmask", "AVCodecContext_channel_layoutmask_s", "AVCodecContext_ch_layout_nb_channels", "AVCodecContext_ch_layout_nb_channels_s", "AVCodecContext_coded_side_data", "AVCodecContext_coded_side_data_s", "AVCodecContext_compression_level", "AVCodecContext_compression_level_s", "AVCodecContext_extradata", "AVCodecContext_extradata_s", "AVCodecContext_extradata_size", "AVCodecContext_extradata_size_s", "AVCodecContext_frame_size", "AVCodecContext_frame_size_s", "AVCodecContext_framerate_num", "AVCodecContext_framerate_den", "AVCodecContext_framerate_num_s", "AVCodecContext_framerate_den_s", "AVCodecContext_framerate_s", "AVCodecContext_gop_size", "AVCodecContext_gop_size_s", "AVCodecContext_height", "AVCodecContext_height_s", "AVCodecContext_keyint_min", "AVCodecContext_keyint_min_s", "AVCodecContext_level", "AVCodecContext_level_s", "AVCodecContext_max_b_frames", "AVCodecContext_max_b_frames_s", "AVCodecContext_nb_coded_side_data", "AVCodecContext_nb_coded_side_data_s", "AVCodecContext_pix_fmt", "AVCodecContext_pix_fmt_s", "AVCodecContext_profile", "AVCodecContext_profile_s", "AVCodecContext_rc_max_rate", "AVCodecContext_rc_max_rate_s", "AVCodecContext_rc_max_ratehi", "AVCodecContext_rc_max_ratehi_s", "AVCodecContext_rc_min_rate", "AVCodecContext_rc_min_rate_s", "AVCodecContext_rc_min_ratehi", "AVCodecContext_rc_min_ratehi_s", "AVCodecContext_sample_aspect_ratio_num", "AVCodecContext_sample_aspect_ratio_den", "AVCodecContext_sample_aspect_ratio_num_s", "AVCodecContext_sample_aspect_ratio_den_s", "AVCodecContext_sample_aspect_ratio_s", "AVCodecContext_sample_fmt", "AVCodecContext_sample_fmt_s", "AVCodecContext_sample_rate", "AVCodecContext_sample_rate_s", "AVCodecContext_strict_std_compliance", "AVCodecContext_strict_std_compliance_s", "AVCodecContext_time_base_num", "AVCodecContext_time_base_den", "AVCodecContext_time_base_num_s", "AVCodecContext_time_base_den_s", "AVCodecContext_time_base_s", "AVCodecContext_pkt_timebase_num", "AVCodecContext_pkt_timebase_den", "AVCodecContext_pkt_timebase_num_s", "AVCodecContext_pkt_timebase_den_s", "AVCodecContext_pkt_timebase_s", "AVCodecContext_qmax", "AVCodecContext_qmax_s", "AVCodecContext_qmin", "AVCodecContext_qmin_s", "AVCodecContext_width", "AVCodecContext_width_s", "avcodec_free_context_js", "av_frame_alloc", "av_frame_clone", "av_frame_free", "av_frame_get_buffer", "av_frame_make_writable", "av_frame_ref", "av_frame_unref", "av_get_bytes_per_sample", "av_get_sample_fmt_name", "av_pix_fmt_desc_get", "AVPixFmtDescriptor_comp_depth", "ff_frame_rescale_ts_js", "ff_copyout_frame", "ff_copyout_frame_video", "ff_frame_video_packed_size", "ff_copyout_frame_video_packed", "ff_copyout_frame_video_imagedata", "ff_copyout_frame_ptr", "ff_copyin_frame", "AVFrame_channel_layout", "AVFrame_channel_layout_s", "AVFrame_channel_layouthi", "AVFrame_channel_layouthi_s", "AVFrame_channels", "AVFrame_channels_s", "AVFrame_channel_layoutmask", "AVFrame_channel_layoutmask_s", "AVFrame_ch_layout_nb_channels", "AVFrame_ch_layout_nb_channels_s", "AVFrame_crop_bottom", "AVFrame_crop_bottom_s", "AVFrame_crop_left", "AVFrame_crop_left_s", "AVFrame_crop_right", "AVFrame_crop_right_s", "AVFrame_crop_top", "AVFrame_crop_top_s", "AVFrame_data_a", "AVFrame_data_a_s", "AVFrame_duration", "AVFrame_duration_s", "AVFrame_flags", "AVFrame_flags_s", "AVFrame_format", "AVFrame_format_s", "AVFrame_height", "AVFrame_height_s", "AVFrame_key_frame", "AVFrame_key_frame_s", "AVFrame_linesize_a", "AVFrame_linesize_a_s", "AVFrame_nb_samples", "AVFrame_nb_samples_s", "AVFrame_pict_type", "AVFrame_pict_type_s", "AVFrame_pts", "AVFrame_pts_s", "AVFrame_ptshi", "AVFrame_ptshi_s", "AVFrame_best_effort_timestamp", "AVFrame_best_effort_timestamp_s", "AVFrame_best_effort_timestamphi", "AVFrame_best_effort_timestamphi_s", "AVFrame_sample_aspect_ratio_num", "AVFrame_sample_aspect_ratio_den", "AVFrame_sample_aspect_ratio_num_s", "AVFrame_sample_aspect_ratio_den_s", "AVFrame_sample_aspect_ratio_s", "AVFrame_sample_rate", "AVFrame_sample_rate_s", "AVFrame_time_base_num", "AVFrame_time_base_den", "AVFrame_time_base_num_s", "AVFrame_time_base_den_s", "AVFrame_time_base_s", "AVFrame_width", "AVFrame_width_s", "AVPixFmtDescriptor_flags", "AVPixFmtDescriptor_flags_s", "AVPixFmtDescriptor_log2_chroma_h", "AVPixFmtDescriptor_log2_chroma_h_s", "AVPixFmtDescriptor_log2_chroma_w", "AVPixFmtDescriptor_log2_chroma_w_s", "AVPixFmtDescriptor_nb_components", "AVPixFmtDescriptor_nb_components_s", "av_frame_free_js", "av_buffersink_get_frame", "av_buffersink_get_time_base_num", "av_buffersink_get_time_base_den", "av_buffersink_set_frame_size", "ff_buffersink_set_ch_layout", "av_buffersrc_add_frame_flags", "avfilter_free", "avfilter_get_by_name", "avfilter_graph_alloc", "avfilter_graph_config", "avfilter_graph_create_filter_js", "avfilter_graph_free", "avfilter_graph_parse", "avfilter_inout_alloc", "avfilter_inout_free", "avfilter_link", "LIBAVFILTER_VERSION_INT", "ff_init_filter_graph", "ff_filter_multi", "ff_decode_filter_multi", "AVFilterInOut_filter_ctx", "AVFilterInOut_filter_ctx_s", "AVFilterInOut_name", "AVFilterInOut_name_s", "AVFilterInOut_next", "AVFilterInOut_next_s", "AVFilterInOut_pad_idx", "AVFilterInOut_pad_idx_s", "avfilter_graph_free_js", "avfilter_inout_free_js"];
          var localFuncs = ["copyin_u8", "copyout_u8", "copyin_s16", "copyout_s16", "copyin_s32", "copyout_s32", "copyin_f32", "copyout_f32", "createLazyFile", "ff_block_reader_dev_send", "ff_reader_dev_send", "ff_reader_dev_waiting", "mkblockreaderdev", "mkdev", "mkfsfhfile", "mkreadaheadfile", "mkreaderdev", "mkstreamwriterdev", "mkworkerfsfile", "mkwriterdev", "mountwriterfs", "readFile", "unlink", "unlinkfsfhfile", "unlinkreadaheadfile", "unlinkworkerfsfile", "unmount", "writeFile"];
          ret.libavjsMode = mode;
          if (mode === "worker") {
            indirectors(funcs);
            indirectors(localFuncs);
          } else if (mode === "threads") {
            indirectors(funcs);
            directs(localFuncs);
          } else {
            directs(funcs);
            directs(localFuncs);
          }
          Object.assign(ret, libavStatics);
          return ret;
        }));
      };
    })();
    ({ base, isWebAssemblySupported, isThreadingSupported, target: target2, VER, CONFIG, DBG, factories, i64tof64, f64toi64, i64ToBigInt, bigIntToi64, ff_channel_layout, ff_channels, AV_VERSION_INT, AV_TIME_BASE, AV_NOPTS_VALUE_I64, AV_NOPTS_VALUE_LO, AV_NOPTS_VALUE_HI, AV_NOPTS_VALUE, AV_OPT_SEARCH_CHILDREN, AVMEDIA_TYPE_UNKNOWN, AVMEDIA_TYPE_VIDEO, AVMEDIA_TYPE_AUDIO, AVMEDIA_TYPE_DATA, AVMEDIA_TYPE_SUBTITLE, AVMEDIA_TYPE_ATTACHMENT, AV_SAMPLE_FMT_NONE, AV_SAMPLE_FMT_U8, AV_SAMPLE_FMT_S16, AV_SAMPLE_FMT_S32, AV_SAMPLE_FMT_FLT, AV_SAMPLE_FMT_DBL, AV_SAMPLE_FMT_U8P, AV_SAMPLE_FMT_S16P, AV_SAMPLE_FMT_S32P, AV_SAMPLE_FMT_FLTP, AV_SAMPLE_FMT_DBLP, AV_SAMPLE_FMT_S64, AV_SAMPLE_FMT_S64P, AV_SAMPLE_FMT_NB, AV_PIX_FMT_NONE, AV_PIX_FMT_YUV420P, AV_PIX_FMT_YUYV422, AV_PIX_FMT_RGB24, AV_PIX_FMT_BGR24, AV_PIX_FMT_YUV422P, AV_PIX_FMT_YUV444P, AV_PIX_FMT_YUV410P, AV_PIX_FMT_YUV411P, AV_PIX_FMT_GRAY8, AV_PIX_FMT_MONOWHITE, AV_PIX_FMT_MONOBLACK, AV_PIX_FMT_PAL8, AV_PIX_FMT_YUVJ420P, AV_PIX_FMT_YUVJ422P, AV_PIX_FMT_YUVJ444P, AV_PIX_FMT_UYVY422, AV_PIX_FMT_UYYVYY411, AV_PIX_FMT_BGR8, AV_PIX_FMT_BGR4, AV_PIX_FMT_BGR4_BYTE, AV_PIX_FMT_RGB8, AV_PIX_FMT_RGB4, AV_PIX_FMT_RGB4_BYTE, AV_PIX_FMT_NV12, AV_PIX_FMT_NV21, AV_PIX_FMT_ARGB, AV_PIX_FMT_RGBA, AV_PIX_FMT_ABGR, AV_PIX_FMT_BGRA, AV_PIX_FMT_GRAY16BE, AV_PIX_FMT_GRAY16LE, AV_PIX_FMT_YUV440P, AV_PIX_FMT_YUVJ440P, AV_PIX_FMT_YUVA420P, AV_PIX_FMT_RGB48BE, AV_PIX_FMT_RGB48LE, AV_PIX_FMT_RGB565BE, AV_PIX_FMT_RGB565LE, AV_PIX_FMT_RGB555BE, AV_PIX_FMT_RGB555LE, AV_PIX_FMT_BGR565BE, AV_PIX_FMT_BGR565LE, AV_PIX_FMT_BGR555BE, AV_PIX_FMT_BGR555LE, AVIO_FLAG_READ, AVIO_FLAG_WRITE, AVIO_FLAG_READ_WRITE, AVIO_FLAG_NONBLOCK, AVIO_FLAG_DIRECT, AVFMT_FLAG_NOBUFFER, AVFMT_FLAG_FLUSH_PACKETS, AVSEEK_FLAG_BACKWARD, AVSEEK_FLAG_BYTE, AVSEEK_FLAG_ANY, AVSEEK_FLAG_FRAME, AVDISCARD_NONE, AVDISCARD_DEFAULT, AVDISCARD_NONREF, AVDISCARD_BIDIR, AVDISCARD_NONINTRA, AVDISCARD_NONKEY, AVDISCARD_ALL, AV_LOG_QUIET, AV_LOG_PANIC, AV_LOG_FATAL, AV_LOG_ERROR, AV_LOG_WARNING, AV_LOG_INFO, AV_LOG_VERBOSE, AV_LOG_DEBUG, AV_LOG_TRACE, AV_PKT_FLAG_KEY, AV_PKT_FLAG_CORRUPT, AV_PKT_FLAG_DISCARD, AV_PKT_FLAG_TRUSTED, AV_PKT_FLAG_DISPOSABLE, E2BIG, EPERM, EADDRINUSE, EADDRNOTAVAIL, EAFNOSUPPORT, EAGAIN, EALREADY, EBADF, EBADMSG, EBUSY, ECANCELED, ECHILD, ECONNABORTED, ECONNREFUSED, ECONNRESET, EDEADLOCK, EDESTADDRREQ, EDOM, EDQUOT, EEXIST, EFAULT, EFBIG, EHOSTUNREACH, EIDRM, EILSEQ, EINPROGRESS, EINTR, EINVAL, EIO, EISCONN, EISDIR, ELOOP, EMFILE, EMLINK, EMSGSIZE, EMULTIHOP, ENAMETOOLONG, ENETDOWN, ENETRESET, ENETUNREACH, ENFILE, ENOBUFS, ENODEV, ENOENT, AVERROR_EOF, LibAV: LibAV2 } = libav);
    libav_opus_af_default = libav;
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/encoded-audio-chunk.js
var EncodedAudioChunk2;
var init_encoded_audio_chunk = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/encoded-audio-chunk.js"() {
    EncodedAudioChunk2 = class {
      constructor(init) {
        {
          this.type = init.type;
          this.timestamp = init.timestamp;
          if (typeof init.duration === "number")
            this.duration = init.duration;
          else
            this.duration = null;
          this.byteLength = init.data.byteLength;
          let transfer = false;
          if (init.transfer) {
            let inBuffer;
            if (init.data.buffer)
              inBuffer = init.data.buffer;
            else
              inBuffer = init.data;
            let t;
            if (init.transfer instanceof Array)
              t = init.transfer;
            else
              t = Array.from(init.transfer);
            for (const b3 of t) {
              if (b3 === inBuffer) {
                transfer = true;
                break;
              }
            }
          }
          const data = new Uint8Array(init.data.buffer || init.data, init.data.byteOffset || 0, init.data.BYTES_PER_ELEMENT ? init.data.BYTES_PER_ELEMENT * init.data.length : init.data.byteLength);
          if (transfer)
            this._data = data;
          else
            this._data = data.slice(0);
        }
      }
      // Internal
      _libavGetData() {
        return this._data;
      }
      copyTo(destination) {
        new Uint8Array(destination.buffer || destination, destination.byteOffset || 0).set(this._data);
      }
    };
  }
});

// ../../node_modules/@ungap/global-this/esm/index.js
var init_esm = __esm({
  "../../node_modules/@ungap/global-this/esm/index.js"() {
    (function(Object2) {
      typeof globalThis !== "object" && (this ? get2() : (Object2.defineProperty(Object2.prototype, "_T_", {
        configurable: true,
        get: get2
      }), _T_));
      function get2() {
        var global = this || self;
        global.globalThis = global;
        delete Object2.prototype._T_;
      }
    })(Object);
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/audio-data.js
function audioView(format, buffer, byteOffset) {
  switch (format) {
    case "u8":
    case "u8-planar":
      return new Uint8Array(buffer, byteOffset);
    case "s16":
    case "s16-planar":
      return new Int16Array(buffer, byteOffset);
    case "s32":
    case "s32-planar":
      return new Int32Array(buffer, byteOffset);
    case "f32":
    case "f32-planar":
      return new Float32Array(buffer, byteOffset);
    default:
      throw new TypeError("Invalid AudioSampleFormat");
  }
}
function bytesPerSample(format) {
  switch (format) {
    case "u8":
    case "u8-planar":
      return 1;
    case "s16":
    case "s16-planar":
      return 2;
    case "s32":
    case "s32-planar":
    case "f32":
    case "f32-planar":
      return 4;
    default:
      throw new TypeError("Invalid AudioSampleFormat");
  }
}
function isInterleaved(format) {
  switch (format) {
    case "u8":
    case "s16":
    case "s32":
    case "f32":
      return true;
    case "u8-planar":
    case "s16-planar":
    case "s32-planar":
    case "f32-planar":
      return false;
    default:
      throw new TypeError("Invalid AudioSampleFormat");
  }
}
var AudioData2;
var init_audio_data = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/audio-data.js"() {
    init_esm();
    AudioData2 = class _AudioData {
      constructor(init) {
        _AudioData._checkValidAudioDataInit(init);
        {
          this.format = init.format;
          this.sampleRate = init.sampleRate;
          this.numberOfFrames = init.numberOfFrames;
          this.numberOfChannels = init.numberOfChannels;
          this.timestamp = init.timestamp;
          let transfer = false;
          if (init.transfer) {
            let inBuffer;
            if (init.data.buffer)
              inBuffer = init.data.buffer;
            else
              inBuffer = init.data;
            let t;
            if (init.transfer instanceof Array)
              t = init.transfer;
            else
              t = Array.from(init.transfer);
            for (const b3 of t) {
              if (b3 === inBuffer) {
                transfer = true;
                break;
              }
            }
          }
          let inData, byteOffset = 0;
          if (transfer) {
            inData = init.data;
            byteOffset = init.data.byteOffset || 0;
          } else {
            inData = init.data.slice(0);
          }
          const resourceReference = audioView(init.format, inData.buffer || inData, byteOffset);
          this._data = resourceReference;
        }
        this.duration = init.numberOfFrames / init.sampleRate * 1e6;
      }
      /**
       * Convert a polyfill AudioData to a native AudioData.
       * @param opts  Conversion options
       */
      toNative(opts = {}) {
        const ret = new globalThis.AudioData({
          data: this._data,
          format: this.format,
          sampleRate: this.sampleRate,
          numberOfFrames: this.numberOfFrames,
          numberOfChannels: this.numberOfChannels,
          timestamp: this.timestamp,
          transfer: opts.transfer ? [this._data.buffer] : []
        });
        if (opts.transfer)
          this.close();
        return ret;
      }
      /**
       * Convert a native AudioData to a polyfill AudioData. WARNING: Inefficient,
       * as the data cannot be transferred out.
       * @param from  AudioData to copy in
       */
      static fromNative(from2) {
        const ad = from2;
        const isInterleaved_ = isInterleaved(ad.format);
        const planes = isInterleaved_ ? 1 : ad.numberOfChannels;
        const sizePerPlane = ad.allocationSize({
          format: ad.format,
          planeIndex: 0
        });
        const data = new Uint8Array(sizePerPlane * planes);
        for (let p3 = 0; p3 < planes; p3++) {
          ad.copyTo(data.subarray(p3 * sizePerPlane), {
            format: ad.format,
            planeIndex: p3
          });
        }
        return new _AudioData({
          data,
          format: ad.format,
          sampleRate: ad.sampleRate,
          numberOfFrames: ad.numberOfFrames,
          numberOfChannels: ad.numberOfChannels,
          timestamp: ad.timestamp,
          transfer: [data.buffer]
        });
      }
      // Internal
      _libavGetData() {
        return this._data;
      }
      static _checkValidAudioDataInit(init) {
        if (init.sampleRate <= 0)
          throw new TypeError(`Invalid sample rate ${init.sampleRate}`);
        if (init.numberOfFrames <= 0)
          throw new TypeError(`Invalid number of frames ${init.numberOfFrames}`);
        if (init.numberOfChannels <= 0)
          throw new TypeError(`Invalid number of channels ${init.numberOfChannels}`);
        {
          const totalSamples = init.numberOfFrames * init.numberOfChannels;
          const bytesPerSample_ = bytesPerSample(init.format);
          const totalSize = bytesPerSample_ * totalSamples;
          const dataSize = init.data.byteLength;
          if (dataSize < totalSize)
            throw new TypeError(`This audio data must be at least ${totalSize} bytes`);
        }
      }
      allocationSize(options) {
        if (this._data === null)
          throw new DOMException("Detached", "InvalidStateError");
        const copyElementCount = this._computeCopyElementCount(options);
        let destFormat = this.format;
        if (options.format)
          destFormat = options.format;
        const bytesPerSample_ = bytesPerSample(destFormat);
        return bytesPerSample_ * copyElementCount;
      }
      _computeCopyElementCount(options) {
        let destFormat = this.format;
        if (options.format)
          destFormat = options.format;
        const isInterleaved_ = isInterleaved(destFormat);
        if (isInterleaved_) {
          if (options.planeIndex > 0)
            throw new RangeError("Invalid plane");
        } else if (options.planeIndex >= this.numberOfChannels)
          throw new RangeError("Invalid plane");
        if (this.format !== destFormat && destFormat !== "f32-planar")
          throw new DOMException("Only conversion to f32-planar is supported", "NotSupportedError");
        const frameCount = this.numberOfFrames;
        const frameOffset = options.frameOffset || 0;
        if (frameOffset >= frameCount)
          throw new RangeError("Frame offset out of range");
        let copyFrameCount = frameCount - frameOffset;
        if (typeof options.frameCount === "number") {
          if (options.frameCount > copyFrameCount)
            throw new RangeError("Frame count out of range");
          copyFrameCount = options.frameCount;
        }
        let elementCount = copyFrameCount;
        if (isInterleaved_)
          elementCount *= this.numberOfChannels;
        return elementCount;
      }
      copyTo(destination, options) {
        if (this._data === null)
          throw new DOMException("Detached", "InvalidStateError");
        const copyElementCount = this._computeCopyElementCount(options);
        let destFormat = this.format;
        if (options.format)
          destFormat = options.format;
        const bytesPerSample_ = bytesPerSample(destFormat);
        if (bytesPerSample_ * copyElementCount > destination.byteLength)
          throw new RangeError("Buffer too small");
        const resource = this._data;
        const planeFrames = isInterleaved(this.format) ? resource : resource.subarray(options.planeIndex * this.numberOfFrames);
        const frameOffset = options.frameOffset || 0;
        const numberOfChannels = this.numberOfChannels;
        if (this.format === destFormat) {
          const dest = audioView(destFormat, destination.buffer || destination, destination.byteOffset || 0);
          if (isInterleaved(destFormat)) {
            dest.set(planeFrames.subarray(frameOffset * numberOfChannels, frameOffset * numberOfChannels + copyElementCount));
          } else {
            dest.set(planeFrames.subarray(frameOffset, frameOffset + copyElementCount));
          }
        } else {
          const out = audioView(destFormat, destination.buffer || destination, destination.byteOffset || 0);
          let sub = 0;
          let div = 1;
          switch (this.format) {
            case "u8":
            case "u8-planar":
              sub = 128;
              div = 128;
              break;
            case "s16":
            case "s16-planar":
              div = 32768;
              break;
            case "s32":
            case "s32-planar":
              div = 2147483648;
              break;
          }
          if (isInterleaved(this.format)) {
            for (let i2 = options.planeIndex + frameOffset * numberOfChannels, o = 0; o < copyElementCount; i2 += numberOfChannels, o++)
              out[o] = (planeFrames[i2] - sub) / div;
          } else {
            for (let i2 = frameOffset, o = 0; o < copyElementCount; i2++, o++)
              out[o] = (planeFrames[i2] - sub) / div;
          }
        }
      }
      clone() {
        if (this._data === null)
          throw new DOMException("Detached", "InvalidStateError");
        return new _AudioData({
          format: this.format,
          sampleRate: this.sampleRate,
          numberOfFrames: this.numberOfFrames,
          numberOfChannels: this.numberOfChannels,
          timestamp: this.timestamp,
          data: this._data
        });
      }
      close() {
        this._data = null;
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/event-target.js
var HasAEventTarget, DequeueEventTarget;
var init_event_target = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/event-target.js"() {
    HasAEventTarget = class {
      constructor() {
        const ev = this._eventer = new EventTarget();
        this.addEventListener = ev.addEventListener.bind(ev);
        this.removeEventListener = ev.removeEventListener.bind(ev);
        this.dispatchEvent = ev.dispatchEvent.bind(ev);
      }
    };
    DequeueEventTarget = class extends HasAEventTarget {
      constructor() {
        super();
        this.addEventListener("dequeue", (ev) => {
          if (this.ondequeue)
            this.ondequeue(ev);
        });
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/avloader.js
function setLibAV(to) {
  LibAVWrapper = to;
}
function setLibAVOptions(to) {
  libavOptions = to;
}
function get() {
  return __awaiter(this, void 0, void 0, function* () {
    if (libavs.length)
      return libavs.shift();
    return yield LibAVWrapper.LibAV(libavOptions);
  });
}
function free(libav2) {
  libavs.push(libav2);
}
function codecs(encoders2) {
  return __awaiter(this, void 0, void 0, function* () {
    const libav2 = yield get();
    const ret = [];
    for (const [avname, codec] of [
      ["flac", "flac"],
      ["libopus", "opus"],
      ["libvorbis", "vorbis"],
      ["libaom-av1", "av01"],
      ["libvpx-vp9", "vp09"],
      ["libvpx", "vp8"]
    ]) {
      if (encoders2) {
        if (yield libav2.avcodec_find_encoder_by_name(avname))
          ret.push(codec);
      } else {
        if (yield libav2.avcodec_find_decoder_by_name(avname))
          ret.push(codec);
      }
    }
    free(libav2);
    return ret;
  });
}
function load() {
  return __awaiter(this, void 0, void 0, function* () {
    LibAVWrapper = LibAVWrapper || LibAV;
    decoders = yield codecs(false);
    encoders = yield codecs(true);
  });
}
function decoder2(codec, config2) {
  if (typeof codec === "string") {
    codec = codec.replace(/\..*/, "");
    let outCodec = codec;
    switch (codec) {
      // Audio
      case "flac":
        if (typeof config2.description === "undefined") {
          return null;
        }
        break;
      case "opus":
        if (typeof config2.description !== "undefined") {
          return null;
        }
        outCodec = "libopus";
        break;
      case "vorbis":
        if (typeof config2.description === "undefined") {
          return null;
        }
        outCodec = "libvorbis";
        break;
      // Video
      case "av01":
        outCodec = "libaom-av1";
        break;
      case "vp09":
        outCodec = "libvpx-vp9";
        break;
      case "vp8":
        outCodec = "libvpx";
        break;
      // Unsupported
      case "mp3":
      case "mp4a":
      case "ulaw":
      case "alaw":
      case "avc1":
      case "avc3":
      case "hev1":
      case "hvc1":
        return null;
      // Unrecognized
      default:
        throw new TypeError("Unrecognized codec");
    }
    if (!(decoders.indexOf(codec) >= 0))
      return null;
    return { codec: outCodec };
  } else {
    return codec.libavjs;
  }
}
function encoder(codec, config2) {
  if (typeof codec === "string") {
    const codecParts = codec.split(".");
    codec = codecParts[0];
    let outCodec = codec;
    const ctx = {};
    const options = {};
    let video = false;
    switch (codec) {
      // Audio
      case "flac":
        ctx.sample_fmt = 2;
        ctx.bit_rate = 0;
        if (typeof config2.flac === "object" && config2.flac !== null) {
          const flac = config2.flac;
          if (typeof flac.blockSize === "number")
            ctx.frame_size = flac.blockSize;
          if (typeof flac.compressLevel === "number") {
            return null;
          }
        }
        break;
      case "opus":
        outCodec = "libopus";
        ctx.sample_fmt = 3;
        ctx.sample_rate = 48e3;
        if (typeof config2.opus === "object" && config2.opus !== null) {
          const opus = config2.opus;
          if (typeof opus.frameDuration === "number")
            options.frame_duration = "" + opus.frameDuration / 1e3;
          if (typeof opus.complexity !== "undefined") {
            return null;
          }
          if (typeof opus.packetlossperc === "number") {
            if (opus.packetlossperc < 0 || opus.packetlossperc > 100)
              return null;
            options.packet_loss = "" + opus.packetlossperc;
          }
          if (typeof opus.useinbandfec === "boolean")
            options.fec = opus.useinbandfec ? "1" : "0";
          if (typeof opus.usedtx === "boolean") {
            return null;
          }
          if (typeof opus.format === "string") {
            if (opus.format !== "opus")
              return null;
          }
        }
        break;
      case "vorbis":
        outCodec = "libvorbis";
        ctx.sample_fmt = 8;
        break;
      // Video
      case "av01":
        video = true;
        outCodec = "libaom-av1";
        if (config2.latencyMode === "realtime") {
          options.usage = "realtime";
          options["cpu-used"] = "8";
        }
        if (!av1Advanced(codecParts, ctx))
          return null;
        break;
      case "vp09":
        video = true;
        outCodec = "libvpx-vp9";
        if (config2.latencyMode === "realtime") {
          options.quality = "realtime";
          options["cpu-used"] = "8";
        }
        if (!vp9Advanced(codecParts, ctx))
          return null;
        break;
      case "vp8":
        video = true;
        outCodec = "libvpx";
        if (config2.latencyMode === "realtime") {
          options.quality = "realtime";
          options["cpu-used"] = "8";
        }
        break;
      // Unsupported
      case "mp3":
      case "mp4a":
      case "ulaw":
      case "alaw":
      case "avc1":
        return null;
      // Unrecognized
      default:
        throw new TypeError("Unrecognized codec");
    }
    if (!(encoders.indexOf(codec) >= 0))
      return null;
    if (video) {
      if (typeof ctx.pix_fmt !== "number")
        ctx.pix_fmt = 0;
      const width = ctx.width = config2.width;
      const height = ctx.height = config2.height;
      if (config2.framerate) {
        ctx.framerate_num = Math.round(config2.framerate);
        ctx.framerate_den = 1;
      }
      const dWidth = config2.displayWidth || config2.width;
      const dHeight = config2.displayHeight || config2.height;
      if (dWidth !== width || dHeight !== height) {
        ctx.sample_aspect_ratio_num = dWidth * height;
        ctx.sample_aspect_ratio_den = dHeight * width;
      }
    } else {
      if (!ctx.sample_rate)
        ctx.sample_rate = config2.sampleRate || 48e3;
      if (config2.numberOfChannels) {
        const n2 = config2.numberOfChannels;
        ctx.channel_layout = n2 === 1 ? 4 : (1 << n2) - 1;
      }
    }
    if (typeof ctx.bit_rate !== "number" && config2.bitrate) {
      ctx.bit_rate = config2.bitrate;
    }
    return {
      codec: outCodec,
      ctx,
      options
    };
  } else {
    return codec.libavjs;
  }
}
function av1Advanced(codecParts, ctx) {
  if (codecParts[1]) {
    const profile = +codecParts[1];
    if (profile >= 0 && profile <= 2)
      ctx.profile = profile;
    else
      throw new TypeError("Invalid AV1 profile");
  }
  if (codecParts[2]) {
    const level = +codecParts[2];
    if (level >= 0 && level <= 23)
      ctx.level = level;
    else
      throw new TypeError("Invalid AV1 level");
  }
  if (codecParts[3]) {
    switch (codecParts[3]) {
      case "M":
        break;
      case "H":
        if (ctx.level && ctx.level >= 8) {
          return false;
        } else {
          throw new TypeError("The AV1 high tier is only available for level 4.0 and up");
        }
        break;
      default:
        throw new TypeError("Invalid AV1 tier");
    }
  }
  if (codecParts[4]) {
    const depth = +codecParts[3];
    if (depth === 10 || depth === 12) {
      return false;
    } else if (depth !== 8) {
      throw new TypeError("Invalid AV1 bit depth");
    }
  }
  if (codecParts[5]) {
    switch (codecParts[5]) {
      case "0":
        break;
      case "1":
        return false;
      default:
        throw new TypeError("Invalid AV1 monochrome flag");
    }
  }
  if (codecParts[6]) {
    switch (codecParts[6]) {
      case "000":
        ctx.pix_fmt = 5;
        break;
      case "100":
        ctx.pix_fmt = 4;
        break;
      case "110":
        ctx.pix_fmt = 0;
        break;
      case "111":
        return false;
      default:
        throw new TypeError("Invalid AV1 subsampling mode");
    }
  }
  return true;
}
function vp9Advanced(codecParts, ctx) {
  if (codecParts[1]) {
    const profile = +codecParts[1];
    if (profile >= 0 && profile <= 3)
      ctx.profile = profile;
    else
      throw new TypeError("Invalid VP9 profile");
  }
  if (codecParts[2]) {
    const level = [+codecParts[2][0], +codecParts[2][1]];
    if (level[0] >= 1 && level[0] <= 4) {
      if (level[1] >= 0 && level[1] <= 1) {
      } else {
        throw new TypeError("Invalid VP9 level");
      }
    } else if (level[0] >= 5 && level[0] <= 6) {
      if (level[1] >= 0 && level[1] <= 2) {
      } else {
        throw new TypeError("Invalid VP9 level");
      }
    } else {
      throw new TypeError("Invalid VP9 level");
    }
    ctx.level = +codecParts[2];
  }
  if (codecParts[3]) {
    const depth = +codecParts[3];
    if (depth === 10 || depth === 12) {
      return false;
    } else if (depth !== 8) {
      throw new TypeError("Invalid VP9 bit depth");
    }
  }
  if (codecParts[4]) {
    const chromaMode = +codecParts[4];
    switch (chromaMode) {
      case 0:
      case 1:
        ctx.pix_fmt = 0;
        break;
      case 2:
        ctx.pix_fmt = 4;
        break;
      case 3:
        ctx.pix_fmt = 5;
        break;
      default:
        throw new TypeError("Invalid VP9 chroma subsampling format");
    }
  }
  return true;
}
var __awaiter, LibAVWrapper, libavs, libavOptions, decoders, encoders;
var init_avloader = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/avloader.js"() {
    __awaiter = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    LibAVWrapper = null;
    libavs = [];
    libavOptions = {};
    decoders = null;
    encoders = null;
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/misc.js
function cloneConfig(config2, fields) {
  const ret = {};
  for (const field of fields) {
    if (field in config2)
      ret[field] = config2[field];
  }
  return ret;
}
var init_misc = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/misc.js"() {
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/audio-decoder.js
var __awaiter2, AudioDecoder2;
var init_audio_decoder = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/audio-decoder.js"() {
    init_audio_data();
    init_event_target();
    init_avloader();
    init_misc();
    __awaiter2 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    AudioDecoder2 = class extends DequeueEventTarget {
      constructor(init) {
        super();
        this._p = Promise.all([]);
        this._libav = null;
        this._codec = this._c = this._pkt = this._frame = 0;
        this._output = init.output;
        this._error = init.error;
        this.state = "unconfigured";
        this.decodeQueueSize = 0;
      }
      configure(config2) {
        if (this.state === "closed")
          throw new DOMException("Decoder is closed", "InvalidStateError");
        if (this._libav)
          this._p = this._p.then(() => this._free());
        this.state = "configured";
        this._p = this._p.then(() => __awaiter2(this, void 0, void 0, function* () {
          let udesc = void 0;
          if (config2.description) {
            if (ArrayBuffer.isView(config2.description)) {
              const descView = config2.description;
              udesc = new Uint8Array(descView.buffer, descView.byteOffset, descView.byteLength);
            } else {
              const descBuf = config2.description;
              udesc = new Uint8Array(descBuf);
            }
          }
          const supported2 = decoder2(config2.codec, config2);
          if (!supported2) {
            this._closeAudioDecoder(new DOMException("Unsupported codec", "NotSupportedError"));
            return;
          }
          const libav2 = this._libav = yield get();
          const codecpara = yield libav2.avcodec_parameters_alloc();
          const ps = [
            libav2.AVCodecParameters_channels_s(codecpara, config2.numberOfChannels),
            libav2.AVCodecParameters_sample_rate_s(codecpara, config2.sampleRate),
            libav2.AVCodecParameters_codec_type_s(
              codecpara,
              1
              /*  AVMEDIA_TYPE_AUDIO */
            )
          ];
          let extraDataPtr = 0;
          if (!udesc) {
            ps.push(libav2.AVCodecParameters_extradata_s(codecpara, 0));
            ps.push(libav2.AVCodecParameters_extradata_size_s(codecpara, 0));
          } else {
            ps.push(libav2.AVCodecParameters_extradata_size_s(codecpara, udesc.byteLength));
            extraDataPtr = yield libav2.calloc(udesc.byteLength + 64, 1);
            ps.push(libav2.copyin_u8(extraDataPtr, udesc));
            ps.push(libav2.AVCodecParameters_extradata_s(codecpara, extraDataPtr));
          }
          yield Promise.all(ps);
          [this._codec, this._c, this._pkt, this._frame] = yield libav2.ff_init_decoder(supported2.codec, codecpara);
          const fps = [
            libav2.AVCodecContext_time_base_s(this._c, 1, 1e3),
            libav2.avcodec_parameters_free_js(codecpara)
          ];
          if (extraDataPtr)
            fps.push(libav2.free(extraDataPtr));
          yield Promise.all(fps);
        })).catch(this._error);
      }
      // Our own algorithm, close libav
      _free() {
        return __awaiter2(this, void 0, void 0, function* () {
          if (this._c) {
            yield this._libav.ff_free_decoder(this._c, this._pkt, this._frame);
            this._codec = this._c = this._pkt = this._frame = 0;
          }
          if (this._libav) {
            free(this._libav);
            this._libav = null;
          }
        });
      }
      _closeAudioDecoder(exception) {
        this._resetAudioDecoder(exception);
        this.state = "closed";
        this._p = this._p.then(() => this._free());
        if (exception.name !== "AbortError")
          this._p = this._p.then(() => {
            this._error(exception);
          });
      }
      _resetAudioDecoder(exception) {
        if (this.state === "closed")
          throw new DOMException("Decoder closed", "InvalidStateError");
        this.state = "unconfigured";
        this._p = this._p.then(() => this._free());
      }
      decode(chunk) {
        if (this.state !== "configured")
          throw new DOMException("Unconfigured", "InvalidStateError");
        this.decodeQueueSize++;
        this._p = this._p.then(() => __awaiter2(this, void 0, void 0, function* () {
          const libav2 = this._libav;
          const c2 = this._c;
          const pkt = this._pkt;
          const frame = this._frame;
          let decodedOutputs = null;
          this.decodeQueueSize--;
          this.dispatchEvent(new CustomEvent("dequeue"));
          try {
            const ptsFull = Math.floor(chunk.timestamp / 1e3);
            const [pts, ptshi] = libav2.f64toi64(ptsFull);
            const packet = {
              data: chunk._libavGetData(),
              pts,
              ptshi,
              dts: pts,
              dtshi: ptshi
            };
            if (chunk.duration) {
              packet.duration = Math.floor(chunk.duration / 1e3);
              packet.durationhi = 0;
            }
            decodedOutputs = yield libav2.ff_decode_multi(c2, pkt, frame, [packet]);
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeAudioDecoder(ex);
            });
            return;
          }
          if (decodedOutputs)
            this._outputAudioData(decodedOutputs);
        })).catch(this._error);
      }
      _outputAudioData(outputs) {
        const libav2 = this._libav;
        for (const frame of outputs) {
          let format;
          let planar = false;
          switch (frame.format) {
            case libav2.AV_SAMPLE_FMT_U8:
              format = "u8";
              break;
            case libav2.AV_SAMPLE_FMT_S16:
              format = "s16";
              break;
            case libav2.AV_SAMPLE_FMT_S32:
              format = "s32";
              break;
            case libav2.AV_SAMPLE_FMT_FLT:
              format = "f32";
              break;
            case libav2.AV_SAMPLE_FMT_U8P:
              format = "u8";
              planar = true;
              break;
            case libav2.AV_SAMPLE_FMT_S16P:
              format = "s16";
              planar = true;
              break;
            case libav2.AV_SAMPLE_FMT_S32P:
              format = "s32";
              planar = true;
              break;
            case libav2.AV_SAMPLE_FMT_FLTP:
              format = "f32";
              planar = true;
              break;
            default:
              throw new DOMException("Unsupported libav format!", "EncodingError");
          }
          const sampleRate = frame.sample_rate;
          const numberOfFrames = frame.nb_samples;
          const numberOfChannels = frame.channels;
          const timestamp = libav2.i64tof64(frame.pts, frame.ptshi) * 1e3;
          let raw;
          if (planar) {
            let ct2 = 0;
            for (let i2 = 0; i2 < frame.data.length; i2++)
              ct2 += frame.data[i2].length;
            raw = new frame.data[0].constructor(ct2);
            ct2 = 0;
            for (let i2 = 0; i2 < frame.data.length; i2++) {
              const part = frame.data[i2];
              raw.set(part, ct2);
              ct2 += part.length;
            }
          } else {
            raw = frame.data;
          }
          const data = new AudioData2({
            format,
            sampleRate,
            numberOfFrames,
            numberOfChannels,
            timestamp,
            data: raw
          });
          this._output(data);
        }
      }
      flush() {
        if (this.state !== "configured")
          throw new DOMException("Invalid state", "InvalidStateError");
        const ret = this._p.then(() => __awaiter2(this, void 0, void 0, function* () {
          if (!this._c)
            return;
          const libav2 = this._libav;
          const c2 = this._c;
          const pkt = this._pkt;
          const frame = this._frame;
          let decodedOutputs = null;
          try {
            decodedOutputs = yield libav2.ff_decode_multi(c2, pkt, frame, [], true);
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeAudioDecoder(ex);
            });
          }
          {
            if (decodedOutputs)
              this._outputAudioData(decodedOutputs);
          }
        }));
        this._p = ret;
        return ret;
      }
      reset() {
        this._resetAudioDecoder(new DOMException("Reset", "AbortError"));
      }
      close() {
        this._closeAudioDecoder(new DOMException("Close", "AbortError"));
      }
      static isConfigSupported(config2) {
        return __awaiter2(this, void 0, void 0, function* () {
          const dec = decoder2(config2.codec, config2);
          let supported2 = false;
          if (dec) {
            const libav2 = yield get();
            try {
              const [, c2, pkt, frame] = yield libav2.ff_init_decoder(dec.codec);
              yield libav2.ff_free_decoder(c2, pkt, frame);
              supported2 = true;
            } catch (ex) {
            }
            yield free(libav2);
          }
          return {
            supported: supported2,
            config: cloneConfig(config2, ["codec", "sampleRate", "numberOfChannels"])
          };
        });
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/audio-encoder.js
var __awaiter3, AudioEncoder2;
var init_audio_encoder = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/audio-encoder.js"() {
    init_audio_data();
    init_encoded_audio_chunk();
    init_event_target();
    init_avloader();
    init_misc();
    __awaiter3 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    AudioEncoder2 = class extends DequeueEventTarget {
      constructor(init) {
        super();
        this._outputMetadata = null;
        this._outputMetadataFilled = false;
        this._pts = null;
        this._p = Promise.all([]);
        this._libav = null;
        this._codec = this._c = this._frame = this._pkt = 0;
        this._filter_in_ctx = this._filter_out_ctx = null;
        this._filter_graph = this._buffersrc_ctx = this._buffersink_ctx = 0;
        this._output = init.output;
        this._error = init.error;
        this.state = "unconfigured";
        this.encodeQueueSize = 0;
      }
      configure(config2) {
        const self2 = this;
        if (this.state === "closed")
          throw new DOMException("Encoder is closed", "InvalidStateError");
        if (this._libav)
          this._p = this._p.then(() => this._free());
        this.state = "configured";
        this._p = this._p.then(function() {
          return __awaiter3(this, void 0, void 0, function* () {
            const supported2 = encoder(config2.codec, config2);
            self2._outputMetadata = { decoderConfig: {
              codec: config2.codec,
              // Rest will be filled in when we get data
              sampleRate: 0,
              numberOfChannels: 0
            } };
            self2._outputMetadataFilled = false;
            if (!supported2) {
              self2._closeAudioEncoder(new DOMException("Unsupported codec", "NotSupportedError"));
              return;
            }
            const libav2 = self2._libav = yield get();
            let frame_size;
            [self2._codec, self2._c, self2._frame, self2._pkt, frame_size] = yield libav2.ff_init_encoder(supported2.codec, supported2);
            self2._pts = null;
            yield libav2.AVCodecContext_time_base_s(self2._c, 1, supported2.ctx.sample_rate);
            self2._filter_out_ctx = {
              sample_rate: supported2.ctx.sample_rate,
              sample_fmt: supported2.ctx.sample_fmt,
              channel_layout: supported2.ctx.channel_layout,
              frame_size
            };
          });
        }).catch(this._error);
      }
      // Our own algorithm, close libav
      _free() {
        return __awaiter3(this, void 0, void 0, function* () {
          if (this._filter_graph) {
            yield this._libav.avfilter_graph_free_js(this._filter_graph);
            this._filter_in_ctx = this._filter_out_ctx = null;
            this._filter_graph = this._buffersrc_ctx = this._buffersink_ctx = 0;
          }
          if (this._c) {
            yield this._libav.ff_free_encoder(this._c, this._frame, this._pkt);
            this._codec = this._c = this._frame = this._pkt = 0;
          }
          if (this._libav) {
            free(this._libav);
            this._libav = null;
          }
        });
      }
      _closeAudioEncoder(exception) {
        this._resetAudioEncoder(exception);
        this.state = "closed";
        this._p = this._p.then(() => this._free());
        if (exception.name !== "AbortError")
          this._p = this._p.then(() => {
            this._error(exception);
          });
      }
      _resetAudioEncoder(exception) {
        if (this.state === "closed")
          throw new DOMException("Encoder closed", "InvalidStateError");
        this.state = "unconfigured";
        this._p = this._p.then(() => this._free());
      }
      encode(data) {
        if (data._libavGetData() === null)
          throw new TypeError("Detached");
        if (this.state !== "configured")
          throw new DOMException("Unconfigured", "InvalidStateError");
        const dataClone = data.clone();
        this.encodeQueueSize++;
        this._p = this._p.then(() => __awaiter3(this, void 0, void 0, function* () {
          const libav2 = this._libav;
          const c2 = this._c;
          const pkt = this._pkt;
          const framePtr = this._frame;
          let encodedOutputs = null;
          this.encodeQueueSize--;
          this.dispatchEvent(new CustomEvent("dequeue"));
          try {
            let raw = dataClone._libavGetData();
            const nb_samples = dataClone.numberOfFrames;
            if (!isInterleaved(dataClone.format)) {
              let split2 = [];
              for (let i2 = 0; i2 < dataClone.numberOfChannels; i2++)
                split2.push(raw.subarray(i2 * nb_samples, (i2 + 1) * nb_samples));
              raw = split2;
            }
            let format;
            switch (dataClone.format) {
              case "u8":
                format = libav2.AV_SAMPLE_FMT_U8;
                break;
              case "s16":
                format = libav2.AV_SAMPLE_FMT_S16;
                break;
              case "s32":
                format = libav2.AV_SAMPLE_FMT_S32;
                break;
              case "f32":
                format = libav2.AV_SAMPLE_FMT_FLT;
                break;
              case "u8-planar":
                format = libav2.AV_SAMPLE_FMT_U8P;
                break;
              case "s16-planar":
                format = libav2.AV_SAMPLE_FMT_S16P;
                break;
              case "s32-planar":
                format = libav2.AV_SAMPLE_FMT_S32P;
                break;
              case "f32-planar":
                format = libav2.AV_SAMPLE_FMT_FLTP;
                break;
              default:
                throw new TypeError("Invalid AudioSampleFormat");
            }
            const ptsFull = Math.floor(dataClone.timestamp / 1e3);
            const [pts, ptshi] = libav2.f64toi64(ptsFull);
            const cc = dataClone.numberOfChannels;
            const channel_layout = cc === 1 ? 4 : (1 << cc) - 1;
            const sample_rate = dataClone.sampleRate;
            const frame = {
              data: raw,
              format,
              pts,
              ptshi,
              channel_layout,
              sample_rate
            };
            let preOutputs = null;
            if (this._filter_in_ctx) {
              const filter_ctx = this._filter_in_ctx;
              if (filter_ctx.sample_fmt !== frame.format || filter_ctx.channel_layout !== frame.channel_layout || filter_ctx.sample_rate !== frame.sample_rate) {
                let fframes2 = yield this._filter([], true);
                fframes2 = fframes2.filter((x4) => {
                  let frame_size;
                  if (x4.data[0].length) {
                    frame_size = x4.data[0].length;
                  } else {
                    frame_size = x4.data.length / x4.channels;
                  }
                  return frame_size === this._filter_out_ctx.frame_size;
                });
                if (fframes2.length) {
                  preOutputs = yield libav2.ff_encode_multi(c2, framePtr, pkt, fframes2);
                }
                yield libav2.avfilter_graph_free_js(this._filter_graph);
                this._filter_in_ctx = null;
                this._filter_graph = this._buffersrc_ctx = this._buffersink_ctx = 0;
              }
            }
            if (!this._filter_graph) {
              const filter_ctx = this._filter_in_ctx = {
                sample_rate: frame.sample_rate,
                sample_fmt: frame.format,
                channel_layout: frame.channel_layout
              };
              [this._filter_graph, this._buffersrc_ctx, this._buffersink_ctx] = yield libav2.ff_init_filter_graph("aresample", filter_ctx, this._filter_out_ctx);
            }
            const fframes = yield this._filter([frame]);
            encodedOutputs = yield libav2.ff_encode_multi(c2, framePtr, pkt, fframes);
            if (preOutputs)
              encodedOutputs = preOutputs.concat(encodedOutputs);
            if (encodedOutputs.length && !this._outputMetadataFilled && fframes && fframes.length)
              yield this._getOutputMetadata(fframes[0]);
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeAudioEncoder(ex);
            });
          }
          if (encodedOutputs)
            this._outputEncodedAudioChunks(encodedOutputs);
        })).catch(this._error);
      }
      // Internal: Filter the given audio
      _filter(frames, fin = false) {
        return __awaiter3(this, void 0, void 0, function* () {
          if (frames.length && this._pts === null)
            this._pts = frames[0].pts || 0;
          const fframes = yield this._libav.ff_filter_multi(this._buffersrc_ctx, this._buffersink_ctx, this._frame, frames, fin);
          for (const frame of fframes) {
            frame.pts = this._pts;
            frame.ptshi = 0;
            this._pts += frame.nb_samples;
          }
          return fframes;
        });
      }
      // Internal: Get output metadata
      _getOutputMetadata(frame) {
        return __awaiter3(this, void 0, void 0, function* () {
          const libav2 = this._libav;
          const c2 = this._c;
          const extradataPtr = yield libav2.AVCodecContext_extradata(c2);
          const extradata_size = yield libav2.AVCodecContext_extradata_size(c2);
          let extradata = null;
          if (extradataPtr && extradata_size)
            extradata = yield libav2.copyout_u8(extradataPtr, extradata_size);
          this._outputMetadata.decoderConfig.sampleRate = frame.sample_rate;
          this._outputMetadata.decoderConfig.numberOfChannels = frame.channels;
          if (extradata)
            this._outputMetadata.decoderConfig.description = extradata;
          this._outputMetadataFilled = true;
        });
      }
      _outputEncodedAudioChunks(packets) {
        const libav2 = this._libav;
        const sampleRate = this._filter_out_ctx.sample_rate;
        for (const packet of packets) {
          const data = packet.data;
          const type = packet.flags & 1 ? "key" : "delta";
          let timestamp = libav2.i64tof64(packet.pts, packet.ptshi);
          timestamp = Math.floor(timestamp / sampleRate * 1e6);
          let duration2;
          if (typeof packet.duration !== "undefined") {
            duration2 = libav2.i64tof64(packet.duration, packet.durationhi || 0);
            duration2 = Math.floor(duration2 / sampleRate * 1e6);
          }
          const chunk = new EncodedAudioChunk2({
            data,
            type,
            timestamp,
            duration: duration2
          });
          if (this._outputMetadataFilled)
            this._output(chunk, this._outputMetadata || void 0);
          else
            this._output(chunk);
        }
      }
      flush() {
        if (this.state !== "configured")
          throw new DOMException("Invalid state", "InvalidStateError");
        const ret = this._p.then(() => __awaiter3(this, void 0, void 0, function* () {
          if (!this._c)
            return;
          const libav2 = this._libav;
          const c2 = this._c;
          const frame = this._frame;
          const pkt = this._pkt;
          const buffersrc_ctx = this._buffersrc_ctx;
          const buffersink_ctx = this._buffersink_ctx;
          let encodedOutputs = null;
          try {
            let fframes = null;
            if (buffersrc_ctx)
              fframes = yield this._filter([], true);
            encodedOutputs = yield libav2.ff_encode_multi(c2, frame, pkt, fframes || [], true);
            if (!this._outputMetadataFilled && fframes && fframes.length)
              yield this._getOutputMetadata(fframes[0]);
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeAudioEncoder(ex);
            });
          }
          {
            if (encodedOutputs)
              this._outputEncodedAudioChunks(encodedOutputs);
          }
        }));
        this._p = ret;
        return ret;
      }
      reset() {
        this._resetAudioEncoder(new DOMException("Reset", "AbortError"));
      }
      close() {
        this._closeAudioEncoder(new DOMException("Close", "AbortError"));
      }
      static isConfigSupported(config2) {
        return __awaiter3(this, void 0, void 0, function* () {
          const enc = encoder(config2.codec, config2);
          let supported2 = false;
          if (enc) {
            const libav2 = yield get();
            try {
              const [, c2, frame, pkt] = yield libav2.ff_init_encoder(enc.codec, enc);
              yield libav2.ff_free_encoder(c2, frame, pkt);
              supported2 = true;
            } catch (ex) {
            }
            yield free(libav2);
          }
          return {
            supported: supported2,
            config: cloneConfig(config2, ["codec", "sampleRate", "numberOfChannels", "bitrate"])
          };
        });
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/encoded-video-chunk.js
var EncodedVideoChunk2;
var init_encoded_video_chunk = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/encoded-video-chunk.js"() {
    init_encoded_audio_chunk();
    EncodedVideoChunk2 = EncodedAudioChunk2;
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/video-frame.js
function wcFormatToLibAVFormat(libav2, wcFormat) {
  let format = libav2.AV_PIX_FMT_RGBA;
  switch (wcFormat) {
    case "I420":
      format = libav2.AV_PIX_FMT_YUV420P;
      break;
    case "I420P10":
      format = 62;
      break;
    case "I420P12":
      format = 123;
      break;
    case "I420A":
      format = libav2.AV_PIX_FMT_YUVA420P;
      break;
    case "I420AP10":
      format = 87;
      break;
    case "I420AP12":
      throw new TypeError("YUV420P12 is not supported by libav");
      break;
    case "I422":
      format = libav2.AV_PIX_FMT_YUV422P;
      break;
    case "I422P10":
      format = 64;
      break;
    case "I422P12":
      format = 127;
      break;
    case "I422A":
      format = 78;
      break;
    case "I422AP10":
      format = 89;
      break;
    // Tablebox: I422AP12, not I422AP10 a second time (tablebox.io patches.mjs).
    case "I422AP12":
      format = 186;
      break;
    case "I444":
      format = libav2.AV_PIX_FMT_YUV444P;
      break;
    case "I444P10":
      format = 68;
      break;
    case "I444P12":
      format = 131;
      break;
    case "I444A":
      format = 79;
      break;
    case "I444AP10":
      format = 91;
      break;
    case "I444AP12":
      format = 188;
      break;
    case "NV12":
      format = libav2.AV_PIX_FMT_NV12;
      break;
    case "RGBA":
      format = libav2.AV_PIX_FMT_RGBA;
      break;
    case "RGBX":
      format = 119;
      break;
    case "BGRA":
      format = libav2.AV_PIX_FMT_BGRA;
      break;
    case "BGRX":
      format = 121;
      break;
    default:
      throw new TypeError("Invalid VideoPixelFormat");
  }
  return format;
}
function numPlanes(format) {
  switch (format) {
    case "I420":
    case "I420P10":
    case "I420P12":
    case "I422":
    case "I422P10":
    case "I422P12":
    case "I444":
    case "I444P10":
    case "I444P12":
      return 3;
    case "I420A":
    case "I420AP10":
    case "I420AP12":
    case "I422A":
    case "I422AP10":
    case "I422AP12":
    case "I444A":
    case "I444AP10":
    case "I444AP12":
      return 4;
    case "NV12":
      return 2;
    case "RGBA":
    case "RGBX":
    case "BGRA":
    case "BGRX":
      return 1;
    default:
      throw new DOMException("Unsupported video pixel format", "NotSupportedError");
  }
}
function sampleBytes(format, planeIndex) {
  switch (format) {
    case "I420":
    case "I420A":
    case "I422":
    case "I422A":
    case "I444":
    case "I444A":
      return 1;
    case "I420P10":
    case "I420AP10":
    case "I422P10":
    case "I422AP10":
    case "I444P10":
    case "I444AP10":
    case "I420P12":
    case "I420AP12":
    case "I422P12":
    case "I422AP12":
    case "I444P12":
    case "I444AP12":
      return 2;
    case "NV12":
      if (planeIndex === 1)
        return 2;
      else
        return 1;
    case "RGBA":
    case "RGBX":
    case "BGRA":
    case "BGRX":
      return 4;
    default:
      throw new DOMException("Unsupported video pixel format", "NotSupportedError");
  }
}
function horizontalSubSamplingFactor(format, planeIndex) {
  if (planeIndex === 0)
    return 1;
  if (planeIndex === 3)
    return 1;
  switch (format) {
    case "I420":
    case "I420P10":
    case "I420P12":
    case "I420A":
    case "I420AP10":
    case "I420AP12":
    case "I422":
    case "I422P10":
    case "I422P12":
    case "I422A":
    case "I422AP10":
    case "I422AP12":
      return 2;
    case "I444":
    case "I444P10":
    case "I444P12":
    case "I444A":
    case "I444AP10":
    case "I444AP12":
      return 1;
    case "NV12":
      return 2;
    case "RGBA":
    case "RGBX":
    case "BGRA":
    case "BGRX":
      return 1;
    default:
      throw new DOMException("Unsupported video pixel format", "NotSupportedError");
  }
}
function verticalSubSamplingFactor(format, planeIndex) {
  if (planeIndex === 0)
    return 1;
  if (planeIndex === 3)
    return 1;
  switch (format) {
    case "I420":
    case "I420P10":
    case "I420P12":
    case "I420A":
    case "I420AP10":
    case "I420AP12":
      return 2;
    case "I422":
    case "I422P10":
    case "I422P12":
    case "I422A":
    case "I422AP10":
    case "I422AP12":
    case "I444":
    case "I444P10":
    case "I444P12":
    case "I444A":
    case "I444AP10":
    case "I444AP12":
      return 1;
    case "NV12":
      return 2;
    case "RGBA":
    case "RGBX":
    case "BGRA":
    case "BGRX":
      return 1;
    default:
      throw new DOMException("Unsupported video pixel format", "NotSupportedError");
  }
}
var __awaiter4, offscreenCanvas, VideoFrame2;
var init_video_frame = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/video-frame.js"() {
    init_esm();
    __awaiter4 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    offscreenCanvas = null;
    VideoFrame2 = class _VideoFrame {
      constructor(data, init) {
        this.format = "I420";
        this.codedWidth = 0;
        this.codedHeight = 0;
        this.codedRect = null;
        this.visibleRect = null;
        this.displayWidth = 0;
        this.displayHeight = 0;
        this.timestamp = 0;
        this._layout = null;
        this._data = null;
        this._nonSquarePixels = false;
        this._sar_num = 1;
        this._sar_den = 1;
        if (data instanceof ArrayBuffer || data.buffer instanceof ArrayBuffer) {
          this._constructBuffer(data, init);
        } else if (data instanceof _VideoFrame || globalThis.VideoFrame && data instanceof globalThis.VideoFrame) {
          const array2 = new Uint8Array(data.allocationSize());
          data.copyTo(array2);
          this._constructBuffer(array2, {
            transfer: [array2.buffer],
            // 1. Let format be otherFrame.format.
            /* 2. FIXME: If init.alpha is discard, assign
             * otherFrame.format's equivalent opaque format format. */
            format: data.format,
            /* 3. Let validInit be the result of running the Validate
             * VideoFrameInit algorithm with format and otherFrame’s
             * [[coded width]] and [[coded height]]. */
            // 4. If validInit is false, throw a TypeError.
            /* 7. Assign the following attributes from otherFrame to frame:
             * codedWidth, codedHeight, colorSpace. */
            codedHeight: data.codedHeight,
            codedWidth: data.codedWidth,
            colorSpace: data.colorSpace,
            /* 8. Let defaultVisibleRect be the result of performing the
             * getter steps for visibleRect on otherFrame. */
            /* 9. Let defaultDisplayWidth, and defaultDisplayHeight be
             * otherFrame’s [[display width]], and [[display height]]
             * respectively. */
            /* 10. Run the Initialize Visible Rect and Display Size
             * algorithm with init, frame, defaultVisibleRect,
             * defaultDisplayWidth, and defaultDisplayHeight. */
            visibleRect: (init === null || init === void 0 ? void 0 : init.visibleRect) || data.visibleRect,
            displayHeight: (init === null || init === void 0 ? void 0 : init.displayHeight) || data.displayHeight,
            displayWidth: (init === null || init === void 0 ? void 0 : init.displayWidth) || data.displayWidth,
            /* 11. If duration exists in init, assign it to frame’s
             * [[duration]]. Otherwise, assign otherFrame.duration to
             * frame’s [[duration]]. */
            duration: (init === null || init === void 0 ? void 0 : init.duration) || data.duration,
            /* 12. If timestamp exists in init, assign it to frame’s
             * [[timestamp]]. Otherwise, assign otherFrame’s timestamp to
             * frame’s [[timestamp]]. */
            timestamp: (init === null || init === void 0 ? void 0 : init.timestamp) || data.timestamp,
            /* Assign the result of calling Copy VideoFrame metadata with
             * init’s metadata to frame.[[metadata]]. */
            metadata: JSON.parse(JSON.stringify(init === null || init === void 0 ? void 0 : init.metadata))
          });
        } else if (data instanceof HTMLVideoElement) {
          if (data.readyState === HTMLVideoElement.prototype.HAVE_NOTHING || data.readyState === HTMLVideoElement.prototype.HAVE_METADATA) {
            throw new DOMException("Video is not ready for reading frames", "InvalidStateError");
          }
          if (data.networkState === data.NETWORK_EMPTY) {
            throw new DOMException("Video network state is empty", "InvalidStateError");
          }
          this._constructCanvas(data, Object.assign(Object.assign({}, init), { timestamp: (init === null || init === void 0 ? void 0 : init.timestamp) || data.currentTime * 1e6 }));
        } else {
          this._constructCanvas(data, init);
        }
      }
      _constructCanvas(image, init) {
        let width = 0, height = 0;
        if (image.naturalWidth) {
          width = image.naturalWidth;
          height = image.naturalHeight;
        } else if (image.videoWidth) {
          width = image.videoWidth;
          height = image.videoHeight;
        } else if (image.width) {
          width = image.width;
          height = image.height;
        }
        if (!width || !height)
          throw new DOMException("Could not determine dimensions", "InvalidStateError");
        if (offscreenCanvas === null) {
          if (typeof OffscreenCanvas !== "undefined") {
            offscreenCanvas = new OffscreenCanvas(width, height);
          } else {
            offscreenCanvas = document.createElement("canvas");
            offscreenCanvas.style.display = "none";
            document.body.appendChild(offscreenCanvas);
          }
        }
        offscreenCanvas.width = width;
        offscreenCanvas.height = height;
        const options = { desynchronized: true, willReadFrequently: true };
        const ctx = offscreenCanvas.getContext("2d", options);
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(image, 0, 0);
        this._constructBuffer(ctx.getImageData(0, 0, width, height).data, {
          format: "RGBA",
          codedWidth: width,
          codedHeight: height,
          timestamp: (init === null || init === void 0 ? void 0 : init.timestamp) || 0,
          duration: (init === null || init === void 0 ? void 0 : init.duration) || 0,
          layout: [{ offset: 0, stride: width * 4 }],
          displayWidth: (init === null || init === void 0 ? void 0 : init.displayWidth) || width,
          displayHeight: (init === null || init === void 0 ? void 0 : init.displayHeight) || height
        });
      }
      _constructBuffer(data, init) {
        _VideoFrame._checkValidVideoFrameBufferInit(init);
        const defaultRect = new DOMRect(0, 0, init.codedWidth, init.codedHeight);
        let overrideRect = void 0;
        if (init.visibleRect)
          overrideRect = DOMRect.fromRect(init.visibleRect);
        this.codedWidth = init.codedWidth;
        this.codedHeight = init.codedHeight;
        const parsedRect = this._parseVisibleRect(defaultRect, overrideRect || null);
        let optLayout = void 0;
        if (init.layout) {
          if (init.layout instanceof Array)
            optLayout = init.layout;
          else
            optLayout = Array.from(init.layout);
        }
        this.format = init.format;
        const combinedLayout = this._computeLayoutAndAllocationSize(parsedRect, optLayout || null);
        if (data.byteLength < combinedLayout.allocationSize)
          throw new TypeError("data is too small for layout");
        let transfer = false;
        if (init.transfer) {
          let inBuffer;
          if (data.buffer)
            inBuffer = data.buffer;
          else
            inBuffer = data;
          let t;
          if (init.transfer instanceof Array)
            t = init.transfer;
          else
            t = Array.from(init.transfer);
          for (const b3 of t) {
            if (b3 === inBuffer) {
              transfer = true;
              break;
            }
          }
        }
        const format = init.format;
        if (init.layout) {
          if (init.layout instanceof Array)
            this._layout = init.layout;
          else
            this._layout = Array.from(init.layout);
        } else {
          const numPlanes_ = numPlanes(format);
          const layout = [];
          let offset = 0;
          for (let i2 = 0; i2 < numPlanes_; i2++) {
            const sampleWidth = horizontalSubSamplingFactor(format, i2);
            const sampleHeight = verticalSubSamplingFactor(format, i2);
            const stride = ~~(this.codedWidth / sampleWidth);
            layout.push({ offset, stride });
            offset += stride * ~~(this.codedHeight / sampleHeight);
          }
          this._layout = layout;
        }
        this._data = new Uint8Array(data.buffer || data, data.byteOffset || 0);
        if (!transfer) {
          const numPlanes_ = numPlanes(format);
          let layout = this._layout;
          let lo = 1 / 0;
          let hi = 0;
          for (let i2 = 0; i2 < numPlanes_; i2++) {
            const plane = layout[i2];
            let offset = plane.offset;
            if (offset < lo)
              lo = offset;
            const sampleHeight = verticalSubSamplingFactor(format, i2);
            offset += plane.stride * ~~(this.codedHeight / sampleHeight);
            if (offset > hi)
              hi = offset;
          }
          if (lo !== 0) {
            layout = this._layout = layout.map((x4) => ({
              offset: x4.offset - lo,
              stride: x4.stride
            }));
          }
          this._data = this._data.slice(lo, hi);
        }
        const resourceCodedWidth = init.codedWidth;
        const resourceCodedHeight = init.codedHeight;
        const resourceVisibleLeft = parsedRect.left;
        const resourceVisibleTop = parsedRect.top;
        {
          this.codedRect = new DOMRect(0, 0, resourceCodedWidth, resourceCodedHeight);
          this.visibleRect = parsedRect;
          if (init.visibleRect) {
            this.visibleRect = DOMRect.fromRect(init.visibleRect);
          } else {
            this.visibleRect = new DOMRect(0, 0, resourceCodedWidth, resourceCodedHeight);
          }
          if (typeof init.displayWidth === "number")
            this.displayWidth = init.displayWidth;
          else
            this.displayWidth = this.visibleRect.width;
          if (typeof init.displayHeight === "number")
            this.displayHeight = init.displayHeight;
          else
            this.displayHeight = this.visibleRect.height;
          if (this.displayWidth !== this.visibleRect.width || this.displayHeight !== this.visibleRect.height) {
            this._nonSquarePixels = true;
            this._sar_num = this.displayWidth * this.visibleRect.width;
            this._sar_den = this.displayHeight * this.visibleRect.height;
          } else {
            this._nonSquarePixels = false;
            this._sar_num = this._sar_den = 1;
          }
          this.timestamp = init.timestamp;
          this.duration = init.duration;
        }
      }
      /**
       * Convert a polyfill VideoFrame to a native VideoFrame.
       * @param opts  Conversion options
       */
      toNative(opts = {}) {
        const ret = new globalThis.VideoFrame(this._data, {
          layout: this._layout,
          format: this.format,
          codedWidth: this.codedWidth,
          codedHeight: this.codedHeight,
          visibleRect: this.visibleRect,
          displayWidth: this.displayWidth,
          displayHeight: this.displayHeight,
          duration: this.duration,
          timestamp: this.timestamp,
          transfer: opts.transfer ? [this._data.buffer] : []
        });
        if (opts.transfer)
          this.close();
        return ret;
      }
      /**
       * Convert a native VideoFrame to a polyfill VideoFrame. WARNING: Inefficient,
       * as the data cannot be transferred out.
       * @param from  VideoFrame to copy in
       */
      static fromNative(from2) {
        const vf = from2;
        const data = new Uint8Array(vf.allocationSize());
        vf.copyTo(data);
        return new _VideoFrame(data, {
          format: vf.format,
          codedWidth: vf.codedWidth,
          codedHeight: vf.codedHeight,
          visibleRect: vf.visibleRect,
          displayWidth: vf.displayWidth,
          displayHeight: vf.displayHeight,
          duration: vf.duration,
          timestamp: vf.timestamp
        });
      }
      // Internal
      _libavGetData() {
        return this._data;
      }
      _libavGetLayout() {
        return this._layout;
      }
      static _checkValidVideoFrameBufferInit(init) {
        if (!init.codedWidth || !init.codedHeight)
          throw new TypeError("Invalid coded dimensions");
        if (init.visibleRect) {
          const vr = DOMRect.fromRect(init.visibleRect);
          if (vr.x < 0 || !Number.isFinite(vr.x) || vr.y < 0 || !Number.isFinite(vr.y) || vr.width < 0 || !Number.isFinite(vr.width) || vr.height < 0 || !Number.isFinite(vr.height)) {
            throw new TypeError("Invalid visible rectangle");
          }
          if (vr.y + vr.height > init.codedHeight)
            throw new TypeError("Visible rectangle outside of coded height");
          if (vr.x + vr.width > init.codedWidth)
            throw new TypeError("Visible rectangle outside of coded width");
          if (init.displayWidth && !init.displayHeight || !init.displayWidth && !init.displayHeight || (init.displayWidth === 0 || init.displayHeight === 0))
            throw new TypeError("Invalid display dimensions");
        }
      }
      metadata() {
        if (this._data === null)
          throw new DOMException("Detached", "InvalidStateError");
        return null;
      }
      allocationSize(options = {}) {
        if (this._data === null)
          throw new DOMException("Detached", "InvalidStateError");
        if (this.format === null)
          throw new DOMException("Not supported", "NotSupportedError");
        const combinedLayout = this._parseVideoFrameCopyToOptions(options);
        return combinedLayout.allocationSize;
      }
      _parseVideoFrameCopyToOptions(options) {
        const defaultRect = this.visibleRect;
        let overrideRect = options.rect ? new DOMRect(options.rect.x, options.rect.y, options.rect.width, options.rect.height) : null;
        const parsedRect = this._parseVisibleRect(defaultRect, overrideRect);
        let optLayout = null;
        if (options.layout) {
          if (options.layout instanceof Array)
            optLayout = options.layout;
          else
            optLayout = Array.from(options.layout);
        }
        const combinedLayout = this._computeLayoutAndAllocationSize(parsedRect, optLayout);
        return combinedLayout;
      }
      _parseVisibleRect(defaultRect, overrideRect) {
        let sourceRect = defaultRect;
        if (overrideRect) {
          if (overrideRect.width === 0 || overrideRect.height === 0)
            throw new TypeError("Invalid rectangle");
          if (overrideRect.x + overrideRect.width > this.codedWidth)
            throw new TypeError("Invalid rectangle");
          if (overrideRect.y + overrideRect.height > this.codedHeight)
            throw new TypeError("Invalid rectangle");
          sourceRect = overrideRect;
        }
        const validAlignment = this._verifyRectOffsetAlignment(sourceRect);
        if (!validAlignment)
          throw new TypeError("Invalid alignment");
        return sourceRect;
      }
      _computeLayoutAndAllocationSize(parsedRect, layout) {
        let numPlanes_ = numPlanes(this.format);
        if (layout && layout.length !== numPlanes_)
          throw new TypeError("Invalid layout");
        let minAllocationSize = 0;
        let computedLayouts = [];
        let endOffsets = [];
        let planeIndex = 0;
        while (planeIndex < numPlanes_) {
          const sampleBytes_ = sampleBytes(this.format, planeIndex);
          const sampleWidth = horizontalSubSamplingFactor(this.format, planeIndex);
          const sampleHeight = verticalSubSamplingFactor(this.format, planeIndex);
          const computedLayout = {
            destinationOffset: 0,
            destinationStride: 0,
            /* 6. Set computedLayout’s sourceTop to the result of the division
             *    of truncated parsedRect.y by sampleHeight, rounded up to the
             *    nearest integer. */
            sourceTop: Math.ceil(~~parsedRect.y / sampleHeight),
            /* 7. Set computedLayout’s sourceHeight to the result of the
             *    division of truncated parsedRect.height by sampleHeight,
             *    rounded up to the nearest integer. */
            sourceHeight: Math.ceil(~~parsedRect.height / sampleHeight),
            /* 8. Set computedLayout’s sourceLeftBytes to the result of the
             *    integer division of truncated parsedRect.x by sampleWidth,
             *    multiplied by sampleBytes. */
            sourceLeftBytes: ~~(parsedRect.x / sampleWidth * sampleBytes_),
            /* 9. Set computedLayout’s sourceWidthBytes to the result of the
             *    integer division of truncated parsedRect.width by
             *    sampleHeight, multiplied by sampleBytes. */
            sourceWidthBytes: ~~(parsedRect.width / sampleWidth * sampleBytes_)
          };
          if (layout) {
            const planeLayout = layout[planeIndex];
            if (planeLayout.stride < computedLayout.sourceWidthBytes)
              throw new TypeError("Invalid stride");
            computedLayout.destinationOffset = planeLayout.offset;
            computedLayout.destinationStride = planeLayout.stride;
          } else {
            computedLayout.destinationOffset = minAllocationSize;
            computedLayout.destinationStride = computedLayout.sourceWidthBytes;
          }
          const planeSize = computedLayout.destinationStride * computedLayout.sourceHeight;
          const planeEnd = planeSize + computedLayout.destinationOffset;
          if (planeSize >= 4294967296 || planeEnd >= 4294967296)
            throw new TypeError("Plane too large");
          endOffsets.push(planeEnd);
          if (planeEnd > minAllocationSize)
            minAllocationSize = planeEnd;
          let earlierPlaneIndex = 0;
          while (earlierPlaneIndex < planeIndex) {
            const earlierLayout = computedLayouts[earlierPlaneIndex];
            if (planeEnd <= earlierLayout.destinationOffset || endOffsets[earlierPlaneIndex] <= computedLayout.destinationOffset) {
            } else
              throw new TypeError("Invalid plane layout");
            earlierPlaneIndex++;
          }
          computedLayouts.push(computedLayout);
          planeIndex++;
        }
        const combinedLayout = {
          // 1. Assign computedLayouts to computedLayouts.
          computedLayouts,
          // 2. Assign minAllocationSize to allocationSize.
          allocationSize: minAllocationSize
        };
        return combinedLayout;
      }
      _verifyRectOffsetAlignment(rect) {
        if (!this.format)
          return true;
        let planeIndex = 0;
        const numPlanes_ = numPlanes(this.format);
        while (planeIndex < numPlanes_) {
          const sampleWidth = horizontalSubSamplingFactor(this.format, planeIndex);
          const sampleHeight = verticalSubSamplingFactor(this.format, planeIndex);
          const xw = rect.x / sampleWidth;
          if (xw !== ~~xw)
            return false;
          const yh = rect.y / sampleHeight;
          if (yh !== ~~yh)
            return false;
          planeIndex++;
        }
        return true;
      }
      copyTo(destination, options = {}) {
        return __awaiter4(this, void 0, void 0, function* () {
          const destBuf = new Uint8Array(destination.buffer || destination, destination.byteOffset || 0);
          if (this._data === null)
            throw new DOMException("Detached", "InvalidStateError");
          if (!this.format)
            throw new DOMException("No format", "NotSupportedError");
          const combinedLayout = this._parseVideoFrameCopyToOptions(options);
          if (destination.byteLength < combinedLayout.allocationSize)
            throw new TypeError("Insufficient space");
          let planeLayouts = [];
          {
            const numPlanes_ = numPlanes(this.format);
            let planeIndex = 0;
            while (planeIndex < combinedLayout.computedLayouts.length) {
              const sourceStride = this._layout[planeIndex].stride;
              const computedLayout = combinedLayout.computedLayouts[planeIndex];
              let sourceOffset = computedLayout.sourceTop * sourceStride;
              sourceOffset += computedLayout.sourceLeftBytes;
              let destinationOffset = computedLayout.destinationOffset;
              const rowBytes = computedLayout.sourceWidthBytes;
              const layout = {
                offset: computedLayout.destinationOffset,
                stride: computedLayout.destinationStride
              };
              let row = 0;
              while (row < computedLayout.sourceHeight) {
                destBuf.set(this._data.subarray(sourceOffset, sourceOffset + rowBytes), destinationOffset);
                sourceOffset += sourceStride;
                destinationOffset += computedLayout.destinationStride;
                row++;
              }
              planeIndex++;
              planeLayouts.push(layout);
            }
          }
          return planeLayouts;
        });
      }
      clone() {
        return new _VideoFrame(this._data, {
          format: this.format,
          codedWidth: this.codedWidth,
          codedHeight: this.codedHeight,
          timestamp: this.timestamp,
          duration: this.duration,
          layout: this._layout,
          transfer: [this._data.buffer]
        });
      }
      close() {
        this._data = null;
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/video-decoder.js
var __awaiter5, VideoDecoder2;
var init_video_decoder = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/video-decoder.js"() {
    init_event_target();
    init_avloader();
    init_misc();
    init_video_frame();
    __awaiter5 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    VideoDecoder2 = class extends DequeueEventTarget {
      constructor(init) {
        super();
        this._p = Promise.all([]);
        this._libav = null;
        this._codec = this._c = this._pkt = this._frame = 0;
        this._output = init.output;
        this._error = init.error;
        this.state = "unconfigured";
        this.decodeQueueSize = 0;
      }
      configure(config2) {
        if (this.state === "closed")
          throw new DOMException("Decoder is closed", "InvalidStateError");
        if (this._libav)
          this._p = this._p.then(() => this._free());
        this.state = "configured";
        this._p = this._p.then(() => __awaiter5(this, void 0, void 0, function* () {
          const supported2 = decoder2(config2.codec, config2);
          if (!supported2) {
            this._closeVideoDecoder(new DOMException("Unsupported codec", "NotSupportedError"));
            return;
          }
          const libav2 = this._libav = yield get();
          [this._codec, this._c, this._pkt, this._frame] = yield libav2.ff_init_decoder(supported2.codec);
          yield libav2.AVCodecContext_time_base_s(this._c, 1, 1e3);
        })).catch(this._error);
      }
      // Our own algorithm, close libav
      _free() {
        return __awaiter5(this, void 0, void 0, function* () {
          if (this._c) {
            yield this._libav.ff_free_decoder(this._c, this._pkt, this._frame);
            this._codec = this._c = this._pkt = this._frame = 0;
          }
          if (this._libav) {
            free(this._libav);
            this._libav = null;
          }
        });
      }
      _closeVideoDecoder(exception) {
        this._resetVideoDecoder(exception);
        this.state = "closed";
        this._p = this._p.then(() => this._free());
        if (exception.name !== "AbortError")
          this._p = this._p.then(() => {
            this._error(exception);
          });
      }
      _resetVideoDecoder(exception) {
        if (this.state === "closed")
          throw new DOMException("Decoder closed", "InvalidStateError");
        this.state = "unconfigured";
        this._p = this._p.then(() => this._free());
      }
      decode(chunk) {
        const self2 = this;
        if (this.state !== "configured")
          throw new DOMException("Unconfigured", "InvalidStateError");
        this.decodeQueueSize++;
        this._p = this._p.then(function() {
          return __awaiter5(this, void 0, void 0, function* () {
            const libav2 = self2._libav;
            const c2 = self2._c;
            const pkt = self2._pkt;
            const frame = self2._frame;
            let decodedOutputs = null;
            self2.decodeQueueSize--;
            self2.dispatchEvent(new CustomEvent("dequeue"));
            try {
              const ptsFull = Math.floor(chunk.timestamp / 1e3);
              const [pts, ptshi] = libav2.f64toi64(ptsFull);
              const packet = {
                data: chunk._libavGetData(),
                pts,
                ptshi,
                dts: pts,
                dtshi: ptshi
              };
              if (chunk.duration) {
                packet.duration = Math.floor(chunk.duration / 1e3);
                packet.durationhi = 0;
              }
              decodedOutputs = yield libav2.ff_decode_multi(c2, pkt, frame, [packet]);
            } catch (ex) {
              self2._p = self2._p.then(() => {
                self2._closeVideoDecoder(ex);
              });
            }
            if (decodedOutputs)
              self2._outputVideoFrames(decodedOutputs);
          });
        }).catch(this._error);
      }
      _outputVideoFrames(frames) {
        const libav2 = this._libav;
        for (const frame of frames) {
          let format;
          switch (frame.format) {
            case libav2.AV_PIX_FMT_YUV420P:
              format = "I420";
              break;
            case 62:
              format = "I420P10";
              break;
            case 123:
              format = "I420P12";
              break;
            case libav2.AV_PIX_FMT_YUVA420P:
              format = "I420A";
              break;
            case 87:
              format = "I420AP10";
              break;
            case libav2.AV_PIX_FMT_YUV422P:
              format = "I422";
              break;
            case 64:
              format = "I422P10";
              break;
            case 127:
              format = "I422P12";
              break;
            case 78:
              format = "I422A";
              break;
            case 89:
              format = "I422AP10";
              break;
            case 186:
              format = "I422AP12";
              break;
            case libav2.AV_PIX_FMT_YUV444P:
              format = "I444";
              break;
            case 68:
              format = "I444P10";
              break;
            case 131:
              format = "I444P12";
              break;
            case 79:
              format = "I444A";
              break;
            case 91:
              format = "I444AP10";
              break;
            case 188:
              format = "I444AP12";
              break;
            case libav2.AV_PIX_FMT_NV12:
              format = "NV12";
              break;
            case libav2.AV_PIX_FMT_RGBA:
              format = "RGBA";
              break;
            case 119:
              format = "RGBX";
              break;
            case libav2.AV_PIX_FMT_BGRA:
              format = "BGRA";
              break;
            case 121:
              format = "BGRX";
              break;
            default:
              throw new DOMException("Unsupported libav format!", "EncodingError");
          }
          const codedWidth = frame.width;
          const codedHeight = frame.height;
          let visibleRect;
          if (frame.crop) {
            visibleRect = new DOMRect(frame.crop.left, frame.crop.top, codedWidth - frame.crop.left - frame.crop.right, codedHeight - frame.crop.top - frame.crop.bottom);
          } else {
            visibleRect = new DOMRect(0, 0, codedWidth, codedHeight);
          }
          let displayWidth = codedWidth;
          let displayHeight = codedHeight;
          if (frame.sample_aspect_ratio && frame.sample_aspect_ratio[0]) {
            const sar = frame.sample_aspect_ratio;
            if (sar[0] > sar[1])
              displayWidth = ~~(codedWidth * sar[0] / sar[1]);
            else
              displayHeight = ~~(codedHeight * sar[1] / sar[0]);
          }
          const timestamp = libav2.i64tof64(frame.pts, frame.ptshi) * 1e3;
          const data = new VideoFrame2(frame.data, {
            layout: frame.layout,
            format,
            codedWidth,
            codedHeight,
            visibleRect,
            displayWidth,
            displayHeight,
            timestamp
          });
          this._output(data);
        }
      }
      flush() {
        if (this.state !== "configured")
          throw new DOMException("Invalid state", "InvalidStateError");
        const ret = this._p.then(() => __awaiter5(this, void 0, void 0, function* () {
          if (!this._c)
            return;
          const libav2 = this._libav;
          const c2 = this._c;
          const pkt = this._pkt;
          const frame = this._frame;
          let decodedOutputs = null;
          try {
            decodedOutputs = yield libav2.ff_decode_multi(c2, pkt, frame, [], true);
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeVideoDecoder(ex);
            });
          }
          {
            if (decodedOutputs)
              this._outputVideoFrames(decodedOutputs);
          }
        }));
        this._p = ret;
        return ret;
      }
      reset() {
        this._resetVideoDecoder(new DOMException("Reset", "AbortError"));
      }
      close() {
        this._closeVideoDecoder(new DOMException("Close", "AbortError"));
      }
      static isConfigSupported(config2) {
        return __awaiter5(this, void 0, void 0, function* () {
          const dec = decoder2(config2.codec, config2);
          let supported2 = false;
          if (dec) {
            const libav2 = yield get();
            try {
              const [, c2, pkt, frame] = yield libav2.ff_init_decoder(dec.codec);
              yield libav2.ff_free_decoder(c2, pkt, frame);
              supported2 = true;
            } catch (ex) {
            }
            yield free(libav2);
          }
          return {
            supported: supported2,
            config: cloneConfig(config2, ["codec", "codedWidth", "codedHeight"])
          };
        });
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/video-encoder.js
var __awaiter6, VideoEncoder2;
var init_video_encoder = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/video-encoder.js"() {
    init_encoded_video_chunk();
    init_event_target();
    init_avloader();
    init_misc();
    init_video_frame();
    __awaiter6 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    VideoEncoder2 = class extends DequeueEventTarget {
      constructor(init) {
        super();
        this._extradataSet = false;
        this._extradata = null;
        this._nonSquarePixels = false;
        this._sar_num = 1;
        this._sar_den = 1;
        this._p = Promise.all([]);
        this._libav = null;
        this._codec = this._c = this._frame = this._pkt = 0;
        this._output = init.output;
        this._error = init.error;
        this._metadata = null;
        this.state = "unconfigured";
        this.encodeQueueSize = 0;
      }
      configure(config2) {
        if (this.state === "closed")
          throw new DOMException("Encoder is closed", "InvalidStateError");
        if (this._libav)
          this._p = this._p.then(() => this._free());
        this.state = "configured";
        this._p = this._p.then(() => __awaiter6(this, void 0, void 0, function* () {
          const supported2 = encoder(config2.codec, config2);
          if (!supported2) {
            this._closeVideoEncoder(new DOMException("Unsupported codec", "NotSupportedError"));
            return;
          }
          const libav2 = this._libav = yield get();
          this._metadata = {
            decoderConfig: {
              codec: supported2.codec
            }
          };
          [this._codec, this._c, this._frame, this._pkt] = yield libav2.ff_init_encoder(supported2.codec, supported2);
          this._extradataSet = false;
          this._extradata = null;
          yield libav2.AVCodecContext_time_base_s(this._c, 1, 1e3);
          const width = config2.width;
          const height = config2.height;
          this._sws = 0;
          this._swsFrame = 0;
          this._swsOut = {
            width,
            height,
            format: supported2.ctx.pix_fmt
          };
          const dWidth = config2.displayWidth || width;
          const dHeight = config2.displayHeight || height;
          if (dWidth !== width || dHeight !== height) {
            this._nonSquarePixels = true;
            this._sar_num = dWidth * height;
            this._sar_den = dHeight * width;
          } else {
            this._nonSquarePixels = false;
          }
        })).catch(this._error);
      }
      // Our own algorithm, close libav
      _free() {
        return __awaiter6(this, void 0, void 0, function* () {
          if (this._sws) {
            yield this._libav.av_frame_free_js(this._swsFrame);
            yield this._libav.sws_freeContext(this._sws);
            this._sws = this._swsFrame = 0;
            this._swsIn = this._swsOut = void 0;
          }
          if (this._c) {
            yield this._libav.ff_free_encoder(this._c, this._frame, this._pkt);
            this._codec = this._c = this._frame = this._pkt = 0;
          }
          if (this._libav) {
            free(this._libav);
            this._libav = null;
          }
        });
      }
      _closeVideoEncoder(exception) {
        this._resetVideoEncoder(exception);
        this.state = "closed";
        this._p = this._p.then(() => this._free());
        if (exception.name !== "AbortError")
          this._p = this._p.then(() => {
            this._error(exception);
          });
      }
      _resetVideoEncoder(exception) {
        if (this.state === "closed")
          throw new DOMException("Encoder closed", "InvalidStateError");
        this.state = "unconfigured";
        this._p = this._p.then(() => this._free());
      }
      encode(frame, options = {}) {
        if (frame._libavGetData() === null)
          throw new TypeError("Detached");
        if (this.state !== "configured")
          throw new DOMException("Unconfigured", "InvalidStateError");
        const frameClone = frame.clone();
        this.encodeQueueSize++;
        this._p = this._p.then(() => __awaiter6(this, void 0, void 0, function* () {
          const libav2 = this._libav;
          const c2 = this._c;
          const pkt = this._pkt;
          const framePtr = this._frame;
          const swsOut = this._swsOut;
          let encodedOutputs = null;
          this.encodeQueueSize--;
          this.dispatchEvent(new CustomEvent("dequeue"));
          try {
            const format = wcFormatToLibAVFormat(libav2, frameClone.format);
            const rawU8 = frameClone._libavGetData();
            const layout = frameClone._libavGetLayout();
            const ptsFull = Math.floor(frameClone.timestamp / 1e3);
            const [pts, ptshi] = libav2.f64toi64(ptsFull);
            const frame2 = {
              data: rawU8,
              layout,
              format,
              pts,
              ptshi,
              width: frameClone.codedWidth,
              height: frameClone.codedHeight,
              crop: {
                left: frameClone.visibleRect.left,
                right: frameClone.visibleRect.right,
                top: frameClone.visibleRect.top,
                bottom: frameClone.visibleRect.bottom
              },
              key_frame: options.keyFrame ? 1 : 0,
              pict_type: options.keyFrame ? 1 : 0
            };
            if (frame2.width !== swsOut.width || frame2.height !== swsOut.height || frame2.format !== swsOut.format) {
              if (frameClone._nonSquarePixels) {
                frame2.sample_aspect_ratio = [
                  frameClone._sar_num,
                  frameClone._sar_den
                ];
              }
              let sws = this._sws, swsIn = this._swsIn, swsFrame = this._swsFrame;
              if (!sws || frame2.width !== swsIn.width || frame2.height !== swsIn.height || frame2.format !== swsIn.format) {
                if (sws)
                  yield libav2.sws_freeContext(sws);
                swsIn = {
                  width: frame2.width,
                  height: frame2.height,
                  format: frame2.format
                };
                sws = yield libav2.sws_getContext(swsIn.width, swsIn.height, swsIn.format, swsOut.width, swsOut.height, swsOut.format, 2, 0, 0, 0);
                this._sws = sws;
                this._swsIn = swsIn;
                if (!swsFrame)
                  this._swsFrame = swsFrame = yield libav2.av_frame_alloc();
              }
              const [, swsRes, , , , , , encRes] = yield Promise.all([
                libav2.ff_copyin_frame(framePtr, frame2),
                libav2.sws_scale_frame(sws, swsFrame, framePtr),
                this._nonSquarePixels ? libav2.AVFrame_sample_aspect_ratio_s(swsFrame, this._sar_num, this._sar_den) : null,
                libav2.AVFrame_pts_s(swsFrame, pts),
                libav2.AVFrame_ptshi_s(swsFrame, ptshi),
                libav2.AVFrame_key_frame_s(swsFrame, options.keyFrame ? 1 : 0),
                libav2.AVFrame_pict_type_s(swsFrame, options.keyFrame ? 1 : 0),
                libav2.avcodec_send_frame(c2, swsFrame)
              ]);
              if (swsRes < 0 || encRes < 0)
                throw new Error("Encoding failed!");
              encodedOutputs = [];
              while (true) {
                const recv = yield libav2.avcodec_receive_packet(c2, pkt);
                if (recv === -libav2.EAGAIN)
                  break;
                else if (recv < 0)
                  throw new Error("Encoding failed!");
                encodedOutputs.push(yield libav2.ff_copyout_packet(pkt));
              }
            } else {
              if (this._nonSquarePixels) {
                frame2.sample_aspect_ratio = [
                  this._sar_num,
                  this._sar_den
                ];
              }
              encodedOutputs = yield libav2.ff_encode_multi(c2, framePtr, pkt, [frame2]);
            }
            if (encodedOutputs.length && !this._extradataSet)
              yield this._getExtradata();
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeVideoEncoder(ex);
            });
            return;
          }
          if (encodedOutputs)
            this._outputEncodedVideoChunks(encodedOutputs);
        })).catch(this._error);
      }
      // Internal: Get extradata
      _getExtradata() {
        return __awaiter6(this, void 0, void 0, function* () {
          const libav2 = this._libav;
          const c2 = this._c;
          const extradata = yield libav2.AVCodecContext_extradata(c2);
          const extradata_size = yield libav2.AVCodecContext_extradata_size(c2);
          if (extradata && extradata_size) {
            this._metadata.decoderConfig.description = this._extradata = yield libav2.copyout_u8(extradata, extradata_size);
          }
          this._extradataSet = true;
        });
      }
      _outputEncodedVideoChunks(packets) {
        const libav2 = this._libav;
        for (const packet of packets) {
          const type = packet.flags & 1 ? "key" : "delta";
          const timestamp = libav2.i64tof64(packet.pts, packet.ptshi) * 1e3;
          const chunk = new EncodedVideoChunk2({
            type,
            timestamp,
            data: packet.data
          });
          if (this._extradataSet)
            this._output(chunk, this._metadata || void 0);
          else
            this._output(chunk);
        }
      }
      flush() {
        if (this.state !== "configured")
          throw new DOMException("Invalid state", "InvalidStateError");
        const ret = this._p.then(() => __awaiter6(this, void 0, void 0, function* () {
          if (!this._c)
            return;
          const libav2 = this._libav;
          const c2 = this._c;
          const frame = this._frame;
          const pkt = this._pkt;
          let encodedOutputs = null;
          try {
            encodedOutputs = yield libav2.ff_encode_multi(c2, frame, pkt, [], true);
            if (!this._extradataSet)
              yield this._getExtradata();
          } catch (ex) {
            this._p = this._p.then(() => {
              this._closeVideoEncoder(ex);
            });
          }
          {
            if (encodedOutputs)
              this._outputEncodedVideoChunks(encodedOutputs);
          }
        }));
        this._p = ret;
        return ret;
      }
      reset() {
        this._resetVideoEncoder(new DOMException("Reset", "AbortError"));
      }
      close() {
        this._closeVideoEncoder(new DOMException("Close", "AbortError"));
      }
      static isConfigSupported(config2) {
        return __awaiter6(this, void 0, void 0, function* () {
          const enc = encoder(config2.codec, config2);
          let supported2 = false;
          if (enc) {
            const libav2 = yield get();
            try {
              const [, c2, frame, pkt] = yield libav2.ff_init_encoder(enc.codec, enc);
              yield libav2.ff_free_encoder(c2, frame, pkt);
              supported2 = true;
            } catch (ex) {
            }
            yield free(libav2);
          }
          return {
            supported: supported2,
            config: cloneConfig(config2, ["codec", "width", "height", "bitrate", "framerate", "latencyMode"])
          };
        });
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/rendering.js
function load2(libavOptions2, polyfill2) {
  return __awaiter7(this, void 0, void 0, function* () {
    if ("importScripts" in globalThis) {
      LibAVWrapper.nolibavworker = true;
    }
    scalerSync = yield LibAVWrapper.LibAV(Object.assign(Object.assign({}, libavOptions2), { noworker: true, yesthreads: false }));
    scalerAsync = yield LibAVWrapper.LibAV(libavOptions2);
    if ("CanvasRenderingContext2D" in globalThis) {
      origDrawImage = CanvasRenderingContext2D.prototype.drawImage;
      if (polyfill2)
        CanvasRenderingContext2D.prototype.drawImage = drawImagePolyfill;
    }
    if ("OffscreenCanvasRenderingContext2D" in globalThis) {
      origDrawImageOffscreen = OffscreenCanvasRenderingContext2D.prototype.drawImage;
      if (polyfill2)
        OffscreenCanvasRenderingContext2D.prototype.drawImage = drawImagePolyfillOffscreen;
    }
    origCreateImageBitmap = globalThis.createImageBitmap;
    if (polyfill2)
      globalThis.createImageBitmap = createImageBitmap2;
  });
}
function canvasDrawImage(ctx, image, ax, ay, sWidth, sHeight, dx, dy, dWidth, dHeight) {
  if (!image._data) {
    return origDrawImage.apply(ctx, Array.prototype.slice.call(arguments, 1));
  }
  let sx;
  let sy;
  if (typeof sWidth === "undefined") {
    dx = ax;
    dy = ay;
  } else if (typeof dx === "undefined") {
    dx = ax;
    dy = ay;
    dWidth = sWidth;
    dHeight = sHeight;
    sx = void 0;
    sy = void 0;
    sWidth = void 0;
    sHeight = void 0;
  } else {
    sx = ax;
    sy = ay;
  }
  if (typeof dWidth === "undefined") {
    dWidth = image.displayWidth;
    dHeight = image.displayHeight;
  }
  const format = wcFormatToLibAVFormat(scalerSync, image.format);
  const sctx = scalerSync.sws_getContext_sync(image.visibleRect.width, image.visibleRect.height, format, dWidth, dHeight, scalerSync.AV_PIX_FMT_RGBA, 2, 0, 0, 0);
  const inFrame = scalerSync.av_frame_alloc_sync();
  const outFrame = scalerSync.av_frame_alloc_sync();
  let rawU8;
  let layout;
  if (image._libavGetData) {
    rawU8 = image._libavGetData();
    layout = image._libavGetLayout();
  } else {
    rawU8 = image._data;
    layout = image._layout;
  }
  scalerSync.ff_copyin_frame_sync(inFrame, {
    data: rawU8,
    layout,
    format,
    width: image.codedWidth,
    height: image.codedHeight,
    crop: {
      left: image.visibleRect.left,
      right: image.visibleRect.right,
      top: image.visibleRect.top,
      bottom: image.visibleRect.bottom
    }
  });
  scalerSync.sws_scale_frame_sync(sctx, outFrame, inFrame);
  const frameData = scalerSync.ff_copyout_frame_video_imagedata_sync(outFrame);
  ctx.putImageData(frameData, dx, dy);
  scalerSync.av_frame_free_js_sync(outFrame);
  scalerSync.av_frame_free_js_sync(inFrame);
  scalerSync.sws_freeContext_sync(sctx);
}
function drawImagePolyfill(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
  if (image instanceof VideoFrame2) {
    return canvasDrawImage(this, image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
  }
  return origDrawImage.apply(this, arguments);
}
function drawImagePolyfillOffscreen(image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight) {
  if (image instanceof VideoFrame2) {
    return canvasDrawImage(this, image, sx, sy, sWidth, sHeight, dx, dy, dWidth, dHeight);
  }
  return origDrawImageOffscreen.apply(this, arguments);
}
function createImageBitmap2(image, opts = {}) {
  if (!image._data) {
    return origCreateImageBitmap.apply(globalThis, arguments);
  }
  const format = wcFormatToLibAVFormat(scalerAsync, image.format);
  const dWidth = typeof opts.resizeWidth === "number" ? opts.resizeWidth : image.displayWidth;
  const dHeight = typeof opts.resizeHeight === "number" ? opts.resizeHeight : image.displayHeight;
  return (() => __awaiter7(this, void 0, void 0, function* () {
    const [sctx, inFrame, outFrame] = yield Promise.all([
      scalerAsync.sws_getContext(image.visibleRect.width, image.visibleRect.height, format, dWidth, dHeight, scalerAsync.AV_PIX_FMT_RGBA, 2, 0, 0, 0),
      scalerAsync.av_frame_alloc(),
      scalerAsync.av_frame_alloc()
    ]);
    let rawU8;
    let layout = void 0;
    if (image._libavGetData) {
      rawU8 = image._libavGetData();
      layout = image._libavGetLayout();
    } else if (image._data) {
      rawU8 = image._data;
      layout = image._layout;
    } else {
      rawU8 = new Uint8Array(image.allocationSize());
      yield image.copyTo(rawU8);
    }
    yield scalerAsync.ff_copyin_frame(inFrame, {
      data: rawU8,
      layout,
      format,
      width: image.codedWidth,
      height: image.codedHeight,
      crop: {
        left: image.visibleRect.left,
        right: image.visibleRect.right,
        top: image.visibleRect.top,
        bottom: image.visibleRect.bottom
      }
    }), // Rescale
    yield scalerAsync.sws_scale_frame(sctx, outFrame, inFrame);
    const frameData = yield scalerAsync.ff_copyout_frame_video_imagedata(outFrame);
    yield Promise.all([
      scalerAsync.av_frame_free_js(outFrame),
      scalerAsync.av_frame_free_js(inFrame),
      scalerAsync.sws_freeContext(sctx)
    ]);
    return yield origCreateImageBitmap(frameData);
  }))();
}
var __awaiter7, scalerSync, scalerAsync, origDrawImage, origDrawImageOffscreen, origCreateImageBitmap;
var init_rendering = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/rendering.js"() {
    init_avloader();
    init_video_frame();
    init_esm();
    __awaiter7 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    scalerSync = null;
    scalerAsync = null;
    origDrawImage = null;
    origDrawImageOffscreen = null;
    origCreateImageBitmap = null;
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/config.js
function getAudioDecoder(config2) {
  return __awaiter8(this, void 0, void 0, function* () {
    try {
      if (typeof globalThis.AudioDecoder !== "undefined" && (yield globalThis.AudioDecoder.isConfigSupported(config2)).supported) {
        return {
          AudioDecoder: globalThis.AudioDecoder,
          EncodedAudioChunk: globalThis.EncodedAudioChunk,
          AudioData: globalThis.AudioData
        };
      }
    } catch (ex) {
    }
    if ((yield AudioDecoder2.isConfigSupported(config2)).supported) {
      return {
        AudioDecoder: AudioDecoder2,
        EncodedAudioChunk: EncodedAudioChunk2,
        AudioData: AudioData2
      };
    }
    throw new UnsupportedException();
  });
}
function getVideoDecoder(config2) {
  return __awaiter8(this, void 0, void 0, function* () {
    try {
      if (typeof globalThis.VideoDecoder !== "undefined" && (yield globalThis.VideoDecoder.isConfigSupported(config2)).supported) {
        return {
          VideoDecoder: globalThis.VideoDecoder,
          EncodedVideoChunk: globalThis.EncodedVideoChunk,
          VideoFrame: globalThis.VideoFrame
        };
      }
    } catch (ex) {
    }
    if ((yield VideoDecoder2.isConfigSupported(config2)).supported) {
      return {
        VideoDecoder: VideoDecoder2,
        EncodedVideoChunk: EncodedVideoChunk2,
        VideoFrame: VideoFrame2
      };
    }
    throw new UnsupportedException();
  });
}
function getAudioEncoder(config2) {
  return __awaiter8(this, void 0, void 0, function* () {
    try {
      if (typeof globalThis.AudioEncoder !== "undefined" && (yield globalThis.AudioEncoder.isConfigSupported(config2)).supported) {
        return {
          AudioEncoder: globalThis.AudioEncoder,
          EncodedAudioChunk: globalThis.EncodedAudioChunk,
          AudioData: globalThis.AudioData
        };
      }
    } catch (ex) {
    }
    if ((yield AudioEncoder2.isConfigSupported(config2)).supported) {
      return {
        AudioEncoder: AudioEncoder2,
        EncodedAudioChunk: EncodedAudioChunk2,
        AudioData: AudioData2
      };
    }
    throw new UnsupportedException();
  });
}
function getVideoEncoder(config2) {
  return __awaiter8(this, void 0, void 0, function* () {
    try {
      if (typeof globalThis.VideoEncoder !== "undefined" && (yield globalThis.VideoEncoder.isConfigSupported(config2)).supported) {
        return {
          VideoEncoder: globalThis.VideoEncoder,
          EncodedVideoChunk: globalThis.EncodedVideoChunk,
          VideoFrame: globalThis.VideoFrame
        };
      }
    } catch (ex) {
    }
    if ((yield VideoEncoder2.isConfigSupported(config2)).supported) {
      return {
        VideoEncoder: VideoEncoder2,
        EncodedVideoChunk: EncodedVideoChunk2,
        VideoFrame: VideoFrame2
      };
    }
    throw new UnsupportedException();
  });
}
var __awaiter8, UnsupportedException;
var init_config = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/config.js"() {
    init_encoded_audio_chunk();
    init_audio_data();
    init_audio_decoder();
    init_audio_encoder();
    init_encoded_video_chunk();
    init_video_frame();
    init_video_decoder();
    init_video_encoder();
    init_esm();
    __awaiter8 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    UnsupportedException = class extends Error {
      constructor() {
        super("The requested configuration is not supported");
      }
    };
  }
});

// ../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/main.js
var main_exports = {};
__export(main_exports, {
  AudioData: () => AudioData3,
  AudioDecoder: () => AudioDecoder3,
  AudioEncoder: () => AudioEncoder3,
  EncodedAudioChunk: () => EncodedAudioChunk3,
  EncodedVideoChunk: () => EncodedVideoChunk3,
  UnsupportedException: () => UnsupportedException2,
  VideoDecoder: () => VideoDecoder3,
  VideoEncoder: () => VideoEncoder3,
  VideoFrame: () => VideoFrame3,
  canvasDrawImage: () => canvasDrawImage2,
  createImageBitmap: () => createImageBitmap3,
  getAudioDecoder: () => getAudioDecoder2,
  getAudioEncoder: () => getAudioEncoder2,
  getVideoDecoder: () => getVideoDecoder2,
  getVideoEncoder: () => getVideoEncoder2,
  load: () => load3
});
function load3(options = {}) {
  return __awaiter9(this, void 0, void 0, function* () {
    let libavOptions2 = {};
    if (options.libavOptions)
      Object.assign(libavOptions2, options.libavOptions);
    if (!options.LibAV && typeof globalThis.LibAV === "undefined") {
      yield new Promise((res, rej) => {
        libavOptions2.noworker = true;
        const libavBase = "https://cdn.jsdelivr.net/npm/@libav.js/variant-webm-vp9@6.7.7/dist";
        globalThis.LibAV = { base: libavBase };
        const libavVar = "libav-6.7.7.1.1-webm-vp9.js";
        if (typeof importScripts !== "undefined") {
          importScripts(`${libavBase}/${libavVar}`);
          res(void 0);
        } else {
          const scr = document.createElement("script");
          scr.src = `${libavBase}/${libavVar}`;
          scr.onload = res;
          scr.onerror = rej;
          document.body.appendChild(scr);
        }
      });
    }
    if (options.LibAV)
      setLibAV(options.LibAV);
    setLibAVOptions(libavOptions2);
    yield load();
    if (options.polyfill) {
      for (const exp of [
        ["EncodedAudioChunk", EncodedAudioChunk2],
        ["AudioData", AudioData2],
        ["AudioDecoder", AudioDecoder2],
        ["AudioEncoder", AudioEncoder2],
        ["EncodedVideoChunk", EncodedVideoChunk2],
        ["VideoFrame", VideoFrame2],
        ["VideoDecoder", VideoDecoder2],
        ["VideoEncoder", VideoEncoder2]
      ]) {
        if (!globalThis[exp[0]])
          globalThis[exp[0]] = exp[1];
      }
    }
    yield load2(libavOptions2, !!options.polyfill);
  });
}
var __awaiter9, EncodedAudioChunk3, AudioData3, AudioDecoder3, AudioEncoder3, EncodedVideoChunk3, VideoFrame3, VideoDecoder3, VideoEncoder3, canvasDrawImage2, createImageBitmap3, UnsupportedException2, getAudioDecoder2, getVideoDecoder2, getAudioEncoder2, getVideoEncoder2;
var init_main = __esm({
  "../../node_modules/@kixelated/libavjs-webcodecs-polyfill/dist/main.js"() {
    init_encoded_audio_chunk();
    init_audio_data();
    init_audio_decoder();
    init_audio_encoder();
    init_encoded_video_chunk();
    init_video_frame();
    init_video_decoder();
    init_video_encoder();
    init_rendering();
    init_config();
    init_avloader();
    init_esm();
    __awaiter9 = function(thisArg, _arguments, P2, generator) {
      function adopt(value) {
        return value instanceof P2 ? value : new P2(function(resolve2) {
          resolve2(value);
        });
      }
      return new (P2 || (P2 = Promise))(function(resolve2, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e5) {
            reject(e5);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e5) {
            reject(e5);
          }
        }
        function step(result) {
          result.done ? resolve2(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    EncodedAudioChunk3 = EncodedAudioChunk2;
    AudioData3 = AudioData2;
    AudioDecoder3 = AudioDecoder2;
    AudioEncoder3 = AudioEncoder2;
    EncodedVideoChunk3 = EncodedVideoChunk2;
    VideoFrame3 = VideoFrame2;
    VideoDecoder3 = VideoDecoder2;
    VideoEncoder3 = VideoEncoder2;
    canvasDrawImage2 = canvasDrawImage;
    createImageBitmap3 = createImageBitmap2;
    UnsupportedException2 = UnsupportedException;
    getAudioDecoder2 = getAudioDecoder;
    getVideoDecoder2 = getVideoDecoder;
    getAudioEncoder2 = getAudioEncoder;
    getVideoEncoder2 = getVideoEncoder;
  }
});

// ../../node_modules/@moq/hang/util/libav.js
var libav_exports = {};
__export(libav_exports, {
  polyfill: () => polyfill
});
async function polyfill() {
  if (globalThis.AudioEncoder && globalThis.AudioDecoder) {
    return true;
  }
  if (!loading) {
    console.warn("using Opus polyfill; performance may be degraded");
    loading = Promise.all([
      Promise.resolve().then(() => (init_libav_opus_af(), libav_opus_af_exports)),
      Promise.resolve().then(() => (init_main(), main_exports))
    ]).then(async ([opus, libav2]) => {
      await libav2.load({
        LibAV: opus,
        polyfill: true
      });
      return true;
    });
  }
  return await loading;
}
var loading;
var init_libav = __esm({
  "../../node_modules/@moq/hang/util/libav.js"() {
  }
});

// ../../node_modules/@moq/hang/util/opus.js
var opus_exports = {};
__export(opus_exports, {
  DEFAULT_SAMPLE_RATE: () => DEFAULT_SAMPLE_RATE,
  SAMPLE_RATES: () => SAMPLE_RATES2,
  pickRate: () => pickRate2,
  preSkip: () => preSkip,
  supportsRate: () => supportsRate2,
  toDOps: () => toDOps
});
function supportsRate2(rate) {
  return SAMPLE_RATES2.includes(rate);
}
function pickRate2(rate) {
  return SAMPLE_RATES2.find((r2) => r2 >= rate) ?? DEFAULT_SAMPLE_RATE;
}
function header(description) {
  let offset = 0;
  let littleEndian = false;
  if (description.length >= OPUS_HEAD.length && OPUS_HEAD.every((byte, index2) => description[index2] === byte)) {
    offset = OPUS_HEAD.length;
    littleEndian = true;
  } else if (description[0] === 1) {
    littleEndian = true;
  } else if (description[0] !== 0) {
    throw new Error("invalid Opus decoder description");
  }
  if (description.length - offset < 11) {
    throw new Error("Opus decoder description must contain at least 11 bytes");
  }
  return { offset, littleEndian };
}
function preSkip(description) {
  const { offset, littleEndian } = header(description);
  return new DataView(description.buffer, description.byteOffset + offset, 11).getUint16(2, littleEndian);
}
function toDOps(description) {
  const { offset, littleEndian } = header(description);
  if (!littleEndian) {
    return description.slice(offset);
  }
  const input = new DataView(description.buffer, description.byteOffset + offset, 11);
  const output = description.slice(offset);
  const view = new DataView(output.buffer);
  output[0] = 0;
  output[1] = input.getUint8(1);
  view.setUint16(2, input.getUint16(2, true), false);
  view.setUint32(4, input.getUint32(4, true), false);
  view.setInt16(8, input.getInt16(8, true), false);
  output[10] = input.getUint8(10);
  return output;
}
var DEFAULT_SAMPLE_RATE, SAMPLE_RATES2, OPUS_HEAD;
var init_opus = __esm({
  "../../node_modules/@moq/hang/util/opus.js"() {
    DEFAULT_SAMPLE_RATE = 48e3;
    SAMPLE_RATES2 = Object.freeze([8e3, 12e3, 16e3, 24e3, DEFAULT_SAMPLE_RATE]);
    OPUS_HEAD = new TextEncoder().encode("OpusHead");
  }
});

// ../../node_modules/@moq/hang/util/index.js
var init_util2 = __esm({
  "../../node_modules/@moq/hang/util/index.js"() {
    init_aac();
    init_gesture();
    init_hacks();
    init_hex2();
    init_libav();
    init_opus();
  }
});

// ../../node_modules/@moq/publish/video-B0t1PcDc.js
function i(e5) {
  let t;
  try {
    if (t = r && (self.URL || self.webkitURL).createObjectURL(r), !t) throw "";
    let n2 = new Worker(t, { name: e5?.name });
    return n2.addEventListener("error", () => {
      (self.URL || self.webkitURL).revokeObjectURL(t);
    }), n2;
  } catch {
    return new Worker("data:text/javascript;charset=utf-8," + encodeURIComponent(n), { name: e5?.name });
  }
}
function a(e5) {
  return "MediaStreamTrackProcessor" in self ? new MediaStreamTrackProcessor({ track: e5 }).readable.pipeThrough(l()) : m(async () => await u(e5) ?? p(e5));
}
function l() {
  let e5 = new c();
  return new TransformStream({ transform(t, n2) {
    n2.enqueue(e5.stamp(t, performance.now()));
  } });
}
async function u(e5) {
  let t = await d();
  if (!t) return;
  let n2 = e5.clone();
  try {
    t.post({
      type: "start",
      track: n2
    }, [n2]);
  } catch (e6) {
    console.warn("moq-publish: MediaStreamTrack is not transferable", e6), n2.stop(), t.close();
    return;
  }
  let r2 = new c();
  return new ReadableStream({
    async pull(e6) {
      t.post({ type: "pull" });
      let n3 = await t.next();
      switch (n3.type) {
        case "frame":
          e6.enqueue(r2.stamp(n3.frame, n3.at - performance.timeOrigin));
          return;
        case "done":
          t.close(), e6.close();
          return;
        default:
          throw t.close(), Error(n3.type === "error" ? n3.message : `unexpected message: ${n3.type}`);
      }
    },
    cancel() {
      t.close();
    }
  });
}
async function d() {
  let e5;
  try {
    e5 = f(new i());
  } catch (e6) {
    console.warn("moq-publish: failed to start the capture worker", e6);
    return;
  }
  let t = await e5.next();
  if (t.type !== "ready" || !t.supported) {
    e5.close();
    return;
  }
  return e5;
}
function f(e5) {
  let t = [], n2, r2 = (e6) => {
    let r3 = n2;
    n2 = void 0, r3 ? r3(e6) : t.push(e6);
  };
  return e5.onmessage = (e6) => r2(e6.data), e5.onerror = (e6) => r2({
    type: "error",
    message: e6.message
  }), e5.onmessageerror = () => r2({
    type: "error",
    message: "failed to deserialize message"
  }), {
    post: (t2, n3) => {
      e5.postMessage(t2, n3 ?? []);
    },
    next: () => {
      let e6 = t.shift();
      return e6 ? Promise.resolve(e6) : new Promise((e7) => {
        n2 = e7;
      });
    },
    close: () => {
      r2({
        type: "error",
        message: "worker terminated"
      }), e5.terminate();
    }
  };
}
function p(t) {
  console.warn("Using MediaStreamTrackProcessor polyfill; performance might suffer.");
  let n2, r2;
  return new ReadableStream({
    async start() {
      n2 = document.createElement("video"), n2.srcObject = new MediaStream([t]), await Promise.all([n2.play(), new Promise((e5) => {
        n2.onloadedmetadata = e5;
      })]);
    },
    async pull(t2) {
      await new Promise((i2) => {
        r2 = n2.requestVideoFrameCallback((r3, a2) => {
          let o = a2.captureTime ?? r3;
          t2.enqueue(new VideoFrame(n2, { timestamp: time_exports.Micro.fromMilli(o) })), i2();
        });
      });
    },
    cancel() {
      r2 !== void 0 && n2.cancelVideoFrameCallback(r2), n2 && (n2.srcObject = null);
    }
  });
}
function m(e5) {
  let t, n2 = false;
  return new ReadableStream({
    async start() {
      let r2 = await e5();
      if (n2) {
        await r2.cancel();
        return;
      }
      t = r2.getReader();
    },
    async pull(e6) {
      if (!t) {
        e6.close();
        return;
      }
      let { value: n3 } = await t.read();
      n3 ? e6.enqueue(n3) : e6.close();
    },
    async cancel(e6) {
      n2 = true, await t?.cancel(e6);
    }
  });
}
function h() {
  let e5 = navigator.userAgent.match(/Firefox\/(\d+)/i)?.[1];
  return !hacks_exports.isSafari && (e5 === void 0 || Number(e5) >= 143);
}
var n, r, c;
var init_video_B0t1PcDc = __esm({
  "../../node_modules/@moq/publish/video-B0t1PcDc.js"() {
    init_net();
    init_util2();
    n = "(function(){let e=self,t,n;e.addEventListener(`message`,e=>{r(e.data)}),e.postMessage({type:`ready`,supported:`MediaStreamTrackProcessor`in globalThis});async function r(t){try{switch(t.type){case`start`:i(t.track);return;case`pull`:await a();return}}catch(t){o(),e.postMessage({type:`error`,message:`${t}`})}}function i(e){n=e,t=new MediaStreamTrackProcessor({track:e}).readable.getReader()}async function a(){if(!t)throw Error(`not started`);let{value:n}=await t.read(),r=performance.timeOrigin+performance.now();if(!n){o(),e.postMessage({type:`done`});return}e.postMessage({type:`frame`,frame:n,at:r},[n])}function o(){t?.cancel(),t=void 0,n?.stop(),n=void 0}})();\n//# sourceMappingURL=capture-worker-BrEQqi2v.js.map";
    r = typeof self < "u" && self.Blob && new Blob(["(self.URL || self.webkitURL).revokeObjectURL(self.location.href);", n], { type: "text/javascript;charset=utf-8" });
    c = class {
      #e;
      #t = 0;
      #n;
      stamp(e5, t) {
        let n2 = t * 1e3;
        this.#e === void 0 ? (this.#e = e5.timestamp, this.#t = n2) : this.#n === void 0 && (this.#n = e5.timestamp === this.#e);
        let r2 = this.#n ? n2 : e5.timestamp - this.#e + this.#t, i2 = new VideoFrame(e5, { timestamp: r2 });
        return e5.close(), i2;
      }
    };
  }
});

// ../../node_modules/@zod/mini/index.js
var init_mini2 = __esm({
  "../../node_modules/@zod/mini/index.js"() {
    init_mini();
  }
});

// ../../node_modules/@moq/hang/catalog/integers.js
function u53(value) {
  return u53Schema.parse(value);
}
var u8Schema, u53Schema, nonzeroU53Schema;
var init_integers = __esm({
  "../../node_modules/@moq/hang/catalog/integers.js"() {
    init_mini2();
    u8Schema = number2().check(int(), _nonnegative(), _lte(255)).brand("u8");
    u53Schema = number2().check(int(), _nonnegative(), _lte(Number.MAX_SAFE_INTEGER)).brand("u53");
    nonzeroU53Schema = number2().check(int(), _positive(), _lte(Number.MAX_SAFE_INTEGER)).brand("u53");
  }
});

// ../../node_modules/@moq/hang/catalog/path.js
var RelativeBroadcastSchema;
var init_path2 = __esm({
  "../../node_modules/@moq/hang/catalog/path.js"() {
    init_net();
    init_mini2();
    RelativeBroadcastSchema = pipe(string2(), transform(path_exports.normalizeRelative));
  }
});

// ../../node_modules/@moq/hang/catalog/archive.js
var MOQ_EPOCH_UNIX_MILLIS, timescaleSchema, ArchiveSchema;
var init_archive = __esm({
  "../../node_modules/@moq/hang/catalog/archive.js"() {
    init_mini2();
    init_integers();
    init_path2();
    MOQ_EPOCH_UNIX_MILLIS = 15778368e5;
    timescaleSchema = nonzeroU53Schema.check(_lte(4294967295));
    ArchiveSchema = object({
      // The name of the MoQ track carrying the broadcast's segment records.
      track: string2(),
      // Units per second for the records' timestamps. Defaults to milliseconds.
      timescale: _default(timescaleSchema, u53(1e3)),
      // The declared upper bound on a segment's duration in timescale units.
      durationMax: optional(u53Schema),
      // The MoQ broadcast the archive is served back from, relative to this catalog, if any.
      // Absent when the timeline lives on this broadcast. A wildcard replay path names no
      // generation: compare this path and `store` to tell recordings apart.
      replay: optional(RelativeBroadcastSchema),
      // The object-store URL the recording objects live under, if the publisher exposes one.
      store: optional(url()),
      // The recording object format version, {@link ARCHIVE_VERSION} when this package writes
      // objects. Absent when there is no store.
      version: optional(u53Schema)
    });
  }
});

// ../../node_modules/@moq/hang/catalog/container.js
function containerSupported(container) {
  return container.kind !== "unknown";
}
var KNOWN_KINDS, UnknownContainerSchema, ContainerSchema;
var init_container = __esm({
  "../../node_modules/@moq/hang/catalog/container.js"() {
    init_mini2();
    KNOWN_KINDS = ["legacy", "cmaf", "loc"];
    UnknownContainerSchema = pipe(
      looseObject({
        kind: string2().check(refine((kind) => !KNOWN_KINDS.includes(kind), {
          message: "recognized container kind must match its own schema"
        }))
      }),
      // Map to a literal `kind` so {@link Container} stays a discriminated union: a bare
      // `kind: string` arm would widen the discriminant and stop `kind === "cmaf"` from
      // narrowing. `raw` keeps the original object, including its real `kind`.
      transform((raw) => ({ kind: "unknown", raw }))
    );
    ContainerSchema = _default(union([
      discriminatedUnion("kind", [
        // The default hang container
        object({ kind: literal("legacy") }),
        // CMAF container with base64-encoded init segment (ftyp+moov).
        object({
          kind: literal("cmaf"),
          init: base64()
        }),
        // Low Overhead Container.
        object({ kind: literal("loc") })
      ]),
      UnknownContainerSchema
    ]), { kind: "legacy" });
  }
});

// ../../node_modules/@moq/hang/catalog/hex.js
var hexSchema;
var init_hex3 = __esm({
  "../../node_modules/@moq/hang/catalog/hex.js"() {
    init_mini2();
    hexSchema = string2().check(_regex(/^([0-9a-fA-F]{2})*$/, "expected hex"));
  }
});

// ../../node_modules/@moq/hang/catalog/audio.js
var TrackSchema, AudioConfigSchema, AudioSchema;
var init_audio = __esm({
  "../../node_modules/@moq/hang/catalog/audio.js"() {
    init_mini2();
    init_container();
    init_hex3();
    init_integers();
    init_path2();
    TrackSchema = object({
      name: string2()
    });
    AudioConfigSchema = object({
      // Optional reference to another broadcast that publishes this track, expressed
      // relative to the broadcast that served this catalog (e.g. "./source").
      // If unset, the track lives in the same broadcast as the catalog.
      broadcast: optional(RelativeBroadcastSchema),
      // Human-readable rendition name for track pickers.
      label: optional(string2()),
      // Registered WebCodecs codec string, or Hang's "pcm" extension for
      // interleaved little-endian IEEE-754 binary32 samples.
      codec: string2(),
      // The container format, used to decode the timestamp and more.
      container: ContainerSchema,
      // The description is used for some codecs.
      // If provided, we can initialize the decoder based on the catalog alone.
      // Otherwise, the initialization information is in-band.
      description: optional(hexSchema),
      // The sample rate of the audio in Hz
      sampleRate: u53Schema,
      // The number of channels in the audio
      numberOfChannels: u53Schema,
      // The bitrate of the audio in bits per second
      // TODO: Support up to Number.MAX_SAFE_INTEGER
      bitrate: optional(u53Schema),
      // The maximum delay between a frame being ready and the publisher flushing it, in whole
      // milliseconds rounded up. The player's jitter buffer should be larger than this value.
      // If not provided, the player should assume each frame is flushed immediately.
      //
      // This is measured at the publisher (encoder latency, packet packing, reordering),
      // never on the network a consumer sees. It only ever grows over the life of a stream.
      //
      // NOTE: The audio "frame" duration depends on the codec, sample rate, etc.
      // ex: AAC often uses 1024 samples per frame, so at 44100Hz, this would be 1024/44100 = 24ms
      jitter: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value))),
      // How far this rendition's frames reach the transport behind the broadcast's earliest
      // rendition, in whole milliseconds rounded up. A player holds `delay + jitter` for it and never
      // subtracts one rendition's `delay` from another's. Absent on the earliest rendition. It only
      // ever grows over the life of a stream.
      delay: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value)))
    });
    AudioSchema = union([
      object({
        // A map of track name to rendition configuration.
        // This is not an array so it will work with JSON Merge Patch.
        renditions: record(string2(), AudioConfigSchema)
      }),
      // Backwards compatibility: transform old {track, config} format to new object format
      pipe(object({
        track: TrackSchema,
        config: AudioConfigSchema
      }), transform((old) => ({
        renditions: { [old.track.name]: old.config }
      })))
    ]);
  }
});

// ../../node_modules/@moq/hang/catalog/compression.js
var CompressionSchema;
var init_compression2 = __esm({
  "../../node_modules/@moq/hang/catalog/compression.js"() {
    init_mini();
    CompressionSchema = string2();
  }
});

// ../../node_modules/@moq/hang/catalog/mode.js
var ModeSchema;
var init_mode = __esm({
  "../../node_modules/@moq/hang/catalog/mode.js"() {
    init_mini();
    ModeSchema = string2();
  }
});

// ../../node_modules/@moq/hang/catalog/binary.js
var BinaryConfigSchema, BinarySchema;
var init_binary = __esm({
  "../../node_modules/@moq/hang/catalog/binary.js"() {
    init_mini();
    init_compression2();
    init_integers();
    init_mode();
    init_path2();
    BinaryConfigSchema = looseObject({
      // Optional reference to another broadcast that publishes this track, expressed
      // relative to the broadcast that served this catalog (e.g. "./source").
      // If unset, the track lives in the same broadcast as the catalog.
      broadcast: optional(RelativeBroadcastSchema),
      // Whether the track is a latest-value blob or an append log. Always stated.
      mode: ModeSchema,
      // The compression applied to each frame, or absent when they are written through untouched.
      compression: optional(CompressionSchema),
      // An optional media type for each payload (e.g. "image/jpeg"). Purely descriptive:
      // a consumer that doesn't recognize it can still read the track.
      mime: optional(string2()),
      // The maximum bitrate of the track in bits per second, if known.
      bitrate: optional(u53Schema),
      // The maximum delay between a payload being ready and the publisher flushing it, in whole
      // milliseconds rounded up, with the same meaning as a video rendition's `jitter`.
      jitter: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value))),
      // How far this track's payloads reach the transport behind the broadcast's earliest rendition,
      // with the same meaning and encoding as a video rendition's `delay`. Only measured for payloads
      // that carry a capture time.
      delay: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value)))
    });
    BinarySchema = object({
      tracks: record(string2(), BinaryConfigSchema)
    });
  }
});

// ../../node_modules/@moq/hang/catalog/clock.js
var clockTimescaleSchema, ClockSchema;
var init_clock = __esm({
  "../../node_modules/@moq/hang/catalog/clock.js"() {
    init_mini2();
    init_integers();
    clockTimescaleSchema = number2().check(int(), _positive(), _lte(4294967295));
    ClockSchema = object({
      // The wall-clock time of PTS zero, in `timescale` units since the moq epoch. Must fit in a
      // JSON-safe integer so browsers read back exactly what the publisher wrote.
      wall: u53Schema,
      // Units per second for `wall`. Defaults to 1_000_000 (microseconds), the broadcast clock's
      // own timescale. Zero is refused: no timestamp can be expressed in it. Bounded to u32 so
      // Rust and JS accept the same catalogs.
      timescale: _default(clockTimescaleSchema, 1e6)
    });
  }
});

// ../../node_modules/@moq/hang/catalog/format.js
function detectFormat(name) {
  for (const format of FORMATS) {
    if (name.endsWith(`.${format}`))
      return format;
  }
  return void 0;
}
var TRACK3, TRACK_COMPRESSED, FORMATS, DEFAULT_FORMAT;
var init_format = __esm({
  "../../node_modules/@moq/hang/catalog/format.js"() {
    TRACK3 = "catalog.json";
    TRACK_COMPRESSED = "catalog.json.z";
    FORMATS = ["hang", "msf"];
    DEFAULT_FORMAT = "hang";
  }
});

// ../../node_modules/@moq/hang/catalog/json.js
var JsonConfigSchema, JsonSchema;
var init_json2 = __esm({
  "../../node_modules/@moq/hang/catalog/json.js"() {
    init_mini();
    init_compression2();
    init_integers();
    init_mode();
    init_path2();
    JsonConfigSchema = looseObject({
      // Optional reference to another broadcast that publishes this track, expressed
      // relative to the broadcast that served this catalog (e.g. "./source").
      // If unset, the track lives in the same broadcast as the catalog.
      broadcast: optional(RelativeBroadcastSchema),
      // Whether the track is a latest-value document or an append log. Always stated.
      mode: ModeSchema,
      // The compression applied to each frame, or absent when they are plaintext.
      compression: optional(CompressionSchema),
      // An optional identifier for the shape of each value, typically a JSON Schema URL.
      // Purely descriptive: a consumer that doesn't recognize it can still read the track.
      schema: optional(string2()),
      // The maximum bitrate of the track in bits per second, if known.
      bitrate: optional(u53Schema),
      // The maximum delay between a payload being ready and the publisher flushing it, in whole
      // milliseconds rounded up, with the same meaning as a video rendition's `jitter`.
      jitter: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value))),
      // How far this track's payloads reach the transport behind the broadcast's earliest rendition,
      // with the same meaning and encoding as a video rendition's `delay`. Only measured for payloads
      // that carry a capture time.
      delay: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value)))
    });
    JsonSchema = object({
      tracks: record(string2(), JsonConfigSchema)
    });
  }
});

// ../../node_modules/@moq/hang/catalog/priority.js
var PRIORITY;
var init_priority3 = __esm({
  "../../node_modules/@moq/hang/catalog/priority.js"() {
    PRIORITY = {
      catalog: 100,
      text: 90,
      audio: 80,
      video: 60
    };
  }
});

// ../../node_modules/@moq/hang/catalog/section.js
function section(schema, map) {
  return optional(union([
    schema,
    pipe(custom((value) => {
      if (typeof value !== "object" || value === null || !(map in value))
        return true;
      const inner = value[map];
      return typeof inner !== "object" || inner === null || Array.isArray(inner);
    }), transform(() => void 0))
  ]));
}
var init_section = __esm({
  "../../node_modules/@moq/hang/catalog/section.js"() {
    init_mini();
  }
});

// ../../node_modules/@moq/hang/catalog/text.js
var TextFormatSchema, TextRoleSchema, TextConfigSchema, TextSchema;
var init_text = __esm({
  "../../node_modules/@moq/hang/catalog/text.js"() {
    init_mini();
    init_container();
    init_integers();
    init_path2();
    TextFormatSchema = string2();
    TextRoleSchema = string2();
    TextConfigSchema = object({
      // Optional reference to another broadcast that publishes this track, expressed relative to the
      // broadcast that served this catalog (e.g. "../source"). If unset, the track lives in the same
      // broadcast as the catalog.
      broadcast: optional(RelativeBroadcastSchema),
      // The cue serialization format: "vtt" | "ttml" | "utf8" | (unknown).
      format: TextFormatSchema,
      // The accessibility role, defaulting to "subtitle".
      role: _default(TextRoleSchema, "subtitle"),
      // The BCP-47 language tag (e.g. "en", "es-419"), if known.
      lang: optional(string2()),
      // A human-readable label for a track picker, when `lang` alone is ambiguous.
      label: optional(string2()),
      // The container format, used to decode the timestamp and frame the payload.
      container: ContainerSchema,
      // The maximum jitter before the next cue is flushed, in milliseconds. The player's jitter buffer
      // should be at least this large; absent means each cue is flushed immediately.
      jitter: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value))),
      // How far this rendition's frames reach the transport behind the broadcast's earliest
      // rendition, in whole milliseconds rounded up. A player holds `delay + jitter` for it and never
      // subtracts one rendition's `delay` from another's. Absent on the earliest rendition. It only
      // ever grows over the life of a stream.
      delay: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value)))
    });
    TextSchema = object({
      // A map of track name to rendition configuration.
      // This is not an array so it will work with JSON Merge Patch.
      renditions: record(string2(), TextConfigSchema)
    });
  }
});

// ../../node_modules/@moq/hang/catalog/video.js
var TrackSchema2, VideoConfigSchema, VideoSchema;
var init_video = __esm({
  "../../node_modules/@moq/hang/catalog/video.js"() {
    init_mini2();
    init_container();
    init_hex3();
    init_integers();
    init_path2();
    TrackSchema2 = object({
      name: string2()
    });
    VideoConfigSchema = object({
      // Optional reference to another broadcast that publishes this track, expressed
      // relative to the broadcast that served this catalog (e.g. "./source").
      // If unset, the track lives in the same broadcast as the catalog.
      broadcast: optional(RelativeBroadcastSchema),
      // Human-readable rendition name for track pickers.
      label: optional(string2()),
      // See: https://w3c.github.io/webcodecs/codec_registry.html
      codec: string2(),
      // The container format, used to decode the timestamp and more.
      container: ContainerSchema,
      // The description is used for some codecs.
      // If provided, we can initialize the decoder based on the catalog alone.
      // Otherwise, the initialization information is (repeated) before each key-frame.
      description: optional(hexSchema),
      // The width and height of the video in pixels.
      // NOTE: formats that don't use a description can adjust these values in-band.
      codedWidth: optional(u53Schema),
      codedHeight: optional(u53Schema),
      // Ratio of display width/height to coded width/height
      // Allows stretching/squishing individual "pixels" of the video
      // If not provided, the display ratio is 1:1
      displayAspectWidth: optional(u53Schema),
      displayAspectHeight: optional(u53Schema),
      // The frame rate of the video in frames per second
      framerate: optional(number2()),
      // The bitrate of the video in bits per second
      // TODO: Support up to Number.MAX_SAFE_INTEGER
      bitrate: optional(u53Schema),
      // Whether the publisher recommends temporarily avoiding this rendition.
      // The track remains available and may still be selected as a fallback.
      stalled: optional(boolean2()),
      // If true, the decoder will optimize for latency.
      // Default: true
      optimizeForLatency: optional(boolean2()),
      // The maximum delay between a frame being ready and the publisher flushing it, in whole
      // milliseconds rounded up. The player's jitter buffer should be larger than this value.
      // If not provided, the player should assume each frame is flushed immediately.
      //
      // This is measured at the publisher (encoder latency, segment size, B-frame reordering),
      // never on the network a consumer sees. It only ever grows over the life of a stream.
      //
      // ex:
      // - If each frame is flushed immediately, this would be 1000/fps.
      // - If there can be up to 3 b-frames in a row, this would be 3 * 1000/fps.
      // - If frames are buffered into 2s segments, this would be 2s.
      jitter: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value))),
      // How far this rendition's frames reach the transport behind the broadcast's earliest
      // rendition, in whole milliseconds rounded up. A player holds `delay + jitter` for it and never
      // subtracts one rendition's `delay` from another's. Absent on the earliest rendition. It only
      // ever grows over the life of a stream.
      delay: optional(pipe(u53Schema, transform((value) => value === 0 ? void 0 : value)))
    });
    VideoSchema = union([
      object({
        // A map of track name to rendition configuration.
        // This is not an array in order for it to work with JSON Merge Patch.
        renditions: record(string2(), VideoConfigSchema),
        // Render the video at this size in pixels.
        // This is separate from the display aspect ratio because it does not require reinitialization.
        display: optional(object({
          width: u53Schema,
          height: u53Schema
        })),
        // The rotation of the video in degrees.
        // Default: 0
        rotation: optional(number2()),
        // If true, the decoder will flip the video horizontally
        // Default: false
        flip: optional(boolean2())
      }),
      // Backwards compatibility: transform old array of {track, config} to new object format
      pipe(array(object({
        track: TrackSchema2,
        config: VideoConfigSchema
      })), transform((arr) => {
        const config2 = arr[0]?.config;
        return {
          renditions: Object.fromEntries(arr.map((item) => [item.track.name, item.config])),
          display: config2?.displayAspectWidth !== void 0 && config2?.displayAspectHeight !== void 0 ? { width: config2.displayAspectWidth, height: config2.displayAspectHeight } : void 0,
          rotation: void 0,
          flip: void 0
        };
      }))
    ]);
  }
});

// ../../node_modules/@moq/hang/catalog/root.js
function checkRenditions(root) {
  const count2 = Object.keys(root.video?.renditions ?? {}).length + Object.keys(root.audio?.renditions ?? {}).length + Object.keys(root.text?.renditions ?? {}).length;
  if (count2 > MAX_RENDITIONS)
    throw new TooManyRenditions(count2);
  return root;
}
function checkResolvable(root, base2) {
  const sections = [
    root.video?.renditions,
    root.audio?.renditions,
    root.text?.renditions,
    root.json?.tracks,
    root.binary?.tracks
  ];
  for (const section2 of sections) {
    for (const { broadcast: broadcast2 } of Object.values(section2 ?? {})) {
      if (broadcast2 && path_exports.tryResolve(base2, broadcast2) === void 0)
        throw new EscapingBroadcast(broadcast2);
    }
  }
  return root;
}
var RootSchema, MAX_RENDITIONS, TooManyRenditions, EscapingBroadcast;
var init_root = __esm({
  "../../node_modules/@moq/hang/catalog/root.js"() {
    init_net();
    init_mini2();
    init_archive();
    init_audio();
    init_binary();
    init_clock();
    init_json2();
    init_section();
    init_text();
    init_video();
    RootSchema = looseObject({
      video: optional(VideoSchema),
      audio: optional(AudioSchema),
      // An incompatible archive disables seeking/recording, not the rest of the catalog.
      archive: _catch(optional(ArchiveSchema), void 0),
      // The broadcast's one continuous clock, if the publisher exposes one. Independent of
      // `archive`: a live-only publisher exposes its mapping without creating a segment index.
      clock: optional(ClockSchema),
      // `text`, `json`, and `binary` are generic enough keys that an application could have been
      // carrying its own before these sections were reserved, so a value that isn't a section decodes
      // as absent rather than failing the whole catalog. A value that IS a section but carries a
      // malformed entry (a rendition with no `format`, a track with no `mode`) still fails, the same
      // as Rust, rather than silently dropping every caption or data track. See `section`.
      text: section(TextSchema, "renditions"),
      json: section(JsonSchema, "tracks"),
      binary: section(BinarySchema, "tracks")
    });
    MAX_RENDITIONS = 64;
    TooManyRenditions = class extends Error {
      count;
      constructor(count2) {
        super(`catalog has ${count2} renditions, over the limit of ${MAX_RENDITIONS}`);
        this.name = "TooManyRenditions";
        this.count = count2;
      }
    };
    EscapingBroadcast = class extends Error {
      /** The offending reference, normalized. */
      broadcast;
      constructor(broadcast2) {
        super(`catalog broadcast reference escapes the root: ${broadcast2}`);
        this.name = "EscapingBroadcast";
        this.broadcast = broadcast2;
      }
    };
  }
});

// ../../node_modules/@moq/hang/catalog/stalled.js
var stalled_exports = {};
__export(stalled_exports, {
  CLEAR_FRAMES: () => CLEAR_FRAMES,
  DEFAULT_INTERVAL: () => DEFAULT_INTERVAL,
  Detector: () => Detector,
  SET_INTERVALS: () => SET_INTERVALS,
  interval: () => interval,
  intervalFromFps: () => intervalFromFps
});
function interval(value) {
  return value > 0 ? value : DEFAULT_INTERVAL;
}
function intervalFromFps(fps) {
  if (fps === void 0 || !Number.isFinite(fps) || fps <= 0)
    return DEFAULT_INTERVAL;
  const value = time_exports.Micro.fromSecond(1 / fps);
  return Number.isFinite(value) && value >= 5e-4 && value < 2 ** 64 * 1e6 ? value : DEFAULT_INTERVAL;
}
var SET_INTERVALS, CLEAR_FRAMES, DEFAULT_INTERVAL, Detector;
var init_stalled = __esm({
  "../../node_modules/@moq/hang/catalog/stalled.js"() {
    init_net();
    SET_INTERVALS = 3;
    CLEAR_FRAMES = 3;
    DEFAULT_INTERVAL = time_exports.Micro.fromMilli(33);
    Detector = class {
      #on = false;
      #recover = 0;
      /** Whether the rendition is currently stalled. */
      get stalled() {
        return this.#on;
      }
      /** The catalog value: `true` while stalled, omitted otherwise. */
      flag() {
        return this.#on ? true : void 0;
      }
      /** Feed one sample. Returns whether the catalog flag changed. */
      observe(sample) {
        if (sample.idle || !sample.demand)
          return this.#clear();
        const frame = interval(sample.interval);
        const lag = Math.max(sample.mediaLag, sample.quiet);
        const over = lag > frame * SET_INTERVALS;
        const onTime = lag <= frame;
        if (!this.#on) {
          if (!over)
            return false;
          this.#on = true;
          this.#recover = 0;
          return true;
        }
        if (!onTime) {
          this.#recover = 0;
          return false;
        }
        if (!sample.frame)
          return false;
        this.#recover++;
        if (this.#recover < CLEAR_FRAMES)
          return false;
        return this.#clear();
      }
      #clear() {
        this.#recover = 0;
        if (!this.#on)
          return false;
        this.#on = false;
        return true;
      }
    };
  }
});

// ../../node_modules/@moq/hang/catalog/track.js
var TrackSchema3;
var init_track4 = __esm({
  "../../node_modules/@moq/hang/catalog/track.js"() {
    init_mini2();
    TrackSchema3 = object({
      name: string2()
    });
  }
});

// ../../node_modules/@moq/hang/catalog/index.js
var init_catalog = __esm({
  "../../node_modules/@moq/hang/catalog/index.js"() {
    init_archive();
    init_audio();
    init_binary();
    init_clock();
    init_compression2();
    init_container();
    init_format();
    init_hex3();
    init_integers();
    init_json2();
    init_mode();
    init_path2();
    init_priority3();
    init_root();
    init_stalled();
    init_text();
    init_track4();
    init_video();
  }
});

// ../../node_modules/@moq/loc/index.js
var loc_exports = {};
__export(loc_exports, {
  Format: () => Format,
  Producer: () => Producer8
});
var PROP_TIMESCALE2, PROP_TIMESTAMP2, PROP_TIMESTAMP_DRAFT032, DEFAULT_TIMESCALE, Format, Producer8;
var init_loc = __esm({
  "../../node_modules/@moq/loc/index.js"() {
    init_net();
    init_net();
    PROP_TIMESCALE2 = 8;
    PROP_TIMESTAMP2 = 16;
    PROP_TIMESTAMP_DRAFT032 = 6;
    DEFAULT_TIMESCALE = 1e6;
    Format = class {
      /** The kind of content carried by the track. */
      kind;
      /** Configure endpoint metadata for audio or video; opaque data is the default. */
      constructor(kind = "data") {
        this.kind = kind;
      }
      /** Return the video-frame or audio-source endpoint for an empty codec payload. */
      end(frame) {
        return this.kind !== "data" && frame.payload.byteLength === 0 ? frame.timestamp : void 0;
      }
      /** Decode one moq-net frame into its LOC frames. Throws on malformed input. */
      decode(frame) {
        const [propsLen, afterLen] = varint_exports.decode(frame);
        if (afterLen.byteLength < propsLen) {
          throw new Error("loc: properties_length exceeds frame size");
        }
        const props = afterLen.subarray(0, propsLen);
        const payload = afterLen.subarray(propsLen);
        let timestamp;
        let timescale;
        let prevType = 0;
        let first = true;
        let cursor = props;
        while (cursor.byteLength > 0) {
          const [delta, afterDelta] = varint_exports.decode(cursor);
          const abs = first ? delta : prevType + delta;
          first = false;
          prevType = abs;
          cursor = afterDelta;
          if (abs === PROP_TIMESTAMP2 || abs === PROP_TIMESTAMP_DRAFT032) {
            [timestamp, cursor] = varint_exports.decode(cursor);
          } else if (abs === PROP_TIMESCALE2) {
            let value;
            [value, cursor] = varint_exports.decode(cursor);
            if (value === 0) {
              throw new Error("loc: timescale property must be non-zero");
            }
            timescale = value;
          } else if (abs % 2 === 0) {
            cursor = varint_exports.decodeBigInt(cursor)[1];
          } else {
            const [len, afterLenInner] = varint_exports.decode(cursor);
            if (afterLenInner.byteLength < len) {
              throw new Error("loc: property length exceeds remaining bytes");
            }
            cursor = afterLenInner.subarray(len);
          }
        }
        if (timestamp === void 0) {
          throw new Error("loc: frame missing required timestamp property");
        }
        const activeTimescale = timescale ?? DEFAULT_TIMESCALE;
        const micros = Math.round(timestamp * DEFAULT_TIMESCALE / activeTimescale);
        return [{ payload, timestamp: micros, keyframe: false }];
      }
    };
    Producer8 = class {
      #track;
      #group;
      constructor(track) {
        this.#track = track;
      }
      /** Encode one frame and write it to the track. Keyframes start a new group. */
      encode(data, timestamp, keyframe) {
        if (keyframe) {
          this.#group?.close();
          this.#group = this.#track.appendGroup();
        } else if (!this.#group) {
          throw new Error("must start with a keyframe");
        }
        this.#group?.writeFrame({
          payload: this.#encode(data, timestamp),
          timestamp: time_exports.Timestamp.fromMicros(timestamp)
        });
      }
      #encode(source, timestamp) {
        const propTypeBytes = varint_exports.encode(PROP_TIMESTAMP2);
        const propValueBytes = varint_exports.encode(timestamp);
        const propsLen = propTypeBytes.byteLength + propValueBytes.byteLength;
        const propsLenBytes = varint_exports.encode(propsLen);
        const payloadSize = source.byteLength;
        const total = propsLenBytes.byteLength + propsLen + payloadSize;
        const out = new Uint8Array(total);
        let offset = 0;
        out.set(propsLenBytes, offset);
        offset += propsLenBytes.byteLength;
        out.set(propTypeBytes, offset);
        offset += propTypeBytes.byteLength;
        out.set(propValueBytes, offset);
        offset += propValueBytes.byteLength;
        const payloadView = out.subarray(offset);
        if (source instanceof Uint8Array) {
          payloadView.set(source);
        } else {
          source.copyTo(payloadView);
        }
        return out;
      }
      /** Close the current group and the underlying track, optionally with an error. */
      close(err2) {
        this.#group?.close();
        this.#track.close(err2);
      }
    };
  }
});

// ../../node_modules/@svta/cml-utils/dist/index.js
function isArrayBufferLike(value) {
  return value instanceof ArrayBuffer || typeof SharedArrayBuffer !== "undefined" && value instanceof SharedArrayBuffer;
}
function decodeText(data, options = {}) {
  let view;
  if (isArrayBufferLike(data)) view = new DataView(data);
  else view = new DataView(data.buffer, data.byteOffset, data.byteLength);
  let byteOffset = 0;
  let { encoding } = options;
  if (!encoding) {
    const first = view.getUint8(0);
    const second = view.getUint8(1);
    if (first == 239 && second == 187 && view.getUint8(2) == 191) {
      encoding = UTF_8;
      byteOffset = 3;
    } else if (first == 254 && second == 255) {
      encoding = UTF_16_BE;
      byteOffset = 2;
    } else if (first == 255 && second == 254) {
      encoding = UTF_16_LE;
      byteOffset = 2;
    } else encoding = UTF_8;
  }
  if (typeof TextDecoder !== "undefined") return new TextDecoder(encoding).decode(view);
  const { byteLength } = view;
  const endian = encoding !== UTF_16_BE;
  let str = "";
  let char;
  while (byteOffset < byteLength) {
    switch (encoding) {
      case UTF_8:
        char = view.getUint8(byteOffset);
        if (char < 128) byteOffset++;
        else if (char >= 194 && char <= 223) {
          if (byteOffset + 1 < byteLength) {
            const byte2 = view.getUint8(byteOffset + 1);
            if (byte2 >= 128 && byte2 <= 191) {
              char = (char & 31) << 6 | byte2 & 63;
              byteOffset += 2;
            } else byteOffset++;
          } else byteOffset++;
        } else if (char >= 224 && char <= 239) {
          if (byteOffset + 2 <= byteLength - 1) {
            const byte2 = view.getUint8(byteOffset + 1);
            const byte3 = view.getUint8(byteOffset + 2);
            if (byte2 >= 128 && byte2 <= 191 && byte3 >= 128 && byte3 <= 191) {
              char = (char & 15) << 12 | (byte2 & 63) << 6 | byte3 & 63;
              byteOffset += 3;
            } else byteOffset++;
          } else byteOffset++;
        } else if (char >= 240 && char <= 244) {
          if (byteOffset + 3 <= byteLength - 1) {
            const byte2 = view.getUint8(byteOffset + 1);
            const byte3 = view.getUint8(byteOffset + 2);
            const byte4 = view.getUint8(byteOffset + 3);
            if (byte2 >= 128 && byte2 <= 191 && byte3 >= 128 && byte3 <= 191 && byte4 >= 128 && byte4 <= 191) {
              char = (char & 7) << 18 | (byte2 & 63) << 12 | (byte3 & 63) << 6 | byte4 & 63;
              byteOffset += 4;
            } else byteOffset++;
          } else byteOffset++;
        } else byteOffset++;
        break;
      case UTF_16_BE:
      case UTF_16:
      case UTF_16_LE:
        char = view.getUint16(byteOffset, endian);
        byteOffset += 2;
    }
    str += String.fromCodePoint(char);
  }
  return str;
}
function encodeText(data) {
  return new TextEncoder().encode(data);
}
var UTF_16, UTF_16_BE, UTF_16_LE, UTF_8;
var init_dist = __esm({
  "../../node_modules/@svta/cml-utils/dist/index.js"() {
    UTF_16 = "utf-16";
    UTF_16_BE = "utf-16be";
    UTF_16_LE = "utf-16le";
    UTF_8 = "utf-8";
  }
});

// ../../node_modules/@svta/cml-iso-bmff/dist/index.js
function createWriterConfig(config2) {
  return { writers: config2?.writers ?? {} };
}
function isContainer(box) {
  return "boxes" in box || CONTAINERS.includes(box.type);
}
function writeBoxes(boxes, config2) {
  return Array.from(boxes, (box) => writeBox(box, config2));
}
function writeChildBoxes(boxes, config2) {
  const bytes = writeBoxes(boxes, config2);
  return {
    bytes,
    size: bytes.reduce((size2, byte) => size2 + byte.byteLength, 0)
  };
}
function writeContainerBox(box, config2) {
  const headerSize = 8;
  const { bytes, size: size2 } = writeChildBoxes(box.boxes, config2);
  const totalSize = headerSize + size2;
  const writer = new IsoBoxWriteView(box.type, totalSize);
  writer.writeBytes(bytes);
  return writer;
}
function writeBox(box, config2) {
  let view = null;
  if ("type" in box) {
    const { type } = box;
    const writer = config2.writers?.[type];
    if (writer) view = writer(box, config2);
    else if (isContainer(box)) view = writeContainerBox(box, config2);
    else if ("view" in box) view = box.view;
    if (!view) throw new Error(`No writer found for box type: ${type}`);
  }
  if ("buffer" in box) view = box;
  if (!view) throw new Error("Invalid box");
  return new Uint8Array(view.buffer, view.byteOffset, view.byteLength);
}
function readData(dataView, offset, size2) {
  const length = size2 > 0 ? size2 : dataView.byteLength - (offset - dataView.byteOffset);
  return new Uint8Array(dataView.buffer, offset, Math.max(length, 0));
}
function readInt(dataView, offset, size2) {
  let result = NaN;
  const cursor = offset - dataView.byteOffset;
  switch (size2) {
    case 1:
      result = dataView.getInt8(cursor);
      break;
    case 2:
      result = dataView.getInt16(cursor);
      break;
    case 4:
      result = dataView.getInt32(cursor);
      break;
    case 8:
      const s1 = dataView.getInt32(cursor);
      const s2 = dataView.getInt32(cursor + 4);
      result = s1 * Math.pow(2, 32) + s2;
  }
  return result;
}
function readUint(dataView, offset, size2) {
  const cursor = offset - dataView.byteOffset;
  let value = NaN;
  let s1;
  let s2;
  switch (size2) {
    case 1:
      value = dataView.getUint8(cursor);
      break;
    case 2:
      value = dataView.getUint16(cursor);
      break;
    case 3:
      s1 = dataView.getUint16(cursor);
      s2 = dataView.getUint8(cursor + 2);
      value = (s1 << 8) + s2;
      break;
    case 4:
      value = dataView.getUint32(cursor);
      break;
    case 8:
      s1 = dataView.getUint32(cursor);
      s2 = dataView.getUint32(cursor + 4);
      value = s1 * Math.pow(2, 32) + s2;
  }
  return value;
}
function readString(dataView, offset, length) {
  let str = "";
  for (let c2 = 0; c2 < length; c2++) {
    const char = readUint(dataView, offset + c2, 1);
    str += String.fromCharCode(char);
  }
  return str;
}
function readTemplate(dataView, offset, size2) {
  const half = size2 / 2;
  return readUint(dataView, offset, half) + readUint(dataView, offset + half, half) / Math.pow(2, half);
}
function readTerminatedString(dataView, offset) {
  let str = "";
  let cursor = offset;
  while (cursor - dataView.byteOffset < dataView.byteLength) {
    const char = readUint(dataView, cursor, 1);
    if (char === 0) break;
    str += String.fromCharCode(char);
    cursor++;
  }
  return str;
}
function readUtf8String(dataView, offset) {
  const length = dataView.byteLength - (offset - dataView.byteOffset);
  return length > 0 ? decodeText(new DataView(dataView.buffer, offset, length), { encoding: UTF_8 }) : "";
}
function readUtf8TerminatedString(dataView, offset) {
  const length = dataView.byteLength - (offset - dataView.byteOffset);
  let data = "";
  if (length > 0) {
    const view = new DataView(dataView.buffer, offset, length);
    let l2 = 0;
    for (; l2 < length; l2++) if (view.getUint8(l2) === 0) break;
    data = decodeText(new DataView(dataView.buffer, offset, l2), { encoding: UTF_8 });
  }
  return data;
}
function readIsoBoxes(raw, config2) {
  const boxes = [];
  for (const box of new IsoBoxReadView(raw, config2)) boxes.push(box);
  return boxes;
}
function writeIsoBoxes(boxes, config2) {
  return writeBoxes(boxes, createWriterConfig(config2));
}
function readAudioSampleEntryBox(type, view) {
  const { readArray, readUint: readUint2, readTemplate: readTemplate2, readBoxes } = view;
  return {
    type,
    reserved1: readArray(UINT, 1, 6),
    dataReferenceIndex: readUint2(2),
    reserved2: readArray(UINT, 4, 2),
    channelcount: readUint2(2),
    samplesize: readUint2(2),
    preDefined: readUint2(2),
    reserved3: readUint2(2),
    samplerate: readTemplate2(4),
    boxes: readBoxes()
  };
}
function readVisualSampleEntryBox(type, view) {
  const { readArray, readUint: readUint2, readInt: readInt2, readTemplate: readTemplate2, readBoxes } = view;
  return {
    type,
    reserved1: readArray(UINT, 1, 6),
    dataReferenceIndex: readUint2(2),
    preDefined1: readUint2(2),
    reserved2: readUint2(2),
    preDefined2: readArray(UINT, 4, 3),
    width: readUint2(2),
    height: readUint2(2),
    horizresolution: readTemplate2(4),
    vertresolution: readTemplate2(4),
    reserved3: readUint2(4),
    frameCount: readUint2(2),
    compressorName: readArray(UINT, 1, 32),
    depth: readUint2(2),
    preDefined3: readInt2(2),
    boxes: readBoxes()
  };
}
function readAvc1(view) {
  return readVisualSampleEntryBox("avc1", view);
}
function readHdlr(view) {
  return {
    type: "hdlr",
    ...view.readFullBox(),
    preDefined: view.readUint(4),
    handlerType: view.readString(4),
    reserved: view.readArray(UINT, 4, 3),
    name: view.readString(-1)
  };
}
function readHev1(view) {
  return readVisualSampleEntryBox("hev1", view);
}
function readHvc1(view) {
  return readVisualSampleEntryBox("hvc1", view);
}
function readMdat(view) {
  return {
    type: "mdat",
    data: view.readData(-1)
  };
}
function readMdhd(view) {
  const { version: version2, flags } = view.readFullBox();
  const creationTime = view.readUint(version2 == 1 ? 8 : 4);
  const modificationTime = view.readUint(version2 == 1 ? 8 : 4);
  const timescale = view.readUint(4);
  const duration2 = view.readUint(version2 == 1 ? 8 : 4);
  const lang = view.readUint(2);
  return {
    type: "mdhd",
    version: version2,
    flags,
    creationTime,
    modificationTime,
    timescale,
    duration: duration2,
    language: String.fromCharCode((lang >> 10 & 31) + 96, (lang >> 5 & 31) + 96, (lang & 31) + 96),
    preDefined: view.readUint(2)
  };
}
function readMfhd(view) {
  return {
    type: "mfhd",
    ...view.readFullBox(),
    sequenceNumber: view.readUint(4)
  };
}
function readMp4a(view) {
  return readAudioSampleEntryBox("mp4a", view);
}
function readStsd(view) {
  const { version: version2, flags } = view.readFullBox();
  const entryCount = view.readUint(4);
  return {
    type: "stsd",
    version: version2,
    flags,
    entryCount,
    entries: view.readBoxes(entryCount)
  };
}
function readTfdt(view) {
  const { version: version2, flags } = view.readFullBox();
  return {
    type: "tfdt",
    version: version2,
    flags,
    baseMediaDecodeTime: view.readUint(version2 == 1 ? 8 : 4)
  };
}
function readTfhd(view) {
  const { version: version2, flags } = view.readFullBox();
  return {
    type: "tfhd",
    version: version2,
    flags,
    trackId: view.readUint(4),
    baseDataOffset: flags & 1 ? view.readUint(8) : void 0,
    sampleDescriptionIndex: flags & 2 ? view.readUint(4) : void 0,
    defaultSampleDuration: flags & 8 ? view.readUint(4) : void 0,
    defaultSampleSize: flags & 16 ? view.readUint(4) : void 0,
    defaultSampleFlags: flags & 32 ? view.readUint(4) : void 0
  };
}
function readTkhd(view) {
  const { version: version2, flags } = view.readFullBox();
  const size2 = version2 === 1 ? 8 : 4;
  return {
    type: "tkhd",
    version: version2,
    flags,
    creationTime: view.readUint(size2),
    modificationTime: view.readUint(size2),
    trackId: view.readUint(4),
    reserved1: view.readUint(4),
    duration: view.readUint(size2),
    reserved2: view.readArray(UINT, 4, 2),
    layer: view.readUint(2),
    alternateGroup: view.readUint(2),
    volume: view.readTemplate(2),
    reserved3: view.readUint(2),
    matrix: view.readArray(TEMPLATE, 4, 9),
    width: view.readTemplate(4),
    height: view.readTemplate(4)
  };
}
function readTrex(view) {
  return {
    type: "trex",
    ...view.readFullBox(),
    trackId: view.readUint(4),
    defaultSampleDescriptionIndex: view.readUint(4),
    defaultSampleDuration: view.readUint(4),
    defaultSampleSize: view.readUint(4),
    defaultSampleFlags: view.readUint(4)
  };
}
function readTrun(view) {
  const { version: version2, flags } = view.readFullBox();
  const sampleCount = view.readUint(4);
  let dataOffset;
  let firstSampleFlags;
  if (flags & 1) dataOffset = view.readInt(4);
  if (flags & 4) firstSampleFlags = view.readUint(4);
  const samples = view.readEntries(sampleCount, () => {
    const sample = {};
    if (flags & 256) sample.sampleDuration = view.readUint(4);
    if (flags & 512) sample.sampleSize = view.readUint(4);
    if (flags & 1024) sample.sampleFlags = view.readUint(4);
    if (flags & 2048) sample.sampleCompositionTimeOffset = version2 === 1 ? view.readInt(4) : view.readUint(4);
    return sample;
  });
  return {
    type: "trun",
    version: version2,
    flags,
    sampleCount,
    dataOffset,
    firstSampleFlags,
    samples
  };
}
function writeDref(box, config2) {
  const entryCount = box.entries.length;
  const { bytes, size: size2 } = writeChildBoxes(box.entries, config2);
  const writer = new IsoBoxWriteView("dref", 16 + size2);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(entryCount, 4);
  writer.writeBytes(bytes);
  return writer;
}
function writeFtyp(box) {
  const writer = new IsoBoxWriteView("ftyp", 16 + box.compatibleBrands.length * 4);
  writer.writeString(box.majorBrand);
  writer.writeUint(box.minorVersion, 4);
  for (const brand of box.compatibleBrands) writer.writeString(brand);
  return writer;
}
function writeHdlr(box) {
  const writer = new IsoBoxWriteView("hdlr", 32 + (box.name.length + 1));
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.preDefined, 4);
  writer.writeString(box.handlerType);
  writer.writeArray(box.reserved, UINT, 4, 3);
  writer.writeTerminatedString(box.name);
  return writer;
}
function writeMdat(box) {
  const writer = new IsoBoxWriteView("mdat", 8 + box.data.length);
  writer.writeBytes(box.data);
  return writer;
}
function writeMdhd(box) {
  const size2 = box.version === 1 ? 8 : 4;
  const writer = new IsoBoxWriteView("mdhd", 12 + size2 * 3 + 4 + 2 + 2);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.creationTime, size2);
  writer.writeUint(box.modificationTime, size2);
  writer.writeUint(box.timescale, 4);
  writer.writeUint(box.duration, size2);
  const lang = box.language.length >= 3 ? (box.language.charCodeAt(0) - 96 & 31) << 10 | (box.language.charCodeAt(1) - 96 & 31) << 5 | box.language.charCodeAt(2) - 96 & 31 : 0;
  writer.writeUint(lang, 2);
  writer.writeUint(box.preDefined, 2);
  return writer;
}
function writeMfhd(box) {
  const writer = new IsoBoxWriteView("mfhd", 16);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.sequenceNumber, 4);
  return writer;
}
function writeMvhd(box) {
  const size2 = box.version === 1 ? 8 : 4;
  const writer = new IsoBoxWriteView("mvhd", 12 + size2 * 3 + 4 + 4 + 2 + 2 + 8 + 36 + 24 + 4);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.creationTime, size2);
  writer.writeUint(box.modificationTime, size2);
  writer.writeUint(box.timescale, 4);
  writer.writeUint(box.duration, size2);
  writer.writeTemplate(box.rate, 4);
  writer.writeTemplate(box.volume, 2);
  writer.writeUint(box.reserved1, 2);
  writer.writeArray(box.reserved2, UINT, 4, 2);
  writer.writeArray(box.matrix, TEMPLATE, 4, 9);
  writer.writeArray(box.preDefined, UINT, 4, 6);
  writer.writeUint(box.nextTrackId, 4);
  return writer;
}
function writeSmhd(box) {
  const writer = new IsoBoxWriteView("smhd", 16);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.balance, 2);
  writer.writeUint(box.reserved, 2);
  return writer;
}
function writeStsd(box, config2) {
  const entryCount = box.entries.length;
  const { bytes, size: size2 } = writeChildBoxes(box.entries, config2);
  const writer = new IsoBoxWriteView("stsd", 16 + size2);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(entryCount, 4);
  writer.writeBytes(bytes);
  return writer;
}
function writeStts(box) {
  const writer = new IsoBoxWriteView("stts", 16 + box.entryCount * 8);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.entryCount, 4);
  for (const entry of box.entries) {
    writer.writeUint(entry.sampleCount, 4);
    writer.writeUint(entry.sampleDelta, 4);
  }
  return writer;
}
function writeTfdt(box) {
  const size2 = box.version === 1 ? 8 : 4;
  const writer = new IsoBoxWriteView("tfdt", 12 + size2);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.baseMediaDecodeTime, size2);
  return writer;
}
function writeTfhd(box) {
  const baseDataOffsetSize = box.flags & 1 ? 8 : 0;
  const sampleDescriptionIndexSize = box.flags & 2 ? 4 : 0;
  const defaultSampleDurationSize = box.flags & 8 ? 4 : 0;
  const defaultSampleSizeSize = box.flags & 16 ? 4 : 0;
  const defaultSampleFlagsSize = box.flags & 32 ? 4 : 0;
  const writer = new IsoBoxWriteView("tfhd", 16 + baseDataOffsetSize + sampleDescriptionIndexSize + defaultSampleDurationSize + defaultSampleSizeSize + defaultSampleFlagsSize);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.trackId, 4);
  if (box.flags & 1) writer.writeUint(box.baseDataOffset ?? 0, 8);
  if (box.flags & 2) writer.writeUint(box.sampleDescriptionIndex ?? 0, 4);
  if (box.flags & 8) writer.writeUint(box.defaultSampleDuration ?? 0, 4);
  if (box.flags & 16) writer.writeUint(box.defaultSampleSize ?? 0, 4);
  if (box.flags & 32) writer.writeUint(box.defaultSampleFlags ?? 0, 4);
  return writer;
}
function writeTkhd(box) {
  const size2 = box.version === 1 ? 8 : 4;
  const writer = new IsoBoxWriteView("tkhd", 12 + size2 * 3 + 4 + 4 + 8 + 2 + 2 + 2 + 2 + 36 + 4 + 4);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.creationTime, size2);
  writer.writeUint(box.modificationTime, size2);
  writer.writeUint(box.trackId, 4);
  writer.writeUint(box.reserved1, 4);
  writer.writeUint(box.duration, size2);
  writer.writeArray(box.reserved2, UINT, 4, 2);
  writer.writeUint(box.layer, 2);
  writer.writeUint(box.alternateGroup, 2);
  writer.writeTemplate(box.volume, 2);
  writer.writeUint(box.reserved3, 2);
  writer.writeArray(box.matrix, TEMPLATE, 4, 9);
  writer.writeTemplate(box.width, 4);
  writer.writeTemplate(box.height, 4);
  return writer;
}
function writeTrex(box) {
  const writer = new IsoBoxWriteView("trex", 32);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.trackId, 4);
  writer.writeUint(box.defaultSampleDescriptionIndex, 4);
  writer.writeUint(box.defaultSampleDuration, 4);
  writer.writeUint(box.defaultSampleSize, 4);
  writer.writeUint(box.defaultSampleFlags, 4);
  return writer;
}
function writeTrun(box) {
  const dataOffsetSize = box.flags & 1 ? 4 : 0;
  const firstSampleFlagsSize = box.flags & 4 ? 4 : 0;
  let sampleSize = 0;
  if (box.flags & 256) sampleSize += 4;
  if (box.flags & 512) sampleSize += 4;
  if (box.flags & 1024) sampleSize += 4;
  if (box.flags & 2048) sampleSize += 4;
  const samplesSize = sampleSize * box.sampleCount;
  const writer = new IsoBoxWriteView("trun", 16 + dataOffsetSize + firstSampleFlagsSize + samplesSize);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.sampleCount, 4);
  if (box.flags & 1) writer.writeUint(box.dataOffset ?? 0, 4);
  if (box.flags & 4) writer.writeUint(box.firstSampleFlags ?? 0, 4);
  for (const sample of box.samples) {
    if (box.flags & 256) writer.writeUint(sample.sampleDuration ?? 0, 4);
    if (box.flags & 512) writer.writeUint(sample.sampleSize ?? 0, 4);
    if (box.flags & 1024) writer.writeUint(sample.sampleFlags ?? 0, 4);
    if (box.flags & 2048) writer.writeUint(sample.sampleCompositionTimeOffset ?? 0, 4);
  }
  return writer;
}
function writeUrl(box) {
  const writer = new IsoBoxWriteView("url ", 12 + (box.location.length + 1));
  writer.writeFullBox(box.version, box.flags);
  writer.writeTerminatedString(box.location);
  return writer;
}
function writeVmhd(box) {
  const writer = new IsoBoxWriteView("vmhd", 20);
  writer.writeFullBox(box.version, box.flags);
  writer.writeUint(box.graphicsmode, 2);
  writer.writeArray(box.opcolor, UINT, 2, 3);
  return writer;
}
var CONTAINERS, UTF82, UINT, TEMPLATE, STRING2, DATA2, IsoBoxWriteView, IsoBoxReadView;
var init_dist2 = __esm({
  "../../node_modules/@svta/cml-iso-bmff/dist/index.js"() {
    init_dist();
    CONTAINERS = [
      "dinf",
      "edts",
      "grpl",
      "mdia",
      "meco",
      "mfra",
      "minf",
      "moof",
      "moov",
      "mvex",
      "schi",
      "sinf",
      "stbl",
      "strk",
      "traf",
      "trak",
      "tref",
      "udta",
      "vttc"
    ];
    UTF82 = "utf8";
    UINT = "uint";
    TEMPLATE = "template";
    STRING2 = "string";
    DATA2 = "data";
    IsoBoxWriteView = class {
      /**
      * Constructs a new IsoBoxWriteView.
      *
      * @param size - The size of the data view.
      */
      constructor(type, size2) {
        this.writeUint = (value, size3) => {
          const { dataView, cursor } = this;
          switch (size3) {
            case 1:
              dataView.setUint8(cursor, value);
              break;
            case 2:
              dataView.setUint16(cursor, value);
              break;
            case 3: {
              const s1 = (value & 16776960) >> 8;
              const s2 = value & 255;
              dataView.setUint16(cursor, s1);
              dataView.setUint8(cursor + 2, s2);
              break;
            }
            case 4:
              dataView.setUint32(cursor, value);
              break;
            case 8: {
              const s1 = Math.floor(value / Math.pow(2, 32));
              const s2 = value - s1 * Math.pow(2, 32);
              dataView.setUint32(cursor, s1);
              dataView.setUint32(cursor + 4, s2);
              break;
            }
          }
          this.cursor += size3;
        };
        this.writeInt = (value, size3) => {
          const { dataView, cursor } = this;
          switch (size3) {
            case 1:
              dataView.setInt8(cursor, value);
              break;
            case 2:
              dataView.setInt16(cursor, value);
              break;
            case 4:
              dataView.setInt32(cursor, value);
              break;
            case 8:
              const s1 = Math.floor(value / Math.pow(2, 32));
              const s2 = value - s1 * Math.pow(2, 32);
              dataView.setUint32(cursor, s1);
              dataView.setUint32(cursor + 4, s2);
          }
          this.cursor += size3;
        };
        this.writeString = (value) => {
          for (let c2 = 0, len = value.length; c2 < len; c2++) this.writeUint(value.charCodeAt(c2), 1);
        };
        this.writeTerminatedString = (value) => {
          for (let c2 = 0, len = value.length; c2 < len; c2++) this.writeUint(value.charCodeAt(c2), 1);
          this.writeUint(0, 1);
        };
        this.writeUtf8TerminatedString = (value) => {
          const bytes = encodeText(value);
          new Uint8Array(this.dataView.buffer).set(bytes, this.cursor);
          this.cursor += bytes.length;
          this.writeUint(0, 1);
        };
        this.writeBytes = (data) => {
          if (!Array.isArray(data)) data = [data];
          for (const bytes of data) {
            new Uint8Array(this.dataView.buffer).set(bytes, this.cursor);
            this.cursor += bytes.length;
          }
        };
        this.writeArray = (data, type2, size3, length) => {
          const write2 = type2 === "uint" ? this.writeUint : type2 === "template" ? this.writeTemplate : this.writeInt;
          for (let i2 = 0; i2 < length; i2++) write2(data[i2] ?? 0, size3);
        };
        this.writeTemplate = (value, size3) => {
          const fixedPoint = Math.round(value * Math.pow(2, size3 === 4 ? 16 : 8));
          this.writeUint(fixedPoint, size3);
        };
        this.writeBoxHeader = (type2, size3) => {
          if (size3 > 4294967295) {
            this.writeUint(1, 4);
            this.writeString(type2);
            this.writeUint(size3, 8);
          } else {
            this.writeUint(size3, 4);
            this.writeString(type2);
          }
        };
        this.dataView = new DataView(new ArrayBuffer(size2));
        this.cursor = 0;
        this.writeBoxHeader(type, size2);
      }
      /**
      * The buffer of the data view.
      *
      * @returns The buffer of the data view.
      */
      get buffer() {
        return this.dataView.buffer;
      }
      /**
      * The length of the data view.
      *
      * @returns The length of the data view.
      */
      get byteLength() {
        return this.dataView.byteLength;
      }
      /**
      * The offset of the data view.
      *
      * @returns The offset of the data view.
      */
      get byteOffset() {
        return this.dataView.byteOffset;
      }
      /**
      * Writes a full box header to the data view.
      *
      * @param version - The version of the full box.
      * @param flags - The flags of the full box.
      */
      writeFullBox(version2, flags) {
        this.writeUint(version2, 1);
        this.writeUint(flags, 3);
      }
    };
    IsoBoxReadView = class IsoBoxReadView2 {
      /**
      * Creates a new IsoView instance. Similar to DataView, but with additional
      * methods for reading ISO BMFF data. It implements the iterator protocol,
      * so it can be used in a for...of loop.
      *
      * @param raw - The raw data to view.
      * @param config - The configuration for the IsoView.
      */
      constructor(raw, config2) {
        this.truncated = false;
        this.slice = (offset, size2) => {
          const dataView = new DataView(this.dataView.buffer, offset, size2);
          const isoView = new IsoBoxReadView2(dataView, this.config);
          const headerSize = this.offset - offset;
          const bodySize = size2 - headerSize;
          this.offset += bodySize;
          isoView.jump(headerSize);
          return isoView;
        };
        this.read = (type, size2 = 0) => {
          const { dataView, offset } = this;
          let result;
          let cursor = size2;
          switch (type) {
            case UINT:
              result = readUint(dataView, offset, size2);
              break;
            case "int":
              result = readInt(dataView, offset, size2);
              break;
            case TEMPLATE:
              result = readTemplate(dataView, offset, size2);
              break;
            case STRING2:
              if (size2 === -1) {
                result = readTerminatedString(dataView, offset);
                cursor = result.length + 1;
              } else result = readString(dataView, offset, size2);
              break;
            case DATA2:
              result = readData(dataView, offset, size2);
              cursor = result.length;
              break;
            case UTF82:
              if (size2 === -1) {
                result = readUtf8TerminatedString(dataView, offset);
                cursor = result.length + 1;
              } else result = readUtf8String(dataView, offset);
              break;
            default:
              result = -1;
          }
          this.offset += cursor;
          return result;
        };
        this.readUint = (size2) => {
          return this.read(UINT, size2);
        };
        this.readInt = (size2) => {
          return this.read("int", size2);
        };
        this.readString = (size2) => {
          return this.read(STRING2, size2);
        };
        this.readTemplate = (size2) => {
          return this.read(TEMPLATE, size2);
        };
        this.readData = (size2) => {
          return this.read(DATA2, size2);
        };
        this.readUtf8 = (size2) => {
          return this.read(UTF82, size2);
        };
        this.readFullBox = () => {
          return {
            version: this.readUint(1),
            flags: this.readUint(3)
          };
        };
        this.readArray = (type, size2, length) => {
          const value = [];
          for (let i2 = 0; i2 < length; i2++) value.push(this.read(type, size2));
          return value;
        };
        this.jump = (size2) => {
          this.offset += size2;
        };
        this.readBox = () => {
          const { dataView, offset } = this;
          let cursor = 0;
          const size2 = readUint(dataView, offset, 4);
          const type = readString(dataView, offset + 4, 4);
          const box = {
            size: size2,
            type
          };
          cursor += 8;
          if (box.size === 1) {
            box.largesize = readUint(dataView, offset + cursor, 8);
            cursor += 8;
          }
          const actualSize = box.size === 0 ? this.bytesRemaining : box.largesize ?? box.size;
          if (this.cursor + actualSize > dataView.byteLength) {
            this.truncated = true;
            throw new Error("Truncated box");
          }
          this.jump(cursor);
          if (type === "uuid") box.usertype = this.readArray("uint", 1, 16);
          box.view = this.slice(offset, actualSize);
          return box;
        };
        this.readBoxes = (length = -1) => {
          const result = [];
          for (const box of this) {
            result.push(box);
            if (length > 0 && result.length >= length) break;
          }
          return result;
        };
        this.readEntries = (length, map) => {
          const result = [];
          for (let i2 = 0; i2 < length; i2++) result.push(map());
          return result;
        };
        this.dataView = isArrayBufferLike(raw) ? new DataView(raw) : raw instanceof DataView ? raw : new DataView(raw.buffer, raw.byteOffset, raw.byteLength);
        this.offset = this.dataView.byteOffset;
        this.config = config2 || {};
      }
      /**
      * The buffer of the data view.
      */
      get buffer() {
        return this.dataView.buffer;
      }
      /**
      * The byte offset of the data view.
      */
      get byteOffset() {
        return this.dataView.byteOffset;
      }
      /**
      * The byte length of the data view.
      */
      get byteLength() {
        return this.dataView.byteLength;
      }
      /**
      * The current byteoffset in the data view.
      */
      get cursor() {
        return this.offset - this.dataView.byteOffset;
      }
      /**
      * Whether the end of the data view has been reached.
      */
      get done() {
        return this.cursor >= this.dataView.byteLength || this.truncated;
      }
      /**
      * The number of bytes remaining in the data view.
      */
      get bytesRemaining() {
        return this.dataView.byteLength - this.cursor;
      }
      /**
      * Iterates over the boxes in the data view.
      *
      * @returns A generator of boxes.
      */
      *[Symbol.iterator]() {
        const { readers = {} } = this.config;
        while (!this.done) try {
          const box = this.readBox();
          const { type, view } = box;
          const parser = readers[type] || readers[type.trim()];
          if (parser) Object.assign(box, parser(view, type));
          if (isContainer(box) && !box.boxes) {
            const boxes = [];
            for (const child of view) boxes.push(child);
            box.boxes = boxes;
          }
          yield box;
        } catch (error2) {
          if (error2 instanceof Error && error2.message === "Truncated box") break;
          throw error2;
        }
      }
    };
  }
});

// ../../node_modules/@moq/hang/container/cmaf/decode.js
function findBox(boxes, predicate) {
  for (const box of boxes) {
    if (predicate(box)) {
      return box;
    }
    const children = box.boxes;
    if (children && Array.isArray(children)) {
      const found = findBox(children, predicate);
      if (found)
        return found;
    }
  }
  return void 0;
}
function toArrayBuffer(data) {
  const buffer = new ArrayBuffer(data.byteLength);
  new Uint8Array(buffer).set(data);
  return buffer;
}
function isBoxType(type) {
  return (box) => box.type === type;
}
function decodeInitSegment(init) {
  const boxes = readIsoBoxes(toArrayBuffer(init), { readers: INIT_READERS });
  const mdhd = findBox(boxes, isBoxType("mdhd"));
  if (!mdhd) {
    throw new Error("No mdhd box found in init segment");
  }
  const tkhd = findBox(boxes, isBoxType("tkhd"));
  const trackId = tkhd?.trackId ?? 1;
  const hdlr = findBox(boxes, isBoxType("hdlr"));
  if (!hdlr) {
    throw new Error("No hdlr box found in init segment");
  }
  const kind = hdlr.handlerType === "soun" ? "audio" : hdlr.handlerType === "vide" ? "video" : void 0;
  if (!kind) {
    throw new Error(`Unsupported track handler: ${hdlr.handlerType}`);
  }
  const stsd = findBox(boxes, isBoxType("stsd"));
  if (!stsd?.entries || stsd.entries.length === 0) {
    throw new Error("No stsd box found in init segment");
  }
  const entry = stsd.entries[0];
  const description = extractDescription(entry);
  const trex = findBox(boxes, (box) => box.type === "trex" && box.trackId === trackId);
  return {
    description,
    timescale: mdhd.timescale,
    trackId,
    kind,
    defaultSampleDuration: trex?.defaultSampleDuration ?? 0,
    defaultSampleSize: trex?.defaultSampleSize ?? 0,
    defaultSampleFlags: trex?.defaultSampleFlags ?? 0
  };
}
function extractDescription(entry) {
  if (!entry.boxes || !Array.isArray(entry.boxes)) {
    return void 0;
  }
  for (const box of entry.boxes) {
    if (box instanceof Uint8Array) {
      if (box.length > 8) {
        const typeBytes = String.fromCharCode(box[4], box[5], box[6], box[7]);
        if (typeBytes === "avcC" || typeBytes === "hvcC" || typeBytes === "dOps") {
          return new Uint8Array(box.slice(8));
        }
        if (typeBytes === "esds") {
          return extractAudioSpecificConfig(new Uint8Array(box.slice(8)));
        }
      }
      continue;
    }
    const boxType = box.type;
    if (boxType === "avcC" || boxType === "hvcC" || boxType === "dOps") {
      if (box.view) {
        const view = box.view;
        const headerSize = 8;
        const payloadOffset = view.byteOffset + headerSize;
        const payloadLength = box.size - headerSize;
        return new Uint8Array(view.buffer, payloadOffset, payloadLength);
      }
      if (box.data instanceof Uint8Array) {
        return new Uint8Array(box.data);
      }
      if (box.raw instanceof Uint8Array) {
        return new Uint8Array(box.raw.slice(8));
      }
    }
    if (boxType === "esds") {
      let payload;
      if (box.view) {
        const view = box.view;
        const headerSize = 8;
        payload = new Uint8Array(view.buffer, view.byteOffset + headerSize, box.size - headerSize);
      } else if (box.data instanceof Uint8Array) {
        payload = new Uint8Array(box.data);
      } else if (box.raw instanceof Uint8Array) {
        payload = new Uint8Array(box.raw.slice(8));
      }
      if (payload)
        return extractAudioSpecificConfig(payload);
    }
  }
  return void 0;
}
function extractAudioSpecificConfig(esds) {
  let offset = 4;
  while (offset < esds.length) {
    const tag = esds[offset++];
    let size2 = 0;
    for (let i2 = 0; i2 < 4 && offset < esds.length; i2++) {
      const b3 = esds[offset++];
      size2 = size2 << 7 | b3 & 127;
      if ((b3 & 128) === 0)
        break;
    }
    if (tag === 5) {
      if (offset + size2 <= esds.length) {
        return new Uint8Array(esds.buffer, esds.byteOffset + offset, size2);
      }
      return void 0;
    }
    if (tag === 3) {
      offset += 3;
    } else if (tag === 4) {
      offset += 13;
    } else {
      offset += size2;
    }
  }
  return void 0;
}
function decodeTimestamp(segment, init) {
  const boxes = readIsoBoxes(toArrayBuffer(segment), { readers: DATA_READERS });
  const tfdt = findBox(boxes, isBoxType("tfdt"));
  const baseDecodeTime = tfdt?.baseMediaDecodeTime ?? 0;
  return baseDecodeTime * 1e6 / init.timescale;
}
function decodeDataSegment(segment, init) {
  const boxes = readIsoBoxes(toArrayBuffer(segment), { readers: DATA_READERS });
  const tfdt = findBox(boxes, isBoxType("tfdt"));
  const baseDecodeTime = tfdt?.baseMediaDecodeTime ?? 0;
  const tfhd = findBox(boxes, isBoxType("tfhd"));
  const defaultDuration = tfhd?.defaultSampleDuration ?? init.defaultSampleDuration;
  const defaultSize = tfhd?.defaultSampleSize ?? init.defaultSampleSize;
  const defaultFlags = tfhd?.defaultSampleFlags ?? init.defaultSampleFlags;
  const trun = findBox(boxes, isBoxType("trun"));
  if (!trun) {
    throw new Error("No trun box found in data segment");
  }
  const mdat = findBox(boxes, isBoxType("mdat"));
  if (!mdat) {
    throw new Error("No mdat box found in data segment");
  }
  const mdatData = mdat.data;
  if (!mdatData) {
    throw new Error("No data in mdat box");
  }
  const samples = [];
  let dataOffset = 0;
  let decodeTime = baseDecodeTime;
  for (let i2 = 0; i2 < trun.sampleCount; i2++) {
    const sample = trun.samples[i2] ?? {};
    const sampleSize = sample.sampleSize ?? defaultSize;
    const sampleDuration = sample.sampleDuration ?? defaultDuration;
    if (sampleSize <= 0) {
      throw new Error(`Invalid sample size ${sampleSize} for sample ${i2} in trun`);
    }
    if (sampleDuration < 0) {
      throw new Error(`Invalid sample duration ${sampleDuration} for sample ${i2} in trun`);
    }
    if (dataOffset + sampleSize > mdatData.length) {
      throw new Error(`Sample ${i2} would overflow mdat: offset=${dataOffset}, size=${sampleSize}, mdatLength=${mdatData.length}`);
    }
    const sampleFlags = i2 === 0 && trun.firstSampleFlags !== void 0 ? trun.firstSampleFlags : sample.sampleFlags ?? defaultFlags;
    const compositionOffset = sample.sampleCompositionTimeOffset ?? 0;
    const data = new Uint8Array(mdatData.slice(dataOffset, dataOffset + sampleSize));
    dataOffset += sampleSize;
    const pts = decodeTime + compositionOffset;
    const timestamp = Math.round(pts * 1e6 / init.timescale);
    const duration2 = Math.round(sampleDuration * 1e6 / init.timescale);
    const keyframe = init.kind === "video" && (sampleFlags === 0 || (sampleFlags & 65536) === 0);
    samples.push({
      data,
      timestamp,
      keyframe,
      duration: duration2
    });
    decodeTime += sampleDuration;
  }
  return samples;
}
var INIT_READERS, DATA_READERS;
var init_decode = __esm({
  "../../node_modules/@moq/hang/container/cmaf/decode.js"() {
    init_dist2();
    INIT_READERS = {
      avc1: readAvc1,
      avc3: readAvc1,
      // avc3 has same structure
      hvc1: readHvc1,
      hev1: readHev1,
      mp4a: readMp4a,
      stsd: readStsd,
      mdhd: readMdhd,
      hdlr: readHdlr,
      tkhd: readTkhd,
      trex: readTrex
    };
    DATA_READERS = {
      mfhd: readMfhd,
      tfhd: readTfhd,
      tfdt: readTfdt,
      trun: readTrun,
      mdat: readMdat
    };
  }
});

// ../../node_modules/@moq/hang/container/cmaf/encode.js
function writeBoxes2(boxes) {
  return writeIsoBoxes(boxes, { writers: WRITERS });
}
function createFullBox(type, version2, flags, content) {
  const size2 = 8 + 4 + content.length;
  const box = new Uint8Array(size2);
  const view = new DataView(box.buffer);
  view.setUint32(0, size2, false);
  box[4] = type.charCodeAt(0);
  box[5] = type.charCodeAt(1);
  box[6] = type.charCodeAt(2);
  box[7] = type.charCodeAt(3);
  view.setUint32(8, version2 << 24 | flags, false);
  box.set(content, 12);
  return box;
}
function createEmptyStsc() {
  const content = new Uint8Array(4);
  return createFullBox("stsc", 0, 0, content);
}
function createEmptyStsz() {
  const content = new Uint8Array(8);
  return createFullBox("stsz", 0, 0, content);
}
function createEmptyStco() {
  const content = new Uint8Array(4);
  return createFullBox("stco", 0, 0, content);
}
function createAvc1Box(width, height, avcC) {
  const avcCSize = 8 + avcC.length;
  const avc1ContentSize = 6 + 2 + 2 + 2 + 12 + 2 + 2 + 4 + 4 + 4 + 2 + 32 + 2 + 2 + avcCSize;
  const avc1Size = 8 + avc1ContentSize;
  const box = new Uint8Array(avc1Size);
  const view = new DataView(box.buffer);
  let offset = 0;
  view.setUint32(offset, avc1Size, false);
  offset += 4;
  box[offset++] = 97;
  box[offset++] = 118;
  box[offset++] = 99;
  box[offset++] = 49;
  offset += 6;
  view.setUint16(offset, 1, false);
  offset += 2;
  view.setUint16(offset, 0, false);
  offset += 2;
  view.setUint16(offset, 0, false);
  offset += 2;
  offset += 12;
  view.setUint16(offset, width, false);
  offset += 2;
  view.setUint16(offset, height, false);
  offset += 2;
  view.setUint32(offset, 4718592, false);
  offset += 4;
  view.setUint32(offset, 4718592, false);
  offset += 4;
  view.setUint32(offset, 0, false);
  offset += 4;
  view.setUint16(offset, 1, false);
  offset += 2;
  offset += 32;
  view.setUint16(offset, 24, false);
  offset += 2;
  view.setUint16(offset, 65535, false);
  offset += 2;
  view.setUint32(offset, avcCSize, false);
  offset += 4;
  box[offset++] = 97;
  box[offset++] = 118;
  box[offset++] = 99;
  box[offset++] = 67;
  box.set(avcC, offset);
  return box;
}
function createVideoInitSegment(config2) {
  const { codedWidth, codedHeight, description } = config2;
  if (!codedWidth || !codedHeight || !description) {
    throw new Error("Missing required fields to create video init segment");
  }
  const timescale = 1e6;
  const trackId = 1;
  const ftyp = {
    type: "ftyp",
    majorBrand: "isom",
    minorVersion: 512,
    compatibleBrands: ["isom", "iso6", "mp41"]
  };
  const mvhd = {
    type: "mvhd",
    version: 0,
    flags: 0,
    creationTime: 0,
    modificationTime: 0,
    timescale,
    duration: 0,
    // Unknown/fragmented
    rate: 65536,
    // 1.0 in 16.16 fixed point
    volume: 256,
    // 1.0 in 8.8 fixed point
    reserved1: 0,
    reserved2: [0, 0],
    matrix: IDENTITY_MATRIX,
    preDefined: [0, 0, 0, 0, 0, 0],
    nextTrackId: trackId + 1
  };
  const tkhd = {
    type: "tkhd",
    version: 0,
    flags: 3,
    // Track enabled + in movie
    creationTime: 0,
    modificationTime: 0,
    trackId,
    reserved1: 0,
    duration: 0,
    reserved2: [0, 0],
    layer: 0,
    alternateGroup: 0,
    volume: 0,
    // Video tracks have 0 volume
    reserved3: 0,
    matrix: IDENTITY_MATRIX,
    width: codedWidth * 65536,
    // 16.16 fixed point (avoid << which produces signed int)
    height: codedHeight * 65536
  };
  const mdhd = {
    type: "mdhd",
    version: 0,
    flags: 0,
    creationTime: 0,
    modificationTime: 0,
    timescale,
    duration: 0,
    language: "und",
    preDefined: 0
  };
  const hdlr = {
    type: "hdlr",
    version: 0,
    flags: 0,
    preDefined: 0,
    handlerType: "vide",
    reserved: [0, 0, 0],
    name: "VideoHandler"
  };
  const vmhd = {
    type: "vmhd",
    version: 0,
    flags: 1,
    // Required to be 1
    graphicsmode: 0,
    opcolor: [0, 0, 0]
  };
  const urlBox = {
    type: "url ",
    version: 0,
    flags: 1,
    // Self-contained flag
    location: ""
  };
  const dref = {
    type: "dref",
    version: 0,
    flags: 0,
    entryCount: 1,
    entries: [urlBox]
  };
  const dinf = {
    type: "dinf",
    boxes: [dref]
  };
  const avc1Box = createAvc1Box(codedWidth, codedHeight, toBytes2(description));
  const stsd = {
    type: "stsd",
    version: 0,
    flags: 0,
    entryCount: 1,
    // biome-ignore lint/suspicious/noExplicitAny: Raw avc1 box since library doesn't handle avcC children
    entries: [avc1Box]
  };
  const stts = {
    type: "stts",
    version: 0,
    flags: 0,
    entryCount: 0,
    entries: []
  };
  const stsc = createEmptyStsc();
  const stsz = createEmptyStsz();
  const stco = createEmptyStco();
  const stbl = {
    type: "stbl",
    // biome-ignore lint/suspicious/noExplicitAny: Raw boxes for types without library writers
    boxes: [stsd, stts, stsc, stsz, stco]
  };
  const minf = {
    type: "minf",
    boxes: [vmhd, dinf, stbl]
  };
  const mdia = {
    type: "mdia",
    boxes: [mdhd, hdlr, minf]
  };
  const trak = {
    type: "trak",
    boxes: [tkhd, mdia]
  };
  const trex = {
    type: "trex",
    version: 0,
    flags: 0,
    trackId,
    defaultSampleDescriptionIndex: 1,
    defaultSampleDuration: 0,
    defaultSampleSize: 0,
    defaultSampleFlags: 0
  };
  const mvex = {
    type: "mvex",
    boxes: [trex]
  };
  const moov = {
    type: "moov",
    boxes: [mvhd, trak, mvex]
  };
  const buffers = writeBoxes2([ftyp, moov]);
  const totalLength = buffers.reduce((sum, buf) => sum + buf.byteLength, 0);
  const result = new Uint8Array(totalLength);
  let offset = 0;
  for (const buf of buffers) {
    result.set(new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength), offset);
    offset += buf.byteLength;
  }
  return result;
}
function createAudioInitSegment(config2) {
  const { sampleRate, numberOfChannels, description, codec } = config2;
  const timescale = 1e6;
  const trackId = 1;
  const ftyp = {
    type: "ftyp",
    majorBrand: "isom",
    minorVersion: 512,
    compatibleBrands: ["isom", "iso6", "mp41"]
  };
  const mvhd = {
    type: "mvhd",
    version: 0,
    flags: 0,
    creationTime: 0,
    modificationTime: 0,
    timescale,
    duration: 0,
    rate: 65536,
    volume: 256,
    reserved1: 0,
    reserved2: [0, 0],
    matrix: IDENTITY_MATRIX,
    preDefined: [0, 0, 0, 0, 0, 0],
    nextTrackId: trackId + 1
  };
  const tkhd = {
    type: "tkhd",
    version: 0,
    flags: 3,
    creationTime: 0,
    modificationTime: 0,
    trackId,
    reserved1: 0,
    duration: 0,
    reserved2: [0, 0],
    layer: 0,
    alternateGroup: 0,
    volume: 256,
    // Audio tracks have volume (1.0 in 8.8 fixed point)
    reserved3: 0,
    matrix: IDENTITY_MATRIX,
    width: 0,
    height: 0
  };
  const mdhd = {
    type: "mdhd",
    version: 0,
    flags: 0,
    creationTime: 0,
    modificationTime: 0,
    timescale,
    duration: 0,
    language: "und",
    preDefined: 0
  };
  const hdlr = {
    type: "hdlr",
    version: 0,
    flags: 0,
    preDefined: 0,
    handlerType: "soun",
    reserved: [0, 0, 0],
    name: "SoundHandler"
  };
  const smhd = {
    type: "smhd",
    version: 0,
    flags: 0,
    balance: 0,
    reserved: 0
  };
  const urlBox = {
    type: "url ",
    version: 0,
    flags: 1,
    location: ""
  };
  const dref = {
    type: "dref",
    version: 0,
    flags: 0,
    entryCount: 1,
    entries: [urlBox]
  };
  const dinf = {
    type: "dinf",
    boxes: [dref]
  };
  const sampleEntry = createAudioSampleEntry(codec, sampleRate, numberOfChannels, description);
  const stsd = {
    type: "stsd",
    version: 0,
    flags: 0,
    entryCount: 1,
    // biome-ignore lint/suspicious/noExplicitAny: Raw sample entry box
    entries: [sampleEntry]
  };
  const stts = {
    type: "stts",
    version: 0,
    flags: 0,
    entryCount: 0,
    entries: []
  };
  const stsc = createEmptyStsc();
  const stsz = createEmptyStsz();
  const stco = createEmptyStco();
  const stbl = {
    type: "stbl",
    // biome-ignore lint/suspicious/noExplicitAny: Raw boxes for types without library writers
    boxes: [stsd, stts, stsc, stsz, stco]
  };
  const minf = {
    type: "minf",
    boxes: [smhd, dinf, stbl]
  };
  const mdia = {
    type: "mdia",
    boxes: [mdhd, hdlr, minf]
  };
  const trak = {
    type: "trak",
    boxes: [tkhd, mdia]
  };
  const trex = {
    type: "trex",
    version: 0,
    flags: 0,
    trackId,
    defaultSampleDescriptionIndex: 1,
    defaultSampleDuration: 0,
    defaultSampleSize: 0,
    defaultSampleFlags: 0
  };
  const mvex = {
    type: "mvex",
    boxes: [trex]
  };
  const moov = {
    type: "moov",
    boxes: [mvhd, trak, mvex]
  };
  const buffers = writeBoxes2([ftyp, moov]);
  const totalLength = buffers.reduce((sum, buf) => sum + buf.byteLength, 0);
  const result = new Uint8Array(totalLength);
  let offset = 0;
  for (const buf of buffers) {
    result.set(new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength), offset);
    offset += buf.byteLength;
  }
  return result;
}
function createAudioSampleEntry(codec, sampleRate, channelCount, description) {
  if (codec.startsWith("mp4a")) {
    return createMp4aBox(sampleRate, channelCount, description);
  } else if (codec === "opus") {
    return createOpusBox(sampleRate, channelCount, description);
  }
  throw new Error(`Unsupported audio codec: ${codec}`);
}
function createMp4aBox(sampleRate, channelCount, description) {
  const esds = createEsdsBox(sampleRate, channelCount, description);
  const mp4aContentSize = 6 + 2 + 8 + 2 + 2 + 2 + 2 + 4 + esds.length;
  const mp4aSize = 8 + mp4aContentSize;
  const box = new Uint8Array(mp4aSize);
  const view = new DataView(box.buffer);
  let offset = 0;
  view.setUint32(offset, mp4aSize, false);
  offset += 4;
  box[offset++] = 109;
  box[offset++] = 112;
  box[offset++] = 52;
  box[offset++] = 97;
  offset += 6;
  view.setUint16(offset, 1, false);
  offset += 2;
  offset += 8;
  view.setUint16(offset, channelCount, false);
  offset += 2;
  view.setUint16(offset, 16, false);
  offset += 2;
  view.setUint16(offset, 0, false);
  offset += 2;
  view.setUint16(offset, 0, false);
  offset += 2;
  view.setUint32(offset, sampleRate * 65536, false);
  offset += 4;
  box.set(esds, offset);
  return box;
}
function createOpusBox(sampleRate, channelCount, description) {
  const dOps = createDOpsBox(channelCount, sampleRate, description);
  const opusContentSize = 6 + 2 + 8 + 2 + 2 + 2 + 2 + 4 + dOps.length;
  const opusSize = 8 + opusContentSize;
  const box = new Uint8Array(opusSize);
  const view = new DataView(box.buffer);
  let offset = 0;
  view.setUint32(offset, opusSize, false);
  offset += 4;
  box[offset++] = 79;
  box[offset++] = 112;
  box[offset++] = 117;
  box[offset++] = 115;
  offset += 6;
  view.setUint16(offset, 1, false);
  offset += 2;
  offset += 8;
  view.setUint16(offset, channelCount, false);
  offset += 2;
  view.setUint16(offset, 16, false);
  offset += 2;
  view.setUint16(offset, 0, false);
  offset += 2;
  view.setUint16(offset, 0, false);
  offset += 2;
  view.setUint32(offset, sampleRate * 65536, false);
  offset += 4;
  box.set(dOps, offset);
  return box;
}
function createEsdsBox(sampleRate, channelCount, description) {
  const audioSpecificConfig2 = description ? toBytes2(description) : audioSpecificConfig(sampleRate, channelCount);
  const decSpecificInfoSize = audioSpecificConfig2.length;
  const decConfigDescSize = 13 + 2 + decSpecificInfoSize;
  const esDescSize = 3 + 2 + decConfigDescSize + 3;
  const esdsSize = 12 + 2 + esDescSize;
  const esds = new Uint8Array(esdsSize);
  const view = new DataView(esds.buffer);
  let offset = 0;
  view.setUint32(offset, esdsSize, false);
  offset += 4;
  esds[offset++] = 101;
  esds[offset++] = 115;
  esds[offset++] = 100;
  esds[offset++] = 115;
  view.setUint32(offset, 0, false);
  offset += 4;
  esds[offset++] = 3;
  esds[offset++] = esDescSize;
  view.setUint16(offset, 0, false);
  offset += 2;
  esds[offset++] = 0;
  esds[offset++] = 4;
  esds[offset++] = decConfigDescSize;
  esds[offset++] = 64;
  esds[offset++] = 21;
  esds[offset++] = 0;
  esds[offset++] = 0;
  esds[offset++] = 0;
  view.setUint32(offset, 0, false);
  offset += 4;
  view.setUint32(offset, 0, false);
  offset += 4;
  esds[offset++] = 5;
  esds[offset++] = decSpecificInfoSize;
  esds.set(audioSpecificConfig2, offset);
  offset += decSpecificInfoSize;
  esds[offset++] = 6;
  esds[offset++] = 1;
  esds[offset++] = 2;
  return esds;
}
function createDOpsBox(channelCount, sampleRate, description) {
  if (description) {
    const payload = toDOps(toBytes2(description));
    const dOpsSize2 = 8 + payload.length;
    const dOps2 = new Uint8Array(dOpsSize2);
    const view2 = new DataView(dOps2.buffer);
    view2.setUint32(0, dOpsSize2, false);
    dOps2[4] = 100;
    dOps2[5] = 79;
    dOps2[6] = 112;
    dOps2[7] = 115;
    dOps2.set(payload, 8);
    return dOps2;
  }
  const dOpsSize = 8 + 11;
  const dOps = new Uint8Array(dOpsSize);
  const view = new DataView(dOps.buffer);
  let offset = 0;
  view.setUint32(offset, dOpsSize, false);
  offset += 4;
  dOps[offset++] = 100;
  dOps[offset++] = 79;
  dOps[offset++] = 112;
  dOps[offset++] = 115;
  dOps[offset++] = 0;
  dOps[offset++] = channelCount;
  view.setUint16(offset, 0, false);
  offset += 2;
  view.setUint32(offset, sampleRate, false);
  offset += 4;
  view.setInt16(offset, 0, false);
  offset += 2;
  dOps[offset++] = 0;
  return dOps;
}
function encodeDataSegment(opts) {
  const { data, timestamp, duration: duration2, keyframe, kind, sequence, trackId = 1 } = opts;
  const sampleFlags = kind === "audio" || keyframe ? 33554432 : 16842752;
  const mfhd = {
    type: "mfhd",
    version: 0,
    flags: 0,
    sequenceNumber: sequence
  };
  const tfhd = {
    type: "tfhd",
    version: 0,
    flags: 131072,
    trackId
  };
  const tfdt = {
    type: "tfdt",
    version: 1,
    // version 1 for 64-bit baseMediaDecodeTime
    flags: 0,
    baseMediaDecodeTime: timestamp
  };
  const trun = {
    type: "trun",
    version: 0,
    flags: 1 | 256 | 512 | 1024,
    sampleCount: 1,
    dataOffset: 0,
    // Will be calculated after we know moof size
    samples: [
      {
        sampleDuration: duration2,
        sampleSize: data.byteLength,
        sampleFlags
      }
    ]
  };
  const traf = {
    type: "traf",
    boxes: [tfhd, tfdt, trun]
  };
  const moof = {
    type: "moof",
    boxes: [mfhd, traf]
  };
  const moofBuffers = writeBoxes2([moof]);
  let moofSize = 0;
  for (const buf of moofBuffers) {
    moofSize += buf.byteLength;
  }
  trun.dataOffset = moofSize + 8;
  const moofBuffersFinal = writeBoxes2([moof]);
  moofSize = 0;
  for (const buf of moofBuffersFinal) {
    moofSize += buf.byteLength;
  }
  const mdatBuffer = new ArrayBuffer(data.byteLength);
  const mdatData = new Uint8Array(mdatBuffer);
  mdatData.set(data);
  const mdat = {
    type: "mdat",
    data: mdatData
  };
  const mdatBuffers = writeBoxes2([mdat]);
  let mdatSize = 0;
  for (const buf of mdatBuffers) {
    mdatSize += buf.byteLength;
  }
  const result = new Uint8Array(moofSize + mdatSize);
  let offset = 0;
  for (const buf of moofBuffersFinal) {
    result.set(new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength), offset);
    offset += buf.byteLength;
  }
  for (const buf of mdatBuffers) {
    result.set(new Uint8Array(buf.buffer, buf.byteOffset, buf.byteLength), offset);
    offset += buf.byteLength;
  }
  return result;
}
var IDENTITY_MATRIX, WRITERS;
var init_encode = __esm({
  "../../node_modules/@moq/hang/container/cmaf/encode.js"() {
    init_dist2();
    init_aac();
    init_hex2();
    init_opus();
    IDENTITY_MATRIX = [65536, 0, 0, 0, 65536, 0, 0, 0, 1073741824];
    WRITERS = {
      // Init segment boxes
      ftyp: writeFtyp,
      mvhd: writeMvhd,
      tkhd: writeTkhd,
      mdhd: writeMdhd,
      hdlr: writeHdlr,
      vmhd: writeVmhd,
      smhd: writeSmhd,
      "url ": writeUrl,
      dref: writeDref,
      stsd: writeStsd,
      stts: writeStts,
      trex: writeTrex,
      // Data segment boxes
      mfhd: writeMfhd,
      tfhd: writeTfhd,
      tfdt: writeTfdt,
      trun: writeTrun,
      mdat: writeMdat
      // For boxes without library writers, we create them manually as Uint8Arrays
    };
  }
});

// ../../node_modules/@moq/hang/container/cmaf/format.js
var Format2;
var init_format2 = __esm({
  "../../node_modules/@moq/hang/container/cmaf/format.js"() {
    init_decode();
    Format2 = class {
      #init;
      /** Create a format bound to the given parsed init segment (timescale, codec defaults). */
      constructor(init) {
        this.#init = init;
      }
      /** Decode one CMAF fragment into its media frames. */
      decode(frame) {
        return decodeDataSegment(frame, this.#init).map((s) => ({
          payload: s.data,
          timestamp: s.timestamp,
          keyframe: s.keyframe,
          duration: s.duration
        }));
      }
    };
  }
});

// ../../node_modules/@moq/hang/container/cmaf/index.js
var cmaf_exports = {};
__export(cmaf_exports, {
  Format: () => Format2,
  createAudioInitSegment: () => createAudioInitSegment,
  createVideoInitSegment: () => createVideoInitSegment,
  decodeDataSegment: () => decodeDataSegment,
  decodeInitSegment: () => decodeInitSegment,
  decodeTimestamp: () => decodeTimestamp,
  encodeDataSegment: () => encodeDataSegment
});
var init_cmaf = __esm({
  "../../node_modules/@moq/hang/container/cmaf/index.js"() {
    init_decode();
    init_encode();
    init_format2();
  }
});

// ../../node_modules/@moq/hang/container/consumer.js
function ptsContiguous(end, nextStart) {
  return end !== void 0 && nextStart !== void 0 && nextStart <= time_exports.Micro.add(end, CONTIGUITY_TOLERANCE);
}
function continues(prev, next) {
  if (next === void 0)
    return false;
  return next.consumer.sequence === prev.consumer.sequence + 1 || ptsContiguous(prev.end, next.frames.at(0)?.timestamp);
}
var CONTIGUITY_TOLERANCE, Consumer8;
var init_consumer3 = __esm({
  "../../node_modules/@moq/hang/container/consumer.js"() {
    init_net();
    init_signals();
    CONTIGUITY_TOLERANCE = time_exports.Micro.fromMilli(1);
    Consumer8 = class {
      #track;
      #format;
      #maxAge;
      #groups = [];
      #active;
      // the active group sequence number
      // Presentation end (max PTS + duration) of the group we most recently advanced past, so next()'s
      // promotion guard can tell a timeline-continuous next group from one sitting after a gap.
      // Maintained only via #recordPresented; see its comment for the invariant.
      #presentedEnd;
      // Group of the last frame next() returned, so it can report whether the following result
      // continues that frame's timeline. Undefined until the first delivery and after a playhead event.
      #deliveredGroup;
      // Set whenever the consumer throws content away: a group that aged past `maxAge`,
      // a group truncated by a decode error. Reported (and
      // cleared) on the first frame delivered from the next group, which is where the missing span
      // sits. Only the consumer can know this, which is why next() reports it instead of leaving
      // callers to guess from group numbers.
      #gap = false;
      // The live edge of playback: max delivered timestamp and the group that carried it.
      #liveEdge;
      // Increments on a declared marker, an unproven delivered hole, and a latency skip.
      #discontinuity = 0;
      // A group below the live edge aborts the track.
      #error;
      // Wake up the consumer when a new frame is available.
      #notify;
      #buffered = new Signal([]);
      /** The time ranges currently buffered and ready to play. */
      buffered = this.#buffered;
      #signals = new Effect();
      #closed = new Once();
      /** Start consuming the given track, decoding frames with `props.format`. */
      constructor(track, props) {
        this.#track = track;
        this.#format = props.format;
        this.#maxAge = getter(props.maxAge ?? time_exports.Milli.zero);
        this.#signals.spawn(this.#run.bind(this));
        this.#signals.cleanup(() => {
          this.#track.close();
          for (const group of this.#groups) {
            group.consumer.close();
          }
          this.#groups.length = 0;
        });
      }
      #finish(end) {
        if (this.#closed.peek() === void 0)
          this.#closed.set(end);
        this.#notify?.();
        this.#notify = void 0;
      }
      async #run() {
        try {
          for (; ; ) {
            const consumer = await this.#track.recvGroup();
            if (!consumer)
              break;
            if (this.#active === void 0) {
              this.#active = consumer.sequence;
            }
            const group = {
              consumer,
              frames: [],
              empty: true,
              media: false
            };
            this.#groups.push(group);
            this.#groups.sort((a2, b3) => a2.consumer.sequence - b3.consumer.sequence);
            this.#signals.spawn(this.#runGroup.bind(this, group));
          }
          this.#finish(null);
        } catch (err2) {
          this.#finish(err2 instanceof Error ? err2 : new Error(String(err2)));
        }
      }
      async #runGroup(group) {
        try {
          let index2 = 0;
          for (; ; ) {
            const next = await group.consumer.readFrame();
            if (!next)
              break;
            group.empty = false;
            const decoded = this.#format.decode(next.payload);
            for (const sample of decoded) {
              const marker = this.#format.end?.(sample) !== void 0;
              const frame = {
                payload: sample.payload,
                timestamp: sample.timestamp,
                // Protocol invariant: groups always start at a keyframe.
                // For index 0, we enforce this regardless of what the format reports.
                // For index > 0, we trust the format's keyframe detection.
                keyframe: !marker && index2 === 0 ? true : sample.keyframe,
                // Carry the container's per-sample duration through so group.end is the real
                // presentation end (ts + duration), not just the last frame's ts. This is what
                // makes the PTS-contiguity check (next.firstPTS <= group.end) work; without it a
                // contiguous next group looks one frame past the end. Undefined for Legacy (no duration).
                duration: sample.duration
              };
              if (!marker) {
                index2++;
                group.media = true;
                if (group.minMedia === void 0 || frame.timestamp < group.minMedia) {
                  group.minMedia = frame.timestamp;
                }
              }
              group.start ??= frame.timestamp;
              group.frames.push(frame);
              if (group.latest === void 0 || frame.timestamp > group.latest) {
                group.latest = frame.timestamp;
              }
              const end = frame.timestamp + (frame.duration ?? 0);
              if (group.end === void 0 || end > group.end) {
                group.end = end;
              }
              this.#updateBuffered();
              if (!marker && this.#abortIfRewound(group, frame.timestamp))
                return;
              let skipped = false;
              if (group.consumer.sequence !== this.#active) {
                this.#checkMaxAge();
                skipped = this.#tryDurationSkip();
              }
              if (skipped || group.consumer.sequence === this.#active || group === this.#groups[0]) {
                this.#notify?.();
                this.#notify = void 0;
              }
            }
          }
        } catch (err2) {
          if (this.#error)
            return;
          group.truncated = true;
          if (!(err2 instanceof errors_exports2.Stream))
            throw err2;
        } finally {
          group.done = true;
          if (group.consumer.sequence === this.#active) {
            this.#recordPresented(group);
            const next = this.#groups[this.#groups.indexOf(group) + 1];
            this.#active = continues(group, next) ? next.consumer.sequence : group.consumer.sequence + 1;
          }
          this.#updateBuffered();
          this.#notify?.();
          this.#notify = void 0;
          group.consumer.close();
        }
      }
      // Record where a group's content ends as the cursor advances past it. next()'s promotion guard
      // compares the following group's first PTS against this to tell an unbroken timeline from a real
      // gap, so EVERY site that moves #active past a group must call this; a site that forgets leaves a
      // stale end behind and silently blocks the next contiguous group forever. A group with no frames
      // (empty, or errored before the first one) says nothing about the timeline, so it leaves the last
      // known end in place rather than wiping it.
      #recordPresented(group) {
        if (group.end !== void 0)
          this.#presentedEnd = group.end;
      }
      // Whether delivering from group `sequence` continues the timeline of the last frame returned.
      // Frames within a group are consecutive by protocol, so only a group boundary can break it, and
      // there it comes down to whether anything was dropped in between. Deliberately not derived from
      // group numbers: they need not be sequential, so adjacency neither proves continuity nor catches
      // a group the max age check truncated on the way past.
      #continuesDelivery(sequence) {
        if (this.#deliveredGroup === void 0)
          return false;
        return sequence === this.#deliveredGroup || !this.#gap;
      }
      #checkMaxAge() {
        if (this.#active === void 0)
          return;
        let skipped = 0;
        const start = this.#groups[0]?.consumer.sequence;
        let hole = false;
        while (this.#groups.length >= 2) {
          const threshold = time_exports.Micro.fromMilli(this.#maxAge.peek());
          const first = this.#groups[0];
          let min;
          let max;
          for (const group of this.#groups) {
            if (group.latest === void 0)
              continue;
            const frame = group.frames.at(0)?.timestamp ?? group.latest;
            if (min === void 0 || frame < min)
              min = frame;
            if (max === void 0 || group.latest > max)
              max = group.latest;
          }
          if (min === void 0 || max === void 0)
            break;
          const age = max - min;
          if (age <= threshold)
            break;
          this.#groups.shift();
          this.#active = this.#groups[0]?.consumer.sequence;
          const nextStart = this.#groups[0]?.frames.at(0)?.timestamp ?? this.#groups[0]?.end;
          const marker = !first.empty && !first.media;
          if (marker || !ptsContiguous(first.end ?? this.#presentedEnd, nextStart)) {
            hole = true;
          }
          first.consumer.close();
          first.frames.length = 0;
          skipped++;
          this.#gap = true;
        }
        if (hole)
          this.#markPlayhead();
        if (skipped) {
          console.warn(`skipping slow groups: track=${this.#track.name} ${start} -> ${this.#active} count=${skipped}`);
          this.#updateBuffered();
          this.#notify?.();
          this.#notify = void 0;
        }
      }
      // Skip the stalled active group once it has presented up to where the next group
      // begins (its furthest frame end reaches the next group's first timestamp). Only
      // fires when the active group is fully consumed and still open, so we never drop
      // frames the consumer hasn't seen. Returns true if a group was skipped.
      #tryDurationSkip() {
        if (this.#active === void 0)
          return false;
        const active = this.#groups[0];
        if (!active || active.consumer.sequence !== this.#active)
          return false;
        if (active.done || active.frames.length > 0 || active.end === void 0)
          return false;
        const next = this.#groups[1];
        const nextStart = next?.frames.at(0)?.timestamp;
        if (!next || nextStart === void 0 || active.end < nextStart)
          return false;
        this.#groups.shift();
        console.warn(`skipping covered group: ${active.consumer.sequence} -> ${next.consumer.sequence}`);
        this.#recordPresented(active);
        this.#active = next.consumer.sequence;
        active.consumer.close();
        active.frames.length = 0;
        this.#updateBuffered();
        return true;
      }
      // A group whose media timestamps sit below the live edge earlier groups reached is
      // malformed. Returns true if the track was aborted.
      #checkMalformed() {
        const live = this.#liveEdge;
        if (live === void 0)
          return;
        for (const group of this.#groups) {
          if (group.consumer.sequence <= live.group)
            continue;
          if (group.minMedia !== void 0 && group.minMedia < live.timestamp) {
            this.#abort(new Error("group timestamp is below the live edge"));
            return;
          }
        }
      }
      #abortIfRewound(group, timestamp) {
        const live = this.#liveEdge;
        if (live === void 0)
          return false;
        if (group.consumer.sequence <= live.group)
          return false;
        if (timestamp >= live.timestamp)
          return false;
        this.#abort(new Error("group timestamp is below the live edge"));
        return true;
      }
      #abort(error2) {
        this.#error = error2;
        this.#finish(error2);
        this.#track.close(error2);
        this.#notify?.();
        this.#notify = void 0;
      }
      /**
       * Returns the next frame in order along with its group number and the current
       * {@link discontinuity} count, awaiting one if needed. A `frame` of undefined signals either
       * the end of that group or, when `end` is present, an exclusive media endpoint carried by a
       * legacy marker. The overall result is undefined once closed. When `discontinuity`
       * jumps relative to the previous call, re-apply startup delay and skip: it is a playhead
       * event, not a decoder flush.
       *
       * `continuous` is true when this result picks up exactly where the previous frame left off, so
       * the span between them can be treated as delivered. It is false on the first frame, after a
       * playhead event, and whenever the consumer threw content away to keep up: a slow group skipped
       * for the max age, a group truncated by a decode error. Use it rather than comparing group
       * numbers, which are not required to be sequential: adjacency neither proves the timeline is
       * unbroken nor catches a group dropped on the way past.
       *
       * It reports what this consumer dropped plus marker groups the publisher declared.
       * An unmarked forward timestamp jump still reads as continuous because nothing on the wire says
       * the missing span will never arrive.
       * After buffered groups drain, a finished track returns undefined and an aborted track throws.
       */
      async next() {
        for (; ; ) {
          if (this.#error)
            throw this.#error;
          this.#checkMalformed();
          if (this.#error)
            throw this.#error;
          const ended = this.#closed.peek();
          if (this.#groups.length === 0) {
            if (ended !== void 0) {
              if (ended instanceof Error)
                throw ended;
              return void 0;
            }
          }
          if (this.#active !== void 0 && this.#groups.length > 0) {
            const head = this.#groups[0];
            if (head.consumer.sequence > this.#active) {
              const contiguous = ptsContiguous(this.#presentedEnd, head.frames.at(0)?.timestamp);
              const empty2 = head.empty && head.consumer.done;
              const maxAge = time_exports.Micro.fromMilli(this.#maxAge.peek());
              const skipHole = head.frames.length > 0 && (maxAge === 0 || this.#presentedEnd !== void 0 && head.latest !== void 0 && head.latest - this.#presentedEnd > maxAge);
              if (empty2 || contiguous || skipHole || ended !== void 0) {
                if ((skipHole || ended !== void 0) && !contiguous && !empty2)
                  this.#markPlayhead();
                if (!contiguous)
                  this.#gap = true;
                this.#active = head.consumer.sequence;
              }
            }
          }
          if (this.#groups.length > 0 && this.#active !== void 0 && this.#groups[0].consumer.sequence <= this.#active) {
            const frame = this.#groups[0].frames.shift();
            if (frame) {
              const seq = this.#groups[0].consumer.sequence;
              const end = this.#format.end?.(frame);
              if (end !== void 0) {
                if (!this.#groups[0].media)
                  this.#markPlayhead();
                if (this.#liveEdge === void 0 || end > this.#liveEdge.timestamp) {
                  this.#liveEdge = { group: seq, timestamp: end };
                }
                this.#updateBuffered();
                return {
                  frame: void 0,
                  group: seq,
                  discontinuity: this.#discontinuity,
                  continuous: this.#continuesDelivery(seq),
                  end
                };
              }
              const continuous = this.#continuesDelivery(seq);
              if (seq !== this.#deliveredGroup)
                this.#gap = false;
              this.#deliveredGroup = seq;
              const live = this.#liveEdge;
              if (live === void 0 || frame.timestamp > live.timestamp) {
                this.#liveEdge = { group: seq, timestamp: frame.timestamp };
              }
              this.#updateBuffered();
              return { frame, group: seq, discontinuity: this.#discontinuity, continuous };
            }
            if (this.#groups[0].done) {
              if (this.#groups[0].consumer.sequence === this.#active) {
                this.#recordPresented(this.#groups[0]);
                this.#active += 1;
              }
              const group = this.#groups.shift();
              if (group) {
                const seq = group.consumer.sequence;
                if (group.truncated)
                  this.#gap = true;
                this.#updateBuffered();
                return {
                  frame: void 0,
                  group: seq,
                  discontinuity: this.#discontinuity,
                  // A marker carries no content of its own, so this just reports whether
                  // the group it closes was itself reached without a gap.
                  continuous: this.#continuesDelivery(seq)
                };
              }
            }
            if (this.#tryDurationSkip())
              continue;
          }
          if (this.#notify) {
            throw new Error("multiple calls to next not supported");
          }
          const abort = this.#signals.abort;
          if (abort.aborted)
            return void 0;
          const aborted3 = await new Promise((resolve2) => {
            const onAbort = () => resolve2(true);
            abort.addEventListener("abort", onAbort, { once: true });
            this.#notify = () => {
              abort.removeEventListener("abort", onAbort);
              resolve2(false);
            };
          });
          this.#notify = void 0;
          if (aborted3)
            return void 0;
        }
      }
      #markPlayhead() {
        this.#discontinuity++;
        this.#deliveredGroup = void 0;
        this.#gap = true;
      }
      #updateBuffered() {
        const ranges = [];
        let prev;
        for (const group of this.#groups) {
          const first = group.frames.at(0);
          if (!first || group.latest === void 0)
            continue;
          const start = time_exports.Milli.fromMicro(first.timestamp);
          const end = time_exports.Milli.fromMicro(group.latest);
          const last = ranges.at(-1);
          const contiguous = prev?.done && prev.consumer.sequence + 1 === group.consumer.sequence;
          if (last && (last.end >= start || contiguous)) {
            last.end = time_exports.Milli.max(last.end, end);
          } else {
            ranges.push({ start, end });
          }
          prev = group;
        }
        this.#buffered.set(ranges);
      }
      /**
       * A counter that increments at each playhead event: a declared marker group, an unproven
       * delivered hole, or a latency skip. Also surfaced per-read via {@link next}.
       */
      get discontinuity() {
        return this.#discontinuity;
      }
      /** Stop consuming and release the track and all buffered groups. */
      close() {
        this.#finish(null);
        this.#signals.close();
      }
    };
  }
});

// ../../node_modules/@moq/hang/container/legacy.js
var legacy_exports = {};
__export(legacy_exports, {
  Format: () => Format3,
  Producer: () => Producer9,
  encodeFrame: () => encodeFrame
});
function encodeFrame(source, timestamp) {
  const timestampBytes = varint_exports.encode(timestamp);
  const data = new Uint8Array(timestampBytes.byteLength + source.byteLength);
  data.set(timestampBytes, 0);
  if (source instanceof Uint8Array) {
    data.set(source, timestampBytes.byteLength);
  } else {
    source.copyTo(data.subarray(timestampBytes.byteLength));
  }
  return data;
}
var Format3, Producer9;
var init_legacy = __esm({
  "../../node_modules/@moq/hang/container/legacy.js"() {
    init_net();
    init_net();
    Format3 = class {
      /** Configure the format for the track's media kind. */
      kind;
      /** Configure the format from a catalog entry or an explicit media kind. */
      constructor(config2) {
        this.kind = typeof config2 === "string" ? config2 : "sampleRate" in config2 ? "audio" : "video";
      }
      /** Write the final video frame's end timestamp before the group closes. */
      finishGroup(group, end) {
        if (this.kind !== "video" || end === void 0)
          return;
        group.writeFrame({ payload: encodeFrame(new Uint8Array(), end), timestamp: time_exports.Timestamp.fromMicros(end) });
      }
      /** Return the video-frame or audio-source endpoint for an empty codec payload. */
      end(frame) {
        return this.kind !== "data" && frame.payload.byteLength === 0 ? frame.timestamp : void 0;
      }
      /** Decode one legacy frame, including an empty-payload duration marker. */
      decode(frame) {
        const [timestamp, data] = varint_exports.decode(frame);
        return [{ payload: data, timestamp, keyframe: false }];
      }
    };
    Producer9 = class {
      #track;
      #format;
      #previous;
      #reordered = false;
      #group;
      #timeline;
      // The newest timestamp written, reported to the timeline when the track closes: the last
      // group has no successor to bound it, so its segment would be published a group short.
      #end;
      // Exclusive presentation end of finished groups. A frame below this is refused.
      #liveEdge;
      // Gap between consecutive timestamps, used to close the last group when no successor exists.
      #interval;
      // A cut's marker is the newest group, so another one would say nothing new.
      #marked = false;
      /** Wrap a track to publish legacy-container frames into it. */
      constructor(track, format, props = {}) {
        this.#format = format;
        this.#track = track;
        this.#timeline = props.timeline;
      }
      /** Encode and append a frame; a keyframe starts a new group. Throws if the first frame is not a keyframe, or if the timestamp sits below the live edge earlier groups reached. */
      encode(data, timestamp, keyframe) {
        this.#marked = false;
        if (keyframe) {
          const rewound = this.#previous !== void 0 && timestamp < this.#previous;
          this.#close(rewound ? void 0 : timestamp);
          if (rewound)
            this.#interval = void 0;
          this.#refuse(timestamp);
          this.#group = this.#track.appendGroup();
          this.#timeline?.record(this.#group.sequence, timestamp, true);
        } else if (!this.#group) {
          throw new Error("must start with a keyframe");
        } else {
          this.#refuse(timestamp);
        }
        this.#group?.writeFrame({
          payload: encodeFrame(data, timestamp),
          timestamp: time_exports.Timestamp.fromMicros(timestamp)
        });
        this.#reordered ||= this.#previous !== void 0 && timestamp < this.#previous;
        if (this.#previous !== void 0 && timestamp > this.#previous) {
          const delta = timestamp - this.#previous;
          this.#interval = delta;
        }
        this.#previous = timestamp;
        if (this.#end === void 0 || timestamp > this.#end)
          this.#end = timestamp;
      }
      /**
       * Close the current group and mark a break in the timeline: whatever comes next does not
       * continue it. Call it when the timeline is about to jump, e.g. an encoder pausing for lack of
       * demand or switching source; the next keyframe already rolls the group over on its own.
       *
       * `end` is where the content stops, estimated from the frame cadence when omitted. After closing
       * the group, this publishes a marker group of one empty frame at `end`, or at the live edge
       * without one. Without the marker, a group's reach runs to its successor's first frame, so the
       * group before a pause reads as live until whatever resumes it, and a subscriber joining
       * mid-break is handed that stale media. The marker bounds it, and it is the latest group a
       * joiner lands on. Data tracks only close the group, since an empty payload is data. No marker
       * is written until a frame follows the last one. Throws if `end` precedes the last video frame.
       */
      cut(end) {
        this.#close(end);
        this.#interval = void 0;
        const timestamp = end ?? this.#liveEdge;
        if (this.#format.kind === "data" || this.#marked || timestamp === void 0)
          return;
        const group = this.#track.appendGroup();
        this.#timeline?.record(group.sequence, timestamp, false);
        this.#timeline?.end(timestamp);
        group.writeFrame({
          payload: encodeFrame(new Uint8Array(), timestamp),
          timestamp: time_exports.Timestamp.fromMicros(timestamp)
        });
        group.close();
        this.#liveEdge = this.#liveEdge === void 0 ? timestamp : Math.max(this.#liveEdge, timestamp);
        this.#marked = true;
      }
      // Flush and close the current group at the supplied or estimated end timestamp.
      #close(end) {
        if (!this.#group)
          return;
        if (this.#format.kind === "video" && !this.#reordered && end !== void 0 && this.#previous !== void 0 && end < this.#previous) {
          throw new Error("video group endpoint precedes its last frame");
        }
        end ??= this.#end !== void 0 && this.#interval !== void 0 ? this.#end + this.#interval : void 0;
        this.#format.finishGroup(this.#group, this.#reordered ? void 0 : end);
        const bound = end ?? this.#end;
        if (bound !== void 0)
          this.#timeline?.end(bound);
        this.#group.close();
        this.#group = void 0;
        if (this.#end !== void 0) {
          this.#liveEdge = this.#liveEdge === void 0 ? this.#end : Math.max(this.#liveEdge, this.#end);
        }
        this.#end = void 0;
        this.#previous = void 0;
        this.#reordered = false;
      }
      #refuse(timestamp) {
        if (this.#liveEdge !== void 0 && timestamp < this.#liveEdge) {
          throw new Error("frame timestamp is below the live edge");
        }
      }
      /** Close the track and current group, optionally with an error. */
      close(err2) {
        if (!err2)
          this.#close();
        this.#group?.close(err2);
        this.#track.close(err2);
      }
    };
  }
});

// ../../node_modules/@moq/hang/container/track.js
function trackInfo(options) {
  return {
    timescale: time_exports.Timescale.MICRO,
    maxAge: options.maxAge ?? MAX_AGE_MS,
    priority: options.priority
  };
}
var MAX_AGE_MS;
var init_track5 = __esm({
  "../../node_modules/@moq/hang/container/track.js"() {
    init_net();
    MAX_AGE_MS = time_exports.Milli(3e4);
  }
});

// ../../node_modules/@moq/hang/container/types.js
function mergeBufferedRanges(a2, b3) {
  if (a2.length === 0)
    return b3;
  if (b3.length === 0)
    return a2;
  const result = [];
  const all = [...a2, ...b3].sort((x4, y3) => x4.start - y3.start);
  for (const range of all) {
    const last = result.at(-1);
    if (last && last.end >= range.start) {
      last.end = time_exports.Milli.max(last.end, range.end);
    } else {
      result.push({ ...range });
    }
  }
  return result;
}
var init_types = __esm({
  "../../node_modules/@moq/hang/container/types.js"() {
    init_net();
  }
});

// ../../node_modules/@moq/hang/container/index.js
var init_container2 = __esm({
  "../../node_modules/@moq/hang/container/index.js"() {
    init_loc();
    init_cmaf();
    init_consumer3();
    init_legacy();
    init_track5();
    init_types();
  }
});

// ../../node_modules/@moq/publish/encoder-wi3Mqpyi.js
function _(e5) {
  if (!Number.isSafeInteger(e5) || e5 <= 0) throw RangeError(`fanout queue must be a positive safe integer, got ${e5}`);
  return e5;
}
function b(e5) {
  return "samples" in e5;
}
function x(e5) {
  return "track" in e5 || "samples" in e5 ? e5.kind : "auto";
}
function S(e5) {
  return "track" in e5 ? e5 : {
    track: e5,
    kind: "auto"
  };
}
function te() {
  return new TransformStream({ transform(e5, t) {
    let n2 = [];
    for (let t2 = 0; t2 < e5.numberOfChannels; t2++) {
      let r2 = new Float32Array(e5.numberOfFrames);
      e5.copyTo(r2, {
        planeIndex: t2,
        format: "f32-planar"
      }), n2.push(r2);
    }
    t.enqueue({
      timestamp: e5.timestamp,
      channels: n2
    }), e5.close();
  } });
}
function ne(e5) {
  let t = e5.getConstraints().channelCount;
  if (t !== void 0) return typeof t == "number" ? t : t.exact ?? t.ideal ?? t.max ?? t.min;
}
function re(e5) {
  return e5 === void 0 || !Number.isFinite(e5) || e5 <= 0 ? w : opus_exports.supportsRate(e5) ? e5 : w;
}
function ye(e5, t) {
  let n2 = xe(t), i2 = we(n2.mime, e5.sampleRate) ?? e5.sampleRate, a2 = u53(i2), o = u53(e5.channelCount);
  if (n2.mime === "aac") return { catalog: {
    codec: _e,
    sampleRate: a2,
    numberOfChannels: o,
    bitrate: u53(n2.bitrate ?? e5.channelCount * he),
    container: { kind: "legacy" },
    description: hex_exports2.fromBytes(aac_exports.audioSpecificConfig(i2, e5.channelCount))
  } };
  let s = n2.frameDuration ?? pe;
  if (!me.includes(s)) throw Error(`opus frame duration must be ${me.join("/")} ms: ${s}`);
  return {
    catalog: {
      codec: "opus",
      sampleRate: a2,
      numberOfChannels: o,
      bitrate: u53(n2.bitrate ?? e5.channelCount * fe),
      container: { kind: "legacy" }
    },
    frameDuration: time_exports.Micro.fromMilli(s)
  };
}
function be(e5, t) {
  let n2 = e5.catalog;
  if (n2.codec.startsWith("mp4a")) return new de({
    sampleRate: t,
    channels: n2.numberOfChannels,
    size: { samples: ge }
  });
  if (n2.codec !== "opus") throw Error(`unsupported audio codec: ${n2.codec}`);
  return new de({
    sampleRate: t,
    channels: n2.numberOfChannels,
    size: { duration: e5.frameDuration ?? time_exports.Micro.fromMilli(pe) }
  });
}
function xe(e5) {
  return e5 === "opus" ? { mime: "opus" } : e5 === "aac" ? { mime: "aac" } : e5;
}
function Se(e5) {
  switch (e5) {
    case "voice":
      return {
        application: "voip",
        signal: "voice",
        usedtx: true
      };
    case "music":
      return {
        application: "audio",
        signal: "music"
      };
    default:
      return {};
  }
}
function Ce(e5, t, n2) {
  let r2 = e5.catalog, i2 = {
    codec: r2.codec,
    sampleRate: r2.sampleRate,
    numberOfChannels: r2.numberOfChannels,
    bitrate: r2.bitrate
  };
  if (r2.codec.startsWith("mp4a") && (i2.aac = { format: "aac" }), r2.codec === "opus") {
    let r3 = {
      ...Se(t),
      ...n2
    };
    e5.frameDuration !== void 0 && (r3.frameDuration = e5.frameDuration), Object.keys(r3).length > 0 && (i2.opus = r3);
  }
  return i2;
}
function we(e5, t) {
  let n2 = t !== void 0 && Number.isFinite(t) && t > 0 ? t : void 0;
  return e5 === "opus" ? opus_exports.pickRate(n2 ?? opus_exports.DEFAULT_SAMPLE_RATE) : n2 === void 0 ? void 0 : aac_exports.pickRate(n2);
}
function Ee(e5, t) {
  let n2 = (e6) => Object.fromEntries(Object.entries(e6 ?? {}).map(([e7, n3]) => [e7, n3[t]]));
  return {
    audio: n2(e5.audio?.renditions),
    video: n2(e5.video?.renditions),
    text: n2(e5.text?.renditions),
    json: n2(e5.json?.tracks),
    binary: n2(e5.binary?.tracks)
  };
}
function De() {
  let e5 = Math.round((performance.timeOrigin - MOQ_EPOCH_UNIX_MILLIS) * 1e3);
  return e5 < 0 ? {} : { clock: {
    wall: u53(e5),
    timescale: 1e6
  } };
}
function il(e5) {
  return "track" in e5 ? e5 : { track: e5 };
}
function al(e5) {
  return !("frames" in e5) && !("track" in e5);
}
function cl(e5) {
  return "frames" in e5 ? e5.frameRate : il(e5).track.getSettings().frameRate;
}
function ll(e5, t, n2) {
  let r2 = n2.maxPixels ?? t.width * t.height, i2 = 30 + (n2.framerate - 30) / 2, a2 = Math.round(r2 * n2.bitrateScale * i2 * dl(e5)), o = Math.round(Math.min(a2, n2.maxBitrate || a2));
  if (!(o > 0)) throw Error(`bitrate must be positive: ${o}`);
  return o;
}
async function ul(e5) {
  let t, n2 = new VideoEncoder({
    output: (e6, n3) => {
      t ??= n3?.decoderConfig?.codec;
    },
    error: () => {
    }
  });
  try {
    n2.configure(e5);
    let { width: t2, height: r2 } = e5, i2 = new VideoFrame(new Uint8Array(t2 * r2 * 3 / 2).fill(128), {
      format: "I420",
      codedWidth: t2,
      codedHeight: r2,
      timestamp: 0
    });
    try {
      n2.encode(i2, { keyFrame: true });
    } finally {
      i2.close();
    }
    await n2.flush();
  } finally {
    n2.state !== "closed" && n2.close();
  }
  if (!t) throw Error(`${e5.codec} encoder reported no codec string`);
  return t;
}
function dl(e5) {
  if (e5.startsWith("avc1")) return 1;
  if (e5.startsWith("hev1")) return 0.7;
  if (e5.startsWith("vp09")) return 0.8;
  if (e5.startsWith("av01")) return 0.6;
  if (e5 === "vp8") return 1.1;
  throw Error(`unknown codec: ${e5}`);
}
function fl(e5) {
  if ("frames" in e5) return;
  let t = il(e5).track.getConstraints(), n2 = ml(t.width), r2 = ml(t.height);
  return n2 !== void 0 && r2 !== void 0 ? n2 * r2 : void 0;
}
function pl(e5, t) {
  if ("frames" in e5) return;
  let { track: n2 } = il(e5);
  if (t === void 0) return;
  if (!Number.isFinite(t) || t <= 0) throw Error(`scale must be a finite number greater than 0: ${t}`);
  let r2 = n2.getCapabilities(), i2 = r2.width?.max, a2 = r2.height?.max;
  if (!(!i2 || !a2)) return i2 * a2 / t ** 2;
}
function ml(e5) {
  if (typeof e5 != "object" || !e5) return;
  let t = e5.max;
  return typeof t == "number" && Number.isFinite(t) && t > 0 ? t : void 0;
}
var f2, p2, m2, h2, g, v, y, C, w, ee, ie, ae, oe, se, ce, le, ue, de, fe, pe, me, he, ge, _e, ve, Te, Oe, ke, Ne, Pe, qe, Je, At, zt, Wt, Qt, $t, N, F, I, _n, L, er, Ar, jr, Ir, Qr, V, Ri, zi, Bi, ea, ta, na, ra, ia, fa, pa, W, Ba, Oo, Ao, us, ds, fs, ms, hs, Lc, Rc, ol, sl;
var init_encoder_wi3Mqpyi = __esm({
  "../../node_modules/@moq/publish/encoder-wi3Mqpyi.js"() {
    init_video_B0t1PcDc();
    init_net();
    init_net();
    init_signals();
    init_util2();
    init_catalog();
    init_container2();
    init_json();
    f2 = Object.defineProperty;
    p2 = (e5, t) => () => (t || (e5((t = { exports: {} }).exports, t), e5 = null), t.exports);
    m2 = (e5, t) => {
      let n2 = {};
      for (var r2 in e5) f2(n2, r2, {
        get: e5[r2],
        enumerable: true
      });
      return t || f2(n2, Symbol.toStringTag, { value: "Module" }), n2;
    };
    h2 = 4;
    g = class {
      #e;
      #t;
      #n;
      #r = /* @__PURE__ */ new Set();
      #i;
      #a = false;
      #o;
      constructor(e5, t) {
        this.#e = _(t?.queue ?? h2), this.#t = t?.clone, this.#n = t?.release, this.#i = e5.getReader(), this.#s();
      }
      subscribe(e5, t = this.#e) {
        let n2 = {
          queue: [],
          limit: _(t),
          waiting: void 0,
          done: this.#a
        };
        return this.#r.add(n2), e5.cleanup(() => {
          this.#r.delete(n2), this.#u(n2), n2.done = true, n2.waiting?.(), n2.waiting = void 0;
        }), new ReadableStream({
          pull: async (e6) => {
            for (; ; ) {
              let t2 = n2.queue.shift();
              if (t2 !== void 0) {
                e6.enqueue(t2);
                return;
              }
              if (n2.done) {
                this.#o ? e6.error(this.#o.error) : e6.close();
                return;
              }
              await new Promise((e7) => {
                n2.waiting = e7;
              });
            }
          },
          cancel: () => {
            this.#r.delete(n2), this.#u(n2);
          }
        }, { highWaterMark: 0 });
      }
      close() {
        if (!this.#a) {
          this.#a = true, this.#i.cancel().catch(() => {
          });
          for (let e5 of this.#r) this.#u(e5), e5.done = true, e5.waiting?.(), e5.waiting = void 0;
          this.#r.clear();
        }
      }
      async #s() {
        try {
          await this.#c();
        } catch (e5) {
          console.error("fanout source failed:", e5), this.#o = { error: e5 };
        }
        this.close();
      }
      async #c() {
        for (; ; ) {
          let { value: e5 } = await this.#i.read();
          if (e5 === void 0) break;
          if (this.#r.size === 0) {
            this.#n?.(e5);
            continue;
          }
          for (let t of this.#r) this.#l(t, this.#t ? this.#t(e5) : e5);
          this.#t && this.#n?.(e5);
        }
      }
      #l(e5, t) {
        for (; e5.queue.length >= e5.limit; ) {
          let t2 = e5.queue.shift();
          t2 !== void 0 && this.#n?.(t2);
        }
        e5.queue.push(t), e5.waiting?.(), e5.waiting = void 0;
      }
      #u(e5) {
        for (let t of e5.queue) this.#n?.(t);
        e5.queue.length = 0;
      }
    };
    v = new Blob(['Object.assign((value) => value, {\n	zero: 0,\n	fromMicro: (us) => us * 1e3,\n	fromMilli: (ms) => ms * 1e6,\n	fromSecond: (s) => s * 1e9,\n	toMicro: (ns) => ns / 1e3,\n	toMilli: (ns) => ns / 1e6,\n	toSecond: (ns) => ns / 1e9,\n	now: () => performance.now() * 1e6,\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\n/** Constructors, conversions, and arithmetic for {@link Micro} values. */\nconst Micro = Object.assign((value) => value, {\n	zero: 0,\n	fromNano: (ns) => ns / 1e3,\n	fromMilli: (ms) => ms * 1e3,\n	fromSecond: (s) => s * 1e6,\n	toNano: (us) => us * 1e3,\n	toMilli: (us) => us / 1e3,\n	toSecond: (us) => us / 1e6,\n	now: () => performance.now() * 1e3,\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\nObject.assign((value) => value, {\n	zero: 0,\n	fromNano: (ns) => ns / 1e6,\n	fromMicro: (us) => us / 1e3,\n	fromSecond: (s) => s * 1e3,\n	toNano: (ms) => ms * 1e6,\n	toMicro: (ms) => ms * 1e3,\n	toSecond: (ms) => ms / 1e3,\n	now: () => performance.now(),\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\nObject.assign((unitsPerSecond) => {\n	if (!Number.isSafeInteger(unitsPerSecond) || unitsPerSecond <= 0) throw new RangeError(`invalid timescale: ${unitsPerSecond}`);\n	return unitsPerSecond;\n}, {\n	/** One unit per second. */\n	SECOND: 1,\n	/** 1,000 units per second. */\n	MILLI: 1e3,\n	/** 1,000,000 units per second. */\n	MICRO: 1e6,\n	/** 1,000,000,000 units per second. */\n	NANO: 1e9\n});\nObject.assign((value) => value, {\n	zero: 0,\n	fromNano: (ns) => ns / 1e9,\n	fromMicro: (us) => us / 1e6,\n	fromMilli: (ms) => ms / 1e3,\n	toNano: (s) => s * 1e9,\n	toMicro: (s) => s * 1e6,\n	toMilli: (s) => s * 1e3,\n	now: () => performance.now() / 1e3,\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\n//#endregion\n//#region src/audio/capture-worklet.ts\nvar Capture = class extends AudioWorkletProcessor {\n	#sampleCount = 0;\n	#zero;\n	constructor(options) {\n		super();\n		this.#zero = options?.processorOptions?.zero ?? 0;\n	}\n	process(input) {\n		if (input.length > 1) throw new Error("only one input is supported.");\n		const channels = input[0];\n		if (channels.length === 0) return true;\n		const msg = {\n			timestamp: Micro.fromSecond(this.#sampleCount / sampleRate) + this.#zero,\n			channels\n		};\n		this.port.postMessage(msg);\n		this.#sampleCount += channels[0].length;\n		return true;\n	}\n};\nregisterProcessor("capture", Capture);\n//#endregion\n'], { type: "application/javascript" });
    y = URL.createObjectURL(v);
    C = 32;
    w = 48e3;
    ee = class {
      in;
      sampleRate;
      channelCount;
      #e = {
        frames: new Signal(void 0),
        format: new Signal(void 0),
        root: new Signal(void 0)
      };
      out = readonlys(this.#e);
      #t = new Signal(false);
      #n = new Signal(0);
      blocked;
      #r = new Effect();
      constructor(e5) {
        this.in = {
          source: getter(e5?.source),
          enabled: getter(e5?.enabled ?? true)
        }, this.sampleRate = Signal.from(e5?.sampleRate), this.channelCount = Signal.from(e5?.channelCount), this.blocked = this.#r.computed((e6) => e6.get(this.#n) > 0 || e6.get(this.#t)), this.#r.run(this.#i(this.#o.bind(this)));
      }
      #i(e5) {
        return (t) => {
          try {
            e5(t);
          } catch (e6) {
            throw this.#a(t), e6;
          }
        };
      }
      #a(e5) {
        this.#n.update((e6) => e6 + 1), e5.cleanup(() => this.#n.update((e6) => e6 - 1));
      }
      #o(e5) {
        let t = e5.get(this.in.source);
        if (t) {
          if (b(t)) {
            this.#s(t, e5);
            return;
          }
          this.#c(S(t), e5);
        }
      }
      #s(e5, t) {
        let { sampleRate: n2, channelCount: r2 } = e5, i2 = new g(e5.samples.pipeThrough(te()), { queue: C });
        t.cleanup(() => i2.close()), t.set(this.#e.format, {
          sampleRate: n2,
          channelCount: r2
        }, void 0), t.set(this.#e.frames, i2, void 0);
      }
      #c(e5, t) {
        if (!t.get(this.in.enabled)) return;
        let n2 = e5.track.getSettings(), r2 = t.get(this.sampleRate) ?? re(n2.sampleRate), i2 = t.get(this.channelCount) ?? ne(e5.track), o = new AudioContext({
          latencyHint: "interactive",
          sampleRate: r2
        });
        t.cleanup(() => o.close());
        let s = gesture_exports.unlock(t, o);
        t.run((e6) => {
          let t2 = !e6.get(s) && !navigator.userActivation?.hasBeenActive;
          e6.set(this.#t, t2, false);
        });
        let l2 = new MediaStreamAudioSourceNode(o, { mediaStream: new MediaStream([e5.track]) });
        t.cleanup(() => l2.disconnect());
        let u2 = new Signal(false);
        t.spawn(async () => {
          try {
            await t.race(o.audioWorklet.addModule(y).then(() => true)) && u2.set(true);
          } catch (e6) {
            throw this.#a(t), e6;
          }
        }), t.run(this.#i((e6) => {
          if (!e6.get(u2) || !e6.get(s)) return;
          let t2 = i2 ?? n2.channelCount ?? l2.channelCount, r3 = new AudioWorkletNode(o, "capture", {
            numberOfInputs: 1,
            numberOfOutputs: 0,
            channelCount: t2,
            channelCountMode: i2 === void 0 ? "max" : "explicit",
            processorOptions: { zero: performance.now() * 1e3 }
          });
          l2.connect(r3), e6.cleanup(() => l2.disconnect(r3));
          let a2 = new g(this.#l(r3, o.sampleRate, e6), { queue: C });
          e6.cleanup(() => a2.close()), e6.cleanup(() => this.#e.format.set(void 0)), e6.set(this.#e.root, l2), e6.set(this.#e.frames, a2);
        }));
      }
      #l(e5, t, n2) {
        return new ReadableStream({ start: (r2) => {
          n2.event(e5.port, "message", (e6) => {
            let n3 = e6.data, i2 = n3.channels.length;
            i2 && (this.#e.format.peek()?.channelCount !== i2 && this.#e.format.set({
              sampleRate: t,
              channelCount: i2
            }), (r2.desiredSize ?? 0) > 0 && r2.enqueue(n3));
          }), e5.port.start();
        } }, { highWaterMark: C });
      }
      close() {
        this.#r.close();
      }
    };
    ie = 1e7;
    ae = class {
      #e = [];
      #t = 0;
      observe(e5, t) {
        let n2 = t - ie;
        for (; this.#t < this.#e.length && this.#e[this.#t].at < n2; ) this.#t++;
        for (; this.#e.length > this.#t; ) {
          let t2 = this.#e.at(-1);
          if (!t2 || t2.lateness < e5) break;
          this.#e.pop();
        }
        return this.#t === this.#e.length ? (this.#e = [], this.#t = 0) : this.#t > 1024 && this.#t * 2 > this.#e.length && (this.#e = this.#e.slice(this.#t), this.#t = 0), this.#e.push({
          at: t,
          lateness: e5
        }), this.#e[this.#t].lateness;
      }
    };
    oe = class {
      #e = new ae();
      #t = 0;
      #n = 0;
      get estimate() {
        return {
          jitter: this.#t ? u53(this.#t) : void 0,
          delay: this.#n ? u53(this.#n) : void 0
        };
      }
      flush(e5, t, n2 = performance.now() * 1e3) {
        let r2 = n2 - e5, i2 = t.observe(r2, n2), a2 = this.#e.observe(r2, n2), o = Math.ceil((r2 - a2) / 1e3), s = Math.ceil((a2 - i2) / 1e3);
        return o <= this.#t && s <= this.#n ? false : (this.#t = Math.max(this.#t, o), this.#n = Math.max(this.#n, s), true);
      }
    };
    se = 0.2;
    ce = class {
      #e;
      #t;
      constructor(e5 = 1) {
        this.#e = e5, this.#t = e5;
      }
      set(e5) {
        this.#t = e5;
      }
      apply(e5, t) {
        if (this.#e === 1 && this.#t === 1) return e5;
        let n2 = 1 / (se * t), r2 = e5.channels[0]?.length ?? 0, i2 = e5.channels.map((e6) => new Float32Array(e6));
        for (let e6 = 0; e6 < r2; e6++) if (this.#e < this.#t ? this.#e = Math.min(this.#t, this.#e + n2) : this.#e > this.#t && (this.#e = Math.max(this.#t, this.#e - n2)), this.#e !== 1) for (let t2 of i2) t2[e6] *= this.#e;
        return {
          timestamp: e5.timestamp,
          channels: i2
        };
      }
    };
    le = class {
      #e;
      #t;
      #n;
      #r;
      #i = 0;
      #a = 0;
      constructor(e5) {
        if (e5.from <= 0 || e5.to <= 0) throw Error("invalid sample rate");
        if (e5.channels <= 0) throw Error("invalid channel count");
        this.#e = e5.from, this.#t = e5.channels, this.#n = e5.from / e5.to;
      }
      push(e5) {
        if (e5.channels.length !== this.#t) throw Error("wrong number of channels");
        let t = e5.channels[0]?.length ?? 0;
        for (let n3 of e5.channels) if (n3.length !== t) throw Error("mismatching number of samples");
        if (t === 0) return;
        let n2 = this.#i, i2 = n2 + t - 1, a2 = 0;
        for (; Math.floor((this.#a + a2) * this.#n) + 1 <= i2; ) a2++;
        let o = this.#a;
        this.#a += a2;
        let s = Array.from({ length: this.#t }, () => new Float32Array(a2));
        for (let t2 = 0; t2 < a2; t2++) {
          let r2 = (o + t2) * this.#n, i3 = Math.floor(r2), a3 = r2 - i3;
          for (let r3 = 0; r3 < this.#t; r3++) {
            let o2 = i3 < n2 ? this.#r?.[r3] ?? 0 : e5.channels[r3][i3 - n2], c3 = e5.channels[r3][i3 + 1 - n2];
            s[r3][t2] = o2 + (c3 - o2) * a3;
          }
        }
        if (this.#o(e5.channels, t), a2 === 0) return;
        let c2 = o * this.#n - n2;
        return {
          timestamp: e5.timestamp + time_exports.Micro.fromSecond(c2 / this.#e),
          channels: s
        };
      }
      #o(e5, t) {
        this.#r ??= new Float32Array(this.#t);
        for (let n2 = 0; n2 < this.#t; n2++) this.#r[n2] = e5[n2][t - 1];
        this.#i += t;
      }
    };
    ue = time_exports.Micro(1e3);
    de = class {
      #e;
      #t;
      #n;
      #r;
      #i = 0;
      #a = 0;
      #o = 0;
      #s = [];
      #c = 0;
      constructor(e5) {
        if (e5.sampleRate <= 0) throw Error("invalid sample rate");
        if (e5.channels <= 0) throw Error("invalid channel count");
        if ("samples" in e5.size && e5.size.samples <= 0) throw Error("invalid frame samples");
        if ("duration" in e5.size && e5.size.duration <= 0) throw Error("invalid frame duration");
        this.#e = e5.sampleRate, this.#t = e5.channels, this.#n = e5.size;
      }
      push(e5) {
        if (e5.channels.length !== this.#t) throw Error("wrong number of channels");
        let t = e5.channels[0]?.length ?? 0;
        for (let n3 of e5.channels) if (n3.length !== t) throw Error("mismatching number of samples");
        if (t === 0) return [];
        this.#l(e5.timestamp) && this.#u(e5.timestamp), this.#r ??= e5.timestamp, this.#o += t;
        let n2 = [], r2 = 0;
        for (; r2 < t; ) {
          this.#s.length === 0 && (this.#s = this.#d());
          let i2 = this.#s[0].length - this.#c, a2 = Math.min(i2, t - r2);
          for (let t2 = 0; t2 < this.#t; t2++) this.#s[t2].set(e5.channels[t2].subarray(r2, r2 + a2), this.#c);
          r2 += a2, this.#c += a2, this.#c === this.#s[0].length && (n2.push({
            timestamp: this.#p(),
            channels: this.#s
          }), this.#a += this.#s[0].length, this.#i++, this.#s = [], this.#c = 0);
        }
        return n2;
      }
      get next() {
        return this.#p();
      }
      #l(e5) {
        if (this.#r === void 0) return false;
        let t = time_exports.Micro.fromSecond(this.#o / this.#e);
        return Math.abs(e5 - this.#r - t) > ue;
      }
      #u(e5) {
        this.#r = e5, this.#i = 0, this.#a = 0, this.#o = 0, this.#s = [], this.#c = 0;
      }
      #d() {
        let e5 = this.#f();
        return Array.from({ length: this.#t }, () => new Float32Array(e5));
      }
      #f() {
        return "samples" in this.#n ? this.#n.samples : Math.round((this.#i + 1) * this.#n.duration * this.#e / 1e6) - this.#a;
      }
      #p() {
        if (this.#r === void 0) throw Error("missing timestamp origin");
        let e5 = "duration" in this.#n ? this.#i * this.#n.duration : time_exports.Micro.fromSecond(this.#a / this.#e);
        return this.#r + e5;
      }
    };
    fe = 32e3;
    pe = time_exports.Milli(20);
    me = [
      2.5,
      5,
      10,
      20,
      40,
      60
    ];
    he = 64e3;
    ge = 1024;
    _e = "mp4a.40.2";
    ve = class {
      name;
      in;
      volume;
      codec;
      get capture() {
        return this.in.capture.peek();
      }
      #e = new Signal(void 0);
      #t = new Signal(void 0);
      #n = {
        catalog: new Signal(void 0),
        root: new Signal(void 0),
        active: new Signal(false),
        stats: new Signal({
          frames: 0,
          bytes: 0
        })
      };
      out = readonlys(this.#n);
      #r;
      #i;
      #a;
      #o = new Signal(void 0);
      #s = new Signal(0);
      settled;
      #c = new Effect();
      #l = new oe();
      constructor(e5, t) {
        if (t && "source" in t) throw Error("Audio.Encoder: `source` moved to Audio.Capture; construct one and pass `capture`");
        this.name = e5, this.in = {
          enabled: getter(t?.enabled ?? true),
          broadcast: getter(t?.broadcast),
          capture: getter(t?.capture),
          bandwidth: getter(t?.bandwidth)
        }, this.volume = Signal.from(t?.volume ?? 1), this.codec = Signal.from(t?.codec ?? "opus"), this.#c.run((e6) => {
          let t2 = e6.get(this.in.capture);
          t2 && e6.proxy(this.#n.root, t2.out.root);
        }), this.settled = this.#c.computed((e6) => {
          if (e6.get(this.#n.catalog) !== void 0 || e6.get(this.#o) !== void 0 || e6.get(this.#s) > 0) return true;
          let t2 = e6.get(this.in.capture);
          return t2 !== void 0 && !!e6.get(t2.blocked);
        }), this.#c.run(this.#u.bind(this));
        for (let e6 of [this.#f, this.#p]) this.#c.run((t2) => {
          try {
            e6.call(this, t2);
          } catch (e7) {
            throw this.#s.update((e8) => e8 + 1), t2.cleanup(() => this.#s.update((e8) => e8 - 1)), e7;
          }
        });
        this.#c.run(this.#d.bind(this));
      }
      #u(e5) {
        let t = e5.get(this.in.capture);
        if (!t) return;
        let n2 = e5.get(t.out.frames);
        if (!n2) return;
        let r2 = n2.subscribe(e5).getReader();
        e5.cleanup(() => {
          r2.cancel().catch(() => {
          });
        });
        let i2 = new ce(this.volume.peek());
        e5.spawn(async () => {
          for (; ; ) {
            let n3 = await e5.race(r2.read());
            if (!n3?.value) break;
            let a2 = t.out.format.peek();
            if (!a2) continue;
            i2.set(this.volume.peek());
            let o = i2.apply(n3.value, a2.sampleRate), s = this.#r;
            s && s.channelCount === o.channels.length && s.push(o);
          }
        });
      }
      #d(e5) {
        let t = e5.get(this.in.broadcast);
        if (!t) return;
        let n2 = t.audio(this.name);
        e5.cleanup(() => n2.close()), e5.proxy(n2.config, this.out.catalog), e5.run((e6) => {
          let r2 = e6.get(this.in.enabled), i2 = e6.get(this.in.capture), a2 = i2 ? e6.get(i2.out.format) : void 0, o = e6.get(this.#o);
          !r2 || !a2 || o || this.#h(n2.track, t.baseline, a2, e6);
        }), e5.run((e6) => {
          let t2 = e6.get(n2.track);
          t2 && e6.cleanup(() => {
            let e7 = this.#i;
            this.#i = void 0, e7 !== void 0 && t2.closed.peek() === void 0 && (this.#a = e7, t2.writeFrame({
              payload: legacy_exports.encodeFrame(/* @__PURE__ */ new Uint8Array(), e7),
              timestamp: time_exports.Timestamp.fromMicros(e7)
            }));
          });
        }), e5.run((e6) => {
          let t2 = e6.get(this.in.enabled), r2 = e6.get(this.in.capture), i2 = r2 ? e6.get(r2.out.format) : void 0, a2 = e6.get(n2.track), o = e6.get(this.#o);
          o && a2?.close(o), e6.set(this.#n.active, t2 && !!i2 && !!a2 && !o, false);
        }), e5.run((e6) => {
          let t2 = e6.get(this.in.enabled), r2 = e6.get(n2.track), i2 = e6.get(this.in.bandwidth);
          if (!t2 || !r2 || !i2) return;
          let a2;
          e6.subscribe(this.#e, (e7) => {
            let t3 = e7?.catalog.bitrate;
            t3 !== void 0 && (a2 ? a2.update(t3) : a2 = i2.reserve(r2, t3));
          }), e6.cleanup(() => a2?.close());
        });
      }
      #f(e5) {
        let t = e5.get(this.in.capture), n2 = t ? e5.get(t.out.format) : void 0;
        if (!e5.get(this.in.enabled) || !n2) {
          e5.set(this.#e, void 0);
          return;
        }
        e5.set(this.#e, ye(n2, e5.get(this.codec)));
      }
      #p(e5) {
        let t = e5.get(this.#e)?.catalog;
        if (!t) {
          e5.set(this.#n.catalog, void 0);
          return;
        }
        let n2 = e5.get(this.#t), r2 = n2?.config === t ? {
          ...t,
          description: n2.description
        } : t;
        e5.set(this.#n.catalog, {
          ...r2,
          ...this.#l.estimate
        });
      }
      #m(e5) {
        let t = xe(e5.get(this.codec)), n2 = {};
        return t.mime === "opus" ? (t.complexity !== void 0 && (n2.complexity = t.complexity), t.packetlossperc !== void 0 && (n2.packetlossperc = t.packetlossperc), t.useinbandfec !== void 0 && (n2.useinbandfec = t.useinbandfec), t.usedtx !== void 0 && (n2.usedtx = t.usedtx), n2) : n2;
      }
      #h(e5, t, n2, i2) {
        i2.spawn(async () => {
          await libav_exports.polyfill(), i2.run((i3) => {
            let a2 = i3.get(this.#e);
            if (!a2) return;
            let o = a2.catalog, s = i3.get(this.in.capture), c2 = s ? i3.get(s.in.source) : void 0, l2 = Ce(a2, c2 ? x(c2) : "auto", this.#m(i3)), d2 = n2.sampleRate === o.sampleRate ? void 0 : new le({
              from: n2.sampleRate,
              to: o.sampleRate,
              channels: o.numberOfChannels
            }), f3 = be(a2, o.sampleRate), p3 = new AudioEncoder({
              output: (n3, i4) => {
                if (n3.type !== "key") throw Error("only key frames are supported");
                this.#g(o, i4?.decoderConfig?.description), this.#n.stats.update((e6) => ({
                  frames: e6.frames + 1,
                  bytes: e6.bytes + n3.byteLength
                }));
                let a3 = e5.peek();
                if (a3 && !(this.#a !== void 0 && n3.timestamp < this.#a) && (a3.writeFrame({
                  payload: legacy_exports.encodeFrame(n3, n3.timestamp),
                  timestamp: time_exports.Timestamp.fromMicros(n3.timestamp)
                }), this.#l.flush(n3.timestamp, t))) {
                  let e6 = this.#n.catalog.peek();
                  e6 && this.#n.catalog.set({
                    ...e6,
                    ...this.#l.estimate
                  });
                }
              },
              error: (e6) => {
                console.error("encoder error", e6), this.#o.set(e6);
              }
            });
            i3.cleanup(() => {
              p3.state !== "closed" && p3.close();
            }), console.debug("encoding audio", l2), p3.configure(l2);
            let m3, h3 = {
              channelCount: o.numberOfChannels,
              push: (t2) => {
                let n3 = d2 ? d2.push(t2) : t2;
                if (!n3) return;
                let r2 = f3.push(n3);
                for (let [t3, n4] of r2.entries()) {
                  if (!e5.peek()) continue;
                  let i4 = Math.round(n4.timestamp);
                  m3 !== void 0 && i4 !== m3 && (p3.reset(), p3.configure(l2));
                  let a3 = n4.channels.reduce((e6, t4) => e6 + t4.length, 0), s2 = new Float32Array(a3);
                  n4.channels.reduce((e6, t4) => (s2.set(t4, e6), e6 + t4.length), 0);
                  let c3 = new AudioData({
                    format: "f32-planar",
                    sampleRate: o.sampleRate,
                    numberOfFrames: n4.channels[0].length,
                    numberOfChannels: n4.channels.length,
                    timestamp: i4,
                    data: s2,
                    transfer: [s2.buffer]
                  });
                  p3.encode(c3), c3.close(), m3 = Math.round(r2[t3 + 1]?.timestamp ?? f3.next), this.#i = m3;
                }
              }
            };
            this.#r = h3, i3.cleanup(() => {
              this.#r === h3 && (this.#r = void 0);
            });
          });
        });
      }
      #g(e5, t) {
        if (e5.codec !== "opus" || !t) return;
        let n2 = ArrayBuffer.isView(t) ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : new Uint8Array(t), r2 = hex_exports2.fromBytes(n2), i2 = this.#t.peek();
        (i2?.config !== e5 || i2.description !== r2) && this.#t.set({
          config: e5,
          description: r2
        });
      }
      close() {
        this.#c.close();
      }
    };
    Te = class {
      #e = De();
      #t = /* @__PURE__ */ new Set();
      mutate(e5) {
        let t = structuredClone(this.#e);
        e5(t);
        for (let e6 of ["jitter", "delay"]) {
          let n2 = Ee(this.#e, e6);
          for (let [r2, i2] of Object.entries(Ee(t, e6))) for (let [t2, a2] of Object.entries(i2)) {
            if (a2 === 0) throw Error(`omit ${e6} rather than advertising 0`);
            let i3 = n2[r2]?.[t2];
            if (i3 !== void 0 && (a2 === void 0 || a2 < i3)) throw Error(`${e6} cannot decrease for an existing track`);
          }
        }
        this.#e = t;
        for (let e6 of this.#t) e6.update(t);
      }
      serve(e5, t, n2) {
        let r2 = new snapshot_exports.Producer({
          track: e5,
          compression: n2?.compression ? "deflate" : "none",
          deltaRatio: 0
        });
        r2.update(this.#e), this.#t.add(r2), t.cleanup(() => {
          this.#t.delete(r2), r2.finish();
        });
      }
    };
    Oe = class {
      name;
      kind;
      config = new Signal(void 0);
      track;
      #e;
      #t = false;
      constructor(e5, t, n2, r2) {
        this.name = e5, this.kind = t, this.track = n2, this.#e = r2;
      }
      close() {
        this.#t || (this.#t = true, this.#e());
      }
    };
    ke = class e {
      static CATALOG_TRACK = TRACK3;
      static CATALOG_TRACK_COMPRESSED = TRACK_COMPRESSED;
      in;
      catalog = new Te();
      net = new Signal(void 0);
      baseline = new ae();
      #e = new Signal({});
      #t = /* @__PURE__ */ new Map();
      #n = new Effect();
      constructor(e5) {
        this.in = {
          origin: getter(e5?.origin),
          enabled: getter(e5?.enabled ?? true),
          announce: getter(e5?.announce ?? true),
          name: getter(e5?.name ?? path_exports.empty()),
          display: getter(e5?.display),
          flip: getter(e5?.flip ?? false),
          maxAge: getter(e5?.maxAge)
        }, this.#n.run(this.#a.bind(this)), this.#n.run(this.#o.bind(this));
      }
      video(e5) {
        return this.#r(e5, "video");
      }
      audio(e5) {
        return this.#r(e5, "audio");
      }
      text(e5) {
        return this.#r(e5, "text");
      }
      #r(e5, t) {
        if (this.#e.peek()[e5]) throw Error(`rendition already registered: ${e5}`);
        let n2 = new Signal(void 0);
        this.#t.set(e5, n2);
        let r2 = new Oe(e5, t, n2, () => this.#i(e5));
        return this.#e.update((t2) => ({
          ...t2,
          [e5]: r2
        })), r2;
      }
      #i(e5) {
        let t = this.#t.get(e5);
        t && (t.peek()?.close(), t.set(void 0), this.#t.delete(e5)), this.#e.update((t2) => {
          if (!(e5 in t2)) return t2;
          let n2 = { ...t2 };
          return delete n2[e5], n2;
        });
      }
      #a(e5) {
        let t = e5.get(this.in.enabled), n2 = e5.get(this.#e), r2 = {}, i2 = {}, a2 = {};
        for (let o2 of Object.values(n2)) {
          let n3 = t ? e5.get(o2.config) : void 0;
          n3 !== void 0 && (o2.kind === "video" ? r2[o2.name] = n3 : o2.kind === "audio" ? i2[o2.name] = n3 : a2[o2.name] = n3);
        }
        let o = e5.get(this.in.display), s = e5.get(this.in.flip);
        this.catalog.mutate((e6) => {
          if (Object.keys(r2).length > 0) {
            let t2 = { renditions: r2 };
            o && (t2.display = {
              width: u53(o.width),
              height: u53(o.height)
            }), s && (t2.flip = true), e6.video = t2;
          } else delete e6.video;
          Object.keys(i2).length > 0 ? e6.audio = { renditions: i2 } : delete e6.audio, Object.keys(a2).length > 0 ? e6.text = { renditions: a2 } : delete e6.text;
        });
      }
      #o(t) {
        let r2 = t.getAll([this.in.enabled, this.in.origin]);
        if (!r2) return;
        let [i2, a2] = r2, o = t.get(this.in.name);
        detectFormat(o) === void 0 && console.warn(`You should append .hang to broadcast name ${JSON.stringify(o)} to make the catalog format explicit.`);
        let s = a2.createBroadcast(o);
        t.cleanup(() => s.close()), this.net.set(s), t.cleanup(() => {
          this.net.peek() === s && this.net.set(void 0);
        }), t.run((t2) => {
          if (!t2.get(this.in.announce)) {
            s.unannounce();
            return;
          }
          for (let [r3, i3] of [[e.CATALOG_TRACK, false], [e.CATALOG_TRACK_COMPRESSED, true]]) {
            let e5 = s.createTrack(r3, {
              maxAge: time_exports.Milli(2 ** 53 - 1),
              priority: PRIORITY.catalog
            });
            t2.cleanup(() => e5.close()), this.catalog.serve(e5, t2, { compression: i3 });
          }
          s.announce();
        }), t.run((e5) => {
          let t2 = e5.get(this.#e), n2 = e5.get(this.in.maxAge);
          for (let r3 of Object.values(t2)) {
            let t3 = this.#t.get(r3.name);
            if (!t3) continue;
            let i3 = s.createTrack(r3.name, trackInfo({
              maxAge: n2,
              priority: PRIORITY[r3.kind]
            }));
            e5.cleanup(() => i3.close()), e5.run((e6) => {
              e6.set(t3, e6.get(i3.used) ? i3 : void 0);
            });
          }
        });
      }
      close() {
        this.#n.close();
      }
    };
    Ne = Math.PI / 180;
    Pe = 180 / Math.PI;
    qe = (e5) => e5.constructor === Uint8Array ? e5 : ArrayBuffer.isView(e5) ? new Uint8Array(e5.buffer, e5.byteOffset, e5.byteLength) : new Uint8Array(e5);
    globalThis.TextEncoder === void 0 || globalThis.TextEncoder;
    Je = globalThis.TextDecoder === void 0 ? class {
      constructor(e5 = "utf-8") {
        let t = e5.trim().toLowerCase();
        if (t === "utf-8" || t === "utf8" || t === "unicode-1-1-utf-8") this.encoding = "utf-8";
        else if (t === "utf-16le" || t === "utf-16") this.encoding = "utf-16le";
        else if (t === "utf-16be") this.encoding = "utf-16be";
        else throw RangeError(`The encoding label provided ('${e5}') is invalid.`);
      }
      decode(e5) {
        let t = e5 ? qe(e5) : /* @__PURE__ */ new Uint8Array(), n2 = [];
        if (this.encoding === "utf-8") {
          let e6 = t.length >= 3 && t[0] === 239 && t[1] === 187 && t[2] === 191 ? 3 : 0;
          for (; e6 < t.length; ) {
            let r3 = t[e6];
            if (r3 < 128) {
              n2.push(r3), e6++;
              continue;
            }
            let i2, a2;
            if (r3 >= 194 && r3 < 224) i2 = 1, a2 = r3 & 31;
            else if (r3 >= 224 && r3 < 240) i2 = 2, a2 = r3 & 15;
            else if (r3 >= 240 && r3 < 245) i2 = 3, a2 = r3 & 7;
            else {
              n2.push(65533), e6++;
              continue;
            }
            let o = r3 === 224 ? 160 : r3 === 240 ? 144 : 128, s = r3 === 237 ? 159 : r3 === 244 ? 143 : 191, c2 = 1;
            for (; c2 <= i2; c2++) {
              let n3 = e6 + c2 < t.length ? t[e6 + c2] : 0;
              if (n3 < o || n3 > s) break;
              a2 = a2 << 6 | n3 & 63, o = 128, s = 191;
            }
            e6 += c2, c2 <= i2 ? n2.push(65533) : a2 >= 65536 ? (a2 -= 65536, n2.push(55296 | a2 >> 10, 56320 | a2 & 1023)) : n2.push(a2);
          }
        } else {
          let e6 = this.encoding === "utf-16le", r3 = e6 ? 255 : 254, i2 = e6 ? 254 : 255, a2 = t.length >= 2 && t[0] === r3 && t[1] === i2 ? 2 : 0;
          for (; a2 + 1 < t.length; ) {
            let r4 = e6 ? t[a2] | t[a2 + 1] << 8 : t[a2] << 8 | t[a2 + 1];
            if (a2 += 2, r4 >= 55296 && r4 <= 56319) {
              let i3 = a2 + 1 < t.length ? e6 ? t[a2] | t[a2 + 1] << 8 : t[a2] << 8 | t[a2 + 1] : -1;
              i3 >= 56320 && i3 <= 57343 ? (n2.push(r4, i3), a2 += 2) : n2.push(65533);
            } else r4 >= 56320 && r4 <= 57343 ? n2.push(65533) : n2.push(r4);
          }
          a2 < t.length && n2.push(65533);
        }
        let r2 = "";
        for (let e6 = 0; e6 < n2.length; e6 += 8192) r2 += String.fromCharCode(...n2.slice(e6, e6 + 8192));
        return r2;
      }
    } : globalThis.TextDecoder;
    At = 1e6 * (1 + 2 ** -52);
    zt = (/* @__PURE__ */ (async () => {
    })()).constructor;
    Wt = () => {
      Symbol.dispose ??= /* @__PURE__ */ Symbol("Symbol.dispose");
    };
    Qt = class {
      constructor() {
        this._listeners = /* @__PURE__ */ new Map();
      }
      on(e5, t, n2) {
        this._listeners.has(e5) || this._listeners.set(e5, /* @__PURE__ */ new Set());
        let r2 = {
          fn: t,
          once: n2?.once ?? false
        };
        return this._listeners.get(e5).add(r2), () => {
          this._listeners.get(e5)?.delete(r2);
        };
      }
      _emit(...e5) {
        let [t, n2] = e5, r2 = this._listeners.get(t);
        if (r2) for (let e6 of r2) {
          try {
            e6.fn(n2);
          } catch (e7) {
            console.error(e7);
          }
          e6.once && r2.delete(e6);
        }
      }
    };
    (function(e5) {
      e5[e5.Silent = 0] = "Silent", e5[e5.Errors = 1] = "Errors", e5[e5.Warnings = 2] = "Warnings", e5[e5.Info = 3] = "Info";
    })($t ||= {});
    N = class e2 {
      constructor() {
      }
      static get level() {
        return e2._level;
      }
      static set level(t) {
        if (t !== $t.Silent && t !== $t.Errors && t !== $t.Warnings && t !== $t.Info) throw TypeError("Invalid log level. Use one of the values of the LogLevel enum.");
        e2._level = t;
      }
      static get _emitter() {
        return e2._emitterInstance ??= new Qt();
      }
      static on(t, n2, r2) {
        return e2._emitter.on(t, n2, r2);
      }
      static _error(...t) {
        e2._emitter._emit("error", t), e2._level >= $t.Errors && console.error(...t);
      }
      static _warn(...t) {
        e2._emitter._emit("warn", t), e2._level >= $t.Warnings && console.warn(...t);
      }
      static _info(...t) {
        e2._emitter._emit("info", t), e2._level >= $t.Info && console.info(...t);
      }
    };
    N._level = $t.Info, N._emitterInstance = null;
    (function(e5) {
      e5[e5.NON_IDR_SLICE = 1] = "NON_IDR_SLICE", e5[e5.SLICE_DPA = 2] = "SLICE_DPA", e5[e5.SLICE_DPB = 3] = "SLICE_DPB", e5[e5.SLICE_DPC = 4] = "SLICE_DPC", e5[e5.IDR = 5] = "IDR", e5[e5.SEI = 6] = "SEI", e5[e5.SPS = 7] = "SPS", e5[e5.PPS = 8] = "PPS", e5[e5.AUD = 9] = "AUD", e5[e5.SPS_EXT = 13] = "SPS_EXT";
    })(F ||= {});
    (function(e5) {
      e5[e5.RASL_N = 8] = "RASL_N", e5[e5.RASL_R = 9] = "RASL_R", e5[e5.BLA_W_LP = 16] = "BLA_W_LP", e5[e5.RSV_IRAP_VCL23 = 23] = "RSV_IRAP_VCL23", e5[e5.VPS_NUT = 32] = "VPS_NUT", e5[e5.SPS_NUT = 33] = "SPS_NUT", e5[e5.PPS_NUT = 34] = "PPS_NUT", e5[e5.AUD_NUT = 35] = "AUD_NUT", e5[e5.PREFIX_SEI_NUT = 39] = "PREFIX_SEI_NUT", e5[e5.SUFFIX_SEI_NUT = 40] = "SUFFIX_SEI_NUT";
    })(I ||= {});
    _n = new Uint8Array([
      0,
      0,
      0,
      1
    ]);
    (function(e5) {
      e5[e5.audAllowed = 0] = "audAllowed", e5[e5.beforeFirstVcl = 1] = "beforeFirstVcl", e5[e5.afterFirstVcl = 2] = "afterFirstVcl", e5[e5.eoBitstreamAllowed = 3] = "eoBitstreamAllowed", e5[e5.noMoreDataAllowed = 4] = "noMoreDataAllowed";
    })(L ||= {});
    (function(e5) {
      e5[e5.STREAMINFO = 0] = "STREAMINFO", e5[e5.VORBIS_COMMENT = 4] = "VORBIS_COMMENT", e5[e5.PICTURE = 6] = "PICTURE";
    })(er ||= {});
    new Uint8Array([
      5,
      4,
      65,
      67,
      45,
      51
    ]), new Uint8Array([
      5,
      4,
      69,
      65,
      67,
      51
    ]);
    Ar = [
      "pcm-s16",
      "pcm-s16be",
      "pcm-s24",
      "pcm-s24be",
      "pcm-s32",
      "pcm-s32be",
      "pcm-f32",
      "pcm-f32be",
      "pcm-f64",
      "pcm-f64be",
      "pcm-u8",
      "pcm-s8",
      "ulaw",
      "alaw"
    ];
    jr = [
      "aac",
      "opus",
      "mp3",
      "vorbis",
      "flac",
      "ac3",
      "eac3",
      "dts",
      ...Ar
    ];
    Ir = [
      "ap4x",
      "ap4h",
      "apch",
      "apcn",
      "apcs",
      "apco"
    ];
    [...Ir];
    (function(e5) {
      e5[e5.FrameCount = 1] = "FrameCount", e5[e5.FileSize = 2] = "FileSize", e5[e5.Toc = 4] = "Toc";
    })(Qr ||= {});
    (function(e5) {
      e5[e5.EBML = 440786851] = "EBML", e5[e5.EBMLVersion = 17030] = "EBMLVersion", e5[e5.EBMLReadVersion = 17143] = "EBMLReadVersion", e5[e5.EBMLMaxIDLength = 17138] = "EBMLMaxIDLength", e5[e5.EBMLMaxSizeLength = 17139] = "EBMLMaxSizeLength", e5[e5.DocType = 17026] = "DocType", e5[e5.DocTypeVersion = 17031] = "DocTypeVersion", e5[e5.DocTypeReadVersion = 17029] = "DocTypeReadVersion", e5[e5.Void = 236] = "Void", e5[e5.Segment = 408125543] = "Segment", e5[e5.SeekHead = 290298740] = "SeekHead", e5[e5.Seek = 19899] = "Seek", e5[e5.SeekID = 21419] = "SeekID", e5[e5.SeekPosition = 21420] = "SeekPosition", e5[e5.Duration = 17545] = "Duration", e5[e5.Info = 357149030] = "Info", e5[e5.TimestampScale = 2807729] = "TimestampScale", e5[e5.MuxingApp = 19840] = "MuxingApp", e5[e5.WritingApp = 22337] = "WritingApp", e5[e5.Tracks = 374648427] = "Tracks", e5[e5.TrackEntry = 174] = "TrackEntry", e5[e5.TrackNumber = 215] = "TrackNumber", e5[e5.TrackUID = 29637] = "TrackUID", e5[e5.TrackType = 131] = "TrackType", e5[e5.FlagEnabled = 185] = "FlagEnabled", e5[e5.FlagDefault = 136] = "FlagDefault", e5[e5.FlagForced = 21930] = "FlagForced", e5[e5.FlagOriginal = 21934] = "FlagOriginal", e5[e5.FlagHearingImpaired = 21931] = "FlagHearingImpaired", e5[e5.FlagVisualImpaired = 21932] = "FlagVisualImpaired", e5[e5.FlagCommentary = 21935] = "FlagCommentary", e5[e5.FlagLacing = 156] = "FlagLacing", e5[e5.Name = 21358] = "Name", e5[e5.Language = 2274716] = "Language", e5[e5.LanguageBCP47 = 2274717] = "LanguageBCP47", e5[e5.CodecID = 134] = "CodecID", e5[e5.CodecPrivate = 25506] = "CodecPrivate", e5[e5.CodecDelay = 22186] = "CodecDelay", e5[e5.SeekPreRoll = 22203] = "SeekPreRoll", e5[e5.DefaultDuration = 2352003] = "DefaultDuration", e5[e5.Video = 224] = "Video", e5[e5.PixelWidth = 176] = "PixelWidth", e5[e5.PixelHeight = 186] = "PixelHeight", e5[e5.DisplayWidth = 21680] = "DisplayWidth", e5[e5.DisplayHeight = 21690] = "DisplayHeight", e5[e5.DisplayUnit = 21682] = "DisplayUnit", e5[e5.AlphaMode = 21440] = "AlphaMode", e5[e5.Audio = 225] = "Audio", e5[e5.SamplingFrequency = 181] = "SamplingFrequency", e5[e5.Channels = 159] = "Channels", e5[e5.BitDepth = 25188] = "BitDepth", e5[e5.SimpleBlock = 163] = "SimpleBlock", e5[e5.BlockGroup = 160] = "BlockGroup", e5[e5.Block = 161] = "Block", e5[e5.BlockAdditions = 30113] = "BlockAdditions", e5[e5.BlockMore = 166] = "BlockMore", e5[e5.BlockAdditional = 165] = "BlockAdditional", e5[e5.BlockAddID = 238] = "BlockAddID", e5[e5.BlockDuration = 155] = "BlockDuration", e5[e5.ReferenceBlock = 251] = "ReferenceBlock", e5[e5.Cluster = 524531317] = "Cluster", e5[e5.Timestamp = 231] = "Timestamp", e5[e5.Cues = 475249515] = "Cues", e5[e5.CuePoint = 187] = "CuePoint", e5[e5.CueTime = 179] = "CueTime", e5[e5.CueTrackPositions = 183] = "CueTrackPositions", e5[e5.CueTrack = 247] = "CueTrack", e5[e5.CueClusterPosition = 241] = "CueClusterPosition", e5[e5.Colour = 21936] = "Colour", e5[e5.MatrixCoefficients = 21937] = "MatrixCoefficients", e5[e5.TransferCharacteristics = 21946] = "TransferCharacteristics", e5[e5.Primaries = 21947] = "Primaries", e5[e5.Range = 21945] = "Range", e5[e5.Projection = 30320] = "Projection", e5[e5.ProjectionType = 30321] = "ProjectionType", e5[e5.ProjectionPoseYaw = 30323] = "ProjectionPoseYaw", e5[e5.ProjectionPosePitch = 30324] = "ProjectionPosePitch", e5[e5.ProjectionPoseRoll = 30325] = "ProjectionPoseRoll", e5[e5.Attachments = 423732329] = "Attachments", e5[e5.AttachedFile = 24999] = "AttachedFile", e5[e5.FileDescription = 18046] = "FileDescription", e5[e5.FileName = 18030] = "FileName", e5[e5.FileMediaType = 18016] = "FileMediaType", e5[e5.FileData = 18012] = "FileData", e5[e5.FileUID = 18094] = "FileUID", e5[e5.Chapters = 272869232] = "Chapters", e5[e5.Tags = 307544935] = "Tags", e5[e5.Tag = 29555] = "Tag", e5[e5.Targets = 25536] = "Targets", e5[e5.TargetTypeValue = 26826] = "TargetTypeValue", e5[e5.TargetType = 25546] = "TargetType", e5[e5.TagTrackUID = 25541] = "TagTrackUID", e5[e5.TagEditionUID = 25545] = "TagEditionUID", e5[e5.TagChapterUID = 25540] = "TagChapterUID", e5[e5.TagAttachmentUID = 25542] = "TagAttachmentUID", e5[e5.SimpleTag = 26568] = "SimpleTag", e5[e5.TagName = 17827] = "TagName", e5[e5.TagLanguage = 17530] = "TagLanguage", e5[e5.TagString = 17543] = "TagString", e5[e5.TagBinary = 17541] = "TagBinary", e5[e5.ContentEncodings = 28032] = "ContentEncodings", e5[e5.ContentEncoding = 25152] = "ContentEncoding", e5[e5.ContentEncodingOrder = 20529] = "ContentEncodingOrder", e5[e5.ContentEncodingScope = 20530] = "ContentEncodingScope", e5[e5.ContentCompression = 20532] = "ContentCompression", e5[e5.ContentCompAlgo = 16980] = "ContentCompAlgo", e5[e5.ContentCompSettings = 16981] = "ContentCompSettings", e5[e5.ContentEncryption = 20533] = "ContentEncryption";
    })(V ||= {});
    Ri = [V.EBML, V.Segment];
    zi = [
      V.SeekHead,
      V.Info,
      V.Cluster,
      V.Tracks,
      V.Cues,
      V.Attachments,
      V.Chapters,
      V.Tags
    ];
    Bi = [...Ri, ...zi];
    (function(e5) {
      e5[e5.None = 0] = "None", e5[e5.Xiph = 1] = "Xiph", e5[e5.FixedSize = 2] = "FixedSize", e5[e5.Ebml = 3] = "Ebml";
    })(ea ||= {});
    (function(e5) {
      e5[e5.Block = 1] = "Block", e5[e5.Private = 2] = "Private", e5[e5.Next = 4] = "Next";
    })(ta ||= {});
    (function(e5) {
      e5[e5.Zlib = 0] = "Zlib", e5[e5.Bzlib = 1] = "Bzlib", e5[e5.lzo1x = 2] = "lzo1x", e5[e5.HeaderStripping = 3] = "HeaderStripping";
    })(na ||= {});
    ra = [
      {
        id: V.SeekHead,
        flag: "seekHeadSeen"
      },
      {
        id: V.Info,
        flag: "infoSeen"
      },
      {
        id: V.Tracks,
        flag: "tracksSeen"
      },
      {
        id: V.Cues,
        flag: "cuesSeen"
      }
    ];
    ia = 10 * 2 ** 20;
    fa = 79764919;
    pa = /* @__PURE__ */ new Uint32Array(256);
    for (let e5 = 0; e5 < 256; e5++) {
      let t = e5 << 24;
      for (let e6 = 0; e6 < 8; e6++) t = t & 2147483648 ? t << 1 ^ fa : t << 1;
      pa[e5] = t >>> 0 & 4294967295;
    }
    (function(e5) {
      e5[e5.PCM = 1] = "PCM", e5[e5.IEEE_FLOAT = 3] = "IEEE_FLOAT", e5[e5.ALAW = 6] = "ALAW", e5[e5.MULAW = 7] = "MULAW", e5[e5.EXTENSIBLE = 65534] = "EXTENSIBLE";
    })(W ||= {});
    Ba = 2 ** 33;
    (/* @__PURE__ */ p2(((e5, t) => {
      t.exports = {};
    })))(), Wt();
    typeof FinalizationRegistry < "u" && new FinalizationRegistry((e5) => {
      e5();
    });
    Oo = typeof FinalizationRegistry < "u" ? new FinalizationRegistry((e5) => {
      e5.cancel().catch(() => {
      });
    }) : null;
    Ao = 0.5 * 2 ** 20;
    Wt();
    us = -Infinity;
    ds = -Infinity;
    fs = null;
    typeof FinalizationRegistry < "u" && (fs = new FinalizationRegistry((e5) => {
      let t = performance.now();
      e5.type === "video" ? (t - us >= 1e3 && (N._error("A VideoSample was garbage collected without first being closed. For proper resource management, make sure to call close() on all your VideoSamples as soon as you're done using them."), us = t), typeof VideoFrame < "u" && e5.data instanceof VideoFrame && e5.data.close()) : (t - ds >= 1e3 && (N._error("An AudioSample was garbage collected without first being closed. For proper resource management, make sure to call close() on all your AudioSamples as soon as you're done using them."), ds = t), typeof AudioData < "u" && e5.data instanceof AudioData && e5.data.close());
    }));
    ms = [
      "I420",
      "I420P10",
      "I420P12",
      "I420A",
      "I420AP10",
      "I420AP12",
      "I422",
      "I422P10",
      "I422P12",
      "I422A",
      "I422AP10",
      "I422AP12",
      "I444",
      "I444P10",
      "I444P12",
      "I444A",
      "I444AP10",
      "I444AP12",
      "NV12",
      "RGBA",
      "RGBX",
      "BGRA",
      "BGRX"
    ];
    hs = new Set(ms);
    Wt();
    (function(e5) {
      e5[e5.Unsynchronisation = 128] = "Unsynchronisation", e5[e5.ExtendedHeader = 64] = "ExtendedHeader", e5[e5.ExperimentalIndicator = 32] = "ExperimentalIndicator", e5[e5.Footer = 16] = "Footer";
    })(Lc ||= {});
    (function(e5) {
      e5[e5.ISO_8859_1 = 0] = "ISO_8859_1", e5[e5.UTF_16_WITH_BOM = 1] = "UTF_16_WITH_BOM", e5[e5.UTF_16_BE_NO_BOM = 2] = "UTF_16_BE_NO_BOM", e5[e5.UTF_8 = 3] = "UTF_8";
    })(Rc ||= {});
    ol = class {
      in;
      #e = {
        frames: new Signal(void 0),
        display: new Signal(void 0)
      };
      out = readonlys(this.#e);
      #t = new Effect();
      constructor(e5) {
        this.in = { source: getter(e5?.source) }, this.#t.run(this.#n.bind(this));
      }
      #n(t) {
        let n2 = t.get(this.in.source);
        if (!n2) return;
        let r2 = new g(("frames" in n2 ? n2.frames : a(il(n2).track)).pipeThrough(this.#r(n2)), {
          clone: (e5) => e5.clone(),
          release: (e5) => e5.close()
        });
        t.cleanup(() => r2.close()), t.set(this.#e.frames, r2, void 0), t.cleanup(() => {
          this.#e.display.set(void 0);
        });
      }
      #r(e5) {
        return new TransformStream({ transform: (t, n2) => {
          try {
            let r2 = "frames" in e5 ? void 0 : il(e5).scale;
            this.#e.display.set({
              width: t.codedWidth,
              height: t.codedHeight,
              scale: r2
            }), n2.enqueue(t);
          } catch (e6) {
            throw t.close(), e6;
          }
        } });
      }
      close() {
        this.#t.close();
      }
    };
    sl = class {
      name;
      in;
      config;
      get capture() {
        return this.in.capture.peek();
      }
      #e = {
        catalog: new Signal(void 0),
        resolved: new Signal(void 0),
        active: new Signal(false),
        stats: new Signal({
          frames: 0,
          bytes: 0,
          keyframes: 0
        })
      };
      out = readonlys(this.#e);
      #t = new Signal(void 0);
      #n = new Signal(void 0);
      #r = new Signal(void 0);
      #i = new Signal(void 0);
      #a = new Signal(void 0);
      #o;
      #s = new Signal(0);
      settled;
      #c = new Effect();
      #l = new stalled_exports.Detector();
      #u;
      #d;
      #f;
      #p;
      #m = new oe();
      constructor(e5, t) {
        this.name = e5, this.in = {
          enabled: getter(t?.enabled ?? true),
          broadcast: getter(t?.broadcast),
          capture: getter(t?.capture),
          bandwidth: getter(t?.bandwidth)
        }, this.config = Signal.from(t?.config), this.#o = this.#c.computed((e6) => {
          let t2 = e6.get(this.in.capture);
          if (!t2) return;
          let n2 = e6.get(t2.in.source);
          if (!n2) return;
          let r2 = e6.get(this.config) ?? {};
          return {
            required: r2.codec ?? "",
            framerate: r2.frameRate ?? cl(n2) ?? 30,
            maxPixels: r2.maxPixels,
            bitrateScale: r2.bitrateScale ?? 0.07,
            maxBitrate: r2.maxBitrate
          };
        }), this.settled = this.#c.computed((e6) => e6.get(this.#e.catalog) !== void 0 || e6.get(this.#s) > 0);
        for (let e6 of [
          this.#y,
          this.#b,
          this.#x,
          this.#S
        ]) this.#c.run((t2) => {
          try {
            e6.call(this, t2);
          } catch (e7) {
            throw this.#h(t2), e7;
          }
        });
        this.#c.run(this.#g.bind(this));
      }
      #h(e5) {
        this.#s.update((e6) => e6 + 1), e5.cleanup(() => this.#s.update((e6) => e6 - 1));
      }
      #g(e5) {
        let t = e5.get(this.in.broadcast);
        if (!t) return;
        let n2 = t.video(this.name);
        e5.cleanup(() => n2.close()), e5.proxy(n2.config, this.out.catalog), e5.run((e6) => {
          let r2 = e6.get(this.in.enabled), i2 = e6.get(n2.track);
          if (e6.set(this.#e.active, r2 && !!i2, false), !r2 || !i2) {
            this.#v({
              demand: false,
              idle: true
            });
            return;
          }
          this.#_(i2, t.baseline, e6);
        }), e5.run((e6) => {
          let t2 = e6.get(this.in.enabled), r2 = e6.get(n2.track), i2 = e6.get(this.in.bandwidth);
          if (!t2 || !r2 || !i2) return;
          let a2;
          e6.subscribe(this.#i, (e7) => {
            e7 !== void 0 && (a2 ? a2.update(e7) : (a2 = i2.reserve(r2, e7), this.#a.set(a2)));
          }), e6.cleanup(() => {
            a2?.close(), this.#a.peek() === a2 && this.#a.set(void 0);
          });
        });
      }
      #_(e5, t, n2) {
        let i2 = n2.get(this.in.capture);
        if (!i2) {
          this.#v({
            demand: true,
            idle: true
          });
          return;
        }
        this.#v({
          demand: false,
          idle: true
        }), this.#p = performance.now();
        let a2 = new legacy_exports.Producer(e5, new legacy_exports.Format("video"));
        n2.cleanup(() => {
          e5.closed.peek() === void 0 && a2.cut();
        });
        let o, s;
        n2.spawn(async () => {
          let e6 = new VideoEncoder({
            output: (e7) => {
              let n3 = e7.type === "key";
              if (n3 && (o = e7.timestamp), this.#e.stats.update((t2) => ({
                frames: t2.frames + 1,
                bytes: t2.bytes + e7.byteLength,
                keyframes: n3 ? t2.keyframes + 1 : t2.keyframes
              })), a2.encode(e7, e7.timestamp, n3), this.#m.flush(e7.timestamp, t)) {
                let e8 = this.#e.catalog.peek();
                e8 && this.#e.catalog.set({
                  ...e8,
                  ...this.#m.estimate
                });
              }
              this.#f = e7.timestamp, this.#v({
                demand: true,
                idle: false,
                frame: true
              });
            },
            error: (e7) => {
              a2.close(e7);
            }
          });
          n2.cleanup(() => e6.close()), n2.run((t2) => {
            let n3 = t2.get(this.out.resolved);
            n3 && e6.configure(n3);
          }), n2.run((t2) => {
            let n3 = t2.get(i2.out.frames);
            if (!n3) return;
            let a3 = n3.subscribe(t2).getReader();
            t2.cleanup(() => {
              a3.cancel().catch(() => {
              });
            }), t2.spawn(async () => {
              for (; ; ) {
                let n4 = await t2.race(a3.read());
                if (!n4?.value) break;
                let i3 = n4.value;
                try {
                  if (e6.state !== "configured") continue;
                  let t3 = this.config.peek(), n5 = t3?.frameRate;
                  if (n5 && s !== void 0) {
                    let e7 = time_exports.Micro.fromSecond(1 / n5);
                    if (i3.timestamp - s < e7 - e7 / 2) continue;
                  }
                  s = i3.timestamp;
                  let a4 = i3.timestamp;
                  this.#u ??= a4, this.#d = a4, this.#p = performance.now(), this.#v({
                    demand: true,
                    idle: false
                  });
                  let c2 = t3?.keyframeInterval ?? time_exports.Milli.fromSecond(2), l2 = !o || o + time_exports.Micro.fromMilli(c2) <= i3.timestamp;
                  l2 && (o = i3.timestamp), e6.encode(i3, { keyFrame: l2 });
                } finally {
                  i3.close();
                }
              }
            });
          });
        }), n2.interval(() => this.#v({
          demand: true,
          idle: false
        }), 50);
      }
      #v(e5) {
        e5.idle && (this.#u = void 0, this.#d = void 0, this.#f = void 0, this.#p = void 0);
        let t = this.#e.catalog.peek(), n2 = (() => {
          if (this.#d === void 0 || this.#u === void 0) return 0;
          let e6 = this.#f ?? this.#u;
          return Math.max(0, this.#d - e6);
        })(), i2 = this.#p === void 0 ? 0 : time_exports.Micro.fromMilli(performance.now() - this.#p);
        this.#l.observe({
          frame: e5.frame ?? false,
          mediaLag: n2,
          quiet: i2,
          interval: stalled_exports.intervalFromFps(t?.framerate ?? this.out.resolved.peek()?.framerate),
          demand: e5.demand,
          idle: e5.idle
        }) && t && this.#e.catalog.set({
          ...t,
          stalled: this.#l.flag()
        });
      }
      #y(e5) {
        let t = e5.get(this.in.enabled), n2 = e5.get(this.#r);
        if (!t || !n2) {
          e5.set(this.#e.catalog, void 0);
          return;
        }
        let { config: r2, reported: i2 } = n2, a2 = {
          codec: i2,
          bitrate: r2.bitrate ? u53(r2.bitrate) : void 0,
          framerate: r2.framerate,
          codedWidth: u53(r2.width),
          codedHeight: u53(r2.height),
          optimizeForLatency: true,
          container: { kind: "legacy" },
          ...this.#m.estimate,
          stalled: this.#l.flag()
        };
        e5.set(this.#e.catalog, a2);
      }
      #b(e5) {
        let t = e5.get(this.in.enabled), n2 = e5.get(this.#t), r2 = e5.get(this.#o);
        if (!t || !n2 || !r2) {
          this.#n.set(void 0);
          return;
        }
        let i2 = e5.abort;
        e5.spawn(async () => {
          try {
            let e6 = await this.#C(n2, r2);
            i2.aborted || this.#n.set(e6);
          } catch (t2) {
            if (i2.aborted) return;
            throw this.#n.set(void 0), this.#h(e5), t2;
          }
        });
      }
      #x(e5) {
        if (!e5.get(this.in.enabled)) return;
        let t = e5.get(this.#n);
        if (!t) return;
        let n2 = t.config.bitrate;
        e5.set(this.#i, n2);
        let r2 = e5.get(this.#a);
        if (r2) {
          let t2 = r2.peek();
          e5.get(r2.grant), t2 != null && (n2 = Math.min(n2, t2));
        }
        let i2 = {
          ...t.config,
          bitrate: n2
        };
        e5.set(this.#e.resolved, i2), e5.set(this.#r, {
          config: i2,
          reported: t.reported
        });
      }
      #S(e5) {
        let t = e5.get(this.in.capture);
        if (!t) return;
        let n2 = e5.get(t.out.display);
        if (!n2) return;
        let r2 = e5.get(t.in.source);
        if (!r2) return;
        let i2 = e5.get(this.config), a2 = n2.width * n2.height, o = i2?.maxPixels ?? fl(r2) ?? (i2?.maxScale === void 0 ? pl(r2, n2.scale) : void 0) ?? a2;
        if (i2?.maxScale !== void 0) {
          if (!Number.isFinite(i2.maxScale) || i2.maxScale <= 0) throw Error(`maxScale must be a finite number greater than 0: ${i2.maxScale}`);
          o = Math.min(o, a2 * i2.maxScale);
        }
        let s = Math.min(Math.sqrt(o / a2), 1), c2 = 16 * Math.floor(n2.width * s / 16), l2 = 16 * Math.floor(n2.height * s / 16);
        e5.set(this.#t, {
          width: c2,
          height: l2
        });
      }
      async #C(e5, n2) {
        let r2 = [
          "vp09.00.10.08",
          "avc1.640028",
          "avc1.4D401F",
          "avc1.42E01E",
          "av01.0.08M.08",
          "hev1.1.6.L93.B0",
          "vp8"
        ], i2 = [
          "avc1.640028",
          "avc1.4D401F",
          "avc1.42E01E",
          "vp8",
          "vp09.00.10.08",
          "hev1.1.6.L93.B0"
        ], a2 = [...h() ? r2.map((e6) => [e6, "prefer-hardware"]) : [], ...i2.map((e6) => [e6, "prefer-software"])];
        for (let [t, r3] of a2) {
          if (!t.startsWith(n2.required)) continue;
          let i3 = {
            codec: t,
            width: e5.width,
            height: e5.height,
            framerate: n2.framerate,
            bitrate: ll(t, e5, n2),
            latencyMode: "realtime",
            hardwareAcceleration: r3,
            avc: t.startsWith("avc1") ? { format: "annexb" } : void 0,
            hevc: t.startsWith("hev1") ? { format: "annexb" } : void 0
          }, { supported: a3 } = await VideoEncoder.isConfigSupported(i3);
          if (a3) return {
            config: i3,
            reported: await ul(i3)
          };
        }
        throw Error("no supported codec");
      }
      close() {
        this.#c.close();
      }
    };
  }
});

// ../../node_modules/@moq/publish/index.js
var S2, w2;
var init_publish2 = __esm({
  "../../node_modules/@moq/publish/index.js"() {
    init_encoder_wi3Mqpyi();
    S2 = /* @__PURE__ */ m2({
      Capture: () => ee,
      Encoder: () => ve,
      isSampleSource: () => b,
      normalizeSource: () => S,
      sourceKind: () => x
    });
    w2 = /* @__PURE__ */ m2({
      Capture: () => ol,
      Encoder: () => sl,
      isStreamTrack: () => al,
      normalizeSource: () => il
    });
  }
});

// ../../node_modules/@moq/msf/catalog.js
function decode10(raw) {
  const str = new TextDecoder().decode(raw);
  try {
    const root = JSON.parse(str);
    const wire = WireCatalogSchema.parse(root);
    const ext = /* @__PURE__ */ Object.create(null);
    for (const [name, value] of Object.entries(root)) {
      if (!RESERVED_ROOT.includes(name))
        ext[name] = value;
    }
    const inline = new Map((wire.initDataList ?? []).filter((e5) => e5.type === "inline").map((e5) => [e5.id, e5.data]));
    const tracks = (wire.tracks ?? []).map(({ initRef, ...track }) => {
      track.isLive ??= false;
      if (track.initData === void 0 && initRef !== void 0) {
        track.initData = inline.get(initRef);
      }
      return track;
    });
    return Object.keys(ext).length > 0 ? { tracks, ext } : { tracks };
  } catch (error2) {
    console.warn("invalid MSF catalog", str);
    throw error2;
  }
}
async function fetch3(track) {
  const frame = await track.readFrame();
  if (!frame)
    return void 0;
  return decode10(frame.payload);
}
var PackagingSchema, RoleSchema, trackShape, TrackSchema4, CatalogSchema, RESERVED_ROOT, InitDataSchema, WireTrackSchema, WireCatalogSchema;
var init_catalog2 = __esm({
  "../../node_modules/@moq/msf/catalog.js"() {
    init_mini2();
    PackagingSchema = union([
      _enum(["loc", "cmaf", "legacy", "mediatimeline", "eventtimeline"]),
      string2()
    ]);
    RoleSchema = union([
      _enum(["video", "audio", "audiodescription", "caption", "subtitle", "signlanguage"]),
      string2()
    ]);
    trackShape = {
      name: string2(),
      packaging: PackagingSchema,
      // draft-00 marks isLive required but omits it on mediatimeline/eventtimeline
      // tracks, so accept its absence rather than reject the whole catalog.
      isLive: optional(boolean2()),
      role: optional(RoleSchema),
      codec: optional(string2()),
      width: optional(number2()),
      height: optional(number2()),
      framerate: optional(number2()),
      samplerate: optional(number2()),
      channelConfig: optional(string2()),
      bitrate: optional(number2()),
      // Non-standard: whether the publisher recommends temporarily avoiding this track.
      stalled: optional(boolean2()),
      /** Resolved base64 initialization data (draft-01's initRef indirection is resolved away). */
      initData: optional(string2()),
      renderGroup: optional(number2()),
      altGroup: optional(number2()),
      maxGrpSapStartingType: optional(number2()),
      maxObjSapStartingType: optional(number2()),
      // Non-standard: maximum delay (ms) between consecutive frames on this track.
      // The player's buffer must be at least this large to avoid underruns.
      // Mirrors the `jitter` field in the hang catalog.
      jitter: optional(number2()),
      // Non-standard: how far this rendition trails the broadcast's earliest, in milliseconds.
      // Mirrors hang `delay`. A player holds `delay + jitter` and does not subtract across renditions.
      delay: optional(number2())
    };
    TrackSchema4 = object(trackShape);
    CatalogSchema = object({
      tracks: array(TrackSchema4),
      // The application extension: root members beyond the ones MSF defines, kept
      // verbatim. An extension adds a section here, e.g. the `mpegts` section of
      // draft-lcurley-moq-mpegts. Mirrors `Catalog::ext` in `moq-msf`, which is typed;
      // here it stays an untyped map, so members this build has never seen survive a
      // decode/encode round trip unchanged.
      ext: optional(record(string2(), unknown()))
    });
    RESERVED_ROOT = ["version", "generatedAt", "isComplete", "tracks", "initDataList"];
    InitDataSchema = object({
      id: string2(),
      type: string2(),
      data: string2()
    });
    WireTrackSchema = object({
      ...trackShape,
      initRef: optional(string2())
    });
    WireCatalogSchema = object({
      // draft-00 used the number 1; draft-01 uses a "draft-XX" string. Accept both.
      version: union([literal(1), string2()]),
      tracks: optional(array(WireTrackSchema)),
      initDataList: optional(array(InitDataSchema))
    });
  }
});

// ../../node_modules/@moq/msf/index.js
var init_msf = __esm({
  "../../node_modules/@moq/msf/index.js"() {
    init_catalog2();
  }
});

// ../../node_modules/media-captions/dist/prod/srt-parser.js
var srt_parser_exports = {};
__export(srt_parser_exports, {
  SRTParser: () => SRTParser,
  default: () => createSRTParser
});
function createSRTParser() {
  return new SRTParser();
}
var MILLISECOND_SEP_RE, TIMESTAMP_SEP, SRTParser;
var init_srt_parser = __esm({
  "../../node_modules/media-captions/dist/prod/srt-parser.js"() {
    init_prod();
    MILLISECOND_SEP_RE = /,/g;
    TIMESTAMP_SEP = "-->";
    SRTParser = class extends VTTParser {
      parse(line, lineCount) {
        if (line === "") {
          if (this.a) {
            this.j.push(this.a);
            this.f.onCue?.(this.a);
            this.a = null;
          }
          this.c = VTTBlock.None;
        } else if (this.c === VTTBlock.Cue) {
          this.a.text += (this.a.text ? "\n" : "") + line;
        } else if (line.includes(TIMESTAMP_SEP)) {
          const result = this.o(line, lineCount);
          if (result) {
            this.a = new VTTCue(result[0], result[1], result[2].join(" "));
            this.a.id = this.l;
            this.c = VTTBlock.Cue;
          }
        }
        this.l = line;
      }
      o(line, lineCount) {
        return super.o(line.replace(MILLISECOND_SEP_RE, "."), lineCount);
      }
    };
  }
});

// ../../node_modules/media-captions/dist/prod/errors.js
var errors_exports3 = {};
__export(errors_exports3, {
  ParseErrorBuilder: () => ParseErrorBuilder
});
var ParseErrorBuilder;
var init_errors3 = __esm({
  "../../node_modules/media-captions/dist/prod/errors.js"() {
    init_prod();
    ParseErrorBuilder = {
      p() {
        return new ParseError({
          code: ParseErrorCode.BadSignature,
          reason: "missing WEBVTT file header",
          line: 1
        });
      },
      q(startTime, line) {
        return new ParseError({
          code: ParseErrorCode.BadTimestamp,
          reason: `cue start timestamp \`${startTime}\` is invalid on line ${line}`,
          line
        });
      },
      r(endTime, line) {
        return new ParseError({
          code: ParseErrorCode.BadTimestamp,
          reason: `cue end timestamp \`${endTime}\` is invalid on line ${line}`,
          line
        });
      },
      s(startTime, endTime, line) {
        return new ParseError({
          code: ParseErrorCode.BadTimestamp,
          reason: `cue end timestamp \`${endTime}\` is greater than start \`${startTime}\` on line ${line}`,
          line
        });
      },
      w(name, value, line) {
        return new ParseError({
          code: ParseErrorCode.BadSettingValue,
          reason: `invalid value for cue setting \`${name}\` on line ${line} (value: ${value})`,
          line
        });
      },
      v(name, value, line) {
        return new ParseError({
          code: ParseErrorCode.UnknownSetting,
          reason: `unknown cue setting \`${name}\` on line ${line} (value: ${value})`,
          line
        });
      },
      u(name, value, line) {
        return new ParseError({
          code: ParseErrorCode.BadSettingValue,
          reason: `invalid value for region setting \`${name}\` on line ${line} (value: ${value})`,
          line
        });
      },
      t(name, value, line) {
        return new ParseError({
          code: ParseErrorCode.UnknownSetting,
          reason: `unknown region setting \`${name}\` on line ${line} (value: ${value})`,
          line
        });
      },
      // SSA-specific errors
      T(type, line) {
        return new ParseError({
          code: ParseErrorCode.BadFormat,
          reason: `format missing for \`${type}\` block on line ${line}`,
          line
        });
      }
    };
  }
});

// ../../node_modules/media-captions/dist/prod/ssa-parser.js
var ssa_parser_exports = {};
__export(ssa_parser_exports, {
  SSAParser: () => SSAParser,
  default: () => createSSAParser
});
function parseColor(color) {
  const abgr = parseInt(color.replace("&H", ""), 16);
  if (abgr >= 0) {
    const a2 = abgr >> 24 & 255 ^ 255;
    const alpha = a2 / 255;
    const b3 = abgr >> 16 & 255;
    const g3 = abgr >> 8 & 255;
    const r2 = abgr & 255;
    return "rgba(" + [r2, g3, b3, alpha].join(",") + ")";
  }
  return null;
}
function buildTextShadow(x4, y3, color) {
  const noOfShadows = Math.ceil(2 * Math.PI * x4);
  let textShadow = "";
  for (let i2 = 0; i2 < noOfShadows; i2++) {
    const theta = 2 * Math.PI * i2 / noOfShadows;
    textShadow += x4 * Math.cos(theta) + "px " + y3 * Math.sin(theta) + "px 0 " + color + (i2 == noOfShadows - 1 ? "" : ",");
  }
  return textShadow;
}
function createSSAParser() {
  return new SSAParser();
}
var FORMAT_START_RE, STYLE_START_RE, DIALOGUE_START_RE, FORMAT_SPLIT_RE, STYLE_FUNCTION_RE, NEW_LINE_RE, STYLES_SECTION_START_RE, EVENTS_SECTION_START_RE, SSAParser;
var init_ssa_parser = __esm({
  "../../node_modules/media-captions/dist/prod/ssa-parser.js"() {
    init_prod();
    FORMAT_START_RE = /^Format:[\s\t]*/;
    STYLE_START_RE = /^Style:[\s\t]*/;
    DIALOGUE_START_RE = /^Dialogue:[\s\t]*/;
    FORMAT_SPLIT_RE = /[\s\t]*,[\s\t]*/;
    STYLE_FUNCTION_RE = /\{[^}]+\}/g;
    NEW_LINE_RE = /\\N/g;
    STYLES_SECTION_START_RE = /^\[(.*)[\s\t]?Styles\]$/;
    EVENTS_SECTION_START_RE = /^\[(.*)[\s\t]?Events\]$/;
    SSAParser = class {
      f;
      O = 0;
      a = null;
      j = [];
      k = [];
      N = null;
      d;
      P = {};
      async init(init) {
        this.f = init;
        if (init.errors)
          this.d = (await Promise.resolve().then(() => (init_errors3(), errors_exports3))).ParseErrorBuilder;
      }
      parse(line, lineCount) {
        if (this.O) {
          switch (this.O) {
            case 1:
              if (line === "") {
                this.O = 0;
              } else if (STYLE_START_RE.test(line)) {
                if (this.N) {
                  const styles = line.replace(STYLE_START_RE, "").split(FORMAT_SPLIT_RE);
                  this.S(styles);
                } else {
                  this.e(this.d?.T("Style", lineCount));
                }
              } else if (FORMAT_START_RE.test(line)) {
                this.N = line.replace(FORMAT_START_RE, "").split(FORMAT_SPLIT_RE);
              } else if (EVENTS_SECTION_START_RE.test(line)) {
                this.N = null;
                this.O = 2;
              }
              break;
            case 2:
              if (line === "") {
                this.Q();
              } else if (DIALOGUE_START_RE.test(line)) {
                this.Q();
                if (this.N) {
                  const dialogue = line.replace(DIALOGUE_START_RE, "").split(FORMAT_SPLIT_RE), cue = this.U(dialogue, lineCount);
                  if (cue)
                    this.a = cue;
                } else {
                  this.e(this.d?.T("Dialogue", lineCount));
                }
              } else if (this.a) {
                this.a.text += "\n" + line.replace(STYLE_FUNCTION_RE, "").replace(NEW_LINE_RE, "\n");
              } else if (FORMAT_START_RE.test(line)) {
                this.N = line.replace(FORMAT_START_RE, "").split(FORMAT_SPLIT_RE);
              } else if (STYLES_SECTION_START_RE.test(line)) {
                this.N = null;
                this.O = 1;
              } else if (EVENTS_SECTION_START_RE.test(line)) {
                this.N = null;
              }
          }
        } else if (line === "") ;
        else if (STYLES_SECTION_START_RE.test(line)) {
          this.N = null;
          this.O = 1;
        } else if (EVENTS_SECTION_START_RE.test(line)) {
          this.N = null;
          this.O = 2;
        }
      }
      done() {
        return {
          metadata: {},
          cues: this.j,
          regions: [],
          errors: this.k
        };
      }
      Q() {
        if (!this.a)
          return;
        this.j.push(this.a);
        this.f.onCue?.(this.a);
        this.a = null;
      }
      S(values) {
        let name = "Default", styles = {}, outlineX, align = "center", vertical = "bottom", marginV, outlineY = 1.2, outlineColor, bgColor, borderStyle = 3, transform2 = [];
        for (let i2 = 0; i2 < this.N.length; i2++) {
          const field = this.N[i2], value = values[i2];
          switch (field) {
            case "Name":
              name = value;
              break;
            case "Fontname":
              styles["font-family"] = value;
              break;
            case "Fontsize":
              styles["font-size"] = `calc(${value} / var(--overlay-height))`;
              break;
            case "PrimaryColour":
              const color = parseColor(value);
              if (color)
                styles["--cue-color"] = color;
              break;
            case "BorderStyle":
              borderStyle = parseInt(value, 10);
              break;
            case "BackColour":
              bgColor = parseColor(value);
              break;
            case "OutlineColour":
              const _outlineColor = parseColor(value);
              if (_outlineColor)
                outlineColor = _outlineColor;
              break;
            case "Bold":
              if (parseInt(value))
                styles["font-weight"] = "bold";
              break;
            case "Italic":
              if (parseInt(value))
                styles["font-style"] = "italic";
              break;
            case "Underline":
              if (parseInt(value))
                styles["text-decoration"] = "underline";
              break;
            case "StrikeOut":
              if (parseInt(value))
                styles["text-decoration"] = "line-through";
              break;
            case "Spacing":
              styles["letter-spacing"] = value + "px";
              break;
            case "AlphaLevel":
              styles["opacity"] = parseFloat(value);
              break;
            case "ScaleX":
              transform2.push(`scaleX(${parseFloat(value) / 100})`);
              break;
            case "ScaleY":
              transform2.push(`scaleY(${parseFloat(value) / 100})`);
              break;
            case "Angle":
              transform2.push(`rotate(${value}deg)`);
              break;
            case "Shadow":
              outlineY = parseInt(value, 10) * 1.2;
              break;
            case "MarginL":
              styles["--cue-width"] = "auto";
              styles["--cue-left"] = parseFloat(value) + "px";
              break;
            case "MarginR":
              styles["--cue-width"] = "auto";
              styles["--cue-right"] = parseFloat(value) + "px";
              break;
            case "MarginV":
              marginV = parseFloat(value);
              break;
            case "Outline":
              outlineX = parseInt(value, 10);
              break;
            case "Alignment":
              const alignment = parseInt(value, 10);
              if (alignment >= 4)
                vertical = alignment >= 7 ? "top" : "center";
              switch (alignment % 3) {
                case 1:
                  align = "start";
                  break;
                case 2:
                  align = "center";
                  break;
                case 3:
                  align = "end";
                  break;
              }
          }
        }
        styles.R = vertical;
        styles["--cue-white-space"] = "normal";
        styles["--cue-line-height"] = "normal";
        styles["--cue-text-align"] = align;
        if (vertical === "center") {
          styles[`--cue-top`] = "50%";
          transform2.push("translateY(-50%)");
        } else {
          styles[`--cue-${vertical}`] = (marginV || 0) + "px";
        }
        if (borderStyle === 1) {
          styles["--cue-padding-y"] = "0";
        }
        if (borderStyle === 1 || bgColor) {
          styles["--cue-bg-color"] = borderStyle === 1 ? "none" : bgColor;
        }
        if (borderStyle === 3 && outlineColor) {
          styles["--cue-outline"] = `${outlineX}px solid ${outlineColor}`;
        }
        if (borderStyle === 1 && typeof outlineX === "number") {
          const color = bgColor ?? "#000";
          styles["--cue-text-shadow"] = [
            outlineColor && buildTextShadow(outlineX * 1.2, outlineY * 1.2, outlineColor),
            outlineColor ? buildTextShadow(outlineX * (outlineX / 2), outlineY * (outlineX / 2), color) : buildTextShadow(outlineX, outlineY, color)
          ].filter(Boolean).join(", ");
        }
        if (transform2.length)
          styles["--cue-transform"] = transform2.join(" ");
        this.P[name] = styles;
      }
      U(values, lineCount) {
        const fields = this.V(values);
        const timestamp = this.o(fields.Start, fields.End, lineCount);
        if (!timestamp)
          return;
        const cue = new VTTCue(timestamp[0], timestamp[1], ""), styles = { ...this.P[fields.Style] || {} }, voice = fields.Name ? `<v ${fields.Name}>` : "";
        const vertical = styles.R, marginLeft = fields.MarginL && parseFloat(fields.MarginL), marginRight = fields.MarginR && parseFloat(fields.MarginR), marginV = fields.MarginV && parseFloat(fields.MarginV);
        if (marginLeft) {
          styles["--cue-width"] = "auto";
          styles["--cue-left"] = marginLeft + "px";
        }
        if (marginRight) {
          styles["--cue-width"] = "auto";
          styles["--cue-right"] = marginRight + "px";
        }
        if (marginV && vertical !== "center") {
          styles[`--cue-${vertical}`] = marginV + "px";
        }
        cue.text = voice + values.slice(this.N.length - 1).join(", ").replace(STYLE_FUNCTION_RE, "").replace(NEW_LINE_RE, "\n");
        delete styles.R;
        if (Object.keys(styles).length)
          cue.style = styles;
        return cue;
      }
      V(values) {
        const fields = {};
        for (let i2 = 0; i2 < this.N.length; i2++) {
          fields[this.N[i2]] = values[i2];
        }
        return fields;
      }
      o(startTimeText, endTimeText, lineCount) {
        const startTime = parseVTTTimestamp(startTimeText), endTime = parseVTTTimestamp(endTimeText);
        if (startTime !== null && endTime !== null && endTime > startTime) {
          return [startTime, endTime];
        } else {
          if (startTime === null) {
            this.e(this.d?.q(startTimeText, lineCount));
          }
          if (endTime === null) {
            this.e(this.d?.r(endTimeText, lineCount));
          }
          if (startTime != null && endTime !== null && endTime > startTime) {
            this.e(this.d?.s(startTime, endTime, lineCount));
          }
        }
      }
      e(error2) {
        if (!error2)
          return;
        this.k.push(error2);
        if (this.f.strict) {
          this.f.cancel();
          throw error2;
        } else {
          this.f.onError?.(error2);
        }
      }
    };
  }
});

// ../../node_modules/media-captions/dist/prod/index.js
async function parseText(text, options) {
  const stream = new ReadableStream({
    start(controller) {
      const lines = text.split(LINE_TERMINATOR_RE);
      for (const line of lines)
        controller.enqueue(line);
      controller.close();
    }
  });
  return parseTextStream(stream, options);
}
async function parseTextStream(stream, options) {
  const type = options?.type ?? "vtt";
  let factory;
  if (typeof type === "string") {
    switch (type) {
      case "srt":
        factory = (await Promise.resolve().then(() => (init_srt_parser(), srt_parser_exports))).default;
        break;
      case "ssa":
      case "ass":
        factory = (await Promise.resolve().then(() => (init_ssa_parser(), ssa_parser_exports))).default;
        break;
      default:
        factory = (await Promise.resolve().then(function() {
          return vttParser;
        })).default;
    }
  } else {
    factory = type;
  }
  let result;
  const reader = stream.getReader(), parser = factory(), errors = !!options?.strict || !!options?.errors;
  await parser.init({
    strict: false,
    ...options,
    errors,
    type,
    cancel() {
      reader.cancel();
      result = parser.done(true);
    }
  });
  let i2 = 1;
  while (true) {
    const { value, done } = await reader.read();
    if (done) {
      parser.parse("", i2);
      result = parser.done(false);
      break;
    }
    parser.parse(value, i2);
    i2++;
  }
  return result;
}
function toNumber2(text) {
  const num = parseInt(text, 10);
  return !Number.isNaN(num) ? num : null;
}
function toPercentage(text) {
  const num = parseInt(text.replace(PERCENT_SIGN$1, ""), 10);
  return !Number.isNaN(num) && num >= 0 && num <= 100 ? num : null;
}
function toCoords(text) {
  if (!text.includes(COMMA$1))
    return null;
  const [x4, y3] = text.split(COMMA$1).map(toPercentage);
  return x4 !== null && y3 !== null ? [x4, y3] : null;
}
function toFloat(text) {
  const num = parseFloat(text);
  return !Number.isNaN(num) ? num : null;
}
function parseVTTTimestamp(timestamp) {
  const match = timestamp.match(TIMESTAMP_RE);
  if (!match)
    return null;
  const hours = match[1] ? parseInt(match[1], 10) : 0, minutes = parseInt(match[2], 10), seconds = parseInt(match[3], 10), milliseconds = match[4] ? parseInt(match[4].padEnd(3, "0"), 10) : 0, total = hours * 3600 + minutes * 60 + seconds + milliseconds / 1e3;
  if (hours < 0 || minutes < 0 || seconds < 0 || milliseconds < 0 || minutes > 59 || seconds > 59) {
    return null;
  }
  return total;
}
function createVTTParser() {
  return new VTTParser();
}
function tokenizeVTTCue(cue) {
  let buffer = "", mode = 1, result = [], stack = [], node;
  for (let i2 = 0; i2 < cue.text.length; i2++) {
    const char = cue.text[i2];
    switch (mode) {
      case 1:
        if (char === "<") {
          addText();
          mode = 2;
        } else {
          buffer += char;
        }
        break;
      case 2:
        switch (char) {
          case "\n":
          case "	":
          case " ":
            addNode();
            mode = 4;
            break;
          case ".":
            addNode();
            mode = 3;
            break;
          case "/":
            mode = 5;
            break;
          case ">":
            addNode();
            mode = 1;
            break;
          default:
            if (!buffer && DIGIT_RE.test(char))
              mode = 6;
            buffer += char;
            break;
        }
        break;
      case 3:
        switch (char) {
          case "	":
          case " ":
          case "\n":
            addClass();
            if (node)
              node.class?.trim();
            mode = 4;
            break;
          case ".":
            addClass();
            break;
          case ">":
            addClass();
            if (node)
              node.class?.trim();
            mode = 1;
            break;
          default:
            buffer += char;
        }
        break;
      case 4:
        if (char === ">") {
          buffer = buffer.replace(MULTI_SPACE_RE, " ");
          if (node?.type === "v")
            node.voice = replaceHTMLEntities(buffer);
          else if (node?.type === "lang")
            node.lang = replaceHTMLEntities(buffer);
          buffer = "";
          mode = 1;
        } else {
          buffer += char;
        }
        break;
      case 5:
        if (char === ">") {
          buffer = "";
          node = stack.pop();
          mode = 1;
        }
        break;
      case 6:
        if (char === ">") {
          const time2 = parseVTTTimestamp(buffer);
          if (time2 !== null && time2 >= cue.startTime && time2 <= cue.endTime) {
            buffer = "timestamp";
            addNode();
            node.time = time2;
          }
          buffer = "";
          mode = 1;
        } else {
          buffer += char;
        }
        break;
    }
  }
  function addNode() {
    if (BLOCK_TYPES.has(buffer)) {
      const parent = node;
      node = createBlockNode(buffer);
      if (parent) {
        if (stack[stack.length - 1] !== parent)
          stack.push(parent);
        parent.children.push(node);
      } else
        result.push(node);
    }
    buffer = "";
    mode = 1;
  }
  function addClass() {
    if (node && buffer) {
      const color = buffer.replace("bg_", "");
      if (COLORS.has(color)) {
        node[buffer.startsWith("bg_") ? "bgColor" : "color"] = color;
      } else {
        node.class = !node.class ? buffer : node.class + " " + buffer;
      }
    }
    buffer = "";
  }
  function addText() {
    if (!buffer)
      return;
    const text = { type: "text", data: replaceHTMLEntities(buffer) };
    node ? node.children.push(text) : result.push(text);
    buffer = "";
  }
  if (mode === 1)
    addText();
  return result;
}
function createBlockNode(type) {
  return {
    tagName: TAG_NAME[type],
    type,
    children: []
  };
}
function replaceHTMLEntities(text) {
  return text.replace(HTML_ENTITY_RE, (entity) => HTML_ENTITIES[entity] || "'");
}
function setCSSVar(el, name, value) {
  el.style.setProperty(`--${name}`, value + "");
}
function setDataAttr(el, name, value = true) {
  el.setAttribute(`data-${name}`, value === true ? "" : value + "");
}
function setPartAttr(el, name) {
  el.setAttribute("part", name);
}
function getLineHeight(el) {
  return parseFloat(getComputedStyle(el).lineHeight) || 0;
}
function renderVTTCueString(cue, currentTime = 0) {
  return renderVTTTokensString(tokenizeVTTCue(cue), currentTime);
}
function renderVTTTokensString(tokens, currentTime = 0) {
  let attrs, result = "";
  for (const token of tokens) {
    if (token.type === "text") {
      result += token.data;
    } else {
      const isTimestamp = token.type === "timestamp";
      attrs = {};
      attrs.class = token.class;
      attrs.title = token.type === "v" && token.voice;
      attrs.lang = token.type === "lang" && token.lang;
      attrs["part"] = token.type === "v" && "voice";
      if (isTimestamp) {
        attrs["part"] = "timed";
        attrs["data-time"] = token.time;
        attrs["data-future"] = token.time > currentTime;
        attrs["data-past"] = token.time < currentTime;
      }
      attrs.style = `${token.color ? `color: ${token.color};` : ""}${token.bgColor ? `background-color: ${token.bgColor};` : ""}`;
      const attributes = Object.entries(attrs).filter((v3) => v3[1]).map((v3) => `${v3[0]}="${v3[1] === true ? "" : v3[1]}"`).join(" ");
      result += `<${token.tagName}${attributes ? " " + attributes : ""}>${renderVTTTokensString(
        token.children
      )}</${token.tagName}>`;
    }
  }
  return result;
}
function updateTimedVTTCueNodes(root, currentTime) {
  for (const el of root.querySelectorAll('[part="timed"]')) {
    const time2 = Number(el.getAttribute("data-time"));
    if (Number.isNaN(time2))
      continue;
    if (time2 > currentTime)
      setDataAttr(el, "future");
    else
      el.removeAttribute("data-future");
    if (time2 < currentTime)
      setDataAttr(el, "past");
    else
      el.removeAttribute("data-past");
  }
}
function debounce(fn, delay) {
  let timeout = null, args;
  function run() {
    clear();
    fn(...args);
    args = void 0;
  }
  function clear() {
    clearTimeout(timeout);
    timeout = null;
  }
  function debounce2() {
    args = [].slice.call(arguments);
    clear();
    timeout = setTimeout(run, delay);
  }
  return debounce2;
}
function createBox(box) {
  if (box instanceof HTMLElement) {
    return {
      top: box.offsetTop,
      width: box.clientWidth,
      height: box.clientHeight,
      left: box.offsetLeft,
      right: box.offsetLeft + box.clientWidth,
      bottom: box.offsetTop + box.clientHeight
    };
  }
  return { ...box };
}
function moveBox(box, axis, delta) {
  switch (axis) {
    case "+x":
      box.left += delta;
      box.right += delta;
      break;
    case "-x":
      box.left -= delta;
      box.right -= delta;
      break;
    case "+y":
      box.top += delta;
      box.bottom += delta;
      break;
    case "-y":
      box.top -= delta;
      box.bottom -= delta;
      break;
  }
}
function isBoxCollision(a2, b3) {
  return a2.left <= b3.right && a2.right >= b3.left && a2.top <= b3.bottom && a2.bottom >= b3.top;
}
function isAnyBoxCollision(box, boxes) {
  for (let i2 = 0; i2 < boxes.length; i2++)
    if (isBoxCollision(box, boxes[i2]))
      return boxes[i2];
  return null;
}
function isWithinBox(container, box) {
  return box.top >= 0 && box.bottom <= container.height && box.left >= 0 && box.right <= container.width;
}
function isBoxOutOfBounds(container, box, axis) {
  switch (axis) {
    case "+x":
      return box.left < 0;
    case "-x":
      return box.right > container.width;
    case "+y":
      return box.top < 0;
    case "-y":
      return box.bottom > container.height;
  }
}
function calcBoxIntersectPercentage(container, box) {
  const x4 = Math.max(0, Math.min(container.width, box.right) - Math.max(0, box.left)), y3 = Math.max(0, Math.min(container.height, box.bottom) - Math.max(0, box.top)), intersectArea = x4 * y3;
  return intersectArea / (container.height * container.width);
}
function createCSSBox(container, box) {
  return {
    top: box.top / container.height,
    left: box.left / container.width,
    right: (container.width - box.right) / container.width,
    bottom: (container.height - box.bottom) / container.height
  };
}
function resolveRelativeBox(container, box) {
  box.top = box.top * container.height;
  box.left = box.left * container.width;
  box.right = container.width - box.right * container.width;
  box.bottom = container.height - box.bottom * container.height;
  return box;
}
function setBoxCSSVars(el, container, box, prefix) {
  const cssBox = createCSSBox(container, box);
  for (const side of BOX_SIDES) {
    setCSSVar(el, `${prefix}-${side}`, cssBox[side] * 100 + "%");
  }
}
function avoidBoxCollisions(container, box, boxes, axis) {
  let percentage = 1, positionedBox, startBox = { ...box };
  for (let i2 = 0; i2 < axis.length; i2++) {
    while (isBoxOutOfBounds(container, box, axis[i2]) || isWithinBox(container, box) && isAnyBoxCollision(box, boxes)) {
      moveBox(box, axis[i2], 1);
    }
    if (isWithinBox(container, box))
      return box;
    const intersection = calcBoxIntersectPercentage(container, box);
    if (percentage > intersection) {
      positionedBox = { ...box };
      percentage = intersection;
    }
    box = { ...startBox };
  }
  return positionedBox || startBox;
}
function positionCue(container, cue, displayEl, boxes) {
  let cueEl = displayEl.firstElementChild, line = computeCueLine(cue), displayBox, axis = [];
  if (!displayEl[STARTING_BOX]) {
    displayEl[STARTING_BOX] = createStartingBox(container, displayEl);
  }
  displayBox = resolveRelativeBox(container, { ...displayEl[STARTING_BOX] });
  if (displayEl[POSITION_OVERRIDE]) {
    axis = [displayEl[POSITION_OVERRIDE] === "top" ? "+y" : "-y", "+x", "-x"];
  } else if (cue.snapToLines) {
    let size2;
    switch (cue.vertical) {
      case "":
        axis = ["+y", "-y"];
        size2 = "height";
        break;
      case "rl":
        axis = ["+x", "-x"];
        size2 = "width";
        break;
      case "lr":
        axis = ["-x", "+x"];
        size2 = "width";
        break;
    }
    let step = getLineHeight(cueEl), position = step * Math.round(line), maxPosition = container[size2] + step, initialAxis = axis[0];
    if (Math.abs(position) > maxPosition) {
      position = position < 0 ? -1 : 1;
      position *= Math.ceil(maxPosition / step) * step;
    }
    if (line < 0) {
      position += cue.vertical === "" ? container.height : container.width;
      axis = axis.reverse();
    }
    moveBox(displayBox, initialAxis, position);
  } else {
    const isHorizontal = cue.vertical === "", posAxis = isHorizontal ? "+y" : "+x", size2 = isHorizontal ? displayBox.height : displayBox.width;
    moveBox(
      displayBox,
      posAxis,
      (isHorizontal ? container.height : container.width) * line / 100
    );
    moveBox(
      displayBox,
      posAxis,
      cue.lineAlign === "center" ? size2 / 2 : cue.lineAlign === "end" ? size2 : 0
    );
    axis = isHorizontal ? ["-y", "+y", "-x", "+x"] : ["-x", "+x", "-y", "+y"];
  }
  displayBox = avoidBoxCollisions(container, displayBox, boxes, axis);
  setBoxCSSVars(displayEl, container, displayBox, "cue");
  return displayBox;
}
function createStartingBox(container, cueEl) {
  const box = createBox(cueEl), pos = getStyledPositions(cueEl);
  cueEl[POSITION_OVERRIDE] = false;
  if (pos.top) {
    box.top = pos.top;
    box.bottom = pos.top + box.height;
    cueEl[POSITION_OVERRIDE] = "top";
  }
  if (pos.bottom) {
    const bottom = container.height - pos.bottom;
    box.top = bottom - box.height;
    box.bottom = bottom;
    cueEl[POSITION_OVERRIDE] = "bottom";
  }
  if (pos.left)
    box.left = pos.left;
  if (pos.right)
    box.right = container.width - pos.right;
  return createCSSBox(container, box);
}
function getStyledPositions(el) {
  const positions = {};
  for (const side of BOX_SIDES) {
    positions[side] = parseFloat(el.style.getPropertyValue(`--cue-${side}`));
  }
  return positions;
}
function computeCueLine(cue) {
  if (cue.line === "auto") {
    if (!cue.snapToLines) {
      return 100;
    } else {
      return -1;
    }
  }
  return cue.line;
}
function computeCuePosition(cue) {
  if (cue.position === "auto") {
    switch (cue.align) {
      case "start":
      case "left":
        return 0;
      case "right":
      case "end":
        return 100;
      default:
        return 50;
    }
  }
  return cue.position;
}
function computeCuePositionAlignment(cue, dir) {
  if (cue.positionAlign === "auto") {
    switch (cue.align) {
      case "start":
        return dir === "ltr" ? "line-left" : "line-right";
      case "end":
        return dir === "ltr" ? "line-right" : "line-left";
      case "center":
        return "center";
      default:
        return `line-${cue.align}`;
    }
  }
  return cue.positionAlign;
}
function positionRegion(container, region, regionEl, boxes) {
  let cues = Array.from(regionEl.querySelectorAll('[part="cue-display"]')), height = 0, limit = Math.max(0, cues.length - region.lines);
  for (let i2 = cues.length - 1; i2 >= limit; i2--) {
    height += cues[i2].offsetHeight;
  }
  setCSSVar(regionEl, "region-height", height + "px");
  if (!regionEl[STARTING_BOX]) {
    regionEl[STARTING_BOX] = createCSSBox(container, createBox(regionEl));
  }
  let box = { ...regionEl[STARTING_BOX] };
  box = resolveRelativeBox(container, box);
  box.width = regionEl.clientWidth;
  box.height = height;
  box.right = box.left + box.width;
  box.bottom = box.top + height;
  box = avoidBoxCollisions(container, box, boxes, REGION_AXIS);
  setBoxCSSVars(regionEl, container, box, "region");
  return box;
}
var ParseErrorCode, ParseError, LINE_TERMINATOR_RE, CueBase, VTTCue, VTTRegion, COMMA$1, PERCENT_SIGN$1, HEADER_MAGIC, COMMA, PERCENT_SIGN, SETTING_SEP_RE, SETTING_LINE_RE, NOTE_BLOCK_START, REGION_BLOCK_START, REGION_BLOCK_START_RE, SPACE_RE, TIMESTAMP_SEP2, TIMESTAMP_SEP_RE, ALIGN_RE, LINE_ALIGN_RE, POS_ALIGN_RE, TIMESTAMP_RE, VTTBlock, VTTParser, vttParser, DIGIT_RE, MULTI_SPACE_RE, TAG_NAME, HTML_ENTITIES, HTML_ENTITY_RE, COLORS, BLOCK_TYPES, STARTING_BOX, BOX_SIDES, POSITION_OVERRIDE, REGION_AXIS, CaptionsRenderer;
var init_prod = __esm({
  "../../node_modules/media-captions/dist/prod/index.js"() {
    ParseErrorCode = {
      LoadFail: 0,
      BadSignature: 1,
      BadTimestamp: 2,
      BadSettingValue: 3,
      BadFormat: 4,
      UnknownSetting: 5
    };
    ParseError = class extends Error {
      code;
      line;
      constructor(init) {
        super(init.reason);
        this.code = init.code;
        this.line = init.line;
      }
    };
    LINE_TERMINATOR_RE = /\r?\n|\r/gm;
    CueBase = window.VTTCue;
    VTTCue = class extends CueBase {
      /**
       * A `VTTRegion` object describing the video's sub-region that the cue will be drawn onto,
       * or `null` if none is assigned.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/region}
       */
      region = null;
      /**
       * The cue writing direction.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/vertical}
       */
      vertical = "";
      /**
       * Returns `true` if the `VTTCue.line` attribute is an integer number of lines or a percentage
       * of the video size.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/snapToLines}
       */
      snapToLines = true;
      /**
       * Returns the line positioning of the cue. This can be the string `'auto'` or a number whose
       * interpretation depends on the value of `VTTCue.snapToLines`.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/line}
       */
      line = "auto";
      /**
       * Returns an enum representing the alignment of the `VTTCue.line`.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/lineAlign}
       */
      lineAlign = "start";
      /**
       * Returns the indentation of the cue within the line. This can be the string `'auto'` or a
       * number representing the percentage of the `VTTCue.region`, or the video size if `VTTCue`.region`
       * is `null`.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/position}
       */
      position = "auto";
      /**
       * Returns an enum representing the alignment of the cue. This is used to determine what
       * the `VTTCue.position` is anchored to. The default is `'auto'`.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/positionAlign}
       */
      positionAlign = "auto";
      /**
       * Returns a double representing the size of the cue, as a percentage of the video size.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/size}
       */
      size = 100;
      /**
       * Returns an enum representing the alignment of all the lines of text within the cue box.
       *
       * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/VTTCue/align}
       */
      align = "center";
      /**
       * Additional styles associated with the cue.
       */
      style;
    };
    VTTRegion = class {
      /**
       * A string that identifies the region.
       */
      id = "";
      /**
       * A `double` representing the width of the region, as a percentage of the video.
       */
      width = 100;
      /**
       * A `double` representing the height of the region, in number of lines.
       */
      lines = 3;
      /**
       * A `double` representing the region anchor X offset, as a percentage of the region.
       */
      regionAnchorX = 0;
      /**
       * A `double` representing the region anchor Y offset, as a percentage of the region.
       */
      regionAnchorY = 100;
      /**
       * A `double` representing the viewport anchor X offset, as a percentage of the video.
       */
      viewportAnchorX = 0;
      /**
       * A `double` representing the viewport anchor Y offset, as a percentage of the video.
       */
      viewportAnchorY = 100;
      /**
       * An enum representing how adding new cues will move existing cues.
       */
      scroll = "";
    };
    COMMA$1 = ",";
    PERCENT_SIGN$1 = "%";
    HEADER_MAGIC = "WEBVTT";
    COMMA = ",";
    PERCENT_SIGN = "%";
    SETTING_SEP_RE = /[:=]/;
    SETTING_LINE_RE = /^[\s\t]*(region|vertical|line|position|size|align)[:=]/;
    NOTE_BLOCK_START = "NOTE";
    REGION_BLOCK_START = "REGION";
    REGION_BLOCK_START_RE = /^REGION:?[\s\t]+/;
    SPACE_RE = /[\s\t]+/;
    TIMESTAMP_SEP2 = "-->";
    TIMESTAMP_SEP_RE = /[\s\t]*-->[\s\t]+/;
    ALIGN_RE = /start|center|end|left|right/;
    LINE_ALIGN_RE = /start|center|end/;
    POS_ALIGN_RE = /line-(?:left|right)|center|auto/;
    TIMESTAMP_RE = /^(?:(\d{1,2}):)?(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/;
    VTTBlock = /* @__PURE__ */ ((VTTBlock2) => {
      VTTBlock2[VTTBlock2["None"] = 0] = "None";
      VTTBlock2[VTTBlock2["Header"] = 1] = "Header";
      VTTBlock2[VTTBlock2["Cue"] = 2] = "Cue";
      VTTBlock2[VTTBlock2["Region"] = 3] = "Region";
      VTTBlock2[VTTBlock2["Note"] = 4] = "Note";
      return VTTBlock2;
    })(VTTBlock || {});
    VTTParser = class {
      f;
      c = 0;
      g = {};
      h = {};
      j = [];
      a = null;
      b = null;
      k = [];
      d;
      l = "";
      async init(init) {
        this.f = init;
        if (init.strict)
          this.c = 1;
        if (init.errors)
          this.d = (await Promise.resolve().then(() => (init_errors3(), errors_exports3))).ParseErrorBuilder;
      }
      parse(line, lineCount) {
        if (line === "") {
          if (this.a) {
            this.j.push(this.a);
            this.f.onCue?.(this.a);
            this.a = null;
          } else if (this.b) {
            this.h[this.b.id] = this.b;
            this.f.onRegion?.(this.b);
            this.b = null;
          } else if (this.c === 1) {
            this.i(line, lineCount);
            this.f.onHeaderMetadata?.(this.g);
          }
          this.c = 0;
        } else if (this.c) {
          switch (this.c) {
            case 1:
              this.i(line, lineCount);
              break;
            case 2:
              if (this.a) {
                const hasText = this.a.text.length > 0;
                if (!hasText && SETTING_LINE_RE.test(line)) {
                  this.m(line.split(SPACE_RE), lineCount);
                } else {
                  this.a.text += (hasText ? "\n" : "") + line;
                }
              }
              break;
            case 3:
              this.n(line.split(SPACE_RE), lineCount);
              break;
          }
        } else if (line.startsWith(NOTE_BLOCK_START)) {
          this.c = 4;
        } else if (line.startsWith(REGION_BLOCK_START)) {
          this.c = 3;
          this.b = new VTTRegion();
          this.n(line.replace(REGION_BLOCK_START_RE, "").split(SPACE_RE), lineCount);
        } else if (line.includes(TIMESTAMP_SEP2)) {
          const result = this.o(line, lineCount);
          if (result) {
            this.a = new VTTCue(result[0], result[1], "");
            this.a.id = this.l;
            this.m(result[2], lineCount);
          }
          this.c = 2;
        } else if (lineCount === 1) {
          this.i(line, lineCount);
        }
        this.l = line;
      }
      done() {
        return {
          metadata: this.g,
          cues: this.j,
          regions: Object.values(this.h),
          errors: this.k
        };
      }
      i(line, lineCount) {
        if (lineCount > 1) {
          if (SETTING_SEP_RE.test(line)) {
            const [key, value] = line.split(SETTING_SEP_RE);
            if (key)
              this.g[key] = (value || "").replace(SPACE_RE, "");
          }
        } else if (line.startsWith(HEADER_MAGIC)) {
          this.c = 1;
        } else {
          this.e(this.d?.p());
        }
      }
      o(line, lineCount) {
        const [startTimeText, trailingText = ""] = line.split(TIMESTAMP_SEP_RE), [endTimeText, ...settingsText] = trailingText.split(SPACE_RE), startTime = parseVTTTimestamp(startTimeText), endTime = parseVTTTimestamp(endTimeText);
        if (startTime !== null && endTime !== null && endTime > startTime) {
          return [startTime, endTime, settingsText];
        } else {
          if (startTime === null) {
            this.e(this.d?.q(startTimeText, lineCount));
          }
          if (endTime === null) {
            this.e(this.d?.r(endTimeText, lineCount));
          }
          if (startTime != null && endTime !== null && endTime > startTime) {
            this.e(this.d?.s(startTime, endTime, lineCount));
          }
        }
      }
      /**
       * @see {@link https://www.w3.org/TR/webvtt1/#region-settings-parsing}
       */
      n(settings, line) {
        let badValue;
        for (let i2 = 0; i2 < settings.length; i2++) {
          if (SETTING_SEP_RE.test(settings[i2])) {
            badValue = false;
            const [name, value] = settings[i2].split(SETTING_SEP_RE);
            switch (name) {
              case "id":
                this.b.id = value;
                break;
              case "width":
                const width = toPercentage(value);
                if (width !== null)
                  this.b.width = width;
                else
                  badValue = true;
                break;
              case "lines":
                const lines = toNumber2(value);
                if (lines !== null)
                  this.b.lines = lines;
                else
                  badValue = true;
                break;
              case "regionanchor":
                const region = toCoords(value);
                if (region !== null) {
                  this.b.regionAnchorX = region[0];
                  this.b.regionAnchorY = region[1];
                } else
                  badValue = true;
                break;
              case "viewportanchor":
                const viewport = toCoords(value);
                if (viewport !== null) {
                  this.b.viewportAnchorX = viewport[0];
                  this.b.viewportAnchorY = viewport[1];
                } else
                  badValue = true;
                break;
              case "scroll":
                if (value === "up")
                  this.b.scroll = "up";
                else
                  badValue = true;
                break;
              default:
                this.e(this.d?.t(name, value, line));
            }
            if (badValue) {
              this.e(this.d?.u(name, value, line));
            }
          }
        }
      }
      /**
       * @see {@link https://www.w3.org/TR/webvtt1/#cue-timings-and-settings-parsing}
       */
      m(settings, line) {
        let badValue;
        for (let i2 = 0; i2 < settings.length; i2++) {
          badValue = false;
          if (SETTING_SEP_RE.test(settings[i2])) {
            const [name, value] = settings[i2].split(SETTING_SEP_RE);
            switch (name) {
              case "region":
                const region = this.h[value];
                if (region)
                  this.a.region = region;
                break;
              case "vertical":
                if (value === "lr" || value === "rl") {
                  this.a.vertical = value;
                  this.a.region = null;
                } else
                  badValue = true;
                break;
              case "line":
                const [linePos, lineAlign] = value.split(COMMA);
                if (linePos.includes(PERCENT_SIGN)) {
                  const percentage = toPercentage(linePos);
                  if (percentage !== null) {
                    this.a.line = percentage;
                    this.a.snapToLines = false;
                  } else
                    badValue = true;
                } else {
                  const number3 = toFloat(linePos);
                  if (number3 !== null)
                    this.a.line = number3;
                  else
                    badValue = true;
                }
                if (LINE_ALIGN_RE.test(lineAlign)) {
                  this.a.lineAlign = lineAlign;
                } else if (lineAlign) {
                  badValue = true;
                }
                if (this.a.line !== "auto")
                  this.a.region = null;
                break;
              case "position":
                const [colPos, colAlign] = value.split(COMMA), position = toPercentage(colPos);
                if (position !== null)
                  this.a.position = position;
                else
                  badValue = true;
                if (colAlign && POS_ALIGN_RE.test(colAlign)) {
                  this.a.positionAlign = colAlign;
                } else if (colAlign) {
                  badValue = true;
                }
                break;
              case "size":
                const size2 = toPercentage(value);
                if (size2 !== null) {
                  this.a.size = size2;
                  if (size2 < 100)
                    this.a.region = null;
                } else {
                  badValue = true;
                }
                break;
              case "align":
                if (ALIGN_RE.test(value)) {
                  this.a.align = value;
                } else {
                  badValue = true;
                }
                break;
              default:
                this.e(this.d?.v(name, value, line));
            }
            if (badValue) {
              this.e(this.d?.w(name, value, line));
            }
          }
        }
      }
      e(error2) {
        if (!error2)
          return;
        this.k.push(error2);
        if (this.f.strict) {
          this.f.cancel();
          throw error2;
        } else {
          this.f.onError?.(error2);
        }
      }
    };
    vttParser = /* @__PURE__ */ Object.freeze({
      __proto__: null,
      VTTBlock,
      VTTParser,
      default: createVTTParser,
      parseVTTTimestamp
    });
    DIGIT_RE = /[0-9]/;
    MULTI_SPACE_RE = /[\s\t]+/;
    TAG_NAME = {
      c: "span",
      i: "i",
      b: "b",
      u: "u",
      ruby: "ruby",
      rt: "rt",
      v: "span",
      lang: "span",
      timestamp: "span"
    };
    HTML_ENTITIES = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'",
      "&nbsp;": "\xA0",
      "&lrm;": "\u200E",
      "&rlm;": "\u200F"
    };
    HTML_ENTITY_RE = /&(?:amp|lt|gt|quot|#(0+)?39|nbsp|lrm|rlm);/g;
    COLORS = /* @__PURE__ */ new Set([
      "white",
      "lime",
      "cyan",
      "red",
      "yellow",
      "magenta",
      "blue",
      "black"
    ]);
    BLOCK_TYPES = /* @__PURE__ */ new Set(Object.keys(TAG_NAME));
    STARTING_BOX = /* @__PURE__ */ Symbol(0);
    BOX_SIDES = ["top", "left", "right", "bottom"];
    POSITION_OVERRIDE = /* @__PURE__ */ Symbol(0);
    REGION_AXIS = ["-y", "+y", "-x", "+x"];
    CaptionsRenderer = class {
      overlay;
      z;
      A = 0;
      C = "ltr";
      B = [];
      D = false;
      E;
      h = /* @__PURE__ */ new Map();
      j = /* @__PURE__ */ new Map();
      /* Text direction. */
      get dir() {
        return this.C;
      }
      set dir(dir) {
        this.C = dir;
        setDataAttr(this.overlay, "dir", dir);
      }
      get currentTime() {
        return this.A;
      }
      set currentTime(time2) {
        this.A = time2;
        this.update();
      }
      constructor(overlay, init) {
        this.overlay = overlay;
        this.dir = init?.dir ?? "ltr";
        overlay.setAttribute("translate", "yes");
        overlay.setAttribute("aria-live", "off");
        overlay.setAttribute("aria-atomic", "true");
        setPartAttr(overlay, "captions");
        this.G();
        this.E = new ResizeObserver(this.I.bind(this));
        this.E.observe(overlay);
      }
      changeTrack({ regions, cues }) {
        this.reset();
        this.J(regions);
        for (const cue of cues)
          this.j.set(cue, null);
        this.update();
      }
      addCue(cue) {
        this.j.set(cue, null);
        this.update();
      }
      removeCue(cue) {
        this.j.delete(cue);
        this.update();
      }
      update(forceUpdate = false) {
        this.H(forceUpdate);
      }
      reset() {
        this.j.clear();
        this.h.clear();
        this.B = [];
        this.overlay.textContent = "";
      }
      destroy() {
        this.reset();
        this.E.disconnect();
      }
      I() {
        this.D = true;
        this.K();
      }
      K = debounce(() => {
        this.D = false;
        this.G();
        for (const el of this.h.values()) {
          el[STARTING_BOX] = null;
        }
        for (const el of this.j.values()) {
          if (el)
            el[STARTING_BOX] = null;
        }
        this.H(true);
      }, 50);
      G() {
        this.z = createBox(this.overlay);
        setCSSVar(this.overlay, "overlay-width", this.z.width + "px");
        setCSSVar(this.overlay, "overlay-height", this.z.height + "px");
      }
      H(forceUpdate = false) {
        if (!this.j.size || this.D)
          return;
        let cue, activeCues = [...this.j.keys()].filter((cue2) => this.A >= cue2.startTime && this.A <= cue2.endTime).sort(
          (cueA, cueB) => cueA.startTime !== cueB.startTime ? cueA.startTime - cueB.startTime : cueA.endTime - cueB.endTime
        ), activeRegions = activeCues.map((cue2) => cue2.region);
        for (let i2 = 0; i2 < this.B.length; i2++) {
          cue = this.B[i2];
          if (activeCues[i2] === cue)
            continue;
          if (cue.region && !activeRegions.includes(cue.region)) {
            const regionEl = this.h.get(cue.region.id);
            if (regionEl) {
              regionEl.removeAttribute("data-active");
              forceUpdate = true;
            }
          }
          const cueEl = this.j.get(cue);
          if (cueEl) {
            cueEl.remove();
            forceUpdate = true;
          }
        }
        for (let i2 = 0; i2 < activeCues.length; i2++) {
          cue = activeCues[i2];
          let cueEl = this.j.get(cue);
          if (!cueEl)
            this.j.set(cue, cueEl = this.L(cue));
          const regionEl = this.F(cue) && this.h.get(cue.region.id);
          if (regionEl && !regionEl.hasAttribute("data-active")) {
            requestAnimationFrame(() => setDataAttr(regionEl, "active"));
            forceUpdate = true;
          }
          if (!cueEl.isConnected) {
            (regionEl || this.overlay).append(cueEl);
            forceUpdate = true;
          }
        }
        if (forceUpdate) {
          const boxes = [], seen = /* @__PURE__ */ new Set();
          for (let i2 = activeCues.length - 1; i2 >= 0; i2--) {
            cue = activeCues[i2];
            if (seen.has(cue.region || cue))
              continue;
            const isRegion = this.F(cue), el = isRegion ? this.h.get(cue.region.id) : this.j.get(cue);
            if (isRegion) {
              boxes.push(positionRegion(this.z, cue.region, el, boxes));
            } else {
              boxes.push(positionCue(this.z, cue, el, boxes));
            }
            seen.add(isRegion ? cue.region : cue);
          }
        }
        updateTimedVTTCueNodes(this.overlay, this.A);
        this.B = activeCues;
      }
      J(regions) {
        if (!regions)
          return;
        for (const region of regions) {
          const el = this.M(region);
          this.h.set(region.id, el);
          this.overlay.append(el);
        }
      }
      M(region) {
        const el = document.createElement("div");
        setPartAttr(el, "region");
        setDataAttr(el, "id", region.id);
        setDataAttr(el, "scroll", region.scroll);
        setCSSVar(el, "region-width", region.width + "%");
        setCSSVar(el, "region-anchor-x", region.regionAnchorX);
        setCSSVar(el, "region-anchor-y", region.regionAnchorY);
        setCSSVar(el, "region-viewport-anchor-x", region.viewportAnchorX);
        setCSSVar(el, "region-viewport-anchor-y", region.viewportAnchorY);
        setCSSVar(el, "region-lines", region.lines);
        return el;
      }
      L(cue) {
        const display = document.createElement("div"), position = computeCuePosition(cue), positionAlignment = computeCuePositionAlignment(cue, this.C);
        setPartAttr(display, "cue-display");
        if (cue.vertical !== "")
          setDataAttr(display, "vertical");
        setCSSVar(display, "cue-text-align", cue.align);
        if (cue.style) {
          for (const prop of Object.keys(cue.style)) {
            display.style.setProperty(prop, cue.style[prop]);
          }
        }
        if (!this.F(cue)) {
          setCSSVar(
            display,
            "cue-writing-mode",
            cue.vertical === "" ? "horizontal-tb" : cue.vertical === "lr" ? "vertical-lr" : "vertical-rl"
          );
          if (!cue.style?.["--cue-width"]) {
            let maxSize = position;
            if (positionAlignment === "line-left") {
              maxSize = 100 - position;
            } else if (positionAlignment === "center" && position <= 50) {
              maxSize = position * 2;
            } else if (positionAlignment === "center" && position > 50) {
              maxSize = (100 - position) * 2;
            }
            const size2 = cue.size < maxSize ? cue.size : maxSize;
            if (cue.vertical === "")
              setCSSVar(display, "cue-width", size2 + "%");
            else
              setCSSVar(display, "cue-height", size2 + "%");
          }
        } else {
          setCSSVar(
            display,
            "cue-offset",
            `${position - (positionAlignment === "line-right" ? 100 : positionAlignment === "center" ? 50 : 0)}%`
          );
        }
        const el = document.createElement("div");
        setPartAttr(el, "cue");
        if (cue.id)
          setDataAttr(el, "id", cue.id);
        el.innerHTML = renderVTTCueString(cue);
        display.append(el);
        return display;
      }
      F(cue) {
        return cue.region && cue.size === 100 && cue.vertical === "" && cue.line === "auto";
      }
    };
  }
});

// ../../node_modules/media-captions/dist/prod.js
var init_prod2 = __esm({
  "../../node_modules/media-captions/dist/prod.js"() {
    init_prod();
  }
});

// ../../node_modules/@moq/watch/player-XR9_DSpx.js
function g2(e5) {
  let t = atob(e5), n2 = new Uint8Array(t.length);
  for (let e6 = 0; e6 < t.length; e6++) n2[e6] = t.charCodeAt(e6);
  return n2;
}
function _2(e5, t) {
  if (e5.get(t.broadcast.closed) !== void 0) return;
  let n2 = t.broadcast.track(t.track).subscribe({
    priority: t.priority,
    maxAge: t.maxAge.peek()
  });
  return e5.cleanup(() => n2.close()), e5.run((e6) => {
    n2.update({
      priority: t.priority,
      maxAge: e6.get(t.maxAge)
    });
  }), n2;
}
async function v2(e5) {
  try {
    return await e5.next();
  } catch (e6) {
    if (!(e6 instanceof errors_exports2.Stream)) throw e6;
    console.debug("media subscription ended", e6);
    return;
  }
}
function C2(e5, t) {
  return BigInt(e5 >>> 0) << 32n | BigInt(t >>> 0);
}
function w3(e5) {
  return Number(e5 >> 32n) | 0;
}
function re2(e5) {
  return !!(w3(e5) & 1);
}
function T(e5) {
  return Number(e5 & ne2) | 0;
}
function ie2(e5) {
  return e5 <= 1 ? 1 : 1 << 32 - Math.clz32(e5 - 1);
}
function ae2(e5, t, n2, r2 = false) {
  if (e5 <= 0) throw Error("invalid channels");
  if (t <= 0 || t > 2 ** 30) throw Error("invalid capacity");
  if (n2 <= 0) throw Error("invalid sample rate");
  t = ie2(t);
  let i2 = new SharedArrayBuffer(e5 * t * Float32Array.BYTES_PER_ELEMENT), a2 = new SharedArrayBuffer(te2 * Int32Array.BYTES_PER_ELEMENT), o = new SharedArrayBuffer(BigInt64Array.BYTES_PER_ELEMENT), s = new Int32Array(a2);
  return Atomics.store(s, x2, 1), {
    channels: e5,
    capacity: t,
    rate: n2,
    samples: i2,
    control: a2,
    state: o,
    buffered: r2
  };
}
function E(e5, t) {
  return (e5 - t | 0) > 0 ? e5 : t;
}
function D(e5, t) {
  return e5 & t - 1;
}
function O(e5, t) {
  return time_exports.Micro.fromSecond(e5 / t);
}
function ce2() {
  return !(typeof SharedArrayBuffer > "u" || typeof crossOriginIsolated < "u" && !crossOriginIsolated);
}
function le2(e5, t, n2, r2, i2 = false) {
  const told = tableboxAudioTold;
  tableboxAudioTold = true;
  return ce2() ? (told || console.log("[audio] using SharedArrayBuffer audio buffer"), new ue2(e5, t, n2, r2, i2)) : (told || console.warn("[audio] SharedArrayBuffer unavailable, falling back to the higher latency postMessage audio buffer. Serve the page cross-origin isolated (Cross-Origin-Opener-Policy: same-origin, Cross-Origin-Embedder-Policy: require-corp) to avoid this."), new de2(e5, t, n2, r2, i2));
}
function k(e5) {
  return {
    codec: e5.codec,
    container: e5.container,
    description: e5.description,
    sampleRate: e5.sampleRate,
    numberOfChannels: e5.numberOfChannels
  };
}
function ve2(e5) {
  return {
    broadcast: e5.broadcast,
    decoder: k(e5)
  };
}
function ye2(e5) {
  let t = (e5.jitter || be2(e5)) ?? 0, n2 = Math.ceil(fe2 / e5.sampleRate * 1e3);
  return time_exports.Milli((e5.delay ?? 0) + t + n2);
}
function be2(e5) {
  if (e5.codec.startsWith("opus")) return pe2;
  if (e5.codec.startsWith("mp4a")) return Math.ceil(me2 / e5.sampleRate * 1e3);
  if (e5.codec === "mp3") {
    let t = e5.sampleRate >= _e2 ? he2 : ge2;
    return Math.ceil(t / e5.sampleRate * 1e3);
  }
}
function A(e5, t) {
  return Math.max(Se2, Math.ceil(e5 * time_exports.Second.fromMilli(t)));
}
async function Oe2(e5) {
  if (!containerSupported(e5.container)) {
    let t2 = e5.container.kind === "unknown" ? e5.container.raw.kind : e5.container.kind;
    return console.warn(`audio: ignoring rendition with unknown container: ${t2}`), false;
  }
  e5.codec === "opus" && !opus_exports.supportsRate(e5.sampleRate) && console.warn(`audio: opus advertised at ${e5.sampleRate}Hz, which some browsers cannot decode`);
  let t;
  if (e5.codec !== "opus") {
    if (e5.description) t = hex_exports2.toBytes(e5.description);
    else if (e5.container.kind === "cmaf") try {
      t = cmaf_exports.decodeInitSegment(g2(e5.container.init)).description;
    } catch (t2) {
      return console.warn(`audio: malformed CMAF init segment for codec ${e5.codec}`, t2), false;
    }
  }
  if (!await libav_exports.polyfill()) return false;
  return (await AudioDecoder.isConfigSupported({
    ...e5,
    description: t
  })).supported ?? false;
}
function Me(e5) {
  let t = "";
  for (let n2 = 0; n2 < e5.length; n2++) t += e5[n2].toString(16).padStart(2, "0");
  return t;
}
function F2(e5) {
  let t;
  try {
    t = e5.initData ? g2(e5.initData) : void 0;
  } catch {
    t = void 0;
  }
  let n2 = t ? Me(t) : void 0;
  switch (e5.packaging) {
    case "cmaf":
      return !e5.initData || !t ? void 0 : {
        container: {
          kind: "cmaf",
          init: e5.initData
        },
        description: void 0
      };
    case "loc":
      return {
        container: { kind: "loc" },
        description: n2
      };
    case "legacy":
      return {
        container: { kind: "legacy" },
        description: n2
      };
    default:
      return;
  }
}
function I2(e5) {
  if (!(e5 <= 0)) return u53(Math.ceil(e5));
}
function Ne2(e5) {
  if (!e5.codec) return;
  let t = F2(e5);
  if (!t) return;
  let { container: n2, description: r2 } = t;
  return {
    codec: e5.codec,
    container: n2,
    description: r2,
    codedWidth: e5.width == null ? void 0 : u53(e5.width),
    codedHeight: e5.height == null ? void 0 : u53(e5.height),
    framerate: e5.framerate,
    bitrate: e5.bitrate == null ? void 0 : u53(e5.bitrate),
    stalled: e5.stalled,
    jitter: e5.jitter == null ? void 0 : u53(e5.jitter),
    delay: e5.delay == null ? void 0 : I2(e5.delay)
  };
}
function Pe2(e5) {
  if (!e5.codec) return;
  let t = (() => {
    if (!e5.channelConfig) return P;
    let t2 = Number.parseInt(e5.channelConfig, 10);
    return Number.isFinite(t2) ? t2 : P;
  })(), n2 = F2(e5);
  if (!n2) return;
  let { container: r2, description: i2 } = n2;
  return {
    codec: e5.codec,
    container: r2,
    description: i2,
    sampleRate: u53(e5.samplerate ?? je),
    numberOfChannels: u53(t),
    bitrate: e5.bitrate == null ? void 0 : u53(e5.bitrate),
    jitter: e5.jitter == null ? void 0 : u53(e5.jitter),
    delay: e5.delay == null ? void 0 : I2(e5.delay)
  };
}
function Fe(e5) {
  let t = {}, n2 = {};
  for (let r3 of e5.tracks) if (r3.role === "video") {
    let e6 = Ne2(r3);
    e6 && (t[r3.name] = e6);
  } else if (r3.role === "audio") {
    let e6 = Pe2(r3);
    e6 && (n2[r3.name] = e6);
  }
  let r2 = {};
  return Object.keys(t).length > 0 && (r2.video = { renditions: t }), Object.keys(n2).length > 0 && (r2.audio = { renditions: n2 }), r2;
}
function L2(e5, t) {
  return Object.fromEntries(Object.entries(e5).filter(([, e6]) => t(e6.broadcast)));
}
function Ie(e5, t) {
  return {
    ...e5,
    video: e5.video ? {
      ...e5.video,
      renditions: L2(e5.video.renditions, t)
    } : void 0,
    audio: e5.audio ? {
      ...e5.audio,
      renditions: L2(e5.audio.renditions, t)
    } : void 0,
    text: e5.text ? {
      ...e5.text,
      renditions: L2(e5.text.renditions, t)
    } : void 0,
    json: e5.json ? {
      ...e5.json,
      tracks: L2(e5.json.tracks, t)
    } : void 0,
    binary: e5.binary ? {
      ...e5.binary,
      tracks: L2(e5.binary.tracks, t)
    } : void 0
  };
}
function V2(e5) {
  return e5.replaceAll("&", "&amp;amp;").replaceAll("<", "&amp;lt;").replaceAll(">", "&amp;gt;").replaceAll('"', "&amp;quot;");
}
function H(e5, t) {
  let n2 = e5.length;
  for (; n2 > 0 && e5[n2 - 1].startTime > t.startTime; ) n2--;
  e5.splice(n2, 0, t);
}
function U(e5, t) {
  let { cues: n2, clears: r2 } = e5, i2 = 0;
  for (let e6 of r2) e6 >= t && (r2[i2++] = e6);
  r2.length = i2;
  let a2 = 0;
  for (let e6 of n2) e6.endTime >= t && (n2[a2++] = e6);
  return a2 !== n2.length && (n2.length = a2, true);
}
function W2(e5, t) {
  let { cues: n2, clears: r2 } = e5, i2 = n2.indexOf(t), a2 = i2 > 0 ? n2[i2 - 1] : void 0;
  a2 && a2.endTime > t.startTime && (a2.endTime = t.startTime);
  let o = n2[i2 + 1];
  o && t.endTime > o.startTime && (t.endTime = o.startTime);
  let s = r2.find((e6) => e6 > t.startTime);
  s !== void 0 && t.endTime > s && (t.endTime = s);
}
function G(e5, t) {
  let { cues: n2, clears: r2 } = e5, i2 = r2.length;
  for (; i2 > 0 && r2[i2 - 1] > t; ) i2--;
  r2[i2] !== t && r2.splice(i2, 0, t);
  for (let e6 = n2.length - 1; e6 >= 0; e6--) {
    let r3 = n2[e6];
    if (!(r3.startTime > t)) {
      r3.endTime > t && (r3.endTime = t);
      return;
    }
  }
}
function q(e5) {
  return Ue.has(e5.format);
}
function X(e5) {
  return {
    broadcast: e5.broadcast,
    decoder: {
      codec: e5.codec,
      container: e5.container,
      description: e5.description,
      displayAspectWidth: e5.displayAspectWidth,
      displayAspectHeight: e5.displayAspectHeight,
      optimizeForLatency: e5.optimizeForLatency ?? true
    }
  };
}
function We(e5) {
  return JSON.stringify(X(e5).decoder);
}
function Ke(e5) {
  let t;
  return e5.jitter === void 0 ? e5.framerate && (t = time_exports.Milli(Math.ceil(1e3 / e5.framerate))) : t = time_exports.Milli(e5.jitter), e5.delay === void 0 ? t : time_exports.Milli.add(time_exports.Milli(e5.delay), t ?? time_exports.Milli.zero);
}
function qe2(e5) {
  return e5.active === void 0 || time_exports.Milli.add(e5.playhead, Ge) >= e5.active;
}
function Je2(e5) {
  return e5.active === void 0 ? e5.pending : e5.pending === void 0 ? e5.active : time_exports.Milli.max(e5.active, e5.pending);
}
function Ye(e5 = 0) {
  let t = (e5 % 360 + 360) % 360;
  return Math.round(t / 90) % 4 * 90;
}
function Xe(e5, t = 0) {
  let n2 = Ye(t);
  return n2 === 90 || n2 === 270 ? {
    width: e5.height,
    height: e5.width
  } : {
    width: e5.width,
    height: e5.height
  };
}
function Z(e5) {
  return Object.is(e5, -0) ? 0 : e5;
}
function Ze(e5, t) {
  let [n2, r2, i2, a2, o, s] = e5;
  return [
    Z(-n2),
    Z(r2),
    Z(-i2),
    Z(a2),
    Z(t - o),
    Z(s)
  ];
}
function Qe(e5, t) {
  let n2 = Ye(t?.rotation), r2 = Xe(e5, n2), i2;
  switch (n2) {
    case 90:
      i2 = [
        0,
        1,
        -1,
        0,
        e5.width,
        0
      ];
      break;
    case 180:
      i2 = [
        -1,
        0,
        0,
        -1,
        e5.width,
        e5.height
      ];
      break;
    case 270:
      i2 = [
        0,
        -1,
        1,
        0,
        0,
        e5.height
      ];
      break;
    default:
      i2 = [
        1,
        0,
        0,
        1,
        0,
        0
      ];
  }
  return t?.flip && (i2 = Ze(i2, e5.width)), {
    matrix: i2,
    source: r2
  };
}
async function tt(e5) {
  if (!containerSupported(e5.container)) {
    let t2 = e5.container.kind === "unknown" ? e5.container.raw.kind : e5.container.kind;
    return console.warn(`video: ignoring rendition with unknown container: ${t2}`), false;
  }
  let t;
  if (e5.description) t = hex_exports2.toBytes(e5.description);
  else if (e5.container.kind === "cmaf") try {
    t = cmaf_exports.decodeInitSegment(g2(e5.container.init)).description;
  } catch (t2) {
    return console.warn(`video: malformed CMAF init segment for codec ${e5.codec}`, t2), false;
  }
  let { supported: n2 } = await VideoDecoder.isConfigSupported({
    codec: e5.codec,
    description: t,
    displayAspectWidth: e5.displayAspectWidth,
    displayAspectHeight: e5.displayAspectHeight,
    optimizeForLatency: e5.optimizeForLatency ?? true
  });
  if (n2) return true;
  if (e5.codec.startsWith("avc3.")) {
    let n3 = `avc1.${e5.codec.slice(5)}`;
    if ((await VideoDecoder.isConfigSupported({
      codec: n3,
      description: t,
      displayAspectWidth: e5.displayAspectWidth,
      displayAspectHeight: e5.displayAspectHeight,
      optimizeForLatency: e5.optimizeForLatency ?? true
    })).supported) return e5.codec = n3, true;
  }
  return false;
}
function it(e5) {
  return (t) => {
    let n2 = [], r2 = [];
    for (let [i2, a2] of t) if (a2.codedWidth && a2.codedHeight) {
      let t2 = a2.codedWidth * a2.codedHeight;
      t2 <= e5 ? n2.push({
        name: i2,
        size: t2
      }) : r2.push({
        name: i2,
        size: t2
      });
    }
    return n2.sort((e6, t2) => t2.size - e6.size), n2.length > 0 ? n2.map((e6) => e6.name) : r2.length > 0 ? (r2.sort((e6, t2) => e6.size - t2.size), [r2[0].name]) : t.map(([e6]) => e6);
  };
}
function at(e5, t) {
  return (n2) => {
    let r2 = [], i2 = [];
    for (let [a2, o] of n2) {
      if (!o.codedWidth || !o.codedHeight) continue;
      let n3 = o.codedWidth * o.codedHeight, s = e5 == null || o.codedWidth <= e5, c2 = t == null || o.codedHeight <= t;
      s && c2 ? r2.push({
        name: a2,
        size: n3
      }) : i2.push({
        name: a2,
        size: n3
      });
    }
    return r2.sort((e6, t2) => t2.size - e6.size), r2.length > 0 ? r2.map((e6) => e6.name) : i2.length > 0 ? (i2.sort((e6, t2) => e6.size - t2.size), [i2[0].name]) : n2.map(([e6]) => e6);
  };
}
function $(e5) {
  return (t) => {
    let n2 = [], r2 = [];
    for (let [i2, a2] of t) a2.bitrate != null && a2.bitrate <= e5 ? n2.push({
      name: i2,
      bitrate: a2.bitrate
    }) : a2.bitrate != null && r2.push({
      name: i2,
      bitrate: a2.bitrate
    });
    return n2.sort((e6, t2) => t2.bitrate - e6.bitrate), n2.length > 0 ? n2.map((e6) => e6.name) : r2.length > 0 ? (r2.sort((e6, t2) => e6.bitrate - t2.bitrate), [r2[0].name]) : t.map(([e6]) => e6);
  };
}
function ot(e5) {
  let t = e5[0];
  for (let n2 of e5) {
    let [, e6] = n2, [, r2] = t, i2 = (e6.codedWidth ?? 0) * (e6.codedHeight ?? 0), a2 = (r2.codedWidth ?? 0) * (r2.codedHeight ?? 0);
    if (i2 !== a2) {
      i2 > a2 && (t = n2);
      continue;
    }
    (e6.bitrate ?? 0) > (r2.bitrate ?? 0) && (t = n2);
  }
  return t[0];
}
function st(e5) {
  let t = Object.entries(e5).filter(([, e6]) => !e6.stalled);
  if (t.length > 0) return Object.fromEntries(t);
  let n2 = Object.entries(e5);
  if (n2.length === 0) return {};
  let r2 = $(0)(n2), i2 = r2.length === 1 ? r2[0] : at(0, 0)(n2)[0];
  return { [i2]: e5[i2] };
}
var y2, b2, x2, S3, te2, ne2, oe2, se2, tableboxAudioTold, ue2, de2, fe2, pe2, me2, he2, ge2, _e2, xe2, Se2, Ce2, we2, Te2, Ee2, De2, j, ke2, M, Ae2, N2, je, P, Le, R, Re, z, B, ze, Be, Ve, He, K2, Ue, J, Y, Ge, $e, Q, et, nt, rt, ct, lt;
var init_player_XR9_DSpx = __esm({
  "../../node_modules/@moq/watch/player-XR9_DSpx.js"() {
    init_net();
    init_signals();
    init_catalog();
    init_catalog();
    init_container2();
    init_util2();
    init_json();
    init_msf();
    init_prod2();
    y2 = 0;
    b2 = 1;
    x2 = 2;
    S3 = 3;
    te2 = 4;
    ne2 = 4294967295n;
    oe2 = class e3 {
      channels;
      capacity;
      rate;
      buffered;
      init;
      #e;
      #t;
      #n;
      #r = false;
      #i = 0;
      #a = 0;
      #o = 0;
      constructor(e5, t) {
        this.channels = e5.channels, this.capacity = e5.capacity, this.rate = e5.rate, this.buffered = e5.buffered, this.init = e5, this.#e = new Int32Array(e5.control), this.#t = new BigInt64Array(e5.state), this.#n = [];
        for (let t2 = 0; t2 < this.channels; t2++) this.#n.push(new Float32Array(e5.samples, t2 * this.capacity * Float32Array.BYTES_PER_ELEMENT, this.capacity));
        t !== void 0 && this.#s(t);
      }
      #s(e5) {
        if (e5.channels !== this.channels || e5.rate !== this.rate) return;
        let t = Atomics.load(e5.#e, S3), n2 = Atomics.load(e5.#t, 0);
        for (; ; ) {
          let e6 = Atomics.load(this.#t, 0);
          if (Atomics.load(this.#e, S3) !== t || (T(n2) - T(e6) | 0) <= 0) return;
          let r2 = C2(w3(e6), T(n2));
          if (Atomics.compareExchange(this.#t, 0, e6, r2) === e6) return;
        }
      }
      #c(e5) {
        for (; ; ) {
          let t = Atomics.load(this.#t, 0);
          if ((e5 - T(t) | 0) <= 0) return;
          let n2 = C2(w3(t), e5);
          if (Atomics.compareExchange(this.#t, 0, t, n2) === t) return;
        }
      }
      #l(e5) {
        for (; ; ) {
          let t = Atomics.load(this.#t, 0), n2 = C2(w3(t) + e5 | 0, T(t));
          if (Atomics.compareExchange(this.#t, 0, t, n2) === t) return;
        }
      }
      insert(e5, t) {
        if (t.length !== this.channels) throw Error("wrong number of channels");
        let n2 = Math.round(time_exports.Second.fromMicro(e5) * this.rate), i2 = t[0].length, a2 = 0;
        if (!this.#r) {
          this.#i = n2;
          let e6 = w3(Atomics.load(this.#t, 0));
          Atomics.add(this.#e, S3, 1), Atomics.store(this.#t, 0, C2(e6 + 2 | 0, 0)), Atomics.store(this.#e, y2, 0), this.#r = true, this.#a = 0, this.#o = 0;
        }
        n2 = n2 - this.#i | 0;
        let o = n2 + i2 | 0, s = T(Atomics.load(this.#t, 0)), c2 = s - n2 | 0;
        if (c2 > 0) {
          if (c2 >= i2) return;
          a2 = c2, n2 = n2 + c2 | 0;
        }
        let l2 = i2 - a2;
        (o - s | 0) > this.capacity && this.#c(o - this.capacity | 0);
        let u2 = Atomics.load(this.#e, y2), d2 = n2 - u2 | 0;
        if (d2 > 0) {
          let e6 = Math.min(d2, this.capacity);
          for (let t2 = 0; t2 < this.channels; t2++) {
            let n3 = this.#n[t2];
            for (let t3 = 0; t3 < e6; t3++) n3[D(u2 + t3 | 0, this.capacity)] = 0;
          }
        }
        for (let e6 = 0; e6 < this.channels; e6++) {
          let r2 = t[e6], i3 = this.#n[e6];
          for (let e7 = 0; e7 < l2; e7++) i3[D(n2 + e7 | 0, this.capacity)] = r2[a2 + e7];
        }
        Atomics.store(this.#e, y2, E(Atomics.load(this.#e, y2), o)), this.#u();
      }
      #u() {
        let e5 = T(Atomics.load(this.#t, 0)), t = Atomics.load(this.#e, y2), n2 = Atomics.load(this.#e, b2);
        (t - e5 | 0) >= n2 && n2 > 0 && Atomics.store(this.#e, x2, 0);
      }
      read(e5) {
        let t = Atomics.load(this.#t, 0);
        if (Atomics.load(this.#e, x2) === 1 || re2(t)) return 0;
        let n2 = T(t), r2 = Atomics.load(this.#e, y2), i2 = Atomics.load(this.#e, b2), a2 = r2 - n2 | 0;
        if (!this.buffered && i2 > 0 && a2 > i2) {
          let e6 = r2 - i2 | 0;
          (e6 - n2 | 0) > 0 && (n2 = e6);
        }
        let o = r2 - n2 | 0, s = Math.min(o, e5[0].length);
        if (s <= 0) return (n2 - T(t) | 0) > 0 && Atomics.compareExchange(this.#t, 0, t, C2(w3(t), n2)), 0;
        for (let t2 = 0; t2 < this.channels; t2++) {
          let r3 = this.#n[t2], i3 = e5[t2];
          for (let e6 = 0; e6 < s; e6++) i3[e6] = r3[D(n2 + e6 | 0, this.capacity)];
        }
        let c2 = C2(w3(t), n2 + s | 0);
        if (Atomics.compareExchange(this.#t, 0, t, c2) !== t) {
          for (let t2 = 0; t2 < this.channels; t2++) e5[t2].fill(0, 0, s);
          return 0;
        }
        return s;
      }
      setLatency(e5) {
        let t = Atomics.exchange(this.#e, b2, e5);
        t > 0 && e5 > t && (Atomics.store(this.#e, x2, 1), this.#l(2)), this.#u();
      }
      truncate(e5) {
        let t = Math.round(time_exports.Second.fromMicro(e5) * this.rate) - this.#i | 0;
        if (!((Atomics.load(this.#e, y2) - t | 0) <= 0)) {
          for (this.#l(1); ; ) {
            let e6 = Atomics.load(this.#e, y2), n2 = E(t, T(Atomics.load(this.#t, 0)));
            if ((e6 - n2 | 0) <= 0 || Atomics.compareExchange(this.#e, y2, e6, n2) === e6) break;
          }
          this.#l(1);
        }
      }
      reset() {
        this.#r = false, Atomics.store(this.#e, x2, 1);
        let e5 = Atomics.load(this.#e, y2), t = Atomics.load(this.#t, 0);
        Atomics.store(this.#t, 0, C2(w3(t), e5));
      }
      resize(t) {
        let n2 = ae2(this.channels, t, this.rate, this.buffered), r2 = new e3(n2);
        r2.#r = this.#r, r2.#i = this.#i;
        let i2 = Atomics.load(this.#t, 0), a2 = T(i2), o = Atomics.load(this.#e, y2), s = Atomics.load(this.#e, b2), c2 = Atomics.load(this.#e, x2), l2 = o - a2 | 0, u2 = Math.max(0, Math.min(l2, r2.capacity)), d2 = o - u2 | 0;
        for (let e5 = 0; e5 < this.channels; e5++) {
          let t2 = this.#n[e5], n3 = r2.#n[e5];
          for (let e6 = 0; e6 < u2; e6++) {
            let i3 = d2 + e6 | 0;
            n3[D(i3, r2.capacity)] = t2[D(i3, this.capacity)];
          }
        }
        return Atomics.store(r2.#e, S3, Atomics.load(this.#e, S3)), Atomics.store(r2.#t, 0, C2(w3(i2), d2)), Atomics.store(r2.#e, y2, o), Atomics.store(r2.#e, b2, s), Atomics.store(r2.#e, x2, c2), r2.#a = this.#d(a2) + (d2 - a2 | 0), r2.#o = d2, r2;
      }
      #d(e5) {
        return this.#a += e5 - this.#o | 0, this.#o = e5, this.#a;
      }
      #f() {
        return this.#d(T(Atomics.load(this.#t, 0)));
      }
      get timestamp() {
        return time_exports.Micro.fromSecond((this.#i + this.#f()) / this.rate);
      }
      get stalled() {
        return Atomics.load(this.#e, x2) === 1;
      }
      get length() {
        return Atomics.load(this.#e, y2) - T(Atomics.load(this.#t, 0)) | 0;
      }
    };
    se2 = class {
      #e;
      #t;
      #n = [];
      constructor(e5, t) {
        this.#e = e5, this.#t = t;
      }
      setHeadroom(e5) {
        this.#t = e5;
      }
      wait(e5, t) {
        return !this.#e || t >= (e5 - this.#t | 0) ? Promise.resolve() : new Promise((t2) => this.#n.push({
          timestamp: e5,
          resolve: t2
        }));
      }
      advance(e5) {
        this.#n.length !== 0 && (this.#n = this.#n.filter(({ timestamp: t, resolve: n2 }) => e5 < (t - this.#t | 0) || (n2(), false)));
      }
      flush() {
        for (let { resolve: e5 } of this.#n) e5();
        this.#n = [];
      }
    };
    tableboxAudioTold = false;
    ue2 = class {
      rate;
      channels;
      #e;
      #t;
      #n = new Signal(0);
      timestamp = this.#n;
      #r = new Signal(true);
      stalled = this.#r;
      #i;
      #a = new Effect();
      constructor(e5, t, n2, r2, i2) {
        this.#e = e5, this.channels = t, this.rate = n2;
        let a2 = Math.max(n2, r2 * 2);
        this.#i = new se2(i2, O(r2, n2));
        let o = ae2(t, a2, n2, i2);
        this.#t = new oe2(o), this.#t.setLatency(r2);
        let s = {
          type: "init-shared",
          ...o
        };
        e5.port.postMessage(s), this.#a.interval(() => {
          let e6 = this.#t.stalled;
          this.#n.set(this.#t.timestamp), this.#r.set(e6), e6 ? this.#i.flush() : this.#i.advance(this.#t.timestamp);
        }, 50);
      }
      insert(e5, t) {
        this.#t.insert(e5, t);
      }
      setLatency(e5) {
        if (this.#i.setHeadroom(O(e5, this.rate)), this.#t.setLatency(e5), this.#t.capacity < e5 * 1.5) {
          let t = Math.max(this.rate, e5 * 2);
          this.#t = this.#t.resize(t);
          let n2 = {
            type: "init-shared",
            ...this.#t.init
          };
          this.#e.port.postMessage(n2);
        }
      }
      truncate(e5) {
        this.#t.truncate(e5);
      }
      reset() {
        this.#t.reset(), this.#i.flush();
      }
      wait(e5) {
        return this.#t.stalled ? Promise.resolve() : this.#i.wait(e5, this.#t.timestamp);
      }
      close() {
        this.#i.flush(), this.#a.close();
      }
    };
    de2 = class {
      rate;
      channels;
      #e;
      #t = new Signal(0);
      timestamp = this.#t;
      #n = new Signal(true);
      stalled = this.#n;
      #r;
      #i = new Effect();
      constructor(e5, t, n2, i2, a2) {
        this.#e = e5, this.channels = t, this.rate = n2, this.#r = new se2(a2, O(i2, n2));
        let o = {
          type: "init-post",
          channels: t,
          rate: n2,
          latency: time_exports.Milli.fromSecond(i2 / n2),
          buffered: a2
        };
        e5.port.postMessage(o), this.#i.event(e5.port, "message", (e6) => {
          let t2 = e6.data;
          t2?.type === "state" && (this.#t.set(t2.timestamp), this.#n.set(t2.stalled), t2.stalled ? this.#r.flush() : this.#r.advance(t2.timestamp));
        }), e5.port.start();
      }
      insert(e5, t) {
        let n2 = {
          type: "data",
          data: t,
          timestamp: e5
        };
        this.#e.port.postMessage(n2, t.map((e6) => e6.buffer));
      }
      setLatency(e5) {
        this.#r.setHeadroom(O(e5, this.rate));
        let t = {
          type: "latency",
          latency: time_exports.Milli.fromSecond(e5 / this.rate)
        };
        this.#e.port.postMessage(t);
      }
      truncate(e5) {
        let t = {
          type: "truncate",
          timestamp: e5
        };
        this.#e.port.postMessage(t);
      }
      reset() {
        this.#e.port.postMessage({ type: "reset" }), this.#r.flush();
      }
      wait(e5) {
        return this.#n.peek() ? Promise.resolve() : this.#r.wait(e5, this.#t.peek());
      }
      close() {
        this.#r.flush(), this.#i.close();
      }
    };
    fe2 = 128;
    pe2 = 20;
    me2 = 1024;
    he2 = 1152;
    ge2 = 576;
    _e2 = 32e3;
    xe2 = class {
      #e = false;
      #t = false;
      opened() {
        this.#e && (this.#t = true), this.#e = true;
      }
      takeover() {
        let e5 = this.#t;
        return this.#t = false, e5;
      }
    };
    Se2 = 128;
    Ce2 = new Blob(['Object.assign((value) => value, {\n	zero: 0,\n	fromMicro: (us) => us * 1e3,\n	fromMilli: (ms) => ms * 1e6,\n	fromSecond: (s) => s * 1e9,\n	toMicro: (ns) => ns / 1e3,\n	toMilli: (ns) => ns / 1e6,\n	toSecond: (ns) => ns / 1e9,\n	now: () => performance.now() * 1e6,\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\n/** Constructors, conversions, and arithmetic for {@link Micro} values. */\nconst Micro = Object.assign((value) => value, {\n	zero: 0,\n	fromNano: (ns) => ns / 1e3,\n	fromMilli: (ms) => ms * 1e3,\n	fromSecond: (s) => s * 1e6,\n	toNano: (us) => us * 1e3,\n	toMilli: (us) => us / 1e3,\n	toSecond: (us) => us / 1e6,\n	now: () => performance.now() * 1e3,\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\nObject.assign((value) => value, {\n	zero: 0,\n	fromNano: (ns) => ns / 1e6,\n	fromMicro: (us) => us / 1e3,\n	fromSecond: (s) => s * 1e3,\n	toNano: (ms) => ms * 1e6,\n	toMicro: (ms) => ms * 1e3,\n	toSecond: (ms) => ms / 1e3,\n	now: () => performance.now(),\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\nObject.assign((unitsPerSecond) => {\n	if (!Number.isSafeInteger(unitsPerSecond) || unitsPerSecond <= 0) throw new RangeError(`invalid timescale: ${unitsPerSecond}`);\n	return unitsPerSecond;\n}, {\n	/** One unit per second. */\n	SECOND: 1,\n	/** 1,000 units per second. */\n	MILLI: 1e3,\n	/** 1,000,000 units per second. */\n	MICRO: 1e6,\n	/** 1,000,000,000 units per second. */\n	NANO: 1e9\n});\n/** Constructors, conversions, and arithmetic for {@link Second} values. */\nconst Second = Object.assign((value) => value, {\n	zero: 0,\n	fromNano: (ns) => ns / 1e9,\n	fromMicro: (us) => us / 1e6,\n	fromMilli: (ms) => ms / 1e3,\n	toNano: (s) => s * 1e9,\n	toMicro: (s) => s * 1e6,\n	toMilli: (s) => s * 1e3,\n	now: () => performance.now() / 1e3,\n	add: (a, b) => a + b,\n	sub: (a, b) => a - b,\n	mul: (a, b) => a * b,\n	div: (a, b) => a / b,\n	max: (a, b) => Math.max(a, b),\n	min: (a, b) => Math.min(a, b)\n});\n//#endregion\n//#region src/audio/ring-buffer.ts\nvar AudioRingBuffer = class {\n	#buffer;\n	#writeIndex = 0;\n	#readIndex = 0;\n	rate;\n	channels;\n	#stalled = true;\n	#buffered;\n	#latencySamples;\n	#anchored = false;\n	constructor(props) {\n		if (props.channels <= 0) throw new Error("invalid channels");\n		if (props.rate <= 0) throw new Error("invalid sample rate");\n		if (props.latency <= 0) throw new Error("invalid latency");\n		this.#latencySamples = Math.ceil(props.rate * Second.fromMilli(props.latency));\n		if (this.#latencySamples === 0) throw new Error("empty buffer");\n		this.rate = props.rate;\n		this.channels = props.channels;\n		this.#buffered = props.buffered ?? false;\n		const capacity = this.#capacityFor(this.#latencySamples);\n		this.#buffer = [];\n		for (let i = 0; i < this.channels; i++) this.#buffer[i] = new Float32Array(capacity);\n	}\n	#capacityFor(latencySamples) {\n		return this.#buffered ? latencySamples * 2 : latencySamples;\n	}\n	get stalled() {\n		return this.#stalled;\n	}\n	get timestamp() {\n		return Micro.fromSecond(this.#readIndex / this.rate);\n	}\n	get length() {\n		return this.#writeIndex - this.#readIndex;\n	}\n	get capacity() {\n		return this.#buffer[0]?.length;\n	}\n	resize(latency) {\n		const latencySamples = Math.ceil(this.rate * Second.fromMilli(latency));\n		if (latencySamples > this.#latencySamples) this.#stalled = true;\n		this.#latencySamples = latencySamples;\n		const newCapacity = this.#capacityFor(this.#latencySamples);\n		if (newCapacity !== this.capacity) this.#reallocate(newCapacity);\n		if (latencySamples > 0 && this.length >= latencySamples) this.#stalled = false;\n	}\n	#reallocate(newCapacity) {\n		if (newCapacity === 0) throw new Error("empty buffer");\n		const newBuffer = [];\n		for (let i = 0; i < this.channels; i++) newBuffer[i] = new Float32Array(newCapacity);\n		const samplesToKeep = Math.min(this.length, newCapacity);\n		if (samplesToKeep > 0) {\n			const copyStart = this.#writeIndex - samplesToKeep;\n			for (let channel = 0; channel < this.channels; channel++) {\n				const src = this.#buffer[channel];\n				const dst = newBuffer[channel];\n				for (let i = 0; i < samplesToKeep; i++) {\n					const srcPos = (copyStart + i) % src.length;\n					const dstPos = (copyStart + i) % dst.length;\n					dst[dstPos] = src[srcPos];\n				}\n			}\n		}\n		this.#buffer = newBuffer;\n		this.#readIndex = this.#writeIndex - samplesToKeep;\n		if (samplesToKeep === 0) this.#stalled = true;\n	}\n	write(timestamp, data) {\n		if (data.length !== this.channels) throw new Error("wrong number of channels");\n		let start = Math.round(Second.fromMicro(timestamp) * this.rate);\n		let samples = data[0].length;\n		if (!this.#anchored) {\n			this.#readIndex = start;\n			this.#writeIndex = start;\n			this.#anchored = true;\n		}\n		let offset = this.#readIndex - start;\n		if (offset > samples) return;\n		else if (offset > 0) {\n			samples -= offset;\n			start += offset;\n		} else offset = 0;\n		const end = start + samples;\n		const overflow = end - this.#readIndex - this.#buffer[0].length;\n		if (overflow >= 0) {\n			this.#stalled = false;\n			this.#readIndex += overflow;\n		}\n		if (start > this.#writeIndex) {\n			const gapSize = Math.min(start - this.#writeIndex, this.#buffer[0].length);\n			if (gapSize === 1) console.warn("floating point inaccuracy detected");\n			for (let channel = 0; channel < this.channels; channel++) {\n				const dst = this.#buffer[channel];\n				for (let i = 0; i < gapSize; i++) {\n					const writePos = (this.#writeIndex + i) % dst.length;\n					dst[writePos] = 0;\n				}\n			}\n		}\n		for (let channel = 0; channel < this.channels; channel++) {\n			let src = data[channel];\n			src = src.subarray(src.length - samples);\n			const dst = this.#buffer[channel];\n			if (src.length !== samples) throw new Error("mismatching number of samples");\n			for (let i = 0; i < samples; i++) {\n				const writePos = (start + i) % dst.length;\n				dst[writePos] = src[i];\n			}\n		}\n		if (end > this.#writeIndex) this.#writeIndex = end;\n		if (this.#buffered && this.length >= this.#latencySamples) this.#stalled = false;\n	}\n	/**\n	* Drop buffered samples at or after `timestamp`, keeping whatever is already due.\n	*\n	* A successor track overwrites the slots its own samples land on, but anything the previous\n	* track wrote beyond them would otherwise still play once the successor runs out.\n	*/\n	truncate(timestamp) {\n		const target = Math.round(Second.fromMicro(timestamp) * this.rate);\n		if (target >= this.#writeIndex) return;\n		this.#writeIndex = Math.max(target, this.#readIndex);\n	}\n	reset() {\n		this.#readIndex = 0;\n		this.#writeIndex = 0;\n		this.#stalled = true;\n		this.#anchored = false;\n	}\n	read(output) {\n		if (output.length !== this.channels) throw new Error("wrong number of channels");\n		if (this.#stalled) return 0;\n		const samples = Math.min(this.#writeIndex - this.#readIndex, output[0].length);\n		if (samples === 0) return 0;\n		for (let channel = 0; channel < this.channels; channel++) {\n			const dst = output[channel];\n			const src = this.#buffer[channel];\n			if (dst.length !== output[0].length) throw new Error("mismatching number of samples");\n			for (let i = 0; i < samples; i++) {\n				const readPos = (this.#readIndex + i) % src.length;\n				dst[i] = src[readPos];\n			}\n		}\n		this.#readIndex += samples;\n		return samples;\n	}\n};\n//#endregion\n//#region src/audio/shared-ring-buffer.ts\nconst WRITE = 0;\nconst LATENCY = 1;\nconst STALLED = 2;\nconst TIMELINE = 3;\nconst CONTROL_SLOTS = 4;\n/**\n* The playhead and its mutation epoch, packed into one 64-bit word: epoch in the high\n* half, read cursor in the low half.\n*\n* They have to move together. The reader samples the ring, copies, and only then publishes, and\n* the writer can rebase the timeline anywhere in between. Checking an epoch and then writing a\n* cursor leaves a window between the two no ordering closes, which is how a stale cursor ends up\n* on a fresh timeline: the playhead lands past WRITE, `read` returns nothing, and `insert` drops\n* everything as too old until WRITE catches up. Packed, the check *is* the write: the reader\n* compare-exchanges the whole word, so a rebase makes its publish fail rather than land.\n*/\nconst CURSOR_MASK = 4294967295n;\nfunction pack(epoch, read) {\n	return BigInt(epoch >>> 0) << 32n | BigInt(read >>> 0);\n}\n/**\n* The mutation epoch. Even while settled, odd while `truncate` retreats WRITE.\n*\n* WRITE lives in a different word, so a retreat cannot move it and the epoch together. Marking\n* the epoch on either side of the retreat is what covers the gap: a reader that snapshotted\n* before the mark finds the word moved and its exchange fails, one that snapshots between the\n* marks sees the odd epoch and renders silence, and one that snapshots after already reads the\n* retreated WRITE. So the writer steps by two on a re-anchor, keeping odd for the retreat alone.\n*/\nfunction epochOf(state) {\n	return Number(state >> 32n) | 0;\n}\n/** Whether a `truncate` is mid-retreat, so WRITE may still describe samples it is dropping. */\nfunction retreating(state) {\n	return (epochOf(state) & 1) !== 0;\n}\n/** The playhead half, back as an i32 so the modular comparisons elsewhere still hold. */\nfunction readOf(state) {\n	return Number(state & CURSOR_MASK) | 0;\n}\n/** Rounds up to a power of two, which is what makes `slot` wrap-invariant. */\nfunction ceilPow2(n) {\n	return n <= 1 ? 1 : 1 << 32 - Math.clz32(n - 1);\n}\n/**\n* Allocate the shared memory for a ring holding at least `capacity` samples per channel.\n*\n* The capacity is rounded up to a power of two so `slot` can mask instead of taking a\n* remainder; read `init.capacity` back rather than assuming the requested value.\n*/\nfunction allocSharedRingBuffer(channels, capacity, rate, buffered = false) {\n	if (channels <= 0) throw new Error("invalid channels");\n	if (capacity <= 0 || capacity > 2 ** 30) throw new Error("invalid capacity");\n	if (rate <= 0) throw new Error("invalid sample rate");\n	capacity = ceilPow2(capacity);\n	const samples = new SharedArrayBuffer(channels * capacity * Float32Array.BYTES_PER_ELEMENT);\n	const control = new SharedArrayBuffer(CONTROL_SLOTS * Int32Array.BYTES_PER_ELEMENT);\n	const state = new SharedArrayBuffer(BigInt64Array.BYTES_PER_ELEMENT);\n	const ctrl = new Int32Array(control);\n	Atomics.store(ctrl, STALLED, 1);\n	return {\n		channels,\n		capacity,\n		rate,\n		samples,\n		control,\n		state,\n		buffered\n	};\n}\n/** Modular i32 max: returns a if a is ahead of b, else b. */\nfunction i32Max(a, b) {\n	return (a - b | 0) > 0 ? a : b;\n}\n/**\n* Maps a sample index to a [0, capacity) array slot.\n*\n* `capacity` is a power of two, so masking is exact for negative indexes and, unlike a\n* remainder, survives the i32 wrap: consecutive indexes stay consecutive slots across\n* 0x7fffffff -> 0x80000000, which is what keeps unread samples from aliasing there.\n*/\nfunction slot(idx, capacity) {\n	return idx & capacity - 1;\n}\nvar SharedRingBuffer = class SharedRingBuffer {\n	channels;\n	capacity;\n	rate;\n	buffered;\n	init;\n	#control;\n	#state;\n	#samples;\n	#anchored = false;\n	#anchor = 0;\n	#position = 0;\n	#lastRead = 0;\n	/**\n	* Wrap the shared memory described by `init`.\n	*\n	* Pass `previous` in the worklet when this ring replaces one already being read. `resize`\n	* snapshots the playhead on the main thread and hands the replacement over by message, so the\n	* reader keeps draining the old ring in the meantime. Carrying its cursor across means those\n	* samples are not played twice.\n	*/\n	constructor(init, previous) {\n		this.channels = init.channels;\n		this.capacity = init.capacity;\n		this.rate = init.rate;\n		this.buffered = init.buffered;\n		this.init = init;\n		this.#control = new Int32Array(init.control);\n		this.#state = new BigInt64Array(init.state);\n		this.#samples = [];\n		for (let i = 0; i < this.channels; i++) this.#samples.push(new Float32Array(init.samples, i * this.capacity * Float32Array.BYTES_PER_ELEMENT, this.capacity));\n		if (previous !== void 0) this.#handoff(previous);\n	}\n	/**\n	* Carry `source`\'s playhead across, if the replacement is still the timeline it belongs to.\n	*\n	* Truncation changes the mutation epoch but preserves timeline identity. Sample state before\n	* identity: a re-anchor publishes identity first, then replaces state. Either the identity\n	* check rejects the old cursor, the exchange fails, or the re-anchor overwrites the carried\n	* cursor. A truncate only forces a retry, preserving audio consumed since the resize.\n	*/\n	#handoff(source) {\n		if (source.channels !== this.channels || source.rate !== this.rate) return;\n		const timeline = Atomics.load(source.#control, TIMELINE);\n		const from = Atomics.load(source.#state, 0);\n		for (;;) {\n			const state = Atomics.load(this.#state, 0);\n			if (Atomics.load(this.#control, TIMELINE) !== timeline) return;\n			if ((readOf(from) - readOf(state) | 0) <= 0) return;\n			const next = pack(epochOf(state), readOf(from));\n			if (Atomics.compareExchange(this.#state, 0, state, next) === state) return;\n		}\n	}\n	/**\n	* Move the playhead forward to `candidate`, staying on whatever timeline is current.\n	*\n	* Retries while the word changes under it, and never steps backwards. Used by the writer\'s\n	* overflow path; the reader publishes with its own exchange so it can tell a rebase apart\n	* from losing a race.\n	*/\n	#advance(candidate) {\n		for (;;) {\n			const state = Atomics.load(this.#state, 0);\n			if ((candidate - readOf(state) | 0) <= 0) return;\n			const next = pack(epochOf(state), candidate);\n			if (Atomics.compareExchange(this.#state, 0, state, next) === state) return;\n		}\n	}\n	/**\n	* Step the epoch by `by`, leaving the playhead wherever the reader has taken it.\n	*\n	* Retries while the word changes under it: only the epoch half is the writer\'s to move.\n	*/\n	#step(by) {\n		for (;;) {\n			const state = Atomics.load(this.#state, 0);\n			const next = pack(epochOf(state) + by | 0, readOf(state));\n			if (Atomics.compareExchange(this.#state, 0, state, next) === state) return;\n		}\n	}\n	/**\n	* Insert audio samples at the given timestamp.\n	* Main thread only. Handles out-of-order writes, gap filling, and overflow.\n	*/\n	insert(timestamp, data) {\n		if (data.length !== this.channels) throw new Error("wrong number of channels");\n		let start = Math.round(Second.fromMicro(timestamp) * this.rate);\n		const originalLength = data[0].length;\n		let offset = 0;\n		if (!this.#anchored) {\n			this.#anchor = start;\n			const epoch = epochOf(Atomics.load(this.#state, 0));\n			Atomics.add(this.#control, TIMELINE, 1);\n			Atomics.store(this.#state, 0, pack(epoch + 2 | 0, 0));\n			Atomics.store(this.#control, WRITE, 0);\n			this.#anchored = true;\n			this.#position = 0;\n			this.#lastRead = 0;\n		}\n		start = start - this.#anchor | 0;\n		const end = start + originalLength | 0;\n		const read = readOf(Atomics.load(this.#state, 0));\n		const behind = read - start | 0;\n		if (behind > 0) {\n			if (behind >= originalLength) return;\n			offset = behind;\n			start = start + behind | 0;\n		}\n		const samples = originalLength - offset;\n		if ((end - read | 0) > this.capacity) this.#advance(end - this.capacity | 0);\n		const write = Atomics.load(this.#control, WRITE);\n		const gap = start - write | 0;\n		if (gap > 0) {\n			const gapSize = Math.min(gap, this.capacity);\n			for (let channel = 0; channel < this.channels; channel++) {\n				const dst = this.#samples[channel];\n				for (let i = 0; i < gapSize; i++) dst[slot(write + i | 0, this.capacity)] = 0;\n			}\n		}\n		for (let channel = 0; channel < this.channels; channel++) {\n			const src = data[channel];\n			const dst = this.#samples[channel];\n			for (let i = 0; i < samples; i++) dst[slot(start + i | 0, this.capacity)] = src[offset + i];\n		}\n		Atomics.store(this.#control, WRITE, i32Max(Atomics.load(this.#control, WRITE), end));\n		this.#resume();\n	}\n	#resume() {\n		const read = readOf(Atomics.load(this.#state, 0));\n		const write = Atomics.load(this.#control, WRITE);\n		const latency = Atomics.load(this.#control, LATENCY);\n		if ((write - read | 0) >= latency && latency > 0) Atomics.store(this.#control, STALLED, 0);\n	}\n	/**\n	* Read audio samples into the output buffers.\n	* AudioWorklet only. Returns the number of samples read.\n	*/\n	read(output) {\n		const state = Atomics.load(this.#state, 0);\n		if (Atomics.load(this.#control, STALLED) === 1) return 0;\n		if (retreating(state)) return 0;\n		let read = readOf(state);\n		const write = Atomics.load(this.#control, WRITE);\n		const latency = Atomics.load(this.#control, LATENCY);\n		const buffered = write - read | 0;\n		if (!this.buffered && latency > 0 && buffered > latency) {\n			const skipTo = write - latency | 0;\n			if ((skipTo - read | 0) > 0) read = skipTo;\n		}\n		const available = write - read | 0;\n		const count = Math.min(available, output[0].length);\n		if (count <= 0) {\n			if ((read - readOf(state) | 0) > 0) Atomics.compareExchange(this.#state, 0, state, pack(epochOf(state), read));\n			return 0;\n		}\n		for (let channel = 0; channel < this.channels; channel++) {\n			const src = this.#samples[channel];\n			const dst = output[channel];\n			for (let i = 0; i < count; i++) dst[i] = src[slot(read + i | 0, this.capacity)];\n		}\n		const next = pack(epochOf(state), read + count | 0);\n		if (Atomics.compareExchange(this.#state, 0, state, next) !== state) {\n			for (let channel = 0; channel < this.channels; channel++) output[channel].fill(0, 0, count);\n			return 0;\n		}\n		return count;\n	}\n	/**\n	* Update the target latency in samples. Main thread only.\n	*\n	* A deeper floor parks playback until it refills. Video holds the extra delay on its own, so\n	* audio that kept draining at the old depth would run ahead by the difference. Parking keeps\n	* what is buffered, so a rise costs only its own size in silence, and none if the buffer\n	* already covers the new floor.\n	*/\n	setLatency(samples) {\n		const previous = Atomics.exchange(this.#control, LATENCY, samples);\n		if (previous > 0 && samples > previous) {\n			Atomics.store(this.#control, STALLED, 1);\n			this.#step(2);\n		}\n		this.#resume();\n	}\n	/**\n	* Drop buffered samples at or after `timestamp`, keeping whatever is already due.\n	* Main thread only.\n	*\n	* A successor track overwrites the slots its own samples land on, but anything the previous\n	* track wrote beyond them would otherwise still play once the successor runs out.\n	*/\n	truncate(timestamp) {\n		const target = Math.round(Second.fromMicro(timestamp) * this.rate) - this.#anchor | 0;\n		if ((Atomics.load(this.#control, WRITE) - target | 0) <= 0) return;\n		this.#step(1);\n		for (;;) {\n			const write = Atomics.load(this.#control, WRITE);\n			const clamped = i32Max(target, readOf(Atomics.load(this.#state, 0)));\n			if ((write - clamped | 0) <= 0) break;\n			if (Atomics.compareExchange(this.#control, WRITE, write, clamped) === write) break;\n		}\n		this.#step(1);\n	}\n	/**\n	* Flush buffered samples and re-stall, ready to anchor the next utterance (buffered mode).\n	* Main thread only. The worklet reader sees STALLED and stops until the next insert.\n	*/\n	reset() {\n		this.#anchored = false;\n		Atomics.store(this.#control, STALLED, 1);\n		const write = Atomics.load(this.#control, WRITE);\n		const state = Atomics.load(this.#state, 0);\n		Atomics.store(this.#state, 0, pack(epochOf(state), write));\n	}\n	/**\n	* Allocate a new ring with `newCapacity` samples and copy the unread window\n	* [READ, WRITE) plus control state into it. Used when growing capacity so\n	* we don\'t drop buffered audio. If `newCapacity` is smaller than the unread\n	* span, the oldest samples are truncated.\n	*\n	* Main thread only. `resize()` reads from the source `SharedRingBuffer` and\n	* writes into a freshly allocated buffer from `allocSharedRingBuffer`, so it\n	* relies on the same invariant as `insert()`: no concurrent main-thread\n	* writers. The AudioWorklet reader is tolerated via the CAS discipline used\n	* by READ/WRITE elsewhere.\n	*/\n	resize(newCapacity) {\n		const init = allocSharedRingBuffer(this.channels, newCapacity, this.rate, this.buffered);\n		const dst = new SharedRingBuffer(init);\n		dst.#anchored = this.#anchored;\n		dst.#anchor = this.#anchor;\n		const state = Atomics.load(this.#state, 0);\n		const read = readOf(state);\n		const write = Atomics.load(this.#control, WRITE);\n		const latency = Atomics.load(this.#control, LATENCY);\n		const stalled = Atomics.load(this.#control, STALLED);\n		const available = write - read | 0;\n		const copyCount = Math.max(0, Math.min(available, dst.capacity));\n		const copyStart = write - copyCount | 0;\n		for (let channel = 0; channel < this.channels; channel++) {\n			const src = this.#samples[channel];\n			const out = dst.#samples[channel];\n			for (let i = 0; i < copyCount; i++) {\n				const idx = copyStart + i | 0;\n				out[slot(idx, dst.capacity)] = src[slot(idx, this.capacity)];\n			}\n		}\n		Atomics.store(dst.#control, TIMELINE, Atomics.load(this.#control, TIMELINE));\n		Atomics.store(dst.#state, 0, pack(epochOf(state), copyStart));\n		Atomics.store(dst.#control, WRITE, write);\n		Atomics.store(dst.#control, LATENCY, latency);\n		Atomics.store(dst.#control, STALLED, stalled);\n		dst.#position = this.#foldRead(read) + (copyStart - read | 0);\n		dst.#lastRead = copyStart;\n		return dst;\n	}\n	/**\n	* Fold an observed READ into `#position`, so the returned offset keeps counting up across\n	* the i32 wrap. Idempotent: folding the same value twice adds a zero delta.\n	*/\n	#foldRead(read) {\n		this.#position += read - this.#lastRead | 0;\n		this.#lastRead = read;\n		return this.#position;\n	}\n	/** `#foldRead` against the current READ. */\n	#unwrapRead() {\n		return this.#foldRead(readOf(Atomics.load(this.#state, 0)));\n	}\n	/**\n	* Current playback timestamp derived from READ position.\n	*\n	* Main thread only, and stateful: it advances the unwrapped read position, so it has to be\n	* polled rather than sampled once. See `#position`.\n	*/\n	get timestamp() {\n		return Micro.fromSecond((this.#anchor + this.#unwrapRead()) / this.rate);\n	}\n	/** Whether the buffer is stalled (waiting to fill). */\n	get stalled() {\n		return Atomics.load(this.#control, STALLED) === 1;\n	}\n	/**\n	* Number of buffered samples (WRITE - READ).\n	*\n	* Non-atomic: WRITE and READ are loaded separately, so a concurrent\n	* writer/reader can make the two loads inconsistent. Intended for\n	* tests and diagnostics, not control-flow decisions.\n	*/\n	get length() {\n		return Atomics.load(this.#control, WRITE) - readOf(Atomics.load(this.#state, 0)) | 0;\n	}\n};\n//#endregion\n//#region src/audio/render-worklet.ts\nvar Render = class extends AudioWorkletProcessor {\n	#backend;\n	#underflow = 0;\n	#stateCounter = 0;\n	constructor() {\n		super();\n		this.port.onmessage = (event) => {\n			const msg = event.data;\n			if (msg.type === "close") this.closed = true;\n			else if (msg.type === "init-shared") {\n				console.log("[audio-worklet] init-shared: using SharedArrayBuffer path");\n				const previous = this.#backend instanceof SharedRingBuffer ? this.#backend : void 0;\n				this.#backend = new SharedRingBuffer(msg, previous);\n				this.#underflow = 0;\n			} else if (msg.type === "init-post") {\n				console.log("[audio-worklet] init-post: using postMessage path");\n				this.#backend = new AudioRingBuffer(msg);\n				this.#underflow = 0;\n			} else if (msg.type === "data") {\n				if (this.#backend instanceof AudioRingBuffer) this.#backend.write(msg.timestamp, msg.data);\n			} else if (msg.type === "latency") {\n				if (this.#backend instanceof AudioRingBuffer) this.#backend.resize(msg.latency);\n			} else if (msg.type === "truncate") {\n				if (this.#backend instanceof AudioRingBuffer) this.#backend.truncate(msg.timestamp);\n			} else if (msg.type === "reset") {\n				if (this.#backend instanceof AudioRingBuffer) this.#backend.reset();\n			}\n		};\n	}\n	process(_inputs, outputs, _parameters) {\n		const output = outputs[0];\n		const backend = this.#backend;\n		const samplesRead = backend?.read(output) ?? 0;\n		if (samplesRead < output[0].length) this.#underflow += output[0].length - samplesRead;\n		else if (this.#underflow > 0 && backend) {\n			console.debug(`audio underflow: ${Math.round(1e3 * this.#underflow / backend.rate)}ms`);\n			this.#underflow = 0;\n		}\n		if (backend instanceof AudioRingBuffer) {\n			this.#stateCounter++;\n			if (this.#stateCounter >= 5) {\n				this.#stateCounter = 0;\n				const state = {\n					type: "state",\n					timestamp: backend.timestamp,\n					stalled: backend.stalled\n				};\n				this.port.postMessage(state);\n			}\n		}\n		return !this.closed;\n	}\n};\nregisterProcessor("render", Render);\n//#endregion\n'], { type: "application/javascript" });
    we2 = URL.createObjectURL(Ce2);
    Te2 = class {
      #e = 0;
      #t;
      #n;
      #r;
      #i = 0;
      #a;
      get end() {
        return this.#t;
      }
      clear(e5 = 0) {
        this.#e = 0, this.#t = void 0, this.#i = e5, this.#o();
      }
      update(e5) {
        let t = e5.discontinuity !== this.#e;
        return t && (this.#e = e5.discontinuity, this.#t = void 0, this.#o()), e5.frame && e5.group !== this.#n && (this.#t = void 0), e5.frame && this.#r === void 0 && (this.#r = e5.frame.timestamp), e5.end !== void 0 && (this.#t = e5.end, this.#n = e5.group), t;
      }
      span(e5) {
        let t = this.#r ?? e5.timestamp;
        this.#r = t;
        let n2 = Math.floor(this.#i * e5.sampleRate / 48e3), r2 = this.#a ?? n2, i2 = Math.min(r2, e5.numberOfFrames);
        this.#a = r2 - i2;
        let a2 = Math.round(n2 * 1e6 / e5.sampleRate), o = Math.max(t, e5.timestamp - a2), s = e5.numberOfFrames - i2;
        if (this.#t !== void 0) {
          if (this.#t <= o) s = 0;
          else {
            let t2 = this.#t - o, n3 = Math.round(t2 * e5.sampleRate / 1e6);
            s = Math.min(s, n3);
          }
        }
        return {
          timestamp: o,
          frameOffset: i2,
          frames: s
        };
      }
      #o() {
        this.#r = void 0, this.#a = void 0;
      }
    };
    Ee2 = class {
      #e;
      constructor(e5) {
        this.#e = e5;
      }
      drop() {
        return this.#e !== 0 && (this.#e--, true);
      }
    };
    De2 = 3;
    j = class {
      in;
      source;
      sync;
      #e = {
        context: new Signal(void 0),
        root: new Signal(void 0),
        sampleRate: new Signal(void 0),
        stats: new Signal(void 0),
        timestamp: new Signal(void 0),
        stalled: new Signal(true),
        buffered: new Signal([])
      };
      out = readonlys(this.#e);
      #t = new Signal([]);
      #n;
      #r = new Signal(void 0);
      #i = new Te2();
      #a = new xe2();
      #o = new Effect();
      #s;
      #c;
      constructor(e5) {
        this.in = { enabled: getter(e5?.enabled ?? true) }, this.source = e5.source, this.sync = e5.sync, this.#o.cleanup(this.sync.register(this.source.out.jitter)), this.#s = this.#o.computed((e6) => {
          let t = e6.get(this.source.out.config);
          return t ? ve2(t) : void 0;
        }), this.#c = this.#o.computed((e6) => {
          let t = e6.get(this.source.out.config);
          return t ? k(t) : void 0;
        }), this.#o.run(this.#l.bind(this)), this.#o.run(this.#u.bind(this)), this.#o.run(this.#d.bind(this)), this.#o.run(this.#f.bind(this));
      }
      #l(e5) {
        let t = e5.get(this.#c);
        if (!t) return;
        let n2 = e5.get(this.#r) ?? t.sampleRate, i2 = t.numberOfChannels;
        e5.set(this.#e.sampleRate, n2);
        let held = j.audioContext?.(n2), a2 = held?.context ?? new AudioContext({
          latencyHint: "interactive",
          sampleRate: n2
        });
        e5.set(this.#e.context, a2), e5.cleanup(() => held ? held.release() : a2.close()), e5.spawn(async () => {
          if (!await e5.race(a2.audioWorklet.addModule(we2).then(() => true))) return;
          let t2 = new AudioWorkletNode(a2, "render", {
            channelCount: i2,
            channelCountMode: "explicit",
            outputChannelCount: [i2]
          });
          e5.cleanup(() => (t2.port.postMessage({ type: "close" }), t2.disconnect()));
          let o = this.sync.out.delay.peek(), s = A(n2, o), c2 = this.sync.out.buffered.peek(), l2 = le2(t2, i2, n2, s, c2);
          this.#n = l2, e5.cleanup(() => {
            l2.close(), this.#n = void 0;
          }), e5.run((e6) => {
            let t3 = time_exports.Milli.fromMicro(e6.get(l2.timestamp));
            this.#e.timestamp.set(t3), this.#v(t3);
          }), e5.run((e6) => {
            this.#e.stalled.set(e6.get(l2.stalled));
          }), e5.set(this.#e.root, t2);
        });
      }
      #u(e5) {
        if (!e5.get(this.in.enabled)) return;
        if (e5.get(this.sync.in.delay) === "instant") {
          this.reset();
          return;
        }
        let t = e5.get(this.#e.context);
        t && gesture_exports.unlock(e5, t);
      }
      #d(e5) {
        if (!e5.get(this.#e.root)) return;
        let t = this.#n;
        if (!t) return;
        let n2 = e5.get(this.sync.out.delay);
        t.setLatency(A(t.rate, n2));
      }
      #f(e5) {
        if (!e5.get(this.in.enabled) || e5.get(this.sync.in.delay) === "instant") return;
        let t = e5.get(this.source.in.broadcast);
        if (!t) return;
        let n2 = e5.get(this.source.out.track);
        if (!n2) return;
        let r2 = e5.get(this.#s);
        if (!r2) return;
        let i2 = r2.decoder, a2 = t.relativeBroadcast(e5, r2.broadcast);
        if (!a2) return;
        this.#a.opened();
        let o = _2(e5, {
          broadcast: a2,
          track: n2,
          priority: PRIORITY.audio,
          maxAge: this.sync.out.maxAge
        });
        o && (i2.container.kind === "cmaf" ? this.#m(e5, o, i2) : this.#p(e5, o, i2));
      }
      #p(e5, t, n2) {
        let i2 = n2.codec === "opus" && n2.description ? opus_exports.preSkip(hex_exports2.toBytes(n2.description)) : 0;
        this.#i.clear(i2);
        let a2 = n2.container.kind === "loc" ? new loc_exports.Format("audio") : new legacy_exports.Format(n2), o = new Consumer8(t, {
          format: a2,
          maxAge: this.sync.out.maxAge
        });
        e5.cleanup(() => o.close()), e5.run((e6) => {
          let t2 = e6.get(o.buffered), n3 = e6.get(this.#t);
          this.#e.buffered.update(() => mergeBufferedRanges(t2, n3));
        }), e5.spawn(async () => {
          if (!await libav_exports.polyfill()) return;
          let t2 = new Ee2(De2), i3 = new AudioDecoder({
            output: (e6) => {
              let n3 = this.#i.span(e6);
              if (t2.drop()) {
                e6.close();
                return;
              }
              this.#h(e6, n3);
            },
            error: (e6) => console.error("audio decoder error", e6)
          });
          e5.cleanup(() => {
            i3.state !== "closed" && i3.close();
          });
          let a3 = n2.codec === "opus" ? void 0 : n2.description ? hex_exports2.toBytes(n2.description) : void 0, s = {
            codec: n2.codec,
            sampleRate: n2.sampleRate,
            numberOfChannels: n2.numberOfChannels,
            description: a3
          };
          for (i3.configure(s); ; ) {
            let e6 = await v2(o);
            if (!e6) break;
            if (this.#y(e6) && (i3.reset(), i3.configure(s)), e6.end !== void 0) continue;
            let { frame: t3 } = e6;
            if (!t3) continue;
            let n3 = time_exports.Milli.fromMicro(t3.timestamp);
            this.sync.received(n3, "audio"), this.#e.stats.update((e7) => ({ bytesReceived: (e7?.bytesReceived ?? 0) + t3.payload.byteLength })), await this.#n?.wait(t3.timestamp);
            let a4 = new EncodedAudioChunk({
              type: t3.keyframe ? "key" : "delta",
              data: t3.payload,
              timestamp: t3.timestamp
            });
            if (i3.state === "closed") break;
            i3.decode(a4);
          }
        });
      }
      #m(e5, t, n2) {
        if (n2.container.kind !== "cmaf") return;
        let i2 = g2(n2.container.init), a2 = cmaf_exports.decodeInitSegment(i2), o = n2.description ? hex_exports2.toBytes(n2.description) : a2.description, s = n2.codec === "opus" && o ? opus_exports.preSkip(o) : 0;
        this.#i.clear(s);
        let c2 = n2.codec === "opus" ? void 0 : n2.description ? hex_exports2.toBytes(n2.description) : a2.description, l2 = new Consumer8(t, {
          format: new cmaf_exports.Format(a2),
          maxAge: this.sync.out.maxAge
        });
        e5.cleanup(() => l2.close()), e5.run((e6) => {
          let t2 = e6.get(l2.buffered), n3 = e6.get(this.#t);
          this.#e.buffered.update(() => mergeBufferedRanges(t2, n3));
        }), e5.spawn(async () => {
          if (!await libav_exports.polyfill()) return;
          let t2 = new AudioDecoder({
            output: (e6) => this.#h(e6),
            error: (e6) => console.error("audio decoder error", e6)
          });
          e5.cleanup(() => {
            t2.state !== "closed" && t2.close();
          });
          let i3 = {
            codec: n2.codec,
            sampleRate: n2.sampleRate,
            numberOfChannels: n2.numberOfChannels,
            description: c2
          };
          for (t2.configure(i3); ; ) {
            let e6 = await v2(l2);
            if (!e6) break;
            this.#y(e6) && (t2.reset(), t2.configure(i3));
            let { frame: n3 } = e6;
            if (!n3) continue;
            let a3 = time_exports.Milli.fromMicro(n3.timestamp);
            if (this.sync.received(a3, "audio"), this.#e.stats.update((e7) => ({ bytesReceived: (e7?.bytesReceived ?? 0) + n3.payload.byteLength })), await this.#n?.wait(n3.timestamp), t2.state === "closed") break;
            t2.decode(new EncodedAudioChunk({
              type: n3.keyframe ? "key" : "delta",
              data: n3.payload,
              timestamp: n3.timestamp
            }));
          }
        });
      }
      #h(e5, t = this.#i.span(e5)) {
        let { timestamp: n2, frameOffset: i2, frames: a2 } = t, o = time_exports.Milli.fromMicro(n2);
        if (a2 === 0) {
          e5.close();
          return;
        }
        let s = this.#n;
        if (!s) {
          e5.close();
          return;
        }
        if (e5.sampleRate !== s.rate) {
          this.#r.set(e5.sampleRate), e5.close();
          return;
        }
        let c2 = a2 / e5.sampleRate * 1e6, l2 = time_exports.Milli.fromMicro(c2), u2 = time_exports.Milli.add(o, l2);
        this.#a.takeover() && (s.truncate(n2), this.#_(o)), this.#g(o, u2);
        let d2 = Math.min(e5.numberOfChannels, s.channels), f3 = [];
        for (let t2 = 0; t2 < d2; t2++) {
          let n3 = new Float32Array(a2);
          e5.copyTo(n3, {
            format: "f32-planar",
            planeIndex: t2,
            frameOffset: i2,
            frameCount: a2
          }), f3.push(n3);
        }
        s.insert(n2, f3), e5.close();
      }
      #g(e5, t) {
        e5 > t || this.#t.mutate((n2) => {
          for (let i2 of n2) if (e5 <= i2.end + 1 && t >= i2.start) {
            i2.start = time_exports.Milli.min(i2.start, e5), i2.end = time_exports.Milli.max(i2.end, t);
            return;
          }
          n2.push({
            start: e5,
            end: t
          }), n2.sort((e6, t2) => e6.start - t2.start);
        });
      }
      #_(e5) {
        this.#t.mutate((t) => {
          for (; t.length > 0 && t[t.length - 1].start >= e5; ) t.pop();
          let n2 = t[t.length - 1];
          n2 && n2.end > e5 && (n2.end = e5);
        });
      }
      #v(e5) {
        this.#t.mutate((t) => {
          for (; t.length > 0; ) {
            if (t[0].end >= e5) {
              t[0].start = time_exports.Milli.max(t[0].start, e5);
              break;
            }
            t.shift();
          }
        });
      }
      reset() {
        this.#n?.reset();
      }
      #y(e5) {
        return this.#i.update(e5) ? (this.#n?.reset(), this.sync.reset(), true) : false;
      }
      close() {
        this.#o.close();
      }
      static supported = Oe2;
    };
    ke2 = 1e-3;
    M = 0.2;
    Ae2 = class {
      source;
      in;
      #e = { enabled: new Signal(false) };
      out = readonlys(this.#e);
      #t = new Effect();
      #n = new Signal(void 0);
      constructor(e5) {
        this.source = e5.source, this.in = {
          volume: getter(e5?.volume ?? 0.5),
          muted: getter(e5?.muted ?? false),
          paused: getter(e5?.paused ?? false)
        }, this.#t.run((e6) => {
          let t = !e6.get(this.in.paused) && !e6.get(this.in.muted);
          this.#e.enabled.set(t);
        }), this.#t.run((e6) => {
          let t = e6.get(this.source.out.root);
          if (!t) return;
          let n2 = new GainNode(t.context, { gain: e6.get(this.in.volume) });
          t.connect(n2), e6.set(this.#n, n2), e6.run((e7) => {
            e7.get(this.#e.enabled) && (n2.connect(t.context.destination), e7.cleanup(() => n2.disconnect()));
          });
        }), this.#t.run((e6) => {
          let t = e6.get(this.#n);
          if (!t) return;
          e6.cleanup(() => t.gain.cancelScheduledValues(t.context.currentTime));
          let n2 = e6.get(this.in.volume);
          n2 < ke2 ? (t.gain.exponentialRampToValueAtTime(ke2, t.context.currentTime + M), t.gain.setValueAtTime(0, t.context.currentTime + M + 0.01)) : t.gain.exponentialRampToValueAtTime(n2, t.context.currentTime + M);
        });
      }
      close() {
        this.#t.close();
      }
    };
    N2 = class {
      in;
      #e = {
        catalog: new Signal(void 0),
        available: new Signal({}),
        track: new Signal(void 0),
        config: new Signal(void 0),
        jitter: new Signal(void 0)
      };
      out = readonlys(this.#e);
      #t = new Effect();
      constructor(e5) {
        this.in = {
          broadcast: getter(e5?.broadcast),
          target: getter(e5?.target),
          supported: getter(e5?.supported)
        }, this.#t.run(this.#n.bind(this)), this.#t.run(this.#r.bind(this)), this.#t.run(this.#i.bind(this));
      }
      #n(e5) {
        let t = e5.get(this.in.broadcast);
        if (!t) return;
        let n2 = e5.get(t.out.catalog)?.audio;
        n2 && e5.set(this.#e.catalog, n2);
      }
      #r(e5) {
        let t = e5.get(this.#e.catalog)?.renditions ?? {}, n2 = e5.get(this.in.supported);
        n2 && e5.spawn(async () => {
          let r2 = {};
          for (let [i2, a2] of Object.entries(t)) {
            let t2 = await e5.race(n2(a2));
            if (e5.abort.aborted) return;
            t2 && (r2[i2] = a2);
          }
          Object.keys(r2).length === 0 && Object.keys(t).length > 0 && console.warn("no supported audio renditions found:", t), this.#e.available.set(r2);
        });
      }
      #i(e5) {
        let t = e5.get(this.#e.available);
        if (Object.keys(t).length === 0) return;
        let n2 = e5.get(this.in.target), r2;
        if (n2?.name && n2.name in t) r2 = {
          track: n2.name,
          config: t[n2.name]
        };
        else if (r2 = this.#a(t), !r2) return;
        e5.set(this.#e.track, r2.track), e5.set(this.#e.config, r2.config), e5.set(this.#e.jitter, ye2(r2.config));
      }
      #a(e5) {
        let t = Object.entries(e5);
        if (t.length !== 0) {
          for (let [e6, n2] of t) if (n2.container.kind === "legacy") return {
            track: e6,
            config: n2
          };
          for (let [e6, n2] of t) if (n2.container.kind === "loc") return {
            track: e6,
            config: n2
          };
          for (let [e6, n2] of t) if (n2.container.kind === "cmaf") return {
            track: e6,
            config: n2
          };
        }
      }
      close() {
        this.#t.close();
      }
    };
    je = 48e3;
    P = 2;
    Le = [
      ...FORMATS,
      "hangz",
      "manual"
    ];
    R = class {
      in;
      #e = {
        status: new Signal("offline"),
        active: new Signal(void 0),
        catalog: new Signal(void 0)
      };
      out = readonlys(this.#e);
      #t = new Signal(void 0);
      #n = new Signal(false);
      #r = new Signal(void 0);
      #i;
      constructor(e5) {
        if (e5 && "reload" in e5) throw Error("Watch.Broadcast: `reload` was renamed to `announced`");
        this.#i = new Effect(), this.in = {
          origin: getter(e5?.origin),
          name: getter(e5?.name ?? path_exports.empty()),
          enabled: getter(e5?.enabled ?? true),
          announced: getter(e5?.announced ?? true),
          catalogFormat: getter(e5?.catalogFormat),
          catalog: getter(e5?.catalog)
        }, this.#i.run(this.#a.bind(this)), this.#i.run(this.#l.bind(this)), this.#i.run(this.#u.bind(this)), this.#i.run(this.#o.bind(this));
      }
      #a(t) {
        if (this.#t.set(void 0), !t.get(this.#n) || !t.get(this.in.announced)) return;
        let n2 = t.get(this.in.origin);
        if (!n2) return;
        let r2 = n2.announced();
        t.cleanup(() => r2.close()), this.#t.set(/* @__PURE__ */ new Set()), t.spawn(async () => {
          for (; ; ) {
            let n3 = await t.race(r2.next());
            if (!n3) break;
            this.#t.mutate((t2) => {
              t2 && (announce_exports.isActive(n3.kind) ? t2.add(n3.prefix) : t2.delete(n3.prefix));
            });
          }
        });
      }
      #o(e5) {
        let t = e5.get(this.#r);
        e5.set(this.#e.catalog, t ? Ie(t, (t2) => this.#d(e5, t2) !== void 0) : void 0);
      }
      #s(e5, t) {
        this.#n.set(true);
        let r2 = e5.get(this.#t);
        if (!r2) return false;
        if (r2.has(t)) return true;
        for (let e6 of r2) if (path_exports.hasPrefix(e6, t)) return true;
        return false;
      }
      #c(e5, t, n2) {
        let r2 = t.request(n2);
        return e5.cleanup(() => r2.close()), e5.get(r2.active);
      }
      #l(e5) {
        if (!e5.get(this.in.enabled)) return;
        let t = e5.get(this.in.origin);
        if (!t) return;
        let n2 = e5.get(this.in.name);
        if (!e5.get(this.in.announced)) {
          e5.set(this.#e.active, this.#c(e5, t, n2), void 0);
          return;
        }
        let r2 = t.request(n2, { announced: true });
        e5.cleanup(() => r2.close()), e5.run((e6) => {
          e6.set(this.#e.active, e6.get(r2.active), void 0);
        });
      }
      #u(e5) {
        if (!e5.get(this.in.enabled)) return;
        let n2 = e5.get(this.in.catalogFormat), r2 = e5.get(this.in.name), i2 = n2 ?? detectFormat(r2) ?? DEFAULT_FORMAT;
        if (i2 === "manual") {
          let t = e5.get(this.in.catalog), n3;
          try {
            n3 = t && checkResolvable(checkRenditions(t), r2);
          } catch (e6) {
            console.error("rejecting catalog", r2, e6);
          }
          this.#r.set(n3, true), e5.cleanup(() => this.#r.set(void 0, true)), this.#e.status.set(n3 ? "live" : "loading");
          return;
        }
        let a2 = e5.get(this.out.active);
        if (!a2 || e5.get(a2.closed) !== void 0) return;
        this.#e.status.set("loading");
        let o = i2 === "hang" ? TRACK3 : i2 === "hangz" ? TRACK_COMPRESSED : "catalog", s = a2.track(o).subscribe({ priority: PRIORITY.catalog });
        e5.cleanup(() => s.close());
        let l2;
        if (i2 === "hang" || i2 === "hangz") {
          let e6 = new snapshot_exports.Consumer({
            track: s,
            schema: RootSchema,
            compression: i2 === "hangz" ? "deflate" : "none"
          });
          l2 = () => e6.next();
        } else {
          let e6 = s.ordered();
          l2 = async () => {
            let t = await fetch3(e6);
            return t ? Fe(t) : void 0;
          };
        }
        e5.spawn(async () => {
          try {
            for (; ; ) {
              let t = await e5.race(l2());
              if (!t) break;
              console.debug("received catalog", i2, this.in.name.peek(), t), this.#r.set(checkResolvable(checkRenditions(t), r2), true), this.#e.status.set("live");
            }
          } catch (e6) {
            e6 instanceof errors_exports2.Stream ? console.debug("catalog subscription ended", this.in.name.peek(), e6) : console.error("error fetching catalog", this.in.name.peek(), e6);
          } finally {
            this.#r.set(void 0), this.#e.status.set("offline");
          }
        });
      }
      #d(e5, t) {
        if (!t) return { local: true };
        let r2 = e5.get(this.in.name), i2 = path_exports.tryResolve(r2, t);
        if (i2 === void 0) {
          console.warn("ignoring rendition: broadcast reference escapes the root", r2, t);
          return;
        }
        if (i2 === r2) return { local: true };
        let a2 = e5.get(this.in.origin);
        if (!a2 || !(e5.get(this.in.announced) && e5.get(a2.discovery) !== false && !this.#s(e5, i2))) return {
          local: false,
          path: i2
        };
      }
      relativeBroadcast(e5, t) {
        let n2 = this.#d(e5, t);
        if (!n2) return;
        if (n2.local) return e5.get(this.out.active);
        if (!e5.get(this.in.enabled)) return;
        let r2 = e5.get(this.in.origin);
        if (r2) return this.#c(e5, r2, n2.path);
      }
      close() {
        this.#i.close();
      }
    };
    Re = time_exports.Milli(20);
    z = time_exports.Milli(100);
    B = class e4 {
      in;
      #e = {
        reference: new Signal(void 0),
        delay: new Signal(time_exports.Milli.zero),
        jitter: new Signal(z),
        timestamp: new Signal(void 0),
        buffered: new Signal(false),
        maxAge: new Signal(time_exports.Milli.zero)
      };
      out = readonlys(this.#e);
      #t = /* @__PURE__ */ new Map();
      #n;
      #r = new Signal([]);
      #i = new Effect();
      constructor(e5) {
        this.in = {
          delay: getter(e5?.delay ?? "auto"),
          buffer: getter(e5?.buffer ?? time_exports.Milli.zero),
          probe: getter(e5?.probe)
        }, this.#i.run(this.#o.bind(this)), this.#i.run(this.#s.bind(this)), this.#i.run(this.#a.bind(this));
      }
      register(e5) {
        let t = { jitter: e5 };
        return this.#r.update((e6) => [...e6, t]), () => this.#r.update((e6) => e6.filter((e7) => e7 !== t));
      }
      #a(e5) {
        let t = e5.get(this.#e.delay), n2 = e5.get(this.in.delay) === "instant" ? time_exports.Milli.zero : e5.get(this.in.buffer);
        this.#e.buffered.set(n2 > 0), this.#e.maxAge.set(time_exports.Milli.add(t, n2));
      }
      #o(e5) {
        let t = e5.get(this.in.delay);
        if (t === "instant") {
          this.#n = void 0, this.#e.jitter.set(time_exports.Milli.zero);
          return;
        }
        if (typeof t == "number") {
          this.#n = void 0, this.#e.jitter.set(t);
          return;
        }
        let n2 = e5.get(this.in.probe)?.rtt;
        if (n2 !== void 0) {
          this.#n = this.#n === void 0 ? n2 : Math.min(this.#n, n2);
          let e6 = time_exports.Milli(Math.max(Re, this.#n * 1.25));
          this.#e.jitter.set(e6);
          return;
        }
        this.#n = void 0, this.#e.jitter.set(z);
      }
      #s(e5) {
        let t = e5.get(this.#e.jitter), n2 = time_exports.Milli.zero;
        for (let t2 of e5.get(this.#r)) n2 = time_exports.Milli.max(n2, e5.get(t2.jitter) ?? time_exports.Milli.zero);
        let i2 = e5.get(this.in.delay) === "instant" ? time_exports.Milli.zero : time_exports.Milli.add(n2, t);
        this.#e.delay.set(i2);
      }
      received(t, n2 = "") {
        this.#e.timestamp.update((e5) => e5 === void 0 || t > e5 ? t : e5);
        let i2 = time_exports.Milli.now(), a2 = time_exports.Milli.sub(i2, t), o = this.#e.reference.peek();
        if (o === void 0) {
          this.#e.reference.set(a2);
          return;
        }
        let s = this.#e.delay.peek(), c2 = time_exports.Milli.add(time_exports.Milli.sub(o, a2), s);
        if (c2 < 0) {
          let e5 = this.#t.get(n2);
          e5 ? (e5.count++, e5.maxMs = Math.max(e5.maxMs, -c2)) : this.#t.set(n2, {
            count: 1,
            maxMs: -c2
          });
        } else {
          let t2 = this.#t.get(n2);
          if (t2) {
            let r2 = n2 ? `sync[${n2}]` : "sync", i3 = e4.#l(t2.maxMs);
            console.debug(`${r2}: ${t2.count} late frame(s), max ${i3} behind`), this.#t.delete(n2);
          }
        }
        if (a2 >= o) return;
        let l2 = this.#e.maxAge.peek();
        c2 <= l2 || this.#e.reference.set(time_exports.Milli.add(a2, time_exports.Milli.sub(l2, s)));
      }
      reset() {
        this.#e.reference.set(void 0), this.#t.clear();
      }
      now() {
        let e5 = this.#e.reference.peek();
        if (e5 !== void 0) return time_exports.Milli.sub(time_exports.Milli.sub(time_exports.Milli.now(), e5), this.#e.delay.peek());
      }
      async wait(e5) {
        if (this.in.delay.peek() !== "instant") {
          if (this.#e.reference.peek() === void 0) throw Error("reference not set; call received() first");
          for (; ; ) {
            if (this.in.delay.peek() === "instant") return;
            let t = time_exports.Milli.now(), n2 = time_exports.Milli.sub(t, e5), i2 = this.#e.reference.peek();
            if (i2 === void 0) return;
            let a2 = time_exports.Milli.add(time_exports.Milli.sub(i2, n2), this.#e.delay.peek());
            if (a2 <= 0 || a2 < 5 || await this.#c(a2)) return;
          }
        }
      }
      #c(e5) {
        return new Promise((t) => {
          let n2 = (e6) => {
            clearTimeout(r2);
            for (let e7 of i2) e7();
            t(e6);
          }, r2 = setTimeout(() => n2(true), e5), i2 = [
            this.in.delay.changed(() => n2(false)),
            this.#e.delay.changed(() => n2(false)),
            this.#e.reference.changed(() => n2(false))
          ];
        });
      }
      static #l(e5) {
        if (e5 = Math.round(e5), e5 < 1e3) return `${e5}ms`;
        let t = e5 / 1e3;
        if (t < 60) return `${Math.round(t * 10) / 10}s`;
        let n2 = t / 60;
        return `${Math.round(n2 * 10) / 10}m`;
      }
      close() {
        this.#i.close();
      }
    };
    ze = ":where([part=captions]){--overlay-padding:1%;--cue-color:white;--cue-bg-color:#000c;--cue-font-size:calc(var(--overlay-height) / 100 * 5);--cue-line-height:calc(var(--cue-font-size) * 1.2);--cue-padding-x:calc(var(--cue-font-size) * .6);--cue-padding-y:calc(var(--cue-font-size) * .4);z-index:1;contain:content;margin:var(--overlay-padding);font-size:var(--cue-font-size);box-sizing:border-box;pointer-events:none;user-select:none;word-spacing:normal;word-break:break-word;font-family:sans-serif;position:absolute;inset:0}:where([part=captions]>[part=cue-display]){contain:content;top:var(--cue-top);left:var(--cue-left);right:var(--cue-right);bottom:var(--cue-bottom);width:var(--cue-width,auto);height:var(--cue-height,auto);box-sizing:border-box;transform:var(--cue-transform);text-align:var(--cue-text-align);writing-mode:var(--cue-writing-mode,unset);white-space:pre-line;direction:ltr;unicode-bidi:plaintext;min-width:min-content;min-height:min-content;position:absolute;overflow:visible}:where([data-dir=rtl] [part=cue-display]){direction:rtl}:where([part=captions] [part=cue]){padding:var(--cue-padding-y) var(--cue-padding-x);line-height:var(--cue-line-height);background-color:var(--cue-bg-color);box-sizing:border-box;color:var(--cue-color);box-shadow:var(--cue-box-shadow);white-space:var(--cue-white-space,pre-wrap);outline:var(--cue-outline);text-shadow:var(--cue-text-shadow);display:inline-block}:where([part=captions] [part=cue-display][data-vertical] [part=cue]){padding:var(--cue-padding-x) var(--cue-padding-y)}\n:where([part=captions] [part=region]){width:var(--region-width);height:var(--region-height);min-height:0;max-height:var(--region-height);writing-mode:horizontal-tb;top:calc(var(--region-top,var(--overlay-height) * var(--region-viewport-anchor-y) / 100 - var(--region-height) * var(--region-anchor-y) / 100));left:var(--region-left,calc(calc(var(--region-viewport-anchor-x) * 1%) - calc(var(--region-width) * var(--region-anchor-x) / 100)));right:var(--region-right);bottom:var(--region-bottom);overflow-wrap:break-word;box-sizing:border-box;flex-flow:column;justify-content:flex-start;display:inline-flex;position:absolute;overflow:hidden}:where([part=captions] [part=region][data-scroll=up]){justify-content:end}:where([part=captions] [part=region][data-active][data-scroll=up]){transition:top .433s}:where([part=captions] [part=region]>[part=cue-display]){width:auto;left:var(--cue-offset);height:var(--cue-height,auto);text-align:var(--cue-text-align);unicode-bidi:plaintext;margin-top:1px;position:relative}:where([part=captions] [part=region] [part=cue]){padding:calc(var(--cue-padding-y) / 2) var(--cue-padding-x);border-radius:0;position:relative}";
    Be = time_exports.Milli(3e4);
    Ve = time_exports.Milli(3e4);
    He = time_exports.Milli(1e3);
    K2 = class {
      source;
      sync;
      in;
      #e = new Effect();
      #t = false;
      constructor(e5) {
        this.source = e5.source, this.sync = e5.sync, this.in = {
          container: getter(e5?.container),
          enabled: getter(e5?.enabled ?? true)
        }, this.#e.run(this.#n.bind(this));
      }
      #n(e5) {
        let n2 = e5.getAll([
          this.in.enabled,
          this.in.container,
          this.source.out.track,
          this.source.out.config,
          this.source.in.broadcast
        ]);
        if (!n2) return;
        let [r2, i2, a2, o, s] = n2, l2 = s.relativeBroadcast(e5, o.broadcast);
        if (!l2) return;
        this.#t = false;
        let d2;
        if (o.container.kind === "legacy") d2 = new legacy_exports.Format("data");
        else if (o.container.kind === "loc") d2 = new loc_exports.Format();
        else {
          console.warn(`captions: unsupported container "${o.container.kind}" for track ${a2}`);
          return;
        }
        let f3 = document.createElement("style");
        f3.textContent = ze, i2.appendChild(f3), e5.cleanup(() => f3.remove());
        let p3 = document.createElement("div");
        p3.style.position = "absolute", p3.style.inset = "0", p3.style.pointerEvents = "none", i2.appendChild(p3), e5.cleanup(() => p3.remove());
        let m3 = new CaptionsRenderer(p3);
        e5.cleanup(() => m3.destroy());
        let h3 = _2(e5, {
          broadcast: l2,
          track: a2,
          priority: PRIORITY.text,
          maxAge: this.sync.out.maxAge
        });
        if (!h3) return;
        let g3 = {
          cues: [],
          regions: /* @__PURE__ */ new Map(),
          clears: []
        }, v3 = () => m3.changeTrack({
          cues: [...g3.cues],
          regions: [...g3.regions.values()]
        }), y3 = () => {
          let t = this.sync.now();
          t !== void 0 && (m3.currentTime = t / 1e3, U(g3, (t - Be) / 1e3) && v3()), e5.animate(y3);
        };
        e5.animate(y3), e5.spawn(async () => {
          for (; ; ) {
            let n3 = await h3.recvGroup().catch((e6) => {
              if (!(e6 instanceof errors_exports2.Stream)) throw e6;
              console.debug("captions subscription ended", e6);
            });
            if (!n3) break;
            e5.spawn(async () => {
              try {
                for (; ; ) {
                  let e6 = await n3.readFrame();
                  if (!e6) break;
                  for (let t of d2.decode(e6.payload)) await this.#r(o.format, t, g3);
                }
              } catch (e6) {
                if (!(e6 instanceof errors_exports2.Stream)) throw e6;
              } finally {
                n3.close();
              }
              v3();
            });
          }
        });
      }
      async #r(e5, t, n2) {
        let r2 = new TextDecoder().decode(t.payload), i2 = t.timestamp / 1e6;
        if (e5 === "utf8") {
          if (r2.length === 0) {
            G(n2, i2);
            return;
          }
          let e6 = new VTTCue(i2, i2 + Ve / 1e3, V2(r2));
          H(n2.cues, e6), W2(n2, e6);
          return;
        }
        if (r2.length === 0) return;
        let a2;
        try {
          a2 = await parseText(r2, { type: "vtt" });
        } catch (e6) {
          console.warn("captions: failed to parse VTT cue", e6);
          return;
        }
        let o = a2.cues.at(0);
        !this.#t && o && Math.abs(o.startTime - i2) > He / 1e3 && (this.#t = true, console.warn(`captions: cue timing is ${(o.startTime - i2).toFixed(3)}s off its frame timestamp; the payload must carry absolute times on the media clock`));
        for (let e6 of a2.regions) n2.regions.set(e6.id, e6);
        for (let e6 of a2.cues) e6.text = V2(e6.text), H(n2.cues, e6);
      }
      close() {
        this.#e.close();
      }
    };
    Ue = /* @__PURE__ */ new Set(["vtt", "utf8"]);
    J = class {
      in;
      #e = {
        catalog: new Signal(void 0),
        available: new Signal({}),
        track: new Signal(void 0),
        config: new Signal(void 0)
      };
      out = readonlys(this.#e);
      #t = new Effect();
      constructor(e5) {
        this.in = {
          broadcast: getter(e5?.broadcast),
          target: getter(e5?.target)
        }, this.#t.run(this.#n.bind(this)), this.#t.run(this.#r.bind(this));
      }
      #n(e5) {
        let t = e5.get(this.in.broadcast), n2 = t ? e5.get(t.out.catalog)?.text : void 0;
        e5.set(this.#e.catalog, n2), this.#e.available.set(n2?.renditions ?? {});
      }
      #r(e5) {
        let t = e5.get(this.#e.available), n2 = e5.get(this.in.target), r2 = n2 ? t[n2] : void 0;
        if (!n2 || !r2) {
          e5.set(this.#e.track, void 0), e5.set(this.#e.config, void 0);
          return;
        }
        q(r2) || console.warn(`captions: unsupported format ${JSON.stringify(r2.format)} for track ${n2}`), e5.set(this.#e.track, n2), e5.set(this.#e.config, r2);
      }
      close() {
        this.#t.close();
      }
    };
    Y = /* @__PURE__ */ Symbol("supportCacheKey");
    Ge = time_exports.Milli(100);
    $e = time_exports.Milli(500);
    Q = class {
      in;
      source;
      sync;
      #e = {
        frame: new Signal(void 0),
        timestamp: new Signal(void 0),
        display: new Signal(void 0),
        stalled: new Signal(false),
        stats: new Signal(void 0),
        jitter: new Signal(void 0),
        buffered: new Signal([])
      };
      out = readonlys(this.#e);
      #t = new Signal(void 0);
      #n = new Signal(void 0);
      #r;
      #i = new Effect();
      #a() {
        this.#e.frame.update((e5) => {
          e5?.close();
        }), this.#e.timestamp.set(void 0);
      }
      constructor(e5) {
        this.in = { enabled: getter(e5?.enabled ?? true) }, this.source = e5.source, this.sync = e5.sync, this.#i.cleanup(this.sync.register(this.out.jitter)), this.#r = this.#i.computed((e6) => {
          let t = e6.get(this.source.out.config);
          return t ? X(t) : void 0;
        }), this.#i.run(this.#o.bind(this)), this.#i.run(this.#s.bind(this)), this.#i.run(this.#c.bind(this)), this.#i.run(this.#l.bind(this)), this.#i.run(this.#u.bind(this));
      }
      #o(e5) {
        let t = (t2, n3) => {
          if (t2 === void 0 || n3 === void 0) return;
          let r3 = e5.get(n3)?.video?.renditions?.[t2];
          return r3 && Ke(r3);
        }, n2 = e5.get(this.#t), r2 = t(n2?.track, n2?.catalog), i2 = e5.get(this.#n), a2 = t(i2?.track, i2?.catalog);
        e5.set(this.#e.jitter, Je2({
          active: r2,
          pending: a2
        }));
      }
      #s(e5) {
        let t = e5.getAll([
          this.in.enabled,
          this.source.in.broadcast,
          this.source.out.track,
          this.#r
        ]);
        if (!t) {
          this.#t.set(void 0);
          return;
        }
        let [n2, r2, i2, a2] = t, o = r2.relativeBroadcast(e5, a2.broadcast);
        if (!o) {
          this.#t.set(void 0), this.#a(), this.#e.buffered.set([]);
          return;
        }
        let s = new et({
          sync: this.sync,
          broadcast: o,
          track: i2,
          config: a2.decoder,
          stats: this.#e.stats,
          catalog: r2.out.catalog
        });
        e5.set(this.#n, {
          track: i2,
          catalog: r2.out.catalog
        }), e5.cleanup(() => s?.close()), e5.run((e6) => {
          if (!s) return;
          let t2 = e6.get(this.#t);
          if (t2) {
            let n3 = e6.get(s.timestamp);
            if (n3 === void 0 || !qe2({
              playhead: n3,
              active: e6.get(t2.timestamp)
            })) return;
          }
          this.#t.set(s), this.#n.set(void 0), s = void 0, e6.close();
        });
      }
      #c(e5) {
        let t = e5.get(this.#t);
        if (!t) {
          this.#e.buffered.set([]);
          return;
        }
        e5.cleanup(() => t.close()), e5.run((e6) => {
          let n2 = e6.get(t.frame);
          n2 && (this.#e.timestamp.set(time_exports.Milli.fromMicro(n2.timestamp)), this.#e.frame.update((e7) => (e7?.close(), n2.clone())));
        }), e5.proxy(this.#e.buffered, t.buffered);
      }
      #l(e5) {
        let t = e5.get(this.source.out.catalog);
        if (!t) return;
        let n2 = t.display;
        if (n2) {
          e5.set(this.#e.display, {
            width: n2.width,
            height: n2.height
          });
          return;
        }
        let r2 = e5.get(this.#e.frame);
        r2 && e5.set(this.#e.display, Xe({
          width: r2.displayWidth,
          height: r2.displayHeight
        }, t.rotation));
      }
      #u(e5) {
        if (e5.get(this.in.enabled)) {
          if (!e5.get(this.#e.frame)) {
            this.#e.stalled.set(true);
            return;
          }
          this.#e.stalled.set(false), e5.timer(() => {
            this.#e.stalled.set(true);
          }, $e);
        }
      }
      close() {
        this.#a(), this.#i.close();
      }
      static supported = tt;
    };
    et = class {
      sync;
      broadcast;
      track;
      config;
      catalog;
      stats;
      timestamp = new Signal(void 0);
      frame = new Signal(void 0);
      buffered = new Signal([]);
      #e = new Signal([]);
      #t = 0;
      #n = new Effect();
      constructor(e5) {
        this.sync = e5.sync, this.broadcast = e5.broadcast, this.track = e5.track, this.config = e5.config, this.catalog = e5.catalog, this.stats = e5.stats, this.#n.run(this.#r.bind(this));
      }
      #r(e5) {
        let t = _2(e5, {
          broadcast: this.broadcast,
          track: this.track,
          priority: PRIORITY.video,
          maxAge: this.sync.out.maxAge
        });
        if (!t) return;
        let n2 = new VideoDecoder({
          output: async (t2) => {
            try {
              let n3 = this.#t, i2 = time_exports.Milli.fromMicro(t2.timestamp);
              if (i2 < (this.timestamp.peek() ?? 0) || this.sync.out.reference.peek() === void 0 || (this.frame.peek() === void 0 && this.frame.set(t2.clone()), !await e5.race(this.sync.wait(i2).then(() => true))) || n3 !== this.#t || i2 < (this.timestamp.peek() ?? 0)) return;
              this.timestamp.set(i2), this.#c(i2), this.frame.update((e6) => (e6?.close(), t2.clone()));
            } finally {
              t2.close();
            }
          },
          error: (t2) => {
            console.error("video decoder error", t2), e5.close();
          }
        });
        e5.cleanup(() => {
          n2.state !== "closed" && n2.close();
        }), this.config.container.kind === "cmaf" ? this.#a(e5, t, n2) : this.#i(e5, t, n2);
      }
      #i(e5, t, n2) {
        let i2 = this.config.container.kind === "loc" ? new loc_exports.Format("video") : new legacy_exports.Format(this.config), a2 = new Consumer8(t, {
          format: i2,
          maxAge: this.sync.out.maxAge
        });
        e5.cleanup(() => a2.close()), e5.run((e6) => {
          let t2 = e6.get(a2.buffered), n3 = e6.get(this.#e);
          this.buffered.update(() => mergeBufferedRanges(t2, n3));
        }), n2.configure({
          codec: this.config.codec,
          description: this.config.description ? hex_exports2.toBytes(this.config.description) : void 0,
          displayAspectWidth: this.config.displayAspectWidth,
          displayAspectHeight: this.config.displayAspectHeight,
          optimizeForLatency: this.config.optimizeForLatency,
          flip: false
        });
        let o, s;
        e5.spawn(async () => {
          for (; ; ) {
            let e6 = await v2(a2);
            if (!e6) break;
            this.#o(e6.discontinuity) && (o = void 0);
            let { frame: t2 } = e6;
            if (!t2) continue;
            let i3 = s !== void 0 && e6.group < s;
            if (this.stats.update((e7) => ({
              frameCount: (e7?.frameCount ?? 0) + +!i3,
              bytesReceived: (e7?.bytesReceived ?? 0) + t2.payload.byteLength
            })), i3) continue;
            let c2 = time_exports.Milli.fromMicro(t2.timestamp);
            this.sync.received(c2, "video");
            let l2 = new EncodedVideoChunk({
              type: t2.keyframe ? "key" : "delta",
              data: t2.payload,
              timestamp: t2.timestamp
            });
            o !== void 0 && e6.continuous && this.#s(time_exports.Milli.fromMicro(o), time_exports.Milli.fromMicro(t2.timestamp)), o = t2.timestamp, s = e6.group, n2.decode(l2);
          }
        });
      }
      #a(e5, t, n2) {
        let i2 = this.config.container;
        if (i2.kind !== "cmaf") return;
        let a2 = g2(i2.init), o = cmaf_exports.decodeInitSegment(a2), s = this.config.description ? hex_exports2.toBytes(this.config.description) : o.description, c2 = new Consumer8(t, {
          format: new cmaf_exports.Format(o),
          maxAge: this.sync.out.maxAge
        });
        e5.cleanup(() => c2.close()), e5.run((e6) => {
          let t2 = e6.get(c2.buffered), n3 = e6.get(this.#e);
          this.buffered.update(() => mergeBufferedRanges(t2, n3));
        }), n2.configure({
          codec: this.config.codec,
          description: s,
          displayAspectWidth: this.config.displayAspectWidth,
          displayAspectHeight: this.config.displayAspectHeight,
          optimizeForLatency: this.config.optimizeForLatency,
          flip: false
        });
        let l2, f3;
        e5.spawn(async () => {
          for (; ; ) {
            let e6 = await v2(c2);
            if (!e6) break;
            this.#o(e6.discontinuity) && (l2 = void 0);
            let { frame: t2 } = e6;
            if (!t2) continue;
            let i3 = f3 !== void 0 && e6.group < f3;
            if (this.stats.update((e7) => ({
              frameCount: (e7?.frameCount ?? 0) + +!i3,
              bytesReceived: (e7?.bytesReceived ?? 0) + t2.payload.byteLength
            })), i3) continue;
            let a3 = time_exports.Milli.fromMicro(t2.timestamp);
            if (this.sync.received(a3, "video"), l2 !== void 0 && e6.continuous && this.#s(time_exports.Milli.fromMicro(l2), time_exports.Milli.fromMicro(t2.timestamp)), l2 = t2.timestamp, n2.state === "closed") break;
            f3 = e6.group, n2.decode(new EncodedVideoChunk({
              type: t2.keyframe ? "key" : "delta",
              data: t2.payload,
              timestamp: t2.timestamp
            }));
          }
        });
      }
      #o(e5) {
        return e5 !== this.#t && (this.#t = e5, this.timestamp.set(void 0), this.#e.set([]), this.sync.reset(), true);
      }
      #s(e5, t) {
        e5 > t || this.#e.mutate((n2) => {
          for (let i2 of n2) if (i2.start <= t && i2.end >= e5) {
            i2.start = time_exports.Milli.min(i2.start, e5), i2.end = time_exports.Milli.max(i2.end, t);
            return;
          }
          n2.push({
            start: e5,
            end: t
          }), n2.sort((e6, t2) => e6.start - t2.start);
        });
      }
      #c(e5) {
        this.#e.mutate((t) => {
          for (; t.length > 0; ) {
            if (t[0].end >= e5) {
              t[0].start = time_exports.Milli.max(t[0].start, e5);
              break;
            }
            t.shift();
          }
        });
      }
      close() {
        this.#n.close(), this.frame.update((e5) => {
          e5?.close();
        });
      }
    };
    Object.assign(tt, { [Y]: We });
    nt = 0.01;
    rt = class {
      decoder;
      in;
      #e = {
        frame: new Signal(void 0),
        timestamp: new Signal(void 0),
        visible: new Signal(false)
      };
      out = readonlys(this.#e);
      #t = new Signal(void 0);
      #n = new Effect();
      constructor(e5) {
        this.decoder = e5.decoder, this.in = {
          canvas: getter(e5?.canvas),
          visible: getter(e5?.visible ?? "20%")
        }, this.#n.run((e6) => {
          let t = e6.get(this.in.canvas);
          this.#t.set(t?.getContext("2d") ?? void 0);
        }), this.#n.run(this.#i.bind(this)), this.#n.run(this.#a.bind(this)), this.#n.run(this.#r.bind(this));
      }
      #r(e5) {
        let t = e5.getAll([this.in.canvas, this.decoder.out.display]);
        if (!t) return;
        let [n2, r2] = t;
        (n2.width !== r2.width || n2.height !== r2.height) && (n2.width = r2.width, n2.height = r2.height);
      }
      #i(e5) {
        let t = e5.get(this.in.visible);
        if (t === "never") {
          this.#e.visible.set(false);
          return;
        }
        if (t === "always") {
          this.#e.visible.set(true), e5.cleanup(() => this.#e.visible.set(false));
          return;
        }
        let n2 = e5.get(this.in.canvas);
        if (!n2) {
          this.#e.visible.set(false);
          return;
        }
        let r2 = false, i2 = () => {
          this.#e.visible.set(r2 && !document.hidden);
        }, a2 = (e6) => {
          for (let t2 of e6) r2 = t2.isIntersecting, i2();
        }, o;
        try {
          o = new IntersectionObserver(a2, {
            threshold: nt,
            rootMargin: t
          });
        } catch {
          console.warn(`moq-watch: invalid visible margin "${t}", using "0px"`), o = new IntersectionObserver(a2, { threshold: nt });
        }
        i2(), e5.event(document, "visibilitychange", i2), o.observe(n2), e5.cleanup(() => o.disconnect()), e5.cleanup(() => this.#e.visible.set(false));
      }
      #a(e5) {
        let t = e5.get(this.#t);
        if (!t) return;
        let n2 = e5.get(this.decoder.out.frame), i2 = e5.get(this.decoder.source.out.catalog), a2 = requestAnimationFrame(() => {
          this.#o(t, n2, i2), n2 ? (this.#e.frame.update((e6) => (e6?.close(), n2.clone())), this.#e.timestamp.set(time_exports.Milli.fromMicro(n2.timestamp))) : (this.#e.frame.update((e6) => {
            e6?.close();
          }), this.#e.timestamp.set(void 0)), a2 = void 0;
        });
        e5.cleanup(() => {
          a2 !== void 0 && cancelAnimationFrame(a2);
        });
      }
      #o(e5, t, n2) {
        if (!t) {
          e5.fillStyle = "#000", e5.fillRect(0, 0, e5.canvas.width, e5.canvas.height);
          return;
        }
        if (e5.save(), e5.fillStyle = "#000", e5.fillRect(0, 0, e5.canvas.width, e5.canvas.height), !n2?.rotation) n2?.flip && (e5.scale(-1, 1), e5.translate(-e5.canvas.width, 0)), e5.drawImage(t, 0, 0, e5.canvas.width, e5.canvas.height);
        else {
          let r2 = Qe(e5.canvas, n2);
          e5.setTransform(...r2.matrix), e5.drawImage(t, 0, 0, r2.source.width, r2.source.height);
        }
        e5.restore();
      }
      close() {
        this.#e.frame.update((e5) => {
          e5?.close();
        }), this.#e.timestamp.set(void 0), this.#n.close();
      }
    };
    ct = class {
      in;
      #e = {
        catalog: new Signal(void 0),
        available: new Signal({}),
        error: new Signal(void 0),
        track: new Signal(void 0),
        config: new Signal(void 0)
      };
      out = readonlys(this.#e);
      #t = new Effect();
      #n = /* @__PURE__ */ new WeakMap();
      constructor(e5) {
        this.in = {
          broadcast: getter(e5?.broadcast),
          target: getter(e5?.target),
          supported: getter(e5?.supported),
          probe: getter(e5?.probe)
        }, this.#t.run(this.#r.bind(this)), this.#t.run(this.#i.bind(this)), this.#t.run(this.#a.bind(this));
      }
      #r(e5) {
        let t = e5.get(this.in.broadcast);
        if (!t) return;
        let n2 = e5.get(t.out.catalog)?.video;
        n2 && e5.set(this.#e.catalog, n2);
      }
      #i(e5) {
        let t = e5.get(this.in.supported);
        if (!t) {
          this.#e.error.set(void 0);
          return;
        }
        let n2 = e5.get(this.#e.catalog)?.renditions ?? {};
        this.#e.error.set(void 0);
        let r2 = this.#n.get(t);
        r2 || (r2 = /* @__PURE__ */ new Map(), this.#n.set(t, r2));
        let i2 = new Set(Object.keys(n2));
        for (let e6 of r2.keys()) i2.has(e6) || r2.delete(e6);
        e5.spawn(async () => {
          let i3 = {};
          for (let [a3, o] of Object.entries(n2)) {
            let n3 = t[Y], s = n3 ? n3(o) : JSON.stringify(o), c2 = r2.get(a3), l2 = false;
            if (c2?.key === s) l2 = c2.supported;
            else {
              let i4 = false;
              try {
                l2 = await e5.race(t(o));
              } catch (e6) {
                i4 = true, console.warn(`[Source] video rendition ${a3} (${o.codec}) support probe failed; treating as unsupported`, e6);
              }
              !i4 && l2 !== void 0 && r2.set(a3, {
                key: n3 ? n3(o) : JSON.stringify(o),
                supported: l2
              });
            }
            if (e5.abort.aborted) return;
            l2 && (i3[a3] = o);
          }
          let a2 = Object.keys(i3).length === 0 && Object.keys(n2).length > 0 ? "unsupported" : void 0;
          a2 === "unsupported" && console.warn("[Source] No supported video renditions found:", n2), this.#e.error.set(a2), this.#e.available.set(i3);
        });
      }
      #a(e5) {
        let t = e5.get(this.#e.available), n2 = e5.get(this.in.target);
        if (n2?.name && n2.name in t) {
          let r3 = t[n2.name];
          e5.set(this.#e.track, n2.name), e5.set(this.#e.config, r3);
          return;
        }
        let r2 = st(t);
        if (Object.keys(r2).length === 0) return;
        let i2 = n2;
        if (!n2?.bitrate) {
          let t2 = e5.get(this.in.probe)?.estimatedRecvRate;
          if (t2 != null) {
            let e6 = Math.round(t2 * 0.8);
            i2 = {
              ...n2,
              bitrate: e6
            };
          }
        }
        let a2 = this.#o(r2, i2);
        if (!a2) return;
        let o = r2[a2];
        e5.set(this.#e.track, a2), e5.set(this.#e.config, o);
      }
      #o(e5, t) {
        let n2 = Object.entries(e5);
        if (n2.length === 0) return;
        if (n2.length === 1) return n2[0][0];
        let r2 = [];
        if (t?.pixels != null && r2.push(it(t.pixels)), (t?.width != null || t?.height != null) && r2.push(at(t.width, t.height)), t?.bitrate != null && r2.push($(t.bitrate)), r2.length === 0) return ot(n2);
        let i2 = r2.map((e6) => e6(n2)), a2 = i2.map((e6) => new Set(e6));
        for (let e6 of i2[0]) if (a2.every((t2) => t2.has(e6))) return e6;
        console.warn("conflicting rendition filters, no rendition satisfies all criteria");
      }
      close() {
        this.#t.close();
      }
    };
    lt = class {
      in;
      broadcast;
      sync;
      text;
      video;
      audio;
      renderer;
      emitter;
      textRenderer;
      #e = new Signal(false);
      #t = new Signal(false);
      #n = new Signal(false);
      #r = new Effect();
      constructor(e5 = {}) {
        this.in = readonlys({
          origin: getter(e5.origin),
          name: getter(e5.name ?? path_exports.empty()),
          enabled: getter(e5.enabled ?? true),
          announced: getter(e5.announced ?? true),
          catalogFormat: getter(e5.catalogFormat),
          catalog: getter(e5.catalog),
          probe: getter(e5.probe),
          canvas: getter(e5.canvas),
          container: getter(e5.container),
          paused: getter(e5.paused ?? false),
          volume: getter(e5.volume ?? 0.5),
          muted: getter(e5.muted ?? false),
          visible: getter(e5.visible ?? "20%"),
          delay: getter(e5.delay ?? "auto"),
          buffer: getter(e5.buffer ?? time_exports.Milli.zero),
          target: getter(e5.target),
          captions: getter(e5.captions)
        }), this.broadcast = new R(this.in), this.#r.cleanup(() => this.broadcast.close());
        let t = new ct({
          broadcast: this.broadcast,
          target: this.in.target,
          supported: Q.supported,
          probe: this.in.probe
        }), i2 = new N2({
          broadcast: this.broadcast,
          supported: j.supported
        });
        this.#r.cleanup(() => {
          t.close(), i2.close();
        }), this.text = new J({
          broadcast: this.broadcast,
          target: this.in.captions
        }), this.#r.cleanup(() => this.text.close()), this.sync = new B({
          delay: this.in.delay,
          buffer: this.in.buffer,
          probe: this.in.probe
        }), this.#r.cleanup(() => this.sync.close()), this.video = new Q({
          source: t,
          sync: this.sync,
          enabled: this.#e
        }), this.audio = new j({
          source: i2,
          sync: this.sync,
          enabled: this.#t
        }), this.#r.cleanup(() => {
          this.video.close(), this.audio.close();
        }), this.emitter = new Ae2({
          source: this.audio,
          volume: this.in.volume,
          muted: this.in.muted,
          paused: this.in.paused
        }), this.renderer = new rt({
          decoder: this.video,
          canvas: this.in.canvas,
          visible: this.in.visible
        }), this.#r.cleanup(() => {
          this.emitter.close(), this.renderer.close();
        }), this.textRenderer = new K2({
          source: this.text,
          sync: this.sync,
          container: this.in.container,
          enabled: this.#n
        }), this.#r.cleanup(() => this.textRenderer.close()), this.#r.run((e6) => {
          this.#n.set(e6.get(this.in.enabled) && !e6.get(this.in.paused));
        }), this.#r.run((e6) => {
          this.#t.set(e6.get(this.in.enabled) && e6.get(this.emitter.out.enabled));
        }), this.#r.run((e6) => {
          let t2 = e6.get(this.renderer.out.visible);
          e6.get(this.in.enabled) ? e6.get(this.in.paused) ? this.#e.set(t2 && !e6.get(this.renderer.out.frame)) : this.#e.set(t2) : this.#e.set(false);
        });
      }
      reset() {
        this.sync.reset(), this.audio.reset();
      }
      close() {
        this.#r.close();
      }
    };
  }
});

// ../../node_modules/@moq/watch/index.js
var x3, S4, C3;
var init_watch = __esm({
  "../../node_modules/@moq/watch/index.js"() {
    init_player_XR9_DSpx();
    x3 = Object.defineProperty;
    S4 = (e5, t) => {
      let n2 = {};
      for (var r2 in e5) x3(n2, r2, {
        get: e5[r2],
        enumerable: true
      });
      return t || x3(n2, Symbol.toStringTag, { value: "Module" }), n2;
    };
    C3 = /* @__PURE__ */ S4({
      Decoder: () => j,
      Emitter: () => Ae2,
      Source: () => N2
    });
  }
});

// src/sound.ts
function audioContext(rate = 48e3) {
  let used = shared.get(rate);
  if (!used) {
    const context = new AudioContext({ latencyHint: "interactive", sampleRate: rate });
    const resume = () => {
      if (context.state !== "running") context.resume().catch(() => {
      });
    };
    for (const type of GESTURES) document.addEventListener(type, resume, LISTEN);
    context.addEventListener("statechange", resume);
    resume();
    shared.set(rate, used = { context, users: 0, resume });
  }
  const it2 = used;
  it2.users++;
  let released = false;
  return {
    context: it2.context,
    release() {
      if (released) return;
      released = true;
      if (--it2.users > 0) return;
      for (const type of GESTURES) document.removeEventListener(type, it2.resume, LISTEN);
      it2.context.removeEventListener("statechange", it2.resume);
      it2.context.close().catch(() => {
      });
      if (shared.get(rate) === it2) shared.delete(rate);
    }
  };
}
var GESTURES, LISTEN, shared;
var init_sound = __esm({
  "src/sound.ts"() {
    "use strict";
    GESTURES = ["pointerdown", "pointerup", "touchend", "click", "keydown"];
    LISTEN = { capture: true, passive: true };
    shared = /* @__PURE__ */ new Map();
  }
});

// src/media-web.ts
var media_web_exports = {};
__export(media_web_exports, {
  media: () => media
});
function slot(changed, ended) {
  const out = new signals_exports.Signal(void 0);
  let given;
  const set = (track) => {
    const next = track?.readyState === "live" ? track : void 0;
    if (next !== given) {
      given?.removeEventListener("ended", ended);
      out.peek()?.stop();
      given = next;
      given?.addEventListener("ended", ended);
      out.set(given?.clone());
      changed();
    }
    const clone2 = out.peek();
    if (clone2 && given) clone2.enabled = given.enabled;
  };
  return { out, given: () => given, set };
}
function streams(changed) {
  let stream;
  return {
    get: () => stream,
    set(tracks) {
      const now = tracks.filter((track) => track !== void 0);
      const had = stream?.getTracks() ?? [];
      if (now.length === had.length && now.every((track) => had.includes(track))) return;
      stream = now.length ? new MediaStream(now) : void 0;
      changed(stream);
    }
  };
}
function numbering(origin) {
  return {
    get closed() {
      return origin.closed;
    },
    get discovery() {
      return origin.discovery;
    },
    createBroadcast(path) {
      const made = origin.createBroadcast(path_exports.from(path.replace(/\.hang$/u, "")));
      const create = made.createTrack.bind(made);
      made.createTrack = (name, info) => {
        const track = create(name, info);
        track.appendGroup = groups(track);
        return track;
      };
      return made;
    },
    request: (path, options) => origin.request(path, options),
    broadcasts: (scope, options) => origin.broadcasts(scope, options),
    announced: (scope, options) => origin.announced(scope, options),
    dynamic: (prefix, route) => origin.dynamic(prefix, route)
  };
}
function broadcast(origin, path, on, video, audio) {
  const effects = [];
  const derived2 = (compute) => {
    const signal = new signals_exports.Signal(void 0);
    effects.push(new signals_exports.Effect((effect) => signal.set(compute(effect))));
    return signal;
  };
  const enabled = derived2(on);
  const out = new ke({ origin: numbering(origin), enabled, announce: enabled, name: path_exports.from(`${path}.hang`) });
  const capture = new w2.Capture({ source: video });
  const audioOn = derived2((effect) => effect.get(audio) !== void 0);
  const sound2 = new S2.Capture({ source: audio, enabled: audioOn, sampleRate: 48e3 });
  const parts3 = [
    new w2.Encoder("video/hd", { broadcast: out, capture, enabled: derived2((effect) => effect.get(video) !== void 0), config: { codec: "avc1", maxPixels: 1280 * 720 } }),
    capture,
    new S2.Encoder("audio", { broadcast: out, capture: sound2, enabled: audioOn, codec: { mime: "opus", usedtx: false } }),
    sound2
  ];
  return {
    close() {
      for (const part of [...parts3, out, ...effects]) part.close();
    }
  };
}
function sound(changed) {
  const held = audioContext();
  let on = false;
  const output = (context) => {
    const out = context.createMediaStreamDestination();
    const gain = new GainNode(context, { gain: on ? 1 : 0 });
    gain.connect(context.destination);
    return { context, out, gain, track: out.stream.getAudioTracks()[0] };
  };
  const end = (one) => {
    one.gain.disconnect();
    one.track.stop();
  };
  let at2 = output(held.context);
  let effect;
  return {
    track: () => at2.track,
    follow(player) {
      effect?.close();
      effect = new signals_exports.Effect((effect2) => {
        const root = effect2.get(player.audio.out.root);
        if (!root) return;
        if (root.context !== at2.context) {
          end(at2);
          at2 = output(root.context);
          changed();
        }
        const { out, gain } = at2;
        root.connect(out);
        root.connect(gain);
        effect2.cleanup(() => {
          try {
            root.disconnect(out);
            root.disconnect(gain);
          } catch {
          }
        });
      });
    },
    heard(now) {
      on = now;
      const { gain } = at2.gain;
      const time2 = at2.context.currentTime;
      gain.cancelScheduledValues(time2);
      gain.setTargetAtTime(on ? 1 : 0, time2, 0.01);
      gain.setValueAtTime(on ? 1 : 0, time2 + 0.05);
    },
    stop() {
      effect?.close();
      end(at2);
      held.release();
    }
  };
}
var REPLAY_MS, REPLAY_MAX_MS, CATALOG_GONE_MS, ENDED_MS, media;
var init_media_web = __esm({
  "src/media-web.ts"() {
    "use strict";
    init_net();
    init_publish2();
    init_watch();
    init_follow();
    init_show();
    init_sound();
    C3.Decoder.audioContext = audioContext;
    REPLAY_MS = 1e3;
    REPLAY_MAX_MS = 16e3;
    CATALOG_GONE_MS = 1500;
    ENDED_MS = 1e3;
    media = {
      send(origin, path, changed) {
        const own2 = streams(changed);
        const update = () => own2.set([video.given(), audio.given()]);
        let given;
        const live = (tracks = []) => tracks.find((track) => track.readyState === "live") ?? null;
        const read2 = () => {
          video.set(live(given?.getVideoTracks()));
          audio.set(live(given?.getAudioTracks()));
        };
        const video = slot(update, read2);
        const audio = slot(update, read2);
        const sent = broadcast(origin, path, (effect) => effect.get(video.out) !== void 0 || effect.get(audio.out) !== void 0, video.out, audio.out);
        const timer = setInterval(read2, ENDED_MS);
        return {
          set(stream) {
            given = stream;
            read2();
          },
          stream: own2.get,
          // Lets go of the application's tracks without stopping them, and stops the clones.
          close() {
            clearInterval(timer);
            sent.close();
            given = void 0;
            read2();
          }
        };
      },
      receive(origin, path, listed, changed) {
        const canvas = document.createElement("canvas");
        let audio;
        let on = false;
        const hearing = () => {
          const one = {
            shown: 0,
            set(now) {
              if (one !== heard) return;
              on = now;
              audio?.heard(now);
            }
          };
          return one;
        };
        let heard = hearing();
        const own2 = streams((stream) => {
          if (stream) received2(stream, heard);
          else (heard = hearing()).set(false);
          changed(stream);
        });
        let has = { video: false, audio: false };
        let picture;
        const update = () => {
          if (has.video && !picture) picture = canvas.captureStream().getVideoTracks()[0];
          else if (!has.video && picture) {
            picture.stop();
            picture = void 0;
          }
          if (has.audio && !audio) {
            audio = sound(update);
            audio.heard(on);
            if (player) audio.follow(player);
          }
          own2.set([picture, has.audio ? audio?.track() : void 0]);
        };
        let player;
        let unsubscribe = () => {
        };
        let replay;
        let replays = 0;
        let gone;
        const start = () => {
          const made = player = new lt({ origin, name: path_exports.from(path), canvas, volume: 0, visible: "always" });
          audio?.follow(made);
          let started = false;
          const offs = [made.broadcast.out.status.subscribe((status) => {
            if (status === "live") replays = 0;
            if (status !== "offline") started = true;
            else if (started && replay === void 0) {
              replay = setTimeout(() => {
                replay = void 0;
                if (player === made && listed()) again();
              }, Math.min(REPLAY_MS * 2 ** replays++, REPLAY_MAX_MS));
            }
          }), made.broadcast.out.catalog.subscribe((catalog) => {
            clearTimeout(gone);
            const now = { video: catalog?.video !== void 0, audio: catalog?.audio !== void 0 };
            const take2 = () => {
              has = now;
              update();
            };
            if (!now.video && !now.audio && listed() && (has.video || has.audio)) gone = setTimeout(take2, CATALOG_GONE_MS);
            else take2();
          })];
          unsubscribe = () => offs.forEach((off) => off());
        };
        const stop = () => {
          unsubscribe();
          clearTimeout(replay);
          replay = void 0;
          clearTimeout(gone);
          player?.close();
          player = void 0;
        };
        const again = () => {
          stop();
          start();
        };
        start();
        update();
        return {
          // The player, the gain and the tracks: nothing of this person's keeps sounding.
          close() {
            stop();
            audio?.stop();
            picture?.stop();
          }
        };
      }
    };
  }
});

// src/connection.ts
init_net();

// src/reason.ts
init_net();
var NAMES = {
  64: "invalid-token",
  65: "expired",
  66: "removed",
  67: "path-closed",
  68: "full",
  69: "unavailable",
  70: "stopped"
};
var CODES = new Map(Object.entries(NAMES).map(([code, name]) => [name, Number(code)]));
var Reason = class _Reason extends Error {
  name;
  code;
  constructor(name, options) {
    super(name, options);
    const code = CODES.get(name);
    if (code === void 0) throw new RangeError(`unknown reason: ${name}`);
    this.name = name;
    this.code = code;
  }
  /** The reason for a session close or stream reset carrying one of the codes, else undefined. */
  static of(error2) {
    if (error2 instanceof _Reason) return error2;
    if (!(error2 instanceof Error)) return void 0;
    const reset = /^RESET_STREAM: (\d+)$/u.exec(error2.message);
    const code = error2 instanceof errors_exports2.Session || error2 instanceof errors_exports2.Stream ? error2.code : Number(reset?.[1]);
    const name = NAMES[code];
    return name && new _Reason(name, { cause: error2 });
  }
};
function stops(reason2, { opened, getToken }) {
  switch (reason2?.name) {
    case "removed":
    case "path-closed":
      return true;
    case "stopped":
      return opened;
    case "invalid-token":
      return !(opened && getToken);
    case "expired":
      return !getToken;
    default:
      return false;
  }
}
var MEANINGS = {
  "invalid-token": "the token is not valid for any key of the project, or its key was deleted",
  expired: "the token expired",
  removed: "this person was removed from the room",
  "path-closed": "the room was closed, or the project was deleted",
  full: "the project has as many connections as its limit",
  unavailable: "the Relay takes no sessions now",
  stopped: "the project's bytes this month reached its limit: in the app's folder, `tablebox api GET /projects/{project}` shows its usage and limits, and `tablebox claim` raises a temporary project's"
};
function warning(reason2, closed) {
  return `tablebox.io: ${reason2.name} (${reason2.code}), ${closed ? "closed" : "connecting again"}: ${MEANINGS[reason2.name]}`;
}
function backoff(attempt, random = Math.random) {
  return Math.min(3e4, 1e3 * 2 ** attempt) * (1 - random() / 2);
}

// src/connection.ts
init_room();

// src/secret.ts
var KEY = "tablebox.io:secret";
var SECRET = /^[A-Za-z0-9_-]{32,128}$/u;
var base64url = (bytes) => btoa(String.fromCharCode(...bytes)).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/u, "");
function newSecret() {
  return base64url(crypto.getRandomValues(new Uint8Array(32)));
}
async function identityOf(secret) {
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(secret));
  return base64url(new Uint8Array(digest)).slice(0, 22);
}
async function secretFor(secret, relays) {
  const text = new TextEncoder();
  const key = await crypto.subtle.importKey("raw", text.encode(secret), { name: "HMAC", hash: "SHA-256" }, false, ["sign"]);
  const scope = [...new Set(relays.map((relay) => relay.href))].sort().join(" ");
  return base64url(new Uint8Array(await crypto.subtle.sign("HMAC", key, text.encode(scope))));
}
async function tabSecret(storage2, relays) {
  let stored;
  try {
    const store = storage2?.();
    if (store) {
      stored = store.getItem(KEY) ?? void 0;
      if (stored === void 0 || !SECRET.test(stored)) store.setItem(KEY, stored = newSecret());
    }
  } catch {
    stored = void 0;
  }
  return stored === void 0 ? newSecret() : secretFor(stored, relays);
}

// src/connection.ts
var STABLE_MS = 5e3;
var DIAL_MS = 5e3;
var LIST_MS = 1e3;
var SOON_MS = 250;
var NEW_KEY_MS = 1e4;
var SWAP_MS = 1e3;
var JWT = /^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/u;
var sleep = (ms2) => new Promise((resolve2) => setTimeout(resolve2, ms2));
var aborted2 = (signal) => new Promise((resolve2) => signal.aborted ? resolve2(false) : signal.addEventListener("abort", () => resolve2(false), { once: true }));
var insides = /* @__PURE__ */ new WeakMap();
function inside(connection) {
  const found = insides.get(connection);
  if (!found) throw new TypeError("not a connection from connect()");
  return found;
}
var Own = class {
  #published = /* @__PURE__ */ new Map();
  #listeners = /* @__PURE__ */ new Map();
  get(key) {
    return this.#published.get(key);
  }
  /** Puts `publication` at `key`; throws while another one is there. */
  take(key, publication) {
    if (this.#published.has(key)) throw new Error(`${key} is published already: close it first`);
    this.#published.set(key, publication);
    this.changed(key);
  }
  /** Takes `publication` from `key`. */
  drop(key, publication) {
    if (this.#published.get(key) !== publication) return;
    this.#published.delete(key);
    this.changed(key);
  }
  /** Tells the listeners of `key` that what is published there changed. */
  changed(key) {
    for (const listener of [...this.#listeners.get(key) ?? []]) listener();
  }
  /** Calls `listener` whenever what is published at `key` changes; the function returned stops it. */
  listen(key, listener) {
    let set = this.#listeners.get(key);
    if (!set) this.#listeners.set(key, set = /* @__PURE__ */ new Set());
    set.add(listener);
    return () => {
      set.delete(listener);
      if (set.size === 0) this.#listeners.delete(key);
    };
  }
};
function dialer(websocket) {
  return (url2, origin, hashes, signal, hop) => Connection3.connect({
    url: url2,
    signal,
    publish: origin.consume(),
    consume: origin,
    webtransport: { serverCertificateHashes: hashes.map((value) => ({ value })) },
    websocket: { enabled: websocket },
    // The session's Hop ID (patches.mjs): the same for every session of one connection.
    ...{ hop }
  });
}
function newHop() {
  const [value] = crypto.getRandomValues(new BigUint64Array(1));
  return value & 0x1fffffffffffffn || 1n;
}
function orderOf(list, seeds) {
  const order = /* @__PURE__ */ new Map();
  for (const relay of [...list, ...seeds]) if (!order.has(relay.href)) order.set(relay.href, relay);
  return [...order.values()];
}
async function ask(relay, signal) {
  try {
    const answer = await fetch(new URL("/relays", relay), { signal });
    const { relays } = await answer.json();
    if (answer.ok && relays.length > 0) return relays.map((each) => new URL(each));
  } catch {
  }
  return void 0;
}
async function ordered(seeds) {
  const stop = new AbortController();
  const timer = setTimeout(() => stop.abort(), LIST_MS);
  const given = seeds.map((seed) => ask(seed, stop.signal).then((list) => list ?? Promise.reject(new Error("no list"))));
  const late = new Promise((_3, reject) => stop.signal.addEventListener("abort", reject));
  try {
    return orderOf(await Promise.race([Promise.any(given), late]), seeds);
  } catch {
    return seeds;
  } finally {
    clearTimeout(timer);
    stop.abort();
  }
}
function after(order, relay) {
  return order[(order.findIndex((each) => each.href === relay.href) + 1) % order.length];
}
function claimsOf(token) {
  try {
    if (typeof token !== "string" || !JWT.test(token)) throw new Error("not a JWT");
    const part = token.split(".")[1].replaceAll("-", "+").replaceAll("_", "/");
    const { room, relays, hashes = [], sub } = JSON.parse(new TextDecoder().decode(Uint8Array.from(atob(part), (char) => char.charCodeAt(0))));
    const seeds = relays.map((each) => new URL(each));
    const pattern = typeof room === "string" && path_exports.Pattern.parse(room);
    const user = sub === void 0 || sub === null || typeof sub === "string" && USER.test(sub);
    const pinned = Array.isArray(hashes) && hashes.every((hash) => typeof hash === "string");
    if (pattern && user && pinned && seeds.length > 0 && seeds.every((seed) => seed.protocol === "https:")) return { room, relays: seeds, hashes, sub: sub ?? void 0 };
  } catch {
  }
  throw new TypeError("this is not a Tablebox token: tablebox init, tablebox token or sign makes one");
}
function roomOf(pattern, given) {
  if (given === void 0 && pattern.includes("*")) throw new TypeError(`give a room: this token lets a page into any room matching ${pattern}`);
  const room = given ?? pattern;
  if (!isRoom(room)) throw new TypeError("a room is a path, such as boards/42");
  if (!path_exports.Pattern.parse(pattern).matches(path_exports.from(room))) throw new TypeError(`this token does not let a page into ${room}: it lets in ${pattern}`);
  return room;
}
function address(relay, token, secret, room) {
  const at2 = new URL(relay);
  at2.searchParams.set("jwt", token);
  at2.searchParams.set("secret", secret);
  at2.searchParams.set("room", room);
  return at2;
}
async function connect2(token, options, means) {
  const next = typeof token === "function" ? token : () => token;
  let first = await next();
  const claims = claimsOf(first);
  const room = roomOf(claims.room, options?.room);
  const seeds = orderOf([], claims.relays);
  const relays = claims.hashes.length > 0 ? Promise.resolve(seeds) : ordered(seeds);
  const media3 = await means.media?.();
  const secret = await tabSecret(means.storage, seeds);
  const tab = await identityOf(secret);
  const id = claims.sub === void 0 ? tab : `${claims.sub}~${tab}`;
  const url2 = async (relay) => {
    const given = first ?? await next();
    first = void 0;
    return address(relay, given, secret, room);
  };
  return new Live(id, relays, claims.hashes, { url: url2, getToken: typeof token === "function" }, means, media3);
}
var Live = class {
  id;
  origin;
  #origin = new origin_exports.Producer();
  #status = new signals_exports.Signal("connecting");
  #reason = new signals_exports.Signal(void 0);
  #closed = Promise.withResolvers();
  /** The Relays in the order they are dialed (`ordered`). */
  #relays;
  #hashes;
  #tokens;
  #dial;
  /**
   * When `connect()` made it, and whether the Relay admitted a session of it (its SETUP came,
   * patches.mjs; a session without `admitted` once it lasted STABLE_MS): a fixed token's refusal
   * before then is tried again for NEW_KEY_MS. Once admitted, its key was there, so a refusal
   * then, as when the key is deleted, stops it at once.
   */
  #started;
  #admitted = false;
  /** This connection's Hop ID, declared by each of its sessions (patches.mjs). */
  #hop = newHop();
  #session;
  /** The Relay of the session in use. */
  #relay;
  /** Aborts the dial a network change started beside the session in use, while it is under way. */
  #beside;
  /** Set by a network change while such a dial is under way: the change is acted on once that dial gave up. */
  #again = false;
  /** The sessions a network change replaced, each open beside the one in use until SWAP_MS later or the connection closes. */
  #replaced = /* @__PURE__ */ new Set();
  /** Settled when such a dial's session took the place of the one in use. */
  #swapped = Promise.withResolvers();
  /** Settled by a network change while no session is in use: ends the wait before the next dial. */
  #woken = Promise.withResolvers();
  constructor(id, relays, hashes, tokens, means, media3) {
    this.id = id;
    this.origin = this.#origin;
    this.#relays = relays;
    this.#hashes = hashes;
    this.#tokens = tokens;
    this.#dial = means.dial;
    this.#started = Date.now();
    insides.set(this, {
      id,
      origin: this.#origin,
      closed: this.#closed.promise,
      isClosed: () => this.#closing(),
      own: new Own(),
      media: media3
    });
    const online = () => this.#changed();
    means.online?.addEventListener("online", online);
    void this.#closed.promise.then(() => means.online?.removeEventListener("online", online));
    void this.#run();
  }
  get status() {
    return this.#status.peek();
  }
  get transport() {
    return this.#session?.transport;
  }
  get reason() {
    return this.#reason.peek();
  }
  onStatus(callback) {
    return this.#status.subscribe(callback);
  }
  /** Closes the connection: its session and everything on its origin. */
  close() {
    this.#stop(void 0);
  }
  #closing() {
    return this.#status.peek() === "closed";
  }
  #stop(reason2) {
    if (this.#closing()) return;
    const session = this.#session;
    this.#session = void 0;
    this.#beside?.abort();
    this.#reason.set(reason2);
    this.#status.set("closed");
    this.#closed.resolve();
    session?.close();
    for (const replaced of this.#replaced) replaced.close();
    this.#replaced.clear();
    this.#origin.close();
  }
  /**
   * Records why a session ended or was refused (`opened`: it had lasted STABLE_MS); true when the
   * connection stops there. A fixed token's refusal with `invalid-token` is tried again for
   * NEW_KEY_MS after `connect()` while the Relay admitted no session of it, since its key may not be
   * at the Relays yet. A reason other than the last, or one that stops it, is written to the console.
   */
  #ended(reason2, opened) {
    const { getToken } = this.#tokens;
    const early = !getToken && !opened && !this.#admitted && reason2?.name === "invalid-token" && Date.now() - this.#started < NEW_KEY_MS;
    const ends = !early && stops(reason2, { opened, getToken });
    if (reason2 && !this.#closing() && (ends || reason2.name !== this.#reason.peek()?.name)) console.warn(warning(reason2, ends));
    if (ends) this.#stop(reason2);
    else this.#reason.set(reason2);
    return this.#closing();
  }
  /** Puts `session`, from a dial at `relay`, in use. */
  #use(session, relay) {
    this.#session = session;
    this.#relay = relay;
    this.#reason.set(void 0);
    this.#status.set("connected");
  }
  /**
   * The browser said the network changed (`online`): after a random wait of up to SOON_MS, a new
   * session is dialed beside the one in use, or, while none is in use, the wait before the next
   * dial ends.
   */
  #changed() {
    setTimeout(() => {
      if (this.#closing()) return;
      if (this.#session) void this.#dialBeside();
      else this.#woken.resolve();
    }, Math.random() * SOON_MS);
  }
  /**
   * Dials the Relay of the session in use again, with the same Hop ID and a fresh URL (a new token
   * from the function `connect()` took), while that session stays in use: the old path may be gone,
   * which Chrome notices only after about 6 to 9 s. Once the Relay admitted the new session (its SETUP came,
   * patches.mjs), it is put in use without the status passing through `connecting`, and the old
   * one is closed SWAP_MS later; a dial that fails, or a session the Relay refuses, leaves the old
   * one in use. `close` and the old session's end abort it. A change while it is under way is acted
   * on once it gave up without a swap.
   */
  async #dialBeside() {
    const old = this.#session;
    const relay = this.#relay;
    if (!old || !relay) return;
    if (this.#beside) {
      this.#again = true;
      return;
    }
    const abort = this.#beside = new AbortController();
    let session;
    let swapped = false;
    try {
      const target3 = await this.#tokens.url(relay);
      abort.signal.throwIfAborted();
      const signal = AbortSignal.any([AbortSignal.timeout(DIAL_MS), abort.signal]);
      session = await this.#dial(target3, this.#origin, this.#hashes, signal, this.#hop);
      const admitted = await Promise.race([session.admitted ?? true, session.closed.then(() => false), aborted2(signal)]);
      if (!admitted || abort.signal.aborted || this.#session !== old) return;
      this.#use(session, relay);
      session = void 0;
      swapped = true;
      this.#swapped.resolve();
      this.#retire(old);
    } catch {
    } finally {
      session?.close();
      if (this.#beside === abort) this.#beside = void 0;
      const again = this.#again;
      this.#again = false;
      if (again && !swapped && !abort.signal.aborted) this.#changed();
    }
  }
  /**
   * Keeps `old`, the session a network change replaced, open beside the new one for SWAP_MS, then
   * closes it; `#stop` closes it sooner. A method of its own, so that no closure of the dial that
   * replaced it holds it: one waits on the new session's `closed`.
   */
  #retire(old) {
    this.#replaced.add(old);
    setTimeout(() => {
      this.#replaced.delete(old);
      old.close();
    }, SWAP_MS);
  }
  /**
   * Waits for the first list (or LIST_MS), then stays on one Relay while its sessions last. A token
   * the function fails to give is asked for again after the wait. A Relay that fails a dial, does not
   * answer it by the deadline, or ends a session with `unavailable` (it has no state from Manager)
   * is left for the next at once, and the wait comes only once every Relay failed in turn; a GOAWAY
   * moves to the next at once; a session that ends otherwise (a refusal with `full` or `stopped`
   * too, as every Relay counts the same project) is dialed again at the same Relay after the wait.
   */
  async #run() {
    const relays = await this.#relays;
    let relay = relays[0];
    let failed = 0;
    for (let attempt = 0, wait = false; ; ) {
      if (wait) await Promise.race([sleep(backoff(attempt++)), this.#closed.promise, this.#woken.promise]);
      wait = true;
      this.#woken = Promise.withResolvers();
      if (this.#closing()) return;
      let target3;
      try {
        target3 = await this.#tokens.url(relay);
      } catch {
        continue;
      }
      let session;
      try {
        session = await this.#dial(target3, this.#origin, this.#hashes, AbortSignal.timeout(DIAL_MS), this.#hop);
      } catch (error2) {
        const reason3 = Reason.of(error2);
        if (this.#ended(reason3, false)) return;
        relay = after(relays, relay);
        wait = ++failed % relays.length === 0 || reason3?.name === "full" || reason3?.name === "stopped" || reason3?.name === "invalid-token";
        continue;
      }
      if (this.#closing()) {
        session.close();
        return;
      }
      this.#use(session, relay);
      const since = Date.now();
      void session.admitted?.then((admitted) => this.#admitted ||= admitted);
      let ended;
      let goaway;
      for (; ; ) {
        goaway = session.goaway;
        this.#swapped = Promise.withResolvers();
        ended = await Promise.race([session.closed, goaway ?? session.closed, this.#swapped.promise]);
        if (this.#session === void 0 || this.#session === session) break;
        session = this.#session;
      }
      this.#beside?.abort();
      const moved = Reason.of(ended) === void 0 && goaway?.peek() !== void 0;
      if (moved) session.close();
      this.#session = void 0;
      if (this.#closing()) return;
      const opened = Date.now() - since >= STABLE_MS;
      if (opened) attempt = failed = 0;
      this.#admitted ||= opened;
      const reason2 = Reason.of(ended);
      if (this.#ended(reason2, opened)) return;
      this.#status.set("connecting");
      if (reason2?.name === "unavailable") {
        relay = after(relays, relay);
        wait = ++failed % relays.length === 0;
      } else {
        failed = 0;
        if (moved) [relay, wait] = [after(relays, relay), relays.length === 1];
      }
    }
  }
};

// src/state.ts
var state_exports = {};
__export(state_exports, {
  publish: () => publish,
  subscribe: () => subscribe2
});
init_json();
init_net();
init_follow();
var TRACK = "value";
function publish(connection, name, value) {
  return new Publication(inside(connection), checkName(name), value);
}
function subscribe2(connection, name, callback, options) {
  if (typeof callback !== "function") throw new TypeError("give a callback");
  return new Subscription(inside(connection), checkName(name), callback, options?.from);
}
var Publication = class {
  /** The value, as JSON text. */
  text;
  #inside;
  #key;
  #broadcast;
  #track;
  #group;
  #closed = false;
  constructor(inside2, name, value) {
    this.text = jsonOf(value);
    this.#inside = inside2;
    this.#key = `state/${name}`;
    inside2.own.take(this.#key, this);
    if (inside2.isClosed()) return;
    this.#broadcast = inside2.origin.createBroadcast(path_exports.from(`${this.#key}/${inside2.id}`));
    this.#track = this.#broadcast.createTrack(TRACK);
    this.#group = groups(this.#track);
    this.#write();
    this.#broadcast.announce();
  }
  set(value) {
    if (this.#closed) throw new Error("this value was closed");
    const text = jsonOf(value);
    if (text === this.text) return;
    this.text = text;
    this.#write();
    this.#inside.own.changed(this.#key);
  }
  close() {
    if (this.#closed) return;
    this.#closed = true;
    this.#track?.close();
    this.#broadcast?.close();
    this.#inside.own.drop(this.#key, this);
  }
  /** Writes the value as a group of its own, while the connection is open. */
  #write() {
    if (!this.#track || this.#track.closed.peek() !== void 0) return;
    const group = this.#group();
    group.writeFrame({ payload: new TextEncoder().encode(this.text), timestamp: time_exports.Timestamp.now() });
    group.close();
  }
};
var Subscription = class extends Map {
  #stops = [];
  #closed = false;
  constructor(inside2, name, callback, from2) {
    super();
    const key = `state/${name}`;
    const tell = (id, value) => later(() => {
      if (this.#closed || value === void 0 && !super.has(id)) return;
      if (value === void 0) super.delete(id);
      else super.set(id, value);
      callback(id, value);
    });
    if (from2 === void 0 || from2 === inside2.id) {
      let last;
      const mine = () => {
        const text = inside2.own.get(key)?.text;
        if (text === last) return;
        last = text;
        tell(inside2.id, text === void 0 ? void 0 : JSON.parse(text));
      };
      this.#stops.push(inside2.own.listen(key, mine));
      mine();
    }
    this.#stops.push(follow(inside2, key, from2, (id) => {
      const stop = reading(inside2, `${key}/${id}`, (broadcast2) => {
        const track = broadcast2.track(TRACK).subscribe();
        const ended = (async () => {
          for await (const value of new snapshot_exports.Consumer({ track })) tell(id, value);
        })();
        return { ended, close: () => track.close() };
      });
      return () => {
        stop();
        tell(id, void 0);
      };
    }));
  }
  close() {
    if (this.#closed) return;
    this.#closed = true;
    for (const stop of this.#stops) stop();
  }
};

// src/log.ts
var log_exports = {};
__export(log_exports, {
  publish: () => publish2,
  subscribe: () => subscribe3
});
init_json();
init_net();
init_follow();
var LOG_KEEP = 100;
var LOG_BYTES = VALUE_BYTES;
var LOG_QUIET_MS = 2e3;
var HEADER_BYTES = 100;
var TRACK2 = "records";
function publish2(connection, name) {
  return new Writer2(inside(connection), checkName(name));
}
function subscribe3(connection, name, callback, options) {
  if (typeof callback !== "function") throw new TypeError("give a callback");
  return new Reader2(inside(connection), checkName(name), callback, options?.from);
}
var isRecord = (raw) => typeof raw === "object" && raw !== null && Number.isFinite(raw.at) && "value" in raw;
var Writer2 = class {
  /** The records kept, oldest first, each with its index and its bytes in the window. */
  kept = [];
  /** The index the next record takes. */
  next = 0;
  #inside;
  #key;
  #encoder = new window_exports.Encoder();
  #broadcast;
  #track;
  #groups;
  #group;
  /** The timer that closes `#group` LOG_QUIET_MS after the last record. */
  #quiet = {};
  /** Bytes of the records kept, as the window's header holds them. */
  #bytes = 0;
  #closed = false;
  constructor(inside2, name) {
    this.#inside = inside2;
    this.#key = `log/${name}`;
    inside2.own.take(this.#key, this);
    if (inside2.isClosed()) return;
    this.#broadcast = inside2.origin.createBroadcast(path_exports.from(`${this.#key}/${inside2.id}`));
    this.#track = this.#broadcast.createTrack(TRACK2);
    this.#groups = groups(this.#track);
    this.#broadcast.announce();
    const quiet = this.#quiet;
    void inside2.closed.then(() => clearTimeout(quiet.timer));
  }
  append(value) {
    if (this.#closed) throw new Error("this log was closed");
    const record2 = { at: Date.now(), value: JSON.parse(jsonOf(value)) };
    const bytes = new TextEncoder().encode(JSON.stringify(record2)).byteLength + 1;
    let drop = 0;
    while (drop < this.kept.length && (this.kept.length - drop >= LOG_KEEP || this.#bytes + bytes + HEADER_BYTES > LOG_BYTES)) this.#bytes -= this.kept[drop++].bytes;
    this.kept.splice(0, drop);
    this.kept.push({ index: this.next++, ...record2, bytes });
    this.#bytes += bytes;
    if (drop > 0) this.#write(() => this.#encoder.pop(drop));
    this.#write(() => this.#encoder.push(record2));
    this.#inside.own.changed(this.#key);
  }
  close() {
    if (this.#closed) return;
    this.#closed = true;
    clearTimeout(this.#quiet.timer);
    this.#group?.close();
    this.#track?.close();
    this.#broadcast?.close();
    this.#inside.own.drop(this.#key, this);
  }
  /**
   * Writes the frame of the window `make` gives, in a new group when it opens one, while the
   * connection is open; a frame not written makes the next one open a group. With no group open
   * (its writer was quiet), the first frame is left uncommitted, so that the next opens a group with
   * all the window keeps; the group closes LOG_QUIET_MS after the last frame.
   */
  #write(make) {
    if (!this.#track || this.#inside.isClosed() || this.#track.closed.peek() !== void 0) return;
    let encoded = make();
    if (encoded && !encoded.keyframe && !this.#group) encoded = make();
    if (!encoded) return;
    if (encoded.keyframe) {
      this.#group?.close();
      this.#group = this.#groups();
    }
    this.#group.writeFrame({ payload: encoded.payload, timestamp: time_exports.Timestamp.now() });
    encoded.commit();
    clearTimeout(this.#quiet.timer);
    this.#quiet.timer = setTimeout(() => {
      this.#group?.close();
      this.#group = void 0;
    }, LOG_QUIET_MS);
  }
};
var Reader2 = class {
  records = [];
  #stops = [];
  #closed = false;
  constructor(inside2, name, callback, from2) {
    const key = `log/${name}`;
    const windows = /* @__PURE__ */ new Map();
    const windowOf = (id) => {
      let window2 = windows.get(id);
      if (!window2) windows.set(id, window2 = /* @__PURE__ */ new Map());
      return window2;
    };
    const push = (id, index2, at2, value) => {
      const window2 = windowOf(id);
      if (window2.get(index2)?.at === at2) return;
      const record2 = { id, at: at2, value };
      window2.set(index2, record2);
      later(() => {
        if (this.#closed) return;
        let place = this.records.length;
        while (place > 0 && this.records[place - 1].at > record2.at) place--;
        this.records.splice(place, 0, record2);
        callback(record2);
      });
    };
    const trim = (id, offset) => {
      const window2 = windowOf(id);
      for (const [index2, record2] of window2) {
        if (index2 >= offset) continue;
        window2.delete(index2);
        later(() => {
          const place = this.records.indexOf(record2);
          if (place >= 0) this.records.splice(place, 1);
        });
      }
    };
    if (from2 === void 0 || from2 === inside2.id) {
      let writer;
      const mine = () => {
        const now = inside2.own.get(key);
        if (now !== writer) windows.delete(inside2.id);
        writer = now;
        if (!writer) return;
        trim(inside2.id, writer.kept[0]?.index ?? writer.next);
        for (const { index: index2, at: at2, value } of writer.kept) push(inside2.id, index2, at2, value);
      };
      this.#stops.push(inside2.own.listen(key, mine));
      mine();
    }
    this.#stops.push(follow(inside2, key, from2, (id) => reading(inside2, `${key}/${id}`, (broadcast2) => {
      const track = broadcast2.track(TRACK2).subscribe();
      const ended = (async () => {
        const consumer = new window_exports.Consumer({ track });
        for await (const event of consumer) {
          const { offset } = consumer;
          trim(id, offset);
          if (!("push" in event) || event.push.index < offset || !isRecord(event.push.value)) continue;
          const { index: index2, value: { at: at2, value } } = event.push;
          push(id, index2, at2, value);
        }
      })();
      return { ended, close: () => track.close() };
    })));
  }
  close() {
    if (this.#closed) return;
    this.#closed = true;
    for (const stop of this.#stops) stop();
  }
};

// src/media.ts
var media_exports = {};
__export(media_exports, {
  publish: () => publish3,
  show: () => show,
  subscribe: () => subscribe4
});
init_follow();
init_show();
function publish3(connection, name, stream) {
  return new Sent(inside(connection), checkName(name), stream);
}
function subscribe4(connection, name, callback, options) {
  if (typeof callback !== "function") throw new TypeError("give a callback");
  return new Watching(inside(connection), checkName(name), callback, options?.from);
}
function maker(at2) {
  if (!at2.media) throw new Error("Media needs a browser: @moq/publish and @moq/watch run in browsers only");
  return at2.media;
}
var Sent = class {
  #inside;
  #key;
  #sender;
  #closed = false;
  constructor(at2, name, stream) {
    const media3 = maker(at2);
    if (!(stream instanceof MediaStream)) throw new TypeError("give a MediaStream");
    this.#inside = at2;
    this.#key = `media/${name}`;
    at2.own.take(this.#key, this);
    this.#sender = media3.send(at2.origin, `${this.#key}/${at2.id}`, () => at2.own.changed(this.#key));
    this.#sender.set(stream);
    void at2.closed.then(() => this.close());
  }
  stream() {
    return this.#sender?.stream();
  }
  set(stream) {
    if (this.#closed) throw new Error("this media was closed");
    if (!(stream instanceof MediaStream)) throw new TypeError("give a MediaStream");
    this.#sender.set(stream);
  }
  close() {
    if (this.#closed) return;
    this.#closed = true;
    this.#sender.close();
    this.#inside.own.drop(this.#key, this);
  }
};
var Watching = class extends Map {
  #stops = [];
  #closed = false;
  constructor(at2, name, callback, from2) {
    super();
    const media3 = maker(at2);
    const key = `media/${name}`;
    const tell = (id, stream) => later(() => {
      if (this.#closed || super.get(id) === stream) return;
      if (stream === void 0) super.delete(id);
      else super.set(id, stream);
      callback(id, stream);
    });
    if (from2 === void 0 || from2 === at2.id) {
      const mine = () => tell(at2.id, at2.own.get(key)?.stream());
      this.#stops.push(at2.own.listen(key, mine));
      mine();
    }
    this.#stops.push(follow(at2, key, from2, (id) => {
      let listed = true;
      const receiver = media3.receive(at2.origin, `${key}/${id}`, () => listed, (stream) => tell(id, stream));
      return () => {
        listed = false;
        receiver.close();
        tell(id, void 0);
      };
    }));
    void at2.closed.then(() => this.close());
  }
  close() {
    if (this.#closed) return;
    this.#closed = true;
    for (const stop of this.#stops) stop();
  }
};

// src/files.ts
var files_exports = {};
__export(files_exports, {
  fetch: () => fetch2,
  publish: () => publish4
});
init_net();

// src/content.ts
init_net();
var FILE_CHUNK_BYTES = 4 * 1024 * 1024;
var FRAME_BYTES = 64 * 1024;
var DATA = "data";
var READ_AHEAD = 2;
var CHUNK_KEEP_MS = 12e4;
var chunksOf = (size2) => Math.max(1, Math.ceil(size2 / FILE_CHUNK_BYTES));
async function within(promise, ms2, what) {
  let timer;
  try {
    return await Promise.race([promise, new Promise((_3, reject) => timer = setTimeout(() => reject(new Error(`${what}: no answer`)), ms2))]);
  } finally {
    clearTimeout(timer);
  }
}
var K = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
var Sha256 = class {
  #h = new Uint32Array([1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225]);
  #w = new Uint32Array(64);
  /** The bytes of a block not yet complete. */
  #block = new Uint8Array(64);
  #filled = 0;
  #length = 0;
  update(bytes) {
    this.#length += bytes.byteLength;
    let at2 = 0;
    if (this.#filled > 0) {
      at2 = Math.min(64 - this.#filled, bytes.byteLength);
      this.#block.set(bytes.subarray(0, at2), this.#filled);
      this.#filled += at2;
      if (this.#filled < 64) return;
      this.#compress(this.#block, 0);
      this.#filled = 0;
    }
    for (; at2 + 64 <= bytes.byteLength; at2 += 64) this.#compress(bytes, at2);
    this.#block.set(bytes.subarray(at2), 0);
    this.#filled = bytes.byteLength - at2;
  }
  digest() {
    const length = this.#length;
    const tail = new Uint8Array((this.#filled < 56 ? 64 : 128) - this.#filled);
    tail[0] = 128;
    const view = new DataView(tail.buffer);
    view.setUint32(tail.byteLength - 8, Math.floor(length / 2 ** 29));
    view.setUint32(tail.byteLength - 4, length * 8 % 2 ** 32);
    this.update(tail);
    return [...this.#h].map((word) => word.toString(16).padStart(8, "0")).join("");
  }
  #compress(bytes, at2) {
    const w4 = this.#w;
    for (let i2 = 0; i2 < 16; i2++, at2 += 4) w4[i2] = bytes[at2] << 24 | bytes[at2 + 1] << 16 | bytes[at2 + 2] << 8 | bytes[at2 + 3];
    for (let i2 = 16; i2 < 64; i2++) {
      const x4 = w4[i2 - 15];
      const y3 = w4[i2 - 2];
      const s0 = (x4 >>> 7 | x4 << 25) ^ (x4 >>> 18 | x4 << 14) ^ x4 >>> 3;
      const s1 = (y3 >>> 17 | y3 << 15) ^ (y3 >>> 19 | y3 << 13) ^ y3 >>> 10;
      w4[i2] = w4[i2 - 16] + s0 + w4[i2 - 7] + s1;
    }
    const h3 = this.#h;
    let a2 = h3[0], b3 = h3[1], c2 = h3[2], d2 = h3[3], e5 = h3[4], f3 = h3[5], g3 = h3[6], k2 = h3[7];
    for (let i2 = 0; i2 < 64; i2++) {
      const t1 = k2 + ((e5 >>> 6 | e5 << 26) ^ (e5 >>> 11 | e5 << 21) ^ (e5 >>> 25 | e5 << 7)) + (e5 & f3 ^ ~e5 & g3) + K[i2] + w4[i2] | 0;
      const t2 = ((a2 >>> 2 | a2 << 30) ^ (a2 >>> 13 | a2 << 19) ^ (a2 >>> 22 | a2 << 10)) + (a2 & b3 ^ a2 & c2 ^ b3 & c2) | 0;
      k2 = g3;
      g3 = f3;
      f3 = e5;
      e5 = d2 + t1 | 0;
      d2 = c2;
      c2 = b3;
      b3 = a2;
      a2 = t1 + t2 | 0;
    }
    h3[0] += a2;
    h3[1] += b3;
    h3[2] += c2;
    h3[3] += d2;
    h3[4] += e5;
    h3[5] += f3;
    h3[6] += g3;
    h3[7] += k2;
  }
};
async function hashOf(blob) {
  const hash = new Sha256();
  for (let at2 = 0; at2 < blob.size; at2 += FILE_CHUNK_BYTES) hash.update(new Uint8Array(await blob.slice(at2, at2 + FILE_CHUNK_BYTES).arrayBuffer()));
  return hash.digest();
}
async function write(track, part) {
  const bytes = new Uint8Array(await part.arrayBuffer());
  if (track.closed.peek() !== void 0) return;
  const group = track.appendGroup();
  for (let at2 = 0; at2 < bytes.byteLength; at2 += FRAME_BYTES) group.writeFrame({ payload: bytes.subarray(at2, at2 + FRAME_BYTES), timestamp: time_exports.Timestamp.now() });
  group.close();
}
function serve(broadcast2, blob) {
  const tracks = [];
  const offs = [];
  let stopped = false;
  const make = (index2) => {
    const track = new track_exports.Producer(`${DATA}.${index2}`).accept({ maxAge: time_exports.Milli(CHUNK_KEEP_MS) });
    try {
      broadcast2.insertTrack(track);
    } catch {
      return;
    }
    tracks[index2] = track;
    let written = false;
    const again = () => {
      if (stopped || tracks[index2] !== track) return;
      offs[index2]();
      track.close();
      make(index2);
    };
    offs[index2] = track.used.subscribe((used) => {
      if (!used) {
        if (written) again();
        return;
      }
      if (written) return;
      written = true;
      write(track, blob.slice(index2 * FILE_CHUNK_BYTES, (index2 + 1) * FILE_CHUNK_BYTES)).catch((error2) => {
        track.close(error2 instanceof Error ? error2 : new Error(String(error2)));
        again();
      });
    });
  };
  for (let index2 = 0; index2 < chunksOf(blob.size); index2++) make(index2);
  return () => {
    stopped = true;
    for (const off of offs) off();
    for (const track of tracks) track.close();
  };
}
async function read(origin, path, size2, type, answerMs) {
  const request = origin.request(path_exports.from(path), { announced: true });
  const reading2 = /* @__PURE__ */ new Set();
  try {
    const found = (async () => {
      while (!request.active.peek() && request.closed.peek() === void 0) await Promise.race([request.active.changed(), request.closed]);
      return request.active.peek();
    })();
    const active = await within(found, answerMs, path);
    if (!active) throw new Error(`${path}: refused`);
    const chunk = async (index2) => {
      const expected = Math.min(FILE_CHUNK_BYTES, size2 - index2 * FILE_CHUNK_BYTES);
      const track = active.track(`${DATA}.${index2}`).subscribe();
      reading2.add(track);
      try {
        const group = await within(track.recvGroup(), answerMs, path);
        if (!group) throw new Error(`${path}: no chunk ${index2}`);
        const frames = [];
        let length = 0;
        for (let frame = await group.readFrame(); frame; frame = await group.readFrame()) {
          length += frame.payload.byteLength;
          if (length > expected) throw new Error(`${path}: chunk ${index2} is over ${expected} bytes`);
          frames.push(frame.payload);
        }
        if (length !== expected) throw new Error(`${path}: chunk ${index2} has ${length} of ${expected} bytes`);
        return frames;
      } finally {
        reading2.delete(track);
        track.close();
      }
    };
    const count2 = chunksOf(size2);
    const pending = [];
    const ask2 = (index2) => {
      if (index2 >= count2) return;
      const frames = chunk(index2);
      frames.catch(() => {
      });
      pending.push(frames);
    };
    for (let index2 = 0; index2 < READ_AHEAD; index2++) ask2(index2);
    const hash = new Sha256();
    const parts3 = [];
    for (let index2 = 0; index2 < count2; index2++) {
      const frames = await pending[index2];
      ask2(index2 + READ_AHEAD);
      for (const frame of frames) hash.update(frame);
      parts3.push(new Blob(frames));
    }
    return { blob: new Blob(parts3, { type }), hash: hash.digest() };
  } finally {
    for (const track of reading2) track.close();
    request.close();
  }
}

// src/files.ts
var ANSWER_MS = 1e4;
var sleep3 = (ms2) => new Promise((resolve2) => setTimeout(resolve2, ms2));
async function publish4(connection, file) {
  const at2 = inside(connection);
  if (!(file instanceof Blob)) throw new TypeError("give a Blob or a File");
  const hash = await hashOf(file);
  const ref = { hash, name: typeof file.name === "string" ? file.name : "", size: file.size, type: file.type || "application/octet-stream" };
  const key = `files/${hash}`;
  let copy = at2.own.get(key);
  if (copy) copy.holders++;
  else {
    let stop = () => {
    };
    if (!at2.isClosed()) {
      const broadcast2 = at2.origin.createBroadcast(path_exports.from(`${key}/${at2.id}`));
      const served = serve(broadcast2, file);
      broadcast2.announce();
      stop = () => {
        served();
        broadcast2.close();
      };
    }
    copy = { blob: file, holders: 1, stop };
    at2.own.take(key, copy);
  }
  const held = copy;
  let closed = false;
  return {
    ref,
    close() {
      if (closed) return;
      closed = true;
      if (--held.holders > 0) return;
      held.stop();
      at2.own.drop(key, held);
    }
  };
}
async function fetch2(connection, ref) {
  const at2 = inside(connection);
  const { hash, size: size2, type } = ref ?? {};
  if (typeof hash !== "string" || !/^[0-9a-f]{64}$/u.test(hash) || !Number.isSafeInteger(size2) || size2 < 0 || typeof type !== "string") throw new TypeError("not a file reference");
  const own2 = at2.own.get(`files/${hash}`);
  if (own2) return new Blob([own2.blob], { type });
  const pattern = path_exports.Pattern.parse(`files/${hash}/*`);
  const sharing = at2.origin.broadcasts(pattern);
  const tried = /* @__PURE__ */ new Set();
  const deadline = Date.now() + ANSWER_MS;
  for (; ; ) {
    const next = [...sharing.peek().keys()].find((path) => pattern.matches(path) && !tried.has(path) && path_exports.parts(path).at(-1) !== at2.id);
    if (next !== void 0) {
      tried.add(next);
      try {
        const got = await read(at2.origin, next, size2, type, ANSWER_MS);
        if (got.hash === hash) return got.blob;
      } catch {
      }
      continue;
    }
    const left = deadline - Date.now();
    if (left <= 0 || at2.isClosed()) throw new Error(`file ${hash}: nobody here gave it`);
    await Promise.race([sharing.changed(), sleep3(left), at2.closed]);
  }
}

// src/browser.ts
init_net();
var dial = dialer(true);
var media2 = () => Promise.resolve().then(() => (init_media_web(), media_web_exports)).then((loaded) => loaded.media);
var storage = () => globalThis.sessionStorage;
function connect3(token, options) {
  return connect2(token, options, { dial, media: media2, online: globalThis, storage });
}
export {
  files_exports as Files,
  log_exports as Log,
  media_exports as Media,
  state_exports as State,
  connect3 as connect,
  net_exports as moq
};
